/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		0:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "" + ({}[chunkId]||chunkId) + "." + {"1":"93cda2a4f0d644e12093","2":"a2d4102aaf2fafce602b","3":"f8d6412558af7190dc4b","4":"5363ca7eab71b8257f60","5":"cf7af831f1dd379e5fce","6":"cfd3b7bfadc507379d47","7":"0dd8ad11b24c9324e4ae","8":"e9a9c56c98a7da186998","9":"044d71c2ab8cdecd0ed1","10":"c27644d384708fdf1612","11":"042fec58ae1b30aeaf76","12":"2d15b2544f18a0d58285","13":"90bbb4ce80388e342013","14":"7dfe3365263217d191f5","15":"d02545980a50d030abc4","16":"e644eb101283f1a8b454","17":"5cc7e41752d19d776fd6","18":"4c94cf9a5d6c255ca2a6","19":"4fd833ade607c48aa324","20":"2e0e0134bac7881ae256","21":"8dd7332a7272bd11b1ab","22":"d2e23a76269fa535fb96","23":"d334a1aac7dba1847635","24":"943d4beb8c2d05875424","25":"9c30e1eee4b10e820cfb","26":"e907fbb81941d789e950","27":"77ec43cfe22c19492fa8","28":"7333a54b2d04936c3319","29":"9b4525f0d2f0d24f6b6a","30":"b4ab0daf8ecae894d57a","31":"7f2b6d499eedc19c5741","32":"87e61c244b23f693c45b","33":"4fd12cf2200237179a14","34":"ff035382fb947a0725c8","35":"0228a7a3727106d09af1","36":"83bc609539de4b34edc5","37":"23be636acadf9b4b7dcd","38":"052b67e132eb9b7c4b30","39":"6527c89354d9e81cbdc2","40":"d0a5aa422208d8145eae","41":"6a4ba16851492bffcd91","42":"230ace17305d81244edd","43":"91f6fb5a29abcfd45924","44":"aef54318fbc333cf40d7","45":"435f2b63b76df5e1e5b7","46":"6eccfe68e08eac44df39","47":"a6ad8c7df1d856594da4","48":"2c456fdc8d7646f914ca","49":"3d42de65920517c1b9ca","50":"0807055c6c62cb7539ad","51":"5e80d43e135bbf3cb59b","52":"ef79f2f07991d88e3cfd","53":"04571351debf0497a114","54":"3791b7110f993c044d30","55":"ac8508f25a6b20c095b0","56":"76614e749eb5047c3a97","57":"8007fbdce7acf82d5873","58":"3745b2dec9841aa7be55","59":"9000bc20808aa878bcb1","60":"a46012742f630d385cb1","61":"1382fd3bad45f8c5c99d","62":"8f57f25d45fedbf5a63b","63":"e6428faf3d0484ed45c8","64":"c8aaf73326a0c463960a","65":"9e45af1b6eb914d21422","66":"7d98ebf77fecee7e3092","67":"3c37d465ac5bc7d1f98f","68":"dc0098e72c7c36f714a5","69":"32c49866f71c45740228","70":"46a199e250cff4662648","71":"d08cf46736fc46996816","72":"73c24e0825c55eabd36c","73":"6d9ba5233833b6f21a3f","74":"14aa291235d8b676e964","75":"74734312b9d44fcee306","76":"b80c138b37649a80c911","77":"02e06b1ee58a6331d85d","78":"c127c2bf7bba84bbd566","79":"911ae904cd787fc88d84","80":"41f04e7be0224fb21aae","81":"fd48770fa19186fcf5bb","82":"0d69ee27ffdfaa9db59d","83":"6263e8f5cd48e6310a43","84":"9cc9e7afd7f4415d2e46","85":"676b4de55b1a1c761b78","86":"238dc8943f84ae08e50d","87":"f8ab7639d2146353dc2e","88":"e24a9589ae7a2c9d18ee","89":"d87f50d13daed58f5a49","90":"d98517987dd5336ca556","91":"a6ec61de1354413900cb","92":"11f306215541c944c152","93":"c65be32d2b847ee82d36","94":"2b6e671e973bf4f4c0df","95":"ae75b249d501da515e9b","96":"c1be94bf6a2d8933b1eb","97":"0e5009734687ab788f03","98":"0884eb6aae3cfb26428f","99":"be7c8e7c8025789e42cd","100":"b31ad72a8368400a1ca1","101":"e3fa9063dff13756b1bd","102":"3a0a60ec8be818396866","103":"7e2e4caaf67cdeb1bf6f","104":"366445031c1ea1677418","105":"a583495a530e409f0560","106":"22cd6217b6bd2558d0c8","107":"6fcda40b5f3e5d526803","108":"5b8d8cd2b4d74a281539","109":"bf41525cfeed61e75fb0","110":"5e590a0054a625eaf945","111":"e368eca5d57bbb438fa5","112":"d8f023ab44cc5637a8b0","113":"dca42da6142a05b81acc","114":"aec00106256dc09ff72e","115":"97d8aad25ade110a92c9","116":"17c812b07c8f57086ded","117":"1d8b4b91c3fdc4a86269","118":"53522ec05127b7658960","119":"f20fc42e7a4baf2adfa1","120":"5c3b646e76f47872d898","121":"05f05250a576c4da701d","122":"5567e9e2a2f8b74f0409","123":"e6091cac5a6c10cf01a6","124":"7fd7bf47307238e49b95","125":"3d2d97d5b36dd6e3fd05","126":"bb2a5fa73cc6aca52c27","127":"38012cdfaa5eff5a3fca","128":"f33715e361c71db513f8","129":"6c7fa5fd38f5dc404ee2","130":"45fb96cb04178e4dcb68","131":"a656445dedea6c9e9331","132":"e0909f518b71e0f94b4f","133":"0cfa70a1ab59e27abcd7","134":"efa578649cc7a513e48a","135":"8b9add23dd5aea91ef01","136":"493339d42dca2c9f36c3","137":"402133f5b397621ba51e","138":"7a1d6364aec0ee0f5b09","139":"9e00f5c0bedec8716e76","140":"767bc5e2325343970b3d","141":"08ed59154f6d4873c66d","142":"418a821336acc4d5b5c2","143":"7b5c28227df29daa2345","144":"a2fb145e648484992276","145":"e37eb4e6075f4c821d5c","146":"450785db0866368ba28d","147":"d1e65a9f8c8fd9527bc6","148":"48f0569110850fe2a1be","149":"859b794a47ee95505d2c","150":"c6125e8837c45510c437","151":"955fda2e8bb96a38288c","152":"62460d230f210b598193","153":"bbf9e1fc8b10fc9af45f","154":"a574b8c622c0ace41b56","155":"ddd3bbdd9d9cbd6b3b70","156":"1ec4e3ee72696053416f","157":"c582e1898efffe608f93","158":"b1811ad66f5662a3aaab","159":"471e37d25e0b46d6db98","160":"2ea05dfbbad06ff6f154","161":"2345a4864b4c2b672a85","162":"182ac08953453c6c2fd1","163":"ad0227eff63a3cad6dbb","164":"dc2ceaee8c754a621ba0","165":"9927604b1e8396ae703a","166":"8121a4de0bd91fc866de","167":"c831f9b45a1e01d2b55f","168":"8c170ef0cab9b8ff6770","169":"954a810b108a59ac7d76","170":"2c26d40cdb69e928d3aa","171":"625aa70da5ffa448a61d","172":"2e6b422190ba1369fdcf","173":"6b6b31c62b50b9ac4bae","174":"8b1dff0515370576c82e","175":"bddcc9cdfca1a03ccab9","176":"88a447e32355d78166da","177":"f2a43a035d00d91b31c7","178":"aaea0ce8dff1735a06b5","179":"428ad6d8360e51767def","180":"d6a8d7874a5b157778a8","181":"cfb06bfe3d77ed6689b5","182":"159d13286ebc8351c237","183":"95c58c997f11ea9fdcf7","184":"8d5c1c4b4132e1c6008e","185":"39baaf34cdcad3870510","186":"b913dfe8e1acc4a2272d","187":"f0eeffb52c102525ce14","188":"9e92d89858e8fbe7eff7","189":"72e4d35ec85dac985f43","190":"84ba01d201c9500cbcf8","191":"3df72565079fb5e1f652","192":"2b06904d73660cb320bd","193":"ff20c95fa4a1fcc723cc","194":"69fb854f8e7cc286f1de","195":"bc7fbf23eff995ce2426","196":"28ee9547170298a0e9d1","197":"5357273ff07be3d5cd0e","198":"5f39021976834fb9ffaf","199":"ac6a253cfd6384e811f6","200":"8d8a52f9bcc05d798db6","201":"4874fbd7d01990d37ab1","202":"f812e4874e5c9896f046","203":"2ab12ef2574935cffafc"}[chunkId] + ".bundle.js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://fe-static-yuketang.yuketang.cn/fe/static/vue/2.2.595/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _typeof2 = __webpack_require__(4);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _promise = __webpack_require__(36);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	__webpack_require__(67);
	
	__webpack_require__(348);
	
	var _navData = __webpack_require__(356);
	
	var _navData2 = _interopRequireDefault(_navData);
	
	var _utils = __webpack_require__(358);
	
	var _vue = __webpack_require__(438);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(439);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueResource = __webpack_require__(440);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _vueFilter = __webpack_require__(464);
	
	var _vueFilter2 = _interopRequireDefault(_vueFilter);
	
	var _vueHttp = __webpack_require__(603);
	
	var _vueHttp2 = _interopRequireDefault(_vueHttp);
	
	var _vueTouch = __webpack_require__(607);
	
	var _vueTouch2 = _interopRequireDefault(_vueTouch);
	
	var _jsCookie = __webpack_require__(398);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var _vueI18n = __webpack_require__(609);
	
	var _vueI18n2 = _interopRequireDefault(_vueI18n);
	
	var _language = __webpack_require__(610);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _mintUi = __webpack_require__(618);
	
	var _zeptoHttp = __webpack_require__(619);
	
	var _zeptoHttp2 = _interopRequireDefault(_zeptoHttp);
	
	var _index = __webpack_require__(620);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _android = __webpack_require__(605);
	
	var _dailyReport = __webpack_require__(621);
	
	var _dailyReport2 = _interopRequireDefault(_dailyReport);
	
	var _sensorsReport = __webpack_require__(622);
	
	var _sensorsReport2 = _interopRequireDefault(_sensorsReport);
	
	var _vars = __webpack_require__(357);
	
	var _vars2 = _interopRequireDefault(_vars);
	
	var _setDocumentTitle = __webpack_require__(623);
	
	var _setDocumentTitle2 = _interopRequireDefault(_setDocumentTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// 日活上报
	
	// 国际化
	_vue2.default.prototype.sensorsReport = _sensorsReport2.default;
	// 埋点上报
	
	
	//设置zepto CSRFToken
	/*
	 * @Author: renjianshu
	 * @Date: 2019-01-28 17:06:01
	 * @LastEditors: gengming
	 * @LastEditTime: 2020-06-30 10:40:52
	 * @Description: file content
	 */
	// created by liujunyang 2016-07-18
	
	// 解决低版本数组接口兼容等ES6
	
	
	var sensors = null;
	
	if (navigator.userAgent.toLowerCase() && /flutterapp/i.test(navigator.userAgent.toLowerCase()) || window.__wxjs_environment === 'miniprogram') {} else {
	    sensors = __webpack_require__(624);
	    var hostname = window.location.hostname;
	    var show_log = true;
	    if (/^(www.xuetangx.com|next.xuetangx.com|www.yuketang.cn)$/.test(hostname)) {
	        show_log = false;
	    }
	    sensors.init({
	        show_log: show_log,
	        is_track_single_page: true,
	        app_js_bridge: true,
	        send_type: "beacon"
	    });
	}
	
	window.sensors = sensors;
	
	_vue2.default.config.debug = ("production") !== 'production';
	_vue2.default.config.devtools = true;
	// process.env.NODE_ENV = 'production'
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_vueFilter2.default);
	_vue2.default.use(_vueHttp2.default);
	_vue2.default.use(_vueTouch2.default);
	_vue2.default.use(_zeptoHttp2.default);
	_vue2.default.use(_vueI18n2.default);
	
	// 全局使用
	window.Vue = _vue2.default;
	window.Toast = _mintUi.Toast;
	
	var key = (0, _utils.getPlatformKey)();
	if (key === 'thu') {
	    _vue2.default.prototype.isThu = true;
	} else if (key === 'changjiang') {
	    _vue2.default.prototype.isChangjiang = true;
	} else if (key === 'huanghe') {
	    _vue2.default.prototype.isHuanghe = true;
	} else if (key === 'rain') {
	    _vue2.default.prototype.isRain = true;
	} else if (key === 'protest') {
	    _vue2.default.prototype.isPro = true;
	} else if (key === "g") {
	    _vue2.default.prototype.isG = true;
	} else if (key === "thunder") {
	    _vue2.default.prototype.isThunder = true;
	} else if (key === 'pre-apple-ykt') {
	    _vue2.default.prototype.isWind = true;
	} else if (key === 'gc') {
	    _vue2.default.prototype.isGC = true;
	} else if (key === 'yudou') {
	    _vue2.default.prototype.isYD = true;
	} else if (key === 'envning') {
	    _vue2.default.prototype.isEnvning = true;
	} else if (key === 'env-example') {
	    _vue2.default.prototype.isEnvExample = true;
	}
	// 控制讨论区是是否开放
	_vue2.default.prototype.isDiscussionOpen = true;
	
	var lng = _jsCookie2.default.get('django_language') || 'zh-cn';
	lng = lng === 'zh-cn' ? 'zh_CN' : 'en';
	// set language
	_language2.default.setLanguage(lng);
	
	(0, _setDocumentTitle2.default)();
	
	var vueRouterConfig = { history: true, root: "/v/index" };
	
	if (false) {
	    _vue2.default.http.patch = _vue2.default.http.get;
	    // Vue.http.post = Vue.http.get
	    vueRouterConfig = { history: true, root: null };
	}
	//用于参数传递，在vue-http.js
	_vue2.default.config.vueRouterConfig = vueRouterConfig;
	
	var router = new _vueRouter2.default(vueRouterConfig);
	
	function launchIntoFullscreen(element) {
	    if (element.requestFullscreen) {
	        element.requestFullscreen();
	    } else if (element.webkitRequestFullscreen) {
	        element.webkitRequestFullscreen();
	    } else if (element.msRequestFullscreen) {
	        element.msRequestFullscreen();
	    }
	}
	function setHeaderStorageFn() {
	    return new _promise2.default(function (resolve, reject) {
	        if ((typeof localStorage === 'undefined' ? 'undefined' : (0, _typeof3.default)(localStorage)) === 'object') {
	            // 默认当前设备是 普通浏览器
	            localStorage.setItem('x-client', 'web');
	            // 小程序
	            if (window.__wxjs_environment === 'miniprogram') {
	                localStorage.setItem('x-client', 'miniprogram');
	                resolve({});
	                return;
	            }
	            // 公众号
	            var ua = navigator.userAgent.toLowerCase();
	            if (ua.match(/MicroMessenger/i) == "micromessenger") {
	                localStorage.setItem('x-client', 'wechat');
	
	                resolve({});
	                return;
	            }
	            // flutter webview iframe嵌套会出现和客户端的交互问题，这个操作只适用webview 直接打开的页面
	            if (_android.isFlutterApp && window === window.top) {
	                localStorage.setItem('x-client', 'apph5');
	                window.callJS = function (res) {
	                    var data = res;
	                    var type = typeof res === 'undefined' ? 'undefined' : (0, _typeof3.default)(res);
	                    if (type === 'string') {
	                        data = JSON.parse(res);
	                    }
	                    if (data.data) {
	                        var info = data.data;
	                        if (typeof data.data === 'string') {
	                            info = JSON.parse(data.data);
	                        }
	                        var sessionid = info.sessionid;
	                        var fluttertype = info.type;
	                        var version = info.version;
	                        !!sessionid && localStorage.setItem('sessionid', sessionid);
	                        !!fluttertype && localStorage.setItem('fluttertype', fluttertype);
	                        !!version && localStorage.setItem('flutterversion', version);
	                        resolve({ sessionid: sessionid });
	                    } else {
	                        reject(data);
	                    }
	                };
	                (0, _android.callFlutter)('getSession', {});
	                // callFlutter('getAppType', {})
	                // 不等待 flutter 调用window.callJS
	                // resolve({sessionid: 0})
	            } else {
	                resolve({});
	            }
	        } else {
	            resolve({});
	        }
	    });
	}
	var App = _vue2.default.extend({
	    data: function data() {
	        return {};
	    },
	    ready: function ready() {
	        setTimeout(function () {
	            __webpack_require__.e/* require */(2, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(618), __webpack_require__(625)]; (function (MintUI) {
	                _vue2.default.use(MintUI);
	                _vue2.default.use(MintUI.Lazyload);
	                // 全局使用
	                window.MintUI = MintUI;
	            }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));});
	        }, 0);
	        // iOS下微信配置一次
	        if ($.isIOS()) $.setWXConfig();
	    },
	
	    template: _index2.default
	});
	
	router.map({
	    '/': {
	        name: 'home',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(3, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(627)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/lessonend': {
	        name: 'lessonend',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(4, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(640)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/course': {
	        name: 'course',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(5, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(644)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        },
	        subRoutes: {
	            '/normalcourse': {
	                name: 'classroomcourse',
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(7, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(649)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                },
	                subRoutes: {
	                    "/": {
	                        name: "normalcourse",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(8, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(663)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    '/error/:status_code': {
	                        name: 'error',
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(11, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(707)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    "/new_course/0": {
	                        name: "new_course",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(12, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(713)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    "/edit_course/:courseid": {
	                        name: "edit_course",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(12/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(713)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    "/manage_classroom/:courseid/:classroomid": {
	                        name: "manage_classroom",
	                        component: function component(resolve) {
	                            // require(['module/course/normalcourse/manage_classroom.vue'], resolve)
	                            __webpack_require__.e/* require */(13, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(721)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    "/manage_classroom_export/:courseid/:classroomid": {
	                        name: "manage_classroom_export",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(13/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(721)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    //不要再修改manage_classroom.vue（文件没有删除），使用manage_classroom_new.vue
	                    "/manage_classroom_student/:courseid/:classroomid": {
	                        name: "manage_classroom_student",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(17, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(773)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    //不要再修改manage_student.vue（文件没有删除），使用manage_student_new.vue
	                    "/manage_student/:courseid/:classroomid": {
	                        name: "manage_student",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(18, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(797)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    "/manage_auditor/:courseid/:classroomid": {
	                        name: "manage_auditor",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(19, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(803)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    "/blacklist/:id": {
	                        name: "blacklist",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(20, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(808)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    // new 新教学日志
	                    "/logs/:courseid/:classroomid": {
	                        name: "logs",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(13/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(721)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	
	                    // 课程设置
	                    "/set_course/:courseid/:classroomid": {
	                        name: "set_course",
	                        component: function component(resolve) {
	                            // require(['module/course/normalcourse/logs/set_course.vue'], resolve)
	                            __webpack_require__.e/* require */(21, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(813)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    // 班级设置
	                    "/set_classroom/:courseid/:classroomid": {
	                        name: "set_classroom",
	                        component: function component(resolve) {
	                            // require(['module/course/normalcourse/logs/set_classroom.vue'], resolve)
	                            __webpack_require__.e/* require */(21/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(813)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    // 设置学生端开放功能
	                    "set_class_config/:cid/:member/:forum/:group/:questions": {
	                        name: 'set_class_config',
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(22, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(832)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	
	                    // 教师预习详情
	                    "/teaching_cards_detail/:courseware_id": {
	                        name: "teaching_cards_detail",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(23, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(837)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        },
	                        meta: {
	                            reportCid: true
	                        }
	                    },
	                    // 教师预习完成情况
	                    "/teaching_cards_completion/:cardid": {
	                        name: "teaching_cards_completion",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(24, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(868)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        },
	                        meta: {
	                            reportCid: true
	                        }
	                    },
	                    // 单个学生的预习数据
	                    "/teaching_cards_completion_detail/:cardid/:userid": {
	                        name: "teaching_cards_completion_detail",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(25, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(876)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        },
	                        meta: {
	                            reportCid: true
	                        }
	                    },
	                    // 教师预习查看课件
	                    "/teaching_cards/:cardid": {
	                        name: "teaching_cards",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(26, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(881)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        },
	                        meta: {
	                            reportCid: true
	                        }
	                    },
	                    // 教师试卷完成情况
	                    "/teaching_quiz_completion/:quizid": {
	                        name: "teaching_quiz_completion",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(27, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(917)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        },
	                        meta: {
	                            reportCid: true
	                        }
	                    },
	                    // 教师试卷完成情况 思博新版本（带排序搜索）
	                    "/teaching_quiz_completion_sort/:quizid": {
	                        name: "teaching_quiz_completion_sort",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(28, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(923)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        },
	                        meta: {
	                            reportCid: true
	                        }
	                    },
	                    // 教师试卷完成情况 思博新版本（学生详情卡片页）
	                    "/teaching_quiz_completion_sort_detail/:quizid/:userid": {
	                        name: "teaching_quiz_completion_sort_detail",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(29, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(928)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        },
	                        meta: {
	                            reportCid: true
	                        }
	                    },
	                    // 教师预习批改
	                    "/teaching_cards_correction/:cardid/:problemid": {
	                        name: "teaching_cards_correction",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(30, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(933)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        },
	                        meta: {
	                            reportCid: true
	                        }
	                    },
	                    // 教师试卷批改
	                    "/teaching_quiz_correction/:quizid/:problemid": {
	                        name: "teaching_quiz_correction",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(30/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(933)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        },
	                        meta: {
	                            reportCid: true
	                        }
	                    },
	                    // 课程小结入口 start
	                    "/teaching_lesson_detail/:courseware_id": {
	                        name: "teaching_lesson_detail",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(33, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1005)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    // 签到统计
	                    "/teacher_sign_list/:id/:type": {
	                        name: "teacher_sign_list",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(34, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1030)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    // 课堂签到统计及学生得分情况
	                    "/teacher_sign_list_lesson_summary/:lessonid": {
	                        name: "teacher_sign_list_lesson_summary",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(35, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1035)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    "/teacher_tougao/:courseware_id": {
	                        name: "teacher_look_tougao",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(36, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1040)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    "/lesson_summary/rank/:courseware_id": {
	                        name: "lesson_summary_rank",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(37, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1061)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    "/lesson_summary/personal/:courseware_id/:user_id": {
	                        name: "lesson_summary_personal",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(38, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1067)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    "/lesson_summary/members/:courseware_id": {
	                        name: "lesson_summary_members",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(39, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1076)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    // 课程小结入口 end
	                    // 教师试卷详情
	                    "/teacher_quiz_detail/:courseware_id": {
	                        name: "teacher_quiz_detail",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(40, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1081)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        },
	                        meta: {
	                            reportCid: true
	                        }
	                    },
	                    // 考试小结
	                    "/exam/:eid/:cid": {
	                        name: "exam_summary",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(42, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1589)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    "/completion/:eid/:cid": {
	                        name: "exam_completion",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(43, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1596)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    // 学生预习详情
	                    "/learning_cards_detail/:courseware_id": {
	                        name: "learning_cards_detail",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(44, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1602)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        },
	                        meta: {
	                            reportCid: true
	                        }
	                    },
	                    // 学生 主观题结果页
	                    "/subjective_result/:problem_id": {
	                        name: "subjective_result",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(45, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1610)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        },
	                        meta: {
	                            reportCid: true
	                        }
	                    },
	                    "/learning_lesson_detail/:courseware_id": {
	                        name: "learning_lesson_detail",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(46, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1615)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    "/learning_tougao/:courseware_id": {
	                        name: "learning_tougao",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(47, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1640)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    "/learning_lesson_score_detail/:courseware_id/:user_id": {
	                        name: "learning_lesson_score_detail",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(38/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1067)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    "/student_ppt_swipe/:type/:courseware_id/:index": {
	                        name: "student_ppt_swipe",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(48, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1645)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	
	                    "/student_ppt/:presentation_id": {
	                        name: "student_ppt",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(49, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1663)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    "/report_teacher/:cards_id": {
	                        name: "report_teacher",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(50, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1678)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        },
	                        meta: {
	                            reportCid: true
	                        }
	                    },
	                    "/cards_feedback_reply/:feed_back_id": {
	                        name: "cards_feedback_reply",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(51, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1683)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        },
	                        meta: {
	                            reportCid: true
	                        }
	                    },
	                    // 教师客观题详情
	                    "/teacher_cards_answer_detail/:problem_id/:item_count": {
	                        name: "teacher_cards_answer_detail",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(52, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1686)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                            // require(['module/course/normalcourse/teacher/teacher_cards_answer_detail.vue'], resolve)
	                        },
	                        meta: {
	                            reportCid: true
	                        }
	                    },
	                    // 教师客观题详情 quiz
	                    "/teacher_quiz_answer_detail/:problem_id/:item_count": {
	                        name: "teacher_quiz_answer_detail",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(53, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1694)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                            // require(['module/course/normalcourse/teacher/teacher_quiz_answer_detail.vue'], resolve)
	                        },
	                        meta: {
	                            reportCid: true
	                        }
	                    },
	                    "/show_teacherPPT/:presentation_id/:lesson_id": {
	                        name: "show_teacherPPT",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(54, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1700)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    "/show_teacherslide_info/:lessonSlide_id/:currentIndex/:lessonid/:type/:presentation_id": {
	                        name: "show_teacherslide_info",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(55, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1707)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    "/teacher_slideproblem_detail/:lessonSlide_id/:lessonid/:presentation_id": {
	                        name: "teacher_slideproblem_detail",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(56, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1712)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    "/teacher_lesson_subjective_problem_result_list/:lesson_id/:problem_id": {
	                        name: "teacher_lesson_subjective_problem_result_list",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(57, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1721)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    "/teacher_slideproblem_resultdetail/:lessonSlide_id": {
	                        name: "teacher_slideproblem_resultdetail",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(59, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1733)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    "/lesson_danmu_detail/:lesson_id": {
	                        name: "lesson_danmu_detail",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(60, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1736)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    //不要再修改manage_role.vue（文件没有删除），使用manage_role_new.vue
	                    "/manage_role/:classroom_id": {
	                        name: "manage_role",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(61, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1741)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    //不要再修改manage_role_collaborator.vue（文件没有删除），使用manage_role_collaborator_new.vue
	                    "/manage_role_collaborator/:classroom_id": {
	                        name: "manage_role_collaborator",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(62, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1746)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    "/advance_pub_courseware/:id": {
	                        name: "advance_pub_courseware",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(63, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1751)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    "/advance_pub_success": {
	                        name: "advance_pub_success",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(64, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1764)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    "/advance_pub_failure": {
	                        name: "advance_pub_failure",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(65, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1769)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    // 修改试卷/课件时间及限制
	                    "/pub_time_limit/:id/:type": {
	                        name: "pub_time_limit",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(66, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1774)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        },
	                        meta: {
	                            reportCid: true
	                        }
	                    },
	                    // 新增课程限制页
	                    "/set_courselimit/:courseid/:classroomid": {
	                        name: "set_courselimit",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(67, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1781)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    // 搜索学生
	                    "/search/:lessonid/:classroomid": {
	                        name: 'search',
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(68, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1788)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    // 本期暂不支持课下修改学生表现分数&标签
	                    '/stuexpression/:classroomid/:lessonid/:userid': {
	                        name: 'stuexpression',
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(69, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1793)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    '/course_setting/:courseid': {
	                        name: 'course_setting',
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(70, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1798)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    '/course_setting_info/:courseid': {
	                        name: 'course_setting_info',
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(71, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1805)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    '/examcover/:cid/:eid': {
	                        name: 'exam_cover',
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(72, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1812)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    '/batch_detail/:coursewareid/:role': {
	                        name: 'batchdetail',
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(73, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1819)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        },
	                        meta: {
	                            reportCid: true
	                        }
	                    }
	                }
	            },
	            /* 去掉公开课
	            '/opencourse': {
	                name: 'opencourse',
	                component: function (resolve) {
	                    require(['module/course/opencourse/opencourse.vue'], resolve)
	                },
	                subRoutes: {
	                    '/': {
	                        name: 'opencourse-list',
	                        component: function (resolve) {
	                            require(['module/course/opencourse/opencourse-list.vue'], resolve)
	                        }
	                    },
	                    '/item/:id': {
	                        name: 'opencourse-item',
	                        component: function (resolve) {
	                            require(['module/course/opencourse/opencourse-item-root.vue'], resolve)
	                        },
	                        subRoutes: {
	                            '/': {
	                                component: function (resolve) {
	                                    require(['module/course/opencourse/opencourse-item.vue'], resolve)
	                                }
	                            },
	                            '/learningplan': {
	                                name: 'opencourse-item-learningplan',
	                                component: function (resolve) {
	                                    require(['module/course/opencourse/opencourse_item/learningplan.vue'], resolve)
	                                }
	                            },
	                            '/learningplan-purchase': {
	                                name: 'opencourse-item-learningplan-purchase',
	                                component: function (resolve) {
	                                    require(['module/course/opencourse/opencourse_item/learningplan-purchase.vue'], resolve)
	                                }
	                            },
	                            '/learningplan-diff/:from': {
	                                name: 'opencourse-item-learningplan-diff',
	                                component: function (resolve) {
	                                    require(['module/course/opencourse/opencourse_item/learningplan-diff.vue'], resolve)
	                                }
	                            },
	                            '/learning': {
	                                name: 'opencourse-item-learning',
	                                component: function (resolve) {
	                                    require(['module/course/opencourse/opencourse_item/learning.vue'], resolve)
	                                }
	                            },
	                            '/learningcards': {
	                                name: 'opencourse-item-learningcards',
	                                component: function (resolve) {
	                                    require(['module/course/opencourse/opencourse_item/learningcards/learningcards.vue'], resolve)
	                                }
	                            },
	                            '/aboutcourse': {
	                                name: 'opencourse-item-aboutcourse',
	                                component: function (resolve) {
	                                    require(['module/course/opencourse/opencourse_item/aboutcourse.vue'], resolve)
	                                }
	                            },
	                            '/ask': {
	                                name: 'opencourse-item-ask',
	                                component: function (resolve) {
	                                    require(['module/course/opencourse/opencourse_item/ask.vue'], resolve)
	                                }
	                            },
	                            '/qaitem/:itemid': {
	                                name: 'opencourse-item-qaitem',
	                                component: function (resolve) {
	                                    require(['module/course/opencourse/opencourse_item/qaitem.vue'], resolve)
	                                }
	                            },
	                            '/qaitem-single-answer/:answerid': {//我的回答、我收藏的回答页面，只有一条回答
	                                name: 'opencourse-item-qaitem-single-answer',
	                                component: function (resolve) {
	                                    require(['module/course/opencourse/opencourse_item/qaitem-single-answer.vue'], resolve)
	                                }
	                            },
	                            '/qaitem/:itemid/answer': {
	                                name: 'opencourse-item-qaitem-answer',
	                                component: function (resolve) {
	                                    require(['module/course/opencourse/opencourse_item/qaitem-answer.vue'], resolve)
	                                }
	                            }
	                        }
	                    }
	                }
	            },
	            */
	            '/openplatform': {
	                name: '',
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(74, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1824)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                },
	                subRoutes: {
	                    "/teacher_sydetail/:courseware_id/:classroom_id/:activityid/:userRole": {
	                        name: "teacher_sydetail",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(75, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1831)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    "/teacher_complete/:courseware_id/:classroom_id": {
	                        name: "teacher_sy_completedetail",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(76, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1836)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    "/teacher_doing/:courseware_id/:classroom_id": {
	                        name: "teacher_sy_doingdetail",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(77, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1841)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    "/teacher_nostart/:courseware_id/:classroom_id": {
	                        name: "teacher_sy_nostartdetail",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(78, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1846)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    "/teacher_syreport/:courseware_id/:student_id": {
	                        name: "teacher_syreport",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(79, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1852)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    "/student_sydetail/:courseware_id/:classroom_id": {
	                        name: "student_sydetail",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(80, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1858)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    "/syinfo/:courseware_id/": {
	                        name: "syinfo",
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(81, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1866)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    }
	                }
	            }
	        }
	    },
	
	    // 升级版教师小结
	    '/teacher_v3': {
	        name: 'teacher_summary_index',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(82, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1871)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        },
	
	        subRoutes: {
	            '/teaching_lesson_detail/:lessonid': {
	                name: 'teaching_lesson_detail_v3',
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(83, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1876)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            },
	            // 课堂签到统计及学生得分情况
	            "/teacher_sign_list_lesson_summary/:lessonid": {
	                name: "teacher_sign_list_lesson_summary_v3",
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(84, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1926)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            },
	            // 单个学生的签到及得分情况
	            "/lesson_summary/:lessonid/:userid": {
	                name: "lesson_summary_personal_v3",
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(85, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1931)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            },
	            // ppt、习题等列表
	            "/show_teacher_ppt/:presentation_id/:lesson_id": {
	                name: "show_teacher_ppt_v3",
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(86, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1947)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            },
	            // 单个ppt、习题
	            "/show_teacherslide_info/:lessonSlide_id/:currentIndex/:lessonid/:type/:presentation_id": {
	                name: "show_teacherslide_info_v3",
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(87, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1952)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            },
	            // 主观题批改列表
	            "/teacher_lesson_subjective_problem_result_list/:lesson_id/:problem_id": {
	                name: "teacher_lesson_subjective_problem_result_list_v3",
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(88, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1957)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            },
	            // 查看客观题详情
	            "/teacher_objective_detail/:lesson_id/:problem_id": {
	                name: "teacher_objective_detail_v3",
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(89, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2005)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            },
	            // 手动批改填空题
	            '/blanks/answermark/:user_id/:problem_id/:classroom_id/:scenes_type': {
	                name: 'blanks-answer-mark_v3',
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(90, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2036)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            },
	            // 弹幕详情
	            "/lesson_danmu_detail/:lesson_id": {
	                name: "lesson_danmu_detail_v3",
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(91, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2046)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            },
	            // 课堂投稿
	            "/teacher_tougao/:lessonid": {
	                name: "teacher_look_tougao_v3",
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(92, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2051)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            },
	            // 随机点名
	            "/teacher_sign_list/:lessonid": {
	                name: "teacher_sign_list_v3",
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(93, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2056)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            },
	            // 搜索
	            // 搜索学生
	            "/search/:lessonid/:classroomid": {
	                name: 'search_v3',
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(94, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2061)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            },
	            // 选择课后学生可查看课件范围
	            "/select_part_ppt/:type": {
	                name: 'select_part_ppt',
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(95, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2066)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            }
	        }
	    },
	    // 升级版学生小结
	
	    /*--------------------*\
	    $  升级版学生小结开始
	    \*--------------------*/
	
	    // 主页
	    "/learning_lesson_detail_v3/:courseware_id": {
	        name: "learning_lesson_detail_v3",
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(96, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2071)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	
	    // k12所有的推送中转页
	    "/k12_loading_page": {
	        name: "k12_loading_page",
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(97, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2078)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    // k12  h5底部菜单的view类型点击后的中转页
	    "/k12_view_loading_page": {
	        name: "k12_view_loading_page",
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(98, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2083)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    // k12所有的推送中转页/点击底部菜单的中转页，请求接口后的err页面，用于提示用户：无权限/账号未激活/此孩子不是该家长下的孩子等等
	    "/k12_err_page": {
	        name: "k12_err_page",
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(99, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2088)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	
	    // 不懂 收藏
	    "/student_ppt_swipe_v3/:type/:courseware_id/:index/:presentation_id": {
	        name: "student_ppt_swipe_v3",
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(100, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2094)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	
	    // 学生ppt
	    "/student_ppt_v3/:presentation_id/:courseware_id/:activity_id/:classroom_id": {
	        name: "student_ppt_v3",
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(101, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2112)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    // 截图分享
	    '/screenshot_v3/:lessonid': {
	        name: 'screenshot_v3',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(102, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2122)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    // 投稿
	    "/learning_contribution_v3/:courseware_id": {
	        name: "learning_contribution_v3",
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(103, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2130)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    /*--------------------*\
	    $  升级版学生小结结束
	    \*--------------------*/
	    // 主页
	    //没有导航菜单的课程相关功能
	    //讨论区相关
	    '/discussion': {
	        name: 'root',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(104, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2135)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        },
	        subRoutes: {
	            "/:classroom_id": {
	                name: "discussion",
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(105, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2140)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            },
	            "/edit_discussion/:classroom_id/:topic_id": {
	                name: "edit_discussion",
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(106, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2150)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            },
	            "/new_discussion/:classroom_id": {
	                name: "new_discussion",
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(106/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2150)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            },
	            "/info/:classroom_id/:id": {
	                name: "discussion_info",
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(107, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2156)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            },
	            "/info_courseware/:classroom_id/:id": {
	                name: "discussion_info_courseware",
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(108, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2176)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            },
	            "/comment/:id": {
	                name: "discussion_comment",
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(109, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2201)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            },
	            "/comment_courseware/:id/:classroom_id": {
	                name: "discussion_comment_courseware",
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(110, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2211)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            }
	        }
	    },
	
	    '/course_v': {
	        name: 'course_v',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(111, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2221)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        },
	        subRoutes: {
	            "/publish_notice/:courseid/:classroom_id": {
	                name: "publish_notice",
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(112, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2224)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            },
	            "/notice_view/:courseware_id/": {
	                name: "notice_view",
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(113, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2238)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            },
	            "/notice_notice_up/:courseware_id/": {
	                name: "notice_notice_up",
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(114, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2248)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            },
	            "/notice_view_new": {
	                name: "notice_view_new",
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(115, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2278)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            },
	            "/notice_ready_static/:courseware_id": {
	                name: "notice_ready_static",
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(116, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2285)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            }
	        }
	    },
	    '/my_collections': {
	        name: 'my_collections',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(117, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2292)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/my_collections2': {
	        name: 'my_collections2',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(118, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2326)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/manage_collections': {
	        name: 'manage_collections',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(119, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2332)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/my_collections_moving/:type': {
	        name: 'my_collections_moving',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(120, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2337)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/my_collections_movetofolder/:pagetype': {
	        name: 'my_collections_movetofolder',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(121, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2342)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/my_collections_tofolder/:pagetype': {
	        name: 'my_collections_tofolder',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(122, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2348)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/my_collections_research/:pagetype': {
	        name: 'my_collections_research',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(123, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2353)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/my_papers': {
	        name: 'my_papers',
	        component: function component(resolve) {
	            //require(['module/mypapers/mypapers.vue'], resolve)
	            __webpack_require__.e/* require */(117/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2292)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/my_papers_moving/:type': {
	        name: 'my_papers_moving',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(120/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2337)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/manage_papers': {
	        name: 'manage_papers',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(124, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2358)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	
	    '/discover': {
	        name: 'discover',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(125, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2363)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        },
	        subRoutes: {
	            '/': {
	                name: 'discover-index',
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(126, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2368)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            }
	        }
	    },
	    '/message': {
	        name: 'message',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(127, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2373)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	
	    //协同教师被移除或添加的提示页面
	    "collaborator_msg": {
	        name: 'collaborator_msg',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(128, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2403)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    // 学情预警消息提醒
	    "academicWarnning": {
	        name: 'academicWarnning',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(129, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2408)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/myself': {
	        name: 'myself',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(130, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2414)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/edituserinfo_simple': {
	        name: 'edituserinfo_simple',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(131, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2435)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/myself_edit': {
	        name: 'myself_edit',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(132, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2441)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/mymainpage': {
	        name: 'mymainpage',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(133, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2446)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/bindSchool_list': {
	        name: 'bindSchool_list',
	        component: function component(resolve) {
	            // require(['module/mystore/bindSchool_list.vue'], resolve)
	            __webpack_require__.e/* require */(134, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2454)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/hasbindschool': {
	        name: 'hasbindschool',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(135, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2467)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/bindschool_register/:id': {
	        name: 'bindschool_register',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(136, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2474)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/bindschool_tips': {
	        name: 'bindschool_tips',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(137, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2479)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    // 一体化特殊学校的绑定 special_binding
	    '/special_binding/:id': {
	        name: 'special_binding',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(138, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2484)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    /*设置新增*/
	    '/setting': {
	        name: 'setting',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(139, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2489)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/setting_lang': {
	        name: 'setting_lang',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(140, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2494)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/identityBinding/:code': {
	        name: 'identityBinding',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(141, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2499)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/bindSchool/:school_id': {
	        name: 'bindSchool',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(142, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2504)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/cas_confirm/:school_id': {
	        name: 'cas_confirm',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(143, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2520)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/bindSchool_validate/:school_id': {
	        name: 'bindSchool_validateCode',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(144, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2525)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/bindSchool_unlock/:school_id': {
	        name: 'bindSchool_unlock',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(145, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2530)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/bindSchool_fail': {
	        name: 'bindSchool_fail',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(146, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2535)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/bindGuidance': {
	        name: 'bindGuidance',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(147, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2541)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/bindSchool_cas/:school_id': {
	        name: 'bindSchoolCas',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(148, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2551)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/bind_page': {
	        name: 'bindPage',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(149, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2556)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    // k12需要绑定页面
	    '/need-bind': {
	        name: 'needBind',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(150, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2562)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    // k12选择身份
	    '/choose-identity/:school_id': {
	        name: 'chooseIdentity',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(151, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2567)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    // k12身份绑定 - 输入账号+密码
	    '/k12-bind-identity/:school_id/:identity': {
	        name: 'k12BindIdentity',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(152, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2572)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    // k12身份绑定 - 输入校内姓名
	    '/k12-verify-name/:school_id': {
	        name: 'k12VerifyName',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(153, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2577)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    // k12第一步 绑定孩子 - 输入姓名+账号+密码+身份
	    '/k12-bind-child/:school_id': {
	        name: 'bindChild',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(154, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2582)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    // k12第一步 注册账号 - 输入手机号+验证码+密码
	    '/k12-register-account/:school_id': {
	        name: 'k12RegisterAccount',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(155, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2587)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/taaAuth': {
	        name: 'taaAuth',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(156, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2592)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/bank': {
	        name: 'bank-root',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(157, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2597)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        },
	        subRoutes: {
	            "/": {
	                name: 'bank',
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(158, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2600)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            },
	            "/:userId": {
	                name: 'bank',
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(158/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2600)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            },
	            "/recharge": {
	                name: 'bank-recharge',
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(159, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2606)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            },
	            "/withdraw/:userId": {
	                name: 'bank-withdraw',
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(160, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2611)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            },
	            "/bill": {
	                name: 'bank-bill',
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(161, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2616)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            }
	        }
	    },
	
	    // 习题集
	    '/problem_sets': {
	        name: 'problem_sets_root',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(162, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2621)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        },
	        subRoutes: {
	            "/": {
	                name: 'problem_sets',
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(163, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2624)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            },
	            "/course/:classroomid": {
	                name: 'problem_sets_course',
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(164, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2629)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            },
	            "/problem/:id/:problemid": {
	                name: 'problem_sets_problem',
	                component: function component(resolve) {
	                    __webpack_require__.e/* require */(165, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2634)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                },
	                subRoutes: {
	                    "/answer/:index": {
	                        name: 'problem_answer',
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(166, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2640)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    "/subjective/:index": {
	                        name: 'problem_subjective',
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(167, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2645)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    "/redo/:index": {
	                        name: 'problem_redo',
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(168, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2650)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    "/nodes/:index": {
	                        name: 'problem_nodes',
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(169, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2655)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    },
	                    "/blanks/:id/:type": {
	                        name: 'problem_blanks',
	                        component: function component(resolve) {
	                            __webpack_require__.e/* require */(170, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2660)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                        }
	                    }
	                }
	            }
	        }
	    },
	
	    // 私信相关设置
	    // ta的个人主页
	    'homepage/:user_id': {
	        name: 'homepage',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(171, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2665)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    // 私信页面
	    'letter/:user_id': {
	        name: 'letter',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(172, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2670)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	
	    '/mystore': {
	        name: 'mystore',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(173, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2678)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/mystore_symbol/:pptindex': {
	        name: 'mystore_symbol',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(174, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2683)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    // 投稿
	    '/mystore_tougao_v3/:tougaoIndex/:listIndex': {
	        name: 'mystore_tougao_v3',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(175, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2690)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/mystore_boards': {
	        name: 'mystore_boards',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(176, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2695)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	
	    // 填空题统计页
	    '/blanks/detail/:type/:id/:cid': {
	        name: 'blanks-detail',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(177, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2701)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	
	    '/blanks/lessondetail/:slideid/:lessonid/:presentationid': {
	        name: 'blanks-detail-lesson',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(178, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2706)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	
	    // 填空题做题页制作
	    '/blanks/answer/:type/:id/:cid': {
	        name: 'blanks-answer',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(179, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2711)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	
	    // 填空题做题结果页制作
	    '/blanks/answerresult/:type/:id/:cid': {
	        name: 'blanks-answer-result',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(180, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2716)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    // 审核行政通知
	    '/inform_preview/:id': {
	        name: 'inform_preview',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(181, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2721)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    // 兼容query和params两种格式的审核行政通知,为了防止打开以前的推送，先留着吧
	    '/inform_preview': {
	        name: 'inform_preview',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(181/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2721)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    // 填空题作答详情
	    '/blanks/answerdetail/:id/:type': {
	        name: 'blanks-answer-detail',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(170/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2660)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	
	    // 手动批改填空题
	    '/blanks/answermark/:user_id/:problem_id/:classroom_id/:scenes_type': {
	        name: 'blanks-answer-mark',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(182, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2735)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	
	    // 课上回放
	    '/playback/:lessonid': {
	        name: 'playback',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(183, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2740)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	
	    // 课上回放 v3接口升级
	    '/v3/playback/:lessonid': {
	        name: 'playback_v3',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(185, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2776)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	
	    // 截图分享
	    '/screenshot/:lessonid': {
	        name: 'screenshot',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(186, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2810)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	
	    // 测试新评论
	    '/comment_input': {
	        name: 'input-box',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(187, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(909)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	
	    // 月报功能
	    '/monthly': {
	        name: 'monthly',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(188, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2815)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	
	    //申请身份认证审核
	    '/apply_identify_audit': {
	        name: 'apply_identify_audit',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(189, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2907)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    //申请直博认证审核
	    '/apply_live_audit/:course_id/:classroom_id': {
	        name: 'apply_live_audit',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(190, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2930)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    //申请直博认证结果
	    '/apply_live_result/:course_id/:classroom_id': {
	        name: 'apply_live_result',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(191, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2935)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    // 运营人员 ：查看直播审核列表
	    '/audit': {
	        name: 'audit',
	        component: function component(reslove) {
	            __webpack_require__.e/* require */(192, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2940)]; (reslove.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        },
	        subRoutes: {
	            //运营人员 ：查看直播审核列表
	            '/audit_list': {
	                name: 'audit_list',
	                component: function component(reslove) {
	                    __webpack_require__.e/* require */(193, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2943)]; (reslove.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            },
	            // 运营人员 审核身份证页面
	            '/audit_identify/:user_id/:audit_id': {
	                name: 'audit_identify',
	                component: function component(reslove) {
	                    __webpack_require__.e/* require */(194, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2948)]; (reslove.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            },
	            // 运营人员 审核直播页面
	            '/audit_live/:audit_id': {
	                name: 'audit_live',
	                component: function component(reslove) {
	                    __webpack_require__.e/* require */(195, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2953)]; (reslove.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	                }
	            }
	        }
	    },
	
	    // 账号密码设置相关
	    '/setting_account': {
	        name: 'setting_account',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(196, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2958)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/setting_email': {
	        name: 'setting_email',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(197, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2963)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/setting_password': {
	        name: 'setting_password',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(198, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2968)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    'setting_phone': {
	        name: 'setting_phone',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(199, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2973)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	
	    // 会员审核页面相关
	    '/apply_vip_index': {
	        name: 'apply_vip_index',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(200, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2985)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/apply_vip_audit': {
	        name: 'apply_vip_audit',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(201, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2990)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/apply_vip_success': {
	        name: 'apply_vip_success',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(202, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2995)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	
	    // 投票器绑定
	    '/voter/binding': {
	        name: 'voter_binding',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(203, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3000)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    }
	});
	
	router.redirect({
	    "/learning_lesson_detail/:courseware_id": "/course/normalcourse/learning_lesson_detail/:courseware_id",
	    "/teaching_lesson_detail/:courseware_id": "/course/normalcourse/teaching_lesson_detail/:courseware_id",
	    "/error/:status_code": "/course/normalcourse/error/:status_code",
	    '*': '/course/normalcourse'
	});
	
	router.beforeEach(function (transition) {
	    window.isHistoryBack = false;
	    var fromcourse2course = transition.to.name == 'course' && transition.from.name == 'normalcourse';
	    if (!fromcourse2course) {
	        $("#global_loading").length == 0 && $(document.body).append("<div id='global_loading' style='display: none;'><img src='https://fe-static-yuketang.yuketang.cn/fe/static/vue_images/2.2.561/images/loading-3.gif'></div>");
	        // $("#global_loading").show();
	    }
	
	    //当点击进入拥有二级导航的一级导航时，定位到之前已经进入的二级导航
	    if (transition.to.name === 'course') {
	        var children = _navData2.default.navlist[_vars2.default.navlv1number.course].children;
	        var activeindex = localStorage && localStorage.getItem('rain.course.activeindex') || children.activeindex;
	        transition.redirect({
	            name: children.list[+activeindex].rel
	        });
	        $("#global_loading").hide();
	    }
	
	    if (transition.to.name == 'mystore' && transition.from.name == 'mymainpage' || !transition.from.name) {
	        window.loadNewCollection = true;
	    } else {
	        window.loadNewCollection = false;
	    }
	
	    // 订阅发布重置
	    var pubSub = window.parent && window.parent.PubSub || null;
	    pubSub && pubSub.publish('reset', { msg: 'reset', name: transition.to.name });
	
	    _utils.resetNavbar.call(router.app, transition.to.name);
	
	    (0, _setDocumentTitle2.default)();
	
	    transition.next();
	});
	
	router.afterEach(function (transition) {
	    $("#global_loading").hide();
	    // 统计
	    setTimeout(function () {
	        if (typeof _dailyReport2.default !== 'undefined') {
	            if (transition.to.params.classroom_id || transition.to.params.classroomid || transition.to.params.cid || transition.to.query.cid || transition.to.query.classroomid || transition.to.query.classroomID || transition.to.meta && transition.to.meta.reportCid) {
	                var _key = 'Report.Daily.Cid';
	                var cid = transition.to.params.classroom_id || transition.to.params.classroomid || transition.to.params.cid || transition.to.query.cid || transition.to.query.classroomid || transition.to.query.classroomID || window.sessionStorage.getItem(_key);
	                _dailyReport2.default.updateLog({ classroom_id: +cid }, true);
	            } else {
	                _dailyReport2.default.updateLog({ classroom_id: undefined }, true);
	            }
	        }
	        // pv单页面统计
	        typeof _dailyReport2.default !== 'undefined' && _dailyReport2.default.reportLog();
	    }, 2000);
	
	    if ($.isAndroid() && transition.to.name && transition.to.name.indexOf('opencourse') !== -1) {
	        $.setWXConfig();
	    }
	    setTimeout(function () {
	        // 解决 android手机字体缩放
	        (0, _utils.setSize)();
	    }, 1200);
	
	    if ((document.title === '雨课堂' || document.title === 'Rain Classroom') && _vue2.default.prototype.isYD) {
	        (0, _setDocumentTitle2.default)();
	    }
	});
	
	//防止键盘弹出时，挡住录入框
	window.addEventListener("resize", function () {
	    if (document.activeElement.tagName == "INPUT" || document.activeElement.tagName == "TEXTAREA") {
	        window.setTimeout(function () {
	            document.activeElement.scrollIntoViewIfNeeded();
	        }, 0);
	    }
	});
	
	window.addEventListener("popstate", function (e) {
	    setTimeout(function () {
	        //回退时添加标记，判断是否需要设置滚动条位置
	        window.isHistoryBack = true;
	    }, 0);
	});
	
	// 解决 android手机字体缩放
	(0, _utils.setSize)();
	
	// 检测http协议改成https
	(0, _utils.initProtocal)();
	
	(0, _utils.pagereload)();
	
	// 检测是否在小程序中
	typeof wx !== 'undefined' && wx.miniProgram.getEnv(function (res) {
	    if (res.miniprogram) {
	        window.miniprogram = true;
	    }
	});
	
	setHeaderStorageFn().then(function (e) {
	    router.start(App, 'app');
	}).catch(function (e) {
	    router.start(App, 'app');
	});
	
	function zPrint() {
	    var text = "";
	    for (var i = 0; i < arguments.length; i++) {
	        text += arguments[i];
	    }
	    text += ";<br/>";
	    var zclient = document.querySelector('#zClientPrint');
	    if (zclient) {
	        zclient.innerHTML += text;
	    } else {
	        var div = document.createElement('div');
	        div.id = "zClientPrint";
	        div.style.position = "fixed";
	        div.style.bottom = "50px";
	        div.style.zIndex = 1111111111;
	        div.style.background = "rgba(122, 64, 72, 0.1)";
	        div.style.pointerEvents = "none";
	        div.style.fontSize = "14px";
	        document.body.append(div);
	        div.innerHTML = text;
	    }
	}
	
	setTimeout(function () {
	    if (window.__wxjs_environment === 'miniprogram' || window.parent && window.parent.__wxjs_environment === 'miniprogram') {
	        return;
	    } else {
	        var jiguangSrc = 'https://web-stat.jiguang.cn/web-janalytics/scripts/janalytics-web.min.js';
	        (0, _utils.loadScript)(jiguangSrc).then(function () {
	            (function () {
	                if (window.JAnalyticsInterface) {
	                    window.JAnalyticsInterface.init({
	                        appkey: 'fcdf8e635093adde6bef4265',
	                        debugMode: false,
	                        channel: 'rainH5',
	                        loc: false, //设置是否尝试获取位置信息上报，默认为 true
	                        singlePage: true //设置是否为单页面，默认为 false
	                    });
	                }
	            })();
	        });
	    }
	}, 3000);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2)(__webpack_require__(3))
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = window.$;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	module.exports = function(src) {
		function log(error) {
			(typeof console !== "undefined")
			&& (console.error || console.log)("[Script Loader]", error);
		}
	
		// Check for IE =< 8
		function isIE() {
			return typeof attachEvent !== "undefined" && typeof addEventListener === "undefined";
		}
	
		try {
			if (typeof execScript !== "undefined" && isIE()) {
				execScript(src);
			} else if (typeof eval !== "undefined") {
				eval.call(null, src);
			} else {
				log("EvalError: No eval function available");
			}
		} catch (error) {
			log(error);
		}
	}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = "/* Zepto v1.2.0 - zepto event ajax form ie - zeptojs.com/license */\n!function(t,e){\"function\"==typeof define&&define.amd?define(function(){return e(t)}):e(t)}(this,function(t){var e=function(){function $(t){return null==t?String(t):S[C.call(t)]||\"object\"}function F(t){return\"function\"==$(t)}function k(t){return null!=t&&t==t.window}function M(t){return null!=t&&t.nodeType==t.DOCUMENT_NODE}function R(t){return\"object\"==$(t)}function Z(t){return R(t)&&!k(t)&&Object.getPrototypeOf(t)==Object.prototype}function z(t){var e=!!t&&\"length\"in t&&t.length,n=r.type(t);return\"function\"!=n&&!k(t)&&(\"array\"==n||0===e||\"number\"==typeof e&&e>0&&e-1 in t)}function q(t){return a.call(t,function(t){return null!=t})}function H(t){return t.length>0?r.fn.concat.apply([],t):t}function I(t){return t.replace(/::/g,\"/\").replace(/([A-Z]+)([A-Z][a-z])/g,\"$1_$2\").replace(/([a-z\\d])([A-Z])/g,\"$1_$2\").replace(/_/g,\"-\").toLowerCase()}function V(t){return t in l?l[t]:l[t]=new RegExp(\"(^|\\\\s)\"+t+\"(\\\\s|$)\")}function _(t,e){return\"number\"!=typeof e||h[I(t)]?e:e+\"px\"}function B(t){var e,n;return c[t]||(e=f.createElement(t),f.body.appendChild(e),n=getComputedStyle(e,\"\").getPropertyValue(\"display\"),e.parentNode.removeChild(e),\"none\"==n&&(n=\"block\"),c[t]=n),c[t]}function U(t){return\"children\"in t?u.call(t.children):r.map(t.childNodes,function(t){return 1==t.nodeType?t:void 0})}function X(t,e){var n,r=t?t.length:0;for(n=0;r>n;n++)this[n]=t[n];this.length=r,this.selector=e||\"\"}function J(t,r,i){for(n in r)i&&(Z(r[n])||L(r[n]))?(Z(r[n])&&!Z(t[n])&&(t[n]={}),L(r[n])&&!L(t[n])&&(t[n]=[]),J(t[n],r[n],i)):r[n]!==e&&(t[n]=r[n])}function W(t,e){return null==e?r(t):r(t).filter(e)}function Y(t,e,n,r){return F(e)?e.call(t,n,r):e}function G(t,e,n){null==n?t.removeAttribute(e):t.setAttribute(e,n)}function K(t,n){var r=t.className||\"\",i=r&&r.baseVal!==e;return n===e?i?r.baseVal:r:void(i?r.baseVal=n:t.className=n)}function Q(t){try{return t?\"true\"==t||(\"false\"==t?!1:\"null\"==t?null:+t+\"\"==t?+t:/^[\\[\\{]/.test(t)?r.parseJSON(t):t):t}catch(e){return t}}function tt(t,e){e(t);for(var n=0,r=t.childNodes.length;r>n;n++)tt(t.childNodes[n],e)}var e,n,r,i,O,P,o=[],s=o.concat,a=o.filter,u=o.slice,f=t.document,c={},l={},h={\"column-count\":1,columns:1,\"font-weight\":1,\"line-height\":1,opacity:1,\"z-index\":1,zoom:1},p=/^\\s*<(\\w+|!)[^>]*>/,d=/^<(\\w+)\\s*\\/?>(?:<\\/\\1>|)$/,m=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\\w:]+)[^>]*)\\/>/gi,g=/^(?:body|html)$/i,v=/([A-Z])/g,y=[\"val\",\"css\",\"html\",\"text\",\"data\",\"width\",\"height\",\"offset\"],x=[\"after\",\"prepend\",\"before\",\"append\"],b=f.createElement(\"table\"),E=f.createElement(\"tr\"),j={tr:f.createElement(\"tbody\"),tbody:b,thead:b,tfoot:b,td:E,th:E,\"*\":f.createElement(\"div\")},w=/complete|loaded|interactive/,T=/^[\\w-]*$/,S={},C=S.toString,N={},A=f.createElement(\"div\"),D={tabindex:\"tabIndex\",readonly:\"readOnly\",\"for\":\"htmlFor\",\"class\":\"className\",maxlength:\"maxLength\",cellspacing:\"cellSpacing\",cellpadding:\"cellPadding\",rowspan:\"rowSpan\",colspan:\"colSpan\",usemap:\"useMap\",frameborder:\"frameBorder\",contenteditable:\"contentEditable\"},L=Array.isArray||function(t){return t instanceof Array};return N.matches=function(t,e){if(!e||!t||1!==t.nodeType)return!1;var n=t.matches||t.webkitMatchesSelector||t.mozMatchesSelector||t.oMatchesSelector||t.matchesSelector;if(n)return n.call(t,e);var r,i=t.parentNode,o=!i;return o&&(i=A).appendChild(t),r=~N.qsa(i,e).indexOf(t),o&&A.removeChild(t),r},O=function(t){return t.replace(/-+(.)?/g,function(t,e){return e?e.toUpperCase():\"\"})},P=function(t){return a.call(t,function(e,n){return t.indexOf(e)==n})},N.fragment=function(t,n,i){var o,s,a;return d.test(t)&&(o=r(f.createElement(RegExp.$1))),o||(t.replace&&(t=t.replace(m,\"<$1></$2>\")),n===e&&(n=p.test(t)&&RegExp.$1),n in j||(n=\"*\"),a=j[n],a.innerHTML=\"\"+t,o=r.each(u.call(a.childNodes),function(){a.removeChild(this)})),Z(i)&&(s=r(o),r.each(i,function(t,e){y.indexOf(t)>-1?s[t](e):s.attr(t,e)})),o},N.Z=function(t,e){return new X(t,e)},N.isZ=function(t){return t instanceof N.Z},N.init=function(t,n){var i;if(!t)return N.Z();if(\"string\"==typeof t)if(t=t.trim(),\"<\"==t[0]&&p.test(t))i=N.fragment(t,RegExp.$1,n),t=null;else{if(n!==e)return r(n).find(t);i=N.qsa(f,t)}else{if(F(t))return r(f).ready(t);if(N.isZ(t))return t;if(L(t))i=q(t);else if(R(t))i=[t],t=null;else if(p.test(t))i=N.fragment(t.trim(),RegExp.$1,n),t=null;else{if(n!==e)return r(n).find(t);i=N.qsa(f,t)}}return N.Z(i,t)},r=function(t,e){return N.init(t,e)},r.extend=function(t){var e,n=u.call(arguments,1);return\"boolean\"==typeof t&&(e=t,t=n.shift()),n.forEach(function(n){J(t,n,e)}),t},N.qsa=function(t,e){var n,r=\"#\"==e[0],i=!r&&\".\"==e[0],o=r||i?e.slice(1):e,s=T.test(o);return t.getElementById&&s&&r?(n=t.getElementById(o))?[n]:[]:1!==t.nodeType&&9!==t.nodeType&&11!==t.nodeType?[]:u.call(s&&!r&&t.getElementsByClassName?i?t.getElementsByClassName(o):t.getElementsByTagName(e):t.querySelectorAll(e))},r.contains=f.documentElement.contains?function(t,e){return t!==e&&t.contains(e)}:function(t,e){for(;e&&(e=e.parentNode);)if(e===t)return!0;return!1},r.type=$,r.isFunction=F,r.isWindow=k,r.isArray=L,r.isPlainObject=Z,r.isEmptyObject=function(t){var e;for(e in t)return!1;return!0},r.isNumeric=function(t){var e=Number(t),n=typeof t;return null!=t&&\"boolean\"!=n&&(\"string\"!=n||t.length)&&!isNaN(e)&&isFinite(e)||!1},r.inArray=function(t,e,n){return o.indexOf.call(e,t,n)},r.camelCase=O,r.trim=function(t){return null==t?\"\":String.prototype.trim.call(t)},r.uuid=0,r.support={},r.expr={},r.noop=function(){},r.map=function(t,e){var n,i,o,r=[];if(z(t))for(i=0;i<t.length;i++)n=e(t[i],i),null!=n&&r.push(n);else for(o in t)n=e(t[o],o),null!=n&&r.push(n);return H(r)},r.each=function(t,e){var n,r;if(z(t)){for(n=0;n<t.length;n++)if(e.call(t[n],n,t[n])===!1)return t}else for(r in t)if(e.call(t[r],r,t[r])===!1)return t;return t},r.grep=function(t,e){return a.call(t,e)},t.JSON&&(r.parseJSON=JSON.parse),r.each(\"Boolean Number String Function Array Date RegExp Object Error\".split(\" \"),function(t,e){S[\"[object \"+e+\"]\"]=e.toLowerCase()}),r.fn={constructor:N.Z,length:0,forEach:o.forEach,reduce:o.reduce,push:o.push,sort:o.sort,splice:o.splice,indexOf:o.indexOf,concat:function(){var t,e,n=[];for(t=0;t<arguments.length;t++)e=arguments[t],n[t]=N.isZ(e)?e.toArray():e;return s.apply(N.isZ(this)?this.toArray():this,n)},map:function(t){return r(r.map(this,function(e,n){return t.call(e,n,e)}))},slice:function(){return r(u.apply(this,arguments))},ready:function(t){return w.test(f.readyState)&&f.body?t(r):f.addEventListener(\"DOMContentLoaded\",function(){t(r)},!1),this},get:function(t){return t===e?u.call(this):this[t>=0?t:t+this.length]},toArray:function(){return this.get()},size:function(){return this.length},remove:function(){return this.each(function(){null!=this.parentNode&&this.parentNode.removeChild(this)})},each:function(t){return o.every.call(this,function(e,n){return t.call(e,n,e)!==!1}),this},filter:function(t){return F(t)?this.not(this.not(t)):r(a.call(this,function(e){return N.matches(e,t)}))},add:function(t,e){return r(P(this.concat(r(t,e))))},is:function(t){return this.length>0&&N.matches(this[0],t)},not:function(t){var n=[];if(F(t)&&t.call!==e)this.each(function(e){t.call(this,e)||n.push(this)});else{var i=\"string\"==typeof t?this.filter(t):z(t)&&F(t.item)?u.call(t):r(t);this.forEach(function(t){i.indexOf(t)<0&&n.push(t)})}return r(n)},has:function(t){return this.filter(function(){return R(t)?r.contains(this,t):r(this).find(t).size()})},eq:function(t){return-1===t?this.slice(t):this.slice(t,+t+1)},first:function(){var t=this[0];return t&&!R(t)?t:r(t)},last:function(){var t=this[this.length-1];return t&&!R(t)?t:r(t)},find:function(t){var e,n=this;return e=t?\"object\"==typeof t?r(t).filter(function(){var t=this;return o.some.call(n,function(e){return r.contains(e,t)})}):1==this.length?r(N.qsa(this[0],t)):this.map(function(){return N.qsa(this,t)}):r()},closest:function(t,e){var n=[],i=\"object\"==typeof t&&r(t);return this.each(function(r,o){for(;o&&!(i?i.indexOf(o)>=0:N.matches(o,t));)o=o!==e&&!M(o)&&o.parentNode;o&&n.indexOf(o)<0&&n.push(o)}),r(n)},parents:function(t){for(var e=[],n=this;n.length>0;)n=r.map(n,function(t){return(t=t.parentNode)&&!M(t)&&e.indexOf(t)<0?(e.push(t),t):void 0});return W(e,t)},parent:function(t){return W(P(this.pluck(\"parentNode\")),t)},children:function(t){return W(this.map(function(){return U(this)}),t)},contents:function(){return this.map(function(){return this.contentDocument||u.call(this.childNodes)})},siblings:function(t){return W(this.map(function(t,e){return a.call(U(e.parentNode),function(t){return t!==e})}),t)},empty:function(){return this.each(function(){this.innerHTML=\"\"})},pluck:function(t){return r.map(this,function(e){return e[t]})},show:function(){return this.each(function(){\"none\"==this.style.display&&(this.style.display=\"\"),\"none\"==getComputedStyle(this,\"\").getPropertyValue(\"display\")&&(this.style.display=B(this.nodeName))})},replaceWith:function(t){return this.before(t).remove()},wrap:function(t){var e=F(t);if(this[0]&&!e)var n=r(t).get(0),i=n.parentNode||this.length>1;return this.each(function(o){r(this).wrapAll(e?t.call(this,o):i?n.cloneNode(!0):n)})},wrapAll:function(t){if(this[0]){r(this[0]).before(t=r(t));for(var e;(e=t.children()).length;)t=e.first();r(t).append(this)}return this},wrapInner:function(t){var e=F(t);return this.each(function(n){var i=r(this),o=i.contents(),s=e?t.call(this,n):t;o.length?o.wrapAll(s):i.append(s)})},unwrap:function(){return this.parent().each(function(){r(this).replaceWith(r(this).children())}),this},clone:function(){return this.map(function(){return this.cloneNode(!0)})},hide:function(){return this.css(\"display\",\"none\")},toggle:function(t){return this.each(function(){var n=r(this);(t===e?\"none\"==n.css(\"display\"):t)?n.show():n.hide()})},prev:function(t){return r(this.pluck(\"previousElementSibling\")).filter(t||\"*\")},next:function(t){return r(this.pluck(\"nextElementSibling\")).filter(t||\"*\")},html:function(t){return 0 in arguments?this.each(function(e){var n=this.innerHTML;r(this).empty().append(Y(this,t,e,n))}):0 in this?this[0].innerHTML:null},text:function(t){return 0 in arguments?this.each(function(e){var n=Y(this,t,e,this.textContent);this.textContent=null==n?\"\":\"\"+n}):0 in this?this.pluck(\"textContent\").join(\"\"):null},attr:function(t,r){var i;return\"string\"!=typeof t||1 in arguments?this.each(function(e){if(1===this.nodeType)if(R(t))for(n in t)G(this,n,t[n]);else G(this,t,Y(this,r,e,this.getAttribute(t)))}):0 in this&&1==this[0].nodeType&&null!=(i=this[0].getAttribute(t))?i:e},removeAttr:function(t){return this.each(function(){1===this.nodeType&&t.split(\" \").forEach(function(t){G(this,t)},this)})},prop:function(t,e){return t=D[t]||t,1 in arguments?this.each(function(n){this[t]=Y(this,e,n,this[t])}):this[0]&&this[0][t]},removeProp:function(t){return t=D[t]||t,this.each(function(){delete this[t]})},data:function(t,n){var r=\"data-\"+t.replace(v,\"-$1\").toLowerCase(),i=1 in arguments?this.attr(r,n):this.attr(r);return null!==i?Q(i):e},val:function(t){return 0 in arguments?(null==t&&(t=\"\"),this.each(function(e){this.value=Y(this,t,e,this.value)})):this[0]&&(this[0].multiple?r(this[0]).find(\"option\").filter(function(){return this.selected}).pluck(\"value\"):this[0].value)},offset:function(e){if(e)return this.each(function(t){var n=r(this),i=Y(this,e,t,n.offset()),o=n.offsetParent().offset(),s={top:i.top-o.top,left:i.left-o.left};\"static\"==n.css(\"position\")&&(s.position=\"relative\"),n.css(s)});if(!this.length)return null;if(f.documentElement!==this[0]&&!r.contains(f.documentElement,this[0]))return{top:0,left:0};var n=this[0].getBoundingClientRect();return{left:n.left+t.pageXOffset,top:n.top+t.pageYOffset,width:Math.round(n.width),height:Math.round(n.height)}},css:function(t,e){if(arguments.length<2){var i=this[0];if(\"string\"==typeof t){if(!i)return;return i.style[O(t)]||getComputedStyle(i,\"\").getPropertyValue(t)}if(L(t)){if(!i)return;var o={},s=getComputedStyle(i,\"\");return r.each(t,function(t,e){o[e]=i.style[O(e)]||s.getPropertyValue(e)}),o}}var a=\"\";if(\"string\"==$(t))e||0===e?a=I(t)+\":\"+_(t,e):this.each(function(){this.style.removeProperty(I(t))});else for(n in t)t[n]||0===t[n]?a+=I(n)+\":\"+_(n,t[n])+\";\":this.each(function(){this.style.removeProperty(I(n))});return this.each(function(){this.style.cssText+=\";\"+a})},index:function(t){return t?this.indexOf(r(t)[0]):this.parent().children().indexOf(this[0])},hasClass:function(t){return t?o.some.call(this,function(t){return this.test(K(t))},V(t)):!1},addClass:function(t){return t?this.each(function(e){if(\"className\"in this){i=[];var n=K(this),o=Y(this,t,e,n);o.split(/\\s+/g).forEach(function(t){r(this).hasClass(t)||i.push(t)},this),i.length&&K(this,n+(n?\" \":\"\")+i.join(\" \"))}}):this},removeClass:function(t){return this.each(function(n){if(\"className\"in this){if(t===e)return K(this,\"\");i=K(this),Y(this,t,n,i).split(/\\s+/g).forEach(function(t){i=i.replace(V(t),\" \")}),K(this,i.trim())}})},toggleClass:function(t,n){return t?this.each(function(i){var o=r(this),s=Y(this,t,i,K(this));s.split(/\\s+/g).forEach(function(t){(n===e?!o.hasClass(t):n)?o.addClass(t):o.removeClass(t)})}):this},scrollTop:function(t){if(this.length){var n=\"scrollTop\"in this[0];return t===e?n?this[0].scrollTop:this[0].pageYOffset:this.each(n?function(){this.scrollTop=t}:function(){this.scrollTo(this.scrollX,t)})}},scrollLeft:function(t){if(this.length){var n=\"scrollLeft\"in this[0];return t===e?n?this[0].scrollLeft:this[0].pageXOffset:this.each(n?function(){this.scrollLeft=t}:function(){this.scrollTo(t,this.scrollY)})}},position:function(){if(this.length){var t=this[0],e=this.offsetParent(),n=this.offset(),i=g.test(e[0].nodeName)?{top:0,left:0}:e.offset();return n.top-=parseFloat(r(t).css(\"margin-top\"))||0,n.left-=parseFloat(r(t).css(\"margin-left\"))||0,i.top+=parseFloat(r(e[0]).css(\"border-top-width\"))||0,i.left+=parseFloat(r(e[0]).css(\"border-left-width\"))||0,{top:n.top-i.top,left:n.left-i.left}}},offsetParent:function(){return this.map(function(){for(var t=this.offsetParent||f.body;t&&!g.test(t.nodeName)&&\"static\"==r(t).css(\"position\");)t=t.offsetParent;return t})}},r.fn.detach=r.fn.remove,[\"width\",\"height\"].forEach(function(t){var n=t.replace(/./,function(t){return t[0].toUpperCase()});r.fn[t]=function(i){var o,s=this[0];return i===e?k(s)?s[\"inner\"+n]:M(s)?s.documentElement[\"scroll\"+n]:(o=this.offset())&&o[t]:this.each(function(e){s=r(this),s.css(t,Y(this,i,e,s[t]()))})}}),x.forEach(function(n,i){var o=i%2;r.fn[n]=function(){var n,a,s=r.map(arguments,function(t){var i=[];return n=$(t),\"array\"==n?(t.forEach(function(t){return t.nodeType!==e?i.push(t):r.zepto.isZ(t)?i=i.concat(t.get()):void(i=i.concat(N.fragment(t)))}),i):\"object\"==n||null==t?t:N.fragment(t)}),u=this.length>1;return s.length<1?this:this.each(function(e,n){a=o?n:n.parentNode,n=0==i?n.nextSibling:1==i?n.firstChild:2==i?n:null;var c=r.contains(f.documentElement,a);s.forEach(function(e){if(u)e=e.cloneNode(!0);else if(!a)return r(e).remove();a.insertBefore(e,n),c&&tt(e,function(e){if(!(null==e.nodeName||\"SCRIPT\"!==e.nodeName.toUpperCase()||e.type&&\"text/javascript\"!==e.type||e.src)){var n=e.ownerDocument?e.ownerDocument.defaultView:t;n.eval.call(n,e.innerHTML)}})})})},r.fn[o?n+\"To\":\"insert\"+(i?\"Before\":\"After\")]=function(t){return r(t)[n](this),this}}),N.Z.prototype=X.prototype=r.fn,N.uniq=P,N.deserializeValue=Q,r.zepto=N,r}();return t.Zepto=e,void 0===t.$&&(t.$=e),function(e){function h(t){return t._zid||(t._zid=n++)}function p(t,e,n,r){if(e=d(e),e.ns)var i=m(e.ns);return(a[h(t)]||[]).filter(function(t){return t&&(!e.e||t.e==e.e)&&(!e.ns||i.test(t.ns))&&(!n||h(t.fn)===h(n))&&(!r||t.sel==r)})}function d(t){var e=(\"\"+t).split(\".\");return{e:e[0],ns:e.slice(1).sort().join(\" \")}}function m(t){return new RegExp(\"(?:^| )\"+t.replace(\" \",\" .* ?\")+\"(?: |$)\")}function g(t,e){return t.del&&!f&&t.e in c||!!e}function v(t){return l[t]||f&&c[t]||t}function y(t,n,i,o,s,u,f){var c=h(t),p=a[c]||(a[c]=[]);n.split(/\\s/).forEach(function(n){if(\"ready\"==n)return e(document).ready(i);var a=d(n);a.fn=i,a.sel=s,a.e in l&&(i=function(t){var n=t.relatedTarget;return!n||n!==this&&!e.contains(this,n)?a.fn.apply(this,arguments):void 0}),a.del=u;var c=u||i;a.proxy=function(e){if(e=T(e),!e.isImmediatePropagationStopped()){e.data=o;var n=c.apply(t,e._args==r?[e]:[e].concat(e._args));return n===!1&&(e.preventDefault(),e.stopPropagation()),n}},a.i=p.length,p.push(a),\"addEventListener\"in t&&t.addEventListener(v(a.e),a.proxy,g(a,f))})}function x(t,e,n,r,i){var o=h(t);(e||\"\").split(/\\s/).forEach(function(e){p(t,e,n,r).forEach(function(e){delete a[o][e.i],\"removeEventListener\"in t&&t.removeEventListener(v(e.e),e.proxy,g(e,i))})})}function T(t,n){return(n||!t.isDefaultPrevented)&&(n||(n=t),e.each(w,function(e,r){var i=n[e];t[e]=function(){return this[r]=b,i&&i.apply(n,arguments)},t[r]=E}),t.timeStamp||(t.timeStamp=Date.now()),(n.defaultPrevented!==r?n.defaultPrevented:\"returnValue\"in n?n.returnValue===!1:n.getPreventDefault&&n.getPreventDefault())&&(t.isDefaultPrevented=b)),t}function S(t){var e,n={originalEvent:t};for(e in t)j.test(e)||t[e]===r||(n[e]=t[e]);return T(n,t)}var r,n=1,i=Array.prototype.slice,o=e.isFunction,s=function(t){return\"string\"==typeof t},a={},u={},f=\"onfocusin\"in t,c={focus:\"focusin\",blur:\"focusout\"},l={mouseenter:\"mouseover\",mouseleave:\"mouseout\"};u.click=u.mousedown=u.mouseup=u.mousemove=\"MouseEvents\",e.event={add:y,remove:x},e.proxy=function(t,n){var r=2 in arguments&&i.call(arguments,2);if(o(t)){var a=function(){return t.apply(n,r?r.concat(i.call(arguments)):arguments)};return a._zid=h(t),a}if(s(n))return r?(r.unshift(t[n],t),e.proxy.apply(null,r)):e.proxy(t[n],t);throw new TypeError(\"expected function\")},e.fn.bind=function(t,e,n){return this.on(t,e,n)},e.fn.unbind=function(t,e){return this.off(t,e)},e.fn.one=function(t,e,n,r){return this.on(t,e,n,r,1)};var b=function(){return!0},E=function(){return!1},j=/^([A-Z]|returnValue$|layer[XY]$|webkitMovement[XY]$)/,w={preventDefault:\"isDefaultPrevented\",stopImmediatePropagation:\"isImmediatePropagationStopped\",stopPropagation:\"isPropagationStopped\"};e.fn.delegate=function(t,e,n){return this.on(e,t,n)},e.fn.undelegate=function(t,e,n){return this.off(e,t,n)},e.fn.live=function(t,n){return e(document.body).delegate(this.selector,t,n),this},e.fn.die=function(t,n){return e(document.body).undelegate(this.selector,t,n),this},e.fn.on=function(t,n,a,u,f){var c,l,h=this;return t&&!s(t)?(e.each(t,function(t,e){h.on(t,n,a,e,f)}),h):(s(n)||o(u)||u===!1||(u=a,a=n,n=r),(u===r||a===!1)&&(u=a,a=r),u===!1&&(u=E),h.each(function(r,o){f&&(c=function(t){return x(o,t.type,u),u.apply(this,arguments)}),n&&(l=function(t){var r,s=e(t.target).closest(n,o).get(0);return s&&s!==o?(r=e.extend(S(t),{currentTarget:s,liveFired:o}),(c||u).apply(s,[r].concat(i.call(arguments,1)))):void 0}),y(o,t,u,a,n,l||c)}))},e.fn.off=function(t,n,i){var a=this;return t&&!s(t)?(e.each(t,function(t,e){a.off(t,n,e)}),a):(s(n)||o(i)||i===!1||(i=n,n=r),i===!1&&(i=E),a.each(function(){x(this,t,i,n)}))},e.fn.trigger=function(t,n){return t=s(t)||e.isPlainObject(t)?e.Event(t):T(t),t._args=n,this.each(function(){t.type in c&&\"function\"==typeof this[t.type]?this[t.type]():\"dispatchEvent\"in this?this.dispatchEvent(t):e(this).triggerHandler(t,n)})},e.fn.triggerHandler=function(t,n){var r,i;return this.each(function(o,a){r=S(s(t)?e.Event(t):t),r._args=n,r.target=a,e.each(p(a,t.type||t),function(t,e){return i=e.proxy(r),r.isImmediatePropagationStopped()?!1:void 0})}),i},\"focusin focusout focus blur load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select keydown keypress keyup error\".split(\" \").forEach(function(t){e.fn[t]=function(e){return 0 in arguments?this.bind(t,e):this.trigger(t)}}),e.Event=function(t,e){s(t)||(e=t,t=e.type);var n=document.createEvent(u[t]||\"Events\"),r=!0;if(e)for(var i in e)\"bubbles\"==i?r=!!e[i]:n[i]=e[i];return n.initEvent(t,r,!0),T(n)}}(e),function(e){function p(t,n,r){var i=e.Event(n);return e(t).trigger(i,r),!i.isDefaultPrevented()}function d(t,e,n,i){return t.global?p(e||r,n,i):void 0}function m(t){t.global&&0===e.active++&&d(t,null,\"ajaxStart\")}function g(t){t.global&&!--e.active&&d(t,null,\"ajaxStop\")}function v(t,e){var n=e.context;return e.beforeSend.call(n,t,e)===!1||d(e,n,\"ajaxBeforeSend\",[t,e])===!1?!1:void d(e,n,\"ajaxSend\",[t,e])}function y(t,e,n,r){var i=n.context,o=\"success\";n.success.call(i,t,o,e),r&&r.resolveWith(i,[t,o,e]),d(n,i,\"ajaxSuccess\",[e,n,t]),b(o,e,n)}function x(t,e,n,r,i){var o=r.context;r.error.call(o,n,e,t),i&&i.rejectWith(o,[n,e,t]),d(r,o,\"ajaxError\",[n,r,t||e]),b(e,n,r)}function b(t,e,n){var r=n.context;n.complete.call(r,e,t),d(n,r,\"ajaxComplete\",[e,n]),g(n)}function E(t,e,n){if(n.dataFilter==j)return t;var r=n.context;return n.dataFilter.call(r,t,e)}function j(){}function w(t){return t&&(t=t.split(\";\",2)[0]),t&&(t==c?\"html\":t==f?\"json\":a.test(t)?\"script\":u.test(t)&&\"xml\")||\"text\"}function T(t,e){return\"\"==e?t:(t+\"&\"+e).replace(/[&?]{1,2}/,\"?\")}function S(t){t.processData&&t.data&&\"string\"!=e.type(t.data)&&(t.data=e.param(t.data,t.traditional)),!t.data||t.type&&\"GET\"!=t.type.toUpperCase()&&\"jsonp\"!=t.dataType||(t.url=T(t.url,t.data),t.data=void 0)}function C(t,n,r,i){return e.isFunction(n)&&(i=r,r=n,n=void 0),e.isFunction(r)||(i=r,r=void 0),{url:t,data:n,success:r,dataType:i}}function O(t,n,r,i){var o,s=e.isArray(n),a=e.isPlainObject(n);e.each(n,function(n,u){o=e.type(u),i&&(n=r?i:i+\"[\"+(a||\"object\"==o||\"array\"==o?n:\"\")+\"]\"),!i&&s?t.add(u.name,u.value):\"array\"==o||!r&&\"object\"==o?O(t,u,r,n):t.add(n,u)})}var i,o,n=+new Date,r=t.document,s=/<script\\b[^<]*(?:(?!<\\/script>)<[^<]*)*<\\/script>/gi,a=/^(?:text|application)\\/javascript/i,u=/^(?:text|application)\\/xml/i,f=\"application/json\",c=\"text/html\",l=/^\\s*$/,h=r.createElement(\"a\");h.href=t.location.href,e.active=0,e.ajaxJSONP=function(i,o){if(!(\"type\"in i))return e.ajax(i);var c,p,s=i.jsonpCallback,a=(e.isFunction(s)?s():s)||\"Zepto\"+n++,u=r.createElement(\"script\"),f=t[a],l=function(t){e(u).triggerHandler(\"error\",t||\"abort\")},h={abort:l};return o&&o.promise(h),e(u).on(\"load error\",function(n,r){clearTimeout(p),e(u).off().remove(),\"error\"!=n.type&&c?y(c[0],h,i,o):x(null,r||\"error\",h,i,o),t[a]=f,c&&e.isFunction(f)&&f(c[0]),f=c=void 0}),v(h,i)===!1?(l(\"abort\"),h):(t[a]=function(){c=arguments},u.src=i.url.replace(/\\?(.+)=\\?/,\"?$1=\"+a),r.head.appendChild(u),i.timeout>0&&(p=setTimeout(function(){l(\"timeout\")},i.timeout)),h)},e.ajaxSettings={type:\"GET\",beforeSend:j,success:j,error:j,complete:j,context:null,global:!0,xhr:function(){return new t.XMLHttpRequest},accepts:{script:\"text/javascript, application/javascript, application/x-javascript\",json:f,xml:\"application/xml, text/xml\",html:c,text:\"text/plain\"},crossDomain:!1,timeout:0,processData:!0,cache:!0,dataFilter:j},e.ajax=function(n){var u,f,s=e.extend({},n||{}),a=e.Deferred&&e.Deferred();for(i in e.ajaxSettings)void 0===s[i]&&(s[i]=e.ajaxSettings[i]);m(s),s.crossDomain||(u=r.createElement(\"a\"),u.href=s.url,u.href=u.href,s.crossDomain=h.protocol+\"//\"+h.host!=u.protocol+\"//\"+u.host),s.url||(s.url=t.location.toString()),(f=s.url.indexOf(\"#\"))>-1&&(s.url=s.url.slice(0,f)),S(s);var c=s.dataType,p=/\\?.+=\\?/.test(s.url);if(p&&(c=\"jsonp\"),s.cache!==!1&&(n&&n.cache===!0||\"script\"!=c&&\"jsonp\"!=c)||(s.url=T(s.url,\"_=\"+Date.now())),\"jsonp\"==c)return p||(s.url=T(s.url,s.jsonp?s.jsonp+\"=?\":s.jsonp===!1?\"\":\"callback=?\")),e.ajaxJSONP(s,a);var P,d=s.accepts[c],g={},b=function(t,e){g[t.toLowerCase()]=[t,e]},C=/^([\\w-]+:)\\/\\//.test(s.url)?RegExp.$1:t.location.protocol,N=s.xhr(),O=N.setRequestHeader;if(a&&a.promise(N),s.crossDomain||b(\"X-Requested-With\",\"XMLHttpRequest\"),b(\"Accept\",d||\"*/*\"),(d=s.mimeType||d)&&(d.indexOf(\",\")>-1&&(d=d.split(\",\",2)[0]),N.overrideMimeType&&N.overrideMimeType(d)),(s.contentType||s.contentType!==!1&&s.data&&\"GET\"!=s.type.toUpperCase())&&b(\"Content-Type\",s.contentType||\"application/x-www-form-urlencoded\"),s.headers)for(o in s.headers)b(o,s.headers[o]);if(N.setRequestHeader=b,N.onreadystatechange=function(){if(4==N.readyState){N.onreadystatechange=j,clearTimeout(P);var t,n=!1;if(N.status>=200&&N.status<300||304==N.status||0==N.status&&\"file:\"==C){if(c=c||w(s.mimeType||N.getResponseHeader(\"content-type\")),\"arraybuffer\"==N.responseType||\"blob\"==N.responseType)t=N.response;else{t=N.responseText;try{t=E(t,c,s),\"script\"==c?(1,eval)(t):\"xml\"==c?t=N.responseXML:\"json\"==c&&(t=l.test(t)?null:e.parseJSON(t))}catch(r){n=r}if(n)return x(n,\"parsererror\",N,s,a)}y(t,N,s,a)}else x(N.statusText||null,N.status?\"error\":\"abort\",N,s,a)}},v(N,s)===!1)return N.abort(),x(null,\"abort\",N,s,a),N;var A=\"async\"in s?s.async:!0;if(N.open(s.type,s.url,A,s.username,s.password),s.xhrFields)for(o in s.xhrFields)N[o]=s.xhrFields[o];for(o in g)O.apply(N,g[o]);return s.timeout>0&&(P=setTimeout(function(){N.onreadystatechange=j,N.abort(),x(null,\"timeout\",N,s,a)},s.timeout)),N.send(s.data?s.data:null),N},e.get=function(){return e.ajax(C.apply(null,arguments))},e.post=function(){var t=C.apply(null,arguments);return t.type=\"POST\",e.ajax(t)},e.getJSON=function(){var t=C.apply(null,arguments);return t.dataType=\"json\",e.ajax(t)},e.fn.load=function(t,n,r){if(!this.length)return this;var a,i=this,o=t.split(/\\s/),u=C(t,n,r),f=u.success;return o.length>1&&(u.url=o[0],a=o[1]),u.success=function(t){i.html(a?e(\"<div>\").html(t.replace(s,\"\")).find(a):t),f&&f.apply(i,arguments)},e.ajax(u),this};var N=encodeURIComponent;e.param=function(t,n){var r=[];return r.add=function(t,n){e.isFunction(n)&&(n=n()),null==n&&(n=\"\"),this.push(N(t)+\"=\"+N(n))},O(r,t,n),r.join(\"&\").replace(/%20/g,\"+\")}}(e),function(t){t.fn.serializeArray=function(){var e,n,r=[],i=function(t){return t.forEach?t.forEach(i):void r.push({name:e,value:t})};return this[0]&&t.each(this[0].elements,function(r,o){n=o.type,e=o.name,e&&\"fieldset\"!=o.nodeName.toLowerCase()&&!o.disabled&&\"submit\"!=n&&\"reset\"!=n&&\"button\"!=n&&\"file\"!=n&&(\"radio\"!=n&&\"checkbox\"!=n||o.checked)&&i(t(o).val())}),r},t.fn.serialize=function(){var t=[];return this.serializeArray().forEach(function(e){t.push(encodeURIComponent(e.name)+\"=\"+encodeURIComponent(e.value))}),t.join(\"&\")},t.fn.submit=function(e){if(0 in arguments)this.bind(\"submit\",e);else if(this.length){var n=t.Event(\"submit\");this.eq(0).trigger(n),n.isDefaultPrevented()||this.get(0).submit()}return this}}(e),function(){try{getComputedStyle(void 0)}catch(e){var n=getComputedStyle;t.getComputedStyle=function(t,e){try{return n(t,e)}catch(r){return null}}}}(),e});"

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Symbol = __webpack_require__(5)["default"];
	
	exports["default"] = function (obj) {
	  return obj && obj.constructor === _Symbol ? "symbol" : typeof obj;
	};
	
	exports.__esModule = true;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(6), __esModule: true };

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	__webpack_require__(35);
	module.exports = __webpack_require__(14).Symbol;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var $              = __webpack_require__(8)
	  , global         = __webpack_require__(9)
	  , has            = __webpack_require__(10)
	  , DESCRIPTORS    = __webpack_require__(11)
	  , $export        = __webpack_require__(13)
	  , redefine       = __webpack_require__(17)
	  , $fails         = __webpack_require__(12)
	  , shared         = __webpack_require__(20)
	  , setToStringTag = __webpack_require__(21)
	  , uid            = __webpack_require__(23)
	  , wks            = __webpack_require__(22)
	  , keyOf          = __webpack_require__(24)
	  , $names         = __webpack_require__(29)
	  , enumKeys       = __webpack_require__(30)
	  , isArray        = __webpack_require__(31)
	  , anObject       = __webpack_require__(32)
	  , toIObject      = __webpack_require__(25)
	  , createDesc     = __webpack_require__(19)
	  , getDesc        = $.getDesc
	  , setDesc        = $.setDesc
	  , _create        = $.create
	  , getNames       = $names.get
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , setter         = false
	  , HIDDEN         = wks('_hidden')
	  , isEnum         = $.isEnum
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , useNative      = typeof $Symbol == 'function'
	  , ObjectProto    = Object.prototype;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(setDesc({}, 'a', {
	    get: function(){ return setDesc(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = getDesc(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  setDesc(it, key, D);
	  if(protoDesc && it !== ObjectProto)setDesc(ObjectProto, key, protoDesc);
	} : setDesc;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol.prototype);
	  sym._k = tag;
	  DESCRIPTORS && setter && setSymbolDesc(ObjectProto, tag, {
	    configurable: true,
	    set: function(value){
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    }
	  });
	  return sym;
	};
	
	var isSymbol = function(it){
	  return typeof it == 'symbol';
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(D && has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))setDesc(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return setDesc(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key);
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key]
	    ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  var D = getDesc(it = toIObject(it), key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = getNames(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i)if(!has(AllSymbols, key = names[i++]) && key != HIDDEN)result.push(key);
	  return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var names  = getNames(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i)if(has(AllSymbols, key = names[i++]))result.push(AllSymbols[key]);
	  return result;
	};
	var $stringify = function stringify(it){
	  if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	  var args = [it]
	    , i    = 1
	    , $$   = arguments
	    , replacer, $replacer;
	  while($$.length > i)args.push($$[i++]);
	  replacer = args[1];
	  if(typeof replacer == 'function')$replacer = replacer;
	  if($replacer || !isArray(replacer))replacer = function(key, value){
	    if($replacer)value = $replacer.call(this, key, value);
	    if(!isSymbol(value))return value;
	  };
	  args[1] = replacer;
	  return _stringify.apply($JSON, args);
	};
	var buggyJSON = $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	});
	
	// 19.4.1.1 Symbol([description])
	if(!useNative){
	  $Symbol = function Symbol(){
	    if(isSymbol(this))throw TypeError('Symbol is not a constructor');
	    return wrap(uid(arguments.length > 0 ? arguments[0] : undefined));
	  };
	  redefine($Symbol.prototype, 'toString', function toString(){
	    return this._k;
	  });
	
	  isSymbol = function(it){
	    return it instanceof $Symbol;
	  };
	
	  $.create     = $create;
	  $.isEnum     = $propertyIsEnumerable;
	  $.getDesc    = $getOwnPropertyDescriptor;
	  $.setDesc    = $defineProperty;
	  $.setDescs   = $defineProperties;
	  $.getNames   = $names.get = $getOwnPropertyNames;
	  $.getSymbols = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(34)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	}
	
	var symbolStatics = {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    return keyOf(SymbolRegistry, key);
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	};
	// 19.4.2.2 Symbol.hasInstance
	// 19.4.2.3 Symbol.isConcatSpreadable
	// 19.4.2.4 Symbol.iterator
	// 19.4.2.6 Symbol.match
	// 19.4.2.8 Symbol.replace
	// 19.4.2.9 Symbol.search
	// 19.4.2.10 Symbol.species
	// 19.4.2.11 Symbol.split
	// 19.4.2.12 Symbol.toPrimitive
	// 19.4.2.13 Symbol.toStringTag
	// 19.4.2.14 Symbol.unscopables
	$.each.call((
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,' +
	  'species,split,toPrimitive,toStringTag,unscopables'
	).split(','), function(it){
	  var sym = wks(it);
	  symbolStatics[it] = useNative ? sym : wrap(sym);
	});
	
	setter = true;
	
	$export($export.G + $export.W, {Symbol: $Symbol});
	
	$export($export.S, 'Symbol', symbolStatics);
	
	$export($export.S + $export.F * !useNative, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!useNative || buggyJSON), 'JSON', {stringify: $stringify});
	
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	var $Object = Object;
	module.exports = {
	  create:     $Object.create,
	  getProto:   $Object.getPrototypeOf,
	  isEnum:     {}.propertyIsEnumerable,
	  getDesc:    $Object.getOwnPropertyDescriptor,
	  setDesc:    $Object.defineProperty,
	  setDescs:   $Object.defineProperties,
	  getKeys:    $Object.keys,
	  getNames:   $Object.getOwnPropertyNames,
	  getSymbols: $Object.getOwnPropertySymbols,
	  each:       [].forEach
	};

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(12)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(9)
	  , core      = __webpack_require__(14)
	  , ctx       = __webpack_require__(15)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && key in target;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(param){
	        return this instanceof C ? new C(param) : C(param);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    if(IS_PROTO)(exports[PROTOTYPE] || (exports[PROTOTYPE] = {}))[key] = out;
	  }
	};
	// type bitmap
	$export.F = 1;  // forced
	$export.G = 2;  // global
	$export.S = 4;  // static
	$export.P = 8;  // proto
	$export.B = 16; // bind
	$export.W = 32; // wrap
	module.exports = $export;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	var core = module.exports = {version: '1.2.6'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(16);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(18);

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var $          = __webpack_require__(8)
	  , createDesc = __webpack_require__(19);
	module.exports = __webpack_require__(11) ? function(object, key, value){
	  return $.setDesc(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(9)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(8).setDesc
	  , has = __webpack_require__(10)
	  , TAG = __webpack_require__(22)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var store  = __webpack_require__(20)('wks')
	  , uid    = __webpack_require__(23)
	  , Symbol = __webpack_require__(9).Symbol;
	module.exports = function(name){
	  return store[name] || (store[name] =
	    Symbol && Symbol[name] || (Symbol || uid)('Symbol.' + name));
	};

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var $         = __webpack_require__(8)
	  , toIObject = __webpack_require__(25);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = $.getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(26)
	  , defined = __webpack_require__(28);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(27);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(25)
	  , getNames  = __webpack_require__(8).getNames
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return getNames(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.get = function getOwnPropertyNames(it){
	  if(windowNames && toString.call(it) == '[object Window]')return getWindowNames(it);
	  return getNames(toIObject(it));
	};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var $ = __webpack_require__(8);
	module.exports = function(it){
	  var keys       = $.getKeys(it)
	    , getSymbols = $.getSymbols;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = $.isEnum
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))keys.push(key);
	  }
	  return keys;
	};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(27);
	module.exports = Array.isArray || function(arg){
	  return cof(arg) == 'Array';
	};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(33);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	module.exports = true;

/***/ }),
/* 35 */
/***/ (function(module, exports) {



/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(37), __esModule: true };

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(35);
	__webpack_require__(38);
	__webpack_require__(44);
	__webpack_require__(48);
	module.exports = __webpack_require__(14).Promise;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(39)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(41)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(40)
	  , defined   = __webpack_require__(28);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(34)
	  , $export        = __webpack_require__(13)
	  , redefine       = __webpack_require__(17)
	  , hide           = __webpack_require__(18)
	  , has            = __webpack_require__(10)
	  , Iterators      = __webpack_require__(42)
	  , $iterCreate    = __webpack_require__(43)
	  , setToStringTag = __webpack_require__(21)
	  , getProto       = __webpack_require__(8).getProto
	  , ITERATOR       = __webpack_require__(22)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , methods, key;
	  // Fix native
	  if($native){
	    var IteratorPrototype = getProto($default.call(new Base));
	    // Set @@toStringTag to native iterators
	    setToStringTag(IteratorPrototype, TAG, true);
	    // FF fix
	    if(!LIBRARY && has(proto, FF_ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    // fix Array#{values, @@iterator}.name in V8 / FF
	    if(DEF_VALUES && $native.name !== VALUES){
	      VALUES_BUG = true;
	      $default = function values(){ return $native.call(this); };
	    }
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES  ? $default : getMethod(VALUES),
	      keys:    IS_SET      ? $default : getMethod(KEYS),
	      entries: !DEF_VALUES ? $default : getMethod('entries')
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	module.exports = {};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $              = __webpack_require__(8)
	  , descriptor     = __webpack_require__(19)
	  , setToStringTag = __webpack_require__(21)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(18)(IteratorPrototype, __webpack_require__(22)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = $.create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(45);
	var Iterators = __webpack_require__(42);
	Iterators.NodeList = Iterators.HTMLCollection = Iterators.Array;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(46)
	  , step             = __webpack_require__(47)
	  , Iterators        = __webpack_require__(42)
	  , toIObject        = __webpack_require__(25);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(41)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	module.exports = function(){ /* empty */ };

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $          = __webpack_require__(8)
	  , LIBRARY    = __webpack_require__(34)
	  , global     = __webpack_require__(9)
	  , ctx        = __webpack_require__(15)
	  , classof    = __webpack_require__(49)
	  , $export    = __webpack_require__(13)
	  , isObject   = __webpack_require__(33)
	  , anObject   = __webpack_require__(32)
	  , aFunction  = __webpack_require__(16)
	  , strictNew  = __webpack_require__(50)
	  , forOf      = __webpack_require__(51)
	  , setProto   = __webpack_require__(56).set
	  , same       = __webpack_require__(57)
	  , SPECIES    = __webpack_require__(22)('species')
	  , speciesConstructor = __webpack_require__(58)
	  , asap       = __webpack_require__(59)
	  , PROMISE    = 'Promise'
	  , process    = global.process
	  , isNode     = classof(process) == 'process'
	  , P          = global[PROMISE]
	  , empty      = function(){ /* empty */ }
	  , Wrapper;
	
	var testResolve = function(sub){
	  var test = new P(empty), promise;
	  if(sub)test.constructor = function(exec){
	    exec(empty, empty);
	  };
	  (promise = P.resolve(test))['catch'](empty);
	  return promise === test;
	};
	
	var USE_NATIVE = function(){
	  var works = false;
	  function P2(x){
	    var self = new P(x);
	    setProto(self, P2.prototype);
	    return self;
	  }
	  try {
	    works = P && P.resolve && testResolve();
	    setProto(P2, P);
	    P2.prototype = $.create(P.prototype, {constructor: {value: P2}});
	    // actual Firefox has broken subclass support, test that
	    if(!(P2.resolve(5).then(function(){}) instanceof P2)){
	      works = false;
	    }
	    // actual V8 bug, https://code.google.com/p/v8/issues/detail?id=4162
	    if(works && __webpack_require__(11)){
	      var thenableThenGotten = false;
	      P.resolve($.setDesc({}, 'then', {
	        get: function(){ thenableThenGotten = true; }
	      }));
	      works = thenableThenGotten;
	    }
	  } catch(e){ works = false; }
	  return works;
	}();
	
	// helpers
	var sameConstructor = function(a, b){
	  // library wrapper special case
	  if(LIBRARY && a === P && b === Wrapper)return true;
	  return same(a, b);
	};
	var getConstructor = function(C){
	  var S = anObject(C)[SPECIES];
	  return S != undefined ? S : C;
	};
	var isThenable = function(it){
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var PromiseCapability = function(C){
	  var resolve, reject;
	  this.promise = new C(function($$resolve, $$reject){
	    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject  = $$reject;
	  });
	  this.resolve = aFunction(resolve),
	  this.reject  = aFunction(reject)
	};
	var perform = function(exec){
	  try {
	    exec();
	  } catch(e){
	    return {error: e};
	  }
	};
	var notify = function(record, isReject){
	  if(record.n)return;
	  record.n = true;
	  var chain = record.c;
	  asap(function(){
	    var value = record.v
	      , ok    = record.s == 1
	      , i     = 0;
	    var run = function(reaction){
	      var handler = ok ? reaction.ok : reaction.fail
	        , resolve = reaction.resolve
	        , reject  = reaction.reject
	        , result, then;
	      try {
	        if(handler){
	          if(!ok)record.h = true;
	          result = handler === true ? value : handler(value);
	          if(result === reaction.promise){
	            reject(TypeError('Promise-chain cycle'));
	          } else if(then = isThenable(result)){
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch(e){
	        reject(e);
	      }
	    };
	    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
	    chain.length = 0;
	    record.n = false;
	    if(isReject)setTimeout(function(){
	      var promise = record.p
	        , handler, console;
	      if(isUnhandled(promise)){
	        if(isNode){
	          process.emit('unhandledRejection', value, promise);
	        } else if(handler = global.onunhandledrejection){
	          handler({promise: promise, reason: value});
	        } else if((console = global.console) && console.error){
	          console.error('Unhandled promise rejection', value);
	        }
	      } record.a = undefined;
	    }, 1);
	  });
	};
	var isUnhandled = function(promise){
	  var record = promise._d
	    , chain  = record.a || record.c
	    , i      = 0
	    , reaction;
	  if(record.h)return false;
	  while(chain.length > i){
	    reaction = chain[i++];
	    if(reaction.fail || !isUnhandled(reaction.promise))return false;
	  } return true;
	};
	var $reject = function(value){
	  var record = this;
	  if(record.d)return;
	  record.d = true;
	  record = record.r || record; // unwrap
	  record.v = value;
	  record.s = 2;
	  record.a = record.c.slice();
	  notify(record, true);
	};
	var $resolve = function(value){
	  var record = this
	    , then;
	  if(record.d)return;
	  record.d = true;
	  record = record.r || record; // unwrap
	  try {
	    if(record.p === value)throw TypeError("Promise can't be resolved itself");
	    if(then = isThenable(value)){
	      asap(function(){
	        var wrapper = {r: record, d: false}; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch(e){
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      record.v = value;
	      record.s = 1;
	      notify(record, false);
	    }
	  } catch(e){
	    $reject.call({r: record, d: false}, e); // wrap
	  }
	};
	
	// constructor polyfill
	if(!USE_NATIVE){
	  // 25.4.3.1 Promise(executor)
	  P = function Promise(executor){
	    aFunction(executor);
	    var record = this._d = {
	      p: strictNew(this, P, PROMISE),         // <- promise
	      c: [],                                  // <- awaiting reactions
	      a: undefined,                           // <- checked in isUnhandled reactions
	      s: 0,                                   // <- state
	      d: false,                               // <- done
	      v: undefined,                           // <- value
	      h: false,                               // <- handled rejection
	      n: false                                // <- notify
	    };
	    try {
	      executor(ctx($resolve, record, 1), ctx($reject, record, 1));
	    } catch(err){
	      $reject.call(record, err);
	    }
	  };
	  __webpack_require__(64)(P.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected){
	      var reaction = new PromiseCapability(speciesConstructor(this, P))
	        , promise  = reaction.promise
	        , record   = this._d;
	      reaction.ok   = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      record.c.push(reaction);
	      if(record.a)record.a.push(reaction);
	      if(record.s)notify(record, false);
	      return promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function(onRejected){
	      return this.then(undefined, onRejected);
	    }
	  });
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: P});
	__webpack_require__(21)(P, PROMISE);
	__webpack_require__(65)(PROMISE);
	Wrapper = __webpack_require__(14)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r){
	    var capability = new PromiseCapability(this)
	      , $$reject   = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (!USE_NATIVE || testResolve(true)), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x){
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if(x instanceof P && sameConstructor(x.constructor, this))return x;
	    var capability = new PromiseCapability(this)
	      , $$resolve  = capability.resolve;
	    $$resolve(x);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(66)(function(iter){
	  P.all(iter)['catch'](function(){});
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable){
	    var C          = getConstructor(this)
	      , capability = new PromiseCapability(C)
	      , resolve    = capability.resolve
	      , reject     = capability.reject
	      , values     = [];
	    var abrupt = perform(function(){
	      forOf(iterable, false, values.push, values);
	      var remaining = values.length
	        , results   = Array(remaining);
	      if(remaining)$.each.call(values, function(promise, index){
	        var alreadyCalled = false;
	        C.resolve(promise).then(function(value){
	          if(alreadyCalled)return;
	          alreadyCalled = true;
	          results[index] = value;
	          --remaining || resolve(results);
	        }, reject);
	      });
	      else resolve(results);
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable){
	    var C          = getConstructor(this)
	      , capability = new PromiseCapability(C)
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      forOf(iterable, false, function(promise){
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  }
	});

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(27)
	  , TAG = __webpack_require__(22)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = (O = Object(it))[TAG]) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	module.exports = function(it, Constructor, name){
	  if(!(it instanceof Constructor))throw TypeError(name + ": use the 'new' operator!");
	  return it;
	};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(15)
	  , call        = __webpack_require__(52)
	  , isArrayIter = __webpack_require__(53)
	  , anObject    = __webpack_require__(32)
	  , toLength    = __webpack_require__(54)
	  , getIterFn   = __webpack_require__(55);
	module.exports = function(iterable, entries, fn, that){
	  var iterFn = getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    call(iterator, f, step.value, entries);
	  }
	};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(32);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(42)
	  , ITERATOR   = __webpack_require__(22)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(40)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(49)
	  , ITERATOR  = __webpack_require__(22)('iterator')
	  , Iterators = __webpack_require__(42);
	module.exports = __webpack_require__(14).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var getDesc  = __webpack_require__(8).getDesc
	  , isObject = __webpack_require__(33)
	  , anObject = __webpack_require__(32);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(15)(Function.call, getDesc(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ }),
/* 57 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y){
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject  = __webpack_require__(32)
	  , aFunction = __webpack_require__(16)
	  , SPECIES   = __webpack_require__(22)('species');
	module.exports = function(O, D){
	  var C = anObject(O).constructor, S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(9)
	  , macrotask = __webpack_require__(60).set
	  , Observer  = global.MutationObserver || global.WebKitMutationObserver
	  , process   = global.process
	  , Promise   = global.Promise
	  , isNode    = __webpack_require__(27)(process) == 'process'
	  , head, last, notify;
	
	var flush = function(){
	  var parent, domain, fn;
	  if(isNode && (parent = process.domain)){
	    process.domain = null;
	    parent.exit();
	  }
	  while(head){
	    domain = head.domain;
	    fn     = head.fn;
	    if(domain)domain.enter();
	    fn(); // <- currently we use it only for Promise - try / catch not required
	    if(domain)domain.exit();
	    head = head.next;
	  } last = undefined;
	  if(parent)parent.enter();
	};
	
	// Node.js
	if(isNode){
	  notify = function(){
	    process.nextTick(flush);
	  };
	// browsers with MutationObserver
	} else if(Observer){
	  var toggle = 1
	    , node   = document.createTextNode('');
	  new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
	  notify = function(){
	    node.data = toggle = -toggle;
	  };
	// environments with maybe non-completely correct, but existent Promise
	} else if(Promise && Promise.resolve){
	  notify = function(){
	    Promise.resolve().then(flush);
	  };
	// for other environments - macrotask based on:
	// - setImmediate
	// - MessageChannel
	// - window.postMessag
	// - onreadystatechange
	// - setTimeout
	} else {
	  notify = function(){
	    // strange IE + webpack dev server bug - use .call(global)
	    macrotask.call(global, flush);
	  };
	}
	
	module.exports = function asap(fn){
	  var task = {fn: fn, next: undefined, domain: isNode && process.domain};
	  if(last)last.next = task;
	  if(!head){
	    head = task;
	    notify();
	  } last = task;
	};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx                = __webpack_require__(15)
	  , invoke             = __webpack_require__(61)
	  , html               = __webpack_require__(62)
	  , cel                = __webpack_require__(63)
	  , global             = __webpack_require__(9)
	  , process            = global.process
	  , setTask            = global.setImmediate
	  , clearTask          = global.clearImmediate
	  , MessageChannel     = global.MessageChannel
	  , counter            = 0
	  , queue              = {}
	  , ONREADYSTATECHANGE = 'onreadystatechange'
	  , defer, channel, port;
	var run = function(){
	  var id = +this;
	  if(queue.hasOwnProperty(id)){
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listner = function(event){
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if(!setTask || !clearTask){
	  setTask = function setImmediate(fn){
	    var args = [], i = 1;
	    while(arguments.length > i)args.push(arguments[i++]);
	    queue[++counter] = function(){
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id){
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if(__webpack_require__(27)(process) == 'process'){
	    defer = function(id){
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if(MessageChannel){
	    channel = new MessageChannel;
	    port    = channel.port2;
	    channel.port1.onmessage = listner;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
	    defer = function(id){
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listner, false);
	  // IE8-
	  } else if(ONREADYSTATECHANGE in cel('script')){
	    defer = function(id){
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function(id){
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set:   setTask,
	  clear: clearTask
	};

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function(fn, args, that){
	  var un = that === undefined;
	  switch(args.length){
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return              fn.apply(that, args);
	};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(9).document && document.documentElement;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(33)
	  , document = __webpack_require__(9).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(17);
	module.exports = function(target, src){
	  for(var key in src)redefine(target, key, src[key]);
	  return target;
	};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var core        = __webpack_require__(14)
	  , $           = __webpack_require__(8)
	  , DESCRIPTORS = __webpack_require__(11)
	  , SPECIES     = __webpack_require__(22)('species');
	
	module.exports = function(KEY){
	  var C = core[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])$.setDesc(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__(22)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ return {done: safe = true}; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(68);
	
	__webpack_require__(325);
	
	__webpack_require__(327);
	
	__webpack_require__(330);
	
	__webpack_require__(332);
	
	__webpack_require__(334);
	
	__webpack_require__(336);
	
	__webpack_require__(339);
	
	__webpack_require__(341);
	
	__webpack_require__(343);
	
	__webpack_require__(347);
	
	if (global._babelPolyfill && typeof console !== "undefined" && console.warn) {
	  console.warn("@babel/polyfill is loaded more than once on this page. This is probably not desirable/intended " + "and may have consequences if different versions of the polyfills are applied sequentially. " + "If you do need to load the polyfill more than once, use @babel/polyfill/noConflict " + "instead to bypass the warning.");
	}
	
	global._babelPolyfill = true;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(69);
	__webpack_require__(119);
	__webpack_require__(120);
	__webpack_require__(121);
	__webpack_require__(122);
	__webpack_require__(124);
	__webpack_require__(126);
	__webpack_require__(127);
	__webpack_require__(128);
	__webpack_require__(129);
	__webpack_require__(130);
	__webpack_require__(131);
	__webpack_require__(132);
	__webpack_require__(133);
	__webpack_require__(134);
	__webpack_require__(136);
	__webpack_require__(138);
	__webpack_require__(140);
	__webpack_require__(142);
	__webpack_require__(145);
	__webpack_require__(146);
	__webpack_require__(147);
	__webpack_require__(151);
	__webpack_require__(153);
	__webpack_require__(155);
	__webpack_require__(158);
	__webpack_require__(159);
	__webpack_require__(160);
	__webpack_require__(161);
	__webpack_require__(163);
	__webpack_require__(164);
	__webpack_require__(165);
	__webpack_require__(166);
	__webpack_require__(167);
	__webpack_require__(168);
	__webpack_require__(169);
	__webpack_require__(171);
	__webpack_require__(172);
	__webpack_require__(173);
	__webpack_require__(175);
	__webpack_require__(176);
	__webpack_require__(177);
	__webpack_require__(179);
	__webpack_require__(181);
	__webpack_require__(182);
	__webpack_require__(183);
	__webpack_require__(184);
	__webpack_require__(185);
	__webpack_require__(186);
	__webpack_require__(187);
	__webpack_require__(188);
	__webpack_require__(189);
	__webpack_require__(190);
	__webpack_require__(191);
	__webpack_require__(192);
	__webpack_require__(193);
	__webpack_require__(198);
	__webpack_require__(199);
	__webpack_require__(203);
	__webpack_require__(204);
	__webpack_require__(205);
	__webpack_require__(206);
	__webpack_require__(208);
	__webpack_require__(209);
	__webpack_require__(210);
	__webpack_require__(211);
	__webpack_require__(212);
	__webpack_require__(213);
	__webpack_require__(214);
	__webpack_require__(215);
	__webpack_require__(216);
	__webpack_require__(217);
	__webpack_require__(218);
	__webpack_require__(219);
	__webpack_require__(220);
	__webpack_require__(221);
	__webpack_require__(222);
	__webpack_require__(224);
	__webpack_require__(225);
	__webpack_require__(227);
	__webpack_require__(228);
	__webpack_require__(234);
	__webpack_require__(235);
	__webpack_require__(237);
	__webpack_require__(238);
	__webpack_require__(239);
	__webpack_require__(243);
	__webpack_require__(244);
	__webpack_require__(245);
	__webpack_require__(246);
	__webpack_require__(247);
	__webpack_require__(249);
	__webpack_require__(250);
	__webpack_require__(251);
	__webpack_require__(252);
	__webpack_require__(255);
	__webpack_require__(257);
	__webpack_require__(258);
	__webpack_require__(259);
	__webpack_require__(261);
	__webpack_require__(263);
	__webpack_require__(265);
	__webpack_require__(267);
	__webpack_require__(268);
	__webpack_require__(269);
	__webpack_require__(273);
	__webpack_require__(274);
	__webpack_require__(275);
	__webpack_require__(277);
	__webpack_require__(287);
	__webpack_require__(291);
	__webpack_require__(292);
	__webpack_require__(294);
	__webpack_require__(295);
	__webpack_require__(299);
	__webpack_require__(300);
	__webpack_require__(302);
	__webpack_require__(303);
	__webpack_require__(304);
	__webpack_require__(305);
	__webpack_require__(306);
	__webpack_require__(307);
	__webpack_require__(308);
	__webpack_require__(309);
	__webpack_require__(310);
	__webpack_require__(311);
	__webpack_require__(312);
	__webpack_require__(313);
	__webpack_require__(314);
	__webpack_require__(315);
	__webpack_require__(316);
	__webpack_require__(317);
	__webpack_require__(318);
	__webpack_require__(319);
	__webpack_require__(320);
	__webpack_require__(322);
	__webpack_require__(323);
	__webpack_require__(324);
	module.exports = __webpack_require__(75);


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(70);
	var has = __webpack_require__(71);
	var DESCRIPTORS = __webpack_require__(72);
	var $export = __webpack_require__(74);
	var redefine = __webpack_require__(84);
	var META = __webpack_require__(91).KEY;
	var $fails = __webpack_require__(73);
	var shared = __webpack_require__(87);
	var setToStringTag = __webpack_require__(92);
	var uid = __webpack_require__(85);
	var wks = __webpack_require__(93);
	var wksExt = __webpack_require__(94);
	var wksDefine = __webpack_require__(95);
	var enumKeys = __webpack_require__(96);
	var isArray = __webpack_require__(111);
	var anObject = __webpack_require__(78);
	var isObject = __webpack_require__(79);
	var toObject = __webpack_require__(112);
	var toIObject = __webpack_require__(99);
	var toPrimitive = __webpack_require__(82);
	var createDesc = __webpack_require__(83);
	var _create = __webpack_require__(113);
	var gOPNExt = __webpack_require__(116);
	var $GOPD = __webpack_require__(118);
	var $GOPS = __webpack_require__(109);
	var $DP = __webpack_require__(77);
	var $keys = __webpack_require__(97);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(117).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(110).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(88)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(76)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 70 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 71 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(73)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 73 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(70);
	var core = __webpack_require__(75);
	var hide = __webpack_require__(76);
	var redefine = __webpack_require__(84);
	var ctx = __webpack_require__(89);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 75 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(77);
	var createDesc = __webpack_require__(83);
	module.exports = __webpack_require__(72) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(78);
	var IE8_DOM_DEFINE = __webpack_require__(80);
	var toPrimitive = __webpack_require__(82);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(72) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(79);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 79 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(72) && !__webpack_require__(73)(function () {
	  return Object.defineProperty(__webpack_require__(81)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(79);
	var document = __webpack_require__(70).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(79);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 83 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(70);
	var hide = __webpack_require__(76);
	var has = __webpack_require__(71);
	var SRC = __webpack_require__(85)('src');
	var $toString = __webpack_require__(86);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(75).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 85 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(87)('native-function-to-string', Function.toString);


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(75);
	var global = __webpack_require__(70);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(88) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 88 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(90);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 90 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(85)('meta');
	var isObject = __webpack_require__(79);
	var has = __webpack_require__(71);
	var setDesc = __webpack_require__(77).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(73)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(77).f;
	var has = __webpack_require__(71);
	var TAG = __webpack_require__(93)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(87)('wks');
	var uid = __webpack_require__(85);
	var Symbol = __webpack_require__(70).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(93);


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(70);
	var core = __webpack_require__(75);
	var LIBRARY = __webpack_require__(88);
	var wksExt = __webpack_require__(94);
	var defineProperty = __webpack_require__(77).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(97);
	var gOPS = __webpack_require__(109);
	var pIE = __webpack_require__(110);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(98);
	var enumBugKeys = __webpack_require__(108);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(71);
	var toIObject = __webpack_require__(99);
	var arrayIndexOf = __webpack_require__(103)(false);
	var IE_PROTO = __webpack_require__(107)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(100);
	var defined = __webpack_require__(102);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(101);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 101 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 102 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(99);
	var toLength = __webpack_require__(104);
	var toAbsoluteIndex = __webpack_require__(106);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(105);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 105 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(105);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(87)('keys');
	var uid = __webpack_require__(85);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 108 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 109 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 110 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(101);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(102);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(78);
	var dPs = __webpack_require__(114);
	var enumBugKeys = __webpack_require__(108);
	var IE_PROTO = __webpack_require__(107)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(81)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(115).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(77);
	var anObject = __webpack_require__(78);
	var getKeys = __webpack_require__(97);
	
	module.exports = __webpack_require__(72) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(70).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(99);
	var gOPN = __webpack_require__(117).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(98);
	var hiddenKeys = __webpack_require__(108).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(110);
	var createDesc = __webpack_require__(83);
	var toIObject = __webpack_require__(99);
	var toPrimitive = __webpack_require__(82);
	var has = __webpack_require__(71);
	var IE8_DOM_DEFINE = __webpack_require__(80);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(72) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(74);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(113) });


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(74);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(72), 'Object', { defineProperty: __webpack_require__(77).f });


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(74);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(72), 'Object', { defineProperties: __webpack_require__(114) });


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(99);
	var $getOwnPropertyDescriptor = __webpack_require__(118).f;
	
	__webpack_require__(123)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(74);
	var core = __webpack_require__(75);
	var fails = __webpack_require__(73);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(112);
	var $getPrototypeOf = __webpack_require__(125);
	
	__webpack_require__(123)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(71);
	var toObject = __webpack_require__(112);
	var IE_PROTO = __webpack_require__(107)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(112);
	var $keys = __webpack_require__(97);
	
	__webpack_require__(123)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(123)('getOwnPropertyNames', function () {
	  return __webpack_require__(116).f;
	});


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(79);
	var meta = __webpack_require__(91).onFreeze;
	
	__webpack_require__(123)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(79);
	var meta = __webpack_require__(91).onFreeze;
	
	__webpack_require__(123)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(79);
	var meta = __webpack_require__(91).onFreeze;
	
	__webpack_require__(123)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(79);
	
	__webpack_require__(123)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(79);
	
	__webpack_require__(123)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(79);
	
	__webpack_require__(123)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(74);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(135) });


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(72);
	var getKeys = __webpack_require__(97);
	var gOPS = __webpack_require__(109);
	var pIE = __webpack_require__(110);
	var toObject = __webpack_require__(112);
	var IObject = __webpack_require__(100);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(73)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(74);
	$export($export.S, 'Object', { is: __webpack_require__(137) });


/***/ }),
/* 137 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(74);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(139).set });


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(79);
	var anObject = __webpack_require__(78);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(89)(Function.call, __webpack_require__(118).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(141);
	var test = {};
	test[__webpack_require__(93)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(84)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(101);
	var TAG = __webpack_require__(93)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(74);
	
	$export($export.P, 'Function', { bind: __webpack_require__(143) });


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(90);
	var isObject = __webpack_require__(79);
	var invoke = __webpack_require__(144);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ }),
/* 144 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(77).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(72) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(79);
	var getPrototypeOf = __webpack_require__(125);
	var HAS_INSTANCE = __webpack_require__(93)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(77).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(74);
	var $parseInt = __webpack_require__(148);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(70).parseInt;
	var $trim = __webpack_require__(149).trim;
	var ws = __webpack_require__(150);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(74);
	var defined = __webpack_require__(102);
	var fails = __webpack_require__(73);
	var spaces = __webpack_require__(150);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ }),
/* 150 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(74);
	var $parseFloat = __webpack_require__(152);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(70).parseFloat;
	var $trim = __webpack_require__(149).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(150) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(70);
	var has = __webpack_require__(71);
	var cof = __webpack_require__(101);
	var inheritIfRequired = __webpack_require__(154);
	var toPrimitive = __webpack_require__(82);
	var fails = __webpack_require__(73);
	var gOPN = __webpack_require__(117).f;
	var gOPD = __webpack_require__(118).f;
	var dP = __webpack_require__(77).f;
	var $trim = __webpack_require__(149).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(113)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(72) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(84)(global, NUMBER, $Number);
	}


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(79);
	var setPrototypeOf = __webpack_require__(139).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(74);
	var toInteger = __webpack_require__(105);
	var aNumberValue = __webpack_require__(156);
	var repeat = __webpack_require__(157);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(73)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(101);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(105);
	var defined = __webpack_require__(102);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(74);
	var $fails = __webpack_require__(73);
	var aNumberValue = __webpack_require__(156);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(74);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(74);
	var _isFinite = __webpack_require__(70).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(74);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(162) });


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(79);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(74);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(74);
	var isInteger = __webpack_require__(162);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(74);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(74);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(74);
	var $parseFloat = __webpack_require__(152);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(74);
	var $parseInt = __webpack_require__(148);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(74);
	var log1p = __webpack_require__(170);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ }),
/* 170 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(74);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(74);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(74);
	var sign = __webpack_require__(174);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ }),
/* 174 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(74);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(74);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(74);
	var $expm1 = __webpack_require__(178);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 178 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(74);
	
	$export($export.S, 'Math', { fround: __webpack_require__(180) });


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(174);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(74);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(74);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(73)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(74);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(74);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(170) });


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(74);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(74);
	
	$export($export.S, 'Math', { sign: __webpack_require__(174) });


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(74);
	var expm1 = __webpack_require__(178);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(73)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(74);
	var expm1 = __webpack_require__(178);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(74);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(74);
	var toAbsoluteIndex = __webpack_require__(106);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(74);
	var toIObject = __webpack_require__(99);
	var toLength = __webpack_require__(104);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(149)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(194)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(195)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(105);
	var defined = __webpack_require__(102);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(88);
	var $export = __webpack_require__(74);
	var redefine = __webpack_require__(84);
	var hide = __webpack_require__(76);
	var Iterators = __webpack_require__(196);
	var $iterCreate = __webpack_require__(197);
	var setToStringTag = __webpack_require__(92);
	var getPrototypeOf = __webpack_require__(125);
	var ITERATOR = __webpack_require__(93)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 196 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(113);
	var descriptor = __webpack_require__(83);
	var setToStringTag = __webpack_require__(92);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(76)(IteratorPrototype, __webpack_require__(93)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(74);
	var $at = __webpack_require__(194)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(74);
	var toLength = __webpack_require__(104);
	var context = __webpack_require__(200);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(202)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(201);
	var defined = __webpack_require__(102);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(79);
	var cof = __webpack_require__(101);
	var MATCH = __webpack_require__(93)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(93)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(74);
	var context = __webpack_require__(200);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(202)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(74);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(157)
	});


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(74);
	var toLength = __webpack_require__(104);
	var context = __webpack_require__(200);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(202)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(207)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(74);
	var fails = __webpack_require__(73);
	var defined = __webpack_require__(102);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(207)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(207)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(207)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(207)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(207)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(207)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(207)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(207)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(207)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(207)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(207)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(207)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(74);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(74);
	var toObject = __webpack_require__(112);
	var toPrimitive = __webpack_require__(82);
	
	$export($export.P + $export.F * __webpack_require__(73)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(74);
	var toISOString = __webpack_require__(223);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(73);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(84)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(93)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(76)(proto, TO_PRIMITIVE, __webpack_require__(226));


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(78);
	var toPrimitive = __webpack_require__(82);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(74);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(111) });


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(89);
	var $export = __webpack_require__(74);
	var toObject = __webpack_require__(112);
	var call = __webpack_require__(229);
	var isArrayIter = __webpack_require__(230);
	var toLength = __webpack_require__(104);
	var createProperty = __webpack_require__(231);
	var getIterFn = __webpack_require__(232);
	
	$export($export.S + $export.F * !__webpack_require__(233)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(78);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(196);
	var ITERATOR = __webpack_require__(93)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(77);
	var createDesc = __webpack_require__(83);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(141);
	var ITERATOR = __webpack_require__(93)('iterator');
	var Iterators = __webpack_require__(196);
	module.exports = __webpack_require__(75).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(93)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(74);
	var createProperty = __webpack_require__(231);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(73)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(74);
	var toIObject = __webpack_require__(99);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(100) != Object || !__webpack_require__(236)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(73);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(74);
	var html = __webpack_require__(115);
	var cof = __webpack_require__(101);
	var toAbsoluteIndex = __webpack_require__(106);
	var toLength = __webpack_require__(104);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(73)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(74);
	var aFunction = __webpack_require__(90);
	var toObject = __webpack_require__(112);
	var fails = __webpack_require__(73);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(236)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(74);
	var $forEach = __webpack_require__(240)(0);
	var STRICT = __webpack_require__(236)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(89);
	var IObject = __webpack_require__(100);
	var toObject = __webpack_require__(112);
	var toLength = __webpack_require__(104);
	var asc = __webpack_require__(241);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(242);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(79);
	var isArray = __webpack_require__(111);
	var SPECIES = __webpack_require__(93)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(74);
	var $map = __webpack_require__(240)(1);
	
	$export($export.P + $export.F * !__webpack_require__(236)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(74);
	var $filter = __webpack_require__(240)(2);
	
	$export($export.P + $export.F * !__webpack_require__(236)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(74);
	var $some = __webpack_require__(240)(3);
	
	$export($export.P + $export.F * !__webpack_require__(236)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(74);
	var $every = __webpack_require__(240)(4);
	
	$export($export.P + $export.F * !__webpack_require__(236)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(74);
	var $reduce = __webpack_require__(248);
	
	$export($export.P + $export.F * !__webpack_require__(236)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(90);
	var toObject = __webpack_require__(112);
	var IObject = __webpack_require__(100);
	var toLength = __webpack_require__(104);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(74);
	var $reduce = __webpack_require__(248);
	
	$export($export.P + $export.F * !__webpack_require__(236)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(74);
	var $indexOf = __webpack_require__(103)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(236)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(74);
	var toIObject = __webpack_require__(99);
	var toInteger = __webpack_require__(105);
	var toLength = __webpack_require__(104);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(236)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(74);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(253) });
	
	__webpack_require__(254)('copyWithin');


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(112);
	var toAbsoluteIndex = __webpack_require__(106);
	var toLength = __webpack_require__(104);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(93)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(76)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(74);
	
	$export($export.P, 'Array', { fill: __webpack_require__(256) });
	
	__webpack_require__(254)('fill');


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(112);
	var toAbsoluteIndex = __webpack_require__(106);
	var toLength = __webpack_require__(104);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(74);
	var $find = __webpack_require__(240)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(254)(KEY);


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(74);
	var $find = __webpack_require__(240)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(254)(KEY);


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(260)('Array');


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(70);
	var dP = __webpack_require__(77);
	var DESCRIPTORS = __webpack_require__(72);
	var SPECIES = __webpack_require__(93)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(254);
	var step = __webpack_require__(262);
	var Iterators = __webpack_require__(196);
	var toIObject = __webpack_require__(99);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(195)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 262 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(70);
	var inheritIfRequired = __webpack_require__(154);
	var dP = __webpack_require__(77).f;
	var gOPN = __webpack_require__(117).f;
	var isRegExp = __webpack_require__(201);
	var $flags = __webpack_require__(264);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(72) && (!CORRECT_NEW || __webpack_require__(73)(function () {
	  re2[__webpack_require__(93)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(84)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(260)('RegExp');


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(78);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var regexpExec = __webpack_require__(266);
	__webpack_require__(74)({
	  target: 'RegExp',
	  proto: true,
	  forced: regexpExec !== /./.exec
	}, {
	  exec: regexpExec
	});


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var regexpFlags = __webpack_require__(264);
	
	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;
	
	var patchedExec = nativeExec;
	
	var LAST_INDEX = 'lastIndex';
	
	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/,
	      re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
	})();
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
	
	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
	
	    match = nativeExec.call(re, str);
	
	    if (UPDATES_LAST_INDEX_WRONG && match) {
	      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      // eslint-disable-next-line no-loop-func
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(268);
	var anObject = __webpack_require__(78);
	var $flags = __webpack_require__(264);
	var DESCRIPTORS = __webpack_require__(72);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(84)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(73)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(72) && /./g.flags != 'g') __webpack_require__(77).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(264)
	});


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(78);
	var toLength = __webpack_require__(104);
	var advanceStringIndex = __webpack_require__(270);
	var regExpExec = __webpack_require__(271);
	
	// @@match logic
	__webpack_require__(272)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[MATCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
	    function (regexp) {
	      var res = maybeCallNative($match, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      if (!rx.global) return regExpExec(rx, S);
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regExpExec(rx, S)) !== null) {
	        var matchStr = String(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var at = __webpack_require__(194)(true);
	
	 // `AdvanceStringIndex` abstract operation
	// https://tc39.github.io/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? at(S, index).length : 1);
	};


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var classof = __webpack_require__(141);
	var builtinExec = RegExp.prototype.exec;
	
	 // `RegExpExec` abstract operation
	// https://tc39.github.io/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if (typeof result !== 'object') {
	      throw new TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }
	  if (classof(R) !== 'RegExp') {
	    throw new TypeError('RegExp#exec called on incompatible receiver');
	  }
	  return builtinExec.call(R, S);
	};


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(265);
	var redefine = __webpack_require__(84);
	var hide = __webpack_require__(76);
	var fails = __webpack_require__(73);
	var defined = __webpack_require__(102);
	var wks = __webpack_require__(93);
	var regexpExec = __webpack_require__(266);
	
	var SPECIES = wks('species');
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
	  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
	})();
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	    re.exec = function () { execCalled = true; return null; };
	    if (KEY === 'split') {
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	    }
	    re[SYMBOL]('');
	    return !execCalled;
	  }) : undefined;
	
	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
	    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var fns = exec(
	      defined,
	      SYMBOL,
	      ''[KEY],
	      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
	        if (regexp.exec === regexpExec) {
	          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	            // The native String method already delegates to @@method (this
	            // polyfilled function), leasing to infinite recursion.
	            // We avoid it by directly calling the native @@method method.
	            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	          }
	          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	        }
	        return { done: false };
	      }
	    );
	    var strfn = fns[0];
	    var rxfn = fns[1];
	
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(78);
	var toObject = __webpack_require__(112);
	var toLength = __webpack_require__(104);
	var toInteger = __webpack_require__(105);
	var advanceStringIndex = __webpack_require__(270);
	var regExpExec = __webpack_require__(271);
	var max = Math.max;
	var min = Math.min;
	var floor = Math.floor;
	var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
	
	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};
	
	// @@replace logic
	__webpack_require__(272)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = defined(this);
	      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	      return fn !== undefined
	        ? fn.call(searchValue, O, replaceValue)
	        : $replace.call(String(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
	    function (regexp, replaceValue) {
	      var res = maybeCallNative($replace, regexp, this, replaceValue);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var functionalReplace = typeof replaceValue === 'function';
	      if (!functionalReplace) replaceValue = String(replaceValue);
	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = regExpExec(rx, S);
	        if (result === null) break;
	        results.push(result);
	        if (!global) break;
	        var matchStr = String(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	        var matched = String(result[0]);
	        var position = max(min(toInteger(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = [matched].concat(captures, position, S);
	          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	          var replacement = String(replaceValue.apply(undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + S.slice(nextSourcePosition);
	    }
	  ];
	
	    // https://tc39.github.io/ecma262/#sec-getsubstitution
	  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
	    var tailPos = position + matched.length;
	    var m = captures.length;
	    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	    if (namedCaptures !== undefined) {
	      namedCaptures = toObject(namedCaptures);
	      symbols = SUBSTITUTION_SYMBOLS;
	    }
	    return $replace.call(replacement, symbols, function (match, ch) {
	      var capture;
	      switch (ch.charAt(0)) {
	        case '$': return '$';
	        case '&': return matched;
	        case '`': return str.slice(0, position);
	        case "'": return str.slice(tailPos);
	        case '<':
	          capture = namedCaptures[ch.slice(1, -1)];
	          break;
	        default: // \d\d?
	          var n = +ch;
	          if (n === 0) return match;
	          if (n > m) {
	            var f = floor(n / 10);
	            if (f === 0) return match;
	            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	            return match;
	          }
	          capture = captures[n - 1];
	      }
	      return capture === undefined ? '' : capture;
	    });
	  }
	});


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(78);
	var sameValue = __webpack_require__(137);
	var regExpExec = __webpack_require__(271);
	
	// @@search logic
	__webpack_require__(272)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
	  return [
	    // `String.prototype.search` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.search
	    function search(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[SEARCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	    },
	    // `RegExp.prototype[@@search]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
	    function (regexp) {
	      var res = maybeCallNative($search, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      var previousLastIndex = rx.lastIndex;
	      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	      var result = regExpExec(rx, S);
	      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	      return result === null ? -1 : result.index;
	    }
	  ];
	});


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isRegExp = __webpack_require__(201);
	var anObject = __webpack_require__(78);
	var speciesConstructor = __webpack_require__(276);
	var advanceStringIndex = __webpack_require__(270);
	var toLength = __webpack_require__(104);
	var callRegExpExec = __webpack_require__(271);
	var regexpExec = __webpack_require__(266);
	var fails = __webpack_require__(73);
	var $min = Math.min;
	var $push = [].push;
	var $SPLIT = 'split';
	var LENGTH = 'length';
	var LAST_INDEX = 'lastIndex';
	var MAX_UINT32 = 0xffffffff;
	
	// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
	var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });
	
	// @@split logic
	__webpack_require__(272)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return $split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy[LAST_INDEX];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
	    };
	  } else {
	    internalSplit = $split;
	  }
	
	  return [
	    // `String.prototype.split` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = defined(this);
	      var splitter = separator == undefined ? undefined : separator[SPLIT];
	      return splitter !== undefined
	        ? splitter.call(separator, O, limit)
	        : internalSplit.call(String(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (regexp, limit) {
	      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var C = speciesConstructor(rx, RegExp);
	
	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (SUPPORTS_Y ? 'y' : 'g');
	
	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = SUPPORTS_Y ? q : 0;
	        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
	        var e;
	        if (
	          z === null ||
	          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
	        ) {
	          q = advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          A.push(S.slice(p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            A.push(z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      A.push(S.slice(p));
	      return A;
	    }
	  ];
	});


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(78);
	var aFunction = __webpack_require__(90);
	var SPECIES = __webpack_require__(93)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(88);
	var global = __webpack_require__(70);
	var ctx = __webpack_require__(89);
	var classof = __webpack_require__(141);
	var $export = __webpack_require__(74);
	var isObject = __webpack_require__(79);
	var aFunction = __webpack_require__(90);
	var anInstance = __webpack_require__(278);
	var forOf = __webpack_require__(279);
	var speciesConstructor = __webpack_require__(276);
	var task = __webpack_require__(280).set;
	var microtask = __webpack_require__(281)();
	var newPromiseCapabilityModule = __webpack_require__(282);
	var perform = __webpack_require__(283);
	var userAgent = __webpack_require__(284);
	var promiseResolve = __webpack_require__(285);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(93)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(286)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(92)($Promise, PROMISE);
	__webpack_require__(260)(PROMISE);
	Wrapper = __webpack_require__(75)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(233)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 278 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(89);
	var call = __webpack_require__(229);
	var isArrayIter = __webpack_require__(230);
	var anObject = __webpack_require__(78);
	var toLength = __webpack_require__(104);
	var getIterFn = __webpack_require__(232);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(89);
	var invoke = __webpack_require__(144);
	var html = __webpack_require__(115);
	var cel = __webpack_require__(81);
	var global = __webpack_require__(70);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(101)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(70);
	var macrotask = __webpack_require__(280).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(101)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(90);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 283 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(70);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(78);
	var isObject = __webpack_require__(79);
	var newPromiseCapability = __webpack_require__(282);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(84);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(288);
	var validate = __webpack_require__(289);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(290)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(77).f;
	var create = __webpack_require__(113);
	var redefineAll = __webpack_require__(286);
	var ctx = __webpack_require__(89);
	var anInstance = __webpack_require__(278);
	var forOf = __webpack_require__(279);
	var $iterDefine = __webpack_require__(195);
	var step = __webpack_require__(262);
	var setSpecies = __webpack_require__(260);
	var DESCRIPTORS = __webpack_require__(72);
	var fastKey = __webpack_require__(91).fastKey;
	var validate = __webpack_require__(289);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(79);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(70);
	var $export = __webpack_require__(74);
	var redefine = __webpack_require__(84);
	var redefineAll = __webpack_require__(286);
	var meta = __webpack_require__(91);
	var forOf = __webpack_require__(279);
	var anInstance = __webpack_require__(278);
	var isObject = __webpack_require__(79);
	var fails = __webpack_require__(73);
	var $iterDetect = __webpack_require__(233);
	var setToStringTag = __webpack_require__(92);
	var inheritIfRequired = __webpack_require__(154);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(288);
	var validate = __webpack_require__(289);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(290)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(70);
	var each = __webpack_require__(240)(0);
	var redefine = __webpack_require__(84);
	var meta = __webpack_require__(91);
	var assign = __webpack_require__(135);
	var weak = __webpack_require__(293);
	var isObject = __webpack_require__(79);
	var validate = __webpack_require__(289);
	var NATIVE_WEAK_MAP = __webpack_require__(289);
	var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(290)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (NATIVE_WEAK_MAP && IS_IE11) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(286);
	var getWeak = __webpack_require__(91).getWeak;
	var anObject = __webpack_require__(78);
	var isObject = __webpack_require__(79);
	var anInstance = __webpack_require__(278);
	var forOf = __webpack_require__(279);
	var createArrayMethod = __webpack_require__(240);
	var $has = __webpack_require__(71);
	var validate = __webpack_require__(289);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(293);
	var validate = __webpack_require__(289);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(290)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(74);
	var $typed = __webpack_require__(296);
	var buffer = __webpack_require__(297);
	var anObject = __webpack_require__(78);
	var toAbsoluteIndex = __webpack_require__(106);
	var toLength = __webpack_require__(104);
	var isObject = __webpack_require__(79);
	var ArrayBuffer = __webpack_require__(70).ArrayBuffer;
	var speciesConstructor = __webpack_require__(276);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(73)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < fin) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(260)(ARRAY_BUFFER);


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(70);
	var hide = __webpack_require__(76);
	var uid = __webpack_require__(85);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(70);
	var DESCRIPTORS = __webpack_require__(72);
	var LIBRARY = __webpack_require__(88);
	var $typed = __webpack_require__(296);
	var hide = __webpack_require__(76);
	var redefineAll = __webpack_require__(286);
	var fails = __webpack_require__(73);
	var anInstance = __webpack_require__(278);
	var toInteger = __webpack_require__(105);
	var toLength = __webpack_require__(104);
	var toIndex = __webpack_require__(298);
	var gOPN = __webpack_require__(117).f;
	var dP = __webpack_require__(77).f;
	var arrayFill = __webpack_require__(256);
	var setToStringTag = __webpack_require__(92);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(105);
	var toLength = __webpack_require__(104);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(74);
	$export($export.G + $export.W + $export.F * !__webpack_require__(296).ABV, {
	  DataView: __webpack_require__(297).DataView
	});


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(301)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(72)) {
	  var LIBRARY = __webpack_require__(88);
	  var global = __webpack_require__(70);
	  var fails = __webpack_require__(73);
	  var $export = __webpack_require__(74);
	  var $typed = __webpack_require__(296);
	  var $buffer = __webpack_require__(297);
	  var ctx = __webpack_require__(89);
	  var anInstance = __webpack_require__(278);
	  var propertyDesc = __webpack_require__(83);
	  var hide = __webpack_require__(76);
	  var redefineAll = __webpack_require__(286);
	  var toInteger = __webpack_require__(105);
	  var toLength = __webpack_require__(104);
	  var toIndex = __webpack_require__(298);
	  var toAbsoluteIndex = __webpack_require__(106);
	  var toPrimitive = __webpack_require__(82);
	  var has = __webpack_require__(71);
	  var classof = __webpack_require__(141);
	  var isObject = __webpack_require__(79);
	  var toObject = __webpack_require__(112);
	  var isArrayIter = __webpack_require__(230);
	  var create = __webpack_require__(113);
	  var getPrototypeOf = __webpack_require__(125);
	  var gOPN = __webpack_require__(117).f;
	  var getIterFn = __webpack_require__(232);
	  var uid = __webpack_require__(85);
	  var wks = __webpack_require__(93);
	  var createArrayMethod = __webpack_require__(240);
	  var createArrayIncludes = __webpack_require__(103);
	  var speciesConstructor = __webpack_require__(276);
	  var ArrayIterators = __webpack_require__(261);
	  var Iterators = __webpack_require__(196);
	  var $iterDetect = __webpack_require__(233);
	  var setSpecies = __webpack_require__(260);
	  var arrayFill = __webpack_require__(256);
	  var arrayCopyWithin = __webpack_require__(253);
	  var $DP = __webpack_require__(77);
	  var $GOPD = __webpack_require__(118);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(301)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(301)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(301)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(301)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(301)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(301)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(301)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(301)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(74);
	var aFunction = __webpack_require__(90);
	var anObject = __webpack_require__(78);
	var rApply = (__webpack_require__(70).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(73)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(74);
	var create = __webpack_require__(113);
	var aFunction = __webpack_require__(90);
	var anObject = __webpack_require__(78);
	var isObject = __webpack_require__(79);
	var fails = __webpack_require__(73);
	var bind = __webpack_require__(143);
	var rConstruct = (__webpack_require__(70).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(77);
	var $export = __webpack_require__(74);
	var anObject = __webpack_require__(78);
	var toPrimitive = __webpack_require__(82);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(73)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(74);
	var gOPD = __webpack_require__(118).f;
	var anObject = __webpack_require__(78);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(74);
	var anObject = __webpack_require__(78);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(197)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(118);
	var getPrototypeOf = __webpack_require__(125);
	var has = __webpack_require__(71);
	var $export = __webpack_require__(74);
	var isObject = __webpack_require__(79);
	var anObject = __webpack_require__(78);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(118);
	var $export = __webpack_require__(74);
	var anObject = __webpack_require__(78);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(74);
	var getProto = __webpack_require__(125);
	var anObject = __webpack_require__(78);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(74);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(74);
	var anObject = __webpack_require__(78);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(74);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(321) });


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(117);
	var gOPS = __webpack_require__(109);
	var anObject = __webpack_require__(78);
	var Reflect = __webpack_require__(70).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(74);
	var anObject = __webpack_require__(78);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(77);
	var gOPD = __webpack_require__(118);
	var getPrototypeOf = __webpack_require__(125);
	var has = __webpack_require__(71);
	var $export = __webpack_require__(74);
	var createDesc = __webpack_require__(83);
	var anObject = __webpack_require__(78);
	var isObject = __webpack_require__(79);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(74);
	var setProto = __webpack_require__(139);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(326);
	module.exports = __webpack_require__(75).Array.includes;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(74);
	var $includes = __webpack_require__(103)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(254)('includes');


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(328);
	module.exports = __webpack_require__(75).String.padStart;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(74);
	var $pad = __webpack_require__(329);
	var userAgent = __webpack_require__(284);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(104);
	var repeat = __webpack_require__(157);
	var defined = __webpack_require__(102);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(331);
	module.exports = __webpack_require__(75).String.padEnd;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(74);
	var $pad = __webpack_require__(329);
	var userAgent = __webpack_require__(284);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(333);
	module.exports = __webpack_require__(94).f('asyncIterator');


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(95)('asyncIterator');


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(335);
	module.exports = __webpack_require__(75).Object.getOwnPropertyDescriptors;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(74);
	var ownKeys = __webpack_require__(321);
	var toIObject = __webpack_require__(99);
	var gOPD = __webpack_require__(118);
	var createProperty = __webpack_require__(231);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(337);
	module.exports = __webpack_require__(75).Object.values;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(74);
	var $values = __webpack_require__(338)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(72);
	var getKeys = __webpack_require__(97);
	var toIObject = __webpack_require__(99);
	var isEnum = __webpack_require__(110).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(340);
	module.exports = __webpack_require__(75).Object.entries;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(74);
	var $entries = __webpack_require__(338)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(277);
	__webpack_require__(342);
	module.exports = __webpack_require__(75).Promise['finally'];


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(74);
	var core = __webpack_require__(75);
	var global = __webpack_require__(70);
	var speciesConstructor = __webpack_require__(276);
	var promiseResolve = __webpack_require__(285);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(344);
	__webpack_require__(345);
	__webpack_require__(346);
	module.exports = __webpack_require__(75);


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(70);
	var $export = __webpack_require__(74);
	var userAgent = __webpack_require__(284);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(74);
	var $task = __webpack_require__(280);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(261);
	var getKeys = __webpack_require__(97);
	var redefine = __webpack_require__(84);
	var global = __webpack_require__(70);
	var hide = __webpack_require__(76);
	var Iterators = __webpack_require__(196);
	var wks = __webpack_require__(93);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 347 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // In sloppy mode, unbound `this` refers to the global object, fallback to
	  // Function constructor if we're in global strict mode. That is sadly a form
	  // of indirect eval which violates Content Security Policy.
	  (function() { return this })() || Function("return this")()
	);


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(349);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(355)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/index.js!../../node_modules/sass-loader/index.js!./style.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/index.js!../../node_modules/sass-loader/index.js!./style.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(350);
	exports = module.exports = __webpack_require__(351)(false);
	// imports
	
	
	// module
	exports.push([module.id, "/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}legend{border:0;padding:0}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}@font-face{font-family:iconfont;src:url(" + escape(__webpack_require__(352)) + ");src:url(" + escape(__webpack_require__(353)) + ") format(\"truetype\"),url(" + escape(__webpack_require__(354)) + "#iconfont) format(\"svg\")}.iconfont{font-family:iconfont!important;font-size:26px;font-style:normal;-webkit-font-smoothing:antialiased;-webkit-text-stroke-width:.2px;-moz-osx-font-smoothing:grayscale}.icon-correct{background-color:#08bc72!important}.icon-wrong{background-color:#f84f41!important}.icon-squarecheckfill{color:#639ef4}.icon-review{background-color:#289acf}.icon-blackboard{background-color:#73cf28}.icon-preview{background-color:#e1a336}.icon-toupiao,.icon-ykq_toupiao{background-color:#639ef4!important}.icon-fangda:before{content:\"\\E631\"}.icon-suoxiao:before{content:\"\\E62F\"}.icon-fill-star:before{content:\"\\E62A\"}.icon-cascades:before{content:\"\\E618\"}.icon-blackboard:before{content:\"\\E61D\"}.icon-question:before{content:\"\\E623\"}.icon-form:before{content:\"\\E60E\"}.icon-forward:before{content:\"\\E602\"}.icon-squarecheckfill:before{content:\"\\E603\"}.icon-square:before{content:\"\\E604\"}.icon-roundadd:before{content:\"\\E605\"}.icon-iconfontcha:before{content:\"\\E64C\"}.icon-back:before{content:\"\\E606\"}.icon-voice:before{content:\"\\E608\"}.icon-next:before{content:\"\\E613\"}.icon-download:before{content:\"\\E630\"}.icon-zhuye:before{content:\"\\E64B\"}.icon-clock:before{content:\"\\E601\"}.icon-unfold:before{content:\"\\E60C\"}.icon-creativefill:before{content:\"\\E619\"}.icon-close:before{content:\"\\E60A\"}.icon-preview:before{content:\"\\E620\"}.icon-star:before{content:\"\\E62B\"}.icon-fill-apps:before{content:\"\\E61B\"}.icon-fill-question:before{content:\"\\E61E\"}.icon-people:before{content:\"\\E60F\"}.icon-scppt:before{content:\"\\E625\"}.icon-more:before{content:\"\\E62E\"}.icon-fold:before{content:\"\\E610\"}.icon-tag:before{content:\"\\E64E\"}.icon-warning:before{content:\"\\E600\"}.icon-trash:before{content:\"\\E614\"}.icon-close1:before{content:\"\\E63B\"}.icon-wrong:before{content:\"\\E622\"}.icon-correct:before{content:\"\\E61A\"}.icon-choose:before{content:\"\\E63C\"}.icon-exercise:before{content:\"\\E626\"}.icon-info:before{content:\"\\E617\"}.icon-pen:before{content:\"\\E61F\"}.icon-edit:before{content:\"\\E60B\"}.icon-review:before{content:\"\\E621\"}.icon-score:before{content:\"\\E612\"}.icon-warning1:before{content:\"\\E64F\"}.icon-toupiao:before{content:\"\\E632\"}.icon-people1:before{content:\"\\E648\"}.icon-sousuo:before{content:\"\\E616\"}.icon-qabtn:before{content:\"\\E63E\"}.icon-qalist:before{content:\"\\E63F\"}.icon-xiangxiajiantou:before{content:\"\\E664\"}.icon-weibiaoti-8:before{content:\"\\E653\"}.icon-refresh:before{content:\"\\E652\"}.icon-xiazai:before{content:\"\\E638\"}.icon-keqianyuxi:before{content:\"\\E629\"}.icon-zan1:before{content:\"\\E65A\"}.icon-buzan:before{content:\"\\E65D\"}.icon-tougao_bushoucang:before{content:\"\\E65E\"}.icon-tougao_shoucang1:before{content:\"\\E65F\"}.icon-fanhui:before{content:\"\\E624\"}.icon-dakai:before{content:\"\\E627\"}.icon-shiti_shijuan:before{content:\"\\E628\"}.icon-shiti_guanbitouping:before{content:\"\\E669\"}.icon-suijidianming1:before{content:\"\\E66B\"}.icon-ykq_tab_danmu:before{content:\"\\E673\"}.icon-ykq_tab_tougao:before{content:\"\\E674\"}.icon-ykq-shiti-guanbi:before{content:\"\\E636\"}.icon-ykq_jiahao:before{content:\"\\E63A\"}.icon-ykq_shiti:before{content:\"\\E63D\"}.icon-ykq_yuyin:before{content:\"\\E640\"}.icon-ykq_bianji:before{content:\"\\E641\"}.icon-ykq_zhuguanti:before{content:\"\\E642\"}.icon-ykq_toupiao:before{content:\"\\E649\"}.icon-ykq_shanchu:before{content:\"\\E64A\"}.icon-WeChat_xiangxishuju:before{content:\"\\E65B\"}.icon-kuangxuanzhong:before{content:\"\\E650\"}.icon-kuang:before{content:\"\\E651\"}.icon-jingshi:before{content:\"\\E62C\"}.icon-teach:before{content:\"\\E644\"}.icon-lesson:before{content:\"\\E643\"}.icon-class:before{content:\"\\E645\"}.icon-zhiding:before{content:\"\\E646\"}.icon-wancheng:before{content:\"\\E647\"}.icon-ykq_dafen:before{content:\"\\E67B\"}.icon-xialazhankai:before{content:\"\\E659\"}.icon-weiwancheng:before{content:\"\\E65C\"}.icon-zankong:before{content:\"\\E660\"}.icon-bangzhu:before{content:\"\\E661\"}.icon-tongzhi:before{content:\"\\E61C\"}.icon-banduibancuo:before{content:\"\\E662\"}.icon-tianjiafujianicon:before{content:\"\\E62D\"}.icon-chenggong:before{content:\"\\E663\"}.icon-quanxian:before{content:\"\\E633\"}.icon-shibai:before{content:\"\\E634\"}.icon-zan:before{content:\"\\E635\"}.icon-qingchuguanbi:before{content:\"\\E69D\"}.icon-shouqi:before{content:\"\\E681\"}.icon-zhankai:before{content:\"\\E682\"}.icon-diandiandian:before{content:\"\\E69B\"}.icon-bianji:before{content:\"\\E67C\"}.icon-kuangxuanzhong1:before{content:\"\\E68B\"}.icon-kuang1:before{content:\"\\E68C\"}.icon-shezhi:before{content:\"\\E68E\"}.icon-bofang:before{content:\"\\E684\"}.icon-kehuduantubiao_qunfalianjie:before{content:\"\\E637\"}.icon-zanactive:before{content:\"\\E685\"}.icon-zannormal:before{content:\"\\E686\"}.icon-xiaoxi1:before{content:\"\\E687\"}.icon-h_yuyan:before{content:\"\\E672\"}.icon-h_shezhi:before{content:\"\\E675\"}.icon-kejianku:before{content:\"\\E676\"}.icon-shenfenqiehuan:before{content:\"\\E677\"}.icon-bianjishezhi:before{content:\"\\E678\"}.icon-taolun:before{content:\"\\E679\"}.icon-xiti:before{content:\"\\E67A\"}.icon-xuesheng:before{content:\"\\E67D\"}.icon-chengjidan:before{content:\"\\E8E8\"}.icon-tongxue:before{content:\"\\E67E\"}.icon-active:before{content:\"\\E67F\"}.icon-normal:before{content:\"\\E680\"}.icon-renwu:before{content:\"\\E683\"}.icon-fujian:before{content:\"\\E688\"}.icon-xiazai1:before{content:\"\\E689\"}.icon-normal1:before{content:\"\\E68A\"}.icon-quan:before{content:\"\\E68D\"}.icon-quanbubiaojiyidu:before{content:\"\\E68F\"}.icon-tianjiatupian-:before{content:\"\\E690\"}.icon-shouqi1:before{content:\"\\E639\"}.icon-zhankai1:before{content:\"\\E64D\"}.icon-kejiankejianqiehuan:before{content:\"\\E607\"}.icon-fenzu:before{content:\"\\E691\"}.icon-yaokongqishezhi:before{content:\"\\E609\"}.icon-yuankuang:before{content:\"\\E692\"}.icon-yuankuangxuanzhong:before{content:\"\\E693\"}.icon-sousuo1:before{content:\"\\E694\"}.icon-kejianjie:before{content:\"\\E695\"}.icon-fenzu1:before{content:\"\\E696\"}.icon-huping:before{content:\"\\E6A8\"}.icon-shengyinkai:before{content:\"\\E6AF\"}.icon-shengyinguan:before{content:\"\\E6B1\"}.icon-zanting:before{content:\"\\E6B2\"}.icon-bofang1:before{content:\"\\E6B3\"}.icon-tab-zhibo:before{content:\"\\E6B4\"}.icon--jiazaiwubaidi:before{content:\"\\E69C\"}.icon-bangdingshouji:before{content:\"\\E6B6\"}.icon-weichenggong:before{content:\"\\E6B7\"}.icon-chenggong1:before{content:\"\\E6B8\"}.icon--fangda:before{content:\"\\E697\"}.icon--xiangyouxuanzhuan:before{content:\"\\E698\"}.icon--suoxiao:before{content:\"\\E699\"}.icon--xiangzuoxuanzhuan:before{content:\"\\E69A\"}.icon--7z:before{content:\"\\E69E\"}.icon--bmp:before{content:\"\\E69F\"}.icon--doc:before{content:\"\\E6A0\"}.icon--csv:before{content:\"\\E6A1\"}.icon--docx:before{content:\"\\E6A2\"}.icon--dps:before{content:\"\\E6A3\"}.icon--et:before{content:\"\\E6A4\"}.icon--gif:before{content:\"\\E6A5\"}.icon--jpg:before{content:\"\\E6A6\"}.icon--key:before{content:\"\\E6A7\"}.icon--num:before{content:\"\\E6A9\"}.icon--pgs:before{content:\"\\E6AA\"}.icon--png:before{content:\"\\E6AB\"}.icon--pdf:before{content:\"\\E6AC\"}.icon--pptx:before{content:\"\\E6AD\"}.icon--rar:before{content:\"\\E6AE\"}.icon--ppt:before{content:\"\\E6B0\"}.icon--tar:before{content:\"\\E6B5\"}.icon--tif:before{content:\"\\E6B9\"}.icon--txt:before{content:\"\\E6C9\"}.icon--wps:before{content:\"\\E6CA\"}.icon--rtf:before{content:\"\\E6CB\"}.icon--xls:before{content:\"\\E6CC\"}.icon--zip:before{content:\"\\E703\"}.icon--xlsx:before{content:\"\\E704\"}.icon--yinpin1:before{content:\"\\E725\"}.icon--tianjiatupiancopy:before{content:\"\\E6BA\"}.icon-ykq_guidang:before{content:\"\\E6BB\"}.icon-fabu:before{content:\"\\E6BC\"}.icon-new-yonghu:before{content:\"\\E654\"}.icon-yinzhang:before{content:\"\\E6BD\"}.icon-huantu:before{content:\"\\E6BE\"}.icon-tupianyulan:before{content:\"\\E6BF\"}.icon-zhang--:before{content:\"\\E6C1\"}.icon--shangsheng:before{content:\"\\E6C0\"}.icon--xiajiang:before{content:\"\\E6C2\"}.icon--zengjiaEEED:before{content:\"\\E6C7\"}.icon--jianshao:before{content:\"\\E6C8\"}.icon-jiantouyindao:before{content:\"\\E6C3\"}.icon--yanzhengshibai:before{content:\"\\E6CD\"}.icon--yanzhengchenggong:before{content:\"\\E6CE\"}.icon-jiafenjiahao:before{content:\"\\E6C4\"}.icon-jiafenjianhao:before{content:\"\\E6C5\"}.icon-biaoqian:before{content:\"\\E6C6\"}.icon-top:before{content:\"\\E657\"}.icon-top1:before{content:\"\\E667\"}.icon-top2:before{content:\"\\E668\"}.icon--jiaoshi:before{content:\"\\E6E3\"}.icon--xuesheng:before{content:\"\\E6E4\"}.icon--jiaoxuehuodong:before{content:\"\\E6E5\"}.icon--jiaoshi1:before{content:\"\\E6E6\"}.icon--yonghu:before{content:\"\\E6E7\"}.icon--huoyueyonghu:before{content:\"\\E6E8\"}.icon--ketanghudong:before{content:\"\\E6E9\"}.icon--daokeshuai:before{content:\"\\E6EA\"}.icon--wu1:before{content:\"\\E6EB\"}.icon-jian:before{content:\"\\E6DB\"}.icon-jia:before{content:\"\\E6DC\"}.icon-yonghu:before{content:\"\\E6EC\"}.icon-weidingyue:before{content:\"\\E6DD\"}.icon--yidingyue:before{content:\"\\E6DF\"}.icon-ketanghuifangx:before{content:\"\\E6D4\"}.icon-right:before{content:\"\\E6D5\"}.icon-wrong1:before{content:\"\\E6D6\"}.icon-genggaiweizhengque:before{content:\"\\E6D7\"}.icon-yanjingkai:before{content:\"\\E6DE\"}.icon-yanjingguan:before{content:\"\\E6E0\"}.icon--shipin1:before{content:\"\\E792\"}.icon-jinzhi:before{content:\"\\E6F1\"}.icon--zhibo:before{content:\"\\E719\"}.icon-quanping:before{content:\"\\E714\"}.icon-zhibo:before{content:\"\\E715\"}.icon-guanbi:before{content:\"\\E718\"}.icon-sanjiaoxing:before{content:\"\\E72A\"}.icon-huoyuebanji:before{content:\"\\E737\"}.icon-guidangbanji:before{content:\"\\E738\"}.icon-bofangzhong:before{content:\"\\E73A\"}.icon-kechengoff:before{content:\"\\E73D\"}.icon-kechengon:before{content:\"\\E73E\"}.icon-faxianoff:before{content:\"\\E73F\"}.icon-faxianon:before{content:\"\\E740\"}.icon-xiaoxioff:before{content:\"\\E741\"}.icon-xiaoxion:before{content:\"\\E742\"}.icon-wodeff:before{content:\"\\E743\"}.icon-wodeon:before{content:\"\\E744\"}.icon--jiahao:before{content:\"\\E745\"}.icon--youjiantou:before{content:\"\\E746\"}.icon--gengduo:before{content:\"\\E747\"}.icon--shouqi:before{content:\"\\E748\"}.icon--zhankai:before{content:\"\\E749\"}.icon-dengdai:before{content:\"\\E74A\"}.icon-yinpin:before{content:\"\\E74B\"}.icon-xiazai2:before{content:\"\\E655\"}.icon-lixiananzhuang:before{content:\"\\E656\"}.icon-zaixiananzhuang:before{content:\"\\E658\"}.icon-qiehuanshijiao:before{content:\"\\E74C\"}.icon-guanbi2:before{content:\"\\E6F5\"}.icon-suoxiao1:before{content:\"\\E70E\"}.icon-quanping1:before{content:\"\\E70F\"}.icon-bofang4:before{content:\"\\E710\"}.icon-zanting2:before{content:\"\\E711\"}.icon-quanbu:before{content:\"\\E712\"}.icon-beisu1:before{content:\"\\E75C\"}.icon--suo:before{content:\"\\E70C\"}.icon-kaiguan-kai:before{content:\"\\E859\"}.icon-kaiguan-guan:before{content:\"\\E85A\"}.icon-shanchu:before{content:\"\\E64A\"}.icon-faxian:before{content:\"\\E77C\"}.icon-wode:before{content:\"\\E787\"}.icon-wode-mianzhuang:before{content:\"\\E788\"}.icon-kecheng-mianzhuang:before{content:\"\\E78B\"}.icon-xiaoxi:before{content:\"\\E78C\"}.icon-kecheng:before{content:\"\\E793\"}.icon-xiaoxi-mianzhuang:before{content:\"\\E795\"}.icon-faxian-mianzhuang:before{content:\"\\E798\"}.icon-iconshuoming:before{content:\"\\E809\"}.icon-dianzhenbi:before{content:\"\\E6CF\"}.icon-cz_xianshi:before{content:\"\\E6D1\"}.icon-cz_yincang:before{content:\"\\E6D2\"}.icon-shouqi2:before{content:\"\\E6D3\"}.icon-xiala:before{content:\"\\E6D8\"}.icon-jinru:before{content:\"\\E6D0\"}.icon-jiankao:before{content:\"\\E7C3\"}.icon-shebei-dianzhenbi-mianzhuang:before{content:\"\\E846\"}.icon-pingjiawodewenjuan:before{content:\"\\E83D\"}html{margin:0;padding:0;border:0;outline:0;vertical-align:baseline;background:transparent}abbr,address,article,aside,audio,b,blockquote,body,canvas,caption,cite,code,dd,del,details,dfn,div,dl,dt,em,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,i,iframe,img,input,ins,kbd,label,legend,li,mark,menu,nav,object,ol,p,pre,q,samp,section,small,span,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,ul,var,video{margin:0;padding:0;border:0;outline:0;-webkit-tap-highlight-color:rgba(0,0,0,0)}li{list-style:none}img{border:0}a{text-decoration:none}.clearfix:after{display:block;content:\"\";clear:both}.fade-transition{transition:opacity .3s ease}.fade-enter,.fade-leave{opacity:0}.mint-button--default{box-shadow:none!important}.mint-button--primary{background-color:#639ef4!important}#nprogress .bar{background:#639ef4}#nprogress .peg{box-shadow:0 0 10px #639ef4,0 0 5px #639ef4}#nprogress .spinner{display:none;top:50%;right:50%}#nprogress .spinner-icon{border-top-color:#639ef4;border-left-color:#639ef4}#global_loading{position:fixed;text-align:center;top:0;left:0;width:100%;height:100%;z-index:999}#global_loading img{position:absolute;z-index:10;left:50%;top:50%;width:60px;margin-left:-30px;margin-top:-60px}body{background:#edf2f6;font-family:arial,Helvetica Neue,tahoma,Hiragino Sans GB,Microsoft YaHei,\\5b8b\\4f53;-webkit-font-smoothing:antialiased;-webkit-text-size-adjust:100%!important;-ms-text-size-adjust:100%!important;text-size-adjust:100%!important}.ellipsis{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.pages{position:relative;overflow:hidden;background:#000}.page,.pages{width:100%;height:100%}.page{box-sizing:border-box;position:absolute;left:0;top:0;background:#efeff4;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-overflow-scrolling:touch}.no_menu_page{position:absolute!important;z-index:101;top:0!important;padding-bottom:0!important}.g-page,.newPage{-webkit-overflow-scrolling:touch}:-webkit-full-screen,:full-screen{width:100%;height:100%}:-webkit-full-screen,:full-screen,:fullscreen{width:100%;height:100%}.mint-indicator-mask,.mint-indicator-wrapper{z-index:200}.msgbox{position:fixed;top:50%;left:50%;-webkit-transform:translate3d(-50%,-50%,0);transform:translate3d(-50%,-50%,0);background-color:#fff;width:72%!important;border-radius:6px!important;font-size:16px;-webkit-user-select:none;overflow:hidden;opacity:1;-webkit-backface-visibility:hidden;backface-visibility:hidden;padding-top:20px}.msgbox-header{padding:0!important;border-bottom:1px solid #ddd}.msgbox-content{padding:5px 20px 20px!important;min-height:36px;position:relative;border-bottom:1px solid #ddd}.msgbox-message{color:#333!important;line-height:24px;margin-left:26px;margin-right:26px}.msgbox-btns,.msgbox-message{font-size:16px;text-align:center}.msgbox-btns{display:-ms-flexbox;display:flex;height:44px!important;line-height:44px!important}.msgbox-btn{display:block;background-color:#fff;border:0;-ms-flex:1;flex:1;margin:0;border-radius:0}.mint-toast{padding:15px!important;border-radius:6px!important;min-height:70px!important;padding:20px 30px!important;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.mint-toast-text{font-size:18px!important;line-height:1}.pop-bounce-transition{transition:.2s .1s}.pop-bounce-enter{opacity:0;transform:translate3d(-50%,-50%,0) scale(.7)}.pop-bounce-leave{opacity:0;transform:translate3d(-50%,-50%,0) scale(.9)}", ""]);
	
	// exports


/***/ }),
/* 350 */
/***/ (function(module, exports) {

	module.exports = function escape(url) {
	    if (typeof url !== 'string') {
	        return url
	    }
	    // If url is already wrapped in quotes, remove them
	    if (/^['"].*['"]$/.test(url)) {
	        url = url.slice(1, -1);
	    }
	    // Should url be wrapped?
	    // See https://drafts.csswg.org/css-values-3/#urls
	    if (/["'() \t\n]/.test(url)) {
	        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
	    }
	
	    return url
	}


/***/ }),
/* 351 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function(useSourceMap) {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			return this.map(function (item) {
				var content = cssWithMappingToString(item, useSourceMap);
				if(item[2]) {
					return "@media " + item[2] + "{" + content + "}";
				} else {
					return content;
				}
			}).join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};
	
	function cssWithMappingToString(item, useSourceMap) {
		var content = item[1] || '';
		var cssMapping = item[3];
		if (!cssMapping) {
			return content;
		}
	
		if (useSourceMap && typeof btoa === 'function') {
			var sourceMapping = toComment(cssMapping);
			var sourceURLs = cssMapping.sources.map(function (source) {
				return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
			});
	
			return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
		}
	
		return [content].join('\n');
	}
	
	// Adapted from convert-source-map (MIT)
	function toComment(sourceMap) {
		// eslint-disable-next-line no-undef
		var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
		var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;
	
		return '/*# ' + data + ' */';
	}


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d61c0555a9672cf1c0ac0e972edde22b.eot";

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bc30794022de5712e3d4fb5514b723aa.ttf";

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ef866b5983d0be0362547ffd256f19f8.svg";

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vars = __webpack_require__(357);
	
	var _vars2 = _interopRequireDefault(_vars);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var navData = {
		'lv1': 0,
		'navlist': [
		// {
		// 	'name': '首页',
		// 	'rel': 'home',
		// 	'link': vars.index,
		// 	'children': {
		// 		'activeindex': 0,
		// 		'list': []
		// 	}
		// },
		{
			'name': '课程',
			'rel': 'course',
			'key': 'nav.course',
			'link': _vars2.default.course,
			'children': {
				'activeindex': 0,
				'list': [{
					'name': '班级课程',
					'rel': 'normalcourse'
				}, {
					'name': '公开课',
					'rel': 'opencourse'
				}]
			}
		}, {
			'name': '发现',
			'rel': 'discover',
			'key': 'nav.discover',
			'link': _vars2.default.discover,
			'children': {
				'activeindex': 0,
				'list': []
			}
		}, {
			'name': '消息',
			'rel': 'message',
			'key': 'nav.message',
			'link': _vars2.default.message,
			'children': {
				'activeindex': 0,
				'list': []
			}
			// {
			// 	'name': '我',
			// 	'rel': 'myself',
			// 	'link': vars.myself,
			// 	'children': {
			// 		'list': []
			// 	}
			// }
		}]
	};
	
	if (_vars2.default.hideOpencourse) {
		navData = {
			'lv1': 0,
			'navlist': [{
				'name': '课程',
				'rel': 'course',
				'link': _vars2.default.course,
				'children': {
					'activeindex': 0,
					'list': [{
						'name': '班级课程',
						'rel': 'normalcourse'
					}, {
						'name': '公开课',
						'rel': 'opencourse'
					}]
				}
			}]
		};
	}
	
	exports.default = navData;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/**
	 * vars 模块
	 * @description 全局通用变量
	 *              production块内是线上入口url
	 *              else 块内是dev url
	 */
	
	// 全局引用jquery
	// import 'jquery'
	// import 'zepto'
	
	var vars = {};
	
	if (true) {
	    vars = {
	        index: '/'
	    };
	} else {
	    vars = {
	        index: '/index.html'
	    };
	}
	vars.hideOpencourse = false;
	vars.showWhatsnew = true;
	vars.peekTicketName = '瞻仰';
	// vars.navlv1number = {
	// 	home: 0,
	// 	course: 1,
	// 	discover: 2,
	// 	message: 3,
	// 	myself: 4
	// }
	vars.navlv1number = {
	    course: 0,
	    discover: 1,
	    message: 2,
	    myself: 3
	};
	
	if (vars.hideOpencourse) {
	    vars.navlv1number = {
	        course: 0,
	        myself: 1
	    };
	}
	
	vars.external_path = {
	    "quiz_result": "/quiz/quiz_result",
	    "quiz_info": "/quiz/quiz_info",
	    "cards_info": "/cards/cards_info",
	    "lesson_info": "/v/lesson/lesson_info",
	    "lesson_student": "/lesson/student",
	    "lesson_teacher": "/lesson/teacher",
	    "links_info": "/v/link/links_info",
	    "manage_memo": "/v/memo/manage_memo"
	};
	
	exports.default = vars;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _assign = __webpack_require__(359);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _promise = __webpack_require__(36);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _stringify = __webpack_require__(364);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	exports.isHtml = isHtml;
	exports.resetNavbar = resetNavbar;
	exports.splitSecond = splitSecond;
	exports.parseUrl = parseUrl;
	exports.pageTo = pageTo;
	exports.setSize = setSize;
	exports.initProtocal = initProtocal;
	exports.pagereload = pagereload;
	exports.isSupported = isSupported;
	exports.getPlatformKey = getPlatformKey;
	exports.getLength = getLength;
	exports.substr = substr;
	exports.loadScript = loadScript;
	exports.encrypt = encrypt;
	exports.configPretreat = configPretreat;
	exports.presentationCanShowSlides = presentationCanShowSlides;
	exports.getMutiCoursewaresConfig = getMutiCoursewaresConfig;
	exports.setItemNotVisible = setItemNotVisible;
	exports.setItemNotVisibleOld = setItemNotVisibleOld;
	exports.isHelpfulArray = isHelpfulArray;
	exports.removeSessionStorageData = removeSessionStorageData;
	exports.isTMWebview = isTMWebview;
	exports.formatTimeUniversal = formatTimeUniversal;
	exports.isOldWeChat = isOldWeChat;
	exports.hexToRgba = hexToRgba;
	
	var _vars = __webpack_require__(357);
	
	var _vars2 = _interopRequireDefault(_vars);
	
	var _navData = __webpack_require__(356);
	
	var _navData2 = _interopRequireDefault(_navData);
	
	var _request = __webpack_require__(366);
	
	var _request2 = _interopRequireDefault(_request);
	
	var _jsencrypt = __webpack_require__(437);
	
	var _jsencrypt2 = _interopRequireDefault(_jsencrypt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// created by liujunyang 2016-07-18
	
	var htmlTags = ["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "math", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rb", "rp", "rt", "rtc", "ruby", "s", "samp", "script", "section", "select", "slot", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "svg", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr"];
	var basic = /\s?<!doctype html>|(<html\b[^>]*>|<body\b[^>]*>|<x-[^>]+>)+/i;
	var full = new RegExp(htmlTags.map(function (el) {
	    return '<' + el + '\\b[^>]*>';
	}).join('|'), 'i');
	
	function isHtml(str) {
	    if (basic.test(str)) {
	        return true;
	    }
	
	    return full.test(str);
	};
	
	/**
	 * 根据路由确定导航条的展示数据
	 * @description 解决刷新页面或浏览器前进后退的时候不能触发toggle函数切换导航展示的问题，
	 *              切换路由的时候执行
	 * @param  {String} name 页面名
	 */
	function resetNavbar(name) {
	    var navlist = _navData2.default.navlist;
	    for (var i = 0; i < navlist.length; i++) {
	        if (navlist[i].rel == name) {
	            _navData2.default.lv1 = i;
	            return;
	        } else {
	            for (var j = 0; j < navlist[i].children.list.length; j++) {
	                if (navlist[i].children.list[j].rel == name) {
	                    _navData2.default.lv1 = i;
	                    navlist[i].children.activeindex = j;
	                    return;
	                }
	            };
	        }
	    };
	}
	
	/**
	 * 秒数转换
	 * @param  {Number} second 秒
	 * @return {Object}        countday    天
	 *                         countHour   时
	 *                         countMinute 分
	 *                         countSecond 秒
	 */
	function splitSecond(second) {
	    var countday = second % (3600 * 24);
	    var counthour = countday % 3600;
	    return {
	        countDay: Math.floor(second / (3600 * 24)),
	        countHour: Math.floor(countday / 3600),
	        countMinute: counthour % 60 ? Math.floor(counthour / 60) : Math.floor(counthour / 60) - 1,
	        countSecond: counthour % 60 ? counthour % 60 : 60
	    };
	}
	
	/**
	 * 格式化url
	 * @param  {[String]} url
	 * @return {[Object]}
	 */
	function parseUrl() {
	    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;
	
	    var a = document.createElement('a');
	    a.href = url;
	    return {
	        source: url,
	        protocol: a.protocol.replace(':', ''),
	        host: a.hostname,
	        port: a.port,
	        query: a.search,
	        params: function () {
	            var ret = {},
	                seg = a.search.replace(/^\?/, '').split('&'),
	                len = seg.length,
	                i = 0,
	                s;
	            for (; i < len; i++) {
	                if (!seg[i]) {
	                    continue;
	                }
	                s = seg[i].split('=');
	                ret[s[0]] = s[1];
	            }
	            return ret;
	        }(),
	        file: (a.pathname.match(/\/([^\/?#]+)$/i) || [null, ''])[1],
	        hash: a.hash.replace('#', ''),
	        path: a.pathname.replace(/^([^\/])/, '/$1'),
	        relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [null, ''])[1],
	        segments: a.pathname.replace(/^\//, '').split('/')
	    };
	}
	
	/**
	 * 页面跳转
	 * @param  {String} page   页面名
	 * @param  {String} params 页面路由参数
	 */
	function pageTo() {
	    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'index';
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var reload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    if (page === 404 || page === 500) {
	        window.location.href = _vars2.default['error'] + '?' + 'c=' + page;
	    }
	    if (page in _vars2.default) {
	        window.location.href = _vars2.default[page] + (reload ? '?t=' + +new Date() : '') + '#!' + params;
	    }
	}
	
	/**
	 * 设置字体禁止放大缩小 android手机字体缩放
	 * @param
	 */
	function setSize() {
	    if (typeof WeixinJSBridge === 'undefined') {
	        document.addEventListener('WeixinJSBridgeReady', function (e) {
	            setTimeout(function () {
	                typeof WeixinJSBridge !== 'undefined' && WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize': 0 }, function (res) {});
	
	                //                 WeixinJSBridge.invoke("setNavigationBarColor", {
	                //                   color: "#8d0809"
	                //                 }, function(res) {
	                //                    console.info(res)
	                //                 })
	            }, 0);
	        });
	    } else {
	        setTimeout(function () {
	            typeof WeixinJSBridge !== 'undefined' && WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize': 0 }, function (res) {});
	
	            //             WeixinJSBridge.invoke("setNavigationBarColor", {
	            //               color: "#8d0809"
	            //             }, function(res) {
	            //                console.info(res)
	            //             })
	        }, 0);
	    }
	}
	
	/**
	 * 检测是否是https
	 * @param
	 */
	function initProtocal() {
	    var url = location.href;
	
	    // 是否是网页版
	    var pubSub = window.parent && window.parent.PubSub || null;
	    if (pubSub) {
	        return this;
	    }
	
	    // 检测是否是http
	    if (location.protocol === 'http:') {
	        if (location.host.indexOf('yuketang') !== -1 || location.host.indexOf('ykt.io') !== -1) {
	            url = url.replace('http:', 'https:').replace('ykt.io', 'www.yuketang.cn');
	
	            location.replace(url);
	        }
	    }
	}
	
	function pagereload() {
	    //修改IOS返回页面不刷新问题。
	    $(function () {
	        var isPageHide = false;
	        window.addEventListener('pageshow', function () {
	            if (isPageHide) {
	                window.location.reload();
	            }
	        });
	        window.addEventListener('pagehide', function () {
	            isPageHide = true;
	        });
	    });
	}
	
	/**
	 * 检测是否支持本地storage
	 * @param
	 */
	function isSupported(storage) {
	    try {
	        var key = "__some_random_key_you_are_not_going_to_use__";
	        storage.setItem(key, key);
	        storage.removeItem(key);
	        return true;
	    } catch (e) {
	        // const QUOTA_EXCEEDED_ERR_CODE = 22;
	        if (e.code === 22) {
	            storage.clear();
	        }
	
	        return false;
	    }
	}
	
	function getPlatformKey() {
	    var key = 'rain';
	    var host = {
	        'www.yuketang.cn': 'rain',
	        'b.yuketang.cn': 'thunder',
	        'pro.yuketang.cn': 'thu',
	        'changjiang.yuketang.cn': 'changjiang',
	        'g.yuketang.cn': 'g',
	        'huanghe.yuketang.cn': 'huanghe',
	        'hhtest.yuketang.cn': 'hhtest',
	        'pro.xuetangonline.com': 'protest',
	        'protest.xuetangonline.com': 'protest',
	        'pre-apple-ykt.xuetangonline.com': 'pre-apple-ykt',
	        'rain.gdufemooc.cn': 'gc',
	        'ykt-dev.xuetangonline.com': 'aliOss',
	        // 镜泊雨课堂
	        'ykt-envning.rainclassroom.com': 'envning',
	        // 鸣泉雨课堂
	        'ykt-env-example.rainclassroom.com': 'env-example',
	        //K12
	        'www.yudou.cn': 'yudou',
	        'jcjy2edu.rainclassroom.com': 'yudou',
	
	        // 清华继教学院定制需求 单独判断该学校使用的域名
	        'online1.yuketang.cn': 'huanghe',
	        'www.itsinghua.com': 'huanghe',
	        'home.itsinghua.com': 'huanghe',
	        'localhost:8080': 'localhost'
	    };
	
	    key = host[location.host] || 'rain';
	
	    return key;
	}
	
	/**
	 * 字符串字符数量 汉字等是两个字符
	 * @param str
	 */
	function getLength(str) {
	    var result = 0;
	    var length = str.length;
	    while (length--) {
	        if (/^[\u0000-\u00ff]$/.test(str.charAt(length))) {
	            result += 1;
	        } else {
	            result += 2;
	        }
	    }
	
	    return result;
	}
	
	/**
	 * 字符串截取 英文*2
	 * @param str maxLength
	 */
	function substr(str, maxLength) {
	    var re = new RegExp("^[a-zA-Z]|[0-9]+$");
	    var length = str.length;
	    var result = 0;
	    var index = 0;
	
	    for (var i = 0; i < str.length; i++) {
	        if (/^[\u0000-\u00ff]$/.test(str.charAt(i))) {
	            result += 1;
	        } else {
	            result += 2;
	        }
	        if (result >= maxLength * 2) {
	            index = i + 1;
	            break;
	        }
	    }
	
	    /**
	     * 如果是开头英文最后是中文的正则检测为true
	     * 此时字符串截取就出错了
	     * 所以改为上面的方法
	         if (re.test(str)) {
	        maxLength = maxLength * 2;
	        }
	        *
	        */
	
	    return str.substr(0, index);
	}
	
	$.extend($, {
	
	    isAndroid: function isAndroid() {
	        var u = navigator.userAgent.toLowerCase();
	        return u.indexOf('android') > -1 || u.indexOf('linux') > -1; //android终端或者uc浏览器
	    },
	
	    isIOS: function isIOS() {
	        var u = navigator.userAgent;
	        return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
	    },
	    setWXConfig: function setWXConfig() {
	        typeof wx !== 'undefined' && $.ajax({ type: 'POST', url: '/v/course_meta/weixin_index_parameter', data: (0, _stringify2.default)({ url: location.href }), dataType: 'json',
	            success: function success(res) {
	                var data = res.data.js_config;
	                // 微信分享配置
	                wx.config({
	                    debug: false,
	                    appId: data.appId,
	                    timestamp: data.timestamp,
	                    nonceStr: data.nonceStr,
	                    signature: data.signature,
	                    jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone', 'showMenuItems', 'translateVoice', 'startRecord', 'stopRecord', 'onVoiceRecordEnd', 'playVoice', 'onVoicePlayEnd', 'pauseVoice', 'stopVoice', 'uploadVoice', 'downloadVoice', 'chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'getNetworkType', 'scanQRCode', 'chooseWXPay', 'openProductSpecificView', 'addCard', 'chooseCard', 'openCard']
	                });
	            }, error: function error(xhr, type) {}
	        });
	    },
	    resetTitle: function resetTitle(title) {
	        var $body = $('body');
	        document.title = title;
	        // hack在微信等webview中无法修改document.title的情况
	        if ($.isIOS()) {
	            var $iframe = $('<iframe src="/vue_images/images/favicon.ico" style="width:1px; height:1px;"></iframe>');
	            $iframe.on('load', function () {
	                setTimeout(function () {
	                    $iframe.off('load').remove();
	                }, 0);
	            }).appendTo($body);
	        }
	    },
	    timeStr2Hour: function timeStr2Hour(str) {
	        // 从时间字符串转化为消耗的小时的数值
	        // 输入：08:52:09
	        // 输出：8.869166666666667
	        var hms = str.split(':');
	        return +hms[0] + +hms[1] / 60 + +hms[2] / 3600;
	    },
	    timeStrArr2HourArr: function timeStrArr2HourArr(strArr) {
	        // 从时间字符串，无视日期，取得其从0点开始过了几个小时
	        // 输入：['2016-11-25 08:52:09', '2016-11-26 09:32:09', '2016-11-27 08:22:09', '2016-11-28 08:42:09']
	        // 输出：[8.869166666666667,9.535833333333333,8.369166666666667,8.702499999999999]
	        var stampList = [];
	        for (var i = 0; i < strArr.length; i++) {
	            var hms = strArr[i].split(' ')[1];
	            var hour = $.timeStr2Hour(hms);
	
	            // 产品设定有效打卡时间，如果超过10点就设置为10点，早于5点设置为5点
	            hour < 5 && (hour = 5);
	            hour > 10 && (hour = 10);
	            // 把10点作为Y轴0点，把5点作为Y轴高点的话，要的起始是距离10点的距离
	            stampList.push(10 - hour);
	        }
	        return stampList;
	    },
	    timeStrArr2DateArr: function timeStrArr2DateArr(strArr, noyear) {
	        // 从时间字符串，取得日期
	        // 输入：['2016-11-25 08:52:09', '2016-11-26 09:32:09', '2016-11-27 08:22:09', '2016-11-28 08:42:09']
	        // 输出：['2016-11-25', '2016-11-26', '2016-11-27', '2016-11-28']
	        // 如果noyear为true，输出中就不带年份：['11-25', '11-26', '11-27', '11-28']
	        var stampList = [];
	        for (var i = 0; i < strArr.length; i++) {
	            var yyyymmdd = strArr[i].split(' ')[0];
	            var _date = noyear ? yyyymmdd.replace('2016-', '').replace('2017-', '') : yyyymmdd;
	
	            stampList.push(_date);
	        }
	        return stampList;
	    },
	    getBytesLength: function getBytesLength(str) {
	        ///<summary>获得字符串实际长度，中文2，英文1</summary>
	        ///<param name="str">要获得长度的字符串</param>
	        var realLength = 0,
	            len = str.length,
	            charCode = -1;
	        for (var i = 0; i < len; i++) {
	            charCode = str.charCodeAt(i);
	            if (charCode >= 0 && charCode <= 128) realLength += 1;else realLength += 2;
	        }
	        return realLength;
	    },
	    urlMock: function urlMock(url) {
	        // TODO: 这里用于测试测试环境接口，暂时不走这个判断
	        if (false) {
	            return 'http://apimock.xuetangx.com/mock/115/' + url;
	        }
	        return "/" + url;
	    }
	});
	
	$.fn.transform = function (s_css) {
	    this.css("transform", s_css);
	    this.css("-webkit-transform", s_css);
	    this.css("-moz-transform", s_css);
	};
	
	// 动态加载js
	function loadScript(src, attributes) {
	    return new _promise2.default(function (resolve, reject) {
	        var scriptNode = document.createElement("script");
	        scriptNode.setAttribute("type", "text/javascript");
	        scriptNode.setAttribute("src", src);
	        if (attributes && attributes.length) {
	            attributes.forEach(function (item) {
	                scriptNode[item] = true;
	            });
	        }
	        document.body.appendChild(scriptNode);
	
	        scriptNode.onload = function (evt) {
	            resolve(evt);
	        };
	
	        scriptNode.onerror = function (evt) {
	            reject('加载失败');
	        };
	    });
	}
	
	function encrypt(value) {
	    // 密码加密
	    var publicKey = '-----BEGIN PUBLIC KEY-----MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCQBaPX7crEH6/jS4hRD7lZrsFRIdfwEhH30onFnrnWxiRATzP9WEneXJEZHopmzudkNS5bDp51SCnBUGGgfL/sUUrlrhV2xnTSe1jRl924ejV5rkVkiii85jp9G8eJrJN6klHs0PfYfp4EVJ8688qpi5iETtg+q4ITocyEyD1+7wIDAQAB-----END PUBLIC KEY-----';
	    var encryptor = new _jsencrypt2.default();
	    encryptor.setPublicKey(publicKey);
	    return encryptor.encrypt(value);
	}
	
	function configPretreat(conf) {
	    var result = {};
	    try {
	        result = typeof conf === "string" ? JSON.parse(conf) : conf;
	        result = typeof result === 'string' ? JSON.parse(result) : result;
	    } catch (error) {
	        result = {};
	    }
	    return result || {};
	}
	
	function presentationCanShowSlides(presentation, slides) {
	    var _ref = presentation || {},
	        config = _ref.config,
	        conf = _ref.conf;
	
	    var list = isHelpfulArray(slides) ? slides : [];
	    var confData = configPretreat(conf || config);
	
	    var _ref2 = confData || {},
	        show_presentation = _ref2.show_presentation,
	        hide_slides = _ref2.hide_slides;
	
	    if (show_presentation === 'all_not') {
	        return [];
	    }
	    if (show_presentation === 'part') {
	        var hideSlides = isHelpfulArray(hide_slides) ? hide_slides : [];
	        return list.filter(function (item) {
	            var _ref3 = item || {},
	                id = _ref3.id,
	                lessonSlideID = _ref3.lessonSlideID;
	
	            return !hideSlides.includes(id || lessonSlideID);
	        });
	    }
	    return list;
	}
	
	// 获取一堂课多个 presentation 集合竞出的config
	// key: 新旧接口字段名称不一样： conf config
	function getMutiCoursewaresConfig(presentations) {
	    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'conf';
	
	    var showStatus = [];
	    if (presentations instanceof Array) {
	        if (presentations.length === 1) {
	            return configPretreat(presentations[0][key]);
	        }
	        for (var i = 0, len = presentations.length; i < len; i++) {
	            var item = presentations[i] || {};
	            var conf = configPretreat(item[key]);
	            var show = conf.show_presentation;
	
	            if (show === 'film' || show === 'part' || show === 'all' && showStatus.includes('all_not') || show === 'all_not' && showStatus.includes('all')) {
	                return {
	                    show_presentation: 'part'
	                };
	            } else {
	                showStatus.push(show);
	            }
	        }
	        return {
	            show_presentation: showStatus.includes('all_not') ? 'all_not' : 'all'
	        };
	    }
	    return {
	        show_presentation: 'all'
	    };
	}
	
	// 给习题列表等单项添加是否可见字段
	function setItemNotVisible(list, presentations, pid) {
	    var confs = {};
	    if (!Array.isArray(list)) {
	        return [];
	    }
	    if (Array.isArray(presentations)) {
	        presentations.forEach(function (item) {
	            var _ref4 = item || {},
	                conf = _ref4.conf,
	                config = _ref4.config,
	                id = _ref4.id;
	
	            var result = configPretreat(conf || config);
	            var show_presentation = result.show_presentation,
	                hide_slides = result.hide_slides;
	
	            if (id) {
	                confs[id] = {
	                    show_presentation: show_presentation || 'all',
	                    hide_slides: hide_slides || []
	                };
	            } else if (presentations.length === 1) {
	                confs[pid] = {
	                    show_presentation: show_presentation || 'all',
	                    hide_slides: hide_slides || []
	                };
	            }
	        });
	    }
	    return list.map(function (item) {
	        var _ref5 = item || {},
	            presentation_id = _ref5.presentation_id,
	            presentationId = _ref5.presentationId,
	            data = _ref5.data,
	            problemId = _ref5.problemId,
	            id = _ref5.id,
	            slideId = _ref5.slideId,
	            slide_id = _ref5.slide_id;
	
	        var _ref6 = data || {},
	            lessonSlideID = _ref6.lessonSlideID,
	            SlideID = _ref6.SlideID;
	
	        if (item.problem) {
	            presentationId = item.problem.presentationId;
	        }
	        if (SlideID) {
	            slideId = SlideID;
	        }
	        var tartget = confs[presentation_id || presentationId || pid];
	
	        var _ref7 = tartget || {},
	            show_presentation = _ref7.show_presentation,
	            hide_slides = _ref7.hide_slides;
	
	        if (tartget) {
	            if (show_presentation === 'all_not') {
	                return (0, _assign2.default)(item, {
	                    notVisible: true
	                });
	            } else if (show_presentation === 'part') {
	                var slides = hide_slides || [];
	                var notVisible = slides.includes(lessonSlideID || problemId || id || slideId || slide_id);
	                return (0, _assign2.default)(item, {
	                    notVisible: notVisible
	                });
	            }
	        }
	        return item;
	    });
	}
	
	function setItemNotVisibleOld(list, config) {
	    var show_presentation = config.show_presentation,
	        hide_slides = config.hide_slides;
	
	    hide_slides = isHelpfulArray(hide_slides) ? hide_slides : [];
	    return list.map(function (item) {
	        var _ref8 = item || {},
	            lessonSlideID = _ref8.lessonSlideID;
	
	        if (show_presentation === 'all_not') {
	            return (0, _assign2.default)(item, {
	                notVisible: true
	            });
	        } else if (show_presentation === 'part') {
	            var notVisible = hide_slides.includes(lessonSlideID);
	            return (0, _assign2.default)(item, {
	                notVisible: notVisible
	            });
	        }
	        return item;
	    });
	}
	
	// 判断是不是一个有效的数组
	function isHelpfulArray(list) {
	    return list instanceof Array && list.length;
	}
	
	// 清除sessionStorage数据
	function removeSessionStorageData(key) {
	    sessionStorage.removeItem(key);
	}
	
	// 是否腾讯会议应用内
	function isTMWebview() {
	    try {
	        var ua = window.navigator.userAgent;
	        return ua.includes('app/tencent_wemeet');
	    } catch (error) {
	        return false;
	    }
	}
	
	// 日期格式转换 2020-09-09 12:00
	function formatTimeUniversal(timestamp) {
	    if (!timestamp) return '';
	
	    // 兼容秒/毫秒时间戳
	    if (('' + timestamp).length === 10) {
	        timestamp = timestamp * 1000;
	    }
	    var time = new Date(timestamp);
	    var date = time.toLocaleDateString('en-CA');
	    // const time = new Date(timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
	    var hour = time.getHours() > 9 ? time.getHours() : '0' + time.getHours();
	    var mins = time.getMinutes() > 9 ? time.getMinutes() : '0' + time.getMinutes();
	    return date + ' ' + hour + ':' + mins;
	}
	
	// 检查是否是旧版本微信
	// https://developers.weixin.qq.com/miniprogram/dev/framework/client-lib/version.html
	// https://weixin.qq.com/cgi-bin/readtemplate?t=weixin_faq_list
	function isOldWeChat() {
	    var res = false;
	    var wxVersion = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i);
	    if (wxVersion && wxVersion[1]) {
	        var v = parseInt(wxVersion[1].split('.')[0]);
	        if (v && v < 8) {
	            res = true;
	        }
	    }
	
	    return res;
	}
	
	// 将Hex颜色值转成RGB模式
	function hexToRgba(hex, alpha) {
	    // 移除前导井号
	    hex = hex.replace(/^#?/, "");
	
	    // 计算RGB值
	    var r;
	    var g;
	    var b;
	
	    // 判断颜色值的长度，并计算相应的RGB值
	    switch (hex.length) {
	        case 3:
	            r = parseInt(hex.substr(0, 1) + hex.substr(0, 1), 16);
	            g = parseInt(hex.substr(1, 1) + hex.substr(1, 1), 16);
	            b = parseInt(hex.substr(2, 1) + hex.substr(2, 1), 16);
	            break;
	        case 6:
	            r = parseInt(hex.substr(0, 2), 16);
	            g = parseInt(hex.substr(2, 2), 16);
	            b = parseInt(hex.substr(4, 2), 16);
	            break;
	        default:
	            throw new Error('Invalid hex color code');
	    }
	
	    // 返回RGBA字符串
	    return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(360), __esModule: true };

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(361);
	module.exports = __webpack_require__(14).Object.assign;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(13);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(362)});

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.1 Object.assign(target, source, ...)
	var $        = __webpack_require__(8)
	  , toObject = __webpack_require__(363)
	  , IObject  = __webpack_require__(26);
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = __webpack_require__(12)(function(){
	  var a = Object.assign
	    , A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return a({}, A)[S] != 7 || Object.keys(a({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , $$    = arguments
	    , $$len = $$.length
	    , index = 1
	    , getKeys    = $.getKeys
	    , getSymbols = $.getSymbols
	    , isEnum     = $.isEnum;
	  while($$len > index){
	    var S      = IObject($$[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  }
	  return T;
	} : Object.assign;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(28);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(365), __esModule: true };

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(14);
	module.exports = function stringify(it){ // eslint-disable-line no-unused-vars
	  return (core.JSON && core.JSON.stringify || JSON.stringify).apply(JSON, arguments);
	};

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(367);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _promise = __webpack_require__(36);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _axios = __webpack_require__(371);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _jsCookie = __webpack_require__(398);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	!_promise2.default && __webpack_require__.e/* require */(1, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(399)]; (function (Promise) {
	  window.Promise = window.Promise || Promise;
	}.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));});
	
	var handleResponse = function handleResponse(res) {
	  // 支付接口使用的 status 判断
	  if (res.data.errcode == 0 || res.data.success || res.data.status === 0) {
	    return _promise2.default.resolve(res.data);
	  } else {
	    // 用户session丢失
	    if (res.data.op === 'redirect') {
	      var sUrl = decodeURIComponent(res.data.url);
	      var iNext = sUrl.indexOf('next=');
	      var newUrl = sUrl.substring(0, iNext);
	
	      newUrl += 'next=' + location.pathname;
	      setTimeout(function () {
	        location.href = '//' + location.host + newUrl;
	      }, 500);
	      return;
	    }
	
	    if (res.data.op && res.data.op === 'mobile_redirect') {
	      // 需要先登录
	      window.location.href = '/login/weixinapp/?next=' + encodeURIComponent(window.location.href);
	
	      return;
	    }
	
	    if (res.data.op == 'redirect_bind') {
	      // 清华绑定提示页
	      window.location.href = '/static/html/tsinghua_bind.html';
	      return;
	    }
	
	    if (res.data.op == 'k12_redirect_bind') {
	      // k12绑定页面
	      window.location.href = '/v/index/need-bind';
	      return;
	    }
	
	    // 没有权限
	    if (res.data.status_code === 2 || res.data.status_code === 4 || res.data.status_code === 902) {
	      location.href = '/v/index/course/normalcourse/error/' + res.data.status_code;
	    }
	
	    // 云雨打通学习单元被删除
	    if (res.data.error_code === 1 || res.data.error_code === 404000 || res.data.error_code === 902) {
	      location.href = '/v/index/course/normalcourse/error/' + res.data.error_code;
	    }
	    if (res.data.error_code === 2 || res.data.error_code === 4) {
	      location.href = '/v/index/course/normalcourse/error/' + res.data.error_code + '?from=notice_view';
	    }
	    // 云雨打通接口错误 根据sub_code 判断异常原因
	    if (res.data.error_code === 40000 && res.data.sub_code) {
	      // sub_code为302 未做身份绑定 跳转至绑定提示页
	      if (res.data.sub_code === 302) {
	        location.href = '/static/html/tsinghua_bind.html?from=2';
	      }
	    }
	    // 没有填写信息 跳转个人信息完善页
	    if (res.data.status_code === 5) {
	      location.href = '/v/index/edituserinfo_simple?next_url=back';
	    }
	
	    if (res.data.node_status_code == '43002') {
	      var lng = _jsCookie2.default.get('django_language') || 'zh-cn';
	      if (window.Toast) {
	        Toast({
	          message: lng == 'zh-cn' ? '输入内容含敏感词，请检查后重试' : 'The input contains sensitive words, please check and try again.',
	          duration: 3000
	        });
	      }
	
	      return;
	    }
	    if (res.data.error_code == '500600' || res.data.error_code == '500500' || res.data.error_code == '500700' || res.data.errcode == '300413') {
	
	      if (window.Toast) {
	        Toast({
	          message: res.data.data && res.data.data.data && res.data.data.data.msg || res.data.msg,
	          duration: 3000
	        });
	      }
	      return _promise2.default.resolve(res.data);
	    }
	
	    return _promise2.default.reject(res.data);
	  }
	};
	
	// 设置请求的设备和sessionid
	if (localStorage) {
	  var sessionid = localStorage.getItem('sessionid');
	  var client = localStorage.getItem('x-client') || 'web';
	  if (sessionid) {
	    _axios2.default.defaults.headers['x-mobile-sessid'] = sessionid;
	  }
	  _axios2.default.defaults.headers['x-client'] = client;
	  _axios2.default.defaults.headers['xtbz'] = 'ykt';
	}
	
	_axios2.default.defaults.headers['Xt-Agent'] = "h5";
	
	function errRequest(error) {
	  var _error$response = error.response,
	      response = _error$response === undefined ? {} : _error$response;
	
	  if (response.status === 401) {
	    var _response$data = response.data,
	        data = _response$data === undefined ? {} : _response$data;
	    var error_code = data.error_code;
	
	    var op = data.data && data.data.op;
	    if (error_code === 20006) {
	      console.log(op);
	      if (op === "mobile_redirect") {
	        window.location.href = '/static/html/openinwx.html';
	        return;
	      }
	      if (op === "redirect") {
	        location.href = '/login/weixinapp/?next=' + encodeURIComponent(location.href);
	        return;
	      }
	    }
	  }
	}
	
	exports.default = {
	  get: function get(url, params, allowEmpty) {
	    params = params || {};
	    var queryString = [];
	
	    (0, _keys2.default)(params).forEach(function (key) {
	      if (!allowEmpty) {
	        params[key] && queryString.push(key + '=' + params[key]);
	      } else {
	        queryString.push(key + '=' + params[key]);
	      }
	    });
	
	    if (queryString.length > 0) {
	      queryString = queryString.join('&');
	      url += '?' + queryString;
	    }
	    if (url.indexOf('?') > -1) {
	      url += "&date_time=" + new Date().getTime();
	    } else {
	      url += "?date_time=" + new Date().getTime();
	    }
	
	    var classroomid = localStorage.getItem('classroomId');
	    var uv_id = localStorage.getItem('uv_id');
	    classroomid && (_axios2.default.defaults.headers['classroom-id'] = classroomid);
	    uv_id && (_axios2.default.defaults.headers['university-id'] = uv_id);
	    return _axios2.default.get(url).then(function (response, data) {
	      return response;
	    }).then(handleResponse).catch(function (error) {
	      errRequest(error);
	      return _promise2.default.reject(error);
	    });
	  },
	  post: function post(url, params) {
	    var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    params = params || {};
	
	    // post统一csrftoken
	    _axios2.default.defaults.headers['X-CSRFToken'] = _jsCookie2.default.get('csrftoken') || '';
	
	    var classroomid = localStorage.getItem('classroomId');
	    var uv_id = localStorage.getItem('uv_id');
	    classroomid && (_axios2.default.defaults.headers['classroom-id'] = classroomid);
	    uv_id && (_axios2.default.defaults.headers['university-id'] = uv_id);
	
	    return _axios2.default.post(url, params, { headers: headers }).then(function (response, data) {
	      return response;
	    }).then(handleResponse).catch(function (error) {
	      errRequest(error);
	      return _promise2.default.reject(error);
	    });
	  },
	  put: function put(url, params) {
	    params = params || {};
	
	    // put统一csrftoken
	    _axios2.default.defaults.headers['X-CSRFToken'] = _jsCookie2.default.get('csrftoken') || '';
	
	    return _axios2.default.put(url, params).then(function (response, data) {
	      return response;
	    }).then(handleResponse).catch(function (error) {
	      return _promise2.default.reject(error);
	    });
	  },
	  delete: function _delete(url, params) {
	    params = params || {};
	    var queryString = [];
	    _axios2.default.defaults.headers['X-CSRFToken'] = _jsCookie2.default.get('csrftoken') || '';
	    // delete统一csrftoken
	    (0, _keys2.default)(params).forEach(function (key) {
	      queryString.push(key + '=' + params[key]);
	    });
	
	    if (queryString.length > 0) {
	      queryString = queryString.join('&');
	      url += '?' + queryString;
	    }
	    if (url.indexOf('?') > -1) {
	      url += "&date_time=" + new Date().getTime();
	    } else {
	      url += "?date_time=" + new Date().getTime();
	    }
	
	    return _axios2.default.delete(url, params).then(function (response, data) {
	      return response;
	    }).then(handleResponse).catch(function (error) {
	      return _promise2.default.reject(error);
	    });
	  }
	};

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(368), __esModule: true };

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(369);
	module.exports = __webpack_require__(14).Object.keys;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(363);
	
	__webpack_require__(370)('keys', function($keys){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(13)
	  , core    = __webpack_require__(14)
	  , fails   = __webpack_require__(12);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(372);

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(373);
	var bind = __webpack_require__(374);
	var Axios = __webpack_require__(376);
	var defaults = __webpack_require__(377);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(395);
	axios.CancelToken = __webpack_require__(396);
	axios.isCancel = __webpack_require__(392);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(397);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(374);
	var isBuffer = __webpack_require__(375);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object' && !isArray(obj)) {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ }),
/* 374 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ }),
/* 375 */
/***/ (function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(377);
	var utils = __webpack_require__(373);
	var InterceptorManager = __webpack_require__(389);
	var dispatchRequest = __webpack_require__(390);
	var isAbsoluteURL = __webpack_require__(393);
	var combineURLs = __webpack_require__(394);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	  config.method = config.method.toLowerCase();
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(373);
	var normalizeHeaderName = __webpack_require__(379);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(380);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(380);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(378)))

/***/ }),
/* 378 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(373);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(373);
	var settle = __webpack_require__(381);
	var buildURL = __webpack_require__(384);
	var parseHeaders = __webpack_require__(385);
	var isURLSameOrigin = __webpack_require__(386);
	var createError = __webpack_require__(382);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(387);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(388);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(382);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(383);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ }),
/* 383 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.request = request;
	  error.response = response;
	  return error;
	};


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(373);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(373);
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  });
	
	  return parsed;
	};


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(373);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ }),
/* 387 */
/***/ (function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(373);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(373);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(373);
	var transformData = __webpack_require__(391);
	var isCancel = __webpack_require__(392);
	var defaults = __webpack_require__(377);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(373);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ }),
/* 392 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ }),
/* 393 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ }),
/* 394 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ }),
/* 395 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(395);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ }),
/* 397 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.2.1
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (true) {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function decode (s) {
			return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
		}
	
		function init (converter) {
			function api() {}
	
			function set (key, value, attributes) {
				if (typeof document === 'undefined') {
					return;
				}
	
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);
	
				if (typeof attributes.expires === 'number') {
					attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
				}
	
				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
				try {
					var result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}
	
				value = converter.write ?
					converter.write(value, key) :
					encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
	
				key = encodeURIComponent(String(key))
					.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
					.replace(/[\(\)]/g, escape);
	
				var stringifiedAttributes = '';
				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
	
					// Considers RFC 6265 section 5.2:
					// ...
					// 3.  If the remaining unparsed-attributes contains a %x3B (";")
					//     character:
					// Consume the characters of the unparsed-attributes up to,
					// not including, the first %x3B (";") character.
					// ...
					stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
				}
	
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}
	
			function get (key, json) {
				if (typeof document === 'undefined') {
					return;
				}
	
				var jar = {};
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all.
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (!json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = decode(parts[0]);
						cookie = (converter.read || converter)(cookie, name) ||
							decode(cookie);
	
						if (json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						jar[name] = cookie;
	
						if (key === name) {
							break;
						}
					} catch (e) {}
				}
	
				return key ? jar[key] : jar;
			}
	
			api.set = set;
			api.get = function (key) {
				return get(key, false /* read as raw */);
			};
			api.getJSON = function (key) {
				return get(key, true /* read as json */);
			};
			api.remove = function (key, attributes) {
				set(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.defaults = {};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));


/***/ }),
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.JSEncrypt = {})));
	}(this, (function (exports) { 'use strict';
	
	var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
	function int2char(n) {
	    return BI_RM.charAt(n);
	}
	//#region BIT_OPERATIONS
	// (public) this & a
	function op_and(x, y) {
	    return x & y;
	}
	// (public) this | a
	function op_or(x, y) {
	    return x | y;
	}
	// (public) this ^ a
	function op_xor(x, y) {
	    return x ^ y;
	}
	// (public) this & ~a
	function op_andnot(x, y) {
	    return x & ~y;
	}
	// return index of lowest 1-bit in x, x < 2^31
	function lbit(x) {
	    if (x == 0) {
	        return -1;
	    }
	    var r = 0;
	    if ((x & 0xffff) == 0) {
	        x >>= 16;
	        r += 16;
	    }
	    if ((x & 0xff) == 0) {
	        x >>= 8;
	        r += 8;
	    }
	    if ((x & 0xf) == 0) {
	        x >>= 4;
	        r += 4;
	    }
	    if ((x & 3) == 0) {
	        x >>= 2;
	        r += 2;
	    }
	    if ((x & 1) == 0) {
	        ++r;
	    }
	    return r;
	}
	// return number of 1 bits in x
	function cbit(x) {
	    var r = 0;
	    while (x != 0) {
	        x &= x - 1;
	        ++r;
	    }
	    return r;
	}
	//#endregion BIT_OPERATIONS
	
	var b64map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	var b64pad = "=";
	function hex2b64(h) {
	    var i;
	    var c;
	    var ret = "";
	    for (i = 0; i + 3 <= h.length; i += 3) {
	        c = parseInt(h.substring(i, i + 3), 16);
	        ret += b64map.charAt(c >> 6) + b64map.charAt(c & 63);
	    }
	    if (i + 1 == h.length) {
	        c = parseInt(h.substring(i, i + 1), 16);
	        ret += b64map.charAt(c << 2);
	    }
	    else if (i + 2 == h.length) {
	        c = parseInt(h.substring(i, i + 2), 16);
	        ret += b64map.charAt(c >> 2) + b64map.charAt((c & 3) << 4);
	    }
	    while ((ret.length & 3) > 0) {
	        ret += b64pad;
	    }
	    return ret;
	}
	// convert a base64 string to hex
	function b64tohex(s) {
	    var ret = "";
	    var i;
	    var k = 0; // b64 state, 0-3
	    var slop = 0;
	    for (i = 0; i < s.length; ++i) {
	        if (s.charAt(i) == b64pad) {
	            break;
	        }
	        var v = b64map.indexOf(s.charAt(i));
	        if (v < 0) {
	            continue;
	        }
	        if (k == 0) {
	            ret += int2char(v >> 2);
	            slop = v & 3;
	            k = 1;
	        }
	        else if (k == 1) {
	            ret += int2char((slop << 2) | (v >> 4));
	            slop = v & 0xf;
	            k = 2;
	        }
	        else if (k == 2) {
	            ret += int2char(slop);
	            ret += int2char(v >> 2);
	            slop = v & 3;
	            k = 3;
	        }
	        else {
	            ret += int2char((slop << 2) | (v >> 4));
	            ret += int2char(v & 0xf);
	            k = 0;
	        }
	    }
	    if (k == 1) {
	        ret += int2char(slop << 2);
	    }
	    return ret;
	}
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = function(d, b) {
	    extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return extendStatics(d, b);
	};
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	// Hex JavaScript decoder
	// Copyright (c) 2008-2013 Lapo Luchini <lapo@lapo.it>
	// Permission to use, copy, modify, and/or distribute this software for any
	// purpose with or without fee is hereby granted, provided that the above
	// copyright notice and this permission notice appear in all copies.
	//
	// THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
	// WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
	// MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
	// ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
	// WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
	// ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
	// OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
	/*jshint browser: true, strict: true, immed: true, latedef: true, undef: true, regexdash: false */
	var decoder;
	var Hex = {
	    decode: function (a) {
	        var i;
	        if (decoder === undefined) {
	            var hex = "0123456789ABCDEF";
	            var ignore = " \f\n\r\t\u00A0\u2028\u2029";
	            decoder = {};
	            for (i = 0; i < 16; ++i) {
	                decoder[hex.charAt(i)] = i;
	            }
	            hex = hex.toLowerCase();
	            for (i = 10; i < 16; ++i) {
	                decoder[hex.charAt(i)] = i;
	            }
	            for (i = 0; i < ignore.length; ++i) {
	                decoder[ignore.charAt(i)] = -1;
	            }
	        }
	        var out = [];
	        var bits = 0;
	        var char_count = 0;
	        for (i = 0; i < a.length; ++i) {
	            var c = a.charAt(i);
	            if (c == "=") {
	                break;
	            }
	            c = decoder[c];
	            if (c == -1) {
	                continue;
	            }
	            if (c === undefined) {
	                throw new Error("Illegal character at offset " + i);
	            }
	            bits |= c;
	            if (++char_count >= 2) {
	                out[out.length] = bits;
	                bits = 0;
	                char_count = 0;
	            }
	            else {
	                bits <<= 4;
	            }
	        }
	        if (char_count) {
	            throw new Error("Hex encoding incomplete: 4 bits missing");
	        }
	        return out;
	    }
	};
	
	// Base64 JavaScript decoder
	// Copyright (c) 2008-2013 Lapo Luchini <lapo@lapo.it>
	// Permission to use, copy, modify, and/or distribute this software for any
	// purpose with or without fee is hereby granted, provided that the above
	// copyright notice and this permission notice appear in all copies.
	//
	// THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
	// WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
	// MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
	// ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
	// WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
	// ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
	// OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
	/*jshint browser: true, strict: true, immed: true, latedef: true, undef: true, regexdash: false */
	var decoder$1;
	var Base64 = {
	    decode: function (a) {
	        var i;
	        if (decoder$1 === undefined) {
	            var b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	            var ignore = "= \f\n\r\t\u00A0\u2028\u2029";
	            decoder$1 = Object.create(null);
	            for (i = 0; i < 64; ++i) {
	                decoder$1[b64.charAt(i)] = i;
	            }
	            for (i = 0; i < ignore.length; ++i) {
	                decoder$1[ignore.charAt(i)] = -1;
	            }
	        }
	        var out = [];
	        var bits = 0;
	        var char_count = 0;
	        for (i = 0; i < a.length; ++i) {
	            var c = a.charAt(i);
	            if (c == "=") {
	                break;
	            }
	            c = decoder$1[c];
	            if (c == -1) {
	                continue;
	            }
	            if (c === undefined) {
	                throw new Error("Illegal character at offset " + i);
	            }
	            bits |= c;
	            if (++char_count >= 4) {
	                out[out.length] = (bits >> 16);
	                out[out.length] = (bits >> 8) & 0xFF;
	                out[out.length] = bits & 0xFF;
	                bits = 0;
	                char_count = 0;
	            }
	            else {
	                bits <<= 6;
	            }
	        }
	        switch (char_count) {
	            case 1:
	                throw new Error("Base64 encoding incomplete: at least 2 bits missing");
	            case 2:
	                out[out.length] = (bits >> 10);
	                break;
	            case 3:
	                out[out.length] = (bits >> 16);
	                out[out.length] = (bits >> 8) & 0xFF;
	                break;
	        }
	        return out;
	    },
	    re: /-----BEGIN [^-]+-----([A-Za-z0-9+\/=\s]+)-----END [^-]+-----|begin-base64[^\n]+\n([A-Za-z0-9+\/=\s]+)====/,
	    unarmor: function (a) {
	        var m = Base64.re.exec(a);
	        if (m) {
	            if (m[1]) {
	                a = m[1];
	            }
	            else if (m[2]) {
	                a = m[2];
	            }
	            else {
	                throw new Error("RegExp out of sync");
	            }
	        }
	        return Base64.decode(a);
	    }
	};
	
	// Big integer base-10 printing library
	// Copyright (c) 2014 Lapo Luchini <lapo@lapo.it>
	// Permission to use, copy, modify, and/or distribute this software for any
	// purpose with or without fee is hereby granted, provided that the above
	// copyright notice and this permission notice appear in all copies.
	//
	// THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
	// WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
	// MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
	// ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
	// WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
	// ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
	// OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
	/*jshint browser: true, strict: true, immed: true, latedef: true, undef: true, regexdash: false */
	var max = 10000000000000; // biggest integer that can still fit 2^53 when multiplied by 256
	var Int10 = /** @class */ (function () {
	    function Int10(value) {
	        this.buf = [+value || 0];
	    }
	    Int10.prototype.mulAdd = function (m, c) {
	        // assert(m <= 256)
	        var b = this.buf;
	        var l = b.length;
	        var i;
	        var t;
	        for (i = 0; i < l; ++i) {
	            t = b[i] * m + c;
	            if (t < max) {
	                c = 0;
	            }
	            else {
	                c = 0 | (t / max);
	                t -= c * max;
	            }
	            b[i] = t;
	        }
	        if (c > 0) {
	            b[i] = c;
	        }
	    };
	    Int10.prototype.sub = function (c) {
	        // assert(m <= 256)
	        var b = this.buf;
	        var l = b.length;
	        var i;
	        var t;
	        for (i = 0; i < l; ++i) {
	            t = b[i] - c;
	            if (t < 0) {
	                t += max;
	                c = 1;
	            }
	            else {
	                c = 0;
	            }
	            b[i] = t;
	        }
	        while (b[b.length - 1] === 0) {
	            b.pop();
	        }
	    };
	    Int10.prototype.toString = function (base) {
	        if ((base || 10) != 10) {
	            throw new Error("only base 10 is supported");
	        }
	        var b = this.buf;
	        var s = b[b.length - 1].toString();
	        for (var i = b.length - 2; i >= 0; --i) {
	            s += (max + b[i]).toString().substring(1);
	        }
	        return s;
	    };
	    Int10.prototype.valueOf = function () {
	        var b = this.buf;
	        var v = 0;
	        for (var i = b.length - 1; i >= 0; --i) {
	            v = v * max + b[i];
	        }
	        return v;
	    };
	    Int10.prototype.simplify = function () {
	        var b = this.buf;
	        return (b.length == 1) ? b[0] : this;
	    };
	    return Int10;
	}());
	
	// ASN.1 JavaScript decoder
	var ellipsis = "\u2026";
	var reTimeS = /^(\d\d)(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([01]\d|2[0-3])(?:([0-5]\d)(?:([0-5]\d)(?:[.,](\d{1,3}))?)?)?(Z|[-+](?:[0]\d|1[0-2])([0-5]\d)?)?$/;
	var reTimeL = /^(\d\d\d\d)(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([01]\d|2[0-3])(?:([0-5]\d)(?:([0-5]\d)(?:[.,](\d{1,3}))?)?)?(Z|[-+](?:[0]\d|1[0-2])([0-5]\d)?)?$/;
	function stringCut(str, len) {
	    if (str.length > len) {
	        str = str.substring(0, len) + ellipsis;
	    }
	    return str;
	}
	var Stream = /** @class */ (function () {
	    function Stream(enc, pos) {
	        this.hexDigits = "0123456789ABCDEF";
	        if (enc instanceof Stream) {
	            this.enc = enc.enc;
	            this.pos = enc.pos;
	        }
	        else {
	            // enc should be an array or a binary string
	            this.enc = enc;
	            this.pos = pos;
	        }
	    }
	    Stream.prototype.get = function (pos) {
	        if (pos === undefined) {
	            pos = this.pos++;
	        }
	        if (pos >= this.enc.length) {
	            throw new Error("Requesting byte offset " + pos + " on a stream of length " + this.enc.length);
	        }
	        return ("string" === typeof this.enc) ? this.enc.charCodeAt(pos) : this.enc[pos];
	    };
	    Stream.prototype.hexByte = function (b) {
	        return this.hexDigits.charAt((b >> 4) & 0xF) + this.hexDigits.charAt(b & 0xF);
	    };
	    Stream.prototype.hexDump = function (start, end, raw) {
	        var s = "";
	        for (var i = start; i < end; ++i) {
	            s += this.hexByte(this.get(i));
	            if (raw !== true) {
	                switch (i & 0xF) {
	                    case 0x7:
	                        s += "  ";
	                        break;
	                    case 0xF:
	                        s += "\n";
	                        break;
	                    default:
	                        s += " ";
	                }
	            }
	        }
	        return s;
	    };
	    Stream.prototype.isASCII = function (start, end) {
	        for (var i = start; i < end; ++i) {
	            var c = this.get(i);
	            if (c < 32 || c > 176) {
	                return false;
	            }
	        }
	        return true;
	    };
	    Stream.prototype.parseStringISO = function (start, end) {
	        var s = "";
	        for (var i = start; i < end; ++i) {
	            s += String.fromCharCode(this.get(i));
	        }
	        return s;
	    };
	    Stream.prototype.parseStringUTF = function (start, end) {
	        var s = "";
	        for (var i = start; i < end;) {
	            var c = this.get(i++);
	            if (c < 128) {
	                s += String.fromCharCode(c);
	            }
	            else if ((c > 191) && (c < 224)) {
	                s += String.fromCharCode(((c & 0x1F) << 6) | (this.get(i++) & 0x3F));
	            }
	            else {
	                s += String.fromCharCode(((c & 0x0F) << 12) | ((this.get(i++) & 0x3F) << 6) | (this.get(i++) & 0x3F));
	            }
	        }
	        return s;
	    };
	    Stream.prototype.parseStringBMP = function (start, end) {
	        var str = "";
	        var hi;
	        var lo;
	        for (var i = start; i < end;) {
	            hi = this.get(i++);
	            lo = this.get(i++);
	            str += String.fromCharCode((hi << 8) | lo);
	        }
	        return str;
	    };
	    Stream.prototype.parseTime = function (start, end, shortYear) {
	        var s = this.parseStringISO(start, end);
	        var m = (shortYear ? reTimeS : reTimeL).exec(s);
	        if (!m) {
	            return "Unrecognized time: " + s;
	        }
	        if (shortYear) {
	            // to avoid querying the timer, use the fixed range [1970, 2069]
	            // it will conform with ITU X.400 [-10, +40] sliding window until 2030
	            m[1] = +m[1];
	            m[1] += (+m[1] < 70) ? 2000 : 1900;
	        }
	        s = m[1] + "-" + m[2] + "-" + m[3] + " " + m[4];
	        if (m[5]) {
	            s += ":" + m[5];
	            if (m[6]) {
	                s += ":" + m[6];
	                if (m[7]) {
	                    s += "." + m[7];
	                }
	            }
	        }
	        if (m[8]) {
	            s += " UTC";
	            if (m[8] != "Z") {
	                s += m[8];
	                if (m[9]) {
	                    s += ":" + m[9];
	                }
	            }
	        }
	        return s;
	    };
	    Stream.prototype.parseInteger = function (start, end) {
	        var v = this.get(start);
	        var neg = (v > 127);
	        var pad = neg ? 255 : 0;
	        var len;
	        var s = "";
	        // skip unuseful bits (not allowed in DER)
	        while (v == pad && ++start < end) {
	            v = this.get(start);
	        }
	        len = end - start;
	        if (len === 0) {
	            return neg ? -1 : 0;
	        }
	        // show bit length of huge integers
	        if (len > 4) {
	            s = v;
	            len <<= 3;
	            while (((+s ^ pad) & 0x80) == 0) {
	                s = +s << 1;
	                --len;
	            }
	            s = "(" + len + " bit)\n";
	        }
	        // decode the integer
	        if (neg) {
	            v = v - 256;
	        }
	        var n = new Int10(v);
	        for (var i = start + 1; i < end; ++i) {
	            n.mulAdd(256, this.get(i));
	        }
	        return s + n.toString();
	    };
	    Stream.prototype.parseBitString = function (start, end, maxLength) {
	        var unusedBit = this.get(start);
	        var lenBit = ((end - start - 1) << 3) - unusedBit;
	        var intro = "(" + lenBit + " bit)\n";
	        var s = "";
	        for (var i = start + 1; i < end; ++i) {
	            var b = this.get(i);
	            var skip = (i == end - 1) ? unusedBit : 0;
	            for (var j = 7; j >= skip; --j) {
	                s += (b >> j) & 1 ? "1" : "0";
	            }
	            if (s.length > maxLength) {
	                return intro + stringCut(s, maxLength);
	            }
	        }
	        return intro + s;
	    };
	    Stream.prototype.parseOctetString = function (start, end, maxLength) {
	        if (this.isASCII(start, end)) {
	            return stringCut(this.parseStringISO(start, end), maxLength);
	        }
	        var len = end - start;
	        var s = "(" + len + " byte)\n";
	        maxLength /= 2; // we work in bytes
	        if (len > maxLength) {
	            end = start + maxLength;
	        }
	        for (var i = start; i < end; ++i) {
	            s += this.hexByte(this.get(i));
	        }
	        if (len > maxLength) {
	            s += ellipsis;
	        }
	        return s;
	    };
	    Stream.prototype.parseOID = function (start, end, maxLength) {
	        var s = "";
	        var n = new Int10();
	        var bits = 0;
	        for (var i = start; i < end; ++i) {
	            var v = this.get(i);
	            n.mulAdd(128, v & 0x7F);
	            bits += 7;
	            if (!(v & 0x80)) { // finished
	                if (s === "") {
	                    n = n.simplify();
	                    if (n instanceof Int10) {
	                        n.sub(80);
	                        s = "2." + n.toString();
	                    }
	                    else {
	                        var m = n < 80 ? n < 40 ? 0 : 1 : 2;
	                        s = m + "." + (n - m * 40);
	                    }
	                }
	                else {
	                    s += "." + n.toString();
	                }
	                if (s.length > maxLength) {
	                    return stringCut(s, maxLength);
	                }
	                n = new Int10();
	                bits = 0;
	            }
	        }
	        if (bits > 0) {
	            s += ".incomplete";
	        }
	        return s;
	    };
	    return Stream;
	}());
	var ASN1 = /** @class */ (function () {
	    function ASN1(stream, header, length, tag, sub) {
	        if (!(tag instanceof ASN1Tag)) {
	            throw new Error("Invalid tag value.");
	        }
	        this.stream = stream;
	        this.header = header;
	        this.length = length;
	        this.tag = tag;
	        this.sub = sub;
	    }
	    ASN1.prototype.typeName = function () {
	        switch (this.tag.tagClass) {
	            case 0: // universal
	                switch (this.tag.tagNumber) {
	                    case 0x00:
	                        return "EOC";
	                    case 0x01:
	                        return "BOOLEAN";
	                    case 0x02:
	                        return "INTEGER";
	                    case 0x03:
	                        return "BIT_STRING";
	                    case 0x04:
	                        return "OCTET_STRING";
	                    case 0x05:
	                        return "NULL";
	                    case 0x06:
	                        return "OBJECT_IDENTIFIER";
	                    case 0x07:
	                        return "ObjectDescriptor";
	                    case 0x08:
	                        return "EXTERNAL";
	                    case 0x09:
	                        return "REAL";
	                    case 0x0A:
	                        return "ENUMERATED";
	                    case 0x0B:
	                        return "EMBEDDED_PDV";
	                    case 0x0C:
	                        return "UTF8String";
	                    case 0x10:
	                        return "SEQUENCE";
	                    case 0x11:
	                        return "SET";
	                    case 0x12:
	                        return "NumericString";
	                    case 0x13:
	                        return "PrintableString"; // ASCII subset
	                    case 0x14:
	                        return "TeletexString"; // aka T61String
	                    case 0x15:
	                        return "VideotexString";
	                    case 0x16:
	                        return "IA5String"; // ASCII
	                    case 0x17:
	                        return "UTCTime";
	                    case 0x18:
	                        return "GeneralizedTime";
	                    case 0x19:
	                        return "GraphicString";
	                    case 0x1A:
	                        return "VisibleString"; // ASCII subset
	                    case 0x1B:
	                        return "GeneralString";
	                    case 0x1C:
	                        return "UniversalString";
	                    case 0x1E:
	                        return "BMPString";
	                }
	                return "Universal_" + this.tag.tagNumber.toString();
	            case 1:
	                return "Application_" + this.tag.tagNumber.toString();
	            case 2:
	                return "[" + this.tag.tagNumber.toString() + "]"; // Context
	            case 3:
	                return "Private_" + this.tag.tagNumber.toString();
	        }
	    };
	    ASN1.prototype.content = function (maxLength) {
	        if (this.tag === undefined) {
	            return null;
	        }
	        if (maxLength === undefined) {
	            maxLength = Infinity;
	        }
	        var content = this.posContent();
	        var len = Math.abs(this.length);
	        if (!this.tag.isUniversal()) {
	            if (this.sub !== null) {
	                return "(" + this.sub.length + " elem)";
	            }
	            return this.stream.parseOctetString(content, content + len, maxLength);
	        }
	        switch (this.tag.tagNumber) {
	            case 0x01: // BOOLEAN
	                return (this.stream.get(content) === 0) ? "false" : "true";
	            case 0x02: // INTEGER
	                return this.stream.parseInteger(content, content + len);
	            case 0x03: // BIT_STRING
	                return this.sub ? "(" + this.sub.length + " elem)" :
	                    this.stream.parseBitString(content, content + len, maxLength);
	            case 0x04: // OCTET_STRING
	                return this.sub ? "(" + this.sub.length + " elem)" :
	                    this.stream.parseOctetString(content, content + len, maxLength);
	            // case 0x05: // NULL
	            case 0x06: // OBJECT_IDENTIFIER
	                return this.stream.parseOID(content, content + len, maxLength);
	            // case 0x07: // ObjectDescriptor
	            // case 0x08: // EXTERNAL
	            // case 0x09: // REAL
	            // case 0x0A: // ENUMERATED
	            // case 0x0B: // EMBEDDED_PDV
	            case 0x10: // SEQUENCE
	            case 0x11: // SET
	                if (this.sub !== null) {
	                    return "(" + this.sub.length + " elem)";
	                }
	                else {
	                    return "(no elem)";
	                }
	            case 0x0C: // UTF8String
	                return stringCut(this.stream.parseStringUTF(content, content + len), maxLength);
	            case 0x12: // NumericString
	            case 0x13: // PrintableString
	            case 0x14: // TeletexString
	            case 0x15: // VideotexString
	            case 0x16: // IA5String
	            // case 0x19: // GraphicString
	            case 0x1A: // VisibleString
	                // case 0x1B: // GeneralString
	                // case 0x1C: // UniversalString
	                return stringCut(this.stream.parseStringISO(content, content + len), maxLength);
	            case 0x1E: // BMPString
	                return stringCut(this.stream.parseStringBMP(content, content + len), maxLength);
	            case 0x17: // UTCTime
	            case 0x18: // GeneralizedTime
	                return this.stream.parseTime(content, content + len, (this.tag.tagNumber == 0x17));
	        }
	        return null;
	    };
	    ASN1.prototype.toString = function () {
	        return this.typeName() + "@" + this.stream.pos + "[header:" + this.header + ",length:" + this.length + ",sub:" + ((this.sub === null) ? "null" : this.sub.length) + "]";
	    };
	    ASN1.prototype.toPrettyString = function (indent) {
	        if (indent === undefined) {
	            indent = "";
	        }
	        var s = indent + this.typeName() + " @" + this.stream.pos;
	        if (this.length >= 0) {
	            s += "+";
	        }
	        s += this.length;
	        if (this.tag.tagConstructed) {
	            s += " (constructed)";
	        }
	        else if ((this.tag.isUniversal() && ((this.tag.tagNumber == 0x03) || (this.tag.tagNumber == 0x04))) && (this.sub !== null)) {
	            s += " (encapsulates)";
	        }
	        s += "\n";
	        if (this.sub !== null) {
	            indent += "  ";
	            for (var i = 0, max = this.sub.length; i < max; ++i) {
	                s += this.sub[i].toPrettyString(indent);
	            }
	        }
	        return s;
	    };
	    ASN1.prototype.posStart = function () {
	        return this.stream.pos;
	    };
	    ASN1.prototype.posContent = function () {
	        return this.stream.pos + this.header;
	    };
	    ASN1.prototype.posEnd = function () {
	        return this.stream.pos + this.header + Math.abs(this.length);
	    };
	    ASN1.prototype.toHexString = function () {
	        return this.stream.hexDump(this.posStart(), this.posEnd(), true);
	    };
	    ASN1.decodeLength = function (stream) {
	        var buf = stream.get();
	        var len = buf & 0x7F;
	        if (len == buf) {
	            return len;
	        }
	        // no reason to use Int10, as it would be a huge buffer anyways
	        if (len > 6) {
	            throw new Error("Length over 48 bits not supported at position " + (stream.pos - 1));
	        }
	        if (len === 0) {
	            return null;
	        } // undefined
	        buf = 0;
	        for (var i = 0; i < len; ++i) {
	            buf = (buf * 256) + stream.get();
	        }
	        return buf;
	    };
	    /**
	     * Retrieve the hexadecimal value (as a string) of the current ASN.1 element
	     * @returns {string}
	     * @public
	     */
	    ASN1.prototype.getHexStringValue = function () {
	        var hexString = this.toHexString();
	        var offset = this.header * 2;
	        var length = this.length * 2;
	        return hexString.substr(offset, length);
	    };
	    ASN1.decode = function (str) {
	        var stream;
	        if (!(str instanceof Stream)) {
	            stream = new Stream(str, 0);
	        }
	        else {
	            stream = str;
	        }
	        var streamStart = new Stream(stream);
	        var tag = new ASN1Tag(stream);
	        var len = ASN1.decodeLength(stream);
	        var start = stream.pos;
	        var header = start - streamStart.pos;
	        var sub = null;
	        var getSub = function () {
	            var ret = [];
	            if (len !== null) {
	                // definite length
	                var end = start + len;
	                while (stream.pos < end) {
	                    ret[ret.length] = ASN1.decode(stream);
	                }
	                if (stream.pos != end) {
	                    throw new Error("Content size is not correct for container starting at offset " + start);
	                }
	            }
	            else {
	                // undefined length
	                try {
	                    for (;;) {
	                        var s = ASN1.decode(stream);
	                        if (s.tag.isEOC()) {
	                            break;
	                        }
	                        ret[ret.length] = s;
	                    }
	                    len = start - stream.pos; // undefined lengths are represented as negative values
	                }
	                catch (e) {
	                    throw new Error("Exception while decoding undefined length content: " + e);
	                }
	            }
	            return ret;
	        };
	        if (tag.tagConstructed) {
	            // must have valid content
	            sub = getSub();
	        }
	        else if (tag.isUniversal() && ((tag.tagNumber == 0x03) || (tag.tagNumber == 0x04))) {
	            // sometimes BitString and OctetString are used to encapsulate ASN.1
	            try {
	                if (tag.tagNumber == 0x03) {
	                    if (stream.get() != 0) {
	                        throw new Error("BIT STRINGs with unused bits cannot encapsulate.");
	                    }
	                }
	                sub = getSub();
	                for (var i = 0; i < sub.length; ++i) {
	                    if (sub[i].tag.isEOC()) {
	                        throw new Error("EOC is not supposed to be actual content.");
	                    }
	                }
	            }
	            catch (e) {
	                // but silently ignore when they don't
	                sub = null;
	            }
	        }
	        if (sub === null) {
	            if (len === null) {
	                throw new Error("We can't skip over an invalid tag with undefined length at offset " + start);
	            }
	            stream.pos = start + Math.abs(len);
	        }
	        return new ASN1(streamStart, header, len, tag, sub);
	    };
	    return ASN1;
	}());
	var ASN1Tag = /** @class */ (function () {
	    function ASN1Tag(stream) {
	        var buf = stream.get();
	        this.tagClass = buf >> 6;
	        this.tagConstructed = ((buf & 0x20) !== 0);
	        this.tagNumber = buf & 0x1F;
	        if (this.tagNumber == 0x1F) { // long tag
	            var n = new Int10();
	            do {
	                buf = stream.get();
	                n.mulAdd(128, buf & 0x7F);
	            } while (buf & 0x80);
	            this.tagNumber = n.simplify();
	        }
	    }
	    ASN1Tag.prototype.isUniversal = function () {
	        return this.tagClass === 0x00;
	    };
	    ASN1Tag.prototype.isEOC = function () {
	        return this.tagClass === 0x00 && this.tagNumber === 0x00;
	    };
	    return ASN1Tag;
	}());
	
	// Copyright (c) 2005  Tom Wu
	// Bits per digit
	var dbits;
	// JavaScript engine analysis
	var canary = 0xdeadbeefcafe;
	var j_lm = ((canary & 0xffffff) == 0xefcafe);
	//#region
	var lowprimes = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509, 521, 523, 541, 547, 557, 563, 569, 571, 577, 587, 593, 599, 601, 607, 613, 617, 619, 631, 641, 643, 647, 653, 659, 661, 673, 677, 683, 691, 701, 709, 719, 727, 733, 739, 743, 751, 757, 761, 769, 773, 787, 797, 809, 811, 821, 823, 827, 829, 839, 853, 857, 859, 863, 877, 881, 883, 887, 907, 911, 919, 929, 937, 941, 947, 953, 967, 971, 977, 983, 991, 997];
	var lplim = (1 << 26) / lowprimes[lowprimes.length - 1];
	//#endregion
	// (public) Constructor
	var BigInteger = /** @class */ (function () {
	    function BigInteger(a, b, c) {
	        if (a != null) {
	            if ("number" == typeof a) {
	                this.fromNumber(a, b, c);
	            }
	            else if (b == null && "string" != typeof a) {
	                this.fromString(a, 256);
	            }
	            else {
	                this.fromString(a, b);
	            }
	        }
	    }
	    //#region PUBLIC
	    // BigInteger.prototype.toString = bnToString;
	    // (public) return string representation in given radix
	    BigInteger.prototype.toString = function (b) {
	        if (this.s < 0) {
	            return "-" + this.negate().toString(b);
	        }
	        var k;
	        if (b == 16) {
	            k = 4;
	        }
	        else if (b == 8) {
	            k = 3;
	        }
	        else if (b == 2) {
	            k = 1;
	        }
	        else if (b == 32) {
	            k = 5;
	        }
	        else if (b == 4) {
	            k = 2;
	        }
	        else {
	            return this.toRadix(b);
	        }
	        var km = (1 << k) - 1;
	        var d;
	        var m = false;
	        var r = "";
	        var i = this.t;
	        var p = this.DB - (i * this.DB) % k;
	        if (i-- > 0) {
	            if (p < this.DB && (d = this[i] >> p) > 0) {
	                m = true;
	                r = int2char(d);
	            }
	            while (i >= 0) {
	                if (p < k) {
	                    d = (this[i] & ((1 << p) - 1)) << (k - p);
	                    d |= this[--i] >> (p += this.DB - k);
	                }
	                else {
	                    d = (this[i] >> (p -= k)) & km;
	                    if (p <= 0) {
	                        p += this.DB;
	                        --i;
	                    }
	                }
	                if (d > 0) {
	                    m = true;
	                }
	                if (m) {
	                    r += int2char(d);
	                }
	            }
	        }
	        return m ? r : "0";
	    };
	    // BigInteger.prototype.negate = bnNegate;
	    // (public) -this
	    BigInteger.prototype.negate = function () {
	        var r = nbi();
	        BigInteger.ZERO.subTo(this, r);
	        return r;
	    };
	    // BigInteger.prototype.abs = bnAbs;
	    // (public) |this|
	    BigInteger.prototype.abs = function () {
	        return (this.s < 0) ? this.negate() : this;
	    };
	    // BigInteger.prototype.compareTo = bnCompareTo;
	    // (public) return + if this > a, - if this < a, 0 if equal
	    BigInteger.prototype.compareTo = function (a) {
	        var r = this.s - a.s;
	        if (r != 0) {
	            return r;
	        }
	        var i = this.t;
	        r = i - a.t;
	        if (r != 0) {
	            return (this.s < 0) ? -r : r;
	        }
	        while (--i >= 0) {
	            if ((r = this[i] - a[i]) != 0) {
	                return r;
	            }
	        }
	        return 0;
	    };
	    // BigInteger.prototype.bitLength = bnBitLength;
	    // (public) return the number of bits in "this"
	    BigInteger.prototype.bitLength = function () {
	        if (this.t <= 0) {
	            return 0;
	        }
	        return this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ (this.s & this.DM));
	    };
	    // BigInteger.prototype.mod = bnMod;
	    // (public) this mod a
	    BigInteger.prototype.mod = function (a) {
	        var r = nbi();
	        this.abs().divRemTo(a, null, r);
	        if (this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) {
	            a.subTo(r, r);
	        }
	        return r;
	    };
	    // BigInteger.prototype.modPowInt = bnModPowInt;
	    // (public) this^e % m, 0 <= e < 2^32
	    BigInteger.prototype.modPowInt = function (e, m) {
	        var z;
	        if (e < 256 || m.isEven()) {
	            z = new Classic(m);
	        }
	        else {
	            z = new Montgomery(m);
	        }
	        return this.exp(e, z);
	    };
	    // BigInteger.prototype.clone = bnClone;
	    // (public)
	    BigInteger.prototype.clone = function () {
	        var r = nbi();
	        this.copyTo(r);
	        return r;
	    };
	    // BigInteger.prototype.intValue = bnIntValue;
	    // (public) return value as integer
	    BigInteger.prototype.intValue = function () {
	        if (this.s < 0) {
	            if (this.t == 1) {
	                return this[0] - this.DV;
	            }
	            else if (this.t == 0) {
	                return -1;
	            }
	        }
	        else if (this.t == 1) {
	            return this[0];
	        }
	        else if (this.t == 0) {
	            return 0;
	        }
	        // assumes 16 < DB < 32
	        return ((this[1] & ((1 << (32 - this.DB)) - 1)) << this.DB) | this[0];
	    };
	    // BigInteger.prototype.byteValue = bnByteValue;
	    // (public) return value as byte
	    BigInteger.prototype.byteValue = function () {
	        return (this.t == 0) ? this.s : (this[0] << 24) >> 24;
	    };
	    // BigInteger.prototype.shortValue = bnShortValue;
	    // (public) return value as short (assumes DB>=16)
	    BigInteger.prototype.shortValue = function () {
	        return (this.t == 0) ? this.s : (this[0] << 16) >> 16;
	    };
	    // BigInteger.prototype.signum = bnSigNum;
	    // (public) 0 if this == 0, 1 if this > 0
	    BigInteger.prototype.signum = function () {
	        if (this.s < 0) {
	            return -1;
	        }
	        else if (this.t <= 0 || (this.t == 1 && this[0] <= 0)) {
	            return 0;
	        }
	        else {
	            return 1;
	        }
	    };
	    // BigInteger.prototype.toByteArray = bnToByteArray;
	    // (public) convert to bigendian byte array
	    BigInteger.prototype.toByteArray = function () {
	        var i = this.t;
	        var r = [];
	        r[0] = this.s;
	        var p = this.DB - (i * this.DB) % 8;
	        var d;
	        var k = 0;
	        if (i-- > 0) {
	            if (p < this.DB && (d = this[i] >> p) != (this.s & this.DM) >> p) {
	                r[k++] = d | (this.s << (this.DB - p));
	            }
	            while (i >= 0) {
	                if (p < 8) {
	                    d = (this[i] & ((1 << p) - 1)) << (8 - p);
	                    d |= this[--i] >> (p += this.DB - 8);
	                }
	                else {
	                    d = (this[i] >> (p -= 8)) & 0xff;
	                    if (p <= 0) {
	                        p += this.DB;
	                        --i;
	                    }
	                }
	                if ((d & 0x80) != 0) {
	                    d |= -256;
	                }
	                if (k == 0 && (this.s & 0x80) != (d & 0x80)) {
	                    ++k;
	                }
	                if (k > 0 || d != this.s) {
	                    r[k++] = d;
	                }
	            }
	        }
	        return r;
	    };
	    // BigInteger.prototype.equals = bnEquals;
	    BigInteger.prototype.equals = function (a) {
	        return (this.compareTo(a) == 0);
	    };
	    // BigInteger.prototype.min = bnMin;
	    BigInteger.prototype.min = function (a) {
	        return (this.compareTo(a) < 0) ? this : a;
	    };
	    // BigInteger.prototype.max = bnMax;
	    BigInteger.prototype.max = function (a) {
	        return (this.compareTo(a) > 0) ? this : a;
	    };
	    // BigInteger.prototype.and = bnAnd;
	    BigInteger.prototype.and = function (a) {
	        var r = nbi();
	        this.bitwiseTo(a, op_and, r);
	        return r;
	    };
	    // BigInteger.prototype.or = bnOr;
	    BigInteger.prototype.or = function (a) {
	        var r = nbi();
	        this.bitwiseTo(a, op_or, r);
	        return r;
	    };
	    // BigInteger.prototype.xor = bnXor;
	    BigInteger.prototype.xor = function (a) {
	        var r = nbi();
	        this.bitwiseTo(a, op_xor, r);
	        return r;
	    };
	    // BigInteger.prototype.andNot = bnAndNot;
	    BigInteger.prototype.andNot = function (a) {
	        var r = nbi();
	        this.bitwiseTo(a, op_andnot, r);
	        return r;
	    };
	    // BigInteger.prototype.not = bnNot;
	    // (public) ~this
	    BigInteger.prototype.not = function () {
	        var r = nbi();
	        for (var i = 0; i < this.t; ++i) {
	            r[i] = this.DM & ~this[i];
	        }
	        r.t = this.t;
	        r.s = ~this.s;
	        return r;
	    };
	    // BigInteger.prototype.shiftLeft = bnShiftLeft;
	    // (public) this << n
	    BigInteger.prototype.shiftLeft = function (n) {
	        var r = nbi();
	        if (n < 0) {
	            this.rShiftTo(-n, r);
	        }
	        else {
	            this.lShiftTo(n, r);
	        }
	        return r;
	    };
	    // BigInteger.prototype.shiftRight = bnShiftRight;
	    // (public) this >> n
	    BigInteger.prototype.shiftRight = function (n) {
	        var r = nbi();
	        if (n < 0) {
	            this.lShiftTo(-n, r);
	        }
	        else {
	            this.rShiftTo(n, r);
	        }
	        return r;
	    };
	    // BigInteger.prototype.getLowestSetBit = bnGetLowestSetBit;
	    // (public) returns index of lowest 1-bit (or -1 if none)
	    BigInteger.prototype.getLowestSetBit = function () {
	        for (var i = 0; i < this.t; ++i) {
	            if (this[i] != 0) {
	                return i * this.DB + lbit(this[i]);
	            }
	        }
	        if (this.s < 0) {
	            return this.t * this.DB;
	        }
	        return -1;
	    };
	    // BigInteger.prototype.bitCount = bnBitCount;
	    // (public) return number of set bits
	    BigInteger.prototype.bitCount = function () {
	        var r = 0;
	        var x = this.s & this.DM;
	        for (var i = 0; i < this.t; ++i) {
	            r += cbit(this[i] ^ x);
	        }
	        return r;
	    };
	    // BigInteger.prototype.testBit = bnTestBit;
	    // (public) true iff nth bit is set
	    BigInteger.prototype.testBit = function (n) {
	        var j = Math.floor(n / this.DB);
	        if (j >= this.t) {
	            return (this.s != 0);
	        }
	        return ((this[j] & (1 << (n % this.DB))) != 0);
	    };
	    // BigInteger.prototype.setBit = bnSetBit;
	    // (public) this | (1<<n)
	    BigInteger.prototype.setBit = function (n) {
	        return this.changeBit(n, op_or);
	    };
	    // BigInteger.prototype.clearBit = bnClearBit;
	    // (public) this & ~(1<<n)
	    BigInteger.prototype.clearBit = function (n) {
	        return this.changeBit(n, op_andnot);
	    };
	    // BigInteger.prototype.flipBit = bnFlipBit;
	    // (public) this ^ (1<<n)
	    BigInteger.prototype.flipBit = function (n) {
	        return this.changeBit(n, op_xor);
	    };
	    // BigInteger.prototype.add = bnAdd;
	    // (public) this + a
	    BigInteger.prototype.add = function (a) {
	        var r = nbi();
	        this.addTo(a, r);
	        return r;
	    };
	    // BigInteger.prototype.subtract = bnSubtract;
	    // (public) this - a
	    BigInteger.prototype.subtract = function (a) {
	        var r = nbi();
	        this.subTo(a, r);
	        return r;
	    };
	    // BigInteger.prototype.multiply = bnMultiply;
	    // (public) this * a
	    BigInteger.prototype.multiply = function (a) {
	        var r = nbi();
	        this.multiplyTo(a, r);
	        return r;
	    };
	    // BigInteger.prototype.divide = bnDivide;
	    // (public) this / a
	    BigInteger.prototype.divide = function (a) {
	        var r = nbi();
	        this.divRemTo(a, r, null);
	        return r;
	    };
	    // BigInteger.prototype.remainder = bnRemainder;
	    // (public) this % a
	    BigInteger.prototype.remainder = function (a) {
	        var r = nbi();
	        this.divRemTo(a, null, r);
	        return r;
	    };
	    // BigInteger.prototype.divideAndRemainder = bnDivideAndRemainder;
	    // (public) [this/a,this%a]
	    BigInteger.prototype.divideAndRemainder = function (a) {
	        var q = nbi();
	        var r = nbi();
	        this.divRemTo(a, q, r);
	        return [q, r];
	    };
	    // BigInteger.prototype.modPow = bnModPow;
	    // (public) this^e % m (HAC 14.85)
	    BigInteger.prototype.modPow = function (e, m) {
	        var i = e.bitLength();
	        var k;
	        var r = nbv(1);
	        var z;
	        if (i <= 0) {
	            return r;
	        }
	        else if (i < 18) {
	            k = 1;
	        }
	        else if (i < 48) {
	            k = 3;
	        }
	        else if (i < 144) {
	            k = 4;
	        }
	        else if (i < 768) {
	            k = 5;
	        }
	        else {
	            k = 6;
	        }
	        if (i < 8) {
	            z = new Classic(m);
	        }
	        else if (m.isEven()) {
	            z = new Barrett(m);
	        }
	        else {
	            z = new Montgomery(m);
	        }
	        // precomputation
	        var g = [];
	        var n = 3;
	        var k1 = k - 1;
	        var km = (1 << k) - 1;
	        g[1] = z.convert(this);
	        if (k > 1) {
	            var g2 = nbi();
	            z.sqrTo(g[1], g2);
	            while (n <= km) {
	                g[n] = nbi();
	                z.mulTo(g2, g[n - 2], g[n]);
	                n += 2;
	            }
	        }
	        var j = e.t - 1;
	        var w;
	        var is1 = true;
	        var r2 = nbi();
	        var t;
	        i = nbits(e[j]) - 1;
	        while (j >= 0) {
	            if (i >= k1) {
	                w = (e[j] >> (i - k1)) & km;
	            }
	            else {
	                w = (e[j] & ((1 << (i + 1)) - 1)) << (k1 - i);
	                if (j > 0) {
	                    w |= e[j - 1] >> (this.DB + i - k1);
	                }
	            }
	            n = k;
	            while ((w & 1) == 0) {
	                w >>= 1;
	                --n;
	            }
	            if ((i -= n) < 0) {
	                i += this.DB;
	                --j;
	            }
	            if (is1) { // ret == 1, don't bother squaring or multiplying it
	                g[w].copyTo(r);
	                is1 = false;
	            }
	            else {
	                while (n > 1) {
	                    z.sqrTo(r, r2);
	                    z.sqrTo(r2, r);
	                    n -= 2;
	                }
	                if (n > 0) {
	                    z.sqrTo(r, r2);
	                }
	                else {
	                    t = r;
	                    r = r2;
	                    r2 = t;
	                }
	                z.mulTo(r2, g[w], r);
	            }
	            while (j >= 0 && (e[j] & (1 << i)) == 0) {
	                z.sqrTo(r, r2);
	                t = r;
	                r = r2;
	                r2 = t;
	                if (--i < 0) {
	                    i = this.DB - 1;
	                    --j;
	                }
	            }
	        }
	        return z.revert(r);
	    };
	    // BigInteger.prototype.modInverse = bnModInverse;
	    // (public) 1/this % m (HAC 14.61)
	    BigInteger.prototype.modInverse = function (m) {
	        var ac = m.isEven();
	        if ((this.isEven() && ac) || m.signum() == 0) {
	            return BigInteger.ZERO;
	        }
	        var u = m.clone();
	        var v = this.clone();
	        var a = nbv(1);
	        var b = nbv(0);
	        var c = nbv(0);
	        var d = nbv(1);
	        while (u.signum() != 0) {
	            while (u.isEven()) {
	                u.rShiftTo(1, u);
	                if (ac) {
	                    if (!a.isEven() || !b.isEven()) {
	                        a.addTo(this, a);
	                        b.subTo(m, b);
	                    }
	                    a.rShiftTo(1, a);
	                }
	                else if (!b.isEven()) {
	                    b.subTo(m, b);
	                }
	                b.rShiftTo(1, b);
	            }
	            while (v.isEven()) {
	                v.rShiftTo(1, v);
	                if (ac) {
	                    if (!c.isEven() || !d.isEven()) {
	                        c.addTo(this, c);
	                        d.subTo(m, d);
	                    }
	                    c.rShiftTo(1, c);
	                }
	                else if (!d.isEven()) {
	                    d.subTo(m, d);
	                }
	                d.rShiftTo(1, d);
	            }
	            if (u.compareTo(v) >= 0) {
	                u.subTo(v, u);
	                if (ac) {
	                    a.subTo(c, a);
	                }
	                b.subTo(d, b);
	            }
	            else {
	                v.subTo(u, v);
	                if (ac) {
	                    c.subTo(a, c);
	                }
	                d.subTo(b, d);
	            }
	        }
	        if (v.compareTo(BigInteger.ONE) != 0) {
	            return BigInteger.ZERO;
	        }
	        if (d.compareTo(m) >= 0) {
	            return d.subtract(m);
	        }
	        if (d.signum() < 0) {
	            d.addTo(m, d);
	        }
	        else {
	            return d;
	        }
	        if (d.signum() < 0) {
	            return d.add(m);
	        }
	        else {
	            return d;
	        }
	    };
	    // BigInteger.prototype.pow = bnPow;
	    // (public) this^e
	    BigInteger.prototype.pow = function (e) {
	        return this.exp(e, new NullExp());
	    };
	    // BigInteger.prototype.gcd = bnGCD;
	    // (public) gcd(this,a) (HAC 14.54)
	    BigInteger.prototype.gcd = function (a) {
	        var x = (this.s < 0) ? this.negate() : this.clone();
	        var y = (a.s < 0) ? a.negate() : a.clone();
	        if (x.compareTo(y) < 0) {
	            var t = x;
	            x = y;
	            y = t;
	        }
	        var i = x.getLowestSetBit();
	        var g = y.getLowestSetBit();
	        if (g < 0) {
	            return x;
	        }
	        if (i < g) {
	            g = i;
	        }
	        if (g > 0) {
	            x.rShiftTo(g, x);
	            y.rShiftTo(g, y);
	        }
	        while (x.signum() > 0) {
	            if ((i = x.getLowestSetBit()) > 0) {
	                x.rShiftTo(i, x);
	            }
	            if ((i = y.getLowestSetBit()) > 0) {
	                y.rShiftTo(i, y);
	            }
	            if (x.compareTo(y) >= 0) {
	                x.subTo(y, x);
	                x.rShiftTo(1, x);
	            }
	            else {
	                y.subTo(x, y);
	                y.rShiftTo(1, y);
	            }
	        }
	        if (g > 0) {
	            y.lShiftTo(g, y);
	        }
	        return y;
	    };
	    // BigInteger.prototype.isProbablePrime = bnIsProbablePrime;
	    // (public) test primality with certainty >= 1-.5^t
	    BigInteger.prototype.isProbablePrime = function (t) {
	        var i;
	        var x = this.abs();
	        if (x.t == 1 && x[0] <= lowprimes[lowprimes.length - 1]) {
	            for (i = 0; i < lowprimes.length; ++i) {
	                if (x[0] == lowprimes[i]) {
	                    return true;
	                }
	            }
	            return false;
	        }
	        if (x.isEven()) {
	            return false;
	        }
	        i = 1;
	        while (i < lowprimes.length) {
	            var m = lowprimes[i];
	            var j = i + 1;
	            while (j < lowprimes.length && m < lplim) {
	                m *= lowprimes[j++];
	            }
	            m = x.modInt(m);
	            while (i < j) {
	                if (m % lowprimes[i++] == 0) {
	                    return false;
	                }
	            }
	        }
	        return x.millerRabin(t);
	    };
	    //#endregion PUBLIC
	    //#region PROTECTED
	    // BigInteger.prototype.copyTo = bnpCopyTo;
	    // (protected) copy this to r
	    BigInteger.prototype.copyTo = function (r) {
	        for (var i = this.t - 1; i >= 0; --i) {
	            r[i] = this[i];
	        }
	        r.t = this.t;
	        r.s = this.s;
	    };
	    // BigInteger.prototype.fromInt = bnpFromInt;
	    // (protected) set from integer value x, -DV <= x < DV
	    BigInteger.prototype.fromInt = function (x) {
	        this.t = 1;
	        this.s = (x < 0) ? -1 : 0;
	        if (x > 0) {
	            this[0] = x;
	        }
	        else if (x < -1) {
	            this[0] = x + this.DV;
	        }
	        else {
	            this.t = 0;
	        }
	    };
	    // BigInteger.prototype.fromString = bnpFromString;
	    // (protected) set from string and radix
	    BigInteger.prototype.fromString = function (s, b) {
	        var k;
	        if (b == 16) {
	            k = 4;
	        }
	        else if (b == 8) {
	            k = 3;
	        }
	        else if (b == 256) {
	            k = 8;
	            /* byte array */
	        }
	        else if (b == 2) {
	            k = 1;
	        }
	        else if (b == 32) {
	            k = 5;
	        }
	        else if (b == 4) {
	            k = 2;
	        }
	        else {
	            this.fromRadix(s, b);
	            return;
	        }
	        this.t = 0;
	        this.s = 0;
	        var i = s.length;
	        var mi = false;
	        var sh = 0;
	        while (--i >= 0) {
	            var x = (k == 8) ? (+s[i]) & 0xff : intAt(s, i);
	            if (x < 0) {
	                if (s.charAt(i) == "-") {
	                    mi = true;
	                }
	                continue;
	            }
	            mi = false;
	            if (sh == 0) {
	                this[this.t++] = x;
	            }
	            else if (sh + k > this.DB) {
	                this[this.t - 1] |= (x & ((1 << (this.DB - sh)) - 1)) << sh;
	                this[this.t++] = (x >> (this.DB - sh));
	            }
	            else {
	                this[this.t - 1] |= x << sh;
	            }
	            sh += k;
	            if (sh >= this.DB) {
	                sh -= this.DB;
	            }
	        }
	        if (k == 8 && ((+s[0]) & 0x80) != 0) {
	            this.s = -1;
	            if (sh > 0) {
	                this[this.t - 1] |= ((1 << (this.DB - sh)) - 1) << sh;
	            }
	        }
	        this.clamp();
	        if (mi) {
	            BigInteger.ZERO.subTo(this, this);
	        }
	    };
	    // BigInteger.prototype.clamp = bnpClamp;
	    // (protected) clamp off excess high words
	    BigInteger.prototype.clamp = function () {
	        var c = this.s & this.DM;
	        while (this.t > 0 && this[this.t - 1] == c) {
	            --this.t;
	        }
	    };
	    // BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
	    // (protected) r = this << n*DB
	    BigInteger.prototype.dlShiftTo = function (n, r) {
	        var i;
	        for (i = this.t - 1; i >= 0; --i) {
	            r[i + n] = this[i];
	        }
	        for (i = n - 1; i >= 0; --i) {
	            r[i] = 0;
	        }
	        r.t = this.t + n;
	        r.s = this.s;
	    };
	    // BigInteger.prototype.drShiftTo = bnpDRShiftTo;
	    // (protected) r = this >> n*DB
	    BigInteger.prototype.drShiftTo = function (n, r) {
	        for (var i = n; i < this.t; ++i) {
	            r[i - n] = this[i];
	        }
	        r.t = Math.max(this.t - n, 0);
	        r.s = this.s;
	    };
	    // BigInteger.prototype.lShiftTo = bnpLShiftTo;
	    // (protected) r = this << n
	    BigInteger.prototype.lShiftTo = function (n, r) {
	        var bs = n % this.DB;
	        var cbs = this.DB - bs;
	        var bm = (1 << cbs) - 1;
	        var ds = Math.floor(n / this.DB);
	        var c = (this.s << bs) & this.DM;
	        for (var i = this.t - 1; i >= 0; --i) {
	            r[i + ds + 1] = (this[i] >> cbs) | c;
	            c = (this[i] & bm) << bs;
	        }
	        for (var i = ds - 1; i >= 0; --i) {
	            r[i] = 0;
	        }
	        r[ds] = c;
	        r.t = this.t + ds + 1;
	        r.s = this.s;
	        r.clamp();
	    };
	    // BigInteger.prototype.rShiftTo = bnpRShiftTo;
	    // (protected) r = this >> n
	    BigInteger.prototype.rShiftTo = function (n, r) {
	        r.s = this.s;
	        var ds = Math.floor(n / this.DB);
	        if (ds >= this.t) {
	            r.t = 0;
	            return;
	        }
	        var bs = n % this.DB;
	        var cbs = this.DB - bs;
	        var bm = (1 << bs) - 1;
	        r[0] = this[ds] >> bs;
	        for (var i = ds + 1; i < this.t; ++i) {
	            r[i - ds - 1] |= (this[i] & bm) << cbs;
	            r[i - ds] = this[i] >> bs;
	        }
	        if (bs > 0) {
	            r[this.t - ds - 1] |= (this.s & bm) << cbs;
	        }
	        r.t = this.t - ds;
	        r.clamp();
	    };
	    // BigInteger.prototype.subTo = bnpSubTo;
	    // (protected) r = this - a
	    BigInteger.prototype.subTo = function (a, r) {
	        var i = 0;
	        var c = 0;
	        var m = Math.min(a.t, this.t);
	        while (i < m) {
	            c += this[i] - a[i];
	            r[i++] = c & this.DM;
	            c >>= this.DB;
	        }
	        if (a.t < this.t) {
	            c -= a.s;
	            while (i < this.t) {
	                c += this[i];
	                r[i++] = c & this.DM;
	                c >>= this.DB;
	            }
	            c += this.s;
	        }
	        else {
	            c += this.s;
	            while (i < a.t) {
	                c -= a[i];
	                r[i++] = c & this.DM;
	                c >>= this.DB;
	            }
	            c -= a.s;
	        }
	        r.s = (c < 0) ? -1 : 0;
	        if (c < -1) {
	            r[i++] = this.DV + c;
	        }
	        else if (c > 0) {
	            r[i++] = c;
	        }
	        r.t = i;
	        r.clamp();
	    };
	    // BigInteger.prototype.multiplyTo = bnpMultiplyTo;
	    // (protected) r = this * a, r != this,a (HAC 14.12)
	    // "this" should be the larger one if appropriate.
	    BigInteger.prototype.multiplyTo = function (a, r) {
	        var x = this.abs();
	        var y = a.abs();
	        var i = x.t;
	        r.t = i + y.t;
	        while (--i >= 0) {
	            r[i] = 0;
	        }
	        for (i = 0; i < y.t; ++i) {
	            r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
	        }
	        r.s = 0;
	        r.clamp();
	        if (this.s != a.s) {
	            BigInteger.ZERO.subTo(r, r);
	        }
	    };
	    // BigInteger.prototype.squareTo = bnpSquareTo;
	    // (protected) r = this^2, r != this (HAC 14.16)
	    BigInteger.prototype.squareTo = function (r) {
	        var x = this.abs();
	        var i = r.t = 2 * x.t;
	        while (--i >= 0) {
	            r[i] = 0;
	        }
	        for (i = 0; i < x.t - 1; ++i) {
	            var c = x.am(i, x[i], r, 2 * i, 0, 1);
	            if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
	                r[i + x.t] -= x.DV;
	                r[i + x.t + 1] = 1;
	            }
	        }
	        if (r.t > 0) {
	            r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
	        }
	        r.s = 0;
	        r.clamp();
	    };
	    // BigInteger.prototype.divRemTo = bnpDivRemTo;
	    // (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
	    // r != q, this != m.  q or r may be null.
	    BigInteger.prototype.divRemTo = function (m, q, r) {
	        var pm = m.abs();
	        if (pm.t <= 0) {
	            return;
	        }
	        var pt = this.abs();
	        if (pt.t < pm.t) {
	            if (q != null) {
	                q.fromInt(0);
	            }
	            if (r != null) {
	                this.copyTo(r);
	            }
	            return;
	        }
	        if (r == null) {
	            r = nbi();
	        }
	        var y = nbi();
	        var ts = this.s;
	        var ms = m.s;
	        var nsh = this.DB - nbits(pm[pm.t - 1]); // normalize modulus
	        if (nsh > 0) {
	            pm.lShiftTo(nsh, y);
	            pt.lShiftTo(nsh, r);
	        }
	        else {
	            pm.copyTo(y);
	            pt.copyTo(r);
	        }
	        var ys = y.t;
	        var y0 = y[ys - 1];
	        if (y0 == 0) {
	            return;
	        }
	        var yt = y0 * (1 << this.F1) + ((ys > 1) ? y[ys - 2] >> this.F2 : 0);
	        var d1 = this.FV / yt;
	        var d2 = (1 << this.F1) / yt;
	        var e = 1 << this.F2;
	        var i = r.t;
	        var j = i - ys;
	        var t = (q == null) ? nbi() : q;
	        y.dlShiftTo(j, t);
	        if (r.compareTo(t) >= 0) {
	            r[r.t++] = 1;
	            r.subTo(t, r);
	        }
	        BigInteger.ONE.dlShiftTo(ys, t);
	        t.subTo(y, y); // "negative" y so we can replace sub with am later
	        while (y.t < ys) {
	            y[y.t++] = 0;
	        }
	        while (--j >= 0) {
	            // Estimate quotient digit
	            var qd = (r[--i] == y0) ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
	            if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) { // Try it out
	                y.dlShiftTo(j, t);
	                r.subTo(t, r);
	                while (r[i] < --qd) {
	                    r.subTo(t, r);
	                }
	            }
	        }
	        if (q != null) {
	            r.drShiftTo(ys, q);
	            if (ts != ms) {
	                BigInteger.ZERO.subTo(q, q);
	            }
	        }
	        r.t = ys;
	        r.clamp();
	        if (nsh > 0) {
	            r.rShiftTo(nsh, r);
	        } // Denormalize remainder
	        if (ts < 0) {
	            BigInteger.ZERO.subTo(r, r);
	        }
	    };
	    // BigInteger.prototype.invDigit = bnpInvDigit;
	    // (protected) return "-1/this % 2^DB"; useful for Mont. reduction
	    // justification:
	    //         xy == 1 (mod m)
	    //         xy =  1+km
	    //   xy(2-xy) = (1+km)(1-km)
	    // x[y(2-xy)] = 1-k^2m^2
	    // x[y(2-xy)] == 1 (mod m^2)
	    // if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
	    // should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
	    // JS multiply "overflows" differently from C/C++, so care is needed here.
	    BigInteger.prototype.invDigit = function () {
	        if (this.t < 1) {
	            return 0;
	        }
	        var x = this[0];
	        if ((x & 1) == 0) {
	            return 0;
	        }
	        var y = x & 3; // y == 1/x mod 2^2
	        y = (y * (2 - (x & 0xf) * y)) & 0xf; // y == 1/x mod 2^4
	        y = (y * (2 - (x & 0xff) * y)) & 0xff; // y == 1/x mod 2^8
	        y = (y * (2 - (((x & 0xffff) * y) & 0xffff))) & 0xffff; // y == 1/x mod 2^16
	        // last step - calculate inverse mod DV directly;
	        // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
	        y = (y * (2 - x * y % this.DV)) % this.DV; // y == 1/x mod 2^dbits
	        // we really want the negative inverse, and -DV < y < DV
	        return (y > 0) ? this.DV - y : -y;
	    };
	    // BigInteger.prototype.isEven = bnpIsEven;
	    // (protected) true iff this is even
	    BigInteger.prototype.isEven = function () {
	        return ((this.t > 0) ? (this[0] & 1) : this.s) == 0;
	    };
	    // BigInteger.prototype.exp = bnpExp;
	    // (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)
	    BigInteger.prototype.exp = function (e, z) {
	        if (e > 0xffffffff || e < 1) {
	            return BigInteger.ONE;
	        }
	        var r = nbi();
	        var r2 = nbi();
	        var g = z.convert(this);
	        var i = nbits(e) - 1;
	        g.copyTo(r);
	        while (--i >= 0) {
	            z.sqrTo(r, r2);
	            if ((e & (1 << i)) > 0) {
	                z.mulTo(r2, g, r);
	            }
	            else {
	                var t = r;
	                r = r2;
	                r2 = t;
	            }
	        }
	        return z.revert(r);
	    };
	    // BigInteger.prototype.chunkSize = bnpChunkSize;
	    // (protected) return x s.t. r^x < DV
	    BigInteger.prototype.chunkSize = function (r) {
	        return Math.floor(Math.LN2 * this.DB / Math.log(r));
	    };
	    // BigInteger.prototype.toRadix = bnpToRadix;
	    // (protected) convert to radix string
	    BigInteger.prototype.toRadix = function (b) {
	        if (b == null) {
	            b = 10;
	        }
	        if (this.signum() == 0 || b < 2 || b > 36) {
	            return "0";
	        }
	        var cs = this.chunkSize(b);
	        var a = Math.pow(b, cs);
	        var d = nbv(a);
	        var y = nbi();
	        var z = nbi();
	        var r = "";
	        this.divRemTo(d, y, z);
	        while (y.signum() > 0) {
	            r = (a + z.intValue()).toString(b).substr(1) + r;
	            y.divRemTo(d, y, z);
	        }
	        return z.intValue().toString(b) + r;
	    };
	    // BigInteger.prototype.fromRadix = bnpFromRadix;
	    // (protected) convert from radix string
	    BigInteger.prototype.fromRadix = function (s, b) {
	        this.fromInt(0);
	        if (b == null) {
	            b = 10;
	        }
	        var cs = this.chunkSize(b);
	        var d = Math.pow(b, cs);
	        var mi = false;
	        var j = 0;
	        var w = 0;
	        for (var i = 0; i < s.length; ++i) {
	            var x = intAt(s, i);
	            if (x < 0) {
	                if (s.charAt(i) == "-" && this.signum() == 0) {
	                    mi = true;
	                }
	                continue;
	            }
	            w = b * w + x;
	            if (++j >= cs) {
	                this.dMultiply(d);
	                this.dAddOffset(w, 0);
	                j = 0;
	                w = 0;
	            }
	        }
	        if (j > 0) {
	            this.dMultiply(Math.pow(b, j));
	            this.dAddOffset(w, 0);
	        }
	        if (mi) {
	            BigInteger.ZERO.subTo(this, this);
	        }
	    };
	    // BigInteger.prototype.fromNumber = bnpFromNumber;
	    // (protected) alternate constructor
	    BigInteger.prototype.fromNumber = function (a, b, c) {
	        if ("number" == typeof b) {
	            // new BigInteger(int,int,RNG)
	            if (a < 2) {
	                this.fromInt(1);
	            }
	            else {
	                this.fromNumber(a, c);
	                if (!this.testBit(a - 1)) {
	                    // force MSB set
	                    this.bitwiseTo(BigInteger.ONE.shiftLeft(a - 1), op_or, this);
	                }
	                if (this.isEven()) {
	                    this.dAddOffset(1, 0);
	                } // force odd
	                while (!this.isProbablePrime(b)) {
	                    this.dAddOffset(2, 0);
	                    if (this.bitLength() > a) {
	                        this.subTo(BigInteger.ONE.shiftLeft(a - 1), this);
	                    }
	                }
	            }
	        }
	        else {
	            // new BigInteger(int,RNG)
	            var x = [];
	            var t = a & 7;
	            x.length = (a >> 3) + 1;
	            b.nextBytes(x);
	            if (t > 0) {
	                x[0] &= ((1 << t) - 1);
	            }
	            else {
	                x[0] = 0;
	            }
	            this.fromString(x, 256);
	        }
	    };
	    // BigInteger.prototype.bitwiseTo = bnpBitwiseTo;
	    // (protected) r = this op a (bitwise)
	    BigInteger.prototype.bitwiseTo = function (a, op, r) {
	        var i;
	        var f;
	        var m = Math.min(a.t, this.t);
	        for (i = 0; i < m; ++i) {
	            r[i] = op(this[i], a[i]);
	        }
	        if (a.t < this.t) {
	            f = a.s & this.DM;
	            for (i = m; i < this.t; ++i) {
	                r[i] = op(this[i], f);
	            }
	            r.t = this.t;
	        }
	        else {
	            f = this.s & this.DM;
	            for (i = m; i < a.t; ++i) {
	                r[i] = op(f, a[i]);
	            }
	            r.t = a.t;
	        }
	        r.s = op(this.s, a.s);
	        r.clamp();
	    };
	    // BigInteger.prototype.changeBit = bnpChangeBit;
	    // (protected) this op (1<<n)
	    BigInteger.prototype.changeBit = function (n, op) {
	        var r = BigInteger.ONE.shiftLeft(n);
	        this.bitwiseTo(r, op, r);
	        return r;
	    };
	    // BigInteger.prototype.addTo = bnpAddTo;
	    // (protected) r = this + a
	    BigInteger.prototype.addTo = function (a, r) {
	        var i = 0;
	        var c = 0;
	        var m = Math.min(a.t, this.t);
	        while (i < m) {
	            c += this[i] + a[i];
	            r[i++] = c & this.DM;
	            c >>= this.DB;
	        }
	        if (a.t < this.t) {
	            c += a.s;
	            while (i < this.t) {
	                c += this[i];
	                r[i++] = c & this.DM;
	                c >>= this.DB;
	            }
	            c += this.s;
	        }
	        else {
	            c += this.s;
	            while (i < a.t) {
	                c += a[i];
	                r[i++] = c & this.DM;
	                c >>= this.DB;
	            }
	            c += a.s;
	        }
	        r.s = (c < 0) ? -1 : 0;
	        if (c > 0) {
	            r[i++] = c;
	        }
	        else if (c < -1) {
	            r[i++] = this.DV + c;
	        }
	        r.t = i;
	        r.clamp();
	    };
	    // BigInteger.prototype.dMultiply = bnpDMultiply;
	    // (protected) this *= n, this >= 0, 1 < n < DV
	    BigInteger.prototype.dMultiply = function (n) {
	        this[this.t] = this.am(0, n - 1, this, 0, 0, this.t);
	        ++this.t;
	        this.clamp();
	    };
	    // BigInteger.prototype.dAddOffset = bnpDAddOffset;
	    // (protected) this += n << w words, this >= 0
	    BigInteger.prototype.dAddOffset = function (n, w) {
	        if (n == 0) {
	            return;
	        }
	        while (this.t <= w) {
	            this[this.t++] = 0;
	        }
	        this[w] += n;
	        while (this[w] >= this.DV) {
	            this[w] -= this.DV;
	            if (++w >= this.t) {
	                this[this.t++] = 0;
	            }
	            ++this[w];
	        }
	    };
	    // BigInteger.prototype.multiplyLowerTo = bnpMultiplyLowerTo;
	    // (protected) r = lower n words of "this * a", a.t <= n
	    // "this" should be the larger one if appropriate.
	    BigInteger.prototype.multiplyLowerTo = function (a, n, r) {
	        var i = Math.min(this.t + a.t, n);
	        r.s = 0; // assumes a,this >= 0
	        r.t = i;
	        while (i > 0) {
	            r[--i] = 0;
	        }
	        for (var j = r.t - this.t; i < j; ++i) {
	            r[i + this.t] = this.am(0, a[i], r, i, 0, this.t);
	        }
	        for (var j = Math.min(a.t, n); i < j; ++i) {
	            this.am(0, a[i], r, i, 0, n - i);
	        }
	        r.clamp();
	    };
	    // BigInteger.prototype.multiplyUpperTo = bnpMultiplyUpperTo;
	    // (protected) r = "this * a" without lower n words, n > 0
	    // "this" should be the larger one if appropriate.
	    BigInteger.prototype.multiplyUpperTo = function (a, n, r) {
	        --n;
	        var i = r.t = this.t + a.t - n;
	        r.s = 0; // assumes a,this >= 0
	        while (--i >= 0) {
	            r[i] = 0;
	        }
	        for (i = Math.max(n - this.t, 0); i < a.t; ++i) {
	            r[this.t + i - n] = this.am(n - i, a[i], r, 0, 0, this.t + i - n);
	        }
	        r.clamp();
	        r.drShiftTo(1, r);
	    };
	    // BigInteger.prototype.modInt = bnpModInt;
	    // (protected) this % n, n < 2^26
	    BigInteger.prototype.modInt = function (n) {
	        if (n <= 0) {
	            return 0;
	        }
	        var d = this.DV % n;
	        var r = (this.s < 0) ? n - 1 : 0;
	        if (this.t > 0) {
	            if (d == 0) {
	                r = this[0] % n;
	            }
	            else {
	                for (var i = this.t - 1; i >= 0; --i) {
	                    r = (d * r + this[i]) % n;
	                }
	            }
	        }
	        return r;
	    };
	    // BigInteger.prototype.millerRabin = bnpMillerRabin;
	    // (protected) true if probably prime (HAC 4.24, Miller-Rabin)
	    BigInteger.prototype.millerRabin = function (t) {
	        var n1 = this.subtract(BigInteger.ONE);
	        var k = n1.getLowestSetBit();
	        if (k <= 0) {
	            return false;
	        }
	        var r = n1.shiftRight(k);
	        t = (t + 1) >> 1;
	        if (t > lowprimes.length) {
	            t = lowprimes.length;
	        }
	        var a = nbi();
	        for (var i = 0; i < t; ++i) {
	            // Pick bases at random, instead of starting at 2
	            a.fromInt(lowprimes[Math.floor(Math.random() * lowprimes.length)]);
	            var y = a.modPow(r, this);
	            if (y.compareTo(BigInteger.ONE) != 0 && y.compareTo(n1) != 0) {
	                var j = 1;
	                while (j++ < k && y.compareTo(n1) != 0) {
	                    y = y.modPowInt(2, this);
	                    if (y.compareTo(BigInteger.ONE) == 0) {
	                        return false;
	                    }
	                }
	                if (y.compareTo(n1) != 0) {
	                    return false;
	                }
	            }
	        }
	        return true;
	    };
	    // BigInteger.prototype.square = bnSquare;
	    // (public) this^2
	    BigInteger.prototype.square = function () {
	        var r = nbi();
	        this.squareTo(r);
	        return r;
	    };
	    //#region ASYNC
	    // Public API method
	    BigInteger.prototype.gcda = function (a, callback) {
	        var x = (this.s < 0) ? this.negate() : this.clone();
	        var y = (a.s < 0) ? a.negate() : a.clone();
	        if (x.compareTo(y) < 0) {
	            var t = x;
	            x = y;
	            y = t;
	        }
	        var i = x.getLowestSetBit();
	        var g = y.getLowestSetBit();
	        if (g < 0) {
	            callback(x);
	            return;
	        }
	        if (i < g) {
	            g = i;
	        }
	        if (g > 0) {
	            x.rShiftTo(g, x);
	            y.rShiftTo(g, y);
	        }
	        // Workhorse of the algorithm, gets called 200 - 800 times per 512 bit keygen.
	        var gcda1 = function () {
	            if ((i = x.getLowestSetBit()) > 0) {
	                x.rShiftTo(i, x);
	            }
	            if ((i = y.getLowestSetBit()) > 0) {
	                y.rShiftTo(i, y);
	            }
	            if (x.compareTo(y) >= 0) {
	                x.subTo(y, x);
	                x.rShiftTo(1, x);
	            }
	            else {
	                y.subTo(x, y);
	                y.rShiftTo(1, y);
	            }
	            if (!(x.signum() > 0)) {
	                if (g > 0) {
	                    y.lShiftTo(g, y);
	                }
	                setTimeout(function () { callback(y); }, 0); // escape
	            }
	            else {
	                setTimeout(gcda1, 0);
	            }
	        };
	        setTimeout(gcda1, 10);
	    };
	    // (protected) alternate constructor
	    BigInteger.prototype.fromNumberAsync = function (a, b, c, callback) {
	        if ("number" == typeof b) {
	            if (a < 2) {
	                this.fromInt(1);
	            }
	            else {
	                this.fromNumber(a, c);
	                if (!this.testBit(a - 1)) {
	                    this.bitwiseTo(BigInteger.ONE.shiftLeft(a - 1), op_or, this);
	                }
	                if (this.isEven()) {
	                    this.dAddOffset(1, 0);
	                }
	                var bnp_1 = this;
	                var bnpfn1_1 = function () {
	                    bnp_1.dAddOffset(2, 0);
	                    if (bnp_1.bitLength() > a) {
	                        bnp_1.subTo(BigInteger.ONE.shiftLeft(a - 1), bnp_1);
	                    }
	                    if (bnp_1.isProbablePrime(b)) {
	                        setTimeout(function () { callback(); }, 0); // escape
	                    }
	                    else {
	                        setTimeout(bnpfn1_1, 0);
	                    }
	                };
	                setTimeout(bnpfn1_1, 0);
	            }
	        }
	        else {
	            var x = [];
	            var t = a & 7;
	            x.length = (a >> 3) + 1;
	            b.nextBytes(x);
	            if (t > 0) {
	                x[0] &= ((1 << t) - 1);
	            }
	            else {
	                x[0] = 0;
	            }
	            this.fromString(x, 256);
	        }
	    };
	    return BigInteger;
	}());
	//#region REDUCERS
	//#region NullExp
	var NullExp = /** @class */ (function () {
	    function NullExp() {
	    }
	    // NullExp.prototype.convert = nNop;
	    NullExp.prototype.convert = function (x) {
	        return x;
	    };
	    // NullExp.prototype.revert = nNop;
	    NullExp.prototype.revert = function (x) {
	        return x;
	    };
	    // NullExp.prototype.mulTo = nMulTo;
	    NullExp.prototype.mulTo = function (x, y, r) {
	        x.multiplyTo(y, r);
	    };
	    // NullExp.prototype.sqrTo = nSqrTo;
	    NullExp.prototype.sqrTo = function (x, r) {
	        x.squareTo(r);
	    };
	    return NullExp;
	}());
	// Modular reduction using "classic" algorithm
	var Classic = /** @class */ (function () {
	    function Classic(m) {
	        this.m = m;
	    }
	    // Classic.prototype.convert = cConvert;
	    Classic.prototype.convert = function (x) {
	        if (x.s < 0 || x.compareTo(this.m) >= 0) {
	            return x.mod(this.m);
	        }
	        else {
	            return x;
	        }
	    };
	    // Classic.prototype.revert = cRevert;
	    Classic.prototype.revert = function (x) {
	        return x;
	    };
	    // Classic.prototype.reduce = cReduce;
	    Classic.prototype.reduce = function (x) {
	        x.divRemTo(this.m, null, x);
	    };
	    // Classic.prototype.mulTo = cMulTo;
	    Classic.prototype.mulTo = function (x, y, r) {
	        x.multiplyTo(y, r);
	        this.reduce(r);
	    };
	    // Classic.prototype.sqrTo = cSqrTo;
	    Classic.prototype.sqrTo = function (x, r) {
	        x.squareTo(r);
	        this.reduce(r);
	    };
	    return Classic;
	}());
	//#endregion
	//#region Montgomery
	// Montgomery reduction
	var Montgomery = /** @class */ (function () {
	    function Montgomery(m) {
	        this.m = m;
	        this.mp = m.invDigit();
	        this.mpl = this.mp & 0x7fff;
	        this.mph = this.mp >> 15;
	        this.um = (1 << (m.DB - 15)) - 1;
	        this.mt2 = 2 * m.t;
	    }
	    // Montgomery.prototype.convert = montConvert;
	    // xR mod m
	    Montgomery.prototype.convert = function (x) {
	        var r = nbi();
	        x.abs().dlShiftTo(this.m.t, r);
	        r.divRemTo(this.m, null, r);
	        if (x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) {
	            this.m.subTo(r, r);
	        }
	        return r;
	    };
	    // Montgomery.prototype.revert = montRevert;
	    // x/R mod m
	    Montgomery.prototype.revert = function (x) {
	        var r = nbi();
	        x.copyTo(r);
	        this.reduce(r);
	        return r;
	    };
	    // Montgomery.prototype.reduce = montReduce;
	    // x = x/R mod m (HAC 14.32)
	    Montgomery.prototype.reduce = function (x) {
	        while (x.t <= this.mt2) {
	            // pad x so am has enough room later
	            x[x.t++] = 0;
	        }
	        for (var i = 0; i < this.m.t; ++i) {
	            // faster way of calculating u0 = x[i]*mp mod DV
	            var j = x[i] & 0x7fff;
	            var u0 = (j * this.mpl + (((j * this.mph + (x[i] >> 15) * this.mpl) & this.um) << 15)) & x.DM;
	            // use am to combine the multiply-shift-add into one call
	            j = i + this.m.t;
	            x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
	            // propagate carry
	            while (x[j] >= x.DV) {
	                x[j] -= x.DV;
	                x[++j]++;
	            }
	        }
	        x.clamp();
	        x.drShiftTo(this.m.t, x);
	        if (x.compareTo(this.m) >= 0) {
	            x.subTo(this.m, x);
	        }
	    };
	    // Montgomery.prototype.mulTo = montMulTo;
	    // r = "xy/R mod m"; x,y != r
	    Montgomery.prototype.mulTo = function (x, y, r) {
	        x.multiplyTo(y, r);
	        this.reduce(r);
	    };
	    // Montgomery.prototype.sqrTo = montSqrTo;
	    // r = "x^2/R mod m"; x != r
	    Montgomery.prototype.sqrTo = function (x, r) {
	        x.squareTo(r);
	        this.reduce(r);
	    };
	    return Montgomery;
	}());
	//#endregion Montgomery
	//#region Barrett
	// Barrett modular reduction
	var Barrett = /** @class */ (function () {
	    function Barrett(m) {
	        this.m = m;
	        // setup Barrett
	        this.r2 = nbi();
	        this.q3 = nbi();
	        BigInteger.ONE.dlShiftTo(2 * m.t, this.r2);
	        this.mu = this.r2.divide(m);
	    }
	    // Barrett.prototype.convert = barrettConvert;
	    Barrett.prototype.convert = function (x) {
	        if (x.s < 0 || x.t > 2 * this.m.t) {
	            return x.mod(this.m);
	        }
	        else if (x.compareTo(this.m) < 0) {
	            return x;
	        }
	        else {
	            var r = nbi();
	            x.copyTo(r);
	            this.reduce(r);
	            return r;
	        }
	    };
	    // Barrett.prototype.revert = barrettRevert;
	    Barrett.prototype.revert = function (x) {
	        return x;
	    };
	    // Barrett.prototype.reduce = barrettReduce;
	    // x = x mod m (HAC 14.42)
	    Barrett.prototype.reduce = function (x) {
	        x.drShiftTo(this.m.t - 1, this.r2);
	        if (x.t > this.m.t + 1) {
	            x.t = this.m.t + 1;
	            x.clamp();
	        }
	        this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3);
	        this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2);
	        while (x.compareTo(this.r2) < 0) {
	            x.dAddOffset(1, this.m.t + 1);
	        }
	        x.subTo(this.r2, x);
	        while (x.compareTo(this.m) >= 0) {
	            x.subTo(this.m, x);
	        }
	    };
	    // Barrett.prototype.mulTo = barrettMulTo;
	    // r = x*y mod m; x,y != r
	    Barrett.prototype.mulTo = function (x, y, r) {
	        x.multiplyTo(y, r);
	        this.reduce(r);
	    };
	    // Barrett.prototype.sqrTo = barrettSqrTo;
	    // r = x^2 mod m; x != r
	    Barrett.prototype.sqrTo = function (x, r) {
	        x.squareTo(r);
	        this.reduce(r);
	    };
	    return Barrett;
	}());
	//#endregion
	//#endregion REDUCERS
	// return new, unset BigInteger
	function nbi() { return new BigInteger(null); }
	function parseBigInt(str, r) {
	    return new BigInteger(str, r);
	}
	// am: Compute w_j += (x*this_i), propagate carries,
	// c is initial carry, returns final carry.
	// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
	// We need to select the fastest one that works in this environment.
	// am1: use a single mult and divide to get the high bits,
	// max digit bits should be 26 because
	// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
	function am1(i, x, w, j, c, n) {
	    while (--n >= 0) {
	        var v = x * this[i++] + w[j] + c;
	        c = Math.floor(v / 0x4000000);
	        w[j++] = v & 0x3ffffff;
	    }
	    return c;
	}
	// am2 avoids a big mult-and-extract completely.
	// Max digit bits should be <= 30 because we do bitwise ops
	// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
	function am2(i, x, w, j, c, n) {
	    var xl = x & 0x7fff;
	    var xh = x >> 15;
	    while (--n >= 0) {
	        var l = this[i] & 0x7fff;
	        var h = this[i++] >> 15;
	        var m = xh * l + h * xl;
	        l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
	        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
	        w[j++] = l & 0x3fffffff;
	    }
	    return c;
	}
	// Alternately, set max digit bits to 28 since some
	// browsers slow down when dealing with 32-bit numbers.
	function am3(i, x, w, j, c, n) {
	    var xl = x & 0x3fff;
	    var xh = x >> 14;
	    while (--n >= 0) {
	        var l = this[i] & 0x3fff;
	        var h = this[i++] >> 14;
	        var m = xh * l + h * xl;
	        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
	        c = (l >> 28) + (m >> 14) + xh * h;
	        w[j++] = l & 0xfffffff;
	    }
	    return c;
	}
	if (j_lm && (navigator.appName == "Microsoft Internet Explorer")) {
	    BigInteger.prototype.am = am2;
	    dbits = 30;
	}
	else if (j_lm && (navigator.appName != "Netscape")) {
	    BigInteger.prototype.am = am1;
	    dbits = 26;
	}
	else { // Mozilla/Netscape seems to prefer am3
	    BigInteger.prototype.am = am3;
	    dbits = 28;
	}
	BigInteger.prototype.DB = dbits;
	BigInteger.prototype.DM = ((1 << dbits) - 1);
	BigInteger.prototype.DV = (1 << dbits);
	var BI_FP = 52;
	BigInteger.prototype.FV = Math.pow(2, BI_FP);
	BigInteger.prototype.F1 = BI_FP - dbits;
	BigInteger.prototype.F2 = 2 * dbits - BI_FP;
	// Digit conversions
	var BI_RC = [];
	var rr;
	var vv;
	rr = "0".charCodeAt(0);
	for (vv = 0; vv <= 9; ++vv) {
	    BI_RC[rr++] = vv;
	}
	rr = "a".charCodeAt(0);
	for (vv = 10; vv < 36; ++vv) {
	    BI_RC[rr++] = vv;
	}
	rr = "A".charCodeAt(0);
	for (vv = 10; vv < 36; ++vv) {
	    BI_RC[rr++] = vv;
	}
	function intAt(s, i) {
	    var c = BI_RC[s.charCodeAt(i)];
	    return (c == null) ? -1 : c;
	}
	// return bigint initialized to value
	function nbv(i) {
	    var r = nbi();
	    r.fromInt(i);
	    return r;
	}
	// returns bit length of the integer x
	function nbits(x) {
	    var r = 1;
	    var t;
	    if ((t = x >>> 16) != 0) {
	        x = t;
	        r += 16;
	    }
	    if ((t = x >> 8) != 0) {
	        x = t;
	        r += 8;
	    }
	    if ((t = x >> 4) != 0) {
	        x = t;
	        r += 4;
	    }
	    if ((t = x >> 2) != 0) {
	        x = t;
	        r += 2;
	    }
	    if ((t = x >> 1) != 0) {
	        x = t;
	        r += 1;
	    }
	    return r;
	}
	// "constants"
	BigInteger.ZERO = nbv(0);
	BigInteger.ONE = nbv(1);
	
	// prng4.js - uses Arcfour as a PRNG
	var Arcfour = /** @class */ (function () {
	    function Arcfour() {
	        this.i = 0;
	        this.j = 0;
	        this.S = [];
	    }
	    // Arcfour.prototype.init = ARC4init;
	    // Initialize arcfour context from key, an array of ints, each from [0..255]
	    Arcfour.prototype.init = function (key) {
	        var i;
	        var j;
	        var t;
	        for (i = 0; i < 256; ++i) {
	            this.S[i] = i;
	        }
	        j = 0;
	        for (i = 0; i < 256; ++i) {
	            j = (j + this.S[i] + key[i % key.length]) & 255;
	            t = this.S[i];
	            this.S[i] = this.S[j];
	            this.S[j] = t;
	        }
	        this.i = 0;
	        this.j = 0;
	    };
	    // Arcfour.prototype.next = ARC4next;
	    Arcfour.prototype.next = function () {
	        var t;
	        this.i = (this.i + 1) & 255;
	        this.j = (this.j + this.S[this.i]) & 255;
	        t = this.S[this.i];
	        this.S[this.i] = this.S[this.j];
	        this.S[this.j] = t;
	        return this.S[(t + this.S[this.i]) & 255];
	    };
	    return Arcfour;
	}());
	// Plug in your RNG constructor here
	function prng_newstate() {
	    return new Arcfour();
	}
	// Pool size must be a multiple of 4 and greater than 32.
	// An array of bytes the size of the pool will be passed to init()
	var rng_psize = 256;
	
	// Random number generator - requires a PRNG backend, e.g. prng4.js
	var rng_state;
	var rng_pool = null;
	var rng_pptr;
	// Initialize the pool with junk if needed.
	if (rng_pool == null) {
	    rng_pool = [];
	    rng_pptr = 0;
	    var t = void 0;
	    if (window.crypto && window.crypto.getRandomValues) {
	        // Extract entropy (2048 bits) from RNG if available
	        var z = new Uint32Array(256);
	        window.crypto.getRandomValues(z);
	        for (t = 0; t < z.length; ++t) {
	            rng_pool[rng_pptr++] = z[t] & 255;
	        }
	    }
	    // Use mouse events for entropy, if we do not have enough entropy by the time
	    // we need it, entropy will be generated by Math.random.
	    var onMouseMoveListener_1 = function (ev) {
	        this.count = this.count || 0;
	        if (this.count >= 256 || rng_pptr >= rng_psize) {
	            if (window.removeEventListener) {
	                window.removeEventListener("mousemove", onMouseMoveListener_1, false);
	            }
	            else if (window.detachEvent) {
	                window.detachEvent("onmousemove", onMouseMoveListener_1);
	            }
	            return;
	        }
	        try {
	            var mouseCoordinates = ev.x + ev.y;
	            rng_pool[rng_pptr++] = mouseCoordinates & 255;
	            this.count += 1;
	        }
	        catch (e) {
	            // Sometimes Firefox will deny permission to access event properties for some reason. Ignore.
	        }
	    };
	    if (window.addEventListener) {
	        window.addEventListener("mousemove", onMouseMoveListener_1, false);
	    }
	    else if (window.attachEvent) {
	        window.attachEvent("onmousemove", onMouseMoveListener_1);
	    }
	}
	function rng_get_byte() {
	    if (rng_state == null) {
	        rng_state = prng_newstate();
	        // At this point, we may not have collected enough entropy.  If not, fall back to Math.random
	        while (rng_pptr < rng_psize) {
	            var random = Math.floor(65536 * Math.random());
	            rng_pool[rng_pptr++] = random & 255;
	        }
	        rng_state.init(rng_pool);
	        for (rng_pptr = 0; rng_pptr < rng_pool.length; ++rng_pptr) {
	            rng_pool[rng_pptr] = 0;
	        }
	        rng_pptr = 0;
	    }
	    // TODO: allow reseeding after first request
	    return rng_state.next();
	}
	var SecureRandom = /** @class */ (function () {
	    function SecureRandom() {
	    }
	    SecureRandom.prototype.nextBytes = function (ba) {
	        for (var i = 0; i < ba.length; ++i) {
	            ba[i] = rng_get_byte();
	        }
	    };
	    return SecureRandom;
	}());
	
	// Depends on jsbn.js and rng.js
	// function linebrk(s,n) {
	//   var ret = "";
	//   var i = 0;
	//   while(i + n < s.length) {
	//     ret += s.substring(i,i+n) + "\n";
	//     i += n;
	//   }
	//   return ret + s.substring(i,s.length);
	// }
	// function byte2Hex(b) {
	//   if(b < 0x10)
	//     return "0" + b.toString(16);
	//   else
	//     return b.toString(16);
	// }
	function pkcs1pad1(s, n) {
	    if (n < s.length + 22) {
	        console.error("Message too long for RSA");
	        return null;
	    }
	    var len = n - s.length - 6;
	    var filler = "";
	    for (var f = 0; f < len; f += 2) {
	        filler += "ff";
	    }
	    var m = "0001" + filler + "00" + s;
	    return parseBigInt(m, 16);
	}
	// PKCS#1 (type 2, random) pad input string s to n bytes, and return a bigint
	function pkcs1pad2(s, n) {
	    if (n < s.length + 11) { // TODO: fix for utf-8
	        console.error("Message too long for RSA");
	        return null;
	    }
	    var ba = [];
	    var i = s.length - 1;
	    while (i >= 0 && n > 0) {
	        var c = s.charCodeAt(i--);
	        if (c < 128) { // encode using utf-8
	            ba[--n] = c;
	        }
	        else if ((c > 127) && (c < 2048)) {
	            ba[--n] = (c & 63) | 128;
	            ba[--n] = (c >> 6) | 192;
	        }
	        else {
	            ba[--n] = (c & 63) | 128;
	            ba[--n] = ((c >> 6) & 63) | 128;
	            ba[--n] = (c >> 12) | 224;
	        }
	    }
	    ba[--n] = 0;
	    var rng = new SecureRandom();
	    var x = [];
	    while (n > 2) { // random non-zero pad
	        x[0] = 0;
	        while (x[0] == 0) {
	            rng.nextBytes(x);
	        }
	        ba[--n] = x[0];
	    }
	    ba[--n] = 2;
	    ba[--n] = 0;
	    return new BigInteger(ba);
	}
	// "empty" RSA key constructor
	var RSAKey = /** @class */ (function () {
	    function RSAKey() {
	        this.n = null;
	        this.e = 0;
	        this.d = null;
	        this.p = null;
	        this.q = null;
	        this.dmp1 = null;
	        this.dmq1 = null;
	        this.coeff = null;
	    }
	    //#region PROTECTED
	    // protected
	    // RSAKey.prototype.doPublic = RSADoPublic;
	    // Perform raw public operation on "x": return x^e (mod n)
	    RSAKey.prototype.doPublic = function (x) {
	        return x.modPowInt(this.e, this.n);
	    };
	    // RSAKey.prototype.doPrivate = RSADoPrivate;
	    // Perform raw private operation on "x": return x^d (mod n)
	    RSAKey.prototype.doPrivate = function (x) {
	        if (this.p == null || this.q == null) {
	            return x.modPow(this.d, this.n);
	        }
	        // TODO: re-calculate any missing CRT params
	        var xp = x.mod(this.p).modPow(this.dmp1, this.p);
	        var xq = x.mod(this.q).modPow(this.dmq1, this.q);
	        while (xp.compareTo(xq) < 0) {
	            xp = xp.add(this.p);
	        }
	        return xp.subtract(xq).multiply(this.coeff).mod(this.p).multiply(this.q).add(xq);
	    };
	    //#endregion PROTECTED
	    //#region PUBLIC
	    // RSAKey.prototype.setPublic = RSASetPublic;
	    // Set the public key fields N and e from hex strings
	    RSAKey.prototype.setPublic = function (N, E) {
	        if (N != null && E != null && N.length > 0 && E.length > 0) {
	            this.n = parseBigInt(N, 16);
	            this.e = parseInt(E, 16);
	        }
	        else {
	            console.error("Invalid RSA public key");
	        }
	    };
	    // RSAKey.prototype.encrypt = RSAEncrypt;
	    // Return the PKCS#1 RSA encryption of "text" as an even-length hex string
	    RSAKey.prototype.encrypt = function (text) {
	        var m = pkcs1pad2(text, (this.n.bitLength() + 7) >> 3);
	        if (m == null) {
	            return null;
	        }
	        var c = this.doPublic(m);
	        if (c == null) {
	            return null;
	        }
	        var h = c.toString(16);
	        if ((h.length & 1) == 0) {
	            return h;
	        }
	        else {
	            return "0" + h;
	        }
	    };
	    // RSAKey.prototype.setPrivate = RSASetPrivate;
	    // Set the private key fields N, e, and d from hex strings
	    RSAKey.prototype.setPrivate = function (N, E, D) {
	        if (N != null && E != null && N.length > 0 && E.length > 0) {
	            this.n = parseBigInt(N, 16);
	            this.e = parseInt(E, 16);
	            this.d = parseBigInt(D, 16);
	        }
	        else {
	            console.error("Invalid RSA private key");
	        }
	    };
	    // RSAKey.prototype.setPrivateEx = RSASetPrivateEx;
	    // Set the private key fields N, e, d and CRT params from hex strings
	    RSAKey.prototype.setPrivateEx = function (N, E, D, P, Q, DP, DQ, C) {
	        if (N != null && E != null && N.length > 0 && E.length > 0) {
	            this.n = parseBigInt(N, 16);
	            this.e = parseInt(E, 16);
	            this.d = parseBigInt(D, 16);
	            this.p = parseBigInt(P, 16);
	            this.q = parseBigInt(Q, 16);
	            this.dmp1 = parseBigInt(DP, 16);
	            this.dmq1 = parseBigInt(DQ, 16);
	            this.coeff = parseBigInt(C, 16);
	        }
	        else {
	            console.error("Invalid RSA private key");
	        }
	    };
	    // RSAKey.prototype.generate = RSAGenerate;
	    // Generate a new random private key B bits long, using public expt E
	    RSAKey.prototype.generate = function (B, E) {
	        var rng = new SecureRandom();
	        var qs = B >> 1;
	        this.e = parseInt(E, 16);
	        var ee = new BigInteger(E, 16);
	        for (;;) {
	            for (;;) {
	                this.p = new BigInteger(B - qs, 1, rng);
	                if (this.p.subtract(BigInteger.ONE).gcd(ee).compareTo(BigInteger.ONE) == 0 && this.p.isProbablePrime(10)) {
	                    break;
	                }
	            }
	            for (;;) {
	                this.q = new BigInteger(qs, 1, rng);
	                if (this.q.subtract(BigInteger.ONE).gcd(ee).compareTo(BigInteger.ONE) == 0 && this.q.isProbablePrime(10)) {
	                    break;
	                }
	            }
	            if (this.p.compareTo(this.q) <= 0) {
	                var t = this.p;
	                this.p = this.q;
	                this.q = t;
	            }
	            var p1 = this.p.subtract(BigInteger.ONE);
	            var q1 = this.q.subtract(BigInteger.ONE);
	            var phi = p1.multiply(q1);
	            if (phi.gcd(ee).compareTo(BigInteger.ONE) == 0) {
	                this.n = this.p.multiply(this.q);
	                this.d = ee.modInverse(phi);
	                this.dmp1 = this.d.mod(p1);
	                this.dmq1 = this.d.mod(q1);
	                this.coeff = this.q.modInverse(this.p);
	                break;
	            }
	        }
	    };
	    // RSAKey.prototype.decrypt = RSADecrypt;
	    // Return the PKCS#1 RSA decryption of "ctext".
	    // "ctext" is an even-length hex string and the output is a plain string.
	    RSAKey.prototype.decrypt = function (ctext) {
	        var c = parseBigInt(ctext, 16);
	        var m = this.doPrivate(c);
	        if (m == null) {
	            return null;
	        }
	        return pkcs1unpad2(m, (this.n.bitLength() + 7) >> 3);
	    };
	    // Generate a new random private key B bits long, using public expt E
	    RSAKey.prototype.generateAsync = function (B, E, callback) {
	        var rng = new SecureRandom();
	        var qs = B >> 1;
	        this.e = parseInt(E, 16);
	        var ee = new BigInteger(E, 16);
	        var rsa = this;
	        // These functions have non-descript names because they were originally for(;;) loops.
	        // I don't know about cryptography to give them better names than loop1-4.
	        var loop1 = function () {
	            var loop4 = function () {
	                if (rsa.p.compareTo(rsa.q) <= 0) {
	                    var t = rsa.p;
	                    rsa.p = rsa.q;
	                    rsa.q = t;
	                }
	                var p1 = rsa.p.subtract(BigInteger.ONE);
	                var q1 = rsa.q.subtract(BigInteger.ONE);
	                var phi = p1.multiply(q1);
	                if (phi.gcd(ee).compareTo(BigInteger.ONE) == 0) {
	                    rsa.n = rsa.p.multiply(rsa.q);
	                    rsa.d = ee.modInverse(phi);
	                    rsa.dmp1 = rsa.d.mod(p1);
	                    rsa.dmq1 = rsa.d.mod(q1);
	                    rsa.coeff = rsa.q.modInverse(rsa.p);
	                    setTimeout(function () { callback(); }, 0); // escape
	                }
	                else {
	                    setTimeout(loop1, 0);
	                }
	            };
	            var loop3 = function () {
	                rsa.q = nbi();
	                rsa.q.fromNumberAsync(qs, 1, rng, function () {
	                    rsa.q.subtract(BigInteger.ONE).gcda(ee, function (r) {
	                        if (r.compareTo(BigInteger.ONE) == 0 && rsa.q.isProbablePrime(10)) {
	                            setTimeout(loop4, 0);
	                        }
	                        else {
	                            setTimeout(loop3, 0);
	                        }
	                    });
	                });
	            };
	            var loop2 = function () {
	                rsa.p = nbi();
	                rsa.p.fromNumberAsync(B - qs, 1, rng, function () {
	                    rsa.p.subtract(BigInteger.ONE).gcda(ee, function (r) {
	                        if (r.compareTo(BigInteger.ONE) == 0 && rsa.p.isProbablePrime(10)) {
	                            setTimeout(loop3, 0);
	                        }
	                        else {
	                            setTimeout(loop2, 0);
	                        }
	                    });
	                });
	            };
	            setTimeout(loop2, 0);
	        };
	        setTimeout(loop1, 0);
	    };
	    RSAKey.prototype.sign = function (text, digestMethod, digestName) {
	        var header = getDigestHeader(digestName);
	        var digest = header + digestMethod(text).toString();
	        var m = pkcs1pad1(digest, this.n.bitLength() / 4);
	        if (m == null) {
	            return null;
	        }
	        var c = this.doPrivate(m);
	        if (c == null) {
	            return null;
	        }
	        var h = c.toString(16);
	        if ((h.length & 1) == 0) {
	            return h;
	        }
	        else {
	            return "0" + h;
	        }
	    };
	    RSAKey.prototype.verify = function (text, signature, digestMethod) {
	        var c = parseBigInt(signature, 16);
	        var m = this.doPublic(c);
	        if (m == null) {
	            return null;
	        }
	        var unpadded = m.toString(16).replace(/^1f+00/, "");
	        var digest = removeDigestHeader(unpadded);
	        return digest == digestMethod(text).toString();
	    };
	    return RSAKey;
	}());
	// Undo PKCS#1 (type 2, random) padding and, if valid, return the plaintext
	function pkcs1unpad2(d, n) {
	    var b = d.toByteArray();
	    var i = 0;
	    while (i < b.length && b[i] == 0) {
	        ++i;
	    }
	    if (b.length - i != n - 1 || b[i] != 2) {
	        return null;
	    }
	    ++i;
	    while (b[i] != 0) {
	        if (++i >= b.length) {
	            return null;
	        }
	    }
	    var ret = "";
	    while (++i < b.length) {
	        var c = b[i] & 255;
	        if (c < 128) { // utf-8 decode
	            ret += String.fromCharCode(c);
	        }
	        else if ((c > 191) && (c < 224)) {
	            ret += String.fromCharCode(((c & 31) << 6) | (b[i + 1] & 63));
	            ++i;
	        }
	        else {
	            ret += String.fromCharCode(((c & 15) << 12) | ((b[i + 1] & 63) << 6) | (b[i + 2] & 63));
	            i += 2;
	        }
	    }
	    return ret;
	}
	// https://tools.ietf.org/html/rfc3447#page-43
	var DIGEST_HEADERS = {
	    md2: "3020300c06082a864886f70d020205000410",
	    md5: "3020300c06082a864886f70d020505000410",
	    sha1: "3021300906052b0e03021a05000414",
	    sha224: "302d300d06096086480165030402040500041c",
	    sha256: "3031300d060960864801650304020105000420",
	    sha384: "3041300d060960864801650304020205000430",
	    sha512: "3051300d060960864801650304020305000440",
	    ripemd160: "3021300906052b2403020105000414",
	};
	function getDigestHeader(name) {
	    return DIGEST_HEADERS[name] || "";
	}
	function removeDigestHeader(str) {
	    for (var name_1 in DIGEST_HEADERS) {
	        if (DIGEST_HEADERS.hasOwnProperty(name_1)) {
	            var header = DIGEST_HEADERS[name_1];
	            var len = header.length;
	            if (str.substr(0, len) == header) {
	                return str.substr(len);
	            }
	        }
	    }
	    return str;
	}
	// Return the PKCS#1 RSA encryption of "text" as a Base64-encoded string
	// function RSAEncryptB64(text) {
	//  var h = this.encrypt(text);
	//  if(h) return hex2b64(h); else return null;
	// }
	// public
	// RSAKey.prototype.encrypt_b64 = RSAEncryptB64;
	
	/*!
	Copyright (c) 2011, Yahoo! Inc. All rights reserved.
	Code licensed under the BSD License:
	http://developer.yahoo.com/yui/license.html
	version: 2.9.0
	*/
	var YAHOO = {};
	YAHOO.lang = {
	    /**
	     * Utility to set up the prototype, constructor and superclass properties to
	     * support an inheritance strategy that can chain constructors and methods.
	     * Static members will not be inherited.
	     *
	     * @method extend
	     * @static
	     * @param {Function} subc   the object to modify
	     * @param {Function} superc the object to inherit
	     * @param {Object} overrides  additional properties/methods to add to the
	     *                              subclass prototype.  These will override the
	     *                              matching items obtained from the superclass
	     *                              if present.
	     */
	    extend: function(subc, superc, overrides) {
	        if (! superc || ! subc) {
	            throw new Error("YAHOO.lang.extend failed, please check that " +
	                "all dependencies are included.");
	        }
	
	        var F = function() {};
	        F.prototype = superc.prototype;
	        subc.prototype = new F();
	        subc.prototype.constructor = subc;
	        subc.superclass = superc.prototype;
	
	        if (superc.prototype.constructor == Object.prototype.constructor) {
	            superc.prototype.constructor = superc;
	        }
	
	        if (overrides) {
	            var i;
	            for (i in overrides) {
	                subc.prototype[i] = overrides[i];
	            }
	
	            /*
	             * IE will not enumerate native functions in a derived object even if the
	             * function was overridden.  This is a workaround for specific functions
	             * we care about on the Object prototype.
	             * @property _IEEnumFix
	             * @param {Function} r  the object to receive the augmentation
	             * @param {Function} s  the object that supplies the properties to augment
	             * @static
	             * @private
	             */
	            var _IEEnumFix = function() {},
	                ADD = ["toString", "valueOf"];
	            try {
	                if (/MSIE/.test(navigator.userAgent)) {
	                    _IEEnumFix = function(r, s) {
	                        for (i = 0; i < ADD.length; i = i + 1) {
	                            var fname = ADD[i], f = s[fname];
	                            if (typeof f === 'function' && f != Object.prototype[fname]) {
	                                r[fname] = f;
	                            }
	                        }
	                    };
	                }
	            } catch (ex) {}            _IEEnumFix(subc.prototype, overrides);
	        }
	    }
	};
	
	/* asn1-1.0.13.js (c) 2013-2017 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
	
	/**
	 * @fileOverview
	 * @name asn1-1.0.js
	 * @author Kenji Urushima kenji.urushima@gmail.com
	 * @version asn1 1.0.13 (2017-Jun-02)
	 * @since jsrsasign 2.1
	 * @license <a href="https://kjur.github.io/jsrsasign/license/">MIT License</a>
	 */
	
	/**
	 * kjur's class library name space
	 * <p>
	 * This name space provides following name spaces:
	 * <ul>
	 * <li>{@link KJUR.asn1} - ASN.1 primitive hexadecimal encoder</li>
	 * <li>{@link KJUR.asn1.x509} - ASN.1 structure for X.509 certificate and CRL</li>
	 * <li>{@link KJUR.crypto} - Java Cryptographic Extension(JCE) style MessageDigest/Signature
	 * class and utilities</li>
	 * </ul>
	 * </p>
	 * NOTE: Please ignore method summary and document of this namespace. This caused by a bug of jsdoc2.
	 * @name KJUR
	 * @namespace kjur's class library name space
	 */
	var KJUR = {};
	
	/**
	 * kjur's ASN.1 class library name space
	 * <p>
	 * This is ITU-T X.690 ASN.1 DER encoder class library and
	 * class structure and methods is very similar to
	 * org.bouncycastle.asn1 package of
	 * well known BouncyCaslte Cryptography Library.
	 * <h4>PROVIDING ASN.1 PRIMITIVES</h4>
	 * Here are ASN.1 DER primitive classes.
	 * <ul>
	 * <li>0x01 {@link KJUR.asn1.DERBoolean}</li>
	 * <li>0x02 {@link KJUR.asn1.DERInteger}</li>
	 * <li>0x03 {@link KJUR.asn1.DERBitString}</li>
	 * <li>0x04 {@link KJUR.asn1.DEROctetString}</li>
	 * <li>0x05 {@link KJUR.asn1.DERNull}</li>
	 * <li>0x06 {@link KJUR.asn1.DERObjectIdentifier}</li>
	 * <li>0x0a {@link KJUR.asn1.DEREnumerated}</li>
	 * <li>0x0c {@link KJUR.asn1.DERUTF8String}</li>
	 * <li>0x12 {@link KJUR.asn1.DERNumericString}</li>
	 * <li>0x13 {@link KJUR.asn1.DERPrintableString}</li>
	 * <li>0x14 {@link KJUR.asn1.DERTeletexString}</li>
	 * <li>0x16 {@link KJUR.asn1.DERIA5String}</li>
	 * <li>0x17 {@link KJUR.asn1.DERUTCTime}</li>
	 * <li>0x18 {@link KJUR.asn1.DERGeneralizedTime}</li>
	 * <li>0x30 {@link KJUR.asn1.DERSequence}</li>
	 * <li>0x31 {@link KJUR.asn1.DERSet}</li>
	 * </ul>
	 * <h4>OTHER ASN.1 CLASSES</h4>
	 * <ul>
	 * <li>{@link KJUR.asn1.ASN1Object}</li>
	 * <li>{@link KJUR.asn1.DERAbstractString}</li>
	 * <li>{@link KJUR.asn1.DERAbstractTime}</li>
	 * <li>{@link KJUR.asn1.DERAbstractStructured}</li>
	 * <li>{@link KJUR.asn1.DERTaggedObject}</li>
	 * </ul>
	 * <h4>SUB NAME SPACES</h4>
	 * <ul>
	 * <li>{@link KJUR.asn1.cades} - CAdES long term signature format</li>
	 * <li>{@link KJUR.asn1.cms} - Cryptographic Message Syntax</li>
	 * <li>{@link KJUR.asn1.csr} - Certificate Signing Request (CSR/PKCS#10)</li>
	 * <li>{@link KJUR.asn1.tsp} - RFC 3161 Timestamping Protocol Format</li>
	 * <li>{@link KJUR.asn1.x509} - RFC 5280 X.509 certificate and CRL</li>
	 * </ul>
	 * </p>
	 * NOTE: Please ignore method summary and document of this namespace.
	 * This caused by a bug of jsdoc2.
	 * @name KJUR.asn1
	 * @namespace
	 */
	if (typeof KJUR.asn1 == "undefined" || !KJUR.asn1) KJUR.asn1 = {};
	
	/**
	 * ASN1 utilities class
	 * @name KJUR.asn1.ASN1Util
	 * @class ASN1 utilities class
	 * @since asn1 1.0.2
	 */
	KJUR.asn1.ASN1Util = new function() {
	    this.integerToByteHex = function(i) {
	        var h = i.toString(16);
	        if ((h.length % 2) == 1) h = '0' + h;
	        return h;
	    };
	    this.bigIntToMinTwosComplementsHex = function(bigIntegerValue) {
	        var h = bigIntegerValue.toString(16);
	        if (h.substr(0, 1) != '-') {
	            if (h.length % 2 == 1) {
	                h = '0' + h;
	            } else {
	                if (! h.match(/^[0-7]/)) {
	                    h = '00' + h;
	                }
	            }
	        } else {
	            var hPos = h.substr(1);
	            var xorLen = hPos.length;
	            if (xorLen % 2 == 1) {
	                xorLen += 1;
	            } else {
	                if (! h.match(/^[0-7]/)) {
	                    xorLen += 2;
	                }
	            }
	            var hMask = '';
	            for (var i = 0; i < xorLen; i++) {
	                hMask += 'f';
	            }
	            var biMask = new BigInteger(hMask, 16);
	            var biNeg = biMask.xor(bigIntegerValue).add(BigInteger.ONE);
	            h = biNeg.toString(16).replace(/^-/, '');
	        }
	        return h;
	    };
	    /**
	     * get PEM string from hexadecimal data and header string
	     * @name getPEMStringFromHex
	     * @memberOf KJUR.asn1.ASN1Util
	     * @function
	     * @param {String} dataHex hexadecimal string of PEM body
	     * @param {String} pemHeader PEM header string (ex. 'RSA PRIVATE KEY')
	     * @return {String} PEM formatted string of input data
	     * @description
	     * This method converts a hexadecimal string to a PEM string with
	     * a specified header. Its line break will be CRLF("\r\n").
	     * @example
	     * var pem  = KJUR.asn1.ASN1Util.getPEMStringFromHex('616161', 'RSA PRIVATE KEY');
	     * // value of pem will be:
	     * -----BEGIN PRIVATE KEY-----
	     * YWFh
	     * -----END PRIVATE KEY-----
	     */
	    this.getPEMStringFromHex = function(dataHex, pemHeader) {
	        return hextopem(dataHex, pemHeader);
	    };
	
	    /**
	     * generate ASN1Object specifed by JSON parameters
	     * @name newObject
	     * @memberOf KJUR.asn1.ASN1Util
	     * @function
	     * @param {Array} param JSON parameter to generate ASN1Object
	     * @return {KJUR.asn1.ASN1Object} generated object
	     * @since asn1 1.0.3
	     * @description
	     * generate any ASN1Object specified by JSON param
	     * including ASN.1 primitive or structured.
	     * Generally 'param' can be described as follows:
	     * <blockquote>
	     * {TYPE-OF-ASNOBJ: ASN1OBJ-PARAMETER}
	     * </blockquote>
	     * 'TYPE-OF-ASN1OBJ' can be one of following symbols:
	     * <ul>
	     * <li>'bool' - DERBoolean</li>
	     * <li>'int' - DERInteger</li>
	     * <li>'bitstr' - DERBitString</li>
	     * <li>'octstr' - DEROctetString</li>
	     * <li>'null' - DERNull</li>
	     * <li>'oid' - DERObjectIdentifier</li>
	     * <li>'enum' - DEREnumerated</li>
	     * <li>'utf8str' - DERUTF8String</li>
	     * <li>'numstr' - DERNumericString</li>
	     * <li>'prnstr' - DERPrintableString</li>
	     * <li>'telstr' - DERTeletexString</li>
	     * <li>'ia5str' - DERIA5String</li>
	     * <li>'utctime' - DERUTCTime</li>
	     * <li>'gentime' - DERGeneralizedTime</li>
	     * <li>'seq' - DERSequence</li>
	     * <li>'set' - DERSet</li>
	     * <li>'tag' - DERTaggedObject</li>
	     * </ul>
	     * @example
	     * newObject({'prnstr': 'aaa'});
	     * newObject({'seq': [{'int': 3}, {'prnstr': 'aaa'}]})
	     * // ASN.1 Tagged Object
	     * newObject({'tag': {'tag': 'a1',
	     *                    'explicit': true,
	     *                    'obj': {'seq': [{'int': 3}, {'prnstr': 'aaa'}]}}});
	     * // more simple representation of ASN.1 Tagged Object
	     * newObject({'tag': ['a1',
	     *                    true,
	     *                    {'seq': [
	     *                      {'int': 3},
	     *                      {'prnstr': 'aaa'}]}
	     *                   ]});
	     */
	    this.newObject = function(param) {
	        var _KJUR = KJUR,
	            _KJUR_asn1 = _KJUR.asn1,
	            _DERBoolean = _KJUR_asn1.DERBoolean,
	            _DERInteger = _KJUR_asn1.DERInteger,
	            _DERBitString = _KJUR_asn1.DERBitString,
	            _DEROctetString = _KJUR_asn1.DEROctetString,
	            _DERNull = _KJUR_asn1.DERNull,
	            _DERObjectIdentifier = _KJUR_asn1.DERObjectIdentifier,
	            _DEREnumerated = _KJUR_asn1.DEREnumerated,
	            _DERUTF8String = _KJUR_asn1.DERUTF8String,
	            _DERNumericString = _KJUR_asn1.DERNumericString,
	            _DERPrintableString = _KJUR_asn1.DERPrintableString,
	            _DERTeletexString = _KJUR_asn1.DERTeletexString,
	            _DERIA5String = _KJUR_asn1.DERIA5String,
	            _DERUTCTime = _KJUR_asn1.DERUTCTime,
	            _DERGeneralizedTime = _KJUR_asn1.DERGeneralizedTime,
	            _DERSequence = _KJUR_asn1.DERSequence,
	            _DERSet = _KJUR_asn1.DERSet,
	            _DERTaggedObject = _KJUR_asn1.DERTaggedObject,
	            _newObject = _KJUR_asn1.ASN1Util.newObject;
	
	        var keys = Object.keys(param);
	        if (keys.length != 1)
	            throw "key of param shall be only one.";
	        var key = keys[0];
	
	        if (":bool:int:bitstr:octstr:null:oid:enum:utf8str:numstr:prnstr:telstr:ia5str:utctime:gentime:seq:set:tag:".indexOf(":" + key + ":") == -1)
	            throw "undefined key: " + key;
	
	        if (key == "bool")    return new _DERBoolean(param[key]);
	        if (key == "int")     return new _DERInteger(param[key]);
	        if (key == "bitstr")  return new _DERBitString(param[key]);
	        if (key == "octstr")  return new _DEROctetString(param[key]);
	        if (key == "null")    return new _DERNull(param[key]);
	        if (key == "oid")     return new _DERObjectIdentifier(param[key]);
	        if (key == "enum")    return new _DEREnumerated(param[key]);
	        if (key == "utf8str") return new _DERUTF8String(param[key]);
	        if (key == "numstr")  return new _DERNumericString(param[key]);
	        if (key == "prnstr")  return new _DERPrintableString(param[key]);
	        if (key == "telstr")  return new _DERTeletexString(param[key]);
	        if (key == "ia5str")  return new _DERIA5String(param[key]);
	        if (key == "utctime") return new _DERUTCTime(param[key]);
	        if (key == "gentime") return new _DERGeneralizedTime(param[key]);
	
	        if (key == "seq") {
	            var paramList = param[key];
	            var a = [];
	            for (var i = 0; i < paramList.length; i++) {
	                var asn1Obj = _newObject(paramList[i]);
	                a.push(asn1Obj);
	            }
	            return new _DERSequence({'array': a});
	        }
	
	        if (key == "set") {
	            var paramList = param[key];
	            var a = [];
	            for (var i = 0; i < paramList.length; i++) {
	                var asn1Obj = _newObject(paramList[i]);
	                a.push(asn1Obj);
	            }
	            return new _DERSet({'array': a});
	        }
	
	        if (key == "tag") {
	            var tagParam = param[key];
	            if (Object.prototype.toString.call(tagParam) === '[object Array]' &&
	                tagParam.length == 3) {
	                var obj = _newObject(tagParam[2]);
	                return new _DERTaggedObject({tag: tagParam[0],
	                    explicit: tagParam[1],
	                    obj: obj});
	            } else {
	                var newParam = {};
	                if (tagParam.explicit !== undefined)
	                    newParam.explicit = tagParam.explicit;
	                if (tagParam.tag !== undefined)
	                    newParam.tag = tagParam.tag;
	                if (tagParam.obj === undefined)
	                    throw "obj shall be specified for 'tag'.";
	                newParam.obj = _newObject(tagParam.obj);
	                return new _DERTaggedObject(newParam);
	            }
	        }
	    };
	
	    /**
	     * get encoded hexadecimal string of ASN1Object specifed by JSON parameters
	     * @name jsonToASN1HEX
	     * @memberOf KJUR.asn1.ASN1Util
	     * @function
	     * @param {Array} param JSON parameter to generate ASN1Object
	     * @return hexadecimal string of ASN1Object
	     * @since asn1 1.0.4
	     * @description
	     * As for ASN.1 object representation of JSON object,
	     * please see {@link newObject}.
	     * @example
	     * jsonToASN1HEX({'prnstr': 'aaa'});
	     */
	    this.jsonToASN1HEX = function(param) {
	        var asn1Obj = this.newObject(param);
	        return asn1Obj.getEncodedHex();
	    };
	};
	
	/**
	 * get dot noted oid number string from hexadecimal value of OID
	 * @name oidHexToInt
	 * @memberOf KJUR.asn1.ASN1Util
	 * @function
	 * @param {String} hex hexadecimal value of object identifier
	 * @return {String} dot noted string of object identifier
	 * @since jsrsasign 4.8.3 asn1 1.0.7
	 * @description
	 * This static method converts from hexadecimal string representation of
	 * ASN.1 value of object identifier to oid number string.
	 * @example
	 * KJUR.asn1.ASN1Util.oidHexToInt('550406') &rarr; "2.5.4.6"
	 */
	KJUR.asn1.ASN1Util.oidHexToInt = function(hex) {
	    var s = "";
	    var i01 = parseInt(hex.substr(0, 2), 16);
	    var i0 = Math.floor(i01 / 40);
	    var i1 = i01 % 40;
	    var s = i0 + "." + i1;
	
	    var binbuf = "";
	    for (var i = 2; i < hex.length; i += 2) {
	        var value = parseInt(hex.substr(i, 2), 16);
	        var bin = ("00000000" + value.toString(2)).slice(- 8);
	        binbuf = binbuf + bin.substr(1, 7);
	        if (bin.substr(0, 1) == "0") {
	            var bi = new BigInteger(binbuf, 2);
	            s = s + "." + bi.toString(10);
	            binbuf = "";
	        }
	    }
	    return s;
	};
	
	/**
	 * get hexadecimal value of object identifier from dot noted oid value
	 * @name oidIntToHex
	 * @memberOf KJUR.asn1.ASN1Util
	 * @function
	 * @param {String} oidString dot noted string of object identifier
	 * @return {String} hexadecimal value of object identifier
	 * @since jsrsasign 4.8.3 asn1 1.0.7
	 * @description
	 * This static method converts from object identifier value string.
	 * to hexadecimal string representation of it.
	 * @example
	 * KJUR.asn1.ASN1Util.oidIntToHex("2.5.4.6") &rarr; "550406"
	 */
	KJUR.asn1.ASN1Util.oidIntToHex = function(oidString) {
	    var itox = function(i) {
	        var h = i.toString(16);
	        if (h.length == 1) h = '0' + h;
	        return h;
	    };
	
	    var roidtox = function(roid) {
	        var h = '';
	        var bi = new BigInteger(roid, 10);
	        var b = bi.toString(2);
	        var padLen = 7 - b.length % 7;
	        if (padLen == 7) padLen = 0;
	        var bPad = '';
	        for (var i = 0; i < padLen; i++) bPad += '0';
	        b = bPad + b;
	        for (var i = 0; i < b.length - 1; i += 7) {
	            var b8 = b.substr(i, 7);
	            if (i != b.length - 7) b8 = '1' + b8;
	            h += itox(parseInt(b8, 2));
	        }
	        return h;
	    };
	
	    if (! oidString.match(/^[0-9.]+$/)) {
	        throw "malformed oid string: " + oidString;
	    }
	    var h = '';
	    var a = oidString.split('.');
	    var i0 = parseInt(a[0]) * 40 + parseInt(a[1]);
	    h += itox(i0);
	    a.splice(0, 2);
	    for (var i = 0; i < a.length; i++) {
	        h += roidtox(a[i]);
	    }
	    return h;
	};
	
	
	// ********************************************************************
	//  Abstract ASN.1 Classes
	// ********************************************************************
	
	// ********************************************************************
	
	/**
	 * base class for ASN.1 DER encoder object
	 * @name KJUR.asn1.ASN1Object
	 * @class base class for ASN.1 DER encoder object
	 * @property {Boolean} isModified flag whether internal data was changed
	 * @property {String} hTLV hexadecimal string of ASN.1 TLV
	 * @property {String} hT hexadecimal string of ASN.1 TLV tag(T)
	 * @property {String} hL hexadecimal string of ASN.1 TLV length(L)
	 * @property {String} hV hexadecimal string of ASN.1 TLV value(V)
	 * @description
	 */
	KJUR.asn1.ASN1Object = function() {
	    var hV = '';
	
	    /**
	     * get hexadecimal ASN.1 TLV length(L) bytes from TLV value(V)
	     * @name getLengthHexFromValue
	     * @memberOf KJUR.asn1.ASN1Object#
	     * @function
	     * @return {String} hexadecimal string of ASN.1 TLV length(L)
	     */
	    this.getLengthHexFromValue = function() {
	        if (typeof this.hV == "undefined" || this.hV == null) {
	            throw "this.hV is null or undefined.";
	        }
	        if (this.hV.length % 2 == 1) {
	            throw "value hex must be even length: n=" + hV.length + ",v=" + this.hV;
	        }
	        var n = this.hV.length / 2;
	        var hN = n.toString(16);
	        if (hN.length % 2 == 1) {
	            hN = "0" + hN;
	        }
	        if (n < 128) {
	            return hN;
	        } else {
	            var hNlen = hN.length / 2;
	            if (hNlen > 15) {
	                throw "ASN.1 length too long to represent by 8x: n = " + n.toString(16);
	            }
	            var head = 128 + hNlen;
	            return head.toString(16) + hN;
	        }
	    };
	
	    /**
	     * get hexadecimal string of ASN.1 TLV bytes
	     * @name getEncodedHex
	     * @memberOf KJUR.asn1.ASN1Object#
	     * @function
	     * @return {String} hexadecimal string of ASN.1 TLV
	     */
	    this.getEncodedHex = function() {
	        if (this.hTLV == null || this.isModified) {
	            this.hV = this.getFreshValueHex();
	            this.hL = this.getLengthHexFromValue();
	            this.hTLV = this.hT + this.hL + this.hV;
	            this.isModified = false;
	            //alert("first time: " + this.hTLV);
	        }
	        return this.hTLV;
	    };
	
	    /**
	     * get hexadecimal string of ASN.1 TLV value(V) bytes
	     * @name getValueHex
	     * @memberOf KJUR.asn1.ASN1Object#
	     * @function
	     * @return {String} hexadecimal string of ASN.1 TLV value(V) bytes
	     */
	    this.getValueHex = function() {
	        this.getEncodedHex();
	        return this.hV;
	    };
	
	    this.getFreshValueHex = function() {
	        return '';
	    };
	};
	
	// == BEGIN DERAbstractString ================================================
	/**
	 * base class for ASN.1 DER string classes
	 * @name KJUR.asn1.DERAbstractString
	 * @class base class for ASN.1 DER string classes
	 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
	 * @property {String} s internal string of value
	 * @extends KJUR.asn1.ASN1Object
	 * @description
	 * <br/>
	 * As for argument 'params' for constructor, you can specify one of
	 * following properties:
	 * <ul>
	 * <li>str - specify initial ASN.1 value(V) by a string</li>
	 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
	 * </ul>
	 * NOTE: 'params' can be omitted.
	 */
	KJUR.asn1.DERAbstractString = function(params) {
	    KJUR.asn1.DERAbstractString.superclass.constructor.call(this);
	
	    /**
	     * get string value of this string object
	     * @name getString
	     * @memberOf KJUR.asn1.DERAbstractString#
	     * @function
	     * @return {String} string value of this string object
	     */
	    this.getString = function() {
	        return this.s;
	    };
	
	    /**
	     * set value by a string
	     * @name setString
	     * @memberOf KJUR.asn1.DERAbstractString#
	     * @function
	     * @param {String} newS value by a string to set
	     */
	    this.setString = function(newS) {
	        this.hTLV = null;
	        this.isModified = true;
	        this.s = newS;
	        this.hV = stohex(this.s);
	    };
	
	    /**
	     * set value by a hexadecimal string
	     * @name setStringHex
	     * @memberOf KJUR.asn1.DERAbstractString#
	     * @function
	     * @param {String} newHexString value by a hexadecimal string to set
	     */
	    this.setStringHex = function(newHexString) {
	        this.hTLV = null;
	        this.isModified = true;
	        this.s = null;
	        this.hV = newHexString;
	    };
	
	    this.getFreshValueHex = function() {
	        return this.hV;
	    };
	
	    if (typeof params != "undefined") {
	        if (typeof params == "string") {
	            this.setString(params);
	        } else if (typeof params['str'] != "undefined") {
	            this.setString(params['str']);
	        } else if (typeof params['hex'] != "undefined") {
	            this.setStringHex(params['hex']);
	        }
	    }
	};
	YAHOO.lang.extend(KJUR.asn1.DERAbstractString, KJUR.asn1.ASN1Object);
	// == END   DERAbstractString ================================================
	
	// == BEGIN DERAbstractTime ==================================================
	/**
	 * base class for ASN.1 DER Generalized/UTCTime class
	 * @name KJUR.asn1.DERAbstractTime
	 * @class base class for ASN.1 DER Generalized/UTCTime class
	 * @param {Array} params associative array of parameters (ex. {'str': '130430235959Z'})
	 * @extends KJUR.asn1.ASN1Object
	 * @description
	 * @see KJUR.asn1.ASN1Object - superclass
	 */
	KJUR.asn1.DERAbstractTime = function(params) {
	    KJUR.asn1.DERAbstractTime.superclass.constructor.call(this);
	
	    // --- PRIVATE METHODS --------------------
	    this.localDateToUTC = function(d) {
	        utc = d.getTime() + (d.getTimezoneOffset() * 60000);
	        var utcDate = new Date(utc);
	        return utcDate;
	    };
	
	    /*
	     * format date string by Data object
	     * @name formatDate
	     * @memberOf KJUR.asn1.AbstractTime;
	     * @param {Date} dateObject
	     * @param {string} type 'utc' or 'gen'
	     * @param {boolean} withMillis flag for with millisections or not
	     * @description
	     * 'withMillis' flag is supported from asn1 1.0.6.
	     */
	    this.formatDate = function(dateObject, type, withMillis) {
	        var pad = this.zeroPadding;
	        var d = this.localDateToUTC(dateObject);
	        var year = String(d.getFullYear());
	        if (type == 'utc') year = year.substr(2, 2);
	        var month = pad(String(d.getMonth() + 1), 2);
	        var day = pad(String(d.getDate()), 2);
	        var hour = pad(String(d.getHours()), 2);
	        var min = pad(String(d.getMinutes()), 2);
	        var sec = pad(String(d.getSeconds()), 2);
	        var s = year + month + day + hour + min + sec;
	        if (withMillis === true) {
	            var millis = d.getMilliseconds();
	            if (millis != 0) {
	                var sMillis = pad(String(millis), 3);
	                sMillis = sMillis.replace(/[0]+$/, "");
	                s = s + "." + sMillis;
	            }
	        }
	        return s + "Z";
	    };
	
	    this.zeroPadding = function(s, len) {
	        if (s.length >= len) return s;
	        return new Array(len - s.length + 1).join('0') + s;
	    };
	
	    // --- PUBLIC METHODS --------------------
	    /**
	     * get string value of this string object
	     * @name getString
	     * @memberOf KJUR.asn1.DERAbstractTime#
	     * @function
	     * @return {String} string value of this time object
	     */
	    this.getString = function() {
	        return this.s;
	    };
	
	    /**
	     * set value by a string
	     * @name setString
	     * @memberOf KJUR.asn1.DERAbstractTime#
	     * @function
	     * @param {String} newS value by a string to set such like "130430235959Z"
	     */
	    this.setString = function(newS) {
	        this.hTLV = null;
	        this.isModified = true;
	        this.s = newS;
	        this.hV = stohex(newS);
	    };
	
	    /**
	     * set value by a Date object
	     * @name setByDateValue
	     * @memberOf KJUR.asn1.DERAbstractTime#
	     * @function
	     * @param {Integer} year year of date (ex. 2013)
	     * @param {Integer} month month of date between 1 and 12 (ex. 12)
	     * @param {Integer} day day of month
	     * @param {Integer} hour hours of date
	     * @param {Integer} min minutes of date
	     * @param {Integer} sec seconds of date
	     */
	    this.setByDateValue = function(year, month, day, hour, min, sec) {
	        var dateObject = new Date(Date.UTC(year, month - 1, day, hour, min, sec, 0));
	        this.setByDate(dateObject);
	    };
	
	    this.getFreshValueHex = function() {
	        return this.hV;
	    };
	};
	YAHOO.lang.extend(KJUR.asn1.DERAbstractTime, KJUR.asn1.ASN1Object);
	// == END   DERAbstractTime ==================================================
	
	// == BEGIN DERAbstractStructured ============================================
	/**
	 * base class for ASN.1 DER structured class
	 * @name KJUR.asn1.DERAbstractStructured
	 * @class base class for ASN.1 DER structured class
	 * @property {Array} asn1Array internal array of ASN1Object
	 * @extends KJUR.asn1.ASN1Object
	 * @description
	 * @see KJUR.asn1.ASN1Object - superclass
	 */
	KJUR.asn1.DERAbstractStructured = function(params) {
	    KJUR.asn1.DERAbstractString.superclass.constructor.call(this);
	
	    /**
	     * set value by array of ASN1Object
	     * @name setByASN1ObjectArray
	     * @memberOf KJUR.asn1.DERAbstractStructured#
	     * @function
	     * @param {array} asn1ObjectArray array of ASN1Object to set
	     */
	    this.setByASN1ObjectArray = function(asn1ObjectArray) {
	        this.hTLV = null;
	        this.isModified = true;
	        this.asn1Array = asn1ObjectArray;
	    };
	
	    /**
	     * append an ASN1Object to internal array
	     * @name appendASN1Object
	     * @memberOf KJUR.asn1.DERAbstractStructured#
	     * @function
	     * @param {ASN1Object} asn1Object to add
	     */
	    this.appendASN1Object = function(asn1Object) {
	        this.hTLV = null;
	        this.isModified = true;
	        this.asn1Array.push(asn1Object);
	    };
	
	    this.asn1Array = new Array();
	    if (typeof params != "undefined") {
	        if (typeof params['array'] != "undefined") {
	            this.asn1Array = params['array'];
	        }
	    }
	};
	YAHOO.lang.extend(KJUR.asn1.DERAbstractStructured, KJUR.asn1.ASN1Object);
	
	
	// ********************************************************************
	//  ASN.1 Object Classes
	// ********************************************************************
	
	// ********************************************************************
	/**
	 * class for ASN.1 DER Boolean
	 * @name KJUR.asn1.DERBoolean
	 * @class class for ASN.1 DER Boolean
	 * @extends KJUR.asn1.ASN1Object
	 * @description
	 * @see KJUR.asn1.ASN1Object - superclass
	 */
	KJUR.asn1.DERBoolean = function() {
	    KJUR.asn1.DERBoolean.superclass.constructor.call(this);
	    this.hT = "01";
	    this.hTLV = "0101ff";
	};
	YAHOO.lang.extend(KJUR.asn1.DERBoolean, KJUR.asn1.ASN1Object);
	
	// ********************************************************************
	/**
	 * class for ASN.1 DER Integer
	 * @name KJUR.asn1.DERInteger
	 * @class class for ASN.1 DER Integer
	 * @extends KJUR.asn1.ASN1Object
	 * @description
	 * <br/>
	 * As for argument 'params' for constructor, you can specify one of
	 * following properties:
	 * <ul>
	 * <li>int - specify initial ASN.1 value(V) by integer value</li>
	 * <li>bigint - specify initial ASN.1 value(V) by BigInteger object</li>
	 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
	 * </ul>
	 * NOTE: 'params' can be omitted.
	 */
	KJUR.asn1.DERInteger = function(params) {
	    KJUR.asn1.DERInteger.superclass.constructor.call(this);
	    this.hT = "02";
	
	    /**
	     * set value by Tom Wu's BigInteger object
	     * @name setByBigInteger
	     * @memberOf KJUR.asn1.DERInteger#
	     * @function
	     * @param {BigInteger} bigIntegerValue to set
	     */
	    this.setByBigInteger = function(bigIntegerValue) {
	        this.hTLV = null;
	        this.isModified = true;
	        this.hV = KJUR.asn1.ASN1Util.bigIntToMinTwosComplementsHex(bigIntegerValue);
	    };
	
	    /**
	     * set value by integer value
	     * @name setByInteger
	     * @memberOf KJUR.asn1.DERInteger
	     * @function
	     * @param {Integer} integer value to set
	     */
	    this.setByInteger = function(intValue) {
	        var bi = new BigInteger(String(intValue), 10);
	        this.setByBigInteger(bi);
	    };
	
	    /**
	     * set value by integer value
	     * @name setValueHex
	     * @memberOf KJUR.asn1.DERInteger#
	     * @function
	     * @param {String} hexadecimal string of integer value
	     * @description
	     * <br/>
	     * NOTE: Value shall be represented by minimum octet length of
	     * two's complement representation.
	     * @example
	     * new KJUR.asn1.DERInteger(123);
	     * new KJUR.asn1.DERInteger({'int': 123});
	     * new KJUR.asn1.DERInteger({'hex': '1fad'});
	     */
	    this.setValueHex = function(newHexString) {
	        this.hV = newHexString;
	    };
	
	    this.getFreshValueHex = function() {
	        return this.hV;
	    };
	
	    if (typeof params != "undefined") {
	        if (typeof params['bigint'] != "undefined") {
	            this.setByBigInteger(params['bigint']);
	        } else if (typeof params['int'] != "undefined") {
	            this.setByInteger(params['int']);
	        } else if (typeof params == "number") {
	            this.setByInteger(params);
	        } else if (typeof params['hex'] != "undefined") {
	            this.setValueHex(params['hex']);
	        }
	    }
	};
	YAHOO.lang.extend(KJUR.asn1.DERInteger, KJUR.asn1.ASN1Object);
	
	// ********************************************************************
	/**
	 * class for ASN.1 DER encoded BitString primitive
	 * @name KJUR.asn1.DERBitString
	 * @class class for ASN.1 DER encoded BitString primitive
	 * @extends KJUR.asn1.ASN1Object
	 * @description
	 * <br/>
	 * As for argument 'params' for constructor, you can specify one of
	 * following properties:
	 * <ul>
	 * <li>bin - specify binary string (ex. '10111')</li>
	 * <li>array - specify array of boolean (ex. [true,false,true,true])</li>
	 * <li>hex - specify hexadecimal string of ASN.1 value(V) including unused bits</li>
	 * <li>obj - specify {@link KJUR.asn1.ASN1Util.newObject}
	 * argument for "BitString encapsulates" structure.</li>
	 * </ul>
	 * NOTE1: 'params' can be omitted.<br/>
	 * NOTE2: 'obj' parameter have been supported since
	 * asn1 1.0.11, jsrsasign 6.1.1 (2016-Sep-25).<br/>
	 * @example
	 * // default constructor
	 * o = new KJUR.asn1.DERBitString();
	 * // initialize with binary string
	 * o = new KJUR.asn1.DERBitString({bin: "1011"});
	 * // initialize with boolean array
	 * o = new KJUR.asn1.DERBitString({array: [true,false,true,true]});
	 * // initialize with hexadecimal string (04 is unused bits)
	 * o = new KJUR.asn1.DEROctetString({hex: "04bac0"});
	 * // initialize with ASN1Util.newObject argument for encapsulated
	 * o = new KJUR.asn1.DERBitString({obj: {seq: [{int: 3}, {prnstr: 'aaa'}]}});
	 * // above generates a ASN.1 data like this:
	 * // BIT STRING, encapsulates {
	 * //   SEQUENCE {
	 * //     INTEGER 3
	 * //     PrintableString 'aaa'
	 * //     }
	 * //   }
	 */
	KJUR.asn1.DERBitString = function(params) {
	    if (params !== undefined && typeof params.obj !== "undefined") {
	        var o = KJUR.asn1.ASN1Util.newObject(params.obj);
	        params.hex = "00" + o.getEncodedHex();
	    }
	    KJUR.asn1.DERBitString.superclass.constructor.call(this);
	    this.hT = "03";
	
	    /**
	     * set ASN.1 value(V) by a hexadecimal string including unused bits
	     * @name setHexValueIncludingUnusedBits
	     * @memberOf KJUR.asn1.DERBitString#
	     * @function
	     * @param {String} newHexStringIncludingUnusedBits
	     */
	    this.setHexValueIncludingUnusedBits = function(newHexStringIncludingUnusedBits) {
	        this.hTLV = null;
	        this.isModified = true;
	        this.hV = newHexStringIncludingUnusedBits;
	    };
	
	    /**
	     * set ASN.1 value(V) by unused bit and hexadecimal string of value
	     * @name setUnusedBitsAndHexValue
	     * @memberOf KJUR.asn1.DERBitString#
	     * @function
	     * @param {Integer} unusedBits
	     * @param {String} hValue
	     */
	    this.setUnusedBitsAndHexValue = function(unusedBits, hValue) {
	        if (unusedBits < 0 || 7 < unusedBits) {
	            throw "unused bits shall be from 0 to 7: u = " + unusedBits;
	        }
	        var hUnusedBits = "0" + unusedBits;
	        this.hTLV = null;
	        this.isModified = true;
	        this.hV = hUnusedBits + hValue;
	    };
	
	    /**
	     * set ASN.1 DER BitString by binary string<br/>
	     * @name setByBinaryString
	     * @memberOf KJUR.asn1.DERBitString#
	     * @function
	     * @param {String} binaryString binary value string (i.e. '10111')
	     * @description
	     * Its unused bits will be calculated automatically by length of
	     * 'binaryValue'. <br/>
	     * NOTE: Trailing zeros '0' will be ignored.
	     * @example
	     * o = new KJUR.asn1.DERBitString();
	     * o.setByBooleanArray("01011");
	     */
	    this.setByBinaryString = function(binaryString) {
	        binaryString = binaryString.replace(/0+$/, '');
	        var unusedBits = 8 - binaryString.length % 8;
	        if (unusedBits == 8) unusedBits = 0;
	        for (var i = 0; i <= unusedBits; i++) {
	            binaryString += '0';
	        }
	        var h = '';
	        for (var i = 0; i < binaryString.length - 1; i += 8) {
	            var b = binaryString.substr(i, 8);
	            var x = parseInt(b, 2).toString(16);
	            if (x.length == 1) x = '0' + x;
	            h += x;
	        }
	        this.hTLV = null;
	        this.isModified = true;
	        this.hV = '0' + unusedBits + h;
	    };
	
	    /**
	     * set ASN.1 TLV value(V) by an array of boolean<br/>
	     * @name setByBooleanArray
	     * @memberOf KJUR.asn1.DERBitString#
	     * @function
	     * @param {array} booleanArray array of boolean (ex. [true, false, true])
	     * @description
	     * NOTE: Trailing falses will be ignored in the ASN.1 DER Object.
	     * @example
	     * o = new KJUR.asn1.DERBitString();
	     * o.setByBooleanArray([false, true, false, true, true]);
	     */
	    this.setByBooleanArray = function(booleanArray) {
	        var s = '';
	        for (var i = 0; i < booleanArray.length; i++) {
	            if (booleanArray[i] == true) {
	                s += '1';
	            } else {
	                s += '0';
	            }
	        }
	        this.setByBinaryString(s);
	    };
	
	    /**
	     * generate an array of falses with specified length<br/>
	     * @name newFalseArray
	     * @memberOf KJUR.asn1.DERBitString
	     * @function
	     * @param {Integer} nLength length of array to generate
	     * @return {array} array of boolean falses
	     * @description
	     * This static method may be useful to initialize boolean array.
	     * @example
	     * o = new KJUR.asn1.DERBitString();
	     * o.newFalseArray(3) &rarr; [false, false, false]
	     */
	    this.newFalseArray = function(nLength) {
	        var a = new Array(nLength);
	        for (var i = 0; i < nLength; i++) {
	            a[i] = false;
	        }
	        return a;
	    };
	
	    this.getFreshValueHex = function() {
	        return this.hV;
	    };
	
	    if (typeof params != "undefined") {
	        if (typeof params == "string" && params.toLowerCase().match(/^[0-9a-f]+$/)) {
	            this.setHexValueIncludingUnusedBits(params);
	        } else if (typeof params['hex'] != "undefined") {
	            this.setHexValueIncludingUnusedBits(params['hex']);
	        } else if (typeof params['bin'] != "undefined") {
	            this.setByBinaryString(params['bin']);
	        } else if (typeof params['array'] != "undefined") {
	            this.setByBooleanArray(params['array']);
	        }
	    }
	};
	YAHOO.lang.extend(KJUR.asn1.DERBitString, KJUR.asn1.ASN1Object);
	
	// ********************************************************************
	/**
	 * class for ASN.1 DER OctetString<br/>
	 * @name KJUR.asn1.DEROctetString
	 * @class class for ASN.1 DER OctetString
	 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
	 * @extends KJUR.asn1.DERAbstractString
	 * @description
	 * This class provides ASN.1 OctetString simple type.<br/>
	 * Supported "params" attributes are:
	 * <ul>
	 * <li>str - to set a string as a value</li>
	 * <li>hex - to set a hexadecimal string as a value</li>
	 * <li>obj - to set a encapsulated ASN.1 value by JSON object
	 * which is defined in {@link KJUR.asn1.ASN1Util.newObject}</li>
	 * </ul>
	 * NOTE: A parameter 'obj' have been supported
	 * for "OCTET STRING, encapsulates" structure.
	 * since asn1 1.0.11, jsrsasign 6.1.1 (2016-Sep-25).
	 * @see KJUR.asn1.DERAbstractString - superclass
	 * @example
	 * // default constructor
	 * o = new KJUR.asn1.DEROctetString();
	 * // initialize with string
	 * o = new KJUR.asn1.DEROctetString({str: "aaa"});
	 * // initialize with hexadecimal string
	 * o = new KJUR.asn1.DEROctetString({hex: "616161"});
	 * // initialize with ASN1Util.newObject argument
	 * o = new KJUR.asn1.DEROctetString({obj: {seq: [{int: 3}, {prnstr: 'aaa'}]}});
	 * // above generates a ASN.1 data like this:
	 * // OCTET STRING, encapsulates {
	 * //   SEQUENCE {
	 * //     INTEGER 3
	 * //     PrintableString 'aaa'
	 * //     }
	 * //   }
	 */
	KJUR.asn1.DEROctetString = function(params) {
	    if (params !== undefined && typeof params.obj !== "undefined") {
	        var o = KJUR.asn1.ASN1Util.newObject(params.obj);
	        params.hex = o.getEncodedHex();
	    }
	    KJUR.asn1.DEROctetString.superclass.constructor.call(this, params);
	    this.hT = "04";
	};
	YAHOO.lang.extend(KJUR.asn1.DEROctetString, KJUR.asn1.DERAbstractString);
	
	// ********************************************************************
	/**
	 * class for ASN.1 DER Null
	 * @name KJUR.asn1.DERNull
	 * @class class for ASN.1 DER Null
	 * @extends KJUR.asn1.ASN1Object
	 * @description
	 * @see KJUR.asn1.ASN1Object - superclass
	 */
	KJUR.asn1.DERNull = function() {
	    KJUR.asn1.DERNull.superclass.constructor.call(this);
	    this.hT = "05";
	    this.hTLV = "0500";
	};
	YAHOO.lang.extend(KJUR.asn1.DERNull, KJUR.asn1.ASN1Object);
	
	// ********************************************************************
	/**
	 * class for ASN.1 DER ObjectIdentifier
	 * @name KJUR.asn1.DERObjectIdentifier
	 * @class class for ASN.1 DER ObjectIdentifier
	 * @param {Array} params associative array of parameters (ex. {'oid': '2.5.4.5'})
	 * @extends KJUR.asn1.ASN1Object
	 * @description
	 * <br/>
	 * As for argument 'params' for constructor, you can specify one of
	 * following properties:
	 * <ul>
	 * <li>oid - specify initial ASN.1 value(V) by a oid string (ex. 2.5.4.13)</li>
	 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
	 * </ul>
	 * NOTE: 'params' can be omitted.
	 */
	KJUR.asn1.DERObjectIdentifier = function(params) {
	    var itox = function(i) {
	        var h = i.toString(16);
	        if (h.length == 1) h = '0' + h;
	        return h;
	    };
	    var roidtox = function(roid) {
	        var h = '';
	        var bi = new BigInteger(roid, 10);
	        var b = bi.toString(2);
	        var padLen = 7 - b.length % 7;
	        if (padLen == 7) padLen = 0;
	        var bPad = '';
	        for (var i = 0; i < padLen; i++) bPad += '0';
	        b = bPad + b;
	        for (var i = 0; i < b.length - 1; i += 7) {
	            var b8 = b.substr(i, 7);
	            if (i != b.length - 7) b8 = '1' + b8;
	            h += itox(parseInt(b8, 2));
	        }
	        return h;
	    };
	
	    KJUR.asn1.DERObjectIdentifier.superclass.constructor.call(this);
	    this.hT = "06";
	
	    /**
	     * set value by a hexadecimal string
	     * @name setValueHex
	     * @memberOf KJUR.asn1.DERObjectIdentifier#
	     * @function
	     * @param {String} newHexString hexadecimal value of OID bytes
	     */
	    this.setValueHex = function(newHexString) {
	        this.hTLV = null;
	        this.isModified = true;
	        this.s = null;
	        this.hV = newHexString;
	    };
	
	    /**
	     * set value by a OID string<br/>
	     * @name setValueOidString
	     * @memberOf KJUR.asn1.DERObjectIdentifier#
	     * @function
	     * @param {String} oidString OID string (ex. 2.5.4.13)
	     * @example
	     * o = new KJUR.asn1.DERObjectIdentifier();
	     * o.setValueOidString("2.5.4.13");
	     */
	    this.setValueOidString = function(oidString) {
	        if (! oidString.match(/^[0-9.]+$/)) {
	            throw "malformed oid string: " + oidString;
	        }
	        var h = '';
	        var a = oidString.split('.');
	        var i0 = parseInt(a[0]) * 40 + parseInt(a[1]);
	        h += itox(i0);
	        a.splice(0, 2);
	        for (var i = 0; i < a.length; i++) {
	            h += roidtox(a[i]);
	        }
	        this.hTLV = null;
	        this.isModified = true;
	        this.s = null;
	        this.hV = h;
	    };
	
	    /**
	     * set value by a OID name
	     * @name setValueName
	     * @memberOf KJUR.asn1.DERObjectIdentifier#
	     * @function
	     * @param {String} oidName OID name (ex. 'serverAuth')
	     * @since 1.0.1
	     * @description
	     * OID name shall be defined in 'KJUR.asn1.x509.OID.name2oidList'.
	     * Otherwise raise error.
	     * @example
	     * o = new KJUR.asn1.DERObjectIdentifier();
	     * o.setValueName("serverAuth");
	     */
	    this.setValueName = function(oidName) {
	        var oid = KJUR.asn1.x509.OID.name2oid(oidName);
	        if (oid !== '') {
	            this.setValueOidString(oid);
	        } else {
	            throw "DERObjectIdentifier oidName undefined: " + oidName;
	        }
	    };
	
	    this.getFreshValueHex = function() {
	        return this.hV;
	    };
	
	    if (params !== undefined) {
	        if (typeof params === "string") {
	            if (params.match(/^[0-2].[0-9.]+$/)) {
	                this.setValueOidString(params);
	            } else {
	                this.setValueName(params);
	            }
	        } else if (params.oid !== undefined) {
	            this.setValueOidString(params.oid);
	        } else if (params.hex !== undefined) {
	            this.setValueHex(params.hex);
	        } else if (params.name !== undefined) {
	            this.setValueName(params.name);
	        }
	    }
	};
	YAHOO.lang.extend(KJUR.asn1.DERObjectIdentifier, KJUR.asn1.ASN1Object);
	
	// ********************************************************************
	/**
	 * class for ASN.1 DER Enumerated
	 * @name KJUR.asn1.DEREnumerated
	 * @class class for ASN.1 DER Enumerated
	 * @extends KJUR.asn1.ASN1Object
	 * @description
	 * <br/>
	 * As for argument 'params' for constructor, you can specify one of
	 * following properties:
	 * <ul>
	 * <li>int - specify initial ASN.1 value(V) by integer value</li>
	 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
	 * </ul>
	 * NOTE: 'params' can be omitted.
	 * @example
	 * new KJUR.asn1.DEREnumerated(123);
	 * new KJUR.asn1.DEREnumerated({int: 123});
	 * new KJUR.asn1.DEREnumerated({hex: '1fad'});
	 */
	KJUR.asn1.DEREnumerated = function(params) {
	    KJUR.asn1.DEREnumerated.superclass.constructor.call(this);
	    this.hT = "0a";
	
	    /**
	     * set value by Tom Wu's BigInteger object
	     * @name setByBigInteger
	     * @memberOf KJUR.asn1.DEREnumerated#
	     * @function
	     * @param {BigInteger} bigIntegerValue to set
	     */
	    this.setByBigInteger = function(bigIntegerValue) {
	        this.hTLV = null;
	        this.isModified = true;
	        this.hV = KJUR.asn1.ASN1Util.bigIntToMinTwosComplementsHex(bigIntegerValue);
	    };
	
	    /**
	     * set value by integer value
	     * @name setByInteger
	     * @memberOf KJUR.asn1.DEREnumerated#
	     * @function
	     * @param {Integer} integer value to set
	     */
	    this.setByInteger = function(intValue) {
	        var bi = new BigInteger(String(intValue), 10);
	        this.setByBigInteger(bi);
	    };
	
	    /**
	     * set value by integer value
	     * @name setValueHex
	     * @memberOf KJUR.asn1.DEREnumerated#
	     * @function
	     * @param {String} hexadecimal string of integer value
	     * @description
	     * <br/>
	     * NOTE: Value shall be represented by minimum octet length of
	     * two's complement representation.
	     */
	    this.setValueHex = function(newHexString) {
	        this.hV = newHexString;
	    };
	
	    this.getFreshValueHex = function() {
	        return this.hV;
	    };
	
	    if (typeof params != "undefined") {
	        if (typeof params['int'] != "undefined") {
	            this.setByInteger(params['int']);
	        } else if (typeof params == "number") {
	            this.setByInteger(params);
	        } else if (typeof params['hex'] != "undefined") {
	            this.setValueHex(params['hex']);
	        }
	    }
	};
	YAHOO.lang.extend(KJUR.asn1.DEREnumerated, KJUR.asn1.ASN1Object);
	
	// ********************************************************************
	/**
	 * class for ASN.1 DER UTF8String
	 * @name KJUR.asn1.DERUTF8String
	 * @class class for ASN.1 DER UTF8String
	 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
	 * @extends KJUR.asn1.DERAbstractString
	 * @description
	 * @see KJUR.asn1.DERAbstractString - superclass
	 */
	KJUR.asn1.DERUTF8String = function(params) {
	    KJUR.asn1.DERUTF8String.superclass.constructor.call(this, params);
	    this.hT = "0c";
	};
	YAHOO.lang.extend(KJUR.asn1.DERUTF8String, KJUR.asn1.DERAbstractString);
	
	// ********************************************************************
	/**
	 * class for ASN.1 DER NumericString
	 * @name KJUR.asn1.DERNumericString
	 * @class class for ASN.1 DER NumericString
	 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
	 * @extends KJUR.asn1.DERAbstractString
	 * @description
	 * @see KJUR.asn1.DERAbstractString - superclass
	 */
	KJUR.asn1.DERNumericString = function(params) {
	    KJUR.asn1.DERNumericString.superclass.constructor.call(this, params);
	    this.hT = "12";
	};
	YAHOO.lang.extend(KJUR.asn1.DERNumericString, KJUR.asn1.DERAbstractString);
	
	// ********************************************************************
	/**
	 * class for ASN.1 DER PrintableString
	 * @name KJUR.asn1.DERPrintableString
	 * @class class for ASN.1 DER PrintableString
	 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
	 * @extends KJUR.asn1.DERAbstractString
	 * @description
	 * @see KJUR.asn1.DERAbstractString - superclass
	 */
	KJUR.asn1.DERPrintableString = function(params) {
	    KJUR.asn1.DERPrintableString.superclass.constructor.call(this, params);
	    this.hT = "13";
	};
	YAHOO.lang.extend(KJUR.asn1.DERPrintableString, KJUR.asn1.DERAbstractString);
	
	// ********************************************************************
	/**
	 * class for ASN.1 DER TeletexString
	 * @name KJUR.asn1.DERTeletexString
	 * @class class for ASN.1 DER TeletexString
	 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
	 * @extends KJUR.asn1.DERAbstractString
	 * @description
	 * @see KJUR.asn1.DERAbstractString - superclass
	 */
	KJUR.asn1.DERTeletexString = function(params) {
	    KJUR.asn1.DERTeletexString.superclass.constructor.call(this, params);
	    this.hT = "14";
	};
	YAHOO.lang.extend(KJUR.asn1.DERTeletexString, KJUR.asn1.DERAbstractString);
	
	// ********************************************************************
	/**
	 * class for ASN.1 DER IA5String
	 * @name KJUR.asn1.DERIA5String
	 * @class class for ASN.1 DER IA5String
	 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
	 * @extends KJUR.asn1.DERAbstractString
	 * @description
	 * @see KJUR.asn1.DERAbstractString - superclass
	 */
	KJUR.asn1.DERIA5String = function(params) {
	    KJUR.asn1.DERIA5String.superclass.constructor.call(this, params);
	    this.hT = "16";
	};
	YAHOO.lang.extend(KJUR.asn1.DERIA5String, KJUR.asn1.DERAbstractString);
	
	// ********************************************************************
	/**
	 * class for ASN.1 DER UTCTime
	 * @name KJUR.asn1.DERUTCTime
	 * @class class for ASN.1 DER UTCTime
	 * @param {Array} params associative array of parameters (ex. {'str': '130430235959Z'})
	 * @extends KJUR.asn1.DERAbstractTime
	 * @description
	 * <br/>
	 * As for argument 'params' for constructor, you can specify one of
	 * following properties:
	 * <ul>
	 * <li>str - specify initial ASN.1 value(V) by a string (ex.'130430235959Z')</li>
	 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
	 * <li>date - specify Date object.</li>
	 * </ul>
	 * NOTE: 'params' can be omitted.
	 * <h4>EXAMPLES</h4>
	 * @example
	 * d1 = new KJUR.asn1.DERUTCTime();
	 * d1.setString('130430125959Z');
	 *
	 * d2 = new KJUR.asn1.DERUTCTime({'str': '130430125959Z'});
	 * d3 = new KJUR.asn1.DERUTCTime({'date': new Date(Date.UTC(2015, 0, 31, 0, 0, 0, 0))});
	 * d4 = new KJUR.asn1.DERUTCTime('130430125959Z');
	 */
	KJUR.asn1.DERUTCTime = function(params) {
	    KJUR.asn1.DERUTCTime.superclass.constructor.call(this, params);
	    this.hT = "17";
	
	    /**
	     * set value by a Date object<br/>
	     * @name setByDate
	     * @memberOf KJUR.asn1.DERUTCTime#
	     * @function
	     * @param {Date} dateObject Date object to set ASN.1 value(V)
	     * @example
	     * o = new KJUR.asn1.DERUTCTime();
	     * o.setByDate(new Date("2016/12/31"));
	     */
	    this.setByDate = function(dateObject) {
	        this.hTLV = null;
	        this.isModified = true;
	        this.date = dateObject;
	        this.s = this.formatDate(this.date, 'utc');
	        this.hV = stohex(this.s);
	    };
	
	    this.getFreshValueHex = function() {
	        if (typeof this.date == "undefined" && typeof this.s == "undefined") {
	            this.date = new Date();
	            this.s = this.formatDate(this.date, 'utc');
	            this.hV = stohex(this.s);
	        }
	        return this.hV;
	    };
	
	    if (params !== undefined) {
	        if (params.str !== undefined) {
	            this.setString(params.str);
	        } else if (typeof params == "string" && params.match(/^[0-9]{12}Z$/)) {
	            this.setString(params);
	        } else if (params.hex !== undefined) {
	            this.setStringHex(params.hex);
	        } else if (params.date !== undefined) {
	            this.setByDate(params.date);
	        }
	    }
	};
	YAHOO.lang.extend(KJUR.asn1.DERUTCTime, KJUR.asn1.DERAbstractTime);
	
	// ********************************************************************
	/**
	 * class for ASN.1 DER GeneralizedTime
	 * @name KJUR.asn1.DERGeneralizedTime
	 * @class class for ASN.1 DER GeneralizedTime
	 * @param {Array} params associative array of parameters (ex. {'str': '20130430235959Z'})
	 * @property {Boolean} withMillis flag to show milliseconds or not
	 * @extends KJUR.asn1.DERAbstractTime
	 * @description
	 * <br/>
	 * As for argument 'params' for constructor, you can specify one of
	 * following properties:
	 * <ul>
	 * <li>str - specify initial ASN.1 value(V) by a string (ex.'20130430235959Z')</li>
	 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
	 * <li>date - specify Date object.</li>
	 * <li>millis - specify flag to show milliseconds (from 1.0.6)</li>
	 * </ul>
	 * NOTE1: 'params' can be omitted.
	 * NOTE2: 'withMillis' property is supported from asn1 1.0.6.
	 */
	KJUR.asn1.DERGeneralizedTime = function(params) {
	    KJUR.asn1.DERGeneralizedTime.superclass.constructor.call(this, params);
	    this.hT = "18";
	    this.withMillis = false;
	
	    /**
	     * set value by a Date object
	     * @name setByDate
	     * @memberOf KJUR.asn1.DERGeneralizedTime#
	     * @function
	     * @param {Date} dateObject Date object to set ASN.1 value(V)
	     * @example
	     * When you specify UTC time, use 'Date.UTC' method like this:<br/>
	     * o1 = new DERUTCTime();
	     * o1.setByDate(date);
	     *
	     * date = new Date(Date.UTC(2015, 0, 31, 23, 59, 59, 0)); #2015JAN31 23:59:59
	     */
	    this.setByDate = function(dateObject) {
	        this.hTLV = null;
	        this.isModified = true;
	        this.date = dateObject;
	        this.s = this.formatDate(this.date, 'gen', this.withMillis);
	        this.hV = stohex(this.s);
	    };
	
	    this.getFreshValueHex = function() {
	        if (this.date === undefined && this.s === undefined) {
	            this.date = new Date();
	            this.s = this.formatDate(this.date, 'gen', this.withMillis);
	            this.hV = stohex(this.s);
	        }
	        return this.hV;
	    };
	
	    if (params !== undefined) {
	        if (params.str !== undefined) {
	            this.setString(params.str);
	        } else if (typeof params == "string" && params.match(/^[0-9]{14}Z$/)) {
	            this.setString(params);
	        } else if (params.hex !== undefined) {
	            this.setStringHex(params.hex);
	        } else if (params.date !== undefined) {
	            this.setByDate(params.date);
	        }
	        if (params.millis === true) {
	            this.withMillis = true;
	        }
	    }
	};
	YAHOO.lang.extend(KJUR.asn1.DERGeneralizedTime, KJUR.asn1.DERAbstractTime);
	
	// ********************************************************************
	/**
	 * class for ASN.1 DER Sequence
	 * @name KJUR.asn1.DERSequence
	 * @class class for ASN.1 DER Sequence
	 * @extends KJUR.asn1.DERAbstractStructured
	 * @description
	 * <br/>
	 * As for argument 'params' for constructor, you can specify one of
	 * following properties:
	 * <ul>
	 * <li>array - specify array of ASN1Object to set elements of content</li>
	 * </ul>
	 * NOTE: 'params' can be omitted.
	 */
	KJUR.asn1.DERSequence = function(params) {
	    KJUR.asn1.DERSequence.superclass.constructor.call(this, params);
	    this.hT = "30";
	    this.getFreshValueHex = function() {
	        var h = '';
	        for (var i = 0; i < this.asn1Array.length; i++) {
	            var asn1Obj = this.asn1Array[i];
	            h += asn1Obj.getEncodedHex();
	        }
	        this.hV = h;
	        return this.hV;
	    };
	};
	YAHOO.lang.extend(KJUR.asn1.DERSequence, KJUR.asn1.DERAbstractStructured);
	
	// ********************************************************************
	/**
	 * class for ASN.1 DER Set
	 * @name KJUR.asn1.DERSet
	 * @class class for ASN.1 DER Set
	 * @extends KJUR.asn1.DERAbstractStructured
	 * @description
	 * <br/>
	 * As for argument 'params' for constructor, you can specify one of
	 * following properties:
	 * <ul>
	 * <li>array - specify array of ASN1Object to set elements of content</li>
	 * <li>sortflag - flag for sort (default: true). ASN.1 BER is not sorted in 'SET OF'.</li>
	 * </ul>
	 * NOTE1: 'params' can be omitted.<br/>
	 * NOTE2: sortflag is supported since 1.0.5.
	 */
	KJUR.asn1.DERSet = function(params) {
	    KJUR.asn1.DERSet.superclass.constructor.call(this, params);
	    this.hT = "31";
	    this.sortFlag = true; // item shall be sorted only in ASN.1 DER
	    this.getFreshValueHex = function() {
	        var a = new Array();
	        for (var i = 0; i < this.asn1Array.length; i++) {
	            var asn1Obj = this.asn1Array[i];
	            a.push(asn1Obj.getEncodedHex());
	        }
	        if (this.sortFlag == true) a.sort();
	        this.hV = a.join('');
	        return this.hV;
	    };
	
	    if (typeof params != "undefined") {
	        if (typeof params.sortflag != "undefined" &&
	            params.sortflag == false)
	            this.sortFlag = false;
	    }
	};
	YAHOO.lang.extend(KJUR.asn1.DERSet, KJUR.asn1.DERAbstractStructured);
	
	// ********************************************************************
	/**
	 * class for ASN.1 DER TaggedObject
	 * @name KJUR.asn1.DERTaggedObject
	 * @class class for ASN.1 DER TaggedObject
	 * @extends KJUR.asn1.ASN1Object
	 * @description
	 * <br/>
	 * Parameter 'tagNoNex' is ASN.1 tag(T) value for this object.
	 * For example, if you find '[1]' tag in a ASN.1 dump,
	 * 'tagNoHex' will be 'a1'.
	 * <br/>
	 * As for optional argument 'params' for constructor, you can specify *ANY* of
	 * following properties:
	 * <ul>
	 * <li>explicit - specify true if this is explicit tag otherwise false
	 *     (default is 'true').</li>
	 * <li>tag - specify tag (default is 'a0' which means [0])</li>
	 * <li>obj - specify ASN1Object which is tagged</li>
	 * </ul>
	 * @example
	 * d1 = new KJUR.asn1.DERUTF8String({'str':'a'});
	 * d2 = new KJUR.asn1.DERTaggedObject({'obj': d1});
	 * hex = d2.getEncodedHex();
	 */
	KJUR.asn1.DERTaggedObject = function(params) {
	    KJUR.asn1.DERTaggedObject.superclass.constructor.call(this);
	    this.hT = "a0";
	    this.hV = '';
	    this.isExplicit = true;
	    this.asn1Object = null;
	
	    /**
	     * set value by an ASN1Object
	     * @name setString
	     * @memberOf KJUR.asn1.DERTaggedObject#
	     * @function
	     * @param {Boolean} isExplicitFlag flag for explicit/implicit tag
	     * @param {Integer} tagNoHex hexadecimal string of ASN.1 tag
	     * @param {ASN1Object} asn1Object ASN.1 to encapsulate
	     */
	    this.setASN1Object = function(isExplicitFlag, tagNoHex, asn1Object) {
	        this.hT = tagNoHex;
	        this.isExplicit = isExplicitFlag;
	        this.asn1Object = asn1Object;
	        if (this.isExplicit) {
	            this.hV = this.asn1Object.getEncodedHex();
	            this.hTLV = null;
	            this.isModified = true;
	        } else {
	            this.hV = null;
	            this.hTLV = asn1Object.getEncodedHex();
	            this.hTLV = this.hTLV.replace(/^../, tagNoHex);
	            this.isModified = false;
	        }
	    };
	
	    this.getFreshValueHex = function() {
	        return this.hV;
	    };
	
	    if (typeof params != "undefined") {
	        if (typeof params['tag'] != "undefined") {
	            this.hT = params['tag'];
	        }
	        if (typeof params['explicit'] != "undefined") {
	            this.isExplicit = params['explicit'];
	        }
	        if (typeof params['obj'] != "undefined") {
	            this.asn1Object = params['obj'];
	            this.setASN1Object(this.isExplicit, this.hT, this.asn1Object);
	        }
	    }
	};
	YAHOO.lang.extend(KJUR.asn1.DERTaggedObject, KJUR.asn1.ASN1Object);
	
	/**
	 * Create a new JSEncryptRSAKey that extends Tom Wu's RSA key object.
	 * This object is just a decorator for parsing the key parameter
	 * @param {string|Object} key - The key in string format, or an object containing
	 * the parameters needed to build a RSAKey object.
	 * @constructor
	 */
	var JSEncryptRSAKey = /** @class */ (function (_super) {
	    __extends(JSEncryptRSAKey, _super);
	    function JSEncryptRSAKey(key) {
	        var _this = _super.call(this) || this;
	        // Call the super constructor.
	        //  RSAKey.call(this);
	        // If a key key was provided.
	        if (key) {
	            // If this is a string...
	            if (typeof key === "string") {
	                _this.parseKey(key);
	            }
	            else if (JSEncryptRSAKey.hasPrivateKeyProperty(key) ||
	                JSEncryptRSAKey.hasPublicKeyProperty(key)) {
	                // Set the values for the key.
	                _this.parsePropertiesFrom(key);
	            }
	        }
	        return _this;
	    }
	    /**
	     * Method to parse a pem encoded string containing both a public or private key.
	     * The method will translate the pem encoded string in a der encoded string and
	     * will parse private key and public key parameters. This method accepts public key
	     * in the rsaencryption pkcs #1 format (oid: 1.2.840.113549.1.1.1).
	     *
	     * @todo Check how many rsa formats use the same format of pkcs #1.
	     *
	     * The format is defined as:
	     * PublicKeyInfo ::= SEQUENCE {
	     *   algorithm       AlgorithmIdentifier,
	     *   PublicKey       BIT STRING
	     * }
	     * Where AlgorithmIdentifier is:
	     * AlgorithmIdentifier ::= SEQUENCE {
	     *   algorithm       OBJECT IDENTIFIER,     the OID of the enc algorithm
	     *   parameters      ANY DEFINED BY algorithm OPTIONAL (NULL for PKCS #1)
	     * }
	     * and PublicKey is a SEQUENCE encapsulated in a BIT STRING
	     * RSAPublicKey ::= SEQUENCE {
	     *   modulus           INTEGER,  -- n
	     *   publicExponent    INTEGER   -- e
	     * }
	     * it's possible to examine the structure of the keys obtained from openssl using
	     * an asn.1 dumper as the one used here to parse the components: http://lapo.it/asn1js/
	     * @argument {string} pem the pem encoded string, can include the BEGIN/END header/footer
	     * @private
	     */
	    JSEncryptRSAKey.prototype.parseKey = function (pem) {
	        try {
	            var modulus = 0;
	            var public_exponent = 0;
	            var reHex = /^\s*(?:[0-9A-Fa-f][0-9A-Fa-f]\s*)+$/;
	            var der = reHex.test(pem) ? Hex.decode(pem) : Base64.unarmor(pem);
	            var asn1 = ASN1.decode(der);
	            // Fixes a bug with OpenSSL 1.0+ private keys
	            if (asn1.sub.length === 3) {
	                asn1 = asn1.sub[2].sub[0];
	            }
	            if (asn1.sub.length === 9) {
	                // Parse the private key.
	                modulus = asn1.sub[1].getHexStringValue(); // bigint
	                this.n = parseBigInt(modulus, 16);
	                public_exponent = asn1.sub[2].getHexStringValue(); // int
	                this.e = parseInt(public_exponent, 16);
	                var private_exponent = asn1.sub[3].getHexStringValue(); // bigint
	                this.d = parseBigInt(private_exponent, 16);
	                var prime1 = asn1.sub[4].getHexStringValue(); // bigint
	                this.p = parseBigInt(prime1, 16);
	                var prime2 = asn1.sub[5].getHexStringValue(); // bigint
	                this.q = parseBigInt(prime2, 16);
	                var exponent1 = asn1.sub[6].getHexStringValue(); // bigint
	                this.dmp1 = parseBigInt(exponent1, 16);
	                var exponent2 = asn1.sub[7].getHexStringValue(); // bigint
	                this.dmq1 = parseBigInt(exponent2, 16);
	                var coefficient = asn1.sub[8].getHexStringValue(); // bigint
	                this.coeff = parseBigInt(coefficient, 16);
	            }
	            else if (asn1.sub.length === 2) {
	                // Parse the public key.
	                var bit_string = asn1.sub[1];
	                var sequence = bit_string.sub[0];
	                modulus = sequence.sub[0].getHexStringValue();
	                this.n = parseBigInt(modulus, 16);
	                public_exponent = sequence.sub[1].getHexStringValue();
	                this.e = parseInt(public_exponent, 16);
	            }
	            else {
	                return false;
	            }
	            return true;
	        }
	        catch (ex) {
	            return false;
	        }
	    };
	    /**
	     * Translate rsa parameters in a hex encoded string representing the rsa key.
	     *
	     * The translation follow the ASN.1 notation :
	     * RSAPrivateKey ::= SEQUENCE {
	     *   version           Version,
	     *   modulus           INTEGER,  -- n
	     *   publicExponent    INTEGER,  -- e
	     *   privateExponent   INTEGER,  -- d
	     *   prime1            INTEGER,  -- p
	     *   prime2            INTEGER,  -- q
	     *   exponent1         INTEGER,  -- d mod (p1)
	     *   exponent2         INTEGER,  -- d mod (q-1)
	     *   coefficient       INTEGER,  -- (inverse of q) mod p
	     * }
	     * @returns {string}  DER Encoded String representing the rsa private key
	     * @private
	     */
	    JSEncryptRSAKey.prototype.getPrivateBaseKey = function () {
	        var options = {
	            array: [
	                new KJUR.asn1.DERInteger({ int: 0 }),
	                new KJUR.asn1.DERInteger({ bigint: this.n }),
	                new KJUR.asn1.DERInteger({ int: this.e }),
	                new KJUR.asn1.DERInteger({ bigint: this.d }),
	                new KJUR.asn1.DERInteger({ bigint: this.p }),
	                new KJUR.asn1.DERInteger({ bigint: this.q }),
	                new KJUR.asn1.DERInteger({ bigint: this.dmp1 }),
	                new KJUR.asn1.DERInteger({ bigint: this.dmq1 }),
	                new KJUR.asn1.DERInteger({ bigint: this.coeff })
	            ]
	        };
	        var seq = new KJUR.asn1.DERSequence(options);
	        return seq.getEncodedHex();
	    };
	    /**
	     * base64 (pem) encoded version of the DER encoded representation
	     * @returns {string} pem encoded representation without header and footer
	     * @public
	     */
	    JSEncryptRSAKey.prototype.getPrivateBaseKeyB64 = function () {
	        return hex2b64(this.getPrivateBaseKey());
	    };
	    /**
	     * Translate rsa parameters in a hex encoded string representing the rsa public key.
	     * The representation follow the ASN.1 notation :
	     * PublicKeyInfo ::= SEQUENCE {
	     *   algorithm       AlgorithmIdentifier,
	     *   PublicKey       BIT STRING
	     * }
	     * Where AlgorithmIdentifier is:
	     * AlgorithmIdentifier ::= SEQUENCE {
	     *   algorithm       OBJECT IDENTIFIER,     the OID of the enc algorithm
	     *   parameters      ANY DEFINED BY algorithm OPTIONAL (NULL for PKCS #1)
	     * }
	     * and PublicKey is a SEQUENCE encapsulated in a BIT STRING
	     * RSAPublicKey ::= SEQUENCE {
	     *   modulus           INTEGER,  -- n
	     *   publicExponent    INTEGER   -- e
	     * }
	     * @returns {string} DER Encoded String representing the rsa public key
	     * @private
	     */
	    JSEncryptRSAKey.prototype.getPublicBaseKey = function () {
	        var first_sequence = new KJUR.asn1.DERSequence({
	            array: [
	                new KJUR.asn1.DERObjectIdentifier({ oid: "1.2.840.113549.1.1.1" }),
	                new KJUR.asn1.DERNull()
	            ]
	        });
	        var second_sequence = new KJUR.asn1.DERSequence({
	            array: [
	                new KJUR.asn1.DERInteger({ bigint: this.n }),
	                new KJUR.asn1.DERInteger({ int: this.e })
	            ]
	        });
	        var bit_string = new KJUR.asn1.DERBitString({
	            hex: "00" + second_sequence.getEncodedHex()
	        });
	        var seq = new KJUR.asn1.DERSequence({
	            array: [
	                first_sequence,
	                bit_string
	            ]
	        });
	        return seq.getEncodedHex();
	    };
	    /**
	     * base64 (pem) encoded version of the DER encoded representation
	     * @returns {string} pem encoded representation without header and footer
	     * @public
	     */
	    JSEncryptRSAKey.prototype.getPublicBaseKeyB64 = function () {
	        return hex2b64(this.getPublicBaseKey());
	    };
	    /**
	     * wrap the string in block of width chars. The default value for rsa keys is 64
	     * characters.
	     * @param {string} str the pem encoded string without header and footer
	     * @param {Number} [width=64] - the length the string has to be wrapped at
	     * @returns {string}
	     * @private
	     */
	    JSEncryptRSAKey.wordwrap = function (str, width) {
	        width = width || 64;
	        if (!str) {
	            return str;
	        }
	        var regex = "(.{1," + width + "})( +|$\n?)|(.{1," + width + "})";
	        return str.match(RegExp(regex, "g")).join("\n");
	    };
	    /**
	     * Retrieve the pem encoded private key
	     * @returns {string} the pem encoded private key with header/footer
	     * @public
	     */
	    JSEncryptRSAKey.prototype.getPrivateKey = function () {
	        var key = "-----BEGIN RSA PRIVATE KEY-----\n";
	        key += JSEncryptRSAKey.wordwrap(this.getPrivateBaseKeyB64()) + "\n";
	        key += "-----END RSA PRIVATE KEY-----";
	        return key;
	    };
	    /**
	     * Retrieve the pem encoded public key
	     * @returns {string} the pem encoded public key with header/footer
	     * @public
	     */
	    JSEncryptRSAKey.prototype.getPublicKey = function () {
	        var key = "-----BEGIN PUBLIC KEY-----\n";
	        key += JSEncryptRSAKey.wordwrap(this.getPublicBaseKeyB64()) + "\n";
	        key += "-----END PUBLIC KEY-----";
	        return key;
	    };
	    /**
	     * Check if the object contains the necessary parameters to populate the rsa modulus
	     * and public exponent parameters.
	     * @param {Object} [obj={}] - An object that may contain the two public key
	     * parameters
	     * @returns {boolean} true if the object contains both the modulus and the public exponent
	     * properties (n and e)
	     * @todo check for types of n and e. N should be a parseable bigInt object, E should
	     * be a parseable integer number
	     * @private
	     */
	    JSEncryptRSAKey.hasPublicKeyProperty = function (obj) {
	        obj = obj || {};
	        return (obj.hasOwnProperty("n") &&
	            obj.hasOwnProperty("e"));
	    };
	    /**
	     * Check if the object contains ALL the parameters of an RSA key.
	     * @param {Object} [obj={}] - An object that may contain nine rsa key
	     * parameters
	     * @returns {boolean} true if the object contains all the parameters needed
	     * @todo check for types of the parameters all the parameters but the public exponent
	     * should be parseable bigint objects, the public exponent should be a parseable integer number
	     * @private
	     */
	    JSEncryptRSAKey.hasPrivateKeyProperty = function (obj) {
	        obj = obj || {};
	        return (obj.hasOwnProperty("n") &&
	            obj.hasOwnProperty("e") &&
	            obj.hasOwnProperty("d") &&
	            obj.hasOwnProperty("p") &&
	            obj.hasOwnProperty("q") &&
	            obj.hasOwnProperty("dmp1") &&
	            obj.hasOwnProperty("dmq1") &&
	            obj.hasOwnProperty("coeff"));
	    };
	    /**
	     * Parse the properties of obj in the current rsa object. Obj should AT LEAST
	     * include the modulus and public exponent (n, e) parameters.
	     * @param {Object} obj - the object containing rsa parameters
	     * @private
	     */
	    JSEncryptRSAKey.prototype.parsePropertiesFrom = function (obj) {
	        this.n = obj.n;
	        this.e = obj.e;
	        if (obj.hasOwnProperty("d")) {
	            this.d = obj.d;
	            this.p = obj.p;
	            this.q = obj.q;
	            this.dmp1 = obj.dmp1;
	            this.dmq1 = obj.dmq1;
	            this.coeff = obj.coeff;
	        }
	    };
	    return JSEncryptRSAKey;
	}(RSAKey));
	
	/**
	 *
	 * @param {Object} [options = {}] - An object to customize JSEncrypt behaviour
	 * possible parameters are:
	 * - default_key_size        {number}  default: 1024 the key size in bit
	 * - default_public_exponent {string}  default: '010001' the hexadecimal representation of the public exponent
	 * - log                     {boolean} default: false whether log warn/error or not
	 * @constructor
	 */
	var JSEncrypt = /** @class */ (function () {
	    function JSEncrypt(options) {
	        options = options || {};
	        this.default_key_size = parseInt(options.default_key_size, 10) || 1024;
	        this.default_public_exponent = options.default_public_exponent || "010001"; // 65537 default openssl public exponent for rsa key type
	        this.log = options.log || false;
	        // The private and public key.
	        this.key = null;
	    }
	    /**
	     * Method to set the rsa key parameter (one method is enough to set both the public
	     * and the private key, since the private key contains the public key paramenters)
	     * Log a warning if logs are enabled
	     * @param {Object|string} key the pem encoded string or an object (with or without header/footer)
	     * @public
	     */
	    JSEncrypt.prototype.setKey = function (key) {
	        if (this.log && this.key) {
	            console.warn("A key was already set, overriding existing.");
	        }
	        this.key = new JSEncryptRSAKey(key);
	    };
	    /**
	     * Proxy method for setKey, for api compatibility
	     * @see setKey
	     * @public
	     */
	    JSEncrypt.prototype.setPrivateKey = function (privkey) {
	        // Create the key.
	        this.setKey(privkey);
	    };
	    /**
	     * Proxy method for setKey, for api compatibility
	     * @see setKey
	     * @public
	     */
	    JSEncrypt.prototype.setPublicKey = function (pubkey) {
	        // Sets the public key.
	        this.setKey(pubkey);
	    };
	    /**
	     * Proxy method for RSAKey object's decrypt, decrypt the string using the private
	     * components of the rsa key object. Note that if the object was not set will be created
	     * on the fly (by the getKey method) using the parameters passed in the JSEncrypt constructor
	     * @param {string} str base64 encoded crypted string to decrypt
	     * @return {string} the decrypted string
	     * @public
	     */
	    JSEncrypt.prototype.decrypt = function (str) {
	        // Return the decrypted string.
	        try {
	            return this.getKey().decrypt(b64tohex(str));
	        }
	        catch (ex) {
	            return false;
	        }
	    };
	    /**
	     * Proxy method for RSAKey object's encrypt, encrypt the string using the public
	     * components of the rsa key object. Note that if the object was not set will be created
	     * on the fly (by the getKey method) using the parameters passed in the JSEncrypt constructor
	     * @param {string} str the string to encrypt
	     * @return {string} the encrypted string encoded in base64
	     * @public
	     */
	    JSEncrypt.prototype.encrypt = function (str) {
	        // Return the encrypted string.
	        try {
	            return hex2b64(this.getKey().encrypt(str));
	        }
	        catch (ex) {
	            return false;
	        }
	    };
	    /**
	     * Proxy method for RSAKey object's sign.
	     * @param {string} str the string to sign
	     * @param {function} digestMethod hash method
	     * @param {string} digestName the name of the hash algorithm
	     * @return {string} the signature encoded in base64
	     * @public
	     */
	    JSEncrypt.prototype.sign = function (str, digestMethod, digestName) {
	        // return the RSA signature of 'str' in 'hex' format.
	        try {
	            return hex2b64(this.getKey().sign(str, digestMethod, digestName));
	        }
	        catch (ex) {
	            return false;
	        }
	    };
	    /**
	     * Proxy method for RSAKey object's verify.
	     * @param {string} str the string to verify
	     * @param {string} signature the signature encoded in base64 to compare the string to
	     * @param {function} digestMethod hash method
	     * @return {boolean} whether the data and signature match
	     * @public
	     */
	    JSEncrypt.prototype.verify = function (str, signature, digestMethod) {
	        // Return the decrypted 'digest' of the signature.
	        try {
	            return this.getKey().verify(str, b64tohex(signature), digestMethod);
	        }
	        catch (ex) {
	            return false;
	        }
	    };
	    /**
	     * Getter for the current JSEncryptRSAKey object. If it doesn't exists a new object
	     * will be created and returned
	     * @param {callback} [cb] the callback to be called if we want the key to be generated
	     * in an async fashion
	     * @returns {JSEncryptRSAKey} the JSEncryptRSAKey object
	     * @public
	     */
	    JSEncrypt.prototype.getKey = function (cb) {
	        // Only create new if it does not exist.
	        if (!this.key) {
	            // Get a new private key.
	            this.key = new JSEncryptRSAKey();
	            if (cb && {}.toString.call(cb) === "[object Function]") {
	                this.key.generateAsync(this.default_key_size, this.default_public_exponent, cb);
	                return;
	            }
	            // Generate the key.
	            this.key.generate(this.default_key_size, this.default_public_exponent);
	        }
	        return this.key;
	    };
	    /**
	     * Returns the pem encoded representation of the private key
	     * If the key doesn't exists a new key will be created
	     * @returns {string} pem encoded representation of the private key WITH header and footer
	     * @public
	     */
	    JSEncrypt.prototype.getPrivateKey = function () {
	        // Return the private representation of this key.
	        return this.getKey().getPrivateKey();
	    };
	    /**
	     * Returns the pem encoded representation of the private key
	     * If the key doesn't exists a new key will be created
	     * @returns {string} pem encoded representation of the private key WITHOUT header and footer
	     * @public
	     */
	    JSEncrypt.prototype.getPrivateKeyB64 = function () {
	        // Return the private representation of this key.
	        return this.getKey().getPrivateBaseKeyB64();
	    };
	    /**
	     * Returns the pem encoded representation of the public key
	     * If the key doesn't exists a new key will be created
	     * @returns {string} pem encoded representation of the public key WITH header and footer
	     * @public
	     */
	    JSEncrypt.prototype.getPublicKey = function () {
	        // Return the private representation of this key.
	        return this.getKey().getPublicKey();
	    };
	    /**
	     * Returns the pem encoded representation of the public key
	     * If the key doesn't exists a new key will be created
	     * @returns {string} pem encoded representation of the public key WITHOUT header and footer
	     * @public
	     */
	    JSEncrypt.prototype.getPublicKeyB64 = function () {
	        // Return the private representation of this key.
	        return this.getKey().getPublicBaseKeyB64();
	    };
	    JSEncrypt.version = "3.0.0-rc.1";
	    return JSEncrypt;
	}());
	
	window.JSEncrypt = JSEncrypt;
	
	exports.JSEncrypt = JSEncrypt;
	exports.default = JSEncrypt;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
	 * Vue.js v1.0.28
	 * (c) 2016 Evan You
	 * Released under the MIT License.
	 */
	'use strict';
	
	function set(obj, key, val) {
	  if (hasOwn(obj, key)) {
	    obj[key] = val;
	    return;
	  }
	  if (obj._isVue) {
	    set(obj._data, key, val);
	    return;
	  }
	  var ob = obj.__ob__;
	  if (!ob) {
	    obj[key] = val;
	    return;
	  }
	  ob.convert(key, val);
	  ob.dep.notify();
	  if (ob.vms) {
	    var i = ob.vms.length;
	    while (i--) {
	      var vm = ob.vms[i];
	      vm._proxy(key);
	      vm._digest();
	    }
	  }
	  return val;
	}
	
	/**
	 * Delete a property and trigger change if necessary.
	 *
	 * @param {Object} obj
	 * @param {String} key
	 */
	
	function del(obj, key) {
	  if (!hasOwn(obj, key)) {
	    return;
	  }
	  delete obj[key];
	  var ob = obj.__ob__;
	  if (!ob) {
	    if (obj._isVue) {
	      delete obj._data[key];
	      obj._digest();
	    }
	    return;
	  }
	  ob.dep.notify();
	  if (ob.vms) {
	    var i = ob.vms.length;
	    while (i--) {
	      var vm = ob.vms[i];
	      vm._unproxy(key);
	      vm._digest();
	    }
	  }
	}
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	/**
	 * Check whether the object has the property.
	 *
	 * @param {Object} obj
	 * @param {String} key
	 * @return {Boolean}
	 */
	
	function hasOwn(obj, key) {
	  return hasOwnProperty.call(obj, key);
	}
	
	/**
	 * Check if an expression is a literal value.
	 *
	 * @param {String} exp
	 * @return {Boolean}
	 */
	
	var literalValueRE = /^\s?(true|false|-?[\d\.]+|'[^']*'|"[^"]*")\s?$/;
	
	function isLiteral(exp) {
	  return literalValueRE.test(exp);
	}
	
	/**
	 * Check if a string starts with $ or _
	 *
	 * @param {String} str
	 * @return {Boolean}
	 */
	
	function isReserved(str) {
	  var c = (str + '').charCodeAt(0);
	  return c === 0x24 || c === 0x5F;
	}
	
	/**
	 * Guard text output, make sure undefined outputs
	 * empty string
	 *
	 * @param {*} value
	 * @return {String}
	 */
	
	function _toString(value) {
	  return value == null ? '' : value.toString();
	}
	
	/**
	 * Check and convert possible numeric strings to numbers
	 * before setting back to data
	 *
	 * @param {*} value
	 * @return {*|Number}
	 */
	
	function toNumber(value) {
	  if (typeof value !== 'string') {
	    return value;
	  } else {
	    var parsed = Number(value);
	    return isNaN(parsed) ? value : parsed;
	  }
	}
	
	/**
	 * Convert string boolean literals into real booleans.
	 *
	 * @param {*} value
	 * @return {*|Boolean}
	 */
	
	function toBoolean(value) {
	  return value === 'true' ? true : value === 'false' ? false : value;
	}
	
	/**
	 * Strip quotes from a string
	 *
	 * @param {String} str
	 * @return {String | false}
	 */
	
	function stripQuotes(str) {
	  var a = str.charCodeAt(0);
	  var b = str.charCodeAt(str.length - 1);
	  return a === b && (a === 0x22 || a === 0x27) ? str.slice(1, -1) : str;
	}
	
	/**
	 * Camelize a hyphen-delimited string.
	 *
	 * @param {String} str
	 * @return {String}
	 */
	
	var camelizeRE = /-(\w)/g;
	
	function camelize(str) {
	  return str.replace(camelizeRE, toUpper);
	}
	
	function toUpper(_, c) {
	  return c ? c.toUpperCase() : '';
	}
	
	/**
	 * Hyphenate a camelCase string.
	 *
	 * @param {String} str
	 * @return {String}
	 */
	
	var hyphenateRE = /([^-])([A-Z])/g;
	
	function hyphenate(str) {
	  return str.replace(hyphenateRE, '$1-$2').replace(hyphenateRE, '$1-$2').toLowerCase();
	}
	
	/**
	 * Converts hyphen/underscore/slash delimitered names into
	 * camelized classNames.
	 *
	 * e.g. my-component => MyComponent
	 *      some_else    => SomeElse
	 *      some/comp    => SomeComp
	 *
	 * @param {String} str
	 * @return {String}
	 */
	
	var classifyRE = /(?:^|[-_\/])(\w)/g;
	
	function classify(str) {
	  return str.replace(classifyRE, toUpper);
	}
	
	/**
	 * Simple bind, faster than native
	 *
	 * @param {Function} fn
	 * @param {Object} ctx
	 * @return {Function}
	 */
	
	function bind(fn, ctx) {
	  return function (a) {
	    var l = arguments.length;
	    return l ? l > 1 ? fn.apply(ctx, arguments) : fn.call(ctx, a) : fn.call(ctx);
	  };
	}
	
	/**
	 * Convert an Array-like object to a real Array.
	 *
	 * @param {Array-like} list
	 * @param {Number} [start] - start index
	 * @return {Array}
	 */
	
	function toArray(list, start) {
	  start = start || 0;
	  var i = list.length - start;
	  var ret = new Array(i);
	  while (i--) {
	    ret[i] = list[i + start];
	  }
	  return ret;
	}
	
	/**
	 * Mix properties into target object.
	 *
	 * @param {Object} to
	 * @param {Object} from
	 */
	
	function extend(to, from) {
	  var keys = Object.keys(from);
	  var i = keys.length;
	  while (i--) {
	    to[keys[i]] = from[keys[i]];
	  }
	  return to;
	}
	
	/**
	 * Quick object check - this is primarily used to tell
	 * Objects from primitive values when we know the value
	 * is a JSON-compliant type.
	 *
	 * @param {*} obj
	 * @return {Boolean}
	 */
	
	function isObject(obj) {
	  return obj !== null && typeof obj === 'object';
	}
	
	/**
	 * Strict object type check. Only returns true
	 * for plain JavaScript objects.
	 *
	 * @param {*} obj
	 * @return {Boolean}
	 */
	
	var toString = Object.prototype.toString;
	var OBJECT_STRING = '[object Object]';
	
	function isPlainObject(obj) {
	  return toString.call(obj) === OBJECT_STRING;
	}
	
	/**
	 * Array type check.
	 *
	 * @param {*} obj
	 * @return {Boolean}
	 */
	
	var isArray = Array.isArray;
	
	/**
	 * Define a property.
	 *
	 * @param {Object} obj
	 * @param {String} key
	 * @param {*} val
	 * @param {Boolean} [enumerable]
	 */
	
	function def(obj, key, val, enumerable) {
	  Object.defineProperty(obj, key, {
	    value: val,
	    enumerable: !!enumerable,
	    writable: true,
	    configurable: true
	  });
	}
	
	/**
	 * Debounce a function so it only gets called after the
	 * input stops arriving after the given wait period.
	 *
	 * @param {Function} func
	 * @param {Number} wait
	 * @return {Function} - the debounced function
	 */
	
	function _debounce(func, wait) {
	  var timeout, args, context, timestamp, result;
	  var later = function later() {
	    var last = Date.now() - timestamp;
	    if (last < wait && last >= 0) {
	      timeout = setTimeout(later, wait - last);
	    } else {
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    }
	  };
	  return function () {
	    context = this;
	    args = arguments;
	    timestamp = Date.now();
	    if (!timeout) {
	      timeout = setTimeout(later, wait);
	    }
	    return result;
	  };
	}
	
	/**
	 * Manual indexOf because it's slightly faster than
	 * native.
	 *
	 * @param {Array} arr
	 * @param {*} obj
	 */
	
	function indexOf(arr, obj) {
	  var i = arr.length;
	  while (i--) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	}
	
	/**
	 * Make a cancellable version of an async callback.
	 *
	 * @param {Function} fn
	 * @return {Function}
	 */
	
	function cancellable(fn) {
	  var cb = function cb() {
	    if (!cb.cancelled) {
	      return fn.apply(this, arguments);
	    }
	  };
	  cb.cancel = function () {
	    cb.cancelled = true;
	  };
	  return cb;
	}
	
	/**
	 * Check if two values are loosely equal - that is,
	 * if they are plain objects, do they have the same shape?
	 *
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 */
	
	function looseEqual(a, b) {
	  /* eslint-disable eqeqeq */
	  return a == b || (isObject(a) && isObject(b) ? JSON.stringify(a) === JSON.stringify(b) : false);
	  /* eslint-enable eqeqeq */
	}
	
	var hasProto = ('__proto__' in {});
	
	// Browser environment sniffing
	var inBrowser = typeof window !== 'undefined' && Object.prototype.toString.call(window) !== '[object Object]';
	
	// detect devtools
	var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
	
	// UA sniffing for working around browser-specific quirks
	var UA = inBrowser && window.navigator.userAgent.toLowerCase();
	var isIE = UA && UA.indexOf('trident') > 0;
	var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
	var isAndroid = UA && UA.indexOf('android') > 0;
	var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA);
	
	var transitionProp = undefined;
	var transitionEndEvent = undefined;
	var animationProp = undefined;
	var animationEndEvent = undefined;
	
	// Transition property/event sniffing
	if (inBrowser && !isIE9) {
	  var isWebkitTrans = window.ontransitionend === undefined && window.onwebkittransitionend !== undefined;
	  var isWebkitAnim = window.onanimationend === undefined && window.onwebkitanimationend !== undefined;
	  transitionProp = isWebkitTrans ? 'WebkitTransition' : 'transition';
	  transitionEndEvent = isWebkitTrans ? 'webkitTransitionEnd' : 'transitionend';
	  animationProp = isWebkitAnim ? 'WebkitAnimation' : 'animation';
	  animationEndEvent = isWebkitAnim ? 'webkitAnimationEnd' : 'animationend';
	}
	
	/* istanbul ignore next */
	function isNative(Ctor) {
	  return (/native code/.test(Ctor.toString())
	  );
	}
	
	/**
	 * Defer a task to execute it asynchronously. Ideally this
	 * should be executed as a microtask, so we leverage
	 * MutationObserver if it's available, and fallback to
	 * setTimeout(0).
	 *
	 * @param {Function} cb
	 * @param {Object} ctx
	 */
	
	var nextTick = (function () {
	  var callbacks = [];
	  var pending = false;
	  var timerFunc = undefined;
	
	  function nextTickHandler() {
	    pending = false;
	    var copies = callbacks.slice(0);
	    callbacks.length = 0;
	    for (var i = 0; i < copies.length; i++) {
	      copies[i]();
	    }
	  }
	
	  // the nextTick behavior leverages the microtask queue, which can be accessed
	  // via either native Promise.then or MutationObserver.
	  // MutationObserver has wider support, however it is seriously bugged in
	  // UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
	  // completely stops working after triggering a few times... so, if native
	  // Promise is available, we will use it:
	  /* istanbul ignore if */
	  if (typeof Promise !== 'undefined' && isNative(Promise)) {
	    var p = Promise.resolve();
	    var noop = function noop() {};
	    timerFunc = function () {
	      p.then(nextTickHandler);
	      // in problematic UIWebViews, Promise.then doesn't completely break, but
	      // it can get stuck in a weird state where callbacks are pushed into the
	      // microtask queue but the queue isn't being flushed, until the browser
	      // needs to do some other work, e.g. handle a timer. Therefore we can
	      // "force" the microtask queue to be flushed by adding an empty timer.
	      if (isIOS) setTimeout(noop);
	    };
	  } else if (typeof MutationObserver !== 'undefined') {
	    // use MutationObserver where native Promise is not available,
	    // e.g. IE11, iOS7, Android 4.4
	    var counter = 1;
	    var observer = new MutationObserver(nextTickHandler);
	    var textNode = document.createTextNode(String(counter));
	    observer.observe(textNode, {
	      characterData: true
	    });
	    timerFunc = function () {
	      counter = (counter + 1) % 2;
	      textNode.data = String(counter);
	    };
	  } else {
	    // fallback to setTimeout
	    /* istanbul ignore next */
	    timerFunc = setTimeout;
	  }
	
	  return function (cb, ctx) {
	    var func = ctx ? function () {
	      cb.call(ctx);
	    } : cb;
	    callbacks.push(func);
	    if (pending) return;
	    pending = true;
	    timerFunc(nextTickHandler, 0);
	  };
	})();
	
	var _Set = undefined;
	/* istanbul ignore if */
	if (typeof Set !== 'undefined' && isNative(Set)) {
	  // use native Set when available.
	  _Set = Set;
	} else {
	  // a non-standard Set polyfill that only works with primitive keys.
	  _Set = function () {
	    this.set = Object.create(null);
	  };
	  _Set.prototype.has = function (key) {
	    return this.set[key] !== undefined;
	  };
	  _Set.prototype.add = function (key) {
	    this.set[key] = 1;
	  };
	  _Set.prototype.clear = function () {
	    this.set = Object.create(null);
	  };
	}
	
	function Cache(limit) {
	  this.size = 0;
	  this.limit = limit;
	  this.head = this.tail = undefined;
	  this._keymap = Object.create(null);
	}
	
	var p = Cache.prototype;
	
	/**
	 * Put <value> into the cache associated with <key>.
	 * Returns the entry which was removed to make room for
	 * the new entry. Otherwise undefined is returned.
	 * (i.e. if there was enough room already).
	 *
	 * @param {String} key
	 * @param {*} value
	 * @return {Entry|undefined}
	 */
	
	p.put = function (key, value) {
	  var removed;
	
	  var entry = this.get(key, true);
	  if (!entry) {
	    if (this.size === this.limit) {
	      removed = this.shift();
	    }
	    entry = {
	      key: key
	    };
	    this._keymap[key] = entry;
	    if (this.tail) {
	      this.tail.newer = entry;
	      entry.older = this.tail;
	    } else {
	      this.head = entry;
	    }
	    this.tail = entry;
	    this.size++;
	  }
	  entry.value = value;
	
	  return removed;
	};
	
	/**
	 * Purge the least recently used (oldest) entry from the
	 * cache. Returns the removed entry or undefined if the
	 * cache was empty.
	 */
	
	p.shift = function () {
	  var entry = this.head;
	  if (entry) {
	    this.head = this.head.newer;
	    this.head.older = undefined;
	    entry.newer = entry.older = undefined;
	    this._keymap[entry.key] = undefined;
	    this.size--;
	  }
	  return entry;
	};
	
	/**
	 * Get and register recent use of <key>. Returns the value
	 * associated with <key> or undefined if not in cache.
	 *
	 * @param {String} key
	 * @param {Boolean} returnEntry
	 * @return {Entry|*}
	 */
	
	p.get = function (key, returnEntry) {
	  var entry = this._keymap[key];
	  if (entry === undefined) return;
	  if (entry === this.tail) {
	    return returnEntry ? entry : entry.value;
	  }
	  // HEAD--------------TAIL
	  //   <.older   .newer>
	  //  <--- add direction --
	  //   A  B  C  <D>  E
	  if (entry.newer) {
	    if (entry === this.head) {
	      this.head = entry.newer;
	    }
	    entry.newer.older = entry.older; // C <-- E.
	  }
	  if (entry.older) {
	    entry.older.newer = entry.newer; // C. --> E
	  }
	  entry.newer = undefined; // D --x
	  entry.older = this.tail; // D. --> E
	  if (this.tail) {
	    this.tail.newer = entry; // E. <-- D
	  }
	  this.tail = entry;
	  return returnEntry ? entry : entry.value;
	};
	
	var cache$1 = new Cache(1000);
	var reservedArgRE = /^in$|^-?\d+/;
	
	/**
	 * Parser state
	 */
	
	var str;
	var dir;
	var len;
	var index;
	var chr;
	var state;
	var startState = 0;
	var filterState = 1;
	var filterNameState = 2;
	var filterArgState = 3;
	
	var doubleChr = 0x22;
	var singleChr = 0x27;
	var pipeChr = 0x7C;
	var escapeChr = 0x5C;
	var spaceChr = 0x20;
	
	var expStartChr = { 0x5B: 1, 0x7B: 1, 0x28: 1 };
	var expChrPair = { 0x5B: 0x5D, 0x7B: 0x7D, 0x28: 0x29 };
	
	function peek() {
	  return str.charCodeAt(index + 1);
	}
	
	function next() {
	  return str.charCodeAt(++index);
	}
	
	function eof() {
	  return index >= len;
	}
	
	function eatSpace() {
	  while (peek() === spaceChr) {
	    next();
	  }
	}
	
	function isStringStart(chr) {
	  return chr === doubleChr || chr === singleChr;
	}
	
	function isExpStart(chr) {
	  return expStartChr[chr];
	}
	
	function isExpEnd(start, chr) {
	  return expChrPair[start] === chr;
	}
	
	function parseString() {
	  var stringQuote = next();
	  var chr;
	  while (!eof()) {
	    chr = next();
	    // escape char
	    if (chr === escapeChr) {
	      next();
	    } else if (chr === stringQuote) {
	      break;
	    }
	  }
	}
	
	function parseSpecialExp(chr) {
	  var inExp = 0;
	  var startChr = chr;
	
	  while (!eof()) {
	    chr = peek();
	    if (isStringStart(chr)) {
	      parseString();
	      continue;
	    }
	
	    if (startChr === chr) {
	      inExp++;
	    }
	    if (isExpEnd(startChr, chr)) {
	      inExp--;
	    }
	
	    next();
	
	    if (inExp === 0) {
	      break;
	    }
	  }
	}
	
	/**
	 * syntax:
	 * expression | filterName  [arg  arg [| filterName arg arg]]
	 */
	
	function parseExpression() {
	  var start = index;
	  while (!eof()) {
	    chr = peek();
	    if (isStringStart(chr)) {
	      parseString();
	    } else if (isExpStart(chr)) {
	      parseSpecialExp(chr);
	    } else if (chr === pipeChr) {
	      next();
	      chr = peek();
	      if (chr === pipeChr) {
	        next();
	      } else {
	        if (state === startState || state === filterArgState) {
	          state = filterState;
	        }
	        break;
	      }
	    } else if (chr === spaceChr && (state === filterNameState || state === filterArgState)) {
	      eatSpace();
	      break;
	    } else {
	      if (state === filterState) {
	        state = filterNameState;
	      }
	      next();
	    }
	  }
	
	  return str.slice(start + 1, index) || null;
	}
	
	function parseFilterList() {
	  var filters = [];
	  while (!eof()) {
	    filters.push(parseFilter());
	  }
	  return filters;
	}
	
	function parseFilter() {
	  var filter = {};
	  var args;
	
	  state = filterState;
	  filter.name = parseExpression().trim();
	
	  state = filterArgState;
	  args = parseFilterArguments();
	
	  if (args.length) {
	    filter.args = args;
	  }
	  return filter;
	}
	
	function parseFilterArguments() {
	  var args = [];
	  while (!eof() && state !== filterState) {
	    var arg = parseExpression();
	    if (!arg) {
	      break;
	    }
	    args.push(processFilterArg(arg));
	  }
	
	  return args;
	}
	
	/**
	 * Check if an argument is dynamic and strip quotes.
	 *
	 * @param {String} arg
	 * @return {Object}
	 */
	
	function processFilterArg(arg) {
	  if (reservedArgRE.test(arg)) {
	    return {
	      value: toNumber(arg),
	      dynamic: false
	    };
	  } else {
	    var stripped = stripQuotes(arg);
	    var dynamic = stripped === arg;
	    return {
	      value: dynamic ? arg : stripped,
	      dynamic: dynamic
	    };
	  }
	}
	
	/**
	 * Parse a directive value and extract the expression
	 * and its filters into a descriptor.
	 *
	 * Example:
	 *
	 * "a + 1 | uppercase" will yield:
	 * {
	 *   expression: 'a + 1',
	 *   filters: [
	 *     { name: 'uppercase', args: null }
	 *   ]
	 * }
	 *
	 * @param {String} s
	 * @return {Object}
	 */
	
	function parseDirective(s) {
	  var hit = cache$1.get(s);
	  if (hit) {
	    return hit;
	  }
	
	  // reset parser state
	  str = s;
	  dir = {};
	  len = str.length;
	  index = -1;
	  chr = '';
	  state = startState;
	
	  var filters;
	
	  if (str.indexOf('|') < 0) {
	    dir.expression = str.trim();
	  } else {
	    dir.expression = parseExpression().trim();
	    filters = parseFilterList();
	    if (filters.length) {
	      dir.filters = filters;
	    }
	  }
	
	  cache$1.put(s, dir);
	  return dir;
	}
	
	var directive = Object.freeze({
	  parseDirective: parseDirective
	});
	
	var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;
	var cache = undefined;
	var tagRE = undefined;
	var htmlRE = undefined;
	/**
	 * Escape a string so it can be used in a RegExp
	 * constructor.
	 *
	 * @param {String} str
	 */
	
	function escapeRegex(str) {
	  return str.replace(regexEscapeRE, '\\$&');
	}
	
	function compileRegex() {
	  var open = escapeRegex(config.delimiters[0]);
	  var close = escapeRegex(config.delimiters[1]);
	  var unsafeOpen = escapeRegex(config.unsafeDelimiters[0]);
	  var unsafeClose = escapeRegex(config.unsafeDelimiters[1]);
	  tagRE = new RegExp(unsafeOpen + '((?:.|\\n)+?)' + unsafeClose + '|' + open + '((?:.|\\n)+?)' + close, 'g');
	  htmlRE = new RegExp('^' + unsafeOpen + '((?:.|\\n)+?)' + unsafeClose + '$');
	  // reset cache
	  cache = new Cache(1000);
	}
	
	/**
	 * Parse a template text string into an array of tokens.
	 *
	 * @param {String} text
	 * @return {Array<Object> | null}
	 *               - {String} type
	 *               - {String} value
	 *               - {Boolean} [html]
	 *               - {Boolean} [oneTime]
	 */
	
	function parseText(text) {
	  if (!cache) {
	    compileRegex();
	  }
	  var hit = cache.get(text);
	  if (hit) {
	    return hit;
	  }
	  if (!tagRE.test(text)) {
	    return null;
	  }
	  var tokens = [];
	  var lastIndex = tagRE.lastIndex = 0;
	  var match, index, html, value, first, oneTime;
	  /* eslint-disable no-cond-assign */
	  while (match = tagRE.exec(text)) {
	    /* eslint-enable no-cond-assign */
	    index = match.index;
	    // push text token
	    if (index > lastIndex) {
	      tokens.push({
	        value: text.slice(lastIndex, index)
	      });
	    }
	    // tag token
	    html = htmlRE.test(match[0]);
	    value = html ? match[1] : match[2];
	    first = value.charCodeAt(0);
	    oneTime = first === 42; // *
	    value = oneTime ? value.slice(1) : value;
	    tokens.push({
	      tag: true,
	      value: value.trim(),
	      html: html,
	      oneTime: oneTime
	    });
	    lastIndex = index + match[0].length;
	  }
	  if (lastIndex < text.length) {
	    tokens.push({
	      value: text.slice(lastIndex)
	    });
	  }
	  cache.put(text, tokens);
	  return tokens;
	}
	
	/**
	 * Format a list of tokens into an expression.
	 * e.g. tokens parsed from 'a {{b}} c' can be serialized
	 * into one single expression as '"a " + b + " c"'.
	 *
	 * @param {Array} tokens
	 * @param {Vue} [vm]
	 * @return {String}
	 */
	
	function tokensToExp(tokens, vm) {
	  if (tokens.length > 1) {
	    return tokens.map(function (token) {
	      return formatToken(token, vm);
	    }).join('+');
	  } else {
	    return formatToken(tokens[0], vm, true);
	  }
	}
	
	/**
	 * Format a single token.
	 *
	 * @param {Object} token
	 * @param {Vue} [vm]
	 * @param {Boolean} [single]
	 * @return {String}
	 */
	
	function formatToken(token, vm, single) {
	  return token.tag ? token.oneTime && vm ? '"' + vm.$eval(token.value) + '"' : inlineFilters(token.value, single) : '"' + token.value + '"';
	}
	
	/**
	 * For an attribute with multiple interpolation tags,
	 * e.g. attr="some-{{thing | filter}}", in order to combine
	 * the whole thing into a single watchable expression, we
	 * have to inline those filters. This function does exactly
	 * that. This is a bit hacky but it avoids heavy changes
	 * to directive parser and watcher mechanism.
	 *
	 * @param {String} exp
	 * @param {Boolean} single
	 * @return {String}
	 */
	
	var filterRE = /[^|]\|[^|]/;
	function inlineFilters(exp, single) {
	  if (!filterRE.test(exp)) {
	    return single ? exp : '(' + exp + ')';
	  } else {
	    var dir = parseDirective(exp);
	    if (!dir.filters) {
	      return '(' + exp + ')';
	    } else {
	      return 'this._applyFilters(' + dir.expression + // value
	      ',null,' + // oldValue (null for read)
	      JSON.stringify(dir.filters) + // filter descriptors
	      ',false)'; // write?
	    }
	  }
	}
	
	var text = Object.freeze({
	  compileRegex: compileRegex,
	  parseText: parseText,
	  tokensToExp: tokensToExp
	});
	
	var delimiters = ['{{', '}}'];
	var unsafeDelimiters = ['{{{', '}}}'];
	
	var config = Object.defineProperties({
	
	  /**
	   * Whether to print debug messages.
	   * Also enables stack trace for warnings.
	   *
	   * @type {Boolean}
	   */
	
	  debug: false,
	
	  /**
	   * Whether to suppress warnings.
	   *
	   * @type {Boolean}
	   */
	
	  silent: false,
	
	  /**
	   * Whether to use async rendering.
	   */
	
	  async: true,
	
	  /**
	   * Whether to warn against errors caught when evaluating
	   * expressions.
	   */
	
	  warnExpressionErrors: true,
	
	  /**
	   * Whether to allow devtools inspection.
	   * Disabled by default in production builds.
	   */
	
	  devtools: ("production") !== 'production',
	
	  /**
	   * Internal flag to indicate the delimiters have been
	   * changed.
	   *
	   * @type {Boolean}
	   */
	
	  _delimitersChanged: true,
	
	  /**
	   * List of asset types that a component can own.
	   *
	   * @type {Array}
	   */
	
	  _assetTypes: ['component', 'directive', 'elementDirective', 'filter', 'transition', 'partial'],
	
	  /**
	   * prop binding modes
	   */
	
	  _propBindingModes: {
	    ONE_WAY: 0,
	    TWO_WAY: 1,
	    ONE_TIME: 2
	  },
	
	  /**
	   * Max circular updates allowed in a batcher flush cycle.
	   */
	
	  _maxUpdateCount: 100
	
	}, {
	  delimiters: { /**
	                 * Interpolation delimiters. Changing these would trigger
	                 * the text parser to re-compile the regular expressions.
	                 *
	                 * @type {Array<String>}
	                 */
	
	    get: function get() {
	      return delimiters;
	    },
	    set: function set(val) {
	      delimiters = val;
	      compileRegex();
	    },
	    configurable: true,
	    enumerable: true
	  },
	  unsafeDelimiters: {
	    get: function get() {
	      return unsafeDelimiters;
	    },
	    set: function set(val) {
	      unsafeDelimiters = val;
	      compileRegex();
	    },
	    configurable: true,
	    enumerable: true
	  }
	});
	
	var warn = undefined;
	var formatComponentName = undefined;
	
	if (false) {
	  (function () {
	    var hasConsole = typeof console !== 'undefined';
	
	    warn = function (msg, vm) {
	      if (hasConsole && !config.silent) {
	        console.error('[Vue warn]: ' + msg + (vm ? formatComponentName(vm) : ''));
	      }
	    };
	
	    formatComponentName = function (vm) {
	      var name = vm._isVue ? vm.$options.name : vm.name;
	      return name ? ' (found in component: <' + hyphenate(name) + '>)' : '';
	    };
	  })();
	}
	
	/**
	 * Append with transition.
	 *
	 * @param {Element} el
	 * @param {Element} target
	 * @param {Vue} vm
	 * @param {Function} [cb]
	 */
	
	function appendWithTransition(el, target, vm, cb) {
	  applyTransition(el, 1, function () {
	    target.appendChild(el);
	  }, vm, cb);
	}
	
	/**
	 * InsertBefore with transition.
	 *
	 * @param {Element} el
	 * @param {Element} target
	 * @param {Vue} vm
	 * @param {Function} [cb]
	 */
	
	function beforeWithTransition(el, target, vm, cb) {
	  applyTransition(el, 1, function () {
	    before(el, target);
	  }, vm, cb);
	}
	
	/**
	 * Remove with transition.
	 *
	 * @param {Element} el
	 * @param {Vue} vm
	 * @param {Function} [cb]
	 */
	
	function removeWithTransition(el, vm, cb) {
	  applyTransition(el, -1, function () {
	    remove(el);
	  }, vm, cb);
	}
	
	/**
	 * Apply transitions with an operation callback.
	 *
	 * @param {Element} el
	 * @param {Number} direction
	 *                  1: enter
	 *                 -1: leave
	 * @param {Function} op - the actual DOM operation
	 * @param {Vue} vm
	 * @param {Function} [cb]
	 */
	
	function applyTransition(el, direction, op, vm, cb) {
	  var transition = el.__v_trans;
	  if (!transition ||
	  // skip if there are no js hooks and CSS transition is
	  // not supported
	  !transition.hooks && !transitionEndEvent ||
	  // skip transitions for initial compile
	  !vm._isCompiled ||
	  // if the vm is being manipulated by a parent directive
	  // during the parent's compilation phase, skip the
	  // animation.
	  vm.$parent && !vm.$parent._isCompiled) {
	    op();
	    if (cb) cb();
	    return;
	  }
	  var action = direction > 0 ? 'enter' : 'leave';
	  transition[action](op, cb);
	}
	
	var transition = Object.freeze({
	  appendWithTransition: appendWithTransition,
	  beforeWithTransition: beforeWithTransition,
	  removeWithTransition: removeWithTransition,
	  applyTransition: applyTransition
	});
	
	/**
	 * Query an element selector if it's not an element already.
	 *
	 * @param {String|Element} el
	 * @return {Element}
	 */
	
	function query(el) {
	  if (typeof el === 'string') {
	    var selector = el;
	    el = document.querySelector(el);
	    if (!el) {
	      ("production") !== 'production' && warn('Cannot find element: ' + selector);
	    }
	  }
	  return el;
	}
	
	/**
	 * Check if a node is in the document.
	 * Note: document.documentElement.contains should work here
	 * but always returns false for comment nodes in phantomjs,
	 * making unit tests difficult. This is fixed by doing the
	 * contains() check on the node's parentNode instead of
	 * the node itself.
	 *
	 * @param {Node} node
	 * @return {Boolean}
	 */
	
	function inDoc(node) {
	  if (!node) return false;
	  var doc = node.ownerDocument.documentElement;
	  var parent = node.parentNode;
	  return doc === node || doc === parent || !!(parent && parent.nodeType === 1 && doc.contains(parent));
	}
	
	/**
	 * Get and remove an attribute from a node.
	 *
	 * @param {Node} node
	 * @param {String} _attr
	 */
	
	function getAttr(node, _attr) {
	  var val = node.getAttribute(_attr);
	  if (val !== null) {
	    node.removeAttribute(_attr);
	  }
	  return val;
	}
	
	/**
	 * Get an attribute with colon or v-bind: prefix.
	 *
	 * @param {Node} node
	 * @param {String} name
	 * @return {String|null}
	 */
	
	function getBindAttr(node, name) {
	  var val = getAttr(node, ':' + name);
	  if (val === null) {
	    val = getAttr(node, 'v-bind:' + name);
	  }
	  return val;
	}
	
	/**
	 * Check the presence of a bind attribute.
	 *
	 * @param {Node} node
	 * @param {String} name
	 * @return {Boolean}
	 */
	
	function hasBindAttr(node, name) {
	  return node.hasAttribute(name) || node.hasAttribute(':' + name) || node.hasAttribute('v-bind:' + name);
	}
	
	/**
	 * Insert el before target
	 *
	 * @param {Element} el
	 * @param {Element} target
	 */
	
	function before(el, target) {
	  target.parentNode.insertBefore(el, target);
	}
	
	/**
	 * Insert el after target
	 *
	 * @param {Element} el
	 * @param {Element} target
	 */
	
	function after(el, target) {
	  if (target.nextSibling) {
	    before(el, target.nextSibling);
	  } else {
	    target.parentNode.appendChild(el);
	  }
	}
	
	/**
	 * Remove el from DOM
	 *
	 * @param {Element} el
	 */
	
	function remove(el) {
	  el.parentNode.removeChild(el);
	}
	
	/**
	 * Prepend el to target
	 *
	 * @param {Element} el
	 * @param {Element} target
	 */
	
	function prepend(el, target) {
	  if (target.firstChild) {
	    before(el, target.firstChild);
	  } else {
	    target.appendChild(el);
	  }
	}
	
	/**
	 * Replace target with el
	 *
	 * @param {Element} target
	 * @param {Element} el
	 */
	
	function replace(target, el) {
	  var parent = target.parentNode;
	  if (parent) {
	    parent.replaceChild(el, target);
	  }
	}
	
	/**
	 * Add event listener shorthand.
	 *
	 * @param {Element} el
	 * @param {String} event
	 * @param {Function} cb
	 * @param {Boolean} [useCapture]
	 */
	
	function on(el, event, cb, useCapture) {
	  el.addEventListener(event, cb, useCapture);
	}
	
	/**
	 * Remove event listener shorthand.
	 *
	 * @param {Element} el
	 * @param {String} event
	 * @param {Function} cb
	 */
	
	function off(el, event, cb) {
	  el.removeEventListener(event, cb);
	}
	
	/**
	 * For IE9 compat: when both class and :class are present
	 * getAttribute('class') returns wrong value...
	 *
	 * @param {Element} el
	 * @return {String}
	 */
	
	function getClass(el) {
	  var classname = el.className;
	  if (typeof classname === 'object') {
	    classname = classname.baseVal || '';
	  }
	  return classname;
	}
	
	/**
	 * In IE9, setAttribute('class') will result in empty class
	 * if the element also has the :class attribute; However in
	 * PhantomJS, setting `className` does not work on SVG elements...
	 * So we have to do a conditional check here.
	 *
	 * @param {Element} el
	 * @param {String} cls
	 */
	
	function setClass(el, cls) {
	  /* istanbul ignore if */
	  if (isIE9 && !/svg$/.test(el.namespaceURI)) {
	    el.className = cls;
	  } else {
	    el.setAttribute('class', cls);
	  }
	}
	
	/**
	 * Add class with compatibility for IE & SVG
	 *
	 * @param {Element} el
	 * @param {String} cls
	 */
	
	function addClass(el, cls) {
	  if (el.classList) {
	    el.classList.add(cls);
	  } else {
	    var cur = ' ' + getClass(el) + ' ';
	    if (cur.indexOf(' ' + cls + ' ') < 0) {
	      setClass(el, (cur + cls).trim());
	    }
	  }
	}
	
	/**
	 * Remove class with compatibility for IE & SVG
	 *
	 * @param {Element} el
	 * @param {String} cls
	 */
	
	function removeClass(el, cls) {
	  if (el.classList) {
	    el.classList.remove(cls);
	  } else {
	    var cur = ' ' + getClass(el) + ' ';
	    var tar = ' ' + cls + ' ';
	    while (cur.indexOf(tar) >= 0) {
	      cur = cur.replace(tar, ' ');
	    }
	    setClass(el, cur.trim());
	  }
	  if (!el.className) {
	    el.removeAttribute('class');
	  }
	}
	
	/**
	 * Extract raw content inside an element into a temporary
	 * container div
	 *
	 * @param {Element} el
	 * @param {Boolean} asFragment
	 * @return {Element|DocumentFragment}
	 */
	
	function extractContent(el, asFragment) {
	  var child;
	  var rawContent;
	  /* istanbul ignore if */
	  if (isTemplate(el) && isFragment(el.content)) {
	    el = el.content;
	  }
	  if (el.hasChildNodes()) {
	    trimNode(el);
	    rawContent = asFragment ? document.createDocumentFragment() : document.createElement('div');
	    /* eslint-disable no-cond-assign */
	    while (child = el.firstChild) {
	      /* eslint-enable no-cond-assign */
	      rawContent.appendChild(child);
	    }
	  }
	  return rawContent;
	}
	
	/**
	 * Trim possible empty head/tail text and comment
	 * nodes inside a parent.
	 *
	 * @param {Node} node
	 */
	
	function trimNode(node) {
	  var child;
	  /* eslint-disable no-sequences */
	  while ((child = node.firstChild, isTrimmable(child))) {
	    node.removeChild(child);
	  }
	  while ((child = node.lastChild, isTrimmable(child))) {
	    node.removeChild(child);
	  }
	  /* eslint-enable no-sequences */
	}
	
	function isTrimmable(node) {
	  return node && (node.nodeType === 3 && !node.data.trim() || node.nodeType === 8);
	}
	
	/**
	 * Check if an element is a template tag.
	 * Note if the template appears inside an SVG its tagName
	 * will be in lowercase.
	 *
	 * @param {Element} el
	 */
	
	function isTemplate(el) {
	  return el.tagName && el.tagName.toLowerCase() === 'template';
	}
	
	/**
	 * Create an "anchor" for performing dom insertion/removals.
	 * This is used in a number of scenarios:
	 * - fragment instance
	 * - v-html
	 * - v-if
	 * - v-for
	 * - component
	 *
	 * @param {String} content
	 * @param {Boolean} persist - IE trashes empty textNodes on
	 *                            cloneNode(true), so in certain
	 *                            cases the anchor needs to be
	 *                            non-empty to be persisted in
	 *                            templates.
	 * @return {Comment|Text}
	 */
	
	function createAnchor(content, persist) {
	  var anchor = config.debug ? document.createComment(content) : document.createTextNode(persist ? ' ' : '');
	  anchor.__v_anchor = true;
	  return anchor;
	}
	
	/**
	 * Find a component ref attribute that starts with $.
	 *
	 * @param {Element} node
	 * @return {String|undefined}
	 */
	
	var refRE = /^v-ref:/;
	
	function findRef(node) {
	  if (node.hasAttributes()) {
	    var attrs = node.attributes;
	    for (var i = 0, l = attrs.length; i < l; i++) {
	      var name = attrs[i].name;
	      if (refRE.test(name)) {
	        return camelize(name.replace(refRE, ''));
	      }
	    }
	  }
	}
	
	/**
	 * Map a function to a range of nodes .
	 *
	 * @param {Node} node
	 * @param {Node} end
	 * @param {Function} op
	 */
	
	function mapNodeRange(node, end, op) {
	  var next;
	  while (node !== end) {
	    next = node.nextSibling;
	    op(node);
	    node = next;
	  }
	  op(end);
	}
	
	/**
	 * Remove a range of nodes with transition, store
	 * the nodes in a fragment with correct ordering,
	 * and call callback when done.
	 *
	 * @param {Node} start
	 * @param {Node} end
	 * @param {Vue} vm
	 * @param {DocumentFragment} frag
	 * @param {Function} cb
	 */
	
	function removeNodeRange(start, end, vm, frag, cb) {
	  var done = false;
	  var removed = 0;
	  var nodes = [];
	  mapNodeRange(start, end, function (node) {
	    if (node === end) done = true;
	    nodes.push(node);
	    removeWithTransition(node, vm, onRemoved);
	  });
	  function onRemoved() {
	    removed++;
	    if (done && removed >= nodes.length) {
	      for (var i = 0; i < nodes.length; i++) {
	        frag.appendChild(nodes[i]);
	      }
	      cb && cb();
	    }
	  }
	}
	
	/**
	 * Check if a node is a DocumentFragment.
	 *
	 * @param {Node} node
	 * @return {Boolean}
	 */
	
	function isFragment(node) {
	  return node && node.nodeType === 11;
	}
	
	/**
	 * Get outerHTML of elements, taking care
	 * of SVG elements in IE as well.
	 *
	 * @param {Element} el
	 * @return {String}
	 */
	
	function getOuterHTML(el) {
	  if (el.outerHTML) {
	    return el.outerHTML;
	  } else {
	    var container = document.createElement('div');
	    container.appendChild(el.cloneNode(true));
	    return container.innerHTML;
	  }
	}
	
	var commonTagRE = /^(div|p|span|img|a|b|i|br|ul|ol|li|h1|h2|h3|h4|h5|h6|code|pre|table|th|td|tr|form|label|input|select|option|nav|article|section|header|footer)$/i;
	var reservedTagRE = /^(slot|partial|component)$/i;
	
	var isUnknownElement = undefined;
	if (false) {
	  isUnknownElement = function (el, tag) {
	    if (tag.indexOf('-') > -1) {
	      // http://stackoverflow.com/a/28210364/1070244
	      return el.constructor === window.HTMLUnknownElement || el.constructor === window.HTMLElement;
	    } else {
	      return (/HTMLUnknownElement/.test(el.toString()) &&
	        // Chrome returns unknown for several HTML5 elements.
	        // https://code.google.com/p/chromium/issues/detail?id=540526
	        // Firefox returns unknown for some "Interactive elements."
	        !/^(data|time|rtc|rb|details|dialog|summary)$/.test(tag)
	      );
	    }
	  };
	}
	
	/**
	 * Check if an element is a component, if yes return its
	 * component id.
	 *
	 * @param {Element} el
	 * @param {Object} options
	 * @return {Object|undefined}
	 */
	
	function checkComponentAttr(el, options) {
	  var tag = el.tagName.toLowerCase();
	  var hasAttrs = el.hasAttributes();
	  if (!commonTagRE.test(tag) && !reservedTagRE.test(tag)) {
	    if (resolveAsset(options, 'components', tag)) {
	      return { id: tag };
	    } else {
	      var is = hasAttrs && getIsBinding(el, options);
	      if (is) {
	        return is;
	      } else if (false) {
	        var expectedTag = options._componentNameMap && options._componentNameMap[tag];
	        if (expectedTag) {
	          warn('Unknown custom element: <' + tag + '> - ' + 'did you mean <' + expectedTag + '>? ' + 'HTML is case-insensitive, remember to use kebab-case in templates.');
	        } else if (isUnknownElement(el, tag)) {
	          warn('Unknown custom element: <' + tag + '> - did you ' + 'register the component correctly? For recursive components, ' + 'make sure to provide the "name" option.');
	        }
	      }
	    }
	  } else if (hasAttrs) {
	    return getIsBinding(el, options);
	  }
	}
	
	/**
	 * Get "is" binding from an element.
	 *
	 * @param {Element} el
	 * @param {Object} options
	 * @return {Object|undefined}
	 */
	
	function getIsBinding(el, options) {
	  // dynamic syntax
	  var exp = el.getAttribute('is');
	  if (exp != null) {
	    if (resolveAsset(options, 'components', exp)) {
	      el.removeAttribute('is');
	      return { id: exp };
	    }
	  } else {
	    exp = getBindAttr(el, 'is');
	    if (exp != null) {
	      return { id: exp, dynamic: true };
	    }
	  }
	}
	
	/**
	 * Option overwriting strategies are functions that handle
	 * how to merge a parent option value and a child option
	 * value into the final value.
	 *
	 * All strategy functions follow the same signature:
	 *
	 * @param {*} parentVal
	 * @param {*} childVal
	 * @param {Vue} [vm]
	 */
	
	var strats = config.optionMergeStrategies = Object.create(null);
	
	/**
	 * Helper that recursively merges two data objects together.
	 */
	
	function mergeData(to, from) {
	  var key, toVal, fromVal;
	  for (key in from) {
	    toVal = to[key];
	    fromVal = from[key];
	    if (!hasOwn(to, key)) {
	      set(to, key, fromVal);
	    } else if (isObject(toVal) && isObject(fromVal)) {
	      mergeData(toVal, fromVal);
	    }
	  }
	  return to;
	}
	
	/**
	 * Data
	 */
	
	strats.data = function (parentVal, childVal, vm) {
	  if (!vm) {
	    // in a Vue.extend merge, both should be functions
	    if (!childVal) {
	      return parentVal;
	    }
	    if (typeof childVal !== 'function') {
	      ("production") !== 'production' && warn('The "data" option should be a function ' + 'that returns a per-instance value in component ' + 'definitions.', vm);
	      return parentVal;
	    }
	    if (!parentVal) {
	      return childVal;
	    }
	    // when parentVal & childVal are both present,
	    // we need to return a function that returns the
	    // merged result of both functions... no need to
	    // check if parentVal is a function here because
	    // it has to be a function to pass previous merges.
	    return function mergedDataFn() {
	      return mergeData(childVal.call(this), parentVal.call(this));
	    };
	  } else if (parentVal || childVal) {
	    return function mergedInstanceDataFn() {
	      // instance merge
	      var instanceData = typeof childVal === 'function' ? childVal.call(vm) : childVal;
	      var defaultData = typeof parentVal === 'function' ? parentVal.call(vm) : undefined;
	      if (instanceData) {
	        return mergeData(instanceData, defaultData);
	      } else {
	        return defaultData;
	      }
	    };
	  }
	};
	
	/**
	 * El
	 */
	
	strats.el = function (parentVal, childVal, vm) {
	  if (!vm && childVal && typeof childVal !== 'function') {
	    ("production") !== 'production' && warn('The "el" option should be a function ' + 'that returns a per-instance value in component ' + 'definitions.', vm);
	    return;
	  }
	  var ret = childVal || parentVal;
	  // invoke the element factory if this is instance merge
	  return vm && typeof ret === 'function' ? ret.call(vm) : ret;
	};
	
	/**
	 * Hooks and param attributes are merged as arrays.
	 */
	
	strats.init = strats.created = strats.ready = strats.attached = strats.detached = strats.beforeCompile = strats.compiled = strats.beforeDestroy = strats.destroyed = strats.activate = function (parentVal, childVal) {
	  return childVal ? parentVal ? parentVal.concat(childVal) : isArray(childVal) ? childVal : [childVal] : parentVal;
	};
	
	/**
	 * Assets
	 *
	 * When a vm is present (instance creation), we need to do
	 * a three-way merge between constructor options, instance
	 * options and parent options.
	 */
	
	function mergeAssets(parentVal, childVal) {
	  var res = Object.create(parentVal || null);
	  return childVal ? extend(res, guardArrayAssets(childVal)) : res;
	}
	
	config._assetTypes.forEach(function (type) {
	  strats[type + 's'] = mergeAssets;
	});
	
	/**
	 * Events & Watchers.
	 *
	 * Events & watchers hashes should not overwrite one
	 * another, so we merge them as arrays.
	 */
	
	strats.watch = strats.events = function (parentVal, childVal) {
	  if (!childVal) return parentVal;
	  if (!parentVal) return childVal;
	  var ret = {};
	  extend(ret, parentVal);
	  for (var key in childVal) {
	    var parent = ret[key];
	    var child = childVal[key];
	    if (parent && !isArray(parent)) {
	      parent = [parent];
	    }
	    ret[key] = parent ? parent.concat(child) : [child];
	  }
	  return ret;
	};
	
	/**
	 * Other object hashes.
	 */
	
	strats.props = strats.methods = strats.computed = function (parentVal, childVal) {
	  if (!childVal) return parentVal;
	  if (!parentVal) return childVal;
	  var ret = Object.create(null);
	  extend(ret, parentVal);
	  extend(ret, childVal);
	  return ret;
	};
	
	/**
	 * Default strategy.
	 */
	
	var defaultStrat = function defaultStrat(parentVal, childVal) {
	  return childVal === undefined ? parentVal : childVal;
	};
	
	/**
	 * Make sure component options get converted to actual
	 * constructors.
	 *
	 * @param {Object} options
	 */
	
	function guardComponents(options) {
	  if (options.components) {
	    var components = options.components = guardArrayAssets(options.components);
	    var ids = Object.keys(components);
	    var def;
	    if (false) {
	      var map = options._componentNameMap = {};
	    }
	    for (var i = 0, l = ids.length; i < l; i++) {
	      var key = ids[i];
	      if (commonTagRE.test(key) || reservedTagRE.test(key)) {
	        ("production") !== 'production' && warn('Do not use built-in or reserved HTML elements as component ' + 'id: ' + key);
	        continue;
	      }
	      // record a all lowercase <-> kebab-case mapping for
	      // possible custom element case error warning
	      if (false) {
	        map[key.replace(/-/g, '').toLowerCase()] = hyphenate(key);
	      }
	      def = components[key];
	      if (isPlainObject(def)) {
	        components[key] = Vue.extend(def);
	      }
	    }
	  }
	}
	
	/**
	 * Ensure all props option syntax are normalized into the
	 * Object-based format.
	 *
	 * @param {Object} options
	 */
	
	function guardProps(options) {
	  var props = options.props;
	  var i, val;
	  if (isArray(props)) {
	    options.props = {};
	    i = props.length;
	    while (i--) {
	      val = props[i];
	      if (typeof val === 'string') {
	        options.props[val] = null;
	      } else if (val.name) {
	        options.props[val.name] = val;
	      }
	    }
	  } else if (isPlainObject(props)) {
	    var keys = Object.keys(props);
	    i = keys.length;
	    while (i--) {
	      val = props[keys[i]];
	      if (typeof val === 'function') {
	        props[keys[i]] = { type: val };
	      }
	    }
	  }
	}
	
	/**
	 * Guard an Array-format assets option and converted it
	 * into the key-value Object format.
	 *
	 * @param {Object|Array} assets
	 * @return {Object}
	 */
	
	function guardArrayAssets(assets) {
	  if (isArray(assets)) {
	    var res = {};
	    var i = assets.length;
	    var asset;
	    while (i--) {
	      asset = assets[i];
	      var id = typeof asset === 'function' ? asset.options && asset.options.name || asset.id : asset.name || asset.id;
	      if (!id) {
	        ("production") !== 'production' && warn('Array-syntax assets must provide a "name" or "id" field.');
	      } else {
	        res[id] = asset;
	      }
	    }
	    return res;
	  }
	  return assets;
	}
	
	/**
	 * Merge two option objects into a new one.
	 * Core utility used in both instantiation and inheritance.
	 *
	 * @param {Object} parent
	 * @param {Object} child
	 * @param {Vue} [vm] - if vm is present, indicates this is
	 *                     an instantiation merge.
	 */
	
	function mergeOptions(parent, child, vm) {
	  guardComponents(child);
	  guardProps(child);
	  if (false) {
	    if (child.propsData && !vm) {
	      warn('propsData can only be used as an instantiation option.');
	    }
	  }
	  var options = {};
	  var key;
	  if (child['extends']) {
	    parent = typeof child['extends'] === 'function' ? mergeOptions(parent, child['extends'].options, vm) : mergeOptions(parent, child['extends'], vm);
	  }
	  if (child.mixins) {
	    for (var i = 0, l = child.mixins.length; i < l; i++) {
	      var mixin = child.mixins[i];
	      var mixinOptions = mixin.prototype instanceof Vue ? mixin.options : mixin;
	      parent = mergeOptions(parent, mixinOptions, vm);
	    }
	  }
	  for (key in parent) {
	    mergeField(key);
	  }
	  for (key in child) {
	    if (!hasOwn(parent, key)) {
	      mergeField(key);
	    }
	  }
	  function mergeField(key) {
	    var strat = strats[key] || defaultStrat;
	    options[key] = strat(parent[key], child[key], vm, key);
	  }
	  return options;
	}
	
	/**
	 * Resolve an asset.
	 * This function is used because child instances need access
	 * to assets defined in its ancestor chain.
	 *
	 * @param {Object} options
	 * @param {String} type
	 * @param {String} id
	 * @param {Boolean} warnMissing
	 * @return {Object|Function}
	 */
	
	function resolveAsset(options, type, id, warnMissing) {
	  /* istanbul ignore if */
	  if (typeof id !== 'string') {
	    return;
	  }
	  var assets = options[type];
	  var camelizedId;
	  var res = assets[id] ||
	  // camelCase ID
	  assets[camelizedId = camelize(id)] ||
	  // Pascal Case ID
	  assets[camelizedId.charAt(0).toUpperCase() + camelizedId.slice(1)];
	  if (false) {
	    warn('Failed to resolve ' + type.slice(0, -1) + ': ' + id, options);
	  }
	  return res;
	}
	
	var uid$1 = 0;
	
	/**
	 * A dep is an observable that can have multiple
	 * directives subscribing to it.
	 *
	 * @constructor
	 */
	function Dep() {
	  this.id = uid$1++;
	  this.subs = [];
	}
	
	// the current target watcher being evaluated.
	// this is globally unique because there could be only one
	// watcher being evaluated at any time.
	Dep.target = null;
	
	/**
	 * Add a directive subscriber.
	 *
	 * @param {Directive} sub
	 */
	
	Dep.prototype.addSub = function (sub) {
	  this.subs.push(sub);
	};
	
	/**
	 * Remove a directive subscriber.
	 *
	 * @param {Directive} sub
	 */
	
	Dep.prototype.removeSub = function (sub) {
	  this.subs.$remove(sub);
	};
	
	/**
	 * Add self as a dependency to the target watcher.
	 */
	
	Dep.prototype.depend = function () {
	  Dep.target.addDep(this);
	};
	
	/**
	 * Notify all subscribers of a new value.
	 */
	
	Dep.prototype.notify = function () {
	  // stablize the subscriber list first
	  var subs = toArray(this.subs);
	  for (var i = 0, l = subs.length; i < l; i++) {
	    subs[i].update();
	  }
	};
	
	var arrayProto = Array.prototype;
	var arrayMethods = Object.create(arrayProto)
	
	/**
	 * Intercept mutating methods and emit events
	 */
	
	;['push', 'pop', 'shift', 'unshift', 'splice', 'sort', 'reverse'].forEach(function (method) {
	  // cache original method
	  var original = arrayProto[method];
	  def(arrayMethods, method, function mutator() {
	    // avoid leaking arguments:
	    // http://jsperf.com/closure-with-arguments
	    var i = arguments.length;
	    var args = new Array(i);
	    while (i--) {
	      args[i] = arguments[i];
	    }
	    var result = original.apply(this, args);
	    var ob = this.__ob__;
	    var inserted;
	    switch (method) {
	      case 'push':
	        inserted = args;
	        break;
	      case 'unshift':
	        inserted = args;
	        break;
	      case 'splice':
	        inserted = args.slice(2);
	        break;
	    }
	    if (inserted) ob.observeArray(inserted);
	    // notify change
	    ob.dep.notify();
	    return result;
	  });
	});
	
	/**
	 * Swap the element at the given index with a new value
	 * and emits corresponding event.
	 *
	 * @param {Number} index
	 * @param {*} val
	 * @return {*} - replaced element
	 */
	
	def(arrayProto, '$set', function $set(index, val) {
	  if (index >= this.length) {
	    this.length = Number(index) + 1;
	  }
	  return this.splice(index, 1, val)[0];
	});
	
	/**
	 * Convenience method to remove the element at given index or target element reference.
	 *
	 * @param {*} item
	 */
	
	def(arrayProto, '$remove', function $remove(item) {
	  /* istanbul ignore if */
	  if (!this.length) return;
	  var index = indexOf(this, item);
	  if (index > -1) {
	    return this.splice(index, 1);
	  }
	});
	
	var arrayKeys = Object.getOwnPropertyNames(arrayMethods);
	
	/**
	 * By default, when a reactive property is set, the new value is
	 * also converted to become reactive. However in certain cases, e.g.
	 * v-for scope alias and props, we don't want to force conversion
	 * because the value may be a nested value under a frozen data structure.
	 *
	 * So whenever we want to set a reactive property without forcing
	 * conversion on the new value, we wrap that call inside this function.
	 */
	
	var shouldConvert = true;
	
	function withoutConversion(fn) {
	  shouldConvert = false;
	  fn();
	  shouldConvert = true;
	}
	
	/**
	 * Observer class that are attached to each observed
	 * object. Once attached, the observer converts target
	 * object's property keys into getter/setters that
	 * collect dependencies and dispatches updates.
	 *
	 * @param {Array|Object} value
	 * @constructor
	 */
	
	function Observer(value) {
	  this.value = value;
	  this.dep = new Dep();
	  def(value, '__ob__', this);
	  if (isArray(value)) {
	    var augment = hasProto ? protoAugment : copyAugment;
	    augment(value, arrayMethods, arrayKeys);
	    this.observeArray(value);
	  } else {
	    this.walk(value);
	  }
	}
	
	// Instance methods
	
	/**
	 * Walk through each property and convert them into
	 * getter/setters. This method should only be called when
	 * value type is Object.
	 *
	 * @param {Object} obj
	 */
	
	Observer.prototype.walk = function (obj) {
	  var keys = Object.keys(obj);
	  for (var i = 0, l = keys.length; i < l; i++) {
	    this.convert(keys[i], obj[keys[i]]);
	  }
	};
	
	/**
	 * Observe a list of Array items.
	 *
	 * @param {Array} items
	 */
	
	Observer.prototype.observeArray = function (items) {
	  for (var i = 0, l = items.length; i < l; i++) {
	    observe(items[i]);
	  }
	};
	
	/**
	 * Convert a property into getter/setter so we can emit
	 * the events when the property is accessed/changed.
	 *
	 * @param {String} key
	 * @param {*} val
	 */
	
	Observer.prototype.convert = function (key, val) {
	  defineReactive(this.value, key, val);
	};
	
	/**
	 * Add an owner vm, so that when $set/$delete mutations
	 * happen we can notify owner vms to proxy the keys and
	 * digest the watchers. This is only called when the object
	 * is observed as an instance's root $data.
	 *
	 * @param {Vue} vm
	 */
	
	Observer.prototype.addVm = function (vm) {
	  (this.vms || (this.vms = [])).push(vm);
	};
	
	/**
	 * Remove an owner vm. This is called when the object is
	 * swapped out as an instance's $data object.
	 *
	 * @param {Vue} vm
	 */
	
	Observer.prototype.removeVm = function (vm) {
	  this.vms.$remove(vm);
	};
	
	// helpers
	
	/**
	 * Augment an target Object or Array by intercepting
	 * the prototype chain using __proto__
	 *
	 * @param {Object|Array} target
	 * @param {Object} src
	 */
	
	function protoAugment(target, src) {
	  /* eslint-disable no-proto */
	  target.__proto__ = src;
	  /* eslint-enable no-proto */
	}
	
	/**
	 * Augment an target Object or Array by defining
	 * hidden properties.
	 *
	 * @param {Object|Array} target
	 * @param {Object} proto
	 */
	
	function copyAugment(target, src, keys) {
	  for (var i = 0, l = keys.length; i < l; i++) {
	    var key = keys[i];
	    def(target, key, src[key]);
	  }
	}
	
	/**
	 * Attempt to create an observer instance for a value,
	 * returns the new observer if successfully observed,
	 * or the existing observer if the value already has one.
	 *
	 * @param {*} value
	 * @param {Vue} [vm]
	 * @return {Observer|undefined}
	 * @static
	 */
	
	function observe(value, vm) {
	  if (!value || typeof value !== 'object') {
	    return;
	  }
	  var ob;
	  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
	    ob = value.__ob__;
	  } else if (shouldConvert && (isArray(value) || isPlainObject(value)) && Object.isExtensible(value) && !value._isVue) {
	    ob = new Observer(value);
	  }
	  if (ob && vm) {
	    ob.addVm(vm);
	  }
	  return ob;
	}
	
	/**
	 * Define a reactive property on an Object.
	 *
	 * @param {Object} obj
	 * @param {String} key
	 * @param {*} val
	 */
	
	function defineReactive(obj, key, val) {
	  var dep = new Dep();
	
	  var property = Object.getOwnPropertyDescriptor(obj, key);
	  if (property && property.configurable === false) {
	    return;
	  }
	
	  // cater for pre-defined getter/setters
	  var getter = property && property.get;
	  var setter = property && property.set;
	
	  var childOb = observe(val);
	  Object.defineProperty(obj, key, {
	    enumerable: true,
	    configurable: true,
	    get: function reactiveGetter() {
	      var value = getter ? getter.call(obj) : val;
	      if (Dep.target) {
	        dep.depend();
	        if (childOb) {
	          childOb.dep.depend();
	        }
	        if (isArray(value)) {
	          for (var e, i = 0, l = value.length; i < l; i++) {
	            e = value[i];
	            e && e.__ob__ && e.__ob__.dep.depend();
	          }
	        }
	      }
	      return value;
	    },
	    set: function reactiveSetter(newVal) {
	      var value = getter ? getter.call(obj) : val;
	      if (newVal === value) {
	        return;
	      }
	      if (setter) {
	        setter.call(obj, newVal);
	      } else {
	        val = newVal;
	      }
	      childOb = observe(newVal);
	      dep.notify();
	    }
	  });
	}
	
	
	
	var util = Object.freeze({
		defineReactive: defineReactive,
		set: set,
		del: del,
		hasOwn: hasOwn,
		isLiteral: isLiteral,
		isReserved: isReserved,
		_toString: _toString,
		toNumber: toNumber,
		toBoolean: toBoolean,
		stripQuotes: stripQuotes,
		camelize: camelize,
		hyphenate: hyphenate,
		classify: classify,
		bind: bind,
		toArray: toArray,
		extend: extend,
		isObject: isObject,
		isPlainObject: isPlainObject,
		def: def,
		debounce: _debounce,
		indexOf: indexOf,
		cancellable: cancellable,
		looseEqual: looseEqual,
		isArray: isArray,
		hasProto: hasProto,
		inBrowser: inBrowser,
		devtools: devtools,
		isIE: isIE,
		isIE9: isIE9,
		isAndroid: isAndroid,
		isIOS: isIOS,
		get transitionProp () { return transitionProp; },
		get transitionEndEvent () { return transitionEndEvent; },
		get animationProp () { return animationProp; },
		get animationEndEvent () { return animationEndEvent; },
		nextTick: nextTick,
		get _Set () { return _Set; },
		query: query,
		inDoc: inDoc,
		getAttr: getAttr,
		getBindAttr: getBindAttr,
		hasBindAttr: hasBindAttr,
		before: before,
		after: after,
		remove: remove,
		prepend: prepend,
		replace: replace,
		on: on,
		off: off,
		setClass: setClass,
		addClass: addClass,
		removeClass: removeClass,
		extractContent: extractContent,
		trimNode: trimNode,
		isTemplate: isTemplate,
		createAnchor: createAnchor,
		findRef: findRef,
		mapNodeRange: mapNodeRange,
		removeNodeRange: removeNodeRange,
		isFragment: isFragment,
		getOuterHTML: getOuterHTML,
		mergeOptions: mergeOptions,
		resolveAsset: resolveAsset,
		checkComponentAttr: checkComponentAttr,
		commonTagRE: commonTagRE,
		reservedTagRE: reservedTagRE,
		get warn () { return warn; }
	});
	
	var uid = 0;
	
	function initMixin (Vue) {
	  /**
	   * The main init sequence. This is called for every
	   * instance, including ones that are created from extended
	   * constructors.
	   *
	   * @param {Object} options - this options object should be
	   *                           the result of merging class
	   *                           options and the options passed
	   *                           in to the constructor.
	   */
	
	  Vue.prototype._init = function (options) {
	    options = options || {};
	
	    this.$el = null;
	    this.$parent = options.parent;
	    this.$root = this.$parent ? this.$parent.$root : this;
	    this.$children = [];
	    this.$refs = {}; // child vm references
	    this.$els = {}; // element references
	    this._watchers = []; // all watchers as an array
	    this._directives = []; // all directives
	
	    // a uid
	    this._uid = uid++;
	
	    // a flag to avoid this being observed
	    this._isVue = true;
	
	    // events bookkeeping
	    this._events = {}; // registered callbacks
	    this._eventsCount = {}; // for $broadcast optimization
	
	    // fragment instance properties
	    this._isFragment = false;
	    this._fragment = // @type {DocumentFragment}
	    this._fragmentStart = // @type {Text|Comment}
	    this._fragmentEnd = null; // @type {Text|Comment}
	
	    // lifecycle state
	    this._isCompiled = this._isDestroyed = this._isReady = this._isAttached = this._isBeingDestroyed = this._vForRemoving = false;
	    this._unlinkFn = null;
	
	    // context:
	    // if this is a transcluded component, context
	    // will be the common parent vm of this instance
	    // and its host.
	    this._context = options._context || this.$parent;
	
	    // scope:
	    // if this is inside an inline v-for, the scope
	    // will be the intermediate scope created for this
	    // repeat fragment. this is used for linking props
	    // and container directives.
	    this._scope = options._scope;
	
	    // fragment:
	    // if this instance is compiled inside a Fragment, it
	    // needs to register itself as a child of that fragment
	    // for attach/detach to work properly.
	    this._frag = options._frag;
	    if (this._frag) {
	      this._frag.children.push(this);
	    }
	
	    // push self into parent / transclusion host
	    if (this.$parent) {
	      this.$parent.$children.push(this);
	    }
	
	    // merge options.
	    options = this.$options = mergeOptions(this.constructor.options, options, this);
	
	    // set ref
	    this._updateRef();
	
	    // initialize data as empty object.
	    // it will be filled up in _initData().
	    this._data = {};
	
	    // call init hook
	    this._callHook('init');
	
	    // initialize data observation and scope inheritance.
	    this._initState();
	
	    // setup event system and option events.
	    this._initEvents();
	
	    // call created hook
	    this._callHook('created');
	
	    // if `el` option is passed, start compilation.
	    if (options.el) {
	      this.$mount(options.el);
	    }
	  };
	}
	
	var pathCache = new Cache(1000);
	
	// actions
	var APPEND = 0;
	var PUSH = 1;
	var INC_SUB_PATH_DEPTH = 2;
	var PUSH_SUB_PATH = 3;
	
	// states
	var BEFORE_PATH = 0;
	var IN_PATH = 1;
	var BEFORE_IDENT = 2;
	var IN_IDENT = 3;
	var IN_SUB_PATH = 4;
	var IN_SINGLE_QUOTE = 5;
	var IN_DOUBLE_QUOTE = 6;
	var AFTER_PATH = 7;
	var ERROR = 8;
	
	var pathStateMachine = [];
	
	pathStateMachine[BEFORE_PATH] = {
	  'ws': [BEFORE_PATH],
	  'ident': [IN_IDENT, APPEND],
	  '[': [IN_SUB_PATH],
	  'eof': [AFTER_PATH]
	};
	
	pathStateMachine[IN_PATH] = {
	  'ws': [IN_PATH],
	  '.': [BEFORE_IDENT],
	  '[': [IN_SUB_PATH],
	  'eof': [AFTER_PATH]
	};
	
	pathStateMachine[BEFORE_IDENT] = {
	  'ws': [BEFORE_IDENT],
	  'ident': [IN_IDENT, APPEND]
	};
	
	pathStateMachine[IN_IDENT] = {
	  'ident': [IN_IDENT, APPEND],
	  '0': [IN_IDENT, APPEND],
	  'number': [IN_IDENT, APPEND],
	  'ws': [IN_PATH, PUSH],
	  '.': [BEFORE_IDENT, PUSH],
	  '[': [IN_SUB_PATH, PUSH],
	  'eof': [AFTER_PATH, PUSH]
	};
	
	pathStateMachine[IN_SUB_PATH] = {
	  "'": [IN_SINGLE_QUOTE, APPEND],
	  '"': [IN_DOUBLE_QUOTE, APPEND],
	  '[': [IN_SUB_PATH, INC_SUB_PATH_DEPTH],
	  ']': [IN_PATH, PUSH_SUB_PATH],
	  'eof': ERROR,
	  'else': [IN_SUB_PATH, APPEND]
	};
	
	pathStateMachine[IN_SINGLE_QUOTE] = {
	  "'": [IN_SUB_PATH, APPEND],
	  'eof': ERROR,
	  'else': [IN_SINGLE_QUOTE, APPEND]
	};
	
	pathStateMachine[IN_DOUBLE_QUOTE] = {
	  '"': [IN_SUB_PATH, APPEND],
	  'eof': ERROR,
	  'else': [IN_DOUBLE_QUOTE, APPEND]
	};
	
	/**
	 * Determine the type of a character in a keypath.
	 *
	 * @param {Char} ch
	 * @return {String} type
	 */
	
	function getPathCharType(ch) {
	  if (ch === undefined) {
	    return 'eof';
	  }
	
	  var code = ch.charCodeAt(0);
	
	  switch (code) {
	    case 0x5B: // [
	    case 0x5D: // ]
	    case 0x2E: // .
	    case 0x22: // "
	    case 0x27: // '
	    case 0x30:
	      // 0
	      return ch;
	
	    case 0x5F: // _
	    case 0x24:
	      // $
	      return 'ident';
	
	    case 0x20: // Space
	    case 0x09: // Tab
	    case 0x0A: // Newline
	    case 0x0D: // Return
	    case 0xA0: // No-break space
	    case 0xFEFF: // Byte Order Mark
	    case 0x2028: // Line Separator
	    case 0x2029:
	      // Paragraph Separator
	      return 'ws';
	  }
	
	  // a-z, A-Z
	  if (code >= 0x61 && code <= 0x7A || code >= 0x41 && code <= 0x5A) {
	    return 'ident';
	  }
	
	  // 1-9
	  if (code >= 0x31 && code <= 0x39) {
	    return 'number';
	  }
	
	  return 'else';
	}
	
	/**
	 * Format a subPath, return its plain form if it is
	 * a literal string or number. Otherwise prepend the
	 * dynamic indicator (*).
	 *
	 * @param {String} path
	 * @return {String}
	 */
	
	function formatSubPath(path) {
	  var trimmed = path.trim();
	  // invalid leading 0
	  if (path.charAt(0) === '0' && isNaN(path)) {
	    return false;
	  }
	  return isLiteral(trimmed) ? stripQuotes(trimmed) : '*' + trimmed;
	}
	
	/**
	 * Parse a string path into an array of segments
	 *
	 * @param {String} path
	 * @return {Array|undefined}
	 */
	
	function parse(path) {
	  var keys = [];
	  var index = -1;
	  var mode = BEFORE_PATH;
	  var subPathDepth = 0;
	  var c, newChar, key, type, transition, action, typeMap;
	
	  var actions = [];
	
	  actions[PUSH] = function () {
	    if (key !== undefined) {
	      keys.push(key);
	      key = undefined;
	    }
	  };
	
	  actions[APPEND] = function () {
	    if (key === undefined) {
	      key = newChar;
	    } else {
	      key += newChar;
	    }
	  };
	
	  actions[INC_SUB_PATH_DEPTH] = function () {
	    actions[APPEND]();
	    subPathDepth++;
	  };
	
	  actions[PUSH_SUB_PATH] = function () {
	    if (subPathDepth > 0) {
	      subPathDepth--;
	      mode = IN_SUB_PATH;
	      actions[APPEND]();
	    } else {
	      subPathDepth = 0;
	      key = formatSubPath(key);
	      if (key === false) {
	        return false;
	      } else {
	        actions[PUSH]();
	      }
	    }
	  };
	
	  function maybeUnescapeQuote() {
	    var nextChar = path[index + 1];
	    if (mode === IN_SINGLE_QUOTE && nextChar === "'" || mode === IN_DOUBLE_QUOTE && nextChar === '"') {
	      index++;
	      newChar = '\\' + nextChar;
	      actions[APPEND]();
	      return true;
	    }
	  }
	
	  while (mode != null) {
	    index++;
	    c = path[index];
	
	    if (c === '\\' && maybeUnescapeQuote()) {
	      continue;
	    }
	
	    type = getPathCharType(c);
	    typeMap = pathStateMachine[mode];
	    transition = typeMap[type] || typeMap['else'] || ERROR;
	
	    if (transition === ERROR) {
	      return; // parse error
	    }
	
	    mode = transition[0];
	    action = actions[transition[1]];
	    if (action) {
	      newChar = transition[2];
	      newChar = newChar === undefined ? c : newChar;
	      if (action() === false) {
	        return;
	      }
	    }
	
	    if (mode === AFTER_PATH) {
	      keys.raw = path;
	      return keys;
	    }
	  }
	}
	
	/**
	 * External parse that check for a cache hit first
	 *
	 * @param {String} path
	 * @return {Array|undefined}
	 */
	
	function parsePath(path) {
	  var hit = pathCache.get(path);
	  if (!hit) {
	    hit = parse(path);
	    if (hit) {
	      pathCache.put(path, hit);
	    }
	  }
	  return hit;
	}
	
	/**
	 * Get from an object from a path string
	 *
	 * @param {Object} obj
	 * @param {String} path
	 */
	
	function getPath(obj, path) {
	  return parseExpression$1(path).get(obj);
	}
	
	/**
	 * Warn against setting non-existent root path on a vm.
	 */
	
	var warnNonExistent;
	if (false) {
	  warnNonExistent = function (path, vm) {
	    warn('You are setting a non-existent path "' + path.raw + '" ' + 'on a vm instance. Consider pre-initializing the property ' + 'with the "data" option for more reliable reactivity ' + 'and better performance.', vm);
	  };
	}
	
	/**
	 * Set on an object from a path
	 *
	 * @param {Object} obj
	 * @param {String | Array} path
	 * @param {*} val
	 */
	
	function setPath(obj, path, val) {
	  var original = obj;
	  if (typeof path === 'string') {
	    path = parse(path);
	  }
	  if (!path || !isObject(obj)) {
	    return false;
	  }
	  var last, key;
	  for (var i = 0, l = path.length; i < l; i++) {
	    last = obj;
	    key = path[i];
	    if (key.charAt(0) === '*') {
	      key = parseExpression$1(key.slice(1)).get.call(original, original);
	    }
	    if (i < l - 1) {
	      obj = obj[key];
	      if (!isObject(obj)) {
	        obj = {};
	        if (false) {
	          warnNonExistent(path, last);
	        }
	        set(last, key, obj);
	      }
	    } else {
	      if (isArray(obj)) {
	        obj.$set(key, val);
	      } else if (key in obj) {
	        obj[key] = val;
	      } else {
	        if (false) {
	          warnNonExistent(path, obj);
	        }
	        set(obj, key, val);
	      }
	    }
	  }
	  return true;
	}
	
	var path = Object.freeze({
	  parsePath: parsePath,
	  getPath: getPath,
	  setPath: setPath
	});
	
	var expressionCache = new Cache(1000);
	
	var allowedKeywords = 'Math,Date,this,true,false,null,undefined,Infinity,NaN,' + 'isNaN,isFinite,decodeURI,decodeURIComponent,encodeURI,' + 'encodeURIComponent,parseInt,parseFloat';
	var allowedKeywordsRE = new RegExp('^(' + allowedKeywords.replace(/,/g, '\\b|') + '\\b)');
	
	// keywords that don't make sense inside expressions
	var improperKeywords = 'break,case,class,catch,const,continue,debugger,default,' + 'delete,do,else,export,extends,finally,for,function,if,' + 'import,in,instanceof,let,return,super,switch,throw,try,' + 'var,while,with,yield,enum,await,implements,package,' + 'protected,static,interface,private,public';
	var improperKeywordsRE = new RegExp('^(' + improperKeywords.replace(/,/g, '\\b|') + '\\b)');
	
	var wsRE = /\s/g;
	var newlineRE = /\n/g;
	var saveRE = /[\{,]\s*[\w\$_]+\s*:|('(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\"']|\\.)*`|`(?:[^`\\]|\\.)*`)|new |typeof |void /g;
	var restoreRE = /"(\d+)"/g;
	var pathTestRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['.*?'\]|\[".*?"\]|\[\d+\]|\[[A-Za-z_$][\w$]*\])*$/;
	var identRE = /[^\w$\.](?:[A-Za-z_$][\w$]*)/g;
	var literalValueRE$1 = /^(?:true|false|null|undefined|Infinity|NaN)$/;
	
	function noop() {}
	
	/**
	 * Save / Rewrite / Restore
	 *
	 * When rewriting paths found in an expression, it is
	 * possible for the same letter sequences to be found in
	 * strings and Object literal property keys. Therefore we
	 * remove and store these parts in a temporary array, and
	 * restore them after the path rewrite.
	 */
	
	var saved = [];
	
	/**
	 * Save replacer
	 *
	 * The save regex can match two possible cases:
	 * 1. An opening object literal
	 * 2. A string
	 * If matched as a plain string, we need to escape its
	 * newlines, since the string needs to be preserved when
	 * generating the function body.
	 *
	 * @param {String} str
	 * @param {String} isString - str if matched as a string
	 * @return {String} - placeholder with index
	 */
	
	function save(str, isString) {
	  var i = saved.length;
	  saved[i] = isString ? str.replace(newlineRE, '\\n') : str;
	  return '"' + i + '"';
	}
	
	/**
	 * Path rewrite replacer
	 *
	 * @param {String} raw
	 * @return {String}
	 */
	
	function rewrite(raw) {
	  var c = raw.charAt(0);
	  var path = raw.slice(1);
	  if (allowedKeywordsRE.test(path)) {
	    return raw;
	  } else {
	    path = path.indexOf('"') > -1 ? path.replace(restoreRE, restore) : path;
	    return c + 'scope.' + path;
	  }
	}
	
	/**
	 * Restore replacer
	 *
	 * @param {String} str
	 * @param {String} i - matched save index
	 * @return {String}
	 */
	
	function restore(str, i) {
	  return saved[i];
	}
	
	/**
	 * Rewrite an expression, prefixing all path accessors with
	 * `scope.` and generate getter/setter functions.
	 *
	 * @param {String} exp
	 * @return {Function}
	 */
	
	function compileGetter(exp) {
	  if (improperKeywordsRE.test(exp)) {
	    ("production") !== 'production' && warn('Avoid using reserved keywords in expression: ' + exp);
	  }
	  // reset state
	  saved.length = 0;
	  // save strings and object literal keys
	  var body = exp.replace(saveRE, save).replace(wsRE, '');
	  // rewrite all paths
	  // pad 1 space here because the regex matches 1 extra char
	  body = (' ' + body).replace(identRE, rewrite).replace(restoreRE, restore);
	  return makeGetterFn(body);
	}
	
	/**
	 * Build a getter function. Requires eval.
	 *
	 * We isolate the try/catch so it doesn't affect the
	 * optimization of the parse function when it is not called.
	 *
	 * @param {String} body
	 * @return {Function|undefined}
	 */
	
	function makeGetterFn(body) {
	  try {
	    /* eslint-disable no-new-func */
	    return new Function('scope', 'return ' + body + ';');
	    /* eslint-enable no-new-func */
	  } catch (e) {
	    if (false) {
	      /* istanbul ignore if */
	      if (e.toString().match(/unsafe-eval|CSP/)) {
	        warn('It seems you are using the default build of Vue.js in an environment ' + 'with Content Security Policy that prohibits unsafe-eval. ' + 'Use the CSP-compliant build instead: ' + 'http://vuejs.org/guide/installation.html#CSP-compliant-build');
	      } else {
	        warn('Invalid expression. ' + 'Generated function body: ' + body);
	      }
	    }
	    return noop;
	  }
	}
	
	/**
	 * Compile a setter function for the expression.
	 *
	 * @param {String} exp
	 * @return {Function|undefined}
	 */
	
	function compileSetter(exp) {
	  var path = parsePath(exp);
	  if (path) {
	    return function (scope, val) {
	      setPath(scope, path, val);
	    };
	  } else {
	    ("production") !== 'production' && warn('Invalid setter expression: ' + exp);
	  }
	}
	
	/**
	 * Parse an expression into re-written getter/setters.
	 *
	 * @param {String} exp
	 * @param {Boolean} needSet
	 * @return {Function}
	 */
	
	function parseExpression$1(exp, needSet) {
	  exp = exp.trim();
	  // try cache
	  var hit = expressionCache.get(exp);
	  if (hit) {
	    if (needSet && !hit.set) {
	      hit.set = compileSetter(hit.exp);
	    }
	    return hit;
	  }
	  var res = { exp: exp };
	  res.get = isSimplePath(exp) && exp.indexOf('[') < 0
	  // optimized super simple getter
	  ? makeGetterFn('scope.' + exp)
	  // dynamic getter
	  : compileGetter(exp);
	  if (needSet) {
	    res.set = compileSetter(exp);
	  }
	  expressionCache.put(exp, res);
	  return res;
	}
	
	/**
	 * Check if an expression is a simple path.
	 *
	 * @param {String} exp
	 * @return {Boolean}
	 */
	
	function isSimplePath(exp) {
	  return pathTestRE.test(exp) &&
	  // don't treat literal values as paths
	  !literalValueRE$1.test(exp) &&
	  // Math constants e.g. Math.PI, Math.E etc.
	  exp.slice(0, 5) !== 'Math.';
	}
	
	var expression = Object.freeze({
	  parseExpression: parseExpression$1,
	  isSimplePath: isSimplePath
	});
	
	// we have two separate queues: one for directive updates
	// and one for user watcher registered via $watch().
	// we want to guarantee directive updates to be called
	// before user watchers so that when user watchers are
	// triggered, the DOM would have already been in updated
	// state.
	
	var queue = [];
	var userQueue = [];
	var has = {};
	var circular = {};
	var waiting = false;
	
	/**
	 * Reset the batcher's state.
	 */
	
	function resetBatcherState() {
	  queue.length = 0;
	  userQueue.length = 0;
	  has = {};
	  circular = {};
	  waiting = false;
	}
	
	/**
	 * Flush both queues and run the watchers.
	 */
	
	function flushBatcherQueue() {
	  var _again = true;
	
	  _function: while (_again) {
	    _again = false;
	
	    runBatcherQueue(queue);
	    runBatcherQueue(userQueue);
	    // user watchers triggered more watchers,
	    // keep flushing until it depletes
	    if (queue.length) {
	      _again = true;
	      continue _function;
	    }
	    // dev tool hook
	    /* istanbul ignore if */
	    if (devtools && config.devtools) {
	      devtools.emit('flush');
	    }
	    resetBatcherState();
	  }
	}
	
	/**
	 * Run the watchers in a single queue.
	 *
	 * @param {Array} queue
	 */
	
	function runBatcherQueue(queue) {
	  // do not cache length because more watchers might be pushed
	  // as we run existing watchers
	  for (var i = 0; i < queue.length; i++) {
	    var watcher = queue[i];
	    var id = watcher.id;
	    has[id] = null;
	    watcher.run();
	    // in dev build, check and stop circular updates.
	    if (false) {
	      circular[id] = (circular[id] || 0) + 1;
	      if (circular[id] > config._maxUpdateCount) {
	        warn('You may have an infinite update loop for watcher ' + 'with expression "' + watcher.expression + '"', watcher.vm);
	        break;
	      }
	    }
	  }
	  queue.length = 0;
	}
	
	/**
	 * Push a watcher into the watcher queue.
	 * Jobs with duplicate IDs will be skipped unless it's
	 * pushed when the queue is being flushed.
	 *
	 * @param {Watcher} watcher
	 *   properties:
	 *   - {Number} id
	 *   - {Function} run
	 */
	
	function pushWatcher(watcher) {
	  var id = watcher.id;
	  if (has[id] == null) {
	    // push watcher into appropriate queue
	    var q = watcher.user ? userQueue : queue;
	    has[id] = q.length;
	    q.push(watcher);
	    // queue the flush
	    if (!waiting) {
	      waiting = true;
	      nextTick(flushBatcherQueue);
	    }
	  }
	}
	
	var uid$2 = 0;
	
	/**
	 * A watcher parses an expression, collects dependencies,
	 * and fires callback when the expression value changes.
	 * This is used for both the $watch() api and directives.
	 *
	 * @param {Vue} vm
	 * @param {String|Function} expOrFn
	 * @param {Function} cb
	 * @param {Object} options
	 *                 - {Array} filters
	 *                 - {Boolean} twoWay
	 *                 - {Boolean} deep
	 *                 - {Boolean} user
	 *                 - {Boolean} sync
	 *                 - {Boolean} lazy
	 *                 - {Function} [preProcess]
	 *                 - {Function} [postProcess]
	 * @constructor
	 */
	function Watcher(vm, expOrFn, cb, options) {
	  // mix in options
	  if (options) {
	    extend(this, options);
	  }
	  var isFn = typeof expOrFn === 'function';
	  this.vm = vm;
	  vm._watchers.push(this);
	  this.expression = expOrFn;
	  this.cb = cb;
	  this.id = ++uid$2; // uid for batching
	  this.active = true;
	  this.dirty = this.lazy; // for lazy watchers
	  this.deps = [];
	  this.newDeps = [];
	  this.depIds = new _Set();
	  this.newDepIds = new _Set();
	  this.prevError = null; // for async error stacks
	  // parse expression for getter/setter
	  if (isFn) {
	    this.getter = expOrFn;
	    this.setter = undefined;
	  } else {
	    var res = parseExpression$1(expOrFn, this.twoWay);
	    this.getter = res.get;
	    this.setter = res.set;
	  }
	  this.value = this.lazy ? undefined : this.get();
	  // state for avoiding false triggers for deep and Array
	  // watchers during vm._digest()
	  this.queued = this.shallow = false;
	}
	
	/**
	 * Evaluate the getter, and re-collect dependencies.
	 */
	
	Watcher.prototype.get = function () {
	  this.beforeGet();
	  var scope = this.scope || this.vm;
	  var value;
	  try {
	    value = this.getter.call(scope, scope);
	  } catch (e) {
	    if (false) {
	      warn('Error when evaluating expression ' + '"' + this.expression + '": ' + e.toString(), this.vm);
	    }
	  }
	  // "touch" every property so they are all tracked as
	  // dependencies for deep watching
	  if (this.deep) {
	    traverse(value);
	  }
	  if (this.preProcess) {
	    value = this.preProcess(value);
	  }
	  if (this.filters) {
	    value = scope._applyFilters(value, null, this.filters, false);
	  }
	  if (this.postProcess) {
	    value = this.postProcess(value);
	  }
	  this.afterGet();
	  return value;
	};
	
	/**
	 * Set the corresponding value with the setter.
	 *
	 * @param {*} value
	 */
	
	Watcher.prototype.set = function (value) {
	  var scope = this.scope || this.vm;
	  if (this.filters) {
	    value = scope._applyFilters(value, this.value, this.filters, true);
	  }
	  try {
	    this.setter.call(scope, scope, value);
	  } catch (e) {
	    if (false) {
	      warn('Error when evaluating setter ' + '"' + this.expression + '": ' + e.toString(), this.vm);
	    }
	  }
	  // two-way sync for v-for alias
	  var forContext = scope.$forContext;
	  if (forContext && forContext.alias === this.expression) {
	    if (forContext.filters) {
	      ("production") !== 'production' && warn('It seems you are using two-way binding on ' + 'a v-for alias (' + this.expression + '), and the ' + 'v-for has filters. This will not work properly. ' + 'Either remove the filters or use an array of ' + 'objects and bind to object properties instead.', this.vm);
	      return;
	    }
	    forContext._withLock(function () {
	      if (scope.$key) {
	        // original is an object
	        forContext.rawValue[scope.$key] = value;
	      } else {
	        forContext.rawValue.$set(scope.$index, value);
	      }
	    });
	  }
	};
	
	/**
	 * Prepare for dependency collection.
	 */
	
	Watcher.prototype.beforeGet = function () {
	  Dep.target = this;
	};
	
	/**
	 * Add a dependency to this directive.
	 *
	 * @param {Dep} dep
	 */
	
	Watcher.prototype.addDep = function (dep) {
	  var id = dep.id;
	  if (!this.newDepIds.has(id)) {
	    this.newDepIds.add(id);
	    this.newDeps.push(dep);
	    if (!this.depIds.has(id)) {
	      dep.addSub(this);
	    }
	  }
	};
	
	/**
	 * Clean up for dependency collection.
	 */
	
	Watcher.prototype.afterGet = function () {
	  Dep.target = null;
	  var i = this.deps.length;
	  while (i--) {
	    var dep = this.deps[i];
	    if (!this.newDepIds.has(dep.id)) {
	      dep.removeSub(this);
	    }
	  }
	  var tmp = this.depIds;
	  this.depIds = this.newDepIds;
	  this.newDepIds = tmp;
	  this.newDepIds.clear();
	  tmp = this.deps;
	  this.deps = this.newDeps;
	  this.newDeps = tmp;
	  this.newDeps.length = 0;
	};
	
	/**
	 * Subscriber interface.
	 * Will be called when a dependency changes.
	 *
	 * @param {Boolean} shallow
	 */
	
	Watcher.prototype.update = function (shallow) {
	  if (this.lazy) {
	    this.dirty = true;
	  } else if (this.sync || !config.async) {
	    this.run();
	  } else {
	    // if queued, only overwrite shallow with non-shallow,
	    // but not the other way around.
	    this.shallow = this.queued ? shallow ? this.shallow : false : !!shallow;
	    this.queued = true;
	    // record before-push error stack in debug mode
	    /* istanbul ignore if */
	    if (false) {
	      this.prevError = new Error('[vue] async stack trace');
	    }
	    pushWatcher(this);
	  }
	};
	
	/**
	 * Batcher job interface.
	 * Will be called by the batcher.
	 */
	
	Watcher.prototype.run = function () {
	  if (this.active) {
	    var value = this.get();
	    if (value !== this.value ||
	    // Deep watchers and watchers on Object/Arrays should fire even
	    // when the value is the same, because the value may
	    // have mutated; but only do so if this is a
	    // non-shallow update (caused by a vm digest).
	    (isObject(value) || this.deep) && !this.shallow) {
	      // set new value
	      var oldValue = this.value;
	      this.value = value;
	      // in debug + async mode, when a watcher callbacks
	      // throws, we also throw the saved before-push error
	      // so the full cross-tick stack trace is available.
	      var prevError = this.prevError;
	      /* istanbul ignore if */
	      if (false) {
	        this.prevError = null;
	        try {
	          this.cb.call(this.vm, value, oldValue);
	        } catch (e) {
	          nextTick(function () {
	            throw prevError;
	          }, 0);
	          throw e;
	        }
	      } else {
	        this.cb.call(this.vm, value, oldValue);
	      }
	    }
	    this.queued = this.shallow = false;
	  }
	};
	
	/**
	 * Evaluate the value of the watcher.
	 * This only gets called for lazy watchers.
	 */
	
	Watcher.prototype.evaluate = function () {
	  // avoid overwriting another watcher that is being
	  // collected.
	  var current = Dep.target;
	  this.value = this.get();
	  this.dirty = false;
	  Dep.target = current;
	};
	
	/**
	 * Depend on all deps collected by this watcher.
	 */
	
	Watcher.prototype.depend = function () {
	  var i = this.deps.length;
	  while (i--) {
	    this.deps[i].depend();
	  }
	};
	
	/**
	 * Remove self from all dependencies' subcriber list.
	 */
	
	Watcher.prototype.teardown = function () {
	  if (this.active) {
	    // remove self from vm's watcher list
	    // this is a somewhat expensive operation so we skip it
	    // if the vm is being destroyed or is performing a v-for
	    // re-render (the watcher list is then filtered by v-for).
	    if (!this.vm._isBeingDestroyed && !this.vm._vForRemoving) {
	      this.vm._watchers.$remove(this);
	    }
	    var i = this.deps.length;
	    while (i--) {
	      this.deps[i].removeSub(this);
	    }
	    this.active = false;
	    this.vm = this.cb = this.value = null;
	  }
	};
	
	/**
	 * Recrusively traverse an object to evoke all converted
	 * getters, so that every nested property inside the object
	 * is collected as a "deep" dependency.
	 *
	 * @param {*} val
	 */
	
	var seenObjects = new _Set();
	function traverse(val, seen) {
	  var i = undefined,
	      keys = undefined;
	  if (!seen) {
	    seen = seenObjects;
	    seen.clear();
	  }
	  var isA = isArray(val);
	  var isO = isObject(val);
	  if ((isA || isO) && Object.isExtensible(val)) {
	    if (val.__ob__) {
	      var depId = val.__ob__.dep.id;
	      if (seen.has(depId)) {
	        return;
	      } else {
	        seen.add(depId);
	      }
	    }
	    if (isA) {
	      i = val.length;
	      while (i--) traverse(val[i], seen);
	    } else if (isO) {
	      keys = Object.keys(val);
	      i = keys.length;
	      while (i--) traverse(val[keys[i]], seen);
	    }
	  }
	}
	
	var text$1 = {
	
	  bind: function bind() {
	    this.attr = this.el.nodeType === 3 ? 'data' : 'textContent';
	  },
	
	  update: function update(value) {
	    this.el[this.attr] = _toString(value);
	  }
	};
	
	var templateCache = new Cache(1000);
	var idSelectorCache = new Cache(1000);
	
	var map = {
	  efault: [0, '', ''],
	  legend: [1, '<fieldset>', '</fieldset>'],
	  tr: [2, '<table><tbody>', '</tbody></table>'],
	  col: [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>']
	};
	
	map.td = map.th = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	map.option = map.optgroup = [1, '<select multiple="multiple">', '</select>'];
	
	map.thead = map.tbody = map.colgroup = map.caption = map.tfoot = [1, '<table>', '</table>'];
	
	map.g = map.defs = map.symbol = map.use = map.image = map.text = map.circle = map.ellipse = map.line = map.path = map.polygon = map.polyline = map.rect = [1, '<svg ' + 'xmlns="http://www.w3.org/2000/svg" ' + 'xmlns:xlink="http://www.w3.org/1999/xlink" ' + 'xmlns:ev="http://www.w3.org/2001/xml-events"' + 'version="1.1">', '</svg>'];
	
	/**
	 * Check if a node is a supported template node with a
	 * DocumentFragment content.
	 *
	 * @param {Node} node
	 * @return {Boolean}
	 */
	
	function isRealTemplate(node) {
	  return isTemplate(node) && isFragment(node.content);
	}
	
	var tagRE$1 = /<([\w:-]+)/;
	var entityRE = /&#?\w+?;/;
	var commentRE = /<!--/;
	
	/**
	 * Convert a string template to a DocumentFragment.
	 * Determines correct wrapping by tag types. Wrapping
	 * strategy found in jQuery & component/domify.
	 *
	 * @param {String} templateString
	 * @param {Boolean} raw
	 * @return {DocumentFragment}
	 */
	
	function stringToFragment(templateString, raw) {
	  // try a cache hit first
	  var cacheKey = raw ? templateString : templateString.trim();
	  var hit = templateCache.get(cacheKey);
	  if (hit) {
	    return hit;
	  }
	
	  var frag = document.createDocumentFragment();
	  var tagMatch = templateString.match(tagRE$1);
	  var entityMatch = entityRE.test(templateString);
	  var commentMatch = commentRE.test(templateString);
	
	  if (!tagMatch && !entityMatch && !commentMatch) {
	    // text only, return a single text node.
	    frag.appendChild(document.createTextNode(templateString));
	  } else {
	    var tag = tagMatch && tagMatch[1];
	    var wrap = map[tag] || map.efault;
	    var depth = wrap[0];
	    var prefix = wrap[1];
	    var suffix = wrap[2];
	    var node = document.createElement('div');
	
	    node.innerHTML = prefix + templateString + suffix;
	    while (depth--) {
	      node = node.lastChild;
	    }
	
	    var child;
	    /* eslint-disable no-cond-assign */
	    while (child = node.firstChild) {
	      /* eslint-enable no-cond-assign */
	      frag.appendChild(child);
	    }
	  }
	  if (!raw) {
	    trimNode(frag);
	  }
	  templateCache.put(cacheKey, frag);
	  return frag;
	}
	
	/**
	 * Convert a template node to a DocumentFragment.
	 *
	 * @param {Node} node
	 * @return {DocumentFragment}
	 */
	
	function nodeToFragment(node) {
	  // if its a template tag and the browser supports it,
	  // its content is already a document fragment. However, iOS Safari has
	  // bug when using directly cloned template content with touch
	  // events and can cause crashes when the nodes are removed from DOM, so we
	  // have to treat template elements as string templates. (#2805)
	  /* istanbul ignore if */
	  if (isRealTemplate(node)) {
	    return stringToFragment(node.innerHTML);
	  }
	  // script template
	  if (node.tagName === 'SCRIPT') {
	    return stringToFragment(node.textContent);
	  }
	  // normal node, clone it to avoid mutating the original
	  var clonedNode = cloneNode(node);
	  var frag = document.createDocumentFragment();
	  var child;
	  /* eslint-disable no-cond-assign */
	  while (child = clonedNode.firstChild) {
	    /* eslint-enable no-cond-assign */
	    frag.appendChild(child);
	  }
	  trimNode(frag);
	  return frag;
	}
	
	// Test for the presence of the Safari template cloning bug
	// https://bugs.webkit.org/showug.cgi?id=137755
	var hasBrokenTemplate = (function () {
	  /* istanbul ignore else */
	  if (inBrowser) {
	    var a = document.createElement('div');
	    a.innerHTML = '<template>1</template>';
	    return !a.cloneNode(true).firstChild.innerHTML;
	  } else {
	    return false;
	  }
	})();
	
	// Test for IE10/11 textarea placeholder clone bug
	var hasTextareaCloneBug = (function () {
	  /* istanbul ignore else */
	  if (inBrowser) {
	    var t = document.createElement('textarea');
	    t.placeholder = 't';
	    return t.cloneNode(true).value === 't';
	  } else {
	    return false;
	  }
	})();
	
	/**
	 * 1. Deal with Safari cloning nested <template> bug by
	 *    manually cloning all template instances.
	 * 2. Deal with IE10/11 textarea placeholder bug by setting
	 *    the correct value after cloning.
	 *
	 * @param {Element|DocumentFragment} node
	 * @return {Element|DocumentFragment}
	 */
	
	function cloneNode(node) {
	  /* istanbul ignore if */
	  if (!node.querySelectorAll) {
	    return node.cloneNode();
	  }
	  var res = node.cloneNode(true);
	  var i, original, cloned;
	  /* istanbul ignore if */
	  if (hasBrokenTemplate) {
	    var tempClone = res;
	    if (isRealTemplate(node)) {
	      node = node.content;
	      tempClone = res.content;
	    }
	    original = node.querySelectorAll('template');
	    if (original.length) {
	      cloned = tempClone.querySelectorAll('template');
	      i = cloned.length;
	      while (i--) {
	        cloned[i].parentNode.replaceChild(cloneNode(original[i]), cloned[i]);
	      }
	    }
	  }
	  /* istanbul ignore if */
	  if (hasTextareaCloneBug) {
	    if (node.tagName === 'TEXTAREA') {
	      res.value = node.value;
	    } else {
	      original = node.querySelectorAll('textarea');
	      if (original.length) {
	        cloned = res.querySelectorAll('textarea');
	        i = cloned.length;
	        while (i--) {
	          cloned[i].value = original[i].value;
	        }
	      }
	    }
	  }
	  return res;
	}
	
	/**
	 * Process the template option and normalizes it into a
	 * a DocumentFragment that can be used as a partial or a
	 * instance template.
	 *
	 * @param {*} template
	 *        Possible values include:
	 *        - DocumentFragment object
	 *        - Node object of type Template
	 *        - id selector: '#some-template-id'
	 *        - template string: '<div><span>{{msg}}</span></div>'
	 * @param {Boolean} shouldClone
	 * @param {Boolean} raw
	 *        inline HTML interpolation. Do not check for id
	 *        selector and keep whitespace in the string.
	 * @return {DocumentFragment|undefined}
	 */
	
	function parseTemplate(template, shouldClone, raw) {
	  var node, frag;
	
	  // if the template is already a document fragment,
	  // do nothing
	  if (isFragment(template)) {
	    trimNode(template);
	    return shouldClone ? cloneNode(template) : template;
	  }
	
	  if (typeof template === 'string') {
	    // id selector
	    if (!raw && template.charAt(0) === '#') {
	      // id selector can be cached too
	      frag = idSelectorCache.get(template);
	      if (!frag) {
	        node = document.getElementById(template.slice(1));
	        if (node) {
	          frag = nodeToFragment(node);
	          // save selector to cache
	          idSelectorCache.put(template, frag);
	        }
	      }
	    } else {
	      // normal string template
	      frag = stringToFragment(template, raw);
	    }
	  } else if (template.nodeType) {
	    // a direct node
	    frag = nodeToFragment(template);
	  }
	
	  return frag && shouldClone ? cloneNode(frag) : frag;
	}
	
	var template = Object.freeze({
	  cloneNode: cloneNode,
	  parseTemplate: parseTemplate
	});
	
	var html = {
	
	  bind: function bind() {
	    // a comment node means this is a binding for
	    // {{{ inline unescaped html }}}
	    if (this.el.nodeType === 8) {
	      // hold nodes
	      this.nodes = [];
	      // replace the placeholder with proper anchor
	      this.anchor = createAnchor('v-html');
	      replace(this.el, this.anchor);
	    }
	  },
	
	  update: function update(value) {
	    value = _toString(value);
	    if (this.nodes) {
	      this.swap(value);
	    } else {
	      this.el.innerHTML = value;
	    }
	  },
	
	  swap: function swap(value) {
	    // remove old nodes
	    var i = this.nodes.length;
	    while (i--) {
	      remove(this.nodes[i]);
	    }
	    // convert new value to a fragment
	    // do not attempt to retrieve from id selector
	    var frag = parseTemplate(value, true, true);
	    // save a reference to these nodes so we can remove later
	    this.nodes = toArray(frag.childNodes);
	    before(frag, this.anchor);
	  }
	};
	
	/**
	 * Abstraction for a partially-compiled fragment.
	 * Can optionally compile content with a child scope.
	 *
	 * @param {Function} linker
	 * @param {Vue} vm
	 * @param {DocumentFragment} frag
	 * @param {Vue} [host]
	 * @param {Object} [scope]
	 * @param {Fragment} [parentFrag]
	 */
	function Fragment(linker, vm, frag, host, scope, parentFrag) {
	  this.children = [];
	  this.childFrags = [];
	  this.vm = vm;
	  this.scope = scope;
	  this.inserted = false;
	  this.parentFrag = parentFrag;
	  if (parentFrag) {
	    parentFrag.childFrags.push(this);
	  }
	  this.unlink = linker(vm, frag, host, scope, this);
	  var single = this.single = frag.childNodes.length === 1 &&
	  // do not go single mode if the only node is an anchor
	  !frag.childNodes[0].__v_anchor;
	  if (single) {
	    this.node = frag.childNodes[0];
	    this.before = singleBefore;
	    this.remove = singleRemove;
	  } else {
	    this.node = createAnchor('fragment-start');
	    this.end = createAnchor('fragment-end');
	    this.frag = frag;
	    prepend(this.node, frag);
	    frag.appendChild(this.end);
	    this.before = multiBefore;
	    this.remove = multiRemove;
	  }
	  this.node.__v_frag = this;
	}
	
	/**
	 * Call attach/detach for all components contained within
	 * this fragment. Also do so recursively for all child
	 * fragments.
	 *
	 * @param {Function} hook
	 */
	
	Fragment.prototype.callHook = function (hook) {
	  var i, l;
	  for (i = 0, l = this.childFrags.length; i < l; i++) {
	    this.childFrags[i].callHook(hook);
	  }
	  for (i = 0, l = this.children.length; i < l; i++) {
	    hook(this.children[i]);
	  }
	};
	
	/**
	 * Insert fragment before target, single node version
	 *
	 * @param {Node} target
	 * @param {Boolean} withTransition
	 */
	
	function singleBefore(target, withTransition) {
	  this.inserted = true;
	  var method = withTransition !== false ? beforeWithTransition : before;
	  method(this.node, target, this.vm);
	  if (inDoc(this.node)) {
	    this.callHook(attach);
	  }
	}
	
	/**
	 * Remove fragment, single node version
	 */
	
	function singleRemove() {
	  this.inserted = false;
	  var shouldCallRemove = inDoc(this.node);
	  var self = this;
	  this.beforeRemove();
	  removeWithTransition(this.node, this.vm, function () {
	    if (shouldCallRemove) {
	      self.callHook(detach);
	    }
	    self.destroy();
	  });
	}
	
	/**
	 * Insert fragment before target, multi-nodes version
	 *
	 * @param {Node} target
	 * @param {Boolean} withTransition
	 */
	
	function multiBefore(target, withTransition) {
	  this.inserted = true;
	  var vm = this.vm;
	  var method = withTransition !== false ? beforeWithTransition : before;
	  mapNodeRange(this.node, this.end, function (node) {
	    method(node, target, vm);
	  });
	  if (inDoc(this.node)) {
	    this.callHook(attach);
	  }
	}
	
	/**
	 * Remove fragment, multi-nodes version
	 */
	
	function multiRemove() {
	  this.inserted = false;
	  var self = this;
	  var shouldCallRemove = inDoc(this.node);
	  this.beforeRemove();
	  removeNodeRange(this.node, this.end, this.vm, this.frag, function () {
	    if (shouldCallRemove) {
	      self.callHook(detach);
	    }
	    self.destroy();
	  });
	}
	
	/**
	 * Prepare the fragment for removal.
	 */
	
	Fragment.prototype.beforeRemove = function () {
	  var i, l;
	  for (i = 0, l = this.childFrags.length; i < l; i++) {
	    // call the same method recursively on child
	    // fragments, depth-first
	    this.childFrags[i].beforeRemove(false);
	  }
	  for (i = 0, l = this.children.length; i < l; i++) {
	    // Call destroy for all contained instances,
	    // with remove:false and defer:true.
	    // Defer is necessary because we need to
	    // keep the children to call detach hooks
	    // on them.
	    this.children[i].$destroy(false, true);
	  }
	  var dirs = this.unlink.dirs;
	  for (i = 0, l = dirs.length; i < l; i++) {
	    // disable the watchers on all the directives
	    // so that the rendered content stays the same
	    // during removal.
	    dirs[i]._watcher && dirs[i]._watcher.teardown();
	  }
	};
	
	/**
	 * Destroy the fragment.
	 */
	
	Fragment.prototype.destroy = function () {
	  if (this.parentFrag) {
	    this.parentFrag.childFrags.$remove(this);
	  }
	  this.node.__v_frag = null;
	  this.unlink();
	};
	
	/**
	 * Call attach hook for a Vue instance.
	 *
	 * @param {Vue} child
	 */
	
	function attach(child) {
	  if (!child._isAttached && inDoc(child.$el)) {
	    child._callHook('attached');
	  }
	}
	
	/**
	 * Call detach hook for a Vue instance.
	 *
	 * @param {Vue} child
	 */
	
	function detach(child) {
	  if (child._isAttached && !inDoc(child.$el)) {
	    child._callHook('detached');
	  }
	}
	
	var linkerCache = new Cache(5000);
	
	/**
	 * A factory that can be used to create instances of a
	 * fragment. Caches the compiled linker if possible.
	 *
	 * @param {Vue} vm
	 * @param {Element|String} el
	 */
	function FragmentFactory(vm, el) {
	  this.vm = vm;
	  var template;
	  var isString = typeof el === 'string';
	  if (isString || isTemplate(el) && !el.hasAttribute('v-if')) {
	    template = parseTemplate(el, true);
	  } else {
	    template = document.createDocumentFragment();
	    template.appendChild(el);
	  }
	  this.template = template;
	  // linker can be cached, but only for components
	  var linker;
	  var cid = vm.constructor.cid;
	  if (cid > 0) {
	    var cacheId = cid + (isString ? el : getOuterHTML(el));
	    linker = linkerCache.get(cacheId);
	    if (!linker) {
	      linker = compile(template, vm.$options, true);
	      linkerCache.put(cacheId, linker);
	    }
	  } else {
	    linker = compile(template, vm.$options, true);
	  }
	  this.linker = linker;
	}
	
	/**
	 * Create a fragment instance with given host and scope.
	 *
	 * @param {Vue} host
	 * @param {Object} scope
	 * @param {Fragment} parentFrag
	 */
	
	FragmentFactory.prototype.create = function (host, scope, parentFrag) {
	  var frag = cloneNode(this.template);
	  return new Fragment(this.linker, this.vm, frag, host, scope, parentFrag);
	};
	
	var ON = 700;
	var MODEL = 800;
	var BIND = 850;
	var TRANSITION = 1100;
	var EL = 1500;
	var COMPONENT = 1500;
	var PARTIAL = 1750;
	var IF = 2100;
	var FOR = 2200;
	var SLOT = 2300;
	
	var uid$3 = 0;
	
	var vFor = {
	
	  priority: FOR,
	  terminal: true,
	
	  params: ['track-by', 'stagger', 'enter-stagger', 'leave-stagger'],
	
	  bind: function bind() {
	    if (false) {
	      warn('<' + this.el.tagName.toLowerCase() + ' v-for="' + this.expression + '" v-if="' + this.el.getAttribute('v-if') + '">: ' + 'Using v-if and v-for on the same element is not recommended - ' + 'consider filtering the source Array instead.', this.vm);
	    }
	
	    // support "item in/of items" syntax
	    var inMatch = this.expression.match(/(.*) (?:in|of) (.*)/);
	    if (inMatch) {
	      var itMatch = inMatch[1].match(/\((.*),(.*)\)/);
	      if (itMatch) {
	        this.iterator = itMatch[1].trim();
	        this.alias = itMatch[2].trim();
	      } else {
	        this.alias = inMatch[1].trim();
	      }
	      this.expression = inMatch[2];
	    }
	
	    if (!this.alias) {
	      ("production") !== 'production' && warn('Invalid v-for expression "' + this.descriptor.raw + '": ' + 'alias is required.', this.vm);
	      return;
	    }
	
	    // uid as a cache identifier
	    this.id = '__v-for__' + ++uid$3;
	
	    // check if this is an option list,
	    // so that we know if we need to update the <select>'s
	    // v-model when the option list has changed.
	    // because v-model has a lower priority than v-for,
	    // the v-model is not bound here yet, so we have to
	    // retrive it in the actual updateModel() function.
	    var tag = this.el.tagName;
	    this.isOption = (tag === 'OPTION' || tag === 'OPTGROUP') && this.el.parentNode.tagName === 'SELECT';
	
	    // setup anchor nodes
	    this.start = createAnchor('v-for-start');
	    this.end = createAnchor('v-for-end');
	    replace(this.el, this.end);
	    before(this.start, this.end);
	
	    // cache
	    this.cache = Object.create(null);
	
	    // fragment factory
	    this.factory = new FragmentFactory(this.vm, this.el);
	  },
	
	  update: function update(data) {
	    this.diff(data);
	    this.updateRef();
	    this.updateModel();
	  },
	
	  /**
	   * Diff, based on new data and old data, determine the
	   * minimum amount of DOM manipulations needed to make the
	   * DOM reflect the new data Array.
	   *
	   * The algorithm diffs the new data Array by storing a
	   * hidden reference to an owner vm instance on previously
	   * seen data. This allows us to achieve O(n) which is
	   * better than a levenshtein distance based algorithm,
	   * which is O(m * n).
	   *
	   * @param {Array} data
	   */
	
	  diff: function diff(data) {
	    // check if the Array was converted from an Object
	    var item = data[0];
	    var convertedFromObject = this.fromObject = isObject(item) && hasOwn(item, '$key') && hasOwn(item, '$value');
	
	    var trackByKey = this.params.trackBy;
	    var oldFrags = this.frags;
	    var frags = this.frags = new Array(data.length);
	    var alias = this.alias;
	    var iterator = this.iterator;
	    var start = this.start;
	    var end = this.end;
	    var inDocument = inDoc(start);
	    var init = !oldFrags;
	    var i, l, frag, key, value, primitive;
	
	    // First pass, go through the new Array and fill up
	    // the new frags array. If a piece of data has a cached
	    // instance for it, we reuse it. Otherwise build a new
	    // instance.
	    for (i = 0, l = data.length; i < l; i++) {
	      item = data[i];
	      key = convertedFromObject ? item.$key : null;
	      value = convertedFromObject ? item.$value : item;
	      primitive = !isObject(value);
	      frag = !init && this.getCachedFrag(value, i, key);
	      if (frag) {
	        // reusable fragment
	        frag.reused = true;
	        // update $index
	        frag.scope.$index = i;
	        // update $key
	        if (key) {
	          frag.scope.$key = key;
	        }
	        // update iterator
	        if (iterator) {
	          frag.scope[iterator] = key !== null ? key : i;
	        }
	        // update data for track-by, object repeat &
	        // primitive values.
	        if (trackByKey || convertedFromObject || primitive) {
	          withoutConversion(function () {
	            frag.scope[alias] = value;
	          });
	        }
	      } else {
	        // new instance
	        frag = this.create(value, alias, i, key);
	        frag.fresh = !init;
	      }
	      frags[i] = frag;
	      if (init) {
	        frag.before(end);
	      }
	    }
	
	    // we're done for the initial render.
	    if (init) {
	      return;
	    }
	
	    // Second pass, go through the old fragments and
	    // destroy those who are not reused (and remove them
	    // from cache)
	    var removalIndex = 0;
	    var totalRemoved = oldFrags.length - frags.length;
	    // when removing a large number of fragments, watcher removal
	    // turns out to be a perf bottleneck, so we batch the watcher
	    // removals into a single filter call!
	    this.vm._vForRemoving = true;
	    for (i = 0, l = oldFrags.length; i < l; i++) {
	      frag = oldFrags[i];
	      if (!frag.reused) {
	        this.deleteCachedFrag(frag);
	        this.remove(frag, removalIndex++, totalRemoved, inDocument);
	      }
	    }
	    this.vm._vForRemoving = false;
	    if (removalIndex) {
	      this.vm._watchers = this.vm._watchers.filter(function (w) {
	        return w.active;
	      });
	    }
	
	    // Final pass, move/insert new fragments into the
	    // right place.
	    var targetPrev, prevEl, currentPrev;
	    var insertionIndex = 0;
	    for (i = 0, l = frags.length; i < l; i++) {
	      frag = frags[i];
	      // this is the frag that we should be after
	      targetPrev = frags[i - 1];
	      prevEl = targetPrev ? targetPrev.staggerCb ? targetPrev.staggerAnchor : targetPrev.end || targetPrev.node : start;
	      if (frag.reused && !frag.staggerCb) {
	        currentPrev = findPrevFrag(frag, start, this.id);
	        if (currentPrev !== targetPrev && (!currentPrev ||
	        // optimization for moving a single item.
	        // thanks to suggestions by @livoras in #1807
	        findPrevFrag(currentPrev, start, this.id) !== targetPrev)) {
	          this.move(frag, prevEl);
	        }
	      } else {
	        // new instance, or still in stagger.
	        // insert with updated stagger index.
	        this.insert(frag, insertionIndex++, prevEl, inDocument);
	      }
	      frag.reused = frag.fresh = false;
	    }
	  },
	
	  /**
	   * Create a new fragment instance.
	   *
	   * @param {*} value
	   * @param {String} alias
	   * @param {Number} index
	   * @param {String} [key]
	   * @return {Fragment}
	   */
	
	  create: function create(value, alias, index, key) {
	    var host = this._host;
	    // create iteration scope
	    var parentScope = this._scope || this.vm;
	    var scope = Object.create(parentScope);
	    // ref holder for the scope
	    scope.$refs = Object.create(parentScope.$refs);
	    scope.$els = Object.create(parentScope.$els);
	    // make sure point $parent to parent scope
	    scope.$parent = parentScope;
	    // for two-way binding on alias
	    scope.$forContext = this;
	    // define scope properties
	    // important: define the scope alias without forced conversion
	    // so that frozen data structures remain non-reactive.
	    withoutConversion(function () {
	      defineReactive(scope, alias, value);
	    });
	    defineReactive(scope, '$index', index);
	    if (key) {
	      defineReactive(scope, '$key', key);
	    } else if (scope.$key) {
	      // avoid accidental fallback
	      def(scope, '$key', null);
	    }
	    if (this.iterator) {
	      defineReactive(scope, this.iterator, key !== null ? key : index);
	    }
	    var frag = this.factory.create(host, scope, this._frag);
	    frag.forId = this.id;
	    this.cacheFrag(value, frag, index, key);
	    return frag;
	  },
	
	  /**
	   * Update the v-ref on owner vm.
	   */
	
	  updateRef: function updateRef() {
	    var ref = this.descriptor.ref;
	    if (!ref) return;
	    var hash = (this._scope || this.vm).$refs;
	    var refs;
	    if (!this.fromObject) {
	      refs = this.frags.map(findVmFromFrag);
	    } else {
	      refs = {};
	      this.frags.forEach(function (frag) {
	        refs[frag.scope.$key] = findVmFromFrag(frag);
	      });
	    }
	    hash[ref] = refs;
	  },
	
	  /**
	   * For option lists, update the containing v-model on
	   * parent <select>.
	   */
	
	  updateModel: function updateModel() {
	    if (this.isOption) {
	      var parent = this.start.parentNode;
	      var model = parent && parent.__v_model;
	      if (model) {
	        model.forceUpdate();
	      }
	    }
	  },
	
	  /**
	   * Insert a fragment. Handles staggering.
	   *
	   * @param {Fragment} frag
	   * @param {Number} index
	   * @param {Node} prevEl
	   * @param {Boolean} inDocument
	   */
	
	  insert: function insert(frag, index, prevEl, inDocument) {
	    if (frag.staggerCb) {
	      frag.staggerCb.cancel();
	      frag.staggerCb = null;
	    }
	    var staggerAmount = this.getStagger(frag, index, null, 'enter');
	    if (inDocument && staggerAmount) {
	      // create an anchor and insert it synchronously,
	      // so that we can resolve the correct order without
	      // worrying about some elements not inserted yet
	      var anchor = frag.staggerAnchor;
	      if (!anchor) {
	        anchor = frag.staggerAnchor = createAnchor('stagger-anchor');
	        anchor.__v_frag = frag;
	      }
	      after(anchor, prevEl);
	      var op = frag.staggerCb = cancellable(function () {
	        frag.staggerCb = null;
	        frag.before(anchor);
	        remove(anchor);
	      });
	      setTimeout(op, staggerAmount);
	    } else {
	      var target = prevEl.nextSibling;
	      /* istanbul ignore if */
	      if (!target) {
	        // reset end anchor position in case the position was messed up
	        // by an external drag-n-drop library.
	        after(this.end, prevEl);
	        target = this.end;
	      }
	      frag.before(target);
	    }
	  },
	
	  /**
	   * Remove a fragment. Handles staggering.
	   *
	   * @param {Fragment} frag
	   * @param {Number} index
	   * @param {Number} total
	   * @param {Boolean} inDocument
	   */
	
	  remove: function remove(frag, index, total, inDocument) {
	    if (frag.staggerCb) {
	      frag.staggerCb.cancel();
	      frag.staggerCb = null;
	      // it's not possible for the same frag to be removed
	      // twice, so if we have a pending stagger callback,
	      // it means this frag is queued for enter but removed
	      // before its transition started. Since it is already
	      // destroyed, we can just leave it in detached state.
	      return;
	    }
	    var staggerAmount = this.getStagger(frag, index, total, 'leave');
	    if (inDocument && staggerAmount) {
	      var op = frag.staggerCb = cancellable(function () {
	        frag.staggerCb = null;
	        frag.remove();
	      });
	      setTimeout(op, staggerAmount);
	    } else {
	      frag.remove();
	    }
	  },
	
	  /**
	   * Move a fragment to a new position.
	   * Force no transition.
	   *
	   * @param {Fragment} frag
	   * @param {Node} prevEl
	   */
	
	  move: function move(frag, prevEl) {
	    // fix a common issue with Sortable:
	    // if prevEl doesn't have nextSibling, this means it's
	    // been dragged after the end anchor. Just re-position
	    // the end anchor to the end of the container.
	    /* istanbul ignore if */
	    if (!prevEl.nextSibling) {
	      this.end.parentNode.appendChild(this.end);
	    }
	    frag.before(prevEl.nextSibling, false);
	  },
	
	  /**
	   * Cache a fragment using track-by or the object key.
	   *
	   * @param {*} value
	   * @param {Fragment} frag
	   * @param {Number} index
	   * @param {String} [key]
	   */
	
	  cacheFrag: function cacheFrag(value, frag, index, key) {
	    var trackByKey = this.params.trackBy;
	    var cache = this.cache;
	    var primitive = !isObject(value);
	    var id;
	    if (key || trackByKey || primitive) {
	      id = getTrackByKey(index, key, value, trackByKey);
	      if (!cache[id]) {
	        cache[id] = frag;
	      } else if (trackByKey !== '$index') {
	        ("production") !== 'production' && this.warnDuplicate(value);
	      }
	    } else {
	      id = this.id;
	      if (hasOwn(value, id)) {
	        if (value[id] === null) {
	          value[id] = frag;
	        } else {
	          ("production") !== 'production' && this.warnDuplicate(value);
	        }
	      } else if (Object.isExtensible(value)) {
	        def(value, id, frag);
	      } else if (false) {
	        warn('Frozen v-for objects cannot be automatically tracked, make sure to ' + 'provide a track-by key.');
	      }
	    }
	    frag.raw = value;
	  },
	
	  /**
	   * Get a cached fragment from the value/index/key
	   *
	   * @param {*} value
	   * @param {Number} index
	   * @param {String} key
	   * @return {Fragment}
	   */
	
	  getCachedFrag: function getCachedFrag(value, index, key) {
	    var trackByKey = this.params.trackBy;
	    var primitive = !isObject(value);
	    var frag;
	    if (key || trackByKey || primitive) {
	      var id = getTrackByKey(index, key, value, trackByKey);
	      frag = this.cache[id];
	    } else {
	      frag = value[this.id];
	    }
	    if (frag && (frag.reused || frag.fresh)) {
	      ("production") !== 'production' && this.warnDuplicate(value);
	    }
	    return frag;
	  },
	
	  /**
	   * Delete a fragment from cache.
	   *
	   * @param {Fragment} frag
	   */
	
	  deleteCachedFrag: function deleteCachedFrag(frag) {
	    var value = frag.raw;
	    var trackByKey = this.params.trackBy;
	    var scope = frag.scope;
	    var index = scope.$index;
	    // fix #948: avoid accidentally fall through to
	    // a parent repeater which happens to have $key.
	    var key = hasOwn(scope, '$key') && scope.$key;
	    var primitive = !isObject(value);
	    if (trackByKey || key || primitive) {
	      var id = getTrackByKey(index, key, value, trackByKey);
	      this.cache[id] = null;
	    } else {
	      value[this.id] = null;
	      frag.raw = null;
	    }
	  },
	
	  /**
	   * Get the stagger amount for an insertion/removal.
	   *
	   * @param {Fragment} frag
	   * @param {Number} index
	   * @param {Number} total
	   * @param {String} type
	   */
	
	  getStagger: function getStagger(frag, index, total, type) {
	    type = type + 'Stagger';
	    var trans = frag.node.__v_trans;
	    var hooks = trans && trans.hooks;
	    var hook = hooks && (hooks[type] || hooks.stagger);
	    return hook ? hook.call(frag, index, total) : index * parseInt(this.params[type] || this.params.stagger, 10);
	  },
	
	  /**
	   * Pre-process the value before piping it through the
	   * filters. This is passed to and called by the watcher.
	   */
	
	  _preProcess: function _preProcess(value) {
	    // regardless of type, store the un-filtered raw value.
	    this.rawValue = value;
	    return value;
	  },
	
	  /**
	   * Post-process the value after it has been piped through
	   * the filters. This is passed to and called by the watcher.
	   *
	   * It is necessary for this to be called during the
	   * watcher's dependency collection phase because we want
	   * the v-for to update when the source Object is mutated.
	   */
	
	  _postProcess: function _postProcess(value) {
	    if (isArray(value)) {
	      return value;
	    } else if (isPlainObject(value)) {
	      // convert plain object to array.
	      var keys = Object.keys(value);
	      var i = keys.length;
	      var res = new Array(i);
	      var key;
	      while (i--) {
	        key = keys[i];
	        res[i] = {
	          $key: key,
	          $value: value[key]
	        };
	      }
	      return res;
	    } else {
	      if (typeof value === 'number' && !isNaN(value)) {
	        value = range(value);
	      }
	      return value || [];
	    }
	  },
	
	  unbind: function unbind() {
	    if (this.descriptor.ref) {
	      (this._scope || this.vm).$refs[this.descriptor.ref] = null;
	    }
	    if (this.frags) {
	      var i = this.frags.length;
	      var frag;
	      while (i--) {
	        frag = this.frags[i];
	        this.deleteCachedFrag(frag);
	        frag.destroy();
	      }
	    }
	  }
	};
	
	/**
	 * Helper to find the previous element that is a fragment
	 * anchor. This is necessary because a destroyed frag's
	 * element could still be lingering in the DOM before its
	 * leaving transition finishes, but its inserted flag
	 * should have been set to false so we can skip them.
	 *
	 * If this is a block repeat, we want to make sure we only
	 * return frag that is bound to this v-for. (see #929)
	 *
	 * @param {Fragment} frag
	 * @param {Comment|Text} anchor
	 * @param {String} id
	 * @return {Fragment}
	 */
	
	function findPrevFrag(frag, anchor, id) {
	  var el = frag.node.previousSibling;
	  /* istanbul ignore if */
	  if (!el) return;
	  frag = el.__v_frag;
	  while ((!frag || frag.forId !== id || !frag.inserted) && el !== anchor) {
	    el = el.previousSibling;
	    /* istanbul ignore if */
	    if (!el) return;
	    frag = el.__v_frag;
	  }
	  return frag;
	}
	
	/**
	 * Create a range array from given number.
	 *
	 * @param {Number} n
	 * @return {Array}
	 */
	
	function range(n) {
	  var i = -1;
	  var ret = new Array(Math.floor(n));
	  while (++i < n) {
	    ret[i] = i;
	  }
	  return ret;
	}
	
	/**
	 * Get the track by key for an item.
	 *
	 * @param {Number} index
	 * @param {String} key
	 * @param {*} value
	 * @param {String} [trackByKey]
	 */
	
	function getTrackByKey(index, key, value, trackByKey) {
	  return trackByKey ? trackByKey === '$index' ? index : trackByKey.charAt(0).match(/\w/) ? getPath(value, trackByKey) : value[trackByKey] : key || value;
	}
	
	if (false) {
	  vFor.warnDuplicate = function (value) {
	    warn('Duplicate value found in v-for="' + this.descriptor.raw + '": ' + JSON.stringify(value) + '. Use track-by="$index" if ' + 'you are expecting duplicate values.', this.vm);
	  };
	}
	
	/**
	 * Find a vm from a fragment.
	 *
	 * @param {Fragment} frag
	 * @return {Vue|undefined}
	 */
	
	function findVmFromFrag(frag) {
	  var node = frag.node;
	  // handle multi-node frag
	  if (frag.end) {
	    while (!node.__vue__ && node !== frag.end && node.nextSibling) {
	      node = node.nextSibling;
	    }
	  }
	  return node.__vue__;
	}
	
	var vIf = {
	
	  priority: IF,
	  terminal: true,
	
	  bind: function bind() {
	    var el = this.el;
	    if (!el.__vue__) {
	      // check else block
	      var next = el.nextElementSibling;
	      if (next && getAttr(next, 'v-else') !== null) {
	        remove(next);
	        this.elseEl = next;
	      }
	      // check main block
	      this.anchor = createAnchor('v-if');
	      replace(el, this.anchor);
	    } else {
	      ("production") !== 'production' && warn('v-if="' + this.expression + '" cannot be ' + 'used on an instance root element.', this.vm);
	      this.invalid = true;
	    }
	  },
	
	  update: function update(value) {
	    if (this.invalid) return;
	    if (value) {
	      if (!this.frag) {
	        this.insert();
	      }
	    } else {
	      this.remove();
	    }
	  },
	
	  insert: function insert() {
	    if (this.elseFrag) {
	      this.elseFrag.remove();
	      this.elseFrag = null;
	    }
	    // lazy init factory
	    if (!this.factory) {
	      this.factory = new FragmentFactory(this.vm, this.el);
	    }
	    this.frag = this.factory.create(this._host, this._scope, this._frag);
	    this.frag.before(this.anchor);
	  },
	
	  remove: function remove() {
	    if (this.frag) {
	      this.frag.remove();
	      this.frag = null;
	    }
	    if (this.elseEl && !this.elseFrag) {
	      if (!this.elseFactory) {
	        this.elseFactory = new FragmentFactory(this.elseEl._context || this.vm, this.elseEl);
	      }
	      this.elseFrag = this.elseFactory.create(this._host, this._scope, this._frag);
	      this.elseFrag.before(this.anchor);
	    }
	  },
	
	  unbind: function unbind() {
	    if (this.frag) {
	      this.frag.destroy();
	    }
	    if (this.elseFrag) {
	      this.elseFrag.destroy();
	    }
	  }
	};
	
	var show = {
	
	  bind: function bind() {
	    // check else block
	    var next = this.el.nextElementSibling;
	    if (next && getAttr(next, 'v-else') !== null) {
	      this.elseEl = next;
	    }
	  },
	
	  update: function update(value) {
	    this.apply(this.el, value);
	    if (this.elseEl) {
	      this.apply(this.elseEl, !value);
	    }
	  },
	
	  apply: function apply(el, value) {
	    if (inDoc(el)) {
	      applyTransition(el, value ? 1 : -1, toggle, this.vm);
	    } else {
	      toggle();
	    }
	    function toggle() {
	      el.style.display = value ? '' : 'none';
	    }
	  }
	};
	
	var text$2 = {
	
	  bind: function bind() {
	    var self = this;
	    var el = this.el;
	    var isRange = el.type === 'range';
	    var lazy = this.params.lazy;
	    var number = this.params.number;
	    var debounce = this.params.debounce;
	
	    // handle composition events.
	    //   http://blog.evanyou.me/2014/01/03/composition-event/
	    // skip this for Android because it handles composition
	    // events quite differently. Android doesn't trigger
	    // composition events for language input methods e.g.
	    // Chinese, but instead triggers them for spelling
	    // suggestions... (see Discussion/#162)
	    var composing = false;
	    if (!isAndroid && !isRange) {
	      this.on('compositionstart', function () {
	        composing = true;
	      });
	      this.on('compositionend', function () {
	        composing = false;
	        // in IE11 the "compositionend" event fires AFTER
	        // the "input" event, so the input handler is blocked
	        // at the end... have to call it here.
	        //
	        // #1327: in lazy mode this is unecessary.
	        if (!lazy) {
	          self.listener();
	        }
	      });
	    }
	
	    // prevent messing with the input when user is typing,
	    // and force update on blur.
	    this.focused = false;
	    if (!isRange && !lazy) {
	      this.on('focus', function () {
	        self.focused = true;
	      });
	      this.on('blur', function () {
	        self.focused = false;
	        // do not sync value after fragment removal (#2017)
	        if (!self._frag || self._frag.inserted) {
	          self.rawListener();
	        }
	      });
	    }
	
	    // Now attach the main listener
	    this.listener = this.rawListener = function () {
	      if (composing || !self._bound) {
	        return;
	      }
	      var val = number || isRange ? toNumber(el.value) : el.value;
	      self.set(val);
	      // force update on next tick to avoid lock & same value
	      // also only update when user is not typing
	      nextTick(function () {
	        if (self._bound && !self.focused) {
	          self.update(self._watcher.value);
	        }
	      });
	    };
	
	    // apply debounce
	    if (debounce) {
	      this.listener = _debounce(this.listener, debounce);
	    }
	
	    // Support jQuery events, since jQuery.trigger() doesn't
	    // trigger native events in some cases and some plugins
	    // rely on $.trigger()
	    //
	    // We want to make sure if a listener is attached using
	    // jQuery, it is also removed with jQuery, that's why
	    // we do the check for each directive instance and
	    // store that check result on itself. This also allows
	    // easier test coverage control by unsetting the global
	    // jQuery variable in tests.
	    this.hasjQuery = typeof jQuery === 'function';
	    if (this.hasjQuery) {
	      var method = jQuery.fn.on ? 'on' : 'bind';
	      jQuery(el)[method]('change', this.rawListener);
	      if (!lazy) {
	        jQuery(el)[method]('input', this.listener);
	      }
	    } else {
	      this.on('change', this.rawListener);
	      if (!lazy) {
	        this.on('input', this.listener);
	      }
	    }
	
	    // IE9 doesn't fire input event on backspace/del/cut
	    if (!lazy && isIE9) {
	      this.on('cut', function () {
	        nextTick(self.listener);
	      });
	      this.on('keyup', function (e) {
	        if (e.keyCode === 46 || e.keyCode === 8) {
	          self.listener();
	        }
	      });
	    }
	
	    // set initial value if present
	    if (el.hasAttribute('value') || el.tagName === 'TEXTAREA' && el.value.trim()) {
	      this.afterBind = this.listener;
	    }
	  },
	
	  update: function update(value) {
	    // #3029 only update when the value changes. This prevent
	    // browsers from overwriting values like selectionStart
	    value = _toString(value);
	    if (value !== this.el.value) this.el.value = value;
	  },
	
	  unbind: function unbind() {
	    var el = this.el;
	    if (this.hasjQuery) {
	      var method = jQuery.fn.off ? 'off' : 'unbind';
	      jQuery(el)[method]('change', this.listener);
	      jQuery(el)[method]('input', this.listener);
	    }
	  }
	};
	
	var radio = {
	
	  bind: function bind() {
	    var self = this;
	    var el = this.el;
	
	    this.getValue = function () {
	      // value overwrite via v-bind:value
	      if (el.hasOwnProperty('_value')) {
	        return el._value;
	      }
	      var val = el.value;
	      if (self.params.number) {
	        val = toNumber(val);
	      }
	      return val;
	    };
	
	    this.listener = function () {
	      self.set(self.getValue());
	    };
	    this.on('change', this.listener);
	
	    if (el.hasAttribute('checked')) {
	      this.afterBind = this.listener;
	    }
	  },
	
	  update: function update(value) {
	    this.el.checked = looseEqual(value, this.getValue());
	  }
	};
	
	var select = {
	
	  bind: function bind() {
	    var _this = this;
	
	    var self = this;
	    var el = this.el;
	
	    // method to force update DOM using latest value.
	    this.forceUpdate = function () {
	      if (self._watcher) {
	        self.update(self._watcher.get());
	      }
	    };
	
	    // check if this is a multiple select
	    var multiple = this.multiple = el.hasAttribute('multiple');
	
	    // attach listener
	    this.listener = function () {
	      var value = getValue(el, multiple);
	      value = self.params.number ? isArray(value) ? value.map(toNumber) : toNumber(value) : value;
	      self.set(value);
	    };
	    this.on('change', this.listener);
	
	    // if has initial value, set afterBind
	    var initValue = getValue(el, multiple, true);
	    if (multiple && initValue.length || !multiple && initValue !== null) {
	      this.afterBind = this.listener;
	    }
	
	    // All major browsers except Firefox resets
	    // selectedIndex with value -1 to 0 when the element
	    // is appended to a new parent, therefore we have to
	    // force a DOM update whenever that happens...
	    this.vm.$on('hook:attached', function () {
	      nextTick(_this.forceUpdate);
	    });
	    if (!inDoc(el)) {
	      nextTick(this.forceUpdate);
	    }
	  },
	
	  update: function update(value) {
	    var el = this.el;
	    el.selectedIndex = -1;
	    var multi = this.multiple && isArray(value);
	    var options = el.options;
	    var i = options.length;
	    var op, val;
	    while (i--) {
	      op = options[i];
	      val = op.hasOwnProperty('_value') ? op._value : op.value;
	      /* eslint-disable eqeqeq */
	      op.selected = multi ? indexOf$1(value, val) > -1 : looseEqual(value, val);
	      /* eslint-enable eqeqeq */
	    }
	  },
	
	  unbind: function unbind() {
	    /* istanbul ignore next */
	    this.vm.$off('hook:attached', this.forceUpdate);
	  }
	};
	
	/**
	 * Get select value
	 *
	 * @param {SelectElement} el
	 * @param {Boolean} multi
	 * @param {Boolean} init
	 * @return {Array|*}
	 */
	
	function getValue(el, multi, init) {
	  var res = multi ? [] : null;
	  var op, val, selected;
	  for (var i = 0, l = el.options.length; i < l; i++) {
	    op = el.options[i];
	    selected = init ? op.hasAttribute('selected') : op.selected;
	    if (selected) {
	      val = op.hasOwnProperty('_value') ? op._value : op.value;
	      if (multi) {
	        res.push(val);
	      } else {
	        return val;
	      }
	    }
	  }
	  return res;
	}
	
	/**
	 * Native Array.indexOf uses strict equal, but in this
	 * case we need to match string/numbers with custom equal.
	 *
	 * @param {Array} arr
	 * @param {*} val
	 */
	
	function indexOf$1(arr, val) {
	  var i = arr.length;
	  while (i--) {
	    if (looseEqual(arr[i], val)) {
	      return i;
	    }
	  }
	  return -1;
	}
	
	var checkbox = {
	
	  bind: function bind() {
	    var self = this;
	    var el = this.el;
	
	    this.getValue = function () {
	      return el.hasOwnProperty('_value') ? el._value : self.params.number ? toNumber(el.value) : el.value;
	    };
	
	    function getBooleanValue() {
	      var val = el.checked;
	      if (val && el.hasOwnProperty('_trueValue')) {
	        return el._trueValue;
	      }
	      if (!val && el.hasOwnProperty('_falseValue')) {
	        return el._falseValue;
	      }
	      return val;
	    }
	
	    this.listener = function () {
	      var model = self._watcher.get();
	      if (isArray(model)) {
	        var val = self.getValue();
	        var i = indexOf(model, val);
	        if (el.checked) {
	          if (i < 0) {
	            self.set(model.concat(val));
	          }
	        } else if (i > -1) {
	          self.set(model.slice(0, i).concat(model.slice(i + 1)));
	        }
	      } else {
	        self.set(getBooleanValue());
	      }
	    };
	
	    this.on('change', this.listener);
	    if (el.hasAttribute('checked')) {
	      this.afterBind = this.listener;
	    }
	  },
	
	  update: function update(value) {
	    var el = this.el;
	    if (isArray(value)) {
	      el.checked = indexOf(value, this.getValue()) > -1;
	    } else {
	      if (el.hasOwnProperty('_trueValue')) {
	        el.checked = looseEqual(value, el._trueValue);
	      } else {
	        el.checked = !!value;
	      }
	    }
	  }
	};
	
	var handlers = {
	  text: text$2,
	  radio: radio,
	  select: select,
	  checkbox: checkbox
	};
	
	var model = {
	
	  priority: MODEL,
	  twoWay: true,
	  handlers: handlers,
	  params: ['lazy', 'number', 'debounce'],
	
	  /**
	   * Possible elements:
	   *   <select>
	   *   <textarea>
	   *   <input type="*">
	   *     - text
	   *     - checkbox
	   *     - radio
	   *     - number
	   */
	
	  bind: function bind() {
	    // friendly warning...
	    this.checkFilters();
	    if (this.hasRead && !this.hasWrite) {
	      ("production") !== 'production' && warn('It seems you are using a read-only filter with ' + 'v-model="' + this.descriptor.raw + '". ' + 'You might want to use a two-way filter to ensure correct behavior.', this.vm);
	    }
	    var el = this.el;
	    var tag = el.tagName;
	    var handler;
	    if (tag === 'INPUT') {
	      handler = handlers[el.type] || handlers.text;
	    } else if (tag === 'SELECT') {
	      handler = handlers.select;
	    } else if (tag === 'TEXTAREA') {
	      handler = handlers.text;
	    } else {
	      ("production") !== 'production' && warn('v-model does not support element type: ' + tag, this.vm);
	      return;
	    }
	    el.__v_model = this;
	    handler.bind.call(this);
	    this.update = handler.update;
	    this._unbind = handler.unbind;
	  },
	
	  /**
	   * Check read/write filter stats.
	   */
	
	  checkFilters: function checkFilters() {
	    var filters = this.filters;
	    if (!filters) return;
	    var i = filters.length;
	    while (i--) {
	      var filter = resolveAsset(this.vm.$options, 'filters', filters[i].name);
	      if (typeof filter === 'function' || filter.read) {
	        this.hasRead = true;
	      }
	      if (filter.write) {
	        this.hasWrite = true;
	      }
	    }
	  },
	
	  unbind: function unbind() {
	    this.el.__v_model = null;
	    this._unbind && this._unbind();
	  }
	};
	
	// keyCode aliases
	var keyCodes = {
	  esc: 27,
	  tab: 9,
	  enter: 13,
	  space: 32,
	  'delete': [8, 46],
	  up: 38,
	  left: 37,
	  right: 39,
	  down: 40
	};
	
	function keyFilter(handler, keys) {
	  var codes = keys.map(function (key) {
	    var charCode = key.charCodeAt(0);
	    if (charCode > 47 && charCode < 58) {
	      return parseInt(key, 10);
	    }
	    if (key.length === 1) {
	      charCode = key.toUpperCase().charCodeAt(0);
	      if (charCode > 64 && charCode < 91) {
	        return charCode;
	      }
	    }
	    return keyCodes[key];
	  });
	  codes = [].concat.apply([], codes);
	  return function keyHandler(e) {
	    if (codes.indexOf(e.keyCode) > -1) {
	      return handler.call(this, e);
	    }
	  };
	}
	
	function stopFilter(handler) {
	  return function stopHandler(e) {
	    e.stopPropagation();
	    return handler.call(this, e);
	  };
	}
	
	function preventFilter(handler) {
	  return function preventHandler(e) {
	    e.preventDefault();
	    return handler.call(this, e);
	  };
	}
	
	function selfFilter(handler) {
	  return function selfHandler(e) {
	    if (e.target === e.currentTarget) {
	      return handler.call(this, e);
	    }
	  };
	}
	
	var on$1 = {
	
	  priority: ON,
	  acceptStatement: true,
	  keyCodes: keyCodes,
	
	  bind: function bind() {
	    // deal with iframes
	    if (this.el.tagName === 'IFRAME' && this.arg !== 'load') {
	      var self = this;
	      this.iframeBind = function () {
	        on(self.el.contentWindow, self.arg, self.handler, self.modifiers.capture);
	      };
	      this.on('load', this.iframeBind);
	    }
	  },
	
	  update: function update(handler) {
	    // stub a noop for v-on with no value,
	    // e.g. @mousedown.prevent
	    if (!this.descriptor.raw) {
	      handler = function () {};
	    }
	
	    if (typeof handler !== 'function') {
	      ("production") !== 'production' && warn('v-on:' + this.arg + '="' + this.expression + '" expects a function value, ' + 'got ' + handler, this.vm);
	      return;
	    }
	
	    // apply modifiers
	    if (this.modifiers.stop) {
	      handler = stopFilter(handler);
	    }
	    if (this.modifiers.prevent) {
	      handler = preventFilter(handler);
	    }
	    if (this.modifiers.self) {
	      handler = selfFilter(handler);
	    }
	    // key filter
	    var keys = Object.keys(this.modifiers).filter(function (key) {
	      return key !== 'stop' && key !== 'prevent' && key !== 'self' && key !== 'capture';
	    });
	    if (keys.length) {
	      handler = keyFilter(handler, keys);
	    }
	
	    this.reset();
	    this.handler = handler;
	
	    if (this.iframeBind) {
	      this.iframeBind();
	    } else {
	      on(this.el, this.arg, this.handler, this.modifiers.capture);
	    }
	  },
	
	  reset: function reset() {
	    var el = this.iframeBind ? this.el.contentWindow : this.el;
	    if (this.handler) {
	      off(el, this.arg, this.handler);
	    }
	  },
	
	  unbind: function unbind() {
	    this.reset();
	  }
	};
	
	var prefixes = ['-webkit-', '-moz-', '-ms-'];
	var camelPrefixes = ['Webkit', 'Moz', 'ms'];
	var importantRE = /!important;?$/;
	var propCache = Object.create(null);
	
	var testEl = null;
	
	var style = {
	
	  deep: true,
	
	  update: function update(value) {
	    if (typeof value === 'string') {
	      this.el.style.cssText = value;
	    } else if (isArray(value)) {
	      this.handleObject(value.reduce(extend, {}));
	    } else {
	      this.handleObject(value || {});
	    }
	  },
	
	  handleObject: function handleObject(value) {
	    // cache object styles so that only changed props
	    // are actually updated.
	    var cache = this.cache || (this.cache = {});
	    var name, val;
	    for (name in cache) {
	      if (!(name in value)) {
	        this.handleSingle(name, null);
	        delete cache[name];
	      }
	    }
	    for (name in value) {
	      val = value[name];
	      if (val !== cache[name]) {
	        cache[name] = val;
	        this.handleSingle(name, val);
	      }
	    }
	  },
	
	  handleSingle: function handleSingle(prop, value) {
	    prop = normalize(prop);
	    if (!prop) return; // unsupported prop
	    // cast possible numbers/booleans into strings
	    if (value != null) value += '';
	    if (value) {
	      var isImportant = importantRE.test(value) ? 'important' : '';
	      if (isImportant) {
	        /* istanbul ignore if */
	        if (false) {
	          warn('It\'s probably a bad idea to use !important with inline rules. ' + 'This feature will be deprecated in a future version of Vue.');
	        }
	        value = value.replace(importantRE, '').trim();
	        this.el.style.setProperty(prop.kebab, value, isImportant);
	      } else {
	        this.el.style[prop.camel] = value;
	      }
	    } else {
	      this.el.style[prop.camel] = '';
	    }
	  }
	
	};
	
	/**
	 * Normalize a CSS property name.
	 * - cache result
	 * - auto prefix
	 * - camelCase -> dash-case
	 *
	 * @param {String} prop
	 * @return {String}
	 */
	
	function normalize(prop) {
	  if (propCache[prop]) {
	    return propCache[prop];
	  }
	  var res = prefix(prop);
	  propCache[prop] = propCache[res] = res;
	  return res;
	}
	
	/**
	 * Auto detect the appropriate prefix for a CSS property.
	 * https://gist.github.com/paulirish/523692
	 *
	 * @param {String} prop
	 * @return {String}
	 */
	
	function prefix(prop) {
	  prop = hyphenate(prop);
	  var camel = camelize(prop);
	  var upper = camel.charAt(0).toUpperCase() + camel.slice(1);
	  if (!testEl) {
	    testEl = document.createElement('div');
	  }
	  var i = prefixes.length;
	  var prefixed;
	  if (camel !== 'filter' && camel in testEl.style) {
	    return {
	      kebab: prop,
	      camel: camel
	    };
	  }
	  while (i--) {
	    prefixed = camelPrefixes[i] + upper;
	    if (prefixed in testEl.style) {
	      return {
	        kebab: prefixes[i] + prop,
	        camel: prefixed
	      };
	    }
	  }
	}
	
	// xlink
	var xlinkNS = 'http://www.w3.org/1999/xlink';
	var xlinkRE = /^xlink:/;
	
	// check for attributes that prohibit interpolations
	var disallowedInterpAttrRE = /^v-|^:|^@|^(?:is|transition|transition-mode|debounce|track-by|stagger|enter-stagger|leave-stagger)$/;
	// these attributes should also set their corresponding properties
	// because they only affect the initial state of the element
	var attrWithPropsRE = /^(?:value|checked|selected|muted)$/;
	// these attributes expect enumrated values of "true" or "false"
	// but are not boolean attributes
	var enumeratedAttrRE = /^(?:draggable|contenteditable|spellcheck)$/;
	
	// these attributes should set a hidden property for
	// binding v-model to object values
	var modelProps = {
	  value: '_value',
	  'true-value': '_trueValue',
	  'false-value': '_falseValue'
	};
	
	var bind$1 = {
	
	  priority: BIND,
	
	  bind: function bind() {
	    var attr = this.arg;
	    var tag = this.el.tagName;
	    // should be deep watch on object mode
	    if (!attr) {
	      this.deep = true;
	    }
	    // handle interpolation bindings
	    var descriptor = this.descriptor;
	    var tokens = descriptor.interp;
	    if (tokens) {
	      // handle interpolations with one-time tokens
	      if (descriptor.hasOneTime) {
	        this.expression = tokensToExp(tokens, this._scope || this.vm);
	      }
	
	      // only allow binding on native attributes
	      if (disallowedInterpAttrRE.test(attr) || attr === 'name' && (tag === 'PARTIAL' || tag === 'SLOT')) {
	        ("production") !== 'production' && warn(attr + '="' + descriptor.raw + '": ' + 'attribute interpolation is not allowed in Vue.js ' + 'directives and special attributes.', this.vm);
	        this.el.removeAttribute(attr);
	        this.invalid = true;
	      }
	
	      /* istanbul ignore if */
	      if (false) {
	        var raw = attr + '="' + descriptor.raw + '": ';
	        // warn src
	        if (attr === 'src') {
	          warn(raw + 'interpolation in "src" attribute will cause ' + 'a 404 request. Use v-bind:src instead.', this.vm);
	        }
	
	        // warn style
	        if (attr === 'style') {
	          warn(raw + 'interpolation in "style" attribute will cause ' + 'the attribute to be discarded in Internet Explorer. ' + 'Use v-bind:style instead.', this.vm);
	        }
	      }
	    }
	  },
	
	  update: function update(value) {
	    if (this.invalid) {
	      return;
	    }
	    var attr = this.arg;
	    if (this.arg) {
	      this.handleSingle(attr, value);
	    } else {
	      this.handleObject(value || {});
	    }
	  },
	
	  // share object handler with v-bind:class
	  handleObject: style.handleObject,
	
	  handleSingle: function handleSingle(attr, value) {
	    var el = this.el;
	    var interp = this.descriptor.interp;
	    if (this.modifiers.camel) {
	      attr = camelize(attr);
	    }
	    if (!interp && attrWithPropsRE.test(attr) && attr in el) {
	      var attrValue = attr === 'value' ? value == null // IE9 will set input.value to "null" for null...
	      ? '' : value : value;
	
	      if (el[attr] !== attrValue) {
	        el[attr] = attrValue;
	      }
	    }
	    // set model props
	    var modelProp = modelProps[attr];
	    if (!interp && modelProp) {
	      el[modelProp] = value;
	      // update v-model if present
	      var model = el.__v_model;
	      if (model) {
	        model.listener();
	      }
	    }
	    // do not set value attribute for textarea
	    if (attr === 'value' && el.tagName === 'TEXTAREA') {
	      el.removeAttribute(attr);
	      return;
	    }
	    // update attribute
	    if (enumeratedAttrRE.test(attr)) {
	      el.setAttribute(attr, value ? 'true' : 'false');
	    } else if (value != null && value !== false) {
	      if (attr === 'class') {
	        // handle edge case #1960:
	        // class interpolation should not overwrite Vue transition class
	        if (el.__v_trans) {
	          value += ' ' + el.__v_trans.id + '-transition';
	        }
	        setClass(el, value);
	      } else if (xlinkRE.test(attr)) {
	        el.setAttributeNS(xlinkNS, attr, value === true ? '' : value);
	      } else {
	        el.setAttribute(attr, value === true ? '' : value);
	      }
	    } else {
	      el.removeAttribute(attr);
	    }
	  }
	};
	
	var el = {
	
	  priority: EL,
	
	  bind: function bind() {
	    /* istanbul ignore if */
	    if (!this.arg) {
	      return;
	    }
	    var id = this.id = camelize(this.arg);
	    var refs = (this._scope || this.vm).$els;
	    if (hasOwn(refs, id)) {
	      refs[id] = this.el;
	    } else {
	      defineReactive(refs, id, this.el);
	    }
	  },
	
	  unbind: function unbind() {
	    var refs = (this._scope || this.vm).$els;
	    if (refs[this.id] === this.el) {
	      refs[this.id] = null;
	    }
	  }
	};
	
	var ref = {
	  bind: function bind() {
	    ("production") !== 'production' && warn('v-ref:' + this.arg + ' must be used on a child ' + 'component. Found on <' + this.el.tagName.toLowerCase() + '>.', this.vm);
	  }
	};
	
	var cloak = {
	  bind: function bind() {
	    var el = this.el;
	    this.vm.$once('pre-hook:compiled', function () {
	      el.removeAttribute('v-cloak');
	    });
	  }
	};
	
	// logic control
	// two-way binding
	// event handling
	// attributes
	// ref & el
	// cloak
	// must export plain object
	var directives = {
	  text: text$1,
	  html: html,
	  'for': vFor,
	  'if': vIf,
	  show: show,
	  model: model,
	  on: on$1,
	  bind: bind$1,
	  el: el,
	  ref: ref,
	  cloak: cloak
	};
	
	var vClass = {
	
	  deep: true,
	
	  update: function update(value) {
	    if (!value) {
	      this.cleanup();
	    } else if (typeof value === 'string') {
	      this.setClass(value.trim().split(/\s+/));
	    } else {
	      this.setClass(normalize$1(value));
	    }
	  },
	
	  setClass: function setClass(value) {
	    this.cleanup(value);
	    for (var i = 0, l = value.length; i < l; i++) {
	      var val = value[i];
	      if (val) {
	        apply(this.el, val, addClass);
	      }
	    }
	    this.prevKeys = value;
	  },
	
	  cleanup: function cleanup(value) {
	    var prevKeys = this.prevKeys;
	    if (!prevKeys) return;
	    var i = prevKeys.length;
	    while (i--) {
	      var key = prevKeys[i];
	      if (!value || value.indexOf(key) < 0) {
	        apply(this.el, key, removeClass);
	      }
	    }
	  }
	};
	
	/**
	 * Normalize objects and arrays (potentially containing objects)
	 * into array of strings.
	 *
	 * @param {Object|Array<String|Object>} value
	 * @return {Array<String>}
	 */
	
	function normalize$1(value) {
	  var res = [];
	  if (isArray(value)) {
	    for (var i = 0, l = value.length; i < l; i++) {
	      var _key = value[i];
	      if (_key) {
	        if (typeof _key === 'string') {
	          res.push(_key);
	        } else {
	          for (var k in _key) {
	            if (_key[k]) res.push(k);
	          }
	        }
	      }
	    }
	  } else if (isObject(value)) {
	    for (var key in value) {
	      if (value[key]) res.push(key);
	    }
	  }
	  return res;
	}
	
	/**
	 * Add or remove a class/classes on an element
	 *
	 * @param {Element} el
	 * @param {String} key The class name. This may or may not
	 *                     contain a space character, in such a
	 *                     case we'll deal with multiple class
	 *                     names at once.
	 * @param {Function} fn
	 */
	
	function apply(el, key, fn) {
	  key = key.trim();
	  if (key.indexOf(' ') === -1) {
	    fn(el, key);
	    return;
	  }
	  // The key contains one or more space characters.
	  // Since a class name doesn't accept such characters, we
	  // treat it as multiple classes.
	  var keys = key.split(/\s+/);
	  for (var i = 0, l = keys.length; i < l; i++) {
	    fn(el, keys[i]);
	  }
	}
	
	var component = {
	
	  priority: COMPONENT,
	
	  params: ['keep-alive', 'transition-mode', 'inline-template'],
	
	  /**
	   * Setup. Two possible usages:
	   *
	   * - static:
	   *   <comp> or <div v-component="comp">
	   *
	   * - dynamic:
	   *   <component :is="view">
	   */
	
	  bind: function bind() {
	    if (!this.el.__vue__) {
	      // keep-alive cache
	      this.keepAlive = this.params.keepAlive;
	      if (this.keepAlive) {
	        this.cache = {};
	      }
	      // check inline-template
	      if (this.params.inlineTemplate) {
	        // extract inline template as a DocumentFragment
	        this.inlineTemplate = extractContent(this.el, true);
	      }
	      // component resolution related state
	      this.pendingComponentCb = this.Component = null;
	      // transition related state
	      this.pendingRemovals = 0;
	      this.pendingRemovalCb = null;
	      // create a ref anchor
	      this.anchor = createAnchor('v-component');
	      replace(this.el, this.anchor);
	      // remove is attribute.
	      // this is removed during compilation, but because compilation is
	      // cached, when the component is used elsewhere this attribute
	      // will remain at link time.
	      this.el.removeAttribute('is');
	      this.el.removeAttribute(':is');
	      // remove ref, same as above
	      if (this.descriptor.ref) {
	        this.el.removeAttribute('v-ref:' + hyphenate(this.descriptor.ref));
	      }
	      // if static, build right now.
	      if (this.literal) {
	        this.setComponent(this.expression);
	      }
	    } else {
	      ("production") !== 'production' && warn('cannot mount component "' + this.expression + '" ' + 'on already mounted element: ' + this.el);
	    }
	  },
	
	  /**
	   * Public update, called by the watcher in the dynamic
	   * literal scenario, e.g. <component :is="view">
	   */
	
	  update: function update(value) {
	    if (!this.literal) {
	      this.setComponent(value);
	    }
	  },
	
	  /**
	   * Switch dynamic components. May resolve the component
	   * asynchronously, and perform transition based on
	   * specified transition mode. Accepts a few additional
	   * arguments specifically for vue-router.
	   *
	   * The callback is called when the full transition is
	   * finished.
	   *
	   * @param {String} value
	   * @param {Function} [cb]
	   */
	
	  setComponent: function setComponent(value, cb) {
	    this.invalidatePending();
	    if (!value) {
	      // just remove current
	      this.unbuild(true);
	      this.remove(this.childVM, cb);
	      this.childVM = null;
	    } else {
	      var self = this;
	      this.resolveComponent(value, function () {
	        self.mountComponent(cb);
	      });
	    }
	  },
	
	  /**
	   * Resolve the component constructor to use when creating
	   * the child vm.
	   *
	   * @param {String|Function} value
	   * @param {Function} cb
	   */
	
	  resolveComponent: function resolveComponent(value, cb) {
	    var self = this;
	    this.pendingComponentCb = cancellable(function (Component) {
	      self.ComponentName = Component.options.name || (typeof value === 'string' ? value : null);
	      self.Component = Component;
	      cb();
	    });
	    this.vm._resolveComponent(value, this.pendingComponentCb);
	  },
	
	  /**
	   * Create a new instance using the current constructor and
	   * replace the existing instance. This method doesn't care
	   * whether the new component and the old one are actually
	   * the same.
	   *
	   * @param {Function} [cb]
	   */
	
	  mountComponent: function mountComponent(cb) {
	    // actual mount
	    this.unbuild(true);
	    var self = this;
	    var activateHooks = this.Component.options.activate;
	    var cached = this.getCached();
	    var newComponent = this.build();
	    if (activateHooks && !cached) {
	      this.waitingFor = newComponent;
	      callActivateHooks(activateHooks, newComponent, function () {
	        if (self.waitingFor !== newComponent) {
	          return;
	        }
	        self.waitingFor = null;
	        self.transition(newComponent, cb);
	      });
	    } else {
	      // update ref for kept-alive component
	      if (cached) {
	        newComponent._updateRef();
	      }
	      this.transition(newComponent, cb);
	    }
	  },
	
	  /**
	   * When the component changes or unbinds before an async
	   * constructor is resolved, we need to invalidate its
	   * pending callback.
	   */
	
	  invalidatePending: function invalidatePending() {
	    if (this.pendingComponentCb) {
	      this.pendingComponentCb.cancel();
	      this.pendingComponentCb = null;
	    }
	  },
	
	  /**
	   * Instantiate/insert a new child vm.
	   * If keep alive and has cached instance, insert that
	   * instance; otherwise build a new one and cache it.
	   *
	   * @param {Object} [extraOptions]
	   * @return {Vue} - the created instance
	   */
	
	  build: function build(extraOptions) {
	    var cached = this.getCached();
	    if (cached) {
	      return cached;
	    }
	    if (this.Component) {
	      // default options
	      var options = {
	        name: this.ComponentName,
	        el: cloneNode(this.el),
	        template: this.inlineTemplate,
	        // make sure to add the child with correct parent
	        // if this is a transcluded component, its parent
	        // should be the transclusion host.
	        parent: this._host || this.vm,
	        // if no inline-template, then the compiled
	        // linker can be cached for better performance.
	        _linkerCachable: !this.inlineTemplate,
	        _ref: this.descriptor.ref,
	        _asComponent: true,
	        _isRouterView: this._isRouterView,
	        // if this is a transcluded component, context
	        // will be the common parent vm of this instance
	        // and its host.
	        _context: this.vm,
	        // if this is inside an inline v-for, the scope
	        // will be the intermediate scope created for this
	        // repeat fragment. this is used for linking props
	        // and container directives.
	        _scope: this._scope,
	        // pass in the owner fragment of this component.
	        // this is necessary so that the fragment can keep
	        // track of its contained components in order to
	        // call attach/detach hooks for them.
	        _frag: this._frag
	      };
	      // extra options
	      // in 1.0.0 this is used by vue-router only
	      /* istanbul ignore if */
	      if (extraOptions) {
	        extend(options, extraOptions);
	      }
	      var child = new this.Component(options);
	      if (this.keepAlive) {
	        this.cache[this.Component.cid] = child;
	      }
	      /* istanbul ignore if */
	      if (false) {
	        warn('Transitions will not work on a fragment instance. ' + 'Template: ' + child.$options.template, child);
	      }
	      return child;
	    }
	  },
	
	  /**
	   * Try to get a cached instance of the current component.
	   *
	   * @return {Vue|undefined}
	   */
	
	  getCached: function getCached() {
	    return this.keepAlive && this.cache[this.Component.cid];
	  },
	
	  /**
	   * Teardown the current child, but defers cleanup so
	   * that we can separate the destroy and removal steps.
	   *
	   * @param {Boolean} defer
	   */
	
	  unbuild: function unbuild(defer) {
	    if (this.waitingFor) {
	      if (!this.keepAlive) {
	        this.waitingFor.$destroy();
	      }
	      this.waitingFor = null;
	    }
	    var child = this.childVM;
	    if (!child || this.keepAlive) {
	      if (child) {
	        // remove ref
	        child._inactive = true;
	        child._updateRef(true);
	      }
	      return;
	    }
	    // the sole purpose of `deferCleanup` is so that we can
	    // "deactivate" the vm right now and perform DOM removal
	    // later.
	    child.$destroy(false, defer);
	  },
	
	  /**
	   * Remove current destroyed child and manually do
	   * the cleanup after removal.
	   *
	   * @param {Function} cb
	   */
	
	  remove: function remove(child, cb) {
	    var keepAlive = this.keepAlive;
	    if (child) {
	      // we may have a component switch when a previous
	      // component is still being transitioned out.
	      // we want to trigger only one lastest insertion cb
	      // when the existing transition finishes. (#1119)
	      this.pendingRemovals++;
	      this.pendingRemovalCb = cb;
	      var self = this;
	      child.$remove(function () {
	        self.pendingRemovals--;
	        if (!keepAlive) child._cleanup();
	        if (!self.pendingRemovals && self.pendingRemovalCb) {
	          self.pendingRemovalCb();
	          self.pendingRemovalCb = null;
	        }
	      });
	    } else if (cb) {
	      cb();
	    }
	  },
	
	  /**
	   * Actually swap the components, depending on the
	   * transition mode. Defaults to simultaneous.
	   *
	   * @param {Vue} target
	   * @param {Function} [cb]
	   */
	
	  transition: function transition(target, cb) {
	    var self = this;
	    var current = this.childVM;
	    // for devtool inspection
	    if (current) current._inactive = true;
	    target._inactive = false;
	    this.childVM = target;
	    switch (self.params.transitionMode) {
	      case 'in-out':
	        target.$before(self.anchor, function () {
	          self.remove(current, cb);
	        });
	        break;
	      case 'out-in':
	        self.remove(current, function () {
	          target.$before(self.anchor, cb);
	        });
	        break;
	      default:
	        self.remove(current);
	        target.$before(self.anchor, cb);
	    }
	  },
	
	  /**
	   * Unbind.
	   */
	
	  unbind: function unbind() {
	    this.invalidatePending();
	    // Do not defer cleanup when unbinding
	    this.unbuild();
	    // destroy all keep-alive cached instances
	    if (this.cache) {
	      for (var key in this.cache) {
	        this.cache[key].$destroy();
	      }
	      this.cache = null;
	    }
	  }
	};
	
	/**
	 * Call activate hooks in order (asynchronous)
	 *
	 * @param {Array} hooks
	 * @param {Vue} vm
	 * @param {Function} cb
	 */
	
	function callActivateHooks(hooks, vm, cb) {
	  var total = hooks.length;
	  var called = 0;
	  hooks[0].call(vm, next);
	  function next() {
	    if (++called >= total) {
	      cb();
	    } else {
	      hooks[called].call(vm, next);
	    }
	  }
	}
	
	var propBindingModes = config._propBindingModes;
	var empty = {};
	
	// regexes
	var identRE$1 = /^[$_a-zA-Z]+[\w$]*$/;
	var settablePathRE = /^[A-Za-z_$][\w$]*(\.[A-Za-z_$][\w$]*|\[[^\[\]]+\])*$/;
	
	/**
	 * Compile props on a root element and return
	 * a props link function.
	 *
	 * @param {Element|DocumentFragment} el
	 * @param {Array} propOptions
	 * @param {Vue} vm
	 * @return {Function} propsLinkFn
	 */
	
	function compileProps(el, propOptions, vm) {
	  var props = [];
	  var propsData = vm.$options.propsData;
	  var names = Object.keys(propOptions);
	  var i = names.length;
	  var options, name, attr, value, path, parsed, prop;
	  while (i--) {
	    name = names[i];
	    options = propOptions[name] || empty;
	
	    if (false) {
	      warn('Do not use $data as prop.', vm);
	      continue;
	    }
	
	    // props could contain dashes, which will be
	    // interpreted as minus calculations by the parser
	    // so we need to camelize the path here
	    path = camelize(name);
	    if (!identRE$1.test(path)) {
	      ("production") !== 'production' && warn('Invalid prop key: "' + name + '". Prop keys ' + 'must be valid identifiers.', vm);
	      continue;
	    }
	
	    prop = {
	      name: name,
	      path: path,
	      options: options,
	      mode: propBindingModes.ONE_WAY,
	      raw: null
	    };
	
	    attr = hyphenate(name);
	    // first check dynamic version
	    if ((value = getBindAttr(el, attr)) === null) {
	      if ((value = getBindAttr(el, attr + '.sync')) !== null) {
	        prop.mode = propBindingModes.TWO_WAY;
	      } else if ((value = getBindAttr(el, attr + '.once')) !== null) {
	        prop.mode = propBindingModes.ONE_TIME;
	      }
	    }
	    if (value !== null) {
	      // has dynamic binding!
	      prop.raw = value;
	      parsed = parseDirective(value);
	      value = parsed.expression;
	      prop.filters = parsed.filters;
	      // check binding type
	      if (isLiteral(value) && !parsed.filters) {
	        // for expressions containing literal numbers and
	        // booleans, there's no need to setup a prop binding,
	        // so we can optimize them as a one-time set.
	        prop.optimizedLiteral = true;
	      } else {
	        prop.dynamic = true;
	        // check non-settable path for two-way bindings
	        if (false) {
	          prop.mode = propBindingModes.ONE_WAY;
	          warn('Cannot bind two-way prop with non-settable ' + 'parent path: ' + value, vm);
	        }
	      }
	      prop.parentPath = value;
	
	      // warn required two-way
	      if (false) {
	        warn('Prop "' + name + '" expects a two-way binding type.', vm);
	      }
	    } else if ((value = getAttr(el, attr)) !== null) {
	      // has literal binding!
	      prop.raw = value;
	    } else if (propsData && (value = propsData[name] || propsData[path]) !== null) {
	      // has propsData
	      prop.raw = value;
	    } else if (false) {
	      // check possible camelCase prop usage
	      var lowerCaseName = path.toLowerCase();
	      value = /[A-Z\-]/.test(name) && (el.getAttribute(lowerCaseName) || el.getAttribute(':' + lowerCaseName) || el.getAttribute('v-bind:' + lowerCaseName) || el.getAttribute(':' + lowerCaseName + '.once') || el.getAttribute('v-bind:' + lowerCaseName + '.once') || el.getAttribute(':' + lowerCaseName + '.sync') || el.getAttribute('v-bind:' + lowerCaseName + '.sync'));
	      if (value) {
	        warn('Possible usage error for prop `' + lowerCaseName + '` - ' + 'did you mean `' + attr + '`? HTML is case-insensitive, remember to use ' + 'kebab-case for props in templates.', vm);
	      } else if (options.required && (!propsData || !(name in propsData) && !(path in propsData))) {
	        // warn missing required
	        warn('Missing required prop: ' + name, vm);
	      }
	    }
	    // push prop
	    props.push(prop);
	  }
	  return makePropsLinkFn(props);
	}
	
	/**
	 * Build a function that applies props to a vm.
	 *
	 * @param {Array} props
	 * @return {Function} propsLinkFn
	 */
	
	function makePropsLinkFn(props) {
	  return function propsLinkFn(vm, scope) {
	    // store resolved props info
	    vm._props = {};
	    var inlineProps = vm.$options.propsData;
	    var i = props.length;
	    var prop, path, options, value, raw;
	    while (i--) {
	      prop = props[i];
	      raw = prop.raw;
	      path = prop.path;
	      options = prop.options;
	      vm._props[path] = prop;
	      if (inlineProps && hasOwn(inlineProps, path)) {
	        initProp(vm, prop, inlineProps[path]);
	      }if (raw === null) {
	        // initialize absent prop
	        initProp(vm, prop, undefined);
	      } else if (prop.dynamic) {
	        // dynamic prop
	        if (prop.mode === propBindingModes.ONE_TIME) {
	          // one time binding
	          value = (scope || vm._context || vm).$get(prop.parentPath);
	          initProp(vm, prop, value);
	        } else {
	          if (vm._context) {
	            // dynamic binding
	            vm._bindDir({
	              name: 'prop',
	              def: propDef,
	              prop: prop
	            }, null, null, scope); // el, host, scope
	          } else {
	              // root instance
	              initProp(vm, prop, vm.$get(prop.parentPath));
	            }
	        }
	      } else if (prop.optimizedLiteral) {
	        // optimized literal, cast it and just set once
	        var stripped = stripQuotes(raw);
	        value = stripped === raw ? toBoolean(toNumber(raw)) : stripped;
	        initProp(vm, prop, value);
	      } else {
	        // string literal, but we need to cater for
	        // Boolean props with no value, or with same
	        // literal value (e.g. disabled="disabled")
	        // see https://github.com/vuejs/vue-loader/issues/182
	        value = options.type === Boolean && (raw === '' || raw === hyphenate(prop.name)) ? true : raw;
	        initProp(vm, prop, value);
	      }
	    }
	  };
	}
	
	/**
	 * Process a prop with a rawValue, applying necessary coersions,
	 * default values & assertions and call the given callback with
	 * processed value.
	 *
	 * @param {Vue} vm
	 * @param {Object} prop
	 * @param {*} rawValue
	 * @param {Function} fn
	 */
	
	function processPropValue(vm, prop, rawValue, fn) {
	  var isSimple = prop.dynamic && isSimplePath(prop.parentPath);
	  var value = rawValue;
	  if (value === undefined) {
	    value = getPropDefaultValue(vm, prop);
	  }
	  value = coerceProp(prop, value, vm);
	  var coerced = value !== rawValue;
	  if (!assertProp(prop, value, vm)) {
	    value = undefined;
	  }
	  if (isSimple && !coerced) {
	    withoutConversion(function () {
	      fn(value);
	    });
	  } else {
	    fn(value);
	  }
	}
	
	/**
	 * Set a prop's initial value on a vm and its data object.
	 *
	 * @param {Vue} vm
	 * @param {Object} prop
	 * @param {*} value
	 */
	
	function initProp(vm, prop, value) {
	  processPropValue(vm, prop, value, function (value) {
	    defineReactive(vm, prop.path, value);
	  });
	}
	
	/**
	 * Update a prop's value on a vm.
	 *
	 * @param {Vue} vm
	 * @param {Object} prop
	 * @param {*} value
	 */
	
	function updateProp(vm, prop, value) {
	  processPropValue(vm, prop, value, function (value) {
	    vm[prop.path] = value;
	  });
	}
	
	/**
	 * Get the default value of a prop.
	 *
	 * @param {Vue} vm
	 * @param {Object} prop
	 * @return {*}
	 */
	
	function getPropDefaultValue(vm, prop) {
	  // no default, return undefined
	  var options = prop.options;
	  if (!hasOwn(options, 'default')) {
	    // absent boolean value defaults to false
	    return options.type === Boolean ? false : undefined;
	  }
	  var def = options['default'];
	  // warn against non-factory defaults for Object & Array
	  if (isObject(def)) {
	    ("production") !== 'production' && warn('Invalid default value for prop "' + prop.name + '": ' + 'Props with type Object/Array must use a factory function ' + 'to return the default value.', vm);
	  }
	  // call factory function for non-Function types
	  return typeof def === 'function' && options.type !== Function ? def.call(vm) : def;
	}
	
	/**
	 * Assert whether a prop is valid.
	 *
	 * @param {Object} prop
	 * @param {*} value
	 * @param {Vue} vm
	 */
	
	function assertProp(prop, value, vm) {
	  if (!prop.options.required && ( // non-required
	  prop.raw === null || // abscent
	  value == null) // null or undefined
	  ) {
	      return true;
	    }
	  var options = prop.options;
	  var type = options.type;
	  var valid = !type;
	  var expectedTypes = [];
	  if (type) {
	    if (!isArray(type)) {
	      type = [type];
	    }
	    for (var i = 0; i < type.length && !valid; i++) {
	      var assertedType = assertType(value, type[i]);
	      expectedTypes.push(assertedType.expectedType);
	      valid = assertedType.valid;
	    }
	  }
	  if (!valid) {
	    if (false) {
	      warn('Invalid prop: type check failed for prop "' + prop.name + '".' + ' Expected ' + expectedTypes.map(formatType).join(', ') + ', got ' + formatValue(value) + '.', vm);
	    }
	    return false;
	  }
	  var validator = options.validator;
	  if (validator) {
	    if (!validator(value)) {
	      ("production") !== 'production' && warn('Invalid prop: custom validator check failed for prop "' + prop.name + '".', vm);
	      return false;
	    }
	  }
	  return true;
	}
	
	/**
	 * Force parsing value with coerce option.
	 *
	 * @param {*} value
	 * @param {Object} options
	 * @return {*}
	 */
	
	function coerceProp(prop, value, vm) {
	  var coerce = prop.options.coerce;
	  if (!coerce) {
	    return value;
	  }
	  if (typeof coerce === 'function') {
	    return coerce(value);
	  } else {
	    ("production") !== 'production' && warn('Invalid coerce for prop "' + prop.name + '": expected function, got ' + typeof coerce + '.', vm);
	    return value;
	  }
	}
	
	/**
	 * Assert the type of a value
	 *
	 * @param {*} value
	 * @param {Function} type
	 * @return {Object}
	 */
	
	function assertType(value, type) {
	  var valid;
	  var expectedType;
	  if (type === String) {
	    expectedType = 'string';
	    valid = typeof value === expectedType;
	  } else if (type === Number) {
	    expectedType = 'number';
	    valid = typeof value === expectedType;
	  } else if (type === Boolean) {
	    expectedType = 'boolean';
	    valid = typeof value === expectedType;
	  } else if (type === Function) {
	    expectedType = 'function';
	    valid = typeof value === expectedType;
	  } else if (type === Object) {
	    expectedType = 'object';
	    valid = isPlainObject(value);
	  } else if (type === Array) {
	    expectedType = 'array';
	    valid = isArray(value);
	  } else {
	    valid = value instanceof type;
	  }
	  return {
	    valid: valid,
	    expectedType: expectedType
	  };
	}
	
	/**
	 * Format type for output
	 *
	 * @param {String} type
	 * @return {String}
	 */
	
	function formatType(type) {
	  return type ? type.charAt(0).toUpperCase() + type.slice(1) : 'custom type';
	}
	
	/**
	 * Format value
	 *
	 * @param {*} value
	 * @return {String}
	 */
	
	function formatValue(val) {
	  return Object.prototype.toString.call(val).slice(8, -1);
	}
	
	var bindingModes = config._propBindingModes;
	
	var propDef = {
	
	  bind: function bind() {
	    var child = this.vm;
	    var parent = child._context;
	    // passed in from compiler directly
	    var prop = this.descriptor.prop;
	    var childKey = prop.path;
	    var parentKey = prop.parentPath;
	    var twoWay = prop.mode === bindingModes.TWO_WAY;
	
	    var parentWatcher = this.parentWatcher = new Watcher(parent, parentKey, function (val) {
	      updateProp(child, prop, val);
	    }, {
	      twoWay: twoWay,
	      filters: prop.filters,
	      // important: props need to be observed on the
	      // v-for scope if present
	      scope: this._scope
	    });
	
	    // set the child initial value.
	    initProp(child, prop, parentWatcher.value);
	
	    // setup two-way binding
	    if (twoWay) {
	      // important: defer the child watcher creation until
	      // the created hook (after data observation)
	      var self = this;
	      child.$once('pre-hook:created', function () {
	        self.childWatcher = new Watcher(child, childKey, function (val) {
	          parentWatcher.set(val);
	        }, {
	          // ensure sync upward before parent sync down.
	          // this is necessary in cases e.g. the child
	          // mutates a prop array, then replaces it. (#1683)
	          sync: true
	        });
	      });
	    }
	  },
	
	  unbind: function unbind() {
	    this.parentWatcher.teardown();
	    if (this.childWatcher) {
	      this.childWatcher.teardown();
	    }
	  }
	};
	
	var queue$1 = [];
	var queued = false;
	
	/**
	 * Push a job into the queue.
	 *
	 * @param {Function} job
	 */
	
	function pushJob(job) {
	  queue$1.push(job);
	  if (!queued) {
	    queued = true;
	    nextTick(flush);
	  }
	}
	
	/**
	 * Flush the queue, and do one forced reflow before
	 * triggering transitions.
	 */
	
	function flush() {
	  // Force layout
	  var f = document.documentElement.offsetHeight;
	  for (var i = 0; i < queue$1.length; i++) {
	    queue$1[i]();
	  }
	  queue$1 = [];
	  queued = false;
	  // dummy return, so js linters don't complain about
	  // unused variable f
	  return f;
	}
	
	var TYPE_TRANSITION = 'transition';
	var TYPE_ANIMATION = 'animation';
	var transDurationProp = transitionProp + 'Duration';
	var animDurationProp = animationProp + 'Duration';
	
	/**
	 * If a just-entered element is applied the
	 * leave class while its enter transition hasn't started yet,
	 * and the transitioned property has the same value for both
	 * enter/leave, then the leave transition will be skipped and
	 * the transitionend event never fires. This function ensures
	 * its callback to be called after a transition has started
	 * by waiting for double raf.
	 *
	 * It falls back to setTimeout on devices that support CSS
	 * transitions but not raf (e.g. Android 4.2 browser) - since
	 * these environments are usually slow, we are giving it a
	 * relatively large timeout.
	 */
	
	var raf = inBrowser && window.requestAnimationFrame;
	var waitForTransitionStart = raf
	/* istanbul ignore next */
	? function (fn) {
	  raf(function () {
	    raf(fn);
	  });
	} : function (fn) {
	  setTimeout(fn, 50);
	};
	
	/**
	 * A Transition object that encapsulates the state and logic
	 * of the transition.
	 *
	 * @param {Element} el
	 * @param {String} id
	 * @param {Object} hooks
	 * @param {Vue} vm
	 */
	function Transition(el, id, hooks, vm) {
	  this.id = id;
	  this.el = el;
	  this.enterClass = hooks && hooks.enterClass || id + '-enter';
	  this.leaveClass = hooks && hooks.leaveClass || id + '-leave';
	  this.hooks = hooks;
	  this.vm = vm;
	  // async state
	  this.pendingCssEvent = this.pendingCssCb = this.cancel = this.pendingJsCb = this.op = this.cb = null;
	  this.justEntered = false;
	  this.entered = this.left = false;
	  this.typeCache = {};
	  // check css transition type
	  this.type = hooks && hooks.type;
	  /* istanbul ignore if */
	  if (false) {
	    if (this.type && this.type !== TYPE_TRANSITION && this.type !== TYPE_ANIMATION) {
	      warn('invalid CSS transition type for transition="' + this.id + '": ' + this.type, vm);
	    }
	  }
	  // bind
	  var self = this;['enterNextTick', 'enterDone', 'leaveNextTick', 'leaveDone'].forEach(function (m) {
	    self[m] = bind(self[m], self);
	  });
	}
	
	var p$1 = Transition.prototype;
	
	/**
	 * Start an entering transition.
	 *
	 * 1. enter transition triggered
	 * 2. call beforeEnter hook
	 * 3. add enter class
	 * 4. insert/show element
	 * 5. call enter hook (with possible explicit js callback)
	 * 6. reflow
	 * 7. based on transition type:
	 *    - transition:
	 *        remove class now, wait for transitionend,
	 *        then done if there's no explicit js callback.
	 *    - animation:
	 *        wait for animationend, remove class,
	 *        then done if there's no explicit js callback.
	 *    - no css transition:
	 *        done now if there's no explicit js callback.
	 * 8. wait for either done or js callback, then call
	 *    afterEnter hook.
	 *
	 * @param {Function} op - insert/show the element
	 * @param {Function} [cb]
	 */
	
	p$1.enter = function (op, cb) {
	  this.cancelPending();
	  this.callHook('beforeEnter');
	  this.cb = cb;
	  addClass(this.el, this.enterClass);
	  op();
	  this.entered = false;
	  this.callHookWithCb('enter');
	  if (this.entered) {
	    return; // user called done synchronously.
	  }
	  this.cancel = this.hooks && this.hooks.enterCancelled;
	  pushJob(this.enterNextTick);
	};
	
	/**
	 * The "nextTick" phase of an entering transition, which is
	 * to be pushed into a queue and executed after a reflow so
	 * that removing the class can trigger a CSS transition.
	 */
	
	p$1.enterNextTick = function () {
	  var _this = this;
	
	  // prevent transition skipping
	  this.justEntered = true;
	  waitForTransitionStart(function () {
	    _this.justEntered = false;
	  });
	  var enterDone = this.enterDone;
	  var type = this.getCssTransitionType(this.enterClass);
	  if (!this.pendingJsCb) {
	    if (type === TYPE_TRANSITION) {
	      // trigger transition by removing enter class now
	      removeClass(this.el, this.enterClass);
	      this.setupCssCb(transitionEndEvent, enterDone);
	    } else if (type === TYPE_ANIMATION) {
	      this.setupCssCb(animationEndEvent, enterDone);
	    } else {
	      enterDone();
	    }
	  } else if (type === TYPE_TRANSITION) {
	    removeClass(this.el, this.enterClass);
	  }
	};
	
	/**
	 * The "cleanup" phase of an entering transition.
	 */
	
	p$1.enterDone = function () {
	  this.entered = true;
	  this.cancel = this.pendingJsCb = null;
	  removeClass(this.el, this.enterClass);
	  this.callHook('afterEnter');
	  if (this.cb) this.cb();
	};
	
	/**
	 * Start a leaving transition.
	 *
	 * 1. leave transition triggered.
	 * 2. call beforeLeave hook
	 * 3. add leave class (trigger css transition)
	 * 4. call leave hook (with possible explicit js callback)
	 * 5. reflow if no explicit js callback is provided
	 * 6. based on transition type:
	 *    - transition or animation:
	 *        wait for end event, remove class, then done if
	 *        there's no explicit js callback.
	 *    - no css transition:
	 *        done if there's no explicit js callback.
	 * 7. wait for either done or js callback, then call
	 *    afterLeave hook.
	 *
	 * @param {Function} op - remove/hide the element
	 * @param {Function} [cb]
	 */
	
	p$1.leave = function (op, cb) {
	  this.cancelPending();
	  this.callHook('beforeLeave');
	  this.op = op;
	  this.cb = cb;
	  addClass(this.el, this.leaveClass);
	  this.left = false;
	  this.callHookWithCb('leave');
	  if (this.left) {
	    return; // user called done synchronously.
	  }
	  this.cancel = this.hooks && this.hooks.leaveCancelled;
	  // only need to handle leaveDone if
	  // 1. the transition is already done (synchronously called
	  //    by the user, which causes this.op set to null)
	  // 2. there's no explicit js callback
	  if (this.op && !this.pendingJsCb) {
	    // if a CSS transition leaves immediately after enter,
	    // the transitionend event never fires. therefore we
	    // detect such cases and end the leave immediately.
	    if (this.justEntered) {
	      this.leaveDone();
	    } else {
	      pushJob(this.leaveNextTick);
	    }
	  }
	};
	
	/**
	 * The "nextTick" phase of a leaving transition.
	 */
	
	p$1.leaveNextTick = function () {
	  var type = this.getCssTransitionType(this.leaveClass);
	  if (type) {
	    var event = type === TYPE_TRANSITION ? transitionEndEvent : animationEndEvent;
	    this.setupCssCb(event, this.leaveDone);
	  } else {
	    this.leaveDone();
	  }
	};
	
	/**
	 * The "cleanup" phase of a leaving transition.
	 */
	
	p$1.leaveDone = function () {
	  this.left = true;
	  this.cancel = this.pendingJsCb = null;
	  this.op();
	  removeClass(this.el, this.leaveClass);
	  this.callHook('afterLeave');
	  if (this.cb) this.cb();
	  this.op = null;
	};
	
	/**
	 * Cancel any pending callbacks from a previously running
	 * but not finished transition.
	 */
	
	p$1.cancelPending = function () {
	  this.op = this.cb = null;
	  var hasPending = false;
	  if (this.pendingCssCb) {
	    hasPending = true;
	    off(this.el, this.pendingCssEvent, this.pendingCssCb);
	    this.pendingCssEvent = this.pendingCssCb = null;
	  }
	  if (this.pendingJsCb) {
	    hasPending = true;
	    this.pendingJsCb.cancel();
	    this.pendingJsCb = null;
	  }
	  if (hasPending) {
	    removeClass(this.el, this.enterClass);
	    removeClass(this.el, this.leaveClass);
	  }
	  if (this.cancel) {
	    this.cancel.call(this.vm, this.el);
	    this.cancel = null;
	  }
	};
	
	/**
	 * Call a user-provided synchronous hook function.
	 *
	 * @param {String} type
	 */
	
	p$1.callHook = function (type) {
	  if (this.hooks && this.hooks[type]) {
	    this.hooks[type].call(this.vm, this.el);
	  }
	};
	
	/**
	 * Call a user-provided, potentially-async hook function.
	 * We check for the length of arguments to see if the hook
	 * expects a `done` callback. If true, the transition's end
	 * will be determined by when the user calls that callback;
	 * otherwise, the end is determined by the CSS transition or
	 * animation.
	 *
	 * @param {String} type
	 */
	
	p$1.callHookWithCb = function (type) {
	  var hook = this.hooks && this.hooks[type];
	  if (hook) {
	    if (hook.length > 1) {
	      this.pendingJsCb = cancellable(this[type + 'Done']);
	    }
	    hook.call(this.vm, this.el, this.pendingJsCb);
	  }
	};
	
	/**
	 * Get an element's transition type based on the
	 * calculated styles.
	 *
	 * @param {String} className
	 * @return {Number}
	 */
	
	p$1.getCssTransitionType = function (className) {
	  /* istanbul ignore if */
	  if (!transitionEndEvent ||
	  // skip CSS transitions if page is not visible -
	  // this solves the issue of transitionend events not
	  // firing until the page is visible again.
	  // pageVisibility API is supported in IE10+, same as
	  // CSS transitions.
	  document.hidden ||
	  // explicit js-only transition
	  this.hooks && this.hooks.css === false ||
	  // element is hidden
	  isHidden(this.el)) {
	    return;
	  }
	  var type = this.type || this.typeCache[className];
	  if (type) return type;
	  var inlineStyles = this.el.style;
	  var computedStyles = window.getComputedStyle(this.el);
	  var transDuration = inlineStyles[transDurationProp] || computedStyles[transDurationProp];
	  if (transDuration && transDuration !== '0s') {
	    type = TYPE_TRANSITION;
	  } else {
	    var animDuration = inlineStyles[animDurationProp] || computedStyles[animDurationProp];
	    if (animDuration && animDuration !== '0s') {
	      type = TYPE_ANIMATION;
	    }
	  }
	  if (type) {
	    this.typeCache[className] = type;
	  }
	  return type;
	};
	
	/**
	 * Setup a CSS transitionend/animationend callback.
	 *
	 * @param {String} event
	 * @param {Function} cb
	 */
	
	p$1.setupCssCb = function (event, cb) {
	  this.pendingCssEvent = event;
	  var self = this;
	  var el = this.el;
	  var onEnd = this.pendingCssCb = function (e) {
	    if (e.target === el) {
	      off(el, event, onEnd);
	      self.pendingCssEvent = self.pendingCssCb = null;
	      if (!self.pendingJsCb && cb) {
	        cb();
	      }
	    }
	  };
	  on(el, event, onEnd);
	};
	
	/**
	 * Check if an element is hidden - in that case we can just
	 * skip the transition alltogether.
	 *
	 * @param {Element} el
	 * @return {Boolean}
	 */
	
	function isHidden(el) {
	  if (/svg$/.test(el.namespaceURI)) {
	    // SVG elements do not have offset(Width|Height)
	    // so we need to check the client rect
	    var rect = el.getBoundingClientRect();
	    return !(rect.width || rect.height);
	  } else {
	    return !(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
	  }
	}
	
	var transition$1 = {
	
	  priority: TRANSITION,
	
	  update: function update(id, oldId) {
	    var el = this.el;
	    // resolve on owner vm
	    var hooks = resolveAsset(this.vm.$options, 'transitions', id);
	    id = id || 'v';
	    oldId = oldId || 'v';
	    el.__v_trans = new Transition(el, id, hooks, this.vm);
	    removeClass(el, oldId + '-transition');
	    addClass(el, id + '-transition');
	  }
	};
	
	var internalDirectives = {
	  style: style,
	  'class': vClass,
	  component: component,
	  prop: propDef,
	  transition: transition$1
	};
	
	// special binding prefixes
	var bindRE = /^v-bind:|^:/;
	var onRE = /^v-on:|^@/;
	var dirAttrRE = /^v-([^:]+)(?:$|:(.*)$)/;
	var modifierRE = /\.[^\.]+/g;
	var transitionRE = /^(v-bind:|:)?transition$/;
	
	// default directive priority
	var DEFAULT_PRIORITY = 1000;
	var DEFAULT_TERMINAL_PRIORITY = 2000;
	
	/**
	 * Compile a template and return a reusable composite link
	 * function, which recursively contains more link functions
	 * inside. This top level compile function would normally
	 * be called on instance root nodes, but can also be used
	 * for partial compilation if the partial argument is true.
	 *
	 * The returned composite link function, when called, will
	 * return an unlink function that tearsdown all directives
	 * created during the linking phase.
	 *
	 * @param {Element|DocumentFragment} el
	 * @param {Object} options
	 * @param {Boolean} partial
	 * @return {Function}
	 */
	
	function compile(el, options, partial) {
	  // link function for the node itself.
	  var nodeLinkFn = partial || !options._asComponent ? compileNode(el, options) : null;
	  // link function for the childNodes
	  var childLinkFn = !(nodeLinkFn && nodeLinkFn.terminal) && !isScript(el) && el.hasChildNodes() ? compileNodeList(el.childNodes, options) : null;
	
	  /**
	   * A composite linker function to be called on a already
	   * compiled piece of DOM, which instantiates all directive
	   * instances.
	   *
	   * @param {Vue} vm
	   * @param {Element|DocumentFragment} el
	   * @param {Vue} [host] - host vm of transcluded content
	   * @param {Object} [scope] - v-for scope
	   * @param {Fragment} [frag] - link context fragment
	   * @return {Function|undefined}
	   */
	
	  return function compositeLinkFn(vm, el, host, scope, frag) {
	    // cache childNodes before linking parent, fix #657
	    var childNodes = toArray(el.childNodes);
	    // link
	    var dirs = linkAndCapture(function compositeLinkCapturer() {
	      if (nodeLinkFn) nodeLinkFn(vm, el, host, scope, frag);
	      if (childLinkFn) childLinkFn(vm, childNodes, host, scope, frag);
	    }, vm);
	    return makeUnlinkFn(vm, dirs);
	  };
	}
	
	/**
	 * Apply a linker to a vm/element pair and capture the
	 * directives created during the process.
	 *
	 * @param {Function} linker
	 * @param {Vue} vm
	 */
	
	function linkAndCapture(linker, vm) {
	  /* istanbul ignore if */
	  if (true) {
	    // reset directives before every capture in production
	    // mode, so that when unlinking we don't need to splice
	    // them out (which turns out to be a perf hit).
	    // they are kept in development mode because they are
	    // useful for Vue's own tests.
	    vm._directives = [];
	  }
	  var originalDirCount = vm._directives.length;
	  linker();
	  var dirs = vm._directives.slice(originalDirCount);
	  sortDirectives(dirs);
	  for (var i = 0, l = dirs.length; i < l; i++) {
	    dirs[i]._bind();
	  }
	  return dirs;
	}
	
	/**
	 * sort directives by priority (stable sort)
	 *
	 * @param {Array} dirs
	 */
	function sortDirectives(dirs) {
	  if (dirs.length === 0) return;
	
	  var groupedMap = {};
	  var i, j, k, l;
	  var index = 0;
	  var priorities = [];
	  for (i = 0, j = dirs.length; i < j; i++) {
	    var dir = dirs[i];
	    var priority = dir.descriptor.def.priority || DEFAULT_PRIORITY;
	    var array = groupedMap[priority];
	    if (!array) {
	      array = groupedMap[priority] = [];
	      priorities.push(priority);
	    }
	    array.push(dir);
	  }
	
	  priorities.sort(function (a, b) {
	    return a > b ? -1 : a === b ? 0 : 1;
	  });
	  for (i = 0, j = priorities.length; i < j; i++) {
	    var group = groupedMap[priorities[i]];
	    for (k = 0, l = group.length; k < l; k++) {
	      dirs[index++] = group[k];
	    }
	  }
	}
	
	/**
	 * Linker functions return an unlink function that
	 * tearsdown all directives instances generated during
	 * the process.
	 *
	 * We create unlink functions with only the necessary
	 * information to avoid retaining additional closures.
	 *
	 * @param {Vue} vm
	 * @param {Array} dirs
	 * @param {Vue} [context]
	 * @param {Array} [contextDirs]
	 * @return {Function}
	 */
	
	function makeUnlinkFn(vm, dirs, context, contextDirs) {
	  function unlink(destroying) {
	    teardownDirs(vm, dirs, destroying);
	    if (context && contextDirs) {
	      teardownDirs(context, contextDirs);
	    }
	  }
	  // expose linked directives
	  unlink.dirs = dirs;
	  return unlink;
	}
	
	/**
	 * Teardown partial linked directives.
	 *
	 * @param {Vue} vm
	 * @param {Array} dirs
	 * @param {Boolean} destroying
	 */
	
	function teardownDirs(vm, dirs, destroying) {
	  var i = dirs.length;
	  while (i--) {
	    dirs[i]._teardown();
	    if (false) {
	      vm._directives.$remove(dirs[i]);
	    }
	  }
	}
	
	/**
	 * Compile link props on an instance.
	 *
	 * @param {Vue} vm
	 * @param {Element} el
	 * @param {Object} props
	 * @param {Object} [scope]
	 * @return {Function}
	 */
	
	function compileAndLinkProps(vm, el, props, scope) {
	  var propsLinkFn = compileProps(el, props, vm);
	  var propDirs = linkAndCapture(function () {
	    propsLinkFn(vm, scope);
	  }, vm);
	  return makeUnlinkFn(vm, propDirs);
	}
	
	/**
	 * Compile the root element of an instance.
	 *
	 * 1. attrs on context container (context scope)
	 * 2. attrs on the component template root node, if
	 *    replace:true (child scope)
	 *
	 * If this is a fragment instance, we only need to compile 1.
	 *
	 * @param {Element} el
	 * @param {Object} options
	 * @param {Object} contextOptions
	 * @return {Function}
	 */
	
	function compileRoot(el, options, contextOptions) {
	  var containerAttrs = options._containerAttrs;
	  var replacerAttrs = options._replacerAttrs;
	  var contextLinkFn, replacerLinkFn;
	
	  // only need to compile other attributes for
	  // non-fragment instances
	  if (el.nodeType !== 11) {
	    // for components, container and replacer need to be
	    // compiled separately and linked in different scopes.
	    if (options._asComponent) {
	      // 2. container attributes
	      if (containerAttrs && contextOptions) {
	        contextLinkFn = compileDirectives(containerAttrs, contextOptions);
	      }
	      if (replacerAttrs) {
	        // 3. replacer attributes
	        replacerLinkFn = compileDirectives(replacerAttrs, options);
	      }
	    } else {
	      // non-component, just compile as a normal element.
	      replacerLinkFn = compileDirectives(el.attributes, options);
	    }
	  } else if (false) {
	    // warn container directives for fragment instances
	    var names = containerAttrs.filter(function (attr) {
	      // allow vue-loader/vueify scoped css attributes
	      return attr.name.indexOf('_v-') < 0 &&
	      // allow event listeners
	      !onRE.test(attr.name) &&
	      // allow slots
	      attr.name !== 'slot';
	    }).map(function (attr) {
	      return '"' + attr.name + '"';
	    });
	    if (names.length) {
	      var plural = names.length > 1;
	
	      var componentName = options.el.tagName.toLowerCase();
	      if (componentName === 'component' && options.name) {
	        componentName += ':' + options.name;
	      }
	
	      warn('Attribute' + (plural ? 's ' : ' ') + names.join(', ') + (plural ? ' are' : ' is') + ' ignored on component ' + '<' + componentName + '> because ' + 'the component is a fragment instance: ' + 'http://vuejs.org/guide/components.html#Fragment-Instance');
	    }
	  }
	
	  options._containerAttrs = options._replacerAttrs = null;
	  return function rootLinkFn(vm, el, scope) {
	    // link context scope dirs
	    var context = vm._context;
	    var contextDirs;
	    if (context && contextLinkFn) {
	      contextDirs = linkAndCapture(function () {
	        contextLinkFn(context, el, null, scope);
	      }, context);
	    }
	
	    // link self
	    var selfDirs = linkAndCapture(function () {
	      if (replacerLinkFn) replacerLinkFn(vm, el);
	    }, vm);
	
	    // return the unlink function that tearsdown context
	    // container directives.
	    return makeUnlinkFn(vm, selfDirs, context, contextDirs);
	  };
	}
	
	/**
	 * Compile a node and return a nodeLinkFn based on the
	 * node type.
	 *
	 * @param {Node} node
	 * @param {Object} options
	 * @return {Function|null}
	 */
	
	function compileNode(node, options) {
	  var type = node.nodeType;
	  if (type === 1 && !isScript(node)) {
	    return compileElement(node, options);
	  } else if (type === 3 && node.data.trim()) {
	    return compileTextNode(node, options);
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Compile an element and return a nodeLinkFn.
	 *
	 * @param {Element} el
	 * @param {Object} options
	 * @return {Function|null}
	 */
	
	function compileElement(el, options) {
	  // preprocess textareas.
	  // textarea treats its text content as the initial value.
	  // just bind it as an attr directive for value.
	  if (el.tagName === 'TEXTAREA') {
	    // a textarea which has v-pre attr should skip complie.
	    if (getAttr(el, 'v-pre') !== null) {
	      return skip;
	    }
	    var tokens = parseText(el.value);
	    if (tokens) {
	      el.setAttribute(':value', tokensToExp(tokens));
	      el.value = '';
	    }
	  }
	  var linkFn;
	  var hasAttrs = el.hasAttributes();
	  var attrs = hasAttrs && toArray(el.attributes);
	  // check terminal directives (for & if)
	  if (hasAttrs) {
	    linkFn = checkTerminalDirectives(el, attrs, options);
	  }
	  // check element directives
	  if (!linkFn) {
	    linkFn = checkElementDirectives(el, options);
	  }
	  // check component
	  if (!linkFn) {
	    linkFn = checkComponent(el, options);
	  }
	  // normal directives
	  if (!linkFn && hasAttrs) {
	    linkFn = compileDirectives(attrs, options);
	  }
	  return linkFn;
	}
	
	/**
	 * Compile a textNode and return a nodeLinkFn.
	 *
	 * @param {TextNode} node
	 * @param {Object} options
	 * @return {Function|null} textNodeLinkFn
	 */
	
	function compileTextNode(node, options) {
	  // skip marked text nodes
	  if (node._skip) {
	    return removeText;
	  }
	
	  var tokens = parseText(node.wholeText);
	  if (!tokens) {
	    return null;
	  }
	
	  // mark adjacent text nodes as skipped,
	  // because we are using node.wholeText to compile
	  // all adjacent text nodes together. This fixes
	  // issues in IE where sometimes it splits up a single
	  // text node into multiple ones.
	  var next = node.nextSibling;
	  while (next && next.nodeType === 3) {
	    next._skip = true;
	    next = next.nextSibling;
	  }
	
	  var frag = document.createDocumentFragment();
	  var el, token;
	  for (var i = 0, l = tokens.length; i < l; i++) {
	    token = tokens[i];
	    el = token.tag ? processTextToken(token, options) : document.createTextNode(token.value);
	    frag.appendChild(el);
	  }
	  return makeTextNodeLinkFn(tokens, frag, options);
	}
	
	/**
	 * Linker for an skipped text node.
	 *
	 * @param {Vue} vm
	 * @param {Text} node
	 */
	
	function removeText(vm, node) {
	  remove(node);
	}
	
	/**
	 * Process a single text token.
	 *
	 * @param {Object} token
	 * @param {Object} options
	 * @return {Node}
	 */
	
	function processTextToken(token, options) {
	  var el;
	  if (token.oneTime) {
	    el = document.createTextNode(token.value);
	  } else {
	    if (token.html) {
	      el = document.createComment('v-html');
	      setTokenType('html');
	    } else {
	      // IE will clean up empty textNodes during
	      // frag.cloneNode(true), so we have to give it
	      // something here...
	      el = document.createTextNode(' ');
	      setTokenType('text');
	    }
	  }
	  function setTokenType(type) {
	    if (token.descriptor) return;
	    var parsed = parseDirective(token.value);
	    token.descriptor = {
	      name: type,
	      def: directives[type],
	      expression: parsed.expression,
	      filters: parsed.filters
	    };
	  }
	  return el;
	}
	
	/**
	 * Build a function that processes a textNode.
	 *
	 * @param {Array<Object>} tokens
	 * @param {DocumentFragment} frag
	 */
	
	function makeTextNodeLinkFn(tokens, frag) {
	  return function textNodeLinkFn(vm, el, host, scope) {
	    var fragClone = frag.cloneNode(true);
	    var childNodes = toArray(fragClone.childNodes);
	    var token, value, node;
	    for (var i = 0, l = tokens.length; i < l; i++) {
	      token = tokens[i];
	      value = token.value;
	      if (token.tag) {
	        node = childNodes[i];
	        if (token.oneTime) {
	          value = (scope || vm).$eval(value);
	          if (token.html) {
	            replace(node, parseTemplate(value, true));
	          } else {
	            node.data = _toString(value);
	          }
	        } else {
	          vm._bindDir(token.descriptor, node, host, scope);
	        }
	      }
	    }
	    replace(el, fragClone);
	  };
	}
	
	/**
	 * Compile a node list and return a childLinkFn.
	 *
	 * @param {NodeList} nodeList
	 * @param {Object} options
	 * @return {Function|undefined}
	 */
	
	function compileNodeList(nodeList, options) {
	  var linkFns = [];
	  var nodeLinkFn, childLinkFn, node;
	  for (var i = 0, l = nodeList.length; i < l; i++) {
	    node = nodeList[i];
	    nodeLinkFn = compileNode(node, options);
	    childLinkFn = !(nodeLinkFn && nodeLinkFn.terminal) && node.tagName !== 'SCRIPT' && node.hasChildNodes() ? compileNodeList(node.childNodes, options) : null;
	    linkFns.push(nodeLinkFn, childLinkFn);
	  }
	  return linkFns.length ? makeChildLinkFn(linkFns) : null;
	}
	
	/**
	 * Make a child link function for a node's childNodes.
	 *
	 * @param {Array<Function>} linkFns
	 * @return {Function} childLinkFn
	 */
	
	function makeChildLinkFn(linkFns) {
	  return function childLinkFn(vm, nodes, host, scope, frag) {
	    var node, nodeLinkFn, childrenLinkFn;
	    for (var i = 0, n = 0, l = linkFns.length; i < l; n++) {
	      node = nodes[n];
	      nodeLinkFn = linkFns[i++];
	      childrenLinkFn = linkFns[i++];
	      // cache childNodes before linking parent, fix #657
	      var childNodes = toArray(node.childNodes);
	      if (nodeLinkFn) {
	        nodeLinkFn(vm, node, host, scope, frag);
	      }
	      if (childrenLinkFn) {
	        childrenLinkFn(vm, childNodes, host, scope, frag);
	      }
	    }
	  };
	}
	
	/**
	 * Check for element directives (custom elements that should
	 * be resovled as terminal directives).
	 *
	 * @param {Element} el
	 * @param {Object} options
	 */
	
	function checkElementDirectives(el, options) {
	  var tag = el.tagName.toLowerCase();
	  if (commonTagRE.test(tag)) {
	    return;
	  }
	  var def = resolveAsset(options, 'elementDirectives', tag);
	  if (def) {
	    return makeTerminalNodeLinkFn(el, tag, '', options, def);
	  }
	}
	
	/**
	 * Check if an element is a component. If yes, return
	 * a component link function.
	 *
	 * @param {Element} el
	 * @param {Object} options
	 * @return {Function|undefined}
	 */
	
	function checkComponent(el, options) {
	  var component = checkComponentAttr(el, options);
	  if (component) {
	    var ref = findRef(el);
	    var descriptor = {
	      name: 'component',
	      ref: ref,
	      expression: component.id,
	      def: internalDirectives.component,
	      modifiers: {
	        literal: !component.dynamic
	      }
	    };
	    var componentLinkFn = function componentLinkFn(vm, el, host, scope, frag) {
	      if (ref) {
	        defineReactive((scope || vm).$refs, ref, null);
	      }
	      vm._bindDir(descriptor, el, host, scope, frag);
	    };
	    componentLinkFn.terminal = true;
	    return componentLinkFn;
	  }
	}
	
	/**
	 * Check an element for terminal directives in fixed order.
	 * If it finds one, return a terminal link function.
	 *
	 * @param {Element} el
	 * @param {Array} attrs
	 * @param {Object} options
	 * @return {Function} terminalLinkFn
	 */
	
	function checkTerminalDirectives(el, attrs, options) {
	  // skip v-pre
	  if (getAttr(el, 'v-pre') !== null) {
	    return skip;
	  }
	  // skip v-else block, but only if following v-if
	  if (el.hasAttribute('v-else')) {
	    var prev = el.previousElementSibling;
	    if (prev && prev.hasAttribute('v-if')) {
	      return skip;
	    }
	  }
	
	  var attr, name, value, modifiers, matched, dirName, rawName, arg, def, termDef;
	  for (var i = 0, j = attrs.length; i < j; i++) {
	    attr = attrs[i];
	    name = attr.name.replace(modifierRE, '');
	    if (matched = name.match(dirAttrRE)) {
	      def = resolveAsset(options, 'directives', matched[1]);
	      if (def && def.terminal) {
	        if (!termDef || (def.priority || DEFAULT_TERMINAL_PRIORITY) > termDef.priority) {
	          termDef = def;
	          rawName = attr.name;
	          modifiers = parseModifiers(attr.name);
	          value = attr.value;
	          dirName = matched[1];
	          arg = matched[2];
	        }
	      }
	    }
	  }
	
	  if (termDef) {
	    return makeTerminalNodeLinkFn(el, dirName, value, options, termDef, rawName, arg, modifiers);
	  }
	}
	
	function skip() {}
	skip.terminal = true;
	
	/**
	 * Build a node link function for a terminal directive.
	 * A terminal link function terminates the current
	 * compilation recursion and handles compilation of the
	 * subtree in the directive.
	 *
	 * @param {Element} el
	 * @param {String} dirName
	 * @param {String} value
	 * @param {Object} options
	 * @param {Object} def
	 * @param {String} [rawName]
	 * @param {String} [arg]
	 * @param {Object} [modifiers]
	 * @return {Function} terminalLinkFn
	 */
	
	function makeTerminalNodeLinkFn(el, dirName, value, options, def, rawName, arg, modifiers) {
	  var parsed = parseDirective(value);
	  var descriptor = {
	    name: dirName,
	    arg: arg,
	    expression: parsed.expression,
	    filters: parsed.filters,
	    raw: value,
	    attr: rawName,
	    modifiers: modifiers,
	    def: def
	  };
	  // check ref for v-for, v-if and router-view
	  if (dirName === 'for' || dirName === 'router-view') {
	    descriptor.ref = findRef(el);
	  }
	  var fn = function terminalNodeLinkFn(vm, el, host, scope, frag) {
	    if (descriptor.ref) {
	      defineReactive((scope || vm).$refs, descriptor.ref, null);
	    }
	    vm._bindDir(descriptor, el, host, scope, frag);
	  };
	  fn.terminal = true;
	  return fn;
	}
	
	/**
	 * Compile the directives on an element and return a linker.
	 *
	 * @param {Array|NamedNodeMap} attrs
	 * @param {Object} options
	 * @return {Function}
	 */
	
	function compileDirectives(attrs, options) {
	  var i = attrs.length;
	  var dirs = [];
	  var attr, name, value, rawName, rawValue, dirName, arg, modifiers, dirDef, tokens, matched;
	  while (i--) {
	    attr = attrs[i];
	    name = rawName = attr.name;
	    value = rawValue = attr.value;
	    tokens = parseText(value);
	    // reset arg
	    arg = null;
	    // check modifiers
	    modifiers = parseModifiers(name);
	    name = name.replace(modifierRE, '');
	
	    // attribute interpolations
	    if (tokens) {
	      value = tokensToExp(tokens);
	      arg = name;
	      pushDir('bind', directives.bind, tokens);
	      // warn against mixing mustaches with v-bind
	      if (false) {
	        if (name === 'class' && Array.prototype.some.call(attrs, function (attr) {
	          return attr.name === ':class' || attr.name === 'v-bind:class';
	        })) {
	          warn('class="' + rawValue + '": Do not mix mustache interpolation ' + 'and v-bind for "class" on the same element. Use one or the other.', options);
	        }
	      }
	    } else
	
	      // special attribute: transition
	      if (transitionRE.test(name)) {
	        modifiers.literal = !bindRE.test(name);
	        pushDir('transition', internalDirectives.transition);
	      } else
	
	        // event handlers
	        if (onRE.test(name)) {
	          arg = name.replace(onRE, '');
	          pushDir('on', directives.on);
	        } else
	
	          // attribute bindings
	          if (bindRE.test(name)) {
	            dirName = name.replace(bindRE, '');
	            if (dirName === 'style' || dirName === 'class') {
	              pushDir(dirName, internalDirectives[dirName]);
	            } else {
	              arg = dirName;
	              pushDir('bind', directives.bind);
	            }
	          } else
	
	            // normal directives
	            if (matched = name.match(dirAttrRE)) {
	              dirName = matched[1];
	              arg = matched[2];
	
	              // skip v-else (when used with v-show)
	              if (dirName === 'else') {
	                continue;
	              }
	
	              dirDef = resolveAsset(options, 'directives', dirName, true);
	              if (dirDef) {
	                pushDir(dirName, dirDef);
	              }
	            }
	  }
	
	  /**
	   * Push a directive.
	   *
	   * @param {String} dirName
	   * @param {Object|Function} def
	   * @param {Array} [interpTokens]
	   */
	
	  function pushDir(dirName, def, interpTokens) {
	    var hasOneTimeToken = interpTokens && hasOneTime(interpTokens);
	    var parsed = !hasOneTimeToken && parseDirective(value);
	    dirs.push({
	      name: dirName,
	      attr: rawName,
	      raw: rawValue,
	      def: def,
	      arg: arg,
	      modifiers: modifiers,
	      // conversion from interpolation strings with one-time token
	      // to expression is differed until directive bind time so that we
	      // have access to the actual vm context for one-time bindings.
	      expression: parsed && parsed.expression,
	      filters: parsed && parsed.filters,
	      interp: interpTokens,
	      hasOneTime: hasOneTimeToken
	    });
	  }
	
	  if (dirs.length) {
	    return makeNodeLinkFn(dirs);
	  }
	}
	
	/**
	 * Parse modifiers from directive attribute name.
	 *
	 * @param {String} name
	 * @return {Object}
	 */
	
	function parseModifiers(name) {
	  var res = Object.create(null);
	  var match = name.match(modifierRE);
	  if (match) {
	    var i = match.length;
	    while (i--) {
	      res[match[i].slice(1)] = true;
	    }
	  }
	  return res;
	}
	
	/**
	 * Build a link function for all directives on a single node.
	 *
	 * @param {Array} directives
	 * @return {Function} directivesLinkFn
	 */
	
	function makeNodeLinkFn(directives) {
	  return function nodeLinkFn(vm, el, host, scope, frag) {
	    // reverse apply because it's sorted low to high
	    var i = directives.length;
	    while (i--) {
	      vm._bindDir(directives[i], el, host, scope, frag);
	    }
	  };
	}
	
	/**
	 * Check if an interpolation string contains one-time tokens.
	 *
	 * @param {Array} tokens
	 * @return {Boolean}
	 */
	
	function hasOneTime(tokens) {
	  var i = tokens.length;
	  while (i--) {
	    if (tokens[i].oneTime) return true;
	  }
	}
	
	function isScript(el) {
	  return el.tagName === 'SCRIPT' && (!el.hasAttribute('type') || el.getAttribute('type') === 'text/javascript');
	}
	
	var specialCharRE = /[^\w\-:\.]/;
	
	/**
	 * Process an element or a DocumentFragment based on a
	 * instance option object. This allows us to transclude
	 * a template node/fragment before the instance is created,
	 * so the processed fragment can then be cloned and reused
	 * in v-for.
	 *
	 * @param {Element} el
	 * @param {Object} options
	 * @return {Element|DocumentFragment}
	 */
	
	function transclude(el, options) {
	  // extract container attributes to pass them down
	  // to compiler, because they need to be compiled in
	  // parent scope. we are mutating the options object here
	  // assuming the same object will be used for compile
	  // right after this.
	  if (options) {
	    options._containerAttrs = extractAttrs(el);
	  }
	  // for template tags, what we want is its content as
	  // a documentFragment (for fragment instances)
	  if (isTemplate(el)) {
	    el = parseTemplate(el);
	  }
	  if (options) {
	    if (options._asComponent && !options.template) {
	      options.template = '<slot></slot>';
	    }
	    if (options.template) {
	      options._content = extractContent(el);
	      el = transcludeTemplate(el, options);
	    }
	  }
	  if (isFragment(el)) {
	    // anchors for fragment instance
	    // passing in `persist: true` to avoid them being
	    // discarded by IE during template cloning
	    prepend(createAnchor('v-start', true), el);
	    el.appendChild(createAnchor('v-end', true));
	  }
	  return el;
	}
	
	/**
	 * Process the template option.
	 * If the replace option is true this will swap the $el.
	 *
	 * @param {Element} el
	 * @param {Object} options
	 * @return {Element|DocumentFragment}
	 */
	
	function transcludeTemplate(el, options) {
	  var template = options.template;
	  var frag = parseTemplate(template, true);
	  if (frag) {
	    var replacer = frag.firstChild;
	    if (!replacer) {
	      return frag;
	    }
	    var tag = replacer.tagName && replacer.tagName.toLowerCase();
	    if (options.replace) {
	      /* istanbul ignore if */
	      if (el === document.body) {
	        ("production") !== 'production' && warn('You are mounting an instance with a template to ' + '<body>. This will replace <body> entirely. You ' + 'should probably use `replace: false` here.');
	      }
	      // there are many cases where the instance must
	      // become a fragment instance: basically anything that
	      // can create more than 1 root nodes.
	      if (
	      // multi-children template
	      frag.childNodes.length > 1 ||
	      // non-element template
	      replacer.nodeType !== 1 ||
	      // single nested component
	      tag === 'component' || resolveAsset(options, 'components', tag) || hasBindAttr(replacer, 'is') ||
	      // element directive
	      resolveAsset(options, 'elementDirectives', tag) ||
	      // for block
	      replacer.hasAttribute('v-for') ||
	      // if block
	      replacer.hasAttribute('v-if')) {
	        return frag;
	      } else {
	        options._replacerAttrs = extractAttrs(replacer);
	        mergeAttrs(el, replacer);
	        return replacer;
	      }
	    } else {
	      el.appendChild(frag);
	      return el;
	    }
	  } else {
	    ("production") !== 'production' && warn('Invalid template option: ' + template);
	  }
	}
	
	/**
	 * Helper to extract a component container's attributes
	 * into a plain object array.
	 *
	 * @param {Element} el
	 * @return {Array}
	 */
	
	function extractAttrs(el) {
	  if (el.nodeType === 1 && el.hasAttributes()) {
	    return toArray(el.attributes);
	  }
	}
	
	/**
	 * Merge the attributes of two elements, and make sure
	 * the class names are merged properly.
	 *
	 * @param {Element} from
	 * @param {Element} to
	 */
	
	function mergeAttrs(from, to) {
	  var attrs = from.attributes;
	  var i = attrs.length;
	  var name, value;
	  while (i--) {
	    name = attrs[i].name;
	    value = attrs[i].value;
	    if (!to.hasAttribute(name) && !specialCharRE.test(name)) {
	      to.setAttribute(name, value);
	    } else if (name === 'class' && !parseText(value) && (value = value.trim())) {
	      value.split(/\s+/).forEach(function (cls) {
	        addClass(to, cls);
	      });
	    }
	  }
	}
	
	/**
	 * Scan and determine slot content distribution.
	 * We do this during transclusion instead at compile time so that
	 * the distribution is decoupled from the compilation order of
	 * the slots.
	 *
	 * @param {Element|DocumentFragment} template
	 * @param {Element} content
	 * @param {Vue} vm
	 */
	
	function resolveSlots(vm, content) {
	  if (!content) {
	    return;
	  }
	  var contents = vm._slotContents = Object.create(null);
	  var el, name;
	  for (var i = 0, l = content.children.length; i < l; i++) {
	    el = content.children[i];
	    /* eslint-disable no-cond-assign */
	    if (name = el.getAttribute('slot')) {
	      (contents[name] || (contents[name] = [])).push(el);
	    }
	    /* eslint-enable no-cond-assign */
	    if (false) {
	      warn('The "slot" attribute must be static.', vm.$parent);
	    }
	  }
	  for (name in contents) {
	    contents[name] = extractFragment(contents[name], content);
	  }
	  if (content.hasChildNodes()) {
	    var nodes = content.childNodes;
	    if (nodes.length === 1 && nodes[0].nodeType === 3 && !nodes[0].data.trim()) {
	      return;
	    }
	    contents['default'] = extractFragment(content.childNodes, content);
	  }
	}
	
	/**
	 * Extract qualified content nodes from a node list.
	 *
	 * @param {NodeList} nodes
	 * @return {DocumentFragment}
	 */
	
	function extractFragment(nodes, parent) {
	  var frag = document.createDocumentFragment();
	  nodes = toArray(nodes);
	  for (var i = 0, l = nodes.length; i < l; i++) {
	    var node = nodes[i];
	    if (isTemplate(node) && !node.hasAttribute('v-if') && !node.hasAttribute('v-for')) {
	      parent.removeChild(node);
	      node = parseTemplate(node, true);
	    }
	    frag.appendChild(node);
	  }
	  return frag;
	}
	
	
	
	var compiler = Object.freeze({
		compile: compile,
		compileAndLinkProps: compileAndLinkProps,
		compileRoot: compileRoot,
		transclude: transclude,
		resolveSlots: resolveSlots
	});
	
	function stateMixin (Vue) {
	  /**
	   * Accessor for `$data` property, since setting $data
	   * requires observing the new object and updating
	   * proxied properties.
	   */
	
	  Object.defineProperty(Vue.prototype, '$data', {
	    get: function get() {
	      return this._data;
	    },
	    set: function set(newData) {
	      if (newData !== this._data) {
	        this._setData(newData);
	      }
	    }
	  });
	
	  /**
	   * Setup the scope of an instance, which contains:
	   * - observed data
	   * - computed properties
	   * - user methods
	   * - meta properties
	   */
	
	  Vue.prototype._initState = function () {
	    this._initProps();
	    this._initMeta();
	    this._initMethods();
	    this._initData();
	    this._initComputed();
	  };
	
	  /**
	   * Initialize props.
	   */
	
	  Vue.prototype._initProps = function () {
	    var options = this.$options;
	    var el = options.el;
	    var props = options.props;
	    if (props && !el) {
	      ("production") !== 'production' && warn('Props will not be compiled if no `el` option is ' + 'provided at instantiation.', this);
	    }
	    // make sure to convert string selectors into element now
	    el = options.el = query(el);
	    this._propsUnlinkFn = el && el.nodeType === 1 && props
	    // props must be linked in proper scope if inside v-for
	    ? compileAndLinkProps(this, el, props, this._scope) : null;
	  };
	
	  /**
	   * Initialize the data.
	   */
	
	  Vue.prototype._initData = function () {
	    var dataFn = this.$options.data;
	    var data = this._data = dataFn ? dataFn() : {};
	    if (!isPlainObject(data)) {
	      data = {};
	      ("production") !== 'production' && warn('data functions should return an object.', this);
	    }
	    var props = this._props;
	    // proxy data on instance
	    var keys = Object.keys(data);
	    var i, key;
	    i = keys.length;
	    while (i--) {
	      key = keys[i];
	      // there are two scenarios where we can proxy a data key:
	      // 1. it's not already defined as a prop
	      // 2. it's provided via a instantiation option AND there are no
	      //    template prop present
	      if (!props || !hasOwn(props, key)) {
	        this._proxy(key);
	      } else if (false) {
	        warn('Data field "' + key + '" is already defined ' + 'as a prop. To provide default value for a prop, use the "default" ' + 'prop option; if you want to pass prop values to an instantiation ' + 'call, use the "propsData" option.', this);
	      }
	    }
	    // observe data
	    observe(data, this);
	  };
	
	  /**
	   * Swap the instance's $data. Called in $data's setter.
	   *
	   * @param {Object} newData
	   */
	
	  Vue.prototype._setData = function (newData) {
	    newData = newData || {};
	    var oldData = this._data;
	    this._data = newData;
	    var keys, key, i;
	    // unproxy keys not present in new data
	    keys = Object.keys(oldData);
	    i = keys.length;
	    while (i--) {
	      key = keys[i];
	      if (!(key in newData)) {
	        this._unproxy(key);
	      }
	    }
	    // proxy keys not already proxied,
	    // and trigger change for changed values
	    keys = Object.keys(newData);
	    i = keys.length;
	    while (i--) {
	      key = keys[i];
	      if (!hasOwn(this, key)) {
	        // new property
	        this._proxy(key);
	      }
	    }
	    oldData.__ob__.removeVm(this);
	    observe(newData, this);
	    this._digest();
	  };
	
	  /**
	   * Proxy a property, so that
	   * vm.prop === vm._data.prop
	   *
	   * @param {String} key
	   */
	
	  Vue.prototype._proxy = function (key) {
	    if (!isReserved(key)) {
	      // need to store ref to self here
	      // because these getter/setters might
	      // be called by child scopes via
	      // prototype inheritance.
	      var self = this;
	      Object.defineProperty(self, key, {
	        configurable: true,
	        enumerable: true,
	        get: function proxyGetter() {
	          return self._data[key];
	        },
	        set: function proxySetter(val) {
	          self._data[key] = val;
	        }
	      });
	    }
	  };
	
	  /**
	   * Unproxy a property.
	   *
	   * @param {String} key
	   */
	
	  Vue.prototype._unproxy = function (key) {
	    if (!isReserved(key)) {
	      delete this[key];
	    }
	  };
	
	  /**
	   * Force update on every watcher in scope.
	   */
	
	  Vue.prototype._digest = function () {
	    for (var i = 0, l = this._watchers.length; i < l; i++) {
	      this._watchers[i].update(true); // shallow updates
	    }
	  };
	
	  /**
	   * Setup computed properties. They are essentially
	   * special getter/setters
	   */
	
	  function noop() {}
	  Vue.prototype._initComputed = function () {
	    var computed = this.$options.computed;
	    if (computed) {
	      for (var key in computed) {
	        var userDef = computed[key];
	        var def = {
	          enumerable: true,
	          configurable: true
	        };
	        if (typeof userDef === 'function') {
	          def.get = makeComputedGetter(userDef, this);
	          def.set = noop;
	        } else {
	          def.get = userDef.get ? userDef.cache !== false ? makeComputedGetter(userDef.get, this) : bind(userDef.get, this) : noop;
	          def.set = userDef.set ? bind(userDef.set, this) : noop;
	        }
	        Object.defineProperty(this, key, def);
	      }
	    }
	  };
	
	  function makeComputedGetter(getter, owner) {
	    var watcher = new Watcher(owner, getter, null, {
	      lazy: true
	    });
	    return function computedGetter() {
	      if (watcher.dirty) {
	        watcher.evaluate();
	      }
	      if (Dep.target) {
	        watcher.depend();
	      }
	      return watcher.value;
	    };
	  }
	
	  /**
	   * Setup instance methods. Methods must be bound to the
	   * instance since they might be passed down as a prop to
	   * child components.
	   */
	
	  Vue.prototype._initMethods = function () {
	    var methods = this.$options.methods;
	    if (methods) {
	      for (var key in methods) {
	        this[key] = bind(methods[key], this);
	      }
	    }
	  };
	
	  /**
	   * Initialize meta information like $index, $key & $value.
	   */
	
	  Vue.prototype._initMeta = function () {
	    var metas = this.$options._meta;
	    if (metas) {
	      for (var key in metas) {
	        defineReactive(this, key, metas[key]);
	      }
	    }
	  };
	}
	
	var eventRE = /^v-on:|^@/;
	
	function eventsMixin (Vue) {
	  /**
	   * Setup the instance's option events & watchers.
	   * If the value is a string, we pull it from the
	   * instance's methods by name.
	   */
	
	  Vue.prototype._initEvents = function () {
	    var options = this.$options;
	    if (options._asComponent) {
	      registerComponentEvents(this, options.el);
	    }
	    registerCallbacks(this, '$on', options.events);
	    registerCallbacks(this, '$watch', options.watch);
	  };
	
	  /**
	   * Register v-on events on a child component
	   *
	   * @param {Vue} vm
	   * @param {Element} el
	   */
	
	  function registerComponentEvents(vm, el) {
	    var attrs = el.attributes;
	    var name, value, handler;
	    for (var i = 0, l = attrs.length; i < l; i++) {
	      name = attrs[i].name;
	      if (eventRE.test(name)) {
	        name = name.replace(eventRE, '');
	        // force the expression into a statement so that
	        // it always dynamically resolves the method to call (#2670)
	        // kinda ugly hack, but does the job.
	        value = attrs[i].value;
	        if (isSimplePath(value)) {
	          value += '.apply(this, $arguments)';
	        }
	        handler = (vm._scope || vm._context).$eval(value, true);
	        handler._fromParent = true;
	        vm.$on(name.replace(eventRE), handler);
	      }
	    }
	  }
	
	  /**
	   * Register callbacks for option events and watchers.
	   *
	   * @param {Vue} vm
	   * @param {String} action
	   * @param {Object} hash
	   */
	
	  function registerCallbacks(vm, action, hash) {
	    if (!hash) return;
	    var handlers, key, i, j;
	    for (key in hash) {
	      handlers = hash[key];
	      if (isArray(handlers)) {
	        for (i = 0, j = handlers.length; i < j; i++) {
	          register(vm, action, key, handlers[i]);
	        }
	      } else {
	        register(vm, action, key, handlers);
	      }
	    }
	  }
	
	  /**
	   * Helper to register an event/watch callback.
	   *
	   * @param {Vue} vm
	   * @param {String} action
	   * @param {String} key
	   * @param {Function|String|Object} handler
	   * @param {Object} [options]
	   */
	
	  function register(vm, action, key, handler, options) {
	    var type = typeof handler;
	    if (type === 'function') {
	      vm[action](key, handler, options);
	    } else if (type === 'string') {
	      var methods = vm.$options.methods;
	      var method = methods && methods[handler];
	      if (method) {
	        vm[action](key, method, options);
	      } else {
	        ("production") !== 'production' && warn('Unknown method: "' + handler + '" when ' + 'registering callback for ' + action + ': "' + key + '".', vm);
	      }
	    } else if (handler && type === 'object') {
	      register(vm, action, key, handler.handler, handler);
	    }
	  }
	
	  /**
	   * Setup recursive attached/detached calls
	   */
	
	  Vue.prototype._initDOMHooks = function () {
	    this.$on('hook:attached', onAttached);
	    this.$on('hook:detached', onDetached);
	  };
	
	  /**
	   * Callback to recursively call attached hook on children
	   */
	
	  function onAttached() {
	    if (!this._isAttached) {
	      this._isAttached = true;
	      this.$children.forEach(callAttach);
	    }
	  }
	
	  /**
	   * Iterator to call attached hook
	   *
	   * @param {Vue} child
	   */
	
	  function callAttach(child) {
	    if (!child._isAttached && inDoc(child.$el)) {
	      child._callHook('attached');
	    }
	  }
	
	  /**
	   * Callback to recursively call detached hook on children
	   */
	
	  function onDetached() {
	    if (this._isAttached) {
	      this._isAttached = false;
	      this.$children.forEach(callDetach);
	    }
	  }
	
	  /**
	   * Iterator to call detached hook
	   *
	   * @param {Vue} child
	   */
	
	  function callDetach(child) {
	    if (child._isAttached && !inDoc(child.$el)) {
	      child._callHook('detached');
	    }
	  }
	
	  /**
	   * Trigger all handlers for a hook
	   *
	   * @param {String} hook
	   */
	
	  Vue.prototype._callHook = function (hook) {
	    this.$emit('pre-hook:' + hook);
	    var handlers = this.$options[hook];
	    if (handlers) {
	      for (var i = 0, j = handlers.length; i < j; i++) {
	        handlers[i].call(this);
	      }
	    }
	    this.$emit('hook:' + hook);
	  };
	}
	
	function noop$1() {}
	
	/**
	 * A directive links a DOM element with a piece of data,
	 * which is the result of evaluating an expression.
	 * It registers a watcher with the expression and calls
	 * the DOM update function when a change is triggered.
	 *
	 * @param {Object} descriptor
	 *                 - {String} name
	 *                 - {Object} def
	 *                 - {String} expression
	 *                 - {Array<Object>} [filters]
	 *                 - {Object} [modifiers]
	 *                 - {Boolean} literal
	 *                 - {String} attr
	 *                 - {String} arg
	 *                 - {String} raw
	 *                 - {String} [ref]
	 *                 - {Array<Object>} [interp]
	 *                 - {Boolean} [hasOneTime]
	 * @param {Vue} vm
	 * @param {Node} el
	 * @param {Vue} [host] - transclusion host component
	 * @param {Object} [scope] - v-for scope
	 * @param {Fragment} [frag] - owner fragment
	 * @constructor
	 */
	function Directive(descriptor, vm, el, host, scope, frag) {
	  this.vm = vm;
	  this.el = el;
	  // copy descriptor properties
	  this.descriptor = descriptor;
	  this.name = descriptor.name;
	  this.expression = descriptor.expression;
	  this.arg = descriptor.arg;
	  this.modifiers = descriptor.modifiers;
	  this.filters = descriptor.filters;
	  this.literal = this.modifiers && this.modifiers.literal;
	  // private
	  this._locked = false;
	  this._bound = false;
	  this._listeners = null;
	  // link context
	  this._host = host;
	  this._scope = scope;
	  this._frag = frag;
	  // store directives on node in dev mode
	  if (false) {
	    this.el._vue_directives = this.el._vue_directives || [];
	    this.el._vue_directives.push(this);
	  }
	}
	
	/**
	 * Initialize the directive, mixin definition properties,
	 * setup the watcher, call definition bind() and update()
	 * if present.
	 */
	
	Directive.prototype._bind = function () {
	  var name = this.name;
	  var descriptor = this.descriptor;
	
	  // remove attribute
	  if ((name !== 'cloak' || this.vm._isCompiled) && this.el && this.el.removeAttribute) {
	    var attr = descriptor.attr || 'v-' + name;
	    this.el.removeAttribute(attr);
	  }
	
	  // copy def properties
	  var def = descriptor.def;
	  if (typeof def === 'function') {
	    this.update = def;
	  } else {
	    extend(this, def);
	  }
	
	  // setup directive params
	  this._setupParams();
	
	  // initial bind
	  if (this.bind) {
	    this.bind();
	  }
	  this._bound = true;
	
	  if (this.literal) {
	    this.update && this.update(descriptor.raw);
	  } else if ((this.expression || this.modifiers) && (this.update || this.twoWay) && !this._checkStatement()) {
	    // wrapped updater for context
	    var dir = this;
	    if (this.update) {
	      this._update = function (val, oldVal) {
	        if (!dir._locked) {
	          dir.update(val, oldVal);
	        }
	      };
	    } else {
	      this._update = noop$1;
	    }
	    var preProcess = this._preProcess ? bind(this._preProcess, this) : null;
	    var postProcess = this._postProcess ? bind(this._postProcess, this) : null;
	    var watcher = this._watcher = new Watcher(this.vm, this.expression, this._update, // callback
	    {
	      filters: this.filters,
	      twoWay: this.twoWay,
	      deep: this.deep,
	      preProcess: preProcess,
	      postProcess: postProcess,
	      scope: this._scope
	    });
	    // v-model with inital inline value need to sync back to
	    // model instead of update to DOM on init. They would
	    // set the afterBind hook to indicate that.
	    if (this.afterBind) {
	      this.afterBind();
	    } else if (this.update) {
	      this.update(watcher.value);
	    }
	  }
	};
	
	/**
	 * Setup all param attributes, e.g. track-by,
	 * transition-mode, etc...
	 */
	
	Directive.prototype._setupParams = function () {
	  if (!this.params) {
	    return;
	  }
	  var params = this.params;
	  // swap the params array with a fresh object.
	  this.params = Object.create(null);
	  var i = params.length;
	  var key, val, mappedKey;
	  while (i--) {
	    key = hyphenate(params[i]);
	    mappedKey = camelize(key);
	    val = getBindAttr(this.el, key);
	    if (val != null) {
	      // dynamic
	      this._setupParamWatcher(mappedKey, val);
	    } else {
	      // static
	      val = getAttr(this.el, key);
	      if (val != null) {
	        this.params[mappedKey] = val === '' ? true : val;
	      }
	    }
	  }
	};
	
	/**
	 * Setup a watcher for a dynamic param.
	 *
	 * @param {String} key
	 * @param {String} expression
	 */
	
	Directive.prototype._setupParamWatcher = function (key, expression) {
	  var self = this;
	  var called = false;
	  var unwatch = (this._scope || this.vm).$watch(expression, function (val, oldVal) {
	    self.params[key] = val;
	    // since we are in immediate mode,
	    // only call the param change callbacks if this is not the first update.
	    if (called) {
	      var cb = self.paramWatchers && self.paramWatchers[key];
	      if (cb) {
	        cb.call(self, val, oldVal);
	      }
	    } else {
	      called = true;
	    }
	  }, {
	    immediate: true,
	    user: false
	  });(this._paramUnwatchFns || (this._paramUnwatchFns = [])).push(unwatch);
	};
	
	/**
	 * Check if the directive is a function caller
	 * and if the expression is a callable one. If both true,
	 * we wrap up the expression and use it as the event
	 * handler.
	 *
	 * e.g. on-click="a++"
	 *
	 * @return {Boolean}
	 */
	
	Directive.prototype._checkStatement = function () {
	  var expression = this.expression;
	  if (expression && this.acceptStatement && !isSimplePath(expression)) {
	    var fn = parseExpression$1(expression).get;
	    var scope = this._scope || this.vm;
	    var handler = function handler(e) {
	      scope.$event = e;
	      fn.call(scope, scope);
	      scope.$event = null;
	    };
	    if (this.filters) {
	      handler = scope._applyFilters(handler, null, this.filters);
	    }
	    this.update(handler);
	    return true;
	  }
	};
	
	/**
	 * Set the corresponding value with the setter.
	 * This should only be used in two-way directives
	 * e.g. v-model.
	 *
	 * @param {*} value
	 * @public
	 */
	
	Directive.prototype.set = function (value) {
	  /* istanbul ignore else */
	  if (this.twoWay) {
	    this._withLock(function () {
	      this._watcher.set(value);
	    });
	  } else if (false) {
	    warn('Directive.set() can only be used inside twoWay' + 'directives.');
	  }
	};
	
	/**
	 * Execute a function while preventing that function from
	 * triggering updates on this directive instance.
	 *
	 * @param {Function} fn
	 */
	
	Directive.prototype._withLock = function (fn) {
	  var self = this;
	  self._locked = true;
	  fn.call(self);
	  nextTick(function () {
	    self._locked = false;
	  });
	};
	
	/**
	 * Convenience method that attaches a DOM event listener
	 * to the directive element and autometically tears it down
	 * during unbind.
	 *
	 * @param {String} event
	 * @param {Function} handler
	 * @param {Boolean} [useCapture]
	 */
	
	Directive.prototype.on = function (event, handler, useCapture) {
	  on(this.el, event, handler, useCapture);(this._listeners || (this._listeners = [])).push([event, handler]);
	};
	
	/**
	 * Teardown the watcher and call unbind.
	 */
	
	Directive.prototype._teardown = function () {
	  if (this._bound) {
	    this._bound = false;
	    if (this.unbind) {
	      this.unbind();
	    }
	    if (this._watcher) {
	      this._watcher.teardown();
	    }
	    var listeners = this._listeners;
	    var i;
	    if (listeners) {
	      i = listeners.length;
	      while (i--) {
	        off(this.el, listeners[i][0], listeners[i][1]);
	      }
	    }
	    var unwatchFns = this._paramUnwatchFns;
	    if (unwatchFns) {
	      i = unwatchFns.length;
	      while (i--) {
	        unwatchFns[i]();
	      }
	    }
	    if (false) {
	      this.el._vue_directives.$remove(this);
	    }
	    this.vm = this.el = this._watcher = this._listeners = null;
	  }
	};
	
	function lifecycleMixin (Vue) {
	  /**
	   * Update v-ref for component.
	   *
	   * @param {Boolean} remove
	   */
	
	  Vue.prototype._updateRef = function (remove) {
	    var ref = this.$options._ref;
	    if (ref) {
	      var refs = (this._scope || this._context).$refs;
	      if (remove) {
	        if (refs[ref] === this) {
	          refs[ref] = null;
	        }
	      } else {
	        refs[ref] = this;
	      }
	    }
	  };
	
	  /**
	   * Transclude, compile and link element.
	   *
	   * If a pre-compiled linker is available, that means the
	   * passed in element will be pre-transcluded and compiled
	   * as well - all we need to do is to call the linker.
	   *
	   * Otherwise we need to call transclude/compile/link here.
	   *
	   * @param {Element} el
	   */
	
	  Vue.prototype._compile = function (el) {
	    var options = this.$options;
	
	    // transclude and init element
	    // transclude can potentially replace original
	    // so we need to keep reference; this step also injects
	    // the template and caches the original attributes
	    // on the container node and replacer node.
	    var original = el;
	    el = transclude(el, options);
	    this._initElement(el);
	
	    // handle v-pre on root node (#2026)
	    if (el.nodeType === 1 && getAttr(el, 'v-pre') !== null) {
	      return;
	    }
	
	    // root is always compiled per-instance, because
	    // container attrs and props can be different every time.
	    var contextOptions = this._context && this._context.$options;
	    var rootLinker = compileRoot(el, options, contextOptions);
	
	    // resolve slot distribution
	    resolveSlots(this, options._content);
	
	    // compile and link the rest
	    var contentLinkFn;
	    var ctor = this.constructor;
	    // component compilation can be cached
	    // as long as it's not using inline-template
	    if (options._linkerCachable) {
	      contentLinkFn = ctor.linker;
	      if (!contentLinkFn) {
	        contentLinkFn = ctor.linker = compile(el, options);
	      }
	    }
	
	    // link phase
	    // make sure to link root with prop scope!
	    var rootUnlinkFn = rootLinker(this, el, this._scope);
	    var contentUnlinkFn = contentLinkFn ? contentLinkFn(this, el) : compile(el, options)(this, el);
	
	    // register composite unlink function
	    // to be called during instance destruction
	    this._unlinkFn = function () {
	      rootUnlinkFn();
	      // passing destroying: true to avoid searching and
	      // splicing the directives
	      contentUnlinkFn(true);
	    };
	
	    // finally replace original
	    if (options.replace) {
	      replace(original, el);
	    }
	
	    this._isCompiled = true;
	    this._callHook('compiled');
	  };
	
	  /**
	   * Initialize instance element. Called in the public
	   * $mount() method.
	   *
	   * @param {Element} el
	   */
	
	  Vue.prototype._initElement = function (el) {
	    if (isFragment(el)) {
	      this._isFragment = true;
	      this.$el = this._fragmentStart = el.firstChild;
	      this._fragmentEnd = el.lastChild;
	      // set persisted text anchors to empty
	      if (this._fragmentStart.nodeType === 3) {
	        this._fragmentStart.data = this._fragmentEnd.data = '';
	      }
	      this._fragment = el;
	    } else {
	      this.$el = el;
	    }
	    this.$el.__vue__ = this;
	    this._callHook('beforeCompile');
	  };
	
	  /**
	   * Create and bind a directive to an element.
	   *
	   * @param {Object} descriptor - parsed directive descriptor
	   * @param {Node} node   - target node
	   * @param {Vue} [host] - transclusion host component
	   * @param {Object} [scope] - v-for scope
	   * @param {Fragment} [frag] - owner fragment
	   */
	
	  Vue.prototype._bindDir = function (descriptor, node, host, scope, frag) {
	    this._directives.push(new Directive(descriptor, this, node, host, scope, frag));
	  };
	
	  /**
	   * Teardown an instance, unobserves the data, unbind all the
	   * directives, turn off all the event listeners, etc.
	   *
	   * @param {Boolean} remove - whether to remove the DOM node.
	   * @param {Boolean} deferCleanup - if true, defer cleanup to
	   *                                 be called later
	   */
	
	  Vue.prototype._destroy = function (remove, deferCleanup) {
	    if (this._isBeingDestroyed) {
	      if (!deferCleanup) {
	        this._cleanup();
	      }
	      return;
	    }
	
	    var destroyReady;
	    var pendingRemoval;
	
	    var self = this;
	    // Cleanup should be called either synchronously or asynchronoysly as
	    // callback of this.$remove(), or if remove and deferCleanup are false.
	    // In any case it should be called after all other removing, unbinding and
	    // turning of is done
	    var cleanupIfPossible = function cleanupIfPossible() {
	      if (destroyReady && !pendingRemoval && !deferCleanup) {
	        self._cleanup();
	      }
	    };
	
	    // remove DOM element
	    if (remove && this.$el) {
	      pendingRemoval = true;
	      this.$remove(function () {
	        pendingRemoval = false;
	        cleanupIfPossible();
	      });
	    }
	
	    this._callHook('beforeDestroy');
	    this._isBeingDestroyed = true;
	    var i;
	    // remove self from parent. only necessary
	    // if parent is not being destroyed as well.
	    var parent = this.$parent;
	    if (parent && !parent._isBeingDestroyed) {
	      parent.$children.$remove(this);
	      // unregister ref (remove: true)
	      this._updateRef(true);
	    }
	    // destroy all children.
	    i = this.$children.length;
	    while (i--) {
	      this.$children[i].$destroy();
	    }
	    // teardown props
	    if (this._propsUnlinkFn) {
	      this._propsUnlinkFn();
	    }
	    // teardown all directives. this also tearsdown all
	    // directive-owned watchers.
	    if (this._unlinkFn) {
	      this._unlinkFn();
	    }
	    i = this._watchers.length;
	    while (i--) {
	      this._watchers[i].teardown();
	    }
	    // remove reference to self on $el
	    if (this.$el) {
	      this.$el.__vue__ = null;
	    }
	
	    destroyReady = true;
	    cleanupIfPossible();
	  };
	
	  /**
	   * Clean up to ensure garbage collection.
	   * This is called after the leave transition if there
	   * is any.
	   */
	
	  Vue.prototype._cleanup = function () {
	    if (this._isDestroyed) {
	      return;
	    }
	    // remove self from owner fragment
	    // do it in cleanup so that we can call $destroy with
	    // defer right when a fragment is about to be removed.
	    if (this._frag) {
	      this._frag.children.$remove(this);
	    }
	    // remove reference from data ob
	    // frozen object may not have observer.
	    if (this._data && this._data.__ob__) {
	      this._data.__ob__.removeVm(this);
	    }
	    // Clean up references to private properties and other
	    // instances. preserve reference to _data so that proxy
	    // accessors still work. The only potential side effect
	    // here is that mutating the instance after it's destroyed
	    // may affect the state of other components that are still
	    // observing the same object, but that seems to be a
	    // reasonable responsibility for the user rather than
	    // always throwing an error on them.
	    this.$el = this.$parent = this.$root = this.$children = this._watchers = this._context = this._scope = this._directives = null;
	    // call the last hook...
	    this._isDestroyed = true;
	    this._callHook('destroyed');
	    // turn off all instance listeners.
	    this.$off();
	  };
	}
	
	function miscMixin (Vue) {
	  /**
	   * Apply a list of filter (descriptors) to a value.
	   * Using plain for loops here because this will be called in
	   * the getter of any watcher with filters so it is very
	   * performance sensitive.
	   *
	   * @param {*} value
	   * @param {*} [oldValue]
	   * @param {Array} filters
	   * @param {Boolean} write
	   * @return {*}
	   */
	
	  Vue.prototype._applyFilters = function (value, oldValue, filters, write) {
	    var filter, fn, args, arg, offset, i, l, j, k;
	    for (i = 0, l = filters.length; i < l; i++) {
	      filter = filters[write ? l - i - 1 : i];
	      fn = resolveAsset(this.$options, 'filters', filter.name, true);
	      if (!fn) continue;
	      fn = write ? fn.write : fn.read || fn;
	      if (typeof fn !== 'function') continue;
	      args = write ? [value, oldValue] : [value];
	      offset = write ? 2 : 1;
	      if (filter.args) {
	        for (j = 0, k = filter.args.length; j < k; j++) {
	          arg = filter.args[j];
	          args[j + offset] = arg.dynamic ? this.$get(arg.value) : arg.value;
	        }
	      }
	      value = fn.apply(this, args);
	    }
	    return value;
	  };
	
	  /**
	   * Resolve a component, depending on whether the component
	   * is defined normally or using an async factory function.
	   * Resolves synchronously if already resolved, otherwise
	   * resolves asynchronously and caches the resolved
	   * constructor on the factory.
	   *
	   * @param {String|Function} value
	   * @param {Function} cb
	   */
	
	  Vue.prototype._resolveComponent = function (value, cb) {
	    var factory;
	    if (typeof value === 'function') {
	      factory = value;
	    } else {
	      factory = resolveAsset(this.$options, 'components', value, true);
	    }
	    /* istanbul ignore if */
	    if (!factory) {
	      return;
	    }
	    // async component factory
	    if (!factory.options) {
	      if (factory.resolved) {
	        // cached
	        cb(factory.resolved);
	      } else if (factory.requested) {
	        // pool callbacks
	        factory.pendingCallbacks.push(cb);
	      } else {
	        factory.requested = true;
	        var cbs = factory.pendingCallbacks = [cb];
	        factory.call(this, function resolve(res) {
	          if (isPlainObject(res)) {
	            res = Vue.extend(res);
	          }
	          // cache resolved
	          factory.resolved = res;
	          // invoke callbacks
	          for (var i = 0, l = cbs.length; i < l; i++) {
	            cbs[i](res);
	          }
	        }, function reject(reason) {
	          ("production") !== 'production' && warn('Failed to resolve async component' + (typeof value === 'string' ? ': ' + value : '') + '. ' + (reason ? '\nReason: ' + reason : ''));
	        });
	      }
	    } else {
	      // normal component
	      cb(factory);
	    }
	  };
	}
	
	var filterRE$1 = /[^|]\|[^|]/;
	
	function dataAPI (Vue) {
	  /**
	   * Get the value from an expression on this vm.
	   *
	   * @param {String} exp
	   * @param {Boolean} [asStatement]
	   * @return {*}
	   */
	
	  Vue.prototype.$get = function (exp, asStatement) {
	    var res = parseExpression$1(exp);
	    if (res) {
	      if (asStatement) {
	        var self = this;
	        return function statementHandler() {
	          self.$arguments = toArray(arguments);
	          var result = res.get.call(self, self);
	          self.$arguments = null;
	          return result;
	        };
	      } else {
	        try {
	          return res.get.call(this, this);
	        } catch (e) {}
	      }
	    }
	  };
	
	  /**
	   * Set the value from an expression on this vm.
	   * The expression must be a valid left-hand
	   * expression in an assignment.
	   *
	   * @param {String} exp
	   * @param {*} val
	   */
	
	  Vue.prototype.$set = function (exp, val) {
	    var res = parseExpression$1(exp, true);
	    if (res && res.set) {
	      res.set.call(this, this, val);
	    }
	  };
	
	  /**
	   * Delete a property on the VM
	   *
	   * @param {String} key
	   */
	
	  Vue.prototype.$delete = function (key) {
	    del(this._data, key);
	  };
	
	  /**
	   * Watch an expression, trigger callback when its
	   * value changes.
	   *
	   * @param {String|Function} expOrFn
	   * @param {Function} cb
	   * @param {Object} [options]
	   *                 - {Boolean} deep
	   *                 - {Boolean} immediate
	   * @return {Function} - unwatchFn
	   */
	
	  Vue.prototype.$watch = function (expOrFn, cb, options) {
	    var vm = this;
	    var parsed;
	    if (typeof expOrFn === 'string') {
	      parsed = parseDirective(expOrFn);
	      expOrFn = parsed.expression;
	    }
	    var watcher = new Watcher(vm, expOrFn, cb, {
	      deep: options && options.deep,
	      sync: options && options.sync,
	      filters: parsed && parsed.filters,
	      user: !options || options.user !== false
	    });
	    if (options && options.immediate) {
	      cb.call(vm, watcher.value);
	    }
	    return function unwatchFn() {
	      watcher.teardown();
	    };
	  };
	
	  /**
	   * Evaluate a text directive, including filters.
	   *
	   * @param {String} text
	   * @param {Boolean} [asStatement]
	   * @return {String}
	   */
	
	  Vue.prototype.$eval = function (text, asStatement) {
	    // check for filters.
	    if (filterRE$1.test(text)) {
	      var dir = parseDirective(text);
	      // the filter regex check might give false positive
	      // for pipes inside strings, so it's possible that
	      // we don't get any filters here
	      var val = this.$get(dir.expression, asStatement);
	      return dir.filters ? this._applyFilters(val, null, dir.filters) : val;
	    } else {
	      // no filter
	      return this.$get(text, asStatement);
	    }
	  };
	
	  /**
	   * Interpolate a piece of template text.
	   *
	   * @param {String} text
	   * @return {String}
	   */
	
	  Vue.prototype.$interpolate = function (text) {
	    var tokens = parseText(text);
	    var vm = this;
	    if (tokens) {
	      if (tokens.length === 1) {
	        return vm.$eval(tokens[0].value) + '';
	      } else {
	        return tokens.map(function (token) {
	          return token.tag ? vm.$eval(token.value) : token.value;
	        }).join('');
	      }
	    } else {
	      return text;
	    }
	  };
	
	  /**
	   * Log instance data as a plain JS object
	   * so that it is easier to inspect in console.
	   * This method assumes console is available.
	   *
	   * @param {String} [path]
	   */
	
	  Vue.prototype.$log = function (path) {
	    var data = path ? getPath(this._data, path) : this._data;
	    if (data) {
	      data = clean(data);
	    }
	    // include computed fields
	    if (!path) {
	      var key;
	      for (key in this.$options.computed) {
	        data[key] = clean(this[key]);
	      }
	      if (this._props) {
	        for (key in this._props) {
	          data[key] = clean(this[key]);
	        }
	      }
	    }
	    console.log(data);
	  };
	
	  /**
	   * "clean" a getter/setter converted object into a plain
	   * object copy.
	   *
	   * @param {Object} - obj
	   * @return {Object}
	   */
	
	  function clean(obj) {
	    return JSON.parse(JSON.stringify(obj));
	  }
	}
	
	function domAPI (Vue) {
	  /**
	   * Convenience on-instance nextTick. The callback is
	   * auto-bound to the instance, and this avoids component
	   * modules having to rely on the global Vue.
	   *
	   * @param {Function} fn
	   */
	
	  Vue.prototype.$nextTick = function (fn) {
	    nextTick(fn, this);
	  };
	
	  /**
	   * Append instance to target
	   *
	   * @param {Node} target
	   * @param {Function} [cb]
	   * @param {Boolean} [withTransition] - defaults to true
	   */
	
	  Vue.prototype.$appendTo = function (target, cb, withTransition) {
	    return insert(this, target, cb, withTransition, append, appendWithTransition);
	  };
	
	  /**
	   * Prepend instance to target
	   *
	   * @param {Node} target
	   * @param {Function} [cb]
	   * @param {Boolean} [withTransition] - defaults to true
	   */
	
	  Vue.prototype.$prependTo = function (target, cb, withTransition) {
	    target = query(target);
	    if (target.hasChildNodes()) {
	      this.$before(target.firstChild, cb, withTransition);
	    } else {
	      this.$appendTo(target, cb, withTransition);
	    }
	    return this;
	  };
	
	  /**
	   * Insert instance before target
	   *
	   * @param {Node} target
	   * @param {Function} [cb]
	   * @param {Boolean} [withTransition] - defaults to true
	   */
	
	  Vue.prototype.$before = function (target, cb, withTransition) {
	    return insert(this, target, cb, withTransition, beforeWithCb, beforeWithTransition);
	  };
	
	  /**
	   * Insert instance after target
	   *
	   * @param {Node} target
	   * @param {Function} [cb]
	   * @param {Boolean} [withTransition] - defaults to true
	   */
	
	  Vue.prototype.$after = function (target, cb, withTransition) {
	    target = query(target);
	    if (target.nextSibling) {
	      this.$before(target.nextSibling, cb, withTransition);
	    } else {
	      this.$appendTo(target.parentNode, cb, withTransition);
	    }
	    return this;
	  };
	
	  /**
	   * Remove instance from DOM
	   *
	   * @param {Function} [cb]
	   * @param {Boolean} [withTransition] - defaults to true
	   */
	
	  Vue.prototype.$remove = function (cb, withTransition) {
	    if (!this.$el.parentNode) {
	      return cb && cb();
	    }
	    var inDocument = this._isAttached && inDoc(this.$el);
	    // if we are not in document, no need to check
	    // for transitions
	    if (!inDocument) withTransition = false;
	    var self = this;
	    var realCb = function realCb() {
	      if (inDocument) self._callHook('detached');
	      if (cb) cb();
	    };
	    if (this._isFragment) {
	      removeNodeRange(this._fragmentStart, this._fragmentEnd, this, this._fragment, realCb);
	    } else {
	      var op = withTransition === false ? removeWithCb : removeWithTransition;
	      op(this.$el, this, realCb);
	    }
	    return this;
	  };
	
	  /**
	   * Shared DOM insertion function.
	   *
	   * @param {Vue} vm
	   * @param {Element} target
	   * @param {Function} [cb]
	   * @param {Boolean} [withTransition]
	   * @param {Function} op1 - op for non-transition insert
	   * @param {Function} op2 - op for transition insert
	   * @return vm
	   */
	
	  function insert(vm, target, cb, withTransition, op1, op2) {
	    target = query(target);
	    var targetIsDetached = !inDoc(target);
	    var op = withTransition === false || targetIsDetached ? op1 : op2;
	    var shouldCallHook = !targetIsDetached && !vm._isAttached && !inDoc(vm.$el);
	    if (vm._isFragment) {
	      mapNodeRange(vm._fragmentStart, vm._fragmentEnd, function (node) {
	        op(node, target, vm);
	      });
	      cb && cb();
	    } else {
	      op(vm.$el, target, vm, cb);
	    }
	    if (shouldCallHook) {
	      vm._callHook('attached');
	    }
	    return vm;
	  }
	
	  /**
	   * Check for selectors
	   *
	   * @param {String|Element} el
	   */
	
	  function query(el) {
	    return typeof el === 'string' ? document.querySelector(el) : el;
	  }
	
	  /**
	   * Append operation that takes a callback.
	   *
	   * @param {Node} el
	   * @param {Node} target
	   * @param {Vue} vm - unused
	   * @param {Function} [cb]
	   */
	
	  function append(el, target, vm, cb) {
	    target.appendChild(el);
	    if (cb) cb();
	  }
	
	  /**
	   * InsertBefore operation that takes a callback.
	   *
	   * @param {Node} el
	   * @param {Node} target
	   * @param {Vue} vm - unused
	   * @param {Function} [cb]
	   */
	
	  function beforeWithCb(el, target, vm, cb) {
	    before(el, target);
	    if (cb) cb();
	  }
	
	  /**
	   * Remove operation that takes a callback.
	   *
	   * @param {Node} el
	   * @param {Vue} vm - unused
	   * @param {Function} [cb]
	   */
	
	  function removeWithCb(el, vm, cb) {
	    remove(el);
	    if (cb) cb();
	  }
	}
	
	function eventsAPI (Vue) {
	  /**
	   * Listen on the given `event` with `fn`.
	   *
	   * @param {String} event
	   * @param {Function} fn
	   */
	
	  Vue.prototype.$on = function (event, fn) {
	    (this._events[event] || (this._events[event] = [])).push(fn);
	    modifyListenerCount(this, event, 1);
	    return this;
	  };
	
	  /**
	   * Adds an `event` listener that will be invoked a single
	   * time then automatically removed.
	   *
	   * @param {String} event
	   * @param {Function} fn
	   */
	
	  Vue.prototype.$once = function (event, fn) {
	    var self = this;
	    function on() {
	      self.$off(event, on);
	      fn.apply(this, arguments);
	    }
	    on.fn = fn;
	    this.$on(event, on);
	    return this;
	  };
	
	  /**
	   * Remove the given callback for `event` or all
	   * registered callbacks.
	   *
	   * @param {String} event
	   * @param {Function} fn
	   */
	
	  Vue.prototype.$off = function (event, fn) {
	    var cbs;
	    // all
	    if (!arguments.length) {
	      if (this.$parent) {
	        for (event in this._events) {
	          cbs = this._events[event];
	          if (cbs) {
	            modifyListenerCount(this, event, -cbs.length);
	          }
	        }
	      }
	      this._events = {};
	      return this;
	    }
	    // specific event
	    cbs = this._events[event];
	    if (!cbs) {
	      return this;
	    }
	    if (arguments.length === 1) {
	      modifyListenerCount(this, event, -cbs.length);
	      this._events[event] = null;
	      return this;
	    }
	    // specific handler
	    var cb;
	    var i = cbs.length;
	    while (i--) {
	      cb = cbs[i];
	      if (cb === fn || cb.fn === fn) {
	        modifyListenerCount(this, event, -1);
	        cbs.splice(i, 1);
	        break;
	      }
	    }
	    return this;
	  };
	
	  /**
	   * Trigger an event on self.
	   *
	   * @param {String|Object} event
	   * @return {Boolean} shouldPropagate
	   */
	
	  Vue.prototype.$emit = function (event) {
	    var isSource = typeof event === 'string';
	    event = isSource ? event : event.name;
	    var cbs = this._events[event];
	    var shouldPropagate = isSource || !cbs;
	    if (cbs) {
	      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
	      // this is a somewhat hacky solution to the question raised
	      // in #2102: for an inline component listener like <comp @test="doThis">,
	      // the propagation handling is somewhat broken. Therefore we
	      // need to treat these inline callbacks differently.
	      var hasParentCbs = isSource && cbs.some(function (cb) {
	        return cb._fromParent;
	      });
	      if (hasParentCbs) {
	        shouldPropagate = false;
	      }
	      var args = toArray(arguments, 1);
	      for (var i = 0, l = cbs.length; i < l; i++) {
	        var cb = cbs[i];
	        var res = cb.apply(this, args);
	        if (res === true && (!hasParentCbs || cb._fromParent)) {
	          shouldPropagate = true;
	        }
	      }
	    }
	    return shouldPropagate;
	  };
	
	  /**
	   * Recursively broadcast an event to all children instances.
	   *
	   * @param {String|Object} event
	   * @param {...*} additional arguments
	   */
	
	  Vue.prototype.$broadcast = function (event) {
	    var isSource = typeof event === 'string';
	    event = isSource ? event : event.name;
	    // if no child has registered for this event,
	    // then there's no need to broadcast.
	    if (!this._eventsCount[event]) return;
	    var children = this.$children;
	    var args = toArray(arguments);
	    if (isSource) {
	      // use object event to indicate non-source emit
	      // on children
	      args[0] = { name: event, source: this };
	    }
	    for (var i = 0, l = children.length; i < l; i++) {
	      var child = children[i];
	      var shouldPropagate = child.$emit.apply(child, args);
	      if (shouldPropagate) {
	        child.$broadcast.apply(child, args);
	      }
	    }
	    return this;
	  };
	
	  /**
	   * Recursively propagate an event up the parent chain.
	   *
	   * @param {String} event
	   * @param {...*} additional arguments
	   */
	
	  Vue.prototype.$dispatch = function (event) {
	    var shouldPropagate = this.$emit.apply(this, arguments);
	    if (!shouldPropagate) return;
	    var parent = this.$parent;
	    var args = toArray(arguments);
	    // use object event to indicate non-source emit
	    // on parents
	    args[0] = { name: event, source: this };
	    while (parent) {
	      shouldPropagate = parent.$emit.apply(parent, args);
	      parent = shouldPropagate ? parent.$parent : null;
	    }
	    return this;
	  };
	
	  /**
	   * Modify the listener counts on all parents.
	   * This bookkeeping allows $broadcast to return early when
	   * no child has listened to a certain event.
	   *
	   * @param {Vue} vm
	   * @param {String} event
	   * @param {Number} count
	   */
	
	  var hookRE = /^hook:/;
	  function modifyListenerCount(vm, event, count) {
	    var parent = vm.$parent;
	    // hooks do not get broadcasted so no need
	    // to do bookkeeping for them
	    if (!parent || !count || hookRE.test(event)) return;
	    while (parent) {
	      parent._eventsCount[event] = (parent._eventsCount[event] || 0) + count;
	      parent = parent.$parent;
	    }
	  }
	}
	
	function lifecycleAPI (Vue) {
	  /**
	   * Set instance target element and kick off the compilation
	   * process. The passed in `el` can be a selector string, an
	   * existing Element, or a DocumentFragment (for block
	   * instances).
	   *
	   * @param {Element|DocumentFragment|string} el
	   * @public
	   */
	
	  Vue.prototype.$mount = function (el) {
	    if (this._isCompiled) {
	      ("production") !== 'production' && warn('$mount() should be called only once.', this);
	      return;
	    }
	    el = query(el);
	    if (!el) {
	      el = document.createElement('div');
	    }
	    this._compile(el);
	    this._initDOMHooks();
	    if (inDoc(this.$el)) {
	      this._callHook('attached');
	      ready.call(this);
	    } else {
	      this.$once('hook:attached', ready);
	    }
	    return this;
	  };
	
	  /**
	   * Mark an instance as ready.
	   */
	
	  function ready() {
	    this._isAttached = true;
	    this._isReady = true;
	    this._callHook('ready');
	  }
	
	  /**
	   * Teardown the instance, simply delegate to the internal
	   * _destroy.
	   *
	   * @param {Boolean} remove
	   * @param {Boolean} deferCleanup
	   */
	
	  Vue.prototype.$destroy = function (remove, deferCleanup) {
	    this._destroy(remove, deferCleanup);
	  };
	
	  /**
	   * Partially compile a piece of DOM and return a
	   * decompile function.
	   *
	   * @param {Element|DocumentFragment} el
	   * @param {Vue} [host]
	   * @param {Object} [scope]
	   * @param {Fragment} [frag]
	   * @return {Function}
	   */
	
	  Vue.prototype.$compile = function (el, host, scope, frag) {
	    return compile(el, this.$options, true)(this, el, host, scope, frag);
	  };
	}
	
	/**
	 * The exposed Vue constructor.
	 *
	 * API conventions:
	 * - public API methods/properties are prefixed with `$`
	 * - internal methods/properties are prefixed with `_`
	 * - non-prefixed properties are assumed to be proxied user
	 *   data.
	 *
	 * @constructor
	 * @param {Object} [options]
	 * @public
	 */
	
	function Vue(options) {
	  this._init(options);
	}
	
	// install internals
	initMixin(Vue);
	stateMixin(Vue);
	eventsMixin(Vue);
	lifecycleMixin(Vue);
	miscMixin(Vue);
	
	// install instance APIs
	dataAPI(Vue);
	domAPI(Vue);
	eventsAPI(Vue);
	lifecycleAPI(Vue);
	
	var slot = {
	
	  priority: SLOT,
	  params: ['name'],
	
	  bind: function bind() {
	    // this was resolved during component transclusion
	    var name = this.params.name || 'default';
	    var content = this.vm._slotContents && this.vm._slotContents[name];
	    if (!content || !content.hasChildNodes()) {
	      this.fallback();
	    } else {
	      this.compile(content.cloneNode(true), this.vm._context, this.vm);
	    }
	  },
	
	  compile: function compile(content, context, host) {
	    if (content && context) {
	      if (this.el.hasChildNodes() && content.childNodes.length === 1 && content.childNodes[0].nodeType === 1 && content.childNodes[0].hasAttribute('v-if')) {
	        // if the inserted slot has v-if
	        // inject fallback content as the v-else
	        var elseBlock = document.createElement('template');
	        elseBlock.setAttribute('v-else', '');
	        elseBlock.innerHTML = this.el.innerHTML;
	        // the else block should be compiled in child scope
	        elseBlock._context = this.vm;
	        content.appendChild(elseBlock);
	      }
	      var scope = host ? host._scope : this._scope;
	      this.unlink = context.$compile(content, host, scope, this._frag);
	    }
	    if (content) {
	      replace(this.el, content);
	    } else {
	      remove(this.el);
	    }
	  },
	
	  fallback: function fallback() {
	    this.compile(extractContent(this.el, true), this.vm);
	  },
	
	  unbind: function unbind() {
	    if (this.unlink) {
	      this.unlink();
	    }
	  }
	};
	
	var partial = {
	
	  priority: PARTIAL,
	
	  params: ['name'],
	
	  // watch changes to name for dynamic partials
	  paramWatchers: {
	    name: function name(value) {
	      vIf.remove.call(this);
	      if (value) {
	        this.insert(value);
	      }
	    }
	  },
	
	  bind: function bind() {
	    this.anchor = createAnchor('v-partial');
	    replace(this.el, this.anchor);
	    this.insert(this.params.name);
	  },
	
	  insert: function insert(id) {
	    var partial = resolveAsset(this.vm.$options, 'partials', id, true);
	    if (partial) {
	      this.factory = new FragmentFactory(this.vm, partial);
	      vIf.insert.call(this);
	    }
	  },
	
	  unbind: function unbind() {
	    if (this.frag) {
	      this.frag.destroy();
	    }
	  }
	};
	
	var elementDirectives = {
	  slot: slot,
	  partial: partial
	};
	
	var convertArray = vFor._postProcess;
	
	/**
	 * Limit filter for arrays
	 *
	 * @param {Number} n
	 * @param {Number} offset (Decimal expected)
	 */
	
	function limitBy(arr, n, offset) {
	  offset = offset ? parseInt(offset, 10) : 0;
	  n = toNumber(n);
	  return typeof n === 'number' ? arr.slice(offset, offset + n) : arr;
	}
	
	/**
	 * Filter filter for arrays
	 *
	 * @param {String} search
	 * @param {String} [delimiter]
	 * @param {String} ...dataKeys
	 */
	
	function filterBy(arr, search, delimiter) {
	  arr = convertArray(arr);
	  if (search == null) {
	    return arr;
	  }
	  if (typeof search === 'function') {
	    return arr.filter(search);
	  }
	  // cast to lowercase string
	  search = ('' + search).toLowerCase();
	  // allow optional `in` delimiter
	  // because why not
	  var n = delimiter === 'in' ? 3 : 2;
	  // extract and flatten keys
	  var keys = Array.prototype.concat.apply([], toArray(arguments, n));
	  var res = [];
	  var item, key, val, j;
	  for (var i = 0, l = arr.length; i < l; i++) {
	    item = arr[i];
	    val = item && item.$value || item;
	    j = keys.length;
	    if (j) {
	      while (j--) {
	        key = keys[j];
	        if (key === '$key' && contains(item.$key, search) || contains(getPath(val, key), search)) {
	          res.push(item);
	          break;
	        }
	      }
	    } else if (contains(item, search)) {
	      res.push(item);
	    }
	  }
	  return res;
	}
	
	/**
	 * Order filter for arrays
	 *
	 * @param {String|Array<String>|Function} ...sortKeys
	 * @param {Number} [order]
	 */
	
	function orderBy(arr) {
	  var comparator = null;
	  var sortKeys = undefined;
	  arr = convertArray(arr);
	
	  // determine order (last argument)
	  var args = toArray(arguments, 1);
	  var order = args[args.length - 1];
	  if (typeof order === 'number') {
	    order = order < 0 ? -1 : 1;
	    args = args.length > 1 ? args.slice(0, -1) : args;
	  } else {
	    order = 1;
	  }
	
	  // determine sortKeys & comparator
	  var firstArg = args[0];
	  if (!firstArg) {
	    return arr;
	  } else if (typeof firstArg === 'function') {
	    // custom comparator
	    comparator = function (a, b) {
	      return firstArg(a, b) * order;
	    };
	  } else {
	    // string keys. flatten first
	    sortKeys = Array.prototype.concat.apply([], args);
	    comparator = function (a, b, i) {
	      i = i || 0;
	      return i >= sortKeys.length - 1 ? baseCompare(a, b, i) : baseCompare(a, b, i) || comparator(a, b, i + 1);
	    };
	  }
	
	  function baseCompare(a, b, sortKeyIndex) {
	    var sortKey = sortKeys[sortKeyIndex];
	    if (sortKey) {
	      if (sortKey !== '$key') {
	        if (isObject(a) && '$value' in a) a = a.$value;
	        if (isObject(b) && '$value' in b) b = b.$value;
	      }
	      a = isObject(a) ? getPath(a, sortKey) : a;
	      b = isObject(b) ? getPath(b, sortKey) : b;
	    }
	    return a === b ? 0 : a > b ? order : -order;
	  }
	
	  // sort on a copy to avoid mutating original array
	  return arr.slice().sort(comparator);
	}
	
	/**
	 * String contain helper
	 *
	 * @param {*} val
	 * @param {String} search
	 */
	
	function contains(val, search) {
	  var i;
	  if (isPlainObject(val)) {
	    var keys = Object.keys(val);
	    i = keys.length;
	    while (i--) {
	      if (contains(val[keys[i]], search)) {
	        return true;
	      }
	    }
	  } else if (isArray(val)) {
	    i = val.length;
	    while (i--) {
	      if (contains(val[i], search)) {
	        return true;
	      }
	    }
	  } else if (val != null) {
	    return val.toString().toLowerCase().indexOf(search) > -1;
	  }
	}
	
	var digitsRE = /(\d{3})(?=\d)/g;
	
	// asset collections must be a plain object.
	var filters = {
	
	  orderBy: orderBy,
	  filterBy: filterBy,
	  limitBy: limitBy,
	
	  /**
	   * Stringify value.
	   *
	   * @param {Number} indent
	   */
	
	  json: {
	    read: function read(value, indent) {
	      return typeof value === 'string' ? value : JSON.stringify(value, null, arguments.length > 1 ? indent : 2);
	    },
	    write: function write(value) {
	      try {
	        return JSON.parse(value);
	      } catch (e) {
	        return value;
	      }
	    }
	  },
	
	  /**
	   * 'abc' => 'Abc'
	   */
	
	  capitalize: function capitalize(value) {
	    if (!value && value !== 0) return '';
	    value = value.toString();
	    return value.charAt(0).toUpperCase() + value.slice(1);
	  },
	
	  /**
	   * 'abc' => 'ABC'
	   */
	
	  uppercase: function uppercase(value) {
	    return value || value === 0 ? value.toString().toUpperCase() : '';
	  },
	
	  /**
	   * 'AbC' => 'abc'
	   */
	
	  lowercase: function lowercase(value) {
	    return value || value === 0 ? value.toString().toLowerCase() : '';
	  },
	
	  /**
	   * 12345 => $12,345.00
	   *
	   * @param {String} sign
	   * @param {Number} decimals Decimal places
	   */
	
	  currency: function currency(value, _currency, decimals) {
	    value = parseFloat(value);
	    if (!isFinite(value) || !value && value !== 0) return '';
	    _currency = _currency != null ? _currency : '$';
	    decimals = decimals != null ? decimals : 2;
	    var stringified = Math.abs(value).toFixed(decimals);
	    var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
	    var i = _int.length % 3;
	    var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : '';
	    var _float = decimals ? stringified.slice(-1 - decimals) : '';
	    var sign = value < 0 ? '-' : '';
	    return sign + _currency + head + _int.slice(i).replace(digitsRE, '$1,') + _float;
	  },
	
	  /**
	   * 'item' => 'items'
	   *
	   * @params
	   *  an array of strings corresponding to
	   *  the single, double, triple ... forms of the word to
	   *  be pluralized. When the number to be pluralized
	   *  exceeds the length of the args, it will use the last
	   *  entry in the array.
	   *
	   *  e.g. ['single', 'double', 'triple', 'multiple']
	   */
	
	  pluralize: function pluralize(value) {
	    var args = toArray(arguments, 1);
	    var length = args.length;
	    if (length > 1) {
	      var index = value % 10 - 1;
	      return index in args ? args[index] : args[length - 1];
	    } else {
	      return args[0] + (value === 1 ? '' : 's');
	    }
	  },
	
	  /**
	   * Debounce a handler function.
	   *
	   * @param {Function} handler
	   * @param {Number} delay = 300
	   * @return {Function}
	   */
	
	  debounce: function debounce(handler, delay) {
	    if (!handler) return;
	    if (!delay) {
	      delay = 300;
	    }
	    return _debounce(handler, delay);
	  }
	};
	
	function installGlobalAPI (Vue) {
	  /**
	   * Vue and every constructor that extends Vue has an
	   * associated options object, which can be accessed during
	   * compilation steps as `this.constructor.options`.
	   *
	   * These can be seen as the default options of every
	   * Vue instance.
	   */
	
	  Vue.options = {
	    directives: directives,
	    elementDirectives: elementDirectives,
	    filters: filters,
	    transitions: {},
	    components: {},
	    partials: {},
	    replace: true
	  };
	
	  /**
	   * Expose useful internals
	   */
	
	  Vue.util = util;
	  Vue.config = config;
	  Vue.set = set;
	  Vue['delete'] = del;
	  Vue.nextTick = nextTick;
	
	  /**
	   * The following are exposed for advanced usage / plugins
	   */
	
	  Vue.compiler = compiler;
	  Vue.FragmentFactory = FragmentFactory;
	  Vue.internalDirectives = internalDirectives;
	  Vue.parsers = {
	    path: path,
	    text: text,
	    template: template,
	    directive: directive,
	    expression: expression
	  };
	
	  /**
	   * Each instance constructor, including Vue, has a unique
	   * cid. This enables us to create wrapped "child
	   * constructors" for prototypal inheritance and cache them.
	   */
	
	  Vue.cid = 0;
	  var cid = 1;
	
	  /**
	   * Class inheritance
	   *
	   * @param {Object} extendOptions
	   */
	
	  Vue.extend = function (extendOptions) {
	    extendOptions = extendOptions || {};
	    var Super = this;
	    var isFirstExtend = Super.cid === 0;
	    if (isFirstExtend && extendOptions._Ctor) {
	      return extendOptions._Ctor;
	    }
	    var name = extendOptions.name || Super.options.name;
	    if (false) {
	      if (!/^[a-zA-Z][\w-]*$/.test(name)) {
	        warn('Invalid component name: "' + name + '". Component names ' + 'can only contain alphanumeric characaters and the hyphen.');
	        name = null;
	      }
	    }
	    var Sub = createClass(name || 'VueComponent');
	    Sub.prototype = Object.create(Super.prototype);
	    Sub.prototype.constructor = Sub;
	    Sub.cid = cid++;
	    Sub.options = mergeOptions(Super.options, extendOptions);
	    Sub['super'] = Super;
	    // allow further extension
	    Sub.extend = Super.extend;
	    // create asset registers, so extended classes
	    // can have their private assets too.
	    config._assetTypes.forEach(function (type) {
	      Sub[type] = Super[type];
	    });
	    // enable recursive self-lookup
	    if (name) {
	      Sub.options.components[name] = Sub;
	    }
	    // cache constructor
	    if (isFirstExtend) {
	      extendOptions._Ctor = Sub;
	    }
	    return Sub;
	  };
	
	  /**
	   * A function that returns a sub-class constructor with the
	   * given name. This gives us much nicer output when
	   * logging instances in the console.
	   *
	   * @param {String} name
	   * @return {Function}
	   */
	
	  function createClass(name) {
	    /* eslint-disable no-new-func */
	    return new Function('return function ' + classify(name) + ' (options) { this._init(options) }')();
	    /* eslint-enable no-new-func */
	  }
	
	  /**
	   * Plugin system
	   *
	   * @param {Object} plugin
	   */
	
	  Vue.use = function (plugin) {
	    /* istanbul ignore if */
	    if (plugin.installed) {
	      return;
	    }
	    // additional parameters
	    var args = toArray(arguments, 1);
	    args.unshift(this);
	    if (typeof plugin.install === 'function') {
	      plugin.install.apply(plugin, args);
	    } else {
	      plugin.apply(null, args);
	    }
	    plugin.installed = true;
	    return this;
	  };
	
	  /**
	   * Apply a global mixin by merging it into the default
	   * options.
	   */
	
	  Vue.mixin = function (mixin) {
	    Vue.options = mergeOptions(Vue.options, mixin);
	  };
	
	  /**
	   * Create asset registration methods with the following
	   * signature:
	   *
	   * @param {String} id
	   * @param {*} definition
	   */
	
	  config._assetTypes.forEach(function (type) {
	    Vue[type] = function (id, definition) {
	      if (!definition) {
	        return this.options[type + 's'][id];
	      } else {
	        /* istanbul ignore if */
	        if (false) {
	          if (type === 'component' && (commonTagRE.test(id) || reservedTagRE.test(id))) {
	            warn('Do not use built-in or reserved HTML elements as component ' + 'id: ' + id);
	          }
	        }
	        if (type === 'component' && isPlainObject(definition)) {
	          if (!definition.name) {
	            definition.name = id;
	          }
	          definition = Vue.extend(definition);
	        }
	        this.options[type + 's'][id] = definition;
	        return definition;
	      }
	    };
	  });
	
	  // expose internal transition API
	  extend(Vue.transition, transition);
	}
	
	installGlobalAPI(Vue);
	
	Vue.version = '1.0.28';
	
	// devtools global hook
	/* istanbul ignore next */
	setTimeout(function () {
	  if (config.devtools) {
	    if (devtools) {
	      devtools.emit('init', Vue);
	    } else if (false) {
	      console.log('Download the Vue Devtools for a better development experience:\n' + 'https://github.com/vuejs/vue-devtools');
	    }
	  }
	}, 0);
	
	module.exports = Vue;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * vue-router v0.7.13
	 * (c) 2016 Evan You
	 * Released under the MIT License.
	 */
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  global.VueRouter = factory();
	}(this, function () { 'use strict';
	
	  var babelHelpers = {};
	
	  babelHelpers.classCallCheck = function (instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  };
	  function Target(path, matcher, delegate) {
	    this.path = path;
	    this.matcher = matcher;
	    this.delegate = delegate;
	  }
	
	  Target.prototype = {
	    to: function to(target, callback) {
	      var delegate = this.delegate;
	
	      if (delegate && delegate.willAddRoute) {
	        target = delegate.willAddRoute(this.matcher.target, target);
	      }
	
	      this.matcher.add(this.path, target);
	
	      if (callback) {
	        if (callback.length === 0) {
	          throw new Error("You must have an argument in the function passed to `to`");
	        }
	        this.matcher.addChild(this.path, target, callback, this.delegate);
	      }
	      return this;
	    }
	  };
	
	  function Matcher(target) {
	    this.routes = {};
	    this.children = {};
	    this.target = target;
	  }
	
	  Matcher.prototype = {
	    add: function add(path, handler) {
	      this.routes[path] = handler;
	    },
	
	    addChild: function addChild(path, target, callback, delegate) {
	      var matcher = new Matcher(target);
	      this.children[path] = matcher;
	
	      var match = generateMatch(path, matcher, delegate);
	
	      if (delegate && delegate.contextEntered) {
	        delegate.contextEntered(target, match);
	      }
	
	      callback(match);
	    }
	  };
	
	  function generateMatch(startingPath, matcher, delegate) {
	    return function (path, nestedCallback) {
	      var fullPath = startingPath + path;
	
	      if (nestedCallback) {
	        nestedCallback(generateMatch(fullPath, matcher, delegate));
	      } else {
	        return new Target(startingPath + path, matcher, delegate);
	      }
	    };
	  }
	
	  function addRoute(routeArray, path, handler) {
	    var len = 0;
	    for (var i = 0, l = routeArray.length; i < l; i++) {
	      len += routeArray[i].path.length;
	    }
	
	    path = path.substr(len);
	    var route = { path: path, handler: handler };
	    routeArray.push(route);
	  }
	
	  function eachRoute(baseRoute, matcher, callback, binding) {
	    var routes = matcher.routes;
	
	    for (var path in routes) {
	      if (routes.hasOwnProperty(path)) {
	        var routeArray = baseRoute.slice();
	        addRoute(routeArray, path, routes[path]);
	
	        if (matcher.children[path]) {
	          eachRoute(routeArray, matcher.children[path], callback, binding);
	        } else {
	          callback.call(binding, routeArray);
	        }
	      }
	    }
	  }
	
	  function map (callback, addRouteCallback) {
	    var matcher = new Matcher();
	
	    callback(generateMatch("", matcher, this.delegate));
	
	    eachRoute([], matcher, function (route) {
	      if (addRouteCallback) {
	        addRouteCallback(this, route);
	      } else {
	        this.add(route);
	      }
	    }, this);
	  }
	
	  var specials = ['/', '.', '*', '+', '?', '|', '(', ')', '[', ']', '{', '}', '\\'];
	
	  var escapeRegex = new RegExp('(\\' + specials.join('|\\') + ')', 'g');
	
	  var noWarning = false;
	  function warn(msg) {
	    if (!noWarning && typeof console !== 'undefined') {
	      console.error('[vue-router] ' + msg);
	    }
	  }
	
	  function tryDecode(uri, asComponent) {
	    try {
	      return asComponent ? decodeURIComponent(uri) : decodeURI(uri);
	    } catch (e) {
	      warn('malformed URI' + (asComponent ? ' component: ' : ': ') + uri);
	    }
	  }
	
	  function isArray(test) {
	    return Object.prototype.toString.call(test) === "[object Array]";
	  }
	
	  // A Segment represents a segment in the original route description.
	  // Each Segment type provides an `eachChar` and `regex` method.
	  //
	  // The `eachChar` method invokes the callback with one or more character
	  // specifications. A character specification consumes one or more input
	  // characters.
	  //
	  // The `regex` method returns a regex fragment for the segment. If the
	  // segment is a dynamic of star segment, the regex fragment also includes
	  // a capture.
	  //
	  // A character specification contains:
	  //
	  // * `validChars`: a String with a list of all valid characters, or
	  // * `invalidChars`: a String with a list of all invalid characters
	  // * `repeat`: true if the character specification can repeat
	
	  function StaticSegment(string) {
	    this.string = string;
	  }
	  StaticSegment.prototype = {
	    eachChar: function eachChar(callback) {
	      var string = this.string,
	          ch;
	
	      for (var i = 0, l = string.length; i < l; i++) {
	        ch = string.charAt(i);
	        callback({ validChars: ch });
	      }
	    },
	
	    regex: function regex() {
	      return this.string.replace(escapeRegex, '\\$1');
	    },
	
	    generate: function generate() {
	      return this.string;
	    }
	  };
	
	  function DynamicSegment(name) {
	    this.name = name;
	  }
	  DynamicSegment.prototype = {
	    eachChar: function eachChar(callback) {
	      callback({ invalidChars: "/", repeat: true });
	    },
	
	    regex: function regex() {
	      return "([^/]+)";
	    },
	
	    generate: function generate(params) {
	      var val = params[this.name];
	      return val == null ? ":" + this.name : val;
	    }
	  };
	
	  function StarSegment(name) {
	    this.name = name;
	  }
	  StarSegment.prototype = {
	    eachChar: function eachChar(callback) {
	      callback({ invalidChars: "", repeat: true });
	    },
	
	    regex: function regex() {
	      return "(.+)";
	    },
	
	    generate: function generate(params) {
	      var val = params[this.name];
	      return val == null ? ":" + this.name : val;
	    }
	  };
	
	  function EpsilonSegment() {}
	  EpsilonSegment.prototype = {
	    eachChar: function eachChar() {},
	    regex: function regex() {
	      return "";
	    },
	    generate: function generate() {
	      return "";
	    }
	  };
	
	  function parse(route, names, specificity) {
	    // normalize route as not starting with a "/". Recognition will
	    // also normalize.
	    if (route.charAt(0) === "/") {
	      route = route.substr(1);
	    }
	
	    var segments = route.split("/"),
	        results = [];
	
	    // A routes has specificity determined by the order that its different segments
	    // appear in. This system mirrors how the magnitude of numbers written as strings
	    // works.
	    // Consider a number written as: "abc". An example would be "200". Any other number written
	    // "xyz" will be smaller than "abc" so long as `a > z`. For instance, "199" is smaller
	    // then "200", even though "y" and "z" (which are both 9) are larger than "0" (the value
	    // of (`b` and `c`). This is because the leading symbol, "2", is larger than the other
	    // leading symbol, "1".
	    // The rule is that symbols to the left carry more weight than symbols to the right
	    // when a number is written out as a string. In the above strings, the leading digit
	    // represents how many 100's are in the number, and it carries more weight than the middle
	    // number which represents how many 10's are in the number.
	    // This system of number magnitude works well for route specificity, too. A route written as
	    // `a/b/c` will be more specific than `x/y/z` as long as `a` is more specific than
	    // `x`, irrespective of the other parts.
	    // Because of this similarity, we assign each type of segment a number value written as a
	    // string. We can find the specificity of compound routes by concatenating these strings
	    // together, from left to right. After we have looped through all of the segments,
	    // we convert the string to a number.
	    specificity.val = '';
	
	    for (var i = 0, l = segments.length; i < l; i++) {
	      var segment = segments[i],
	          match;
	
	      if (match = segment.match(/^:([^\/]+)$/)) {
	        results.push(new DynamicSegment(match[1]));
	        names.push(match[1]);
	        specificity.val += '3';
	      } else if (match = segment.match(/^\*([^\/]+)$/)) {
	        results.push(new StarSegment(match[1]));
	        specificity.val += '2';
	        names.push(match[1]);
	      } else if (segment === "") {
	        results.push(new EpsilonSegment());
	        specificity.val += '1';
	      } else {
	        results.push(new StaticSegment(segment));
	        specificity.val += '4';
	      }
	    }
	
	    specificity.val = +specificity.val;
	
	    return results;
	  }
	
	  // A State has a character specification and (`charSpec`) and a list of possible
	  // subsequent states (`nextStates`).
	  //
	  // If a State is an accepting state, it will also have several additional
	  // properties:
	  //
	  // * `regex`: A regular expression that is used to extract parameters from paths
	  //   that reached this accepting state.
	  // * `handlers`: Information on how to convert the list of captures into calls
	  //   to registered handlers with the specified parameters
	  // * `types`: How many static, dynamic or star segments in this route. Used to
	  //   decide which route to use if multiple registered routes match a path.
	  //
	  // Currently, State is implemented naively by looping over `nextStates` and
	  // comparing a character specification against a character. A more efficient
	  // implementation would use a hash of keys pointing at one or more next states.
	
	  function State(charSpec) {
	    this.charSpec = charSpec;
	    this.nextStates = [];
	  }
	
	  State.prototype = {
	    get: function get(charSpec) {
	      var nextStates = this.nextStates;
	
	      for (var i = 0, l = nextStates.length; i < l; i++) {
	        var child = nextStates[i];
	
	        var isEqual = child.charSpec.validChars === charSpec.validChars;
	        isEqual = isEqual && child.charSpec.invalidChars === charSpec.invalidChars;
	
	        if (isEqual) {
	          return child;
	        }
	      }
	    },
	
	    put: function put(charSpec) {
	      var state;
	
	      // If the character specification already exists in a child of the current
	      // state, just return that state.
	      if (state = this.get(charSpec)) {
	        return state;
	      }
	
	      // Make a new state for the character spec
	      state = new State(charSpec);
	
	      // Insert the new state as a child of the current state
	      this.nextStates.push(state);
	
	      // If this character specification repeats, insert the new state as a child
	      // of itself. Note that this will not trigger an infinite loop because each
	      // transition during recognition consumes a character.
	      if (charSpec.repeat) {
	        state.nextStates.push(state);
	      }
	
	      // Return the new state
	      return state;
	    },
	
	    // Find a list of child states matching the next character
	    match: function match(ch) {
	      // DEBUG "Processing `" + ch + "`:"
	      var nextStates = this.nextStates,
	          child,
	          charSpec,
	          chars;
	
	      // DEBUG "  " + debugState(this)
	      var returned = [];
	
	      for (var i = 0, l = nextStates.length; i < l; i++) {
	        child = nextStates[i];
	
	        charSpec = child.charSpec;
	
	        if (typeof (chars = charSpec.validChars) !== 'undefined') {
	          if (chars.indexOf(ch) !== -1) {
	            returned.push(child);
	          }
	        } else if (typeof (chars = charSpec.invalidChars) !== 'undefined') {
	          if (chars.indexOf(ch) === -1) {
	            returned.push(child);
	          }
	        }
	      }
	
	      return returned;
	    }
	
	    /** IF DEBUG
	    , debug: function() {
	      var charSpec = this.charSpec,
	          debug = "[",
	          chars = charSpec.validChars || charSpec.invalidChars;
	       if (charSpec.invalidChars) { debug += "^"; }
	      debug += chars;
	      debug += "]";
	       if (charSpec.repeat) { debug += "+"; }
	       return debug;
	    }
	    END IF **/
	  };
	
	  /** IF DEBUG
	  function debug(log) {
	    console.log(log);
	  }
	
	  function debugState(state) {
	    return state.nextStates.map(function(n) {
	      if (n.nextStates.length === 0) { return "( " + n.debug() + " [accepting] )"; }
	      return "( " + n.debug() + " <then> " + n.nextStates.map(function(s) { return s.debug() }).join(" or ") + " )";
	    }).join(", ")
	  }
	  END IF **/
	
	  // Sort the routes by specificity
	  function sortSolutions(states) {
	    return states.sort(function (a, b) {
	      return b.specificity.val - a.specificity.val;
	    });
	  }
	
	  function recognizeChar(states, ch) {
	    var nextStates = [];
	
	    for (var i = 0, l = states.length; i < l; i++) {
	      var state = states[i];
	
	      nextStates = nextStates.concat(state.match(ch));
	    }
	
	    return nextStates;
	  }
	
	  var oCreate = Object.create || function (proto) {
	    function F() {}
	    F.prototype = proto;
	    return new F();
	  };
	
	  function RecognizeResults(queryParams) {
	    this.queryParams = queryParams || {};
	  }
	  RecognizeResults.prototype = oCreate({
	    splice: Array.prototype.splice,
	    slice: Array.prototype.slice,
	    push: Array.prototype.push,
	    length: 0,
	    queryParams: null
	  });
	
	  function findHandler(state, path, queryParams) {
	    var handlers = state.handlers,
	        regex = state.regex;
	    var captures = path.match(regex),
	        currentCapture = 1;
	    var result = new RecognizeResults(queryParams);
	
	    for (var i = 0, l = handlers.length; i < l; i++) {
	      var handler = handlers[i],
	          names = handler.names,
	          params = {};
	
	      for (var j = 0, m = names.length; j < m; j++) {
	        params[names[j]] = captures[currentCapture++];
	      }
	
	      result.push({ handler: handler.handler, params: params, isDynamic: !!names.length });
	    }
	
	    return result;
	  }
	
	  function addSegment(currentState, segment) {
	    segment.eachChar(function (ch) {
	      var state;
	
	      currentState = currentState.put(ch);
	    });
	
	    return currentState;
	  }
	
	  function decodeQueryParamPart(part) {
	    // http://www.w3.org/TR/html401/interact/forms.html#h-17.13.4.1
	    part = part.replace(/\+/gm, '%20');
	    return tryDecode(part, true);
	  }
	
	  // The main interface
	
	  var RouteRecognizer = function RouteRecognizer() {
	    this.rootState = new State();
	    this.names = {};
	  };
	
	  RouteRecognizer.prototype = {
	    add: function add(routes, options) {
	      var currentState = this.rootState,
	          regex = "^",
	          specificity = {},
	          handlers = [],
	          allSegments = [],
	          name;
	
	      var isEmpty = true;
	
	      for (var i = 0, l = routes.length; i < l; i++) {
	        var route = routes[i],
	            names = [];
	
	        var segments = parse(route.path, names, specificity);
	
	        allSegments = allSegments.concat(segments);
	
	        for (var j = 0, m = segments.length; j < m; j++) {
	          var segment = segments[j];
	
	          if (segment instanceof EpsilonSegment) {
	            continue;
	          }
	
	          isEmpty = false;
	
	          // Add a "/" for the new segment
	          currentState = currentState.put({ validChars: "/" });
	          regex += "/";
	
	          // Add a representation of the segment to the NFA and regex
	          currentState = addSegment(currentState, segment);
	          regex += segment.regex();
	        }
	
	        var handler = { handler: route.handler, names: names };
	        handlers.push(handler);
	      }
	
	      if (isEmpty) {
	        currentState = currentState.put({ validChars: "/" });
	        regex += "/";
	      }
	
	      currentState.handlers = handlers;
	      currentState.regex = new RegExp(regex + "$");
	      currentState.specificity = specificity;
	
	      if (name = options && options.as) {
	        this.names[name] = {
	          segments: allSegments,
	          handlers: handlers
	        };
	      }
	    },
	
	    handlersFor: function handlersFor(name) {
	      var route = this.names[name],
	          result = [];
	      if (!route) {
	        throw new Error("There is no route named " + name);
	      }
	
	      for (var i = 0, l = route.handlers.length; i < l; i++) {
	        result.push(route.handlers[i]);
	      }
	
	      return result;
	    },
	
	    hasRoute: function hasRoute(name) {
	      return !!this.names[name];
	    },
	
	    generate: function generate(name, params) {
	      var route = this.names[name],
	          output = "";
	      if (!route) {
	        throw new Error("There is no route named " + name);
	      }
	
	      var segments = route.segments;
	
	      for (var i = 0, l = segments.length; i < l; i++) {
	        var segment = segments[i];
	
	        if (segment instanceof EpsilonSegment) {
	          continue;
	        }
	
	        output += "/";
	        output += segment.generate(params);
	      }
	
	      if (output.charAt(0) !== '/') {
	        output = '/' + output;
	      }
	
	      if (params && params.queryParams) {
	        output += this.generateQueryString(params.queryParams);
	      }
	
	      return output;
	    },
	
	    generateQueryString: function generateQueryString(params) {
	      var pairs = [];
	      var keys = [];
	      for (var key in params) {
	        if (params.hasOwnProperty(key)) {
	          keys.push(key);
	        }
	      }
	      keys.sort();
	      for (var i = 0, len = keys.length; i < len; i++) {
	        key = keys[i];
	        var value = params[key];
	        if (value == null) {
	          continue;
	        }
	        var pair = encodeURIComponent(key);
	        if (isArray(value)) {
	          for (var j = 0, l = value.length; j < l; j++) {
	            var arrayPair = key + '[]' + '=' + encodeURIComponent(value[j]);
	            pairs.push(arrayPair);
	          }
	        } else {
	          pair += "=" + encodeURIComponent(value);
	          pairs.push(pair);
	        }
	      }
	
	      if (pairs.length === 0) {
	        return '';
	      }
	
	      return "?" + pairs.join("&");
	    },
	
	    parseQueryString: function parseQueryString(queryString) {
	      var pairs = queryString.split("&"),
	          queryParams = {};
	      for (var i = 0; i < pairs.length; i++) {
	        var pair = pairs[i].split('='),
	            key = decodeQueryParamPart(pair[0]),
	            keyLength = key.length,
	            isArray = false,
	            value;
	        if (pair.length === 1) {
	          value = 'true';
	        } else {
	          //Handle arrays
	          if (keyLength > 2 && key.slice(keyLength - 2) === '[]') {
	            isArray = true;
	            key = key.slice(0, keyLength - 2);
	            if (!queryParams[key]) {
	              queryParams[key] = [];
	            }
	          }
	          value = pair[1] ? decodeQueryParamPart(pair[1]) : '';
	        }
	        if (isArray) {
	          queryParams[key].push(value);
	        } else {
	          queryParams[key] = value;
	        }
	      }
	      return queryParams;
	    },
	
	    recognize: function recognize(path, silent) {
	      noWarning = silent;
	      var states = [this.rootState],
	          pathLen,
	          i,
	          l,
	          queryStart,
	          queryParams = {},
	          isSlashDropped = false;
	
	      queryStart = path.indexOf('?');
	      if (queryStart !== -1) {
	        var queryString = path.substr(queryStart + 1, path.length);
	        path = path.substr(0, queryStart);
	        if (queryString) {
	          queryParams = this.parseQueryString(queryString);
	        }
	      }
	
	      path = tryDecode(path);
	      if (!path) return;
	
	      // DEBUG GROUP path
	
	      if (path.charAt(0) !== "/") {
	        path = "/" + path;
	      }
	
	      pathLen = path.length;
	      if (pathLen > 1 && path.charAt(pathLen - 1) === "/") {
	        path = path.substr(0, pathLen - 1);
	        isSlashDropped = true;
	      }
	
	      for (i = 0, l = path.length; i < l; i++) {
	        states = recognizeChar(states, path.charAt(i));
	        if (!states.length) {
	          break;
	        }
	      }
	
	      // END DEBUG GROUP
	
	      var solutions = [];
	      for (i = 0, l = states.length; i < l; i++) {
	        if (states[i].handlers) {
	          solutions.push(states[i]);
	        }
	      }
	
	      states = sortSolutions(solutions);
	
	      var state = solutions[0];
	
	      if (state && state.handlers) {
	        // if a trailing slash was dropped and a star segment is the last segment
	        // specified, put the trailing slash back
	        if (isSlashDropped && state.regex.source.slice(-5) === "(.+)$") {
	          path = path + "/";
	        }
	        return findHandler(state, path, queryParams);
	      }
	    }
	  };
	
	  RouteRecognizer.prototype.map = map;
	
	  var genQuery = RouteRecognizer.prototype.generateQueryString;
	
	  // export default for holding the Vue reference
	  var exports$1 = {};
	  /**
	   * Warn stuff.
	   *
	   * @param {String} msg
	   */
	
	  function warn$1(msg) {
	    /* istanbul ignore next */
	    if (typeof console !== 'undefined') {
	      console.error('[vue-router] ' + msg);
	    }
	  }
	
	  /**
	   * Resolve a relative path.
	   *
	   * @param {String} base
	   * @param {String} relative
	   * @param {Boolean} append
	   * @return {String}
	   */
	
	  function resolvePath(base, relative, append) {
	    var query = base.match(/(\?.*)$/);
	    if (query) {
	      query = query[1];
	      base = base.slice(0, -query.length);
	    }
	    // a query!
	    if (relative.charAt(0) === '?') {
	      return base + relative;
	    }
	    var stack = base.split('/');
	    // remove trailing segment if:
	    // - not appending
	    // - appending to trailing slash (last segment is empty)
	    if (!append || !stack[stack.length - 1]) {
	      stack.pop();
	    }
	    // resolve relative path
	    var segments = relative.replace(/^\//, '').split('/');
	    for (var i = 0; i < segments.length; i++) {
	      var segment = segments[i];
	      if (segment === '.') {
	        continue;
	      } else if (segment === '..') {
	        stack.pop();
	      } else {
	        stack.push(segment);
	      }
	    }
	    // ensure leading slash
	    if (stack[0] !== '') {
	      stack.unshift('');
	    }
	    return stack.join('/');
	  }
	
	  /**
	   * Forgiving check for a promise
	   *
	   * @param {Object} p
	   * @return {Boolean}
	   */
	
	  function isPromise(p) {
	    return p && typeof p.then === 'function';
	  }
	
	  /**
	   * Retrive a route config field from a component instance
	   * OR a component contructor.
	   *
	   * @param {Function|Vue} component
	   * @param {String} name
	   * @return {*}
	   */
	
	  function getRouteConfig(component, name) {
	    var options = component && (component.$options || component.options);
	    return options && options.route && options.route[name];
	  }
	
	  /**
	   * Resolve an async component factory. Have to do a dirty
	   * mock here because of Vue core's internal API depends on
	   * an ID check.
	   *
	   * @param {Object} handler
	   * @param {Function} cb
	   */
	
	  var resolver = undefined;
	
	  function resolveAsyncComponent(handler, cb) {
	    if (!resolver) {
	      resolver = {
	        resolve: exports$1.Vue.prototype._resolveComponent,
	        $options: {
	          components: {
	            _: handler.component
	          }
	        }
	      };
	    } else {
	      resolver.$options.components._ = handler.component;
	    }
	    resolver.resolve('_', function (Component) {
	      handler.component = Component;
	      cb(Component);
	    });
	  }
	
	  /**
	   * Map the dynamic segments in a path to params.
	   *
	   * @param {String} path
	   * @param {Object} params
	   * @param {Object} query
	   */
	
	  function mapParams(path, params, query) {
	    if (params === undefined) params = {};
	
	    path = path.replace(/:([^\/]+)/g, function (_, key) {
	      var val = params[key];
	      /* istanbul ignore if */
	      if (!val) {
	        warn$1('param "' + key + '" not found when generating ' + 'path for "' + path + '" with params ' + JSON.stringify(params));
	      }
	      return val || '';
	    });
	    if (query) {
	      path += genQuery(query);
	    }
	    return path;
	  }
	
	  var hashRE = /#.*$/;
	
	  var HTML5History = (function () {
	    function HTML5History(_ref) {
	      var root = _ref.root;
	      var onChange = _ref.onChange;
	      babelHelpers.classCallCheck(this, HTML5History);
	
	      if (root && root !== '/') {
	        // make sure there's the starting slash
	        if (root.charAt(0) !== '/') {
	          root = '/' + root;
	        }
	        // remove trailing slash
	        this.root = root.replace(/\/$/, '');
	        this.rootRE = new RegExp('^\\' + this.root);
	      } else {
	        this.root = null;
	      }
	      this.onChange = onChange;
	      // check base tag
	      var baseEl = document.querySelector('base');
	      this.base = baseEl && baseEl.getAttribute('href');
	    }
	
	    HTML5History.prototype.start = function start() {
	      var _this = this;
	
	      this.listener = function (e) {
	        var url = location.pathname + location.search;
	        if (_this.root) {
	          url = url.replace(_this.rootRE, '');
	        }
	        _this.onChange(url, e && e.state, location.hash);
	      };
	      window.addEventListener('popstate', this.listener);
	      this.listener();
	    };
	
	    HTML5History.prototype.stop = function stop() {
	      window.removeEventListener('popstate', this.listener);
	    };
	
	    HTML5History.prototype.go = function go(path, replace, append) {
	      var url = this.formatPath(path, append);
	      if (replace) {
	        history.replaceState({}, '', url);
	      } else {
	        // record scroll position by replacing current state
	        history.replaceState({
	          pos: {
	            x: window.pageXOffset,
	            y: window.pageYOffset
	          }
	        }, '', location.href);
	        // then push new state
	        history.pushState({}, '', url);
	      }
	      var hashMatch = path.match(hashRE);
	      var hash = hashMatch && hashMatch[0];
	      path = url
	      // strip hash so it doesn't mess up params
	      .replace(hashRE, '')
	      // remove root before matching
	      .replace(this.rootRE, '');
	      this.onChange(path, null, hash);
	    };
	
	    HTML5History.prototype.formatPath = function formatPath(path, append) {
	      return path.charAt(0) === '/'
	      // absolute path
	      ? this.root ? this.root + '/' + path.replace(/^\//, '') : path : resolvePath(this.base || location.pathname, path, append);
	    };
	
	    return HTML5History;
	  })();
	
	  var HashHistory = (function () {
	    function HashHistory(_ref) {
	      var hashbang = _ref.hashbang;
	      var onChange = _ref.onChange;
	      babelHelpers.classCallCheck(this, HashHistory);
	
	      this.hashbang = hashbang;
	      this.onChange = onChange;
	    }
	
	    HashHistory.prototype.start = function start() {
	      var self = this;
	      this.listener = function () {
	        var path = location.hash;
	        var raw = path.replace(/^#!?/, '');
	        // always
	        if (raw.charAt(0) !== '/') {
	          raw = '/' + raw;
	        }
	        var formattedPath = self.formatPath(raw);
	        if (formattedPath !== path) {
	          location.replace(formattedPath);
	          return;
	        }
	        // determine query
	        // note it's possible to have queries in both the actual URL
	        // and the hash fragment itself.
	        var query = location.search && path.indexOf('?') > -1 ? '&' + location.search.slice(1) : location.search;
	        self.onChange(path.replace(/^#!?/, '') + query);
	      };
	      window.addEventListener('hashchange', this.listener);
	      this.listener();
	    };
	
	    HashHistory.prototype.stop = function stop() {
	      window.removeEventListener('hashchange', this.listener);
	    };
	
	    HashHistory.prototype.go = function go(path, replace, append) {
	      path = this.formatPath(path, append);
	      if (replace) {
	        location.replace(path);
	      } else {
	        location.hash = path;
	      }
	    };
	
	    HashHistory.prototype.formatPath = function formatPath(path, append) {
	      var isAbsoloute = path.charAt(0) === '/';
	      var prefix = '#' + (this.hashbang ? '!' : '');
	      return isAbsoloute ? prefix + path : prefix + resolvePath(location.hash.replace(/^#!?/, ''), path, append);
	    };
	
	    return HashHistory;
	  })();
	
	  var AbstractHistory = (function () {
	    function AbstractHistory(_ref) {
	      var onChange = _ref.onChange;
	      babelHelpers.classCallCheck(this, AbstractHistory);
	
	      this.onChange = onChange;
	      this.currentPath = '/';
	    }
	
	    AbstractHistory.prototype.start = function start() {
	      this.onChange('/');
	    };
	
	    AbstractHistory.prototype.stop = function stop() {
	      // noop
	    };
	
	    AbstractHistory.prototype.go = function go(path, replace, append) {
	      path = this.currentPath = this.formatPath(path, append);
	      this.onChange(path);
	    };
	
	    AbstractHistory.prototype.formatPath = function formatPath(path, append) {
	      return path.charAt(0) === '/' ? path : resolvePath(this.currentPath, path, append);
	    };
	
	    return AbstractHistory;
	  })();
	
	  /**
	   * Determine the reusability of an existing router view.
	   *
	   * @param {Directive} view
	   * @param {Object} handler
	   * @param {Transition} transition
	   */
	
	  function canReuse(view, handler, transition) {
	    var component = view.childVM;
	    if (!component || !handler) {
	      return false;
	    }
	    // important: check view.Component here because it may
	    // have been changed in activate hook
	    if (view.Component !== handler.component) {
	      return false;
	    }
	    var canReuseFn = getRouteConfig(component, 'canReuse');
	    return typeof canReuseFn === 'boolean' ? canReuseFn : canReuseFn ? canReuseFn.call(component, {
	      to: transition.to,
	      from: transition.from
	    }) : true; // defaults to true
	  }
	
	  /**
	   * Check if a component can deactivate.
	   *
	   * @param {Directive} view
	   * @param {Transition} transition
	   * @param {Function} next
	   */
	
	  function canDeactivate(view, transition, next) {
	    var fromComponent = view.childVM;
	    var hook = getRouteConfig(fromComponent, 'canDeactivate');
	    if (!hook) {
	      next();
	    } else {
	      transition.callHook(hook, fromComponent, next, {
	        expectBoolean: true
	      });
	    }
	  }
	
	  /**
	   * Check if a component can activate.
	   *
	   * @param {Object} handler
	   * @param {Transition} transition
	   * @param {Function} next
	   */
	
	  function canActivate(handler, transition, next) {
	    resolveAsyncComponent(handler, function (Component) {
	      // have to check due to async-ness
	      if (transition.aborted) {
	        return;
	      }
	      // determine if this component can be activated
	      var hook = getRouteConfig(Component, 'canActivate');
	      if (!hook) {
	        next();
	      } else {
	        transition.callHook(hook, null, next, {
	          expectBoolean: true
	        });
	      }
	    });
	  }
	
	  /**
	   * Call deactivate hooks for existing router-views.
	   *
	   * @param {Directive} view
	   * @param {Transition} transition
	   * @param {Function} next
	   */
	
	  function deactivate(view, transition, next) {
	    var component = view.childVM;
	    var hook = getRouteConfig(component, 'deactivate');
	    if (!hook) {
	      next();
	    } else {
	      transition.callHooks(hook, component, next);
	    }
	  }
	
	  /**
	   * Activate / switch component for a router-view.
	   *
	   * @param {Directive} view
	   * @param {Transition} transition
	   * @param {Number} depth
	   * @param {Function} [cb]
	   */
	
	  function activate(view, transition, depth, cb, reuse) {
	    var handler = transition.activateQueue[depth];
	    if (!handler) {
	      saveChildView(view);
	      if (view._bound) {
	        view.setComponent(null);
	      }
	      cb && cb();
	      return;
	    }
	
	    var Component = view.Component = handler.component;
	    var activateHook = getRouteConfig(Component, 'activate');
	    var dataHook = getRouteConfig(Component, 'data');
	    var waitForData = getRouteConfig(Component, 'waitForData');
	
	    view.depth = depth;
	    view.activated = false;
	
	    var component = undefined;
	    var loading = !!(dataHook && !waitForData);
	
	    // "reuse" is a flag passed down when the parent view is
	    // either reused via keep-alive or as a child of a kept-alive view.
	    // of course we can only reuse if the current kept-alive instance
	    // is of the correct type.
	    reuse = reuse && view.childVM && view.childVM.constructor === Component;
	
	    if (reuse) {
	      // just reuse
	      component = view.childVM;
	      component.$loadingRouteData = loading;
	    } else {
	      saveChildView(view);
	
	      // unbuild current component. this step also destroys
	      // and removes all nested child views.
	      view.unbuild(true);
	
	      // build the new component. this will also create the
	      // direct child view of the current one. it will register
	      // itself as view.childView.
	      component = view.build({
	        _meta: {
	          $loadingRouteData: loading
	        },
	        created: function created() {
	          this._routerView = view;
	        }
	      });
	
	      // handle keep-alive.
	      // when a kept-alive child vm is restored, we need to
	      // add its cached child views into the router's view list,
	      // and also properly update current view's child view.
	      if (view.keepAlive) {
	        component.$loadingRouteData = loading;
	        var cachedChildView = component._keepAliveRouterView;
	        if (cachedChildView) {
	          view.childView = cachedChildView;
	          component._keepAliveRouterView = null;
	        }
	      }
	    }
	
	    // cleanup the component in case the transition is aborted
	    // before the component is ever inserted.
	    var cleanup = function cleanup() {
	      component.$destroy();
	    };
	
	    // actually insert the component and trigger transition
	    var insert = function insert() {
	      if (reuse) {
	        cb && cb();
	        return;
	      }
	      var router = transition.router;
	      if (router._rendered || router._transitionOnLoad) {
	        view.transition(component);
	      } else {
	        // no transition on first render, manual transition
	        /* istanbul ignore if */
	        if (view.setCurrent) {
	          // 0.12 compat
	          view.setCurrent(component);
	        } else {
	          // 1.0
	          view.childVM = component;
	        }
	        component.$before(view.anchor, null, false);
	      }
	      cb && cb();
	    };
	
	    var afterData = function afterData() {
	      // activate the child view
	      if (view.childView) {
	        activate(view.childView, transition, depth + 1, null, reuse || view.keepAlive);
	      }
	      insert();
	    };
	
	    // called after activation hook is resolved
	    var afterActivate = function afterActivate() {
	      view.activated = true;
	      if (dataHook && waitForData) {
	        // wait until data loaded to insert
	        loadData(component, transition, dataHook, afterData, cleanup);
	      } else {
	        // load data and insert at the same time
	        if (dataHook) {
	          loadData(component, transition, dataHook);
	        }
	        afterData();
	      }
	    };
	
	    if (activateHook) {
	      transition.callHooks(activateHook, component, afterActivate, {
	        cleanup: cleanup,
	        postActivate: true
	      });
	    } else {
	      afterActivate();
	    }
	  }
	
	  /**
	   * Reuse a view, just reload data if necessary.
	   *
	   * @param {Directive} view
	   * @param {Transition} transition
	   */
	
	  function reuse(view, transition) {
	    var component = view.childVM;
	    var dataHook = getRouteConfig(component, 'data');
	    if (dataHook) {
	      loadData(component, transition, dataHook);
	    }
	  }
	
	  /**
	   * Asynchronously load and apply data to component.
	   *
	   * @param {Vue} component
	   * @param {Transition} transition
	   * @param {Function} hook
	   * @param {Function} cb
	   * @param {Function} cleanup
	   */
	
	  function loadData(component, transition, hook, cb, cleanup) {
	    component.$loadingRouteData = true;
	    transition.callHooks(hook, component, function () {
	      component.$loadingRouteData = false;
	      component.$emit('route-data-loaded', component);
	      cb && cb();
	    }, {
	      cleanup: cleanup,
	      postActivate: true,
	      processData: function processData(data) {
	        // handle promise sugar syntax
	        var promises = [];
	        if (isPlainObject(data)) {
	          Object.keys(data).forEach(function (key) {
	            var val = data[key];
	            if (isPromise(val)) {
	              promises.push(val.then(function (resolvedVal) {
	                component.$set(key, resolvedVal);
	              }));
	            } else {
	              component.$set(key, val);
	            }
	          });
	        }
	        if (promises.length) {
	          return promises[0].constructor.all(promises);
	        }
	      }
	    });
	  }
	
	  /**
	   * Save the child view for a kept-alive view so that
	   * we can restore it when it is switched back to.
	   *
	   * @param {Directive} view
	   */
	
	  function saveChildView(view) {
	    if (view.keepAlive && view.childVM && view.childView) {
	      view.childVM._keepAliveRouterView = view.childView;
	    }
	    view.childView = null;
	  }
	
	  /**
	   * Check plain object.
	   *
	   * @param {*} val
	   */
	
	  function isPlainObject(val) {
	    return Object.prototype.toString.call(val) === '[object Object]';
	  }
	
	  /**
	   * A RouteTransition object manages the pipeline of a
	   * router-view switching process. This is also the object
	   * passed into user route hooks.
	   *
	   * @param {Router} router
	   * @param {Route} to
	   * @param {Route} from
	   */
	
	  var RouteTransition = (function () {
	    function RouteTransition(router, to, from) {
	      babelHelpers.classCallCheck(this, RouteTransition);
	
	      this.router = router;
	      this.to = to;
	      this.from = from;
	      this.next = null;
	      this.aborted = false;
	      this.done = false;
	    }
	
	    /**
	     * Abort current transition and return to previous location.
	     */
	
	    RouteTransition.prototype.abort = function abort() {
	      if (!this.aborted) {
	        this.aborted = true;
	        // if the root path throws an error during validation
	        // on initial load, it gets caught in an infinite loop.
	        var abortingOnLoad = !this.from.path && this.to.path === '/';
	        if (!abortingOnLoad) {
	          this.router.replace(this.from.path || '/');
	        }
	      }
	    };
	
	    /**
	     * Abort current transition and redirect to a new location.
	     *
	     * @param {String} path
	     */
	
	    RouteTransition.prototype.redirect = function redirect(path) {
	      if (!this.aborted) {
	        this.aborted = true;
	        if (typeof path === 'string') {
	          path = mapParams(path, this.to.params, this.to.query);
	        } else {
	          path.params = path.params || this.to.params;
	          path.query = path.query || this.to.query;
	        }
	        this.router.replace(path);
	      }
	    };
	
	    /**
	     * A router view transition's pipeline can be described as
	     * follows, assuming we are transitioning from an existing
	     * <router-view> chain [Component A, Component B] to a new
	     * chain [Component A, Component C]:
	     *
	     *  A    A
	     *  | => |
	     *  B    C
	     *
	     * 1. Reusablity phase:
	     *   -> canReuse(A, A)
	     *   -> canReuse(B, C)
	     *   -> determine new queues:
	     *      - deactivation: [B]
	     *      - activation: [C]
	     *
	     * 2. Validation phase:
	     *   -> canDeactivate(B)
	     *   -> canActivate(C)
	     *
	     * 3. Activation phase:
	     *   -> deactivate(B)
	     *   -> activate(C)
	     *
	     * Each of these steps can be asynchronous, and any
	     * step can potentially abort the transition.
	     *
	     * @param {Function} cb
	     */
	
	    RouteTransition.prototype.start = function start(cb) {
	      var transition = this;
	
	      // determine the queue of views to deactivate
	      var deactivateQueue = [];
	      var view = this.router._rootView;
	      while (view) {
	        deactivateQueue.unshift(view);
	        view = view.childView;
	      }
	      var reverseDeactivateQueue = deactivateQueue.slice().reverse();
	
	      // determine the queue of route handlers to activate
	      var activateQueue = this.activateQueue = toArray(this.to.matched).map(function (match) {
	        return match.handler;
	      });
	
	      // 1. Reusability phase
	      var i = undefined,
	          reuseQueue = undefined;
	      for (i = 0; i < reverseDeactivateQueue.length; i++) {
	        if (!canReuse(reverseDeactivateQueue[i], activateQueue[i], transition)) {
	          break;
	        }
	      }
	      if (i > 0) {
	        reuseQueue = reverseDeactivateQueue.slice(0, i);
	        deactivateQueue = reverseDeactivateQueue.slice(i).reverse();
	        activateQueue = activateQueue.slice(i);
	      }
	
	      // 2. Validation phase
	      transition.runQueue(deactivateQueue, canDeactivate, function () {
	        transition.runQueue(activateQueue, canActivate, function () {
	          transition.runQueue(deactivateQueue, deactivate, function () {
	            // 3. Activation phase
	
	            // Update router current route
	            transition.router._onTransitionValidated(transition);
	
	            // trigger reuse for all reused views
	            reuseQueue && reuseQueue.forEach(function (view) {
	              return reuse(view, transition);
	            });
	
	            // the root of the chain that needs to be replaced
	            // is the top-most non-reusable view.
	            if (deactivateQueue.length) {
	              var _view = deactivateQueue[deactivateQueue.length - 1];
	              var depth = reuseQueue ? reuseQueue.length : 0;
	              activate(_view, transition, depth, cb);
	            } else {
	              cb();
	            }
	          });
	        });
	      });
	    };
	
	    /**
	     * Asynchronously and sequentially apply a function to a
	     * queue.
	     *
	     * @param {Array} queue
	     * @param {Function} fn
	     * @param {Function} cb
	     */
	
	    RouteTransition.prototype.runQueue = function runQueue(queue, fn, cb) {
	      var transition = this;
	      step(0);
	      function step(index) {
	        if (index >= queue.length) {
	          cb();
	        } else {
	          fn(queue[index], transition, function () {
	            step(index + 1);
	          });
	        }
	      }
	    };
	
	    /**
	     * Call a user provided route transition hook and handle
	     * the response (e.g. if the user returns a promise).
	     *
	     * If the user neither expects an argument nor returns a
	     * promise, the hook is assumed to be synchronous.
	     *
	     * @param {Function} hook
	     * @param {*} [context]
	     * @param {Function} [cb]
	     * @param {Object} [options]
	     *                 - {Boolean} expectBoolean
	     *                 - {Boolean} postActive
	     *                 - {Function} processData
	     *                 - {Function} cleanup
	     */
	
	    RouteTransition.prototype.callHook = function callHook(hook, context, cb) {
	      var _ref = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	      var _ref$expectBoolean = _ref.expectBoolean;
	      var expectBoolean = _ref$expectBoolean === undefined ? false : _ref$expectBoolean;
	      var _ref$postActivate = _ref.postActivate;
	      var postActivate = _ref$postActivate === undefined ? false : _ref$postActivate;
	      var processData = _ref.processData;
	      var cleanup = _ref.cleanup;
	
	      var transition = this;
	      var nextCalled = false;
	
	      // abort the transition
	      var abort = function abort() {
	        cleanup && cleanup();
	        transition.abort();
	      };
	
	      // handle errors
	      var onError = function onError(err) {
	        postActivate ? next() : abort();
	        if (err && !transition.router._suppress) {
	          warn$1('Uncaught error during transition: ');
	          throw err instanceof Error ? err : new Error(err);
	        }
	      };
	
	      // since promise swallows errors, we have to
	      // throw it in the next tick...
	      var onPromiseError = function onPromiseError(err) {
	        try {
	          onError(err);
	        } catch (e) {
	          setTimeout(function () {
	            throw e;
	          }, 0);
	        }
	      };
	
	      // advance the transition to the next step
	      var next = function next() {
	        if (nextCalled) {
	          warn$1('transition.next() should be called only once.');
	          return;
	        }
	        nextCalled = true;
	        if (transition.aborted) {
	          cleanup && cleanup();
	          return;
	        }
	        cb && cb();
	      };
	
	      var nextWithBoolean = function nextWithBoolean(res) {
	        if (typeof res === 'boolean') {
	          res ? next() : abort();
	        } else if (isPromise(res)) {
	          res.then(function (ok) {
	            ok ? next() : abort();
	          }, onPromiseError);
	        } else if (!hook.length) {
	          next();
	        }
	      };
	
	      var nextWithData = function nextWithData(data) {
	        var res = undefined;
	        try {
	          res = processData(data);
	        } catch (err) {
	          return onError(err);
	        }
	        if (isPromise(res)) {
	          res.then(next, onPromiseError);
	        } else {
	          next();
	        }
	      };
	
	      // expose a clone of the transition object, so that each
	      // hook gets a clean copy and prevent the user from
	      // messing with the internals.
	      var exposed = {
	        to: transition.to,
	        from: transition.from,
	        abort: abort,
	        next: processData ? nextWithData : next,
	        redirect: function redirect() {
	          transition.redirect.apply(transition, arguments);
	        }
	      };
	
	      // actually call the hook
	      var res = undefined;
	      try {
	        res = hook.call(context, exposed);
	      } catch (err) {
	        return onError(err);
	      }
	
	      if (expectBoolean) {
	        // boolean hooks
	        nextWithBoolean(res);
	      } else if (isPromise(res)) {
	        // promise
	        if (processData) {
	          res.then(nextWithData, onPromiseError);
	        } else {
	          res.then(next, onPromiseError);
	        }
	      } else if (processData && isPlainOjbect(res)) {
	        // data promise sugar
	        nextWithData(res);
	      } else if (!hook.length) {
	        next();
	      }
	    };
	
	    /**
	     * Call a single hook or an array of async hooks in series.
	     *
	     * @param {Array} hooks
	     * @param {*} context
	     * @param {Function} cb
	     * @param {Object} [options]
	     */
	
	    RouteTransition.prototype.callHooks = function callHooks(hooks, context, cb, options) {
	      var _this = this;
	
	      if (Array.isArray(hooks)) {
	        this.runQueue(hooks, function (hook, _, next) {
	          if (!_this.aborted) {
	            _this.callHook(hook, context, next, options);
	          }
	        }, cb);
	      } else {
	        this.callHook(hooks, context, cb, options);
	      }
	    };
	
	    return RouteTransition;
	  })();
	
	  function isPlainOjbect(val) {
	    return Object.prototype.toString.call(val) === '[object Object]';
	  }
	
	  function toArray(val) {
	    return val ? Array.prototype.slice.call(val) : [];
	  }
	
	  var internalKeysRE = /^(component|subRoutes|fullPath)$/;
	
	  /**
	   * Route Context Object
	   *
	   * @param {String} path
	   * @param {Router} router
	   */
	
	  var Route = function Route(path, router) {
	    var _this = this;
	
	    babelHelpers.classCallCheck(this, Route);
	
	    var matched = router._recognizer.recognize(path);
	    if (matched) {
	      // copy all custom fields from route configs
	      [].forEach.call(matched, function (match) {
	        for (var key in match.handler) {
	          if (!internalKeysRE.test(key)) {
	            _this[key] = match.handler[key];
	          }
	        }
	      });
	      // set query and params
	      this.query = matched.queryParams;
	      this.params = [].reduce.call(matched, function (prev, cur) {
	        if (cur.params) {
	          for (var key in cur.params) {
	            prev[key] = cur.params[key];
	          }
	        }
	        return prev;
	      }, {});
	    }
	    // expose path and router
	    this.path = path;
	    // for internal use
	    this.matched = matched || router._notFoundHandler;
	    // internal reference to router
	    Object.defineProperty(this, 'router', {
	      enumerable: false,
	      value: router
	    });
	    // Important: freeze self to prevent observation
	    Object.freeze(this);
	  };
	
	  function applyOverride (Vue) {
	    var _Vue$util = Vue.util;
	    var extend = _Vue$util.extend;
	    var isArray = _Vue$util.isArray;
	    var defineReactive = _Vue$util.defineReactive;
	
	    // override Vue's init and destroy process to keep track of router instances
	    var init = Vue.prototype._init;
	    Vue.prototype._init = function (options) {
	      options = options || {};
	      var root = options._parent || options.parent || this;
	      var router = root.$router;
	      var route = root.$route;
	      if (router) {
	        // expose router
	        this.$router = router;
	        router._children.push(this);
	        /* istanbul ignore if */
	        if (this._defineMeta) {
	          // 0.12
	          this._defineMeta('$route', route);
	        } else {
	          // 1.0
	          defineReactive(this, '$route', route);
	        }
	      }
	      init.call(this, options);
	    };
	
	    var destroy = Vue.prototype._destroy;
	    Vue.prototype._destroy = function () {
	      if (!this._isBeingDestroyed && this.$router) {
	        this.$router._children.$remove(this);
	      }
	      destroy.apply(this, arguments);
	    };
	
	    // 1.0 only: enable route mixins
	    var strats = Vue.config.optionMergeStrategies;
	    var hooksToMergeRE = /^(data|activate|deactivate)$/;
	
	    if (strats) {
	      strats.route = function (parentVal, childVal) {
	        if (!childVal) return parentVal;
	        if (!parentVal) return childVal;
	        var ret = {};
	        extend(ret, parentVal);
	        for (var key in childVal) {
	          var a = ret[key];
	          var b = childVal[key];
	          // for data, activate and deactivate, we need to merge them into
	          // arrays similar to lifecycle hooks.
	          if (a && hooksToMergeRE.test(key)) {
	            ret[key] = (isArray(a) ? a : [a]).concat(b);
	          } else {
	            ret[key] = b;
	          }
	        }
	        return ret;
	      };
	    }
	  }
	
	  function View (Vue) {
	
	    var _ = Vue.util;
	    var componentDef =
	    // 0.12
	    Vue.directive('_component') ||
	    // 1.0
	    Vue.internalDirectives.component;
	    // <router-view> extends the internal component directive
	    var viewDef = _.extend({}, componentDef);
	
	    // with some overrides
	    _.extend(viewDef, {
	
	      _isRouterView: true,
	
	      bind: function bind() {
	        var route = this.vm.$route;
	        /* istanbul ignore if */
	        if (!route) {
	          warn$1('<router-view> can only be used inside a ' + 'router-enabled app.');
	          return;
	        }
	        // force dynamic directive so v-component doesn't
	        // attempt to build right now
	        this._isDynamicLiteral = true;
	        // finally, init by delegating to v-component
	        componentDef.bind.call(this);
	
	        // locate the parent view
	        var parentView = undefined;
	        var parent = this.vm;
	        while (parent) {
	          if (parent._routerView) {
	            parentView = parent._routerView;
	            break;
	          }
	          parent = parent.$parent;
	        }
	        if (parentView) {
	          // register self as a child of the parent view,
	          // instead of activating now. This is so that the
	          // child's activate hook is called after the
	          // parent's has resolved.
	          this.parentView = parentView;
	          parentView.childView = this;
	        } else {
	          // this is the root view!
	          var router = route.router;
	          router._rootView = this;
	        }
	
	        // handle late-rendered view
	        // two possibilities:
	        // 1. root view rendered after transition has been
	        //    validated;
	        // 2. child view rendered after parent view has been
	        //    activated.
	        var transition = route.router._currentTransition;
	        if (!parentView && transition.done || parentView && parentView.activated) {
	          var depth = parentView ? parentView.depth + 1 : 0;
	          activate(this, transition, depth);
	        }
	      },
	
	      unbind: function unbind() {
	        if (this.parentView) {
	          this.parentView.childView = null;
	        }
	        componentDef.unbind.call(this);
	      }
	    });
	
	    Vue.elementDirective('router-view', viewDef);
	  }
	
	  var trailingSlashRE = /\/$/;
	  var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;
	  var queryStringRE = /\?.*$/;
	
	  // install v-link, which provides navigation support for
	  // HTML5 history mode
	  function Link (Vue) {
	    var _Vue$util = Vue.util;
	    var _bind = _Vue$util.bind;
	    var isObject = _Vue$util.isObject;
	    var addClass = _Vue$util.addClass;
	    var removeClass = _Vue$util.removeClass;
	
	    var onPriority = Vue.directive('on').priority;
	    var LINK_UPDATE = '__vue-router-link-update__';
	
	    var activeId = 0;
	
	    Vue.directive('link-active', {
	      priority: 9999,
	      bind: function bind() {
	        var _this = this;
	
	        var id = String(activeId++);
	        // collect v-links contained within this element.
	        // we need do this here before the parent-child relationship
	        // gets messed up by terminal directives (if, for, components)
	        var childLinks = this.el.querySelectorAll('[v-link]');
	        for (var i = 0, l = childLinks.length; i < l; i++) {
	          var link = childLinks[i];
	          var existingId = link.getAttribute(LINK_UPDATE);
	          var value = existingId ? existingId + ',' + id : id;
	          // leave a mark on the link element which can be persisted
	          // through fragment clones.
	          link.setAttribute(LINK_UPDATE, value);
	        }
	        this.vm.$on(LINK_UPDATE, this.cb = function (link, path) {
	          if (link.activeIds.indexOf(id) > -1) {
	            link.updateClasses(path, _this.el);
	          }
	        });
	      },
	      unbind: function unbind() {
	        this.vm.$off(LINK_UPDATE, this.cb);
	      }
	    });
	
	    Vue.directive('link', {
	      priority: onPriority - 2,
	
	      bind: function bind() {
	        var vm = this.vm;
	        /* istanbul ignore if */
	        if (!vm.$route) {
	          warn$1('v-link can only be used inside a router-enabled app.');
	          return;
	        }
	        this.router = vm.$route.router;
	        // update things when the route changes
	        this.unwatch = vm.$watch('$route', _bind(this.onRouteUpdate, this));
	        // check v-link-active ids
	        var activeIds = this.el.getAttribute(LINK_UPDATE);
	        if (activeIds) {
	          this.el.removeAttribute(LINK_UPDATE);
	          this.activeIds = activeIds.split(',');
	        }
	        // no need to handle click if link expects to be opened
	        // in a new window/tab.
	        /* istanbul ignore if */
	        if (this.el.tagName === 'A' && this.el.getAttribute('target') === '_blank') {
	          return;
	        }
	        // handle click
	        this.handler = _bind(this.onClick, this);
	        this.el.addEventListener('click', this.handler);
	      },
	
	      update: function update(target) {
	        this.target = target;
	        if (isObject(target)) {
	          this.append = target.append;
	          this.exact = target.exact;
	          this.prevActiveClass = this.activeClass;
	          this.activeClass = target.activeClass;
	        }
	        this.onRouteUpdate(this.vm.$route);
	      },
	
	      onClick: function onClick(e) {
	        // don't redirect with control keys
	        /* istanbul ignore if */
	        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
	        // don't redirect when preventDefault called
	        /* istanbul ignore if */
	        if (e.defaultPrevented) return;
	        // don't redirect on right click
	        /* istanbul ignore if */
	        if (e.button !== 0) return;
	
	        var target = this.target;
	        if (target) {
	          // v-link with expression, just go
	          e.preventDefault();
	          this.router.go(target);
	        } else {
	          // no expression, delegate for an <a> inside
	          var el = e.target;
	          while (el.tagName !== 'A' && el !== this.el) {
	            el = el.parentNode;
	          }
	          if (el.tagName === 'A' && sameOrigin(el)) {
	            e.preventDefault();
	            var path = el.pathname;
	            if (this.router.history.root) {
	              path = path.replace(this.router.history.rootRE, '');
	            }
	            this.router.go({
	              path: path,
	              replace: target && target.replace,
	              append: target && target.append
	            });
	          }
	        }
	      },
	
	      onRouteUpdate: function onRouteUpdate(route) {
	        // router.stringifyPath is dependent on current route
	        // and needs to be called again whenver route changes.
	        var newPath = this.router.stringifyPath(this.target);
	        if (this.path !== newPath) {
	          this.path = newPath;
	          this.updateActiveMatch();
	          this.updateHref();
	        }
	        if (this.activeIds) {
	          this.vm.$emit(LINK_UPDATE, this, route.path);
	        } else {
	          this.updateClasses(route.path, this.el);
	        }
	      },
	
	      updateActiveMatch: function updateActiveMatch() {
	        this.activeRE = this.path && !this.exact ? new RegExp('^' + this.path.replace(/\/$/, '').replace(queryStringRE, '').replace(regexEscapeRE, '\\$&') + '(\\/|$)') : null;
	      },
	
	      updateHref: function updateHref() {
	        if (this.el.tagName !== 'A') {
	          return;
	        }
	        var path = this.path;
	        var router = this.router;
	        var isAbsolute = path.charAt(0) === '/';
	        // do not format non-hash relative paths
	        var href = path && (router.mode === 'hash' || isAbsolute) ? router.history.formatPath(path, this.append) : path;
	        if (href) {
	          this.el.href = href;
	        } else {
	          this.el.removeAttribute('href');
	        }
	      },
	
	      updateClasses: function updateClasses(path, el) {
	        var activeClass = this.activeClass || this.router._linkActiveClass;
	        // clear old class
	        if (this.prevActiveClass && this.prevActiveClass !== activeClass) {
	          toggleClasses(el, this.prevActiveClass, removeClass);
	        }
	        // remove query string before matching
	        var dest = this.path.replace(queryStringRE, '');
	        path = path.replace(queryStringRE, '');
	        // add new class
	        if (this.exact) {
	          if (dest === path ||
	          // also allow additional trailing slash
	          dest.charAt(dest.length - 1) !== '/' && dest === path.replace(trailingSlashRE, '')) {
	            toggleClasses(el, activeClass, addClass);
	          } else {
	            toggleClasses(el, activeClass, removeClass);
	          }
	        } else {
	          if (this.activeRE && this.activeRE.test(path)) {
	            toggleClasses(el, activeClass, addClass);
	          } else {
	            toggleClasses(el, activeClass, removeClass);
	          }
	        }
	      },
	
	      unbind: function unbind() {
	        this.el.removeEventListener('click', this.handler);
	        this.unwatch && this.unwatch();
	      }
	    });
	
	    function sameOrigin(link) {
	      return link.protocol === location.protocol && link.hostname === location.hostname && link.port === location.port;
	    }
	
	    // this function is copied from v-bind:class implementation until
	    // we properly expose it...
	    function toggleClasses(el, key, fn) {
	      key = key.trim();
	      if (key.indexOf(' ') === -1) {
	        fn(el, key);
	        return;
	      }
	      var keys = key.split(/\s+/);
	      for (var i = 0, l = keys.length; i < l; i++) {
	        fn(el, keys[i]);
	      }
	    }
	  }
	
	  var historyBackends = {
	    abstract: AbstractHistory,
	    hash: HashHistory,
	    html5: HTML5History
	  };
	
	  // late bind during install
	  var Vue = undefined;
	
	  /**
	   * Router constructor
	   *
	   * @param {Object} [options]
	   */
	
	  var Router = (function () {
	    function Router() {
	      var _this = this;
	
	      var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	      var _ref$hashbang = _ref.hashbang;
	      var hashbang = _ref$hashbang === undefined ? true : _ref$hashbang;
	      var _ref$abstract = _ref.abstract;
	      var abstract = _ref$abstract === undefined ? false : _ref$abstract;
	      var _ref$history = _ref.history;
	      var history = _ref$history === undefined ? false : _ref$history;
	      var _ref$saveScrollPosition = _ref.saveScrollPosition;
	      var saveScrollPosition = _ref$saveScrollPosition === undefined ? false : _ref$saveScrollPosition;
	      var _ref$transitionOnLoad = _ref.transitionOnLoad;
	      var transitionOnLoad = _ref$transitionOnLoad === undefined ? false : _ref$transitionOnLoad;
	      var _ref$suppressTransitionError = _ref.suppressTransitionError;
	      var suppressTransitionError = _ref$suppressTransitionError === undefined ? false : _ref$suppressTransitionError;
	      var _ref$root = _ref.root;
	      var root = _ref$root === undefined ? null : _ref$root;
	      var _ref$linkActiveClass = _ref.linkActiveClass;
	      var linkActiveClass = _ref$linkActiveClass === undefined ? 'v-link-active' : _ref$linkActiveClass;
	      babelHelpers.classCallCheck(this, Router);
	
	      /* istanbul ignore if */
	      if (!Router.installed) {
	        throw new Error('Please install the Router with Vue.use() before ' + 'creating an instance.');
	      }
	
	      // Vue instances
	      this.app = null;
	      this._children = [];
	
	      // route recognizer
	      this._recognizer = new RouteRecognizer();
	      this._guardRecognizer = new RouteRecognizer();
	
	      // state
	      this._started = false;
	      this._startCb = null;
	      this._currentRoute = {};
	      this._currentTransition = null;
	      this._previousTransition = null;
	      this._notFoundHandler = null;
	      this._notFoundRedirect = null;
	      this._beforeEachHooks = [];
	      this._afterEachHooks = [];
	
	      // trigger transition on initial render?
	      this._rendered = false;
	      this._transitionOnLoad = transitionOnLoad;
	
	      // history mode
	      this._root = root;
	      this._abstract = abstract;
	      this._hashbang = hashbang;
	
	      // check if HTML5 history is available
	      var hasPushState = typeof window !== 'undefined' && window.history && window.history.pushState;
	      this._history = history && hasPushState;
	      this._historyFallback = history && !hasPushState;
	
	      // create history object
	      var inBrowser = Vue.util.inBrowser;
	      this.mode = !inBrowser || this._abstract ? 'abstract' : this._history ? 'html5' : 'hash';
	
	      var History = historyBackends[this.mode];
	      this.history = new History({
	        root: root,
	        hashbang: this._hashbang,
	        onChange: function onChange(path, state, anchor) {
	          _this._match(path, state, anchor);
	        }
	      });
	
	      // other options
	      this._saveScrollPosition = saveScrollPosition;
	      this._linkActiveClass = linkActiveClass;
	      this._suppress = suppressTransitionError;
	    }
	
	    /**
	     * Allow directly passing components to a route
	     * definition.
	     *
	     * @param {String} path
	     * @param {Object} handler
	     */
	
	    // API ===================================================
	
	    /**
	    * Register a map of top-level paths.
	    *
	    * @param {Object} map
	    */
	
	    Router.prototype.map = function map(_map) {
	      for (var route in _map) {
	        this.on(route, _map[route]);
	      }
	      return this;
	    };
	
	    /**
	     * Register a single root-level path
	     *
	     * @param {String} rootPath
	     * @param {Object} handler
	     *                 - {String} component
	     *                 - {Object} [subRoutes]
	     *                 - {Boolean} [forceRefresh]
	     *                 - {Function} [before]
	     *                 - {Function} [after]
	     */
	
	    Router.prototype.on = function on(rootPath, handler) {
	      if (rootPath === '*') {
	        this._notFound(handler);
	      } else {
	        this._addRoute(rootPath, handler, []);
	      }
	      return this;
	    };
	
	    /**
	     * Set redirects.
	     *
	     * @param {Object} map
	     */
	
	    Router.prototype.redirect = function redirect(map) {
	      for (var path in map) {
	        this._addRedirect(path, map[path]);
	      }
	      return this;
	    };
	
	    /**
	     * Set aliases.
	     *
	     * @param {Object} map
	     */
	
	    Router.prototype.alias = function alias(map) {
	      for (var path in map) {
	        this._addAlias(path, map[path]);
	      }
	      return this;
	    };
	
	    /**
	     * Set global before hook.
	     *
	     * @param {Function} fn
	     */
	
	    Router.prototype.beforeEach = function beforeEach(fn) {
	      this._beforeEachHooks.push(fn);
	      return this;
	    };
	
	    /**
	     * Set global after hook.
	     *
	     * @param {Function} fn
	     */
	
	    Router.prototype.afterEach = function afterEach(fn) {
	      this._afterEachHooks.push(fn);
	      return this;
	    };
	
	    /**
	     * Navigate to a given path.
	     * The path can be an object describing a named path in
	     * the format of { name: '...', params: {}, query: {}}
	     * The path is assumed to be already decoded, and will
	     * be resolved against root (if provided)
	     *
	     * @param {String|Object} path
	     * @param {Boolean} [replace]
	     */
	
	    Router.prototype.go = function go(path) {
	      var replace = false;
	      var append = false;
	      if (Vue.util.isObject(path)) {
	        replace = path.replace;
	        append = path.append;
	      }
	      path = this.stringifyPath(path);
	      if (path) {
	        this.history.go(path, replace, append);
	      }
	    };
	
	    /**
	     * Short hand for replacing current path
	     *
	     * @param {String} path
	     */
	
	    Router.prototype.replace = function replace(path) {
	      if (typeof path === 'string') {
	        path = { path: path };
	      }
	      path.replace = true;
	      this.go(path);
	    };
	
	    /**
	     * Start the router.
	     *
	     * @param {VueConstructor} App
	     * @param {String|Element} container
	     * @param {Function} [cb]
	     */
	
	    Router.prototype.start = function start(App, container, cb) {
	      /* istanbul ignore if */
	      if (this._started) {
	        warn$1('already started.');
	        return;
	      }
	      this._started = true;
	      this._startCb = cb;
	      if (!this.app) {
	        /* istanbul ignore if */
	        if (!App || !container) {
	          throw new Error('Must start vue-router with a component and a ' + 'root container.');
	        }
	        /* istanbul ignore if */
	        if (App instanceof Vue) {
	          throw new Error('Must start vue-router with a component, not a ' + 'Vue instance.');
	        }
	        this._appContainer = container;
	        var Ctor = this._appConstructor = typeof App === 'function' ? App : Vue.extend(App);
	        // give it a name for better debugging
	        Ctor.options.name = Ctor.options.name || 'RouterApp';
	      }
	
	      // handle history fallback in browsers that do not
	      // support HTML5 history API
	      if (this._historyFallback) {
	        var _location = window.location;
	        var _history = new HTML5History({ root: this._root });
	        var path = _history.root ? _location.pathname.replace(_history.rootRE, '') : _location.pathname;
	        if (path && path !== '/') {
	          _location.assign((_history.root || '') + '/' + this.history.formatPath(path) + _location.search);
	          return;
	        }
	      }
	
	      this.history.start();
	    };
	
	    /**
	     * Stop listening to route changes.
	     */
	
	    Router.prototype.stop = function stop() {
	      this.history.stop();
	      this._started = false;
	    };
	
	    /**
	     * Normalize named route object / string paths into
	     * a string.
	     *
	     * @param {Object|String|Number} path
	     * @return {String}
	     */
	
	    Router.prototype.stringifyPath = function stringifyPath(path) {
	      var generatedPath = '';
	      if (path && typeof path === 'object') {
	        if (path.name) {
	          var extend = Vue.util.extend;
	          var currentParams = this._currentTransition && this._currentTransition.to.params;
	          var targetParams = path.params || {};
	          var params = currentParams ? extend(extend({}, currentParams), targetParams) : targetParams;
	          generatedPath = encodeURI(this._recognizer.generate(path.name, params));
	        } else if (path.path) {
	          generatedPath = encodeURI(path.path);
	        }
	        if (path.query) {
	          // note: the generated query string is pre-URL-encoded by the recognizer
	          var query = this._recognizer.generateQueryString(path.query);
	          if (generatedPath.indexOf('?') > -1) {
	            generatedPath += '&' + query.slice(1);
	          } else {
	            generatedPath += query;
	          }
	        }
	      } else {
	        generatedPath = encodeURI(path ? path + '' : '');
	      }
	      return generatedPath;
	    };
	
	    // Internal methods ======================================
	
	    /**
	    * Add a route containing a list of segments to the internal
	    * route recognizer. Will be called recursively to add all
	    * possible sub-routes.
	    *
	    * @param {String} path
	    * @param {Object} handler
	    * @param {Array} segments
	    */
	
	    Router.prototype._addRoute = function _addRoute(path, handler, segments) {
	      guardComponent(path, handler);
	      handler.path = path;
	      handler.fullPath = (segments.reduce(function (path, segment) {
	        return path + segment.path;
	      }, '') + path).replace('//', '/');
	      segments.push({
	        path: path,
	        handler: handler
	      });
	      this._recognizer.add(segments, {
	        as: handler.name
	      });
	      // add sub routes
	      if (handler.subRoutes) {
	        for (var subPath in handler.subRoutes) {
	          // recursively walk all sub routes
	          this._addRoute(subPath, handler.subRoutes[subPath],
	          // pass a copy in recursion to avoid mutating
	          // across branches
	          segments.slice());
	        }
	      }
	    };
	
	    /**
	     * Set the notFound route handler.
	     *
	     * @param {Object} handler
	     */
	
	    Router.prototype._notFound = function _notFound(handler) {
	      guardComponent('*', handler);
	      this._notFoundHandler = [{ handler: handler }];
	    };
	
	    /**
	     * Add a redirect record.
	     *
	     * @param {String} path
	     * @param {String} redirectPath
	     */
	
	    Router.prototype._addRedirect = function _addRedirect(path, redirectPath) {
	      if (path === '*') {
	        this._notFoundRedirect = redirectPath;
	      } else {
	        this._addGuard(path, redirectPath, this.replace);
	      }
	    };
	
	    /**
	     * Add an alias record.
	     *
	     * @param {String} path
	     * @param {String} aliasPath
	     */
	
	    Router.prototype._addAlias = function _addAlias(path, aliasPath) {
	      this._addGuard(path, aliasPath, this._match);
	    };
	
	    /**
	     * Add a path guard.
	     *
	     * @param {String} path
	     * @param {String} mappedPath
	     * @param {Function} handler
	     */
	
	    Router.prototype._addGuard = function _addGuard(path, mappedPath, _handler) {
	      var _this2 = this;
	
	      this._guardRecognizer.add([{
	        path: path,
	        handler: function handler(match, query) {
	          var realPath = mapParams(mappedPath, match.params, query);
	          _handler.call(_this2, realPath);
	        }
	      }]);
	    };
	
	    /**
	     * Check if a path matches any redirect records.
	     *
	     * @param {String} path
	     * @return {Boolean} - if true, will skip normal match.
	     */
	
	    Router.prototype._checkGuard = function _checkGuard(path) {
	      var matched = this._guardRecognizer.recognize(path, true);
	      if (matched) {
	        matched[0].handler(matched[0], matched.queryParams);
	        return true;
	      } else if (this._notFoundRedirect) {
	        matched = this._recognizer.recognize(path);
	        if (!matched) {
	          this.replace(this._notFoundRedirect);
	          return true;
	        }
	      }
	    };
	
	    /**
	     * Match a URL path and set the route context on vm,
	     * triggering view updates.
	     *
	     * @param {String} path
	     * @param {Object} [state]
	     * @param {String} [anchor]
	     */
	
	    Router.prototype._match = function _match(path, state, anchor) {
	      var _this3 = this;
	
	      if (this._checkGuard(path)) {
	        return;
	      }
	
	      var currentRoute = this._currentRoute;
	      var currentTransition = this._currentTransition;
	
	      if (currentTransition) {
	        if (currentTransition.to.path === path) {
	          // do nothing if we have an active transition going to the same path
	          return;
	        } else if (currentRoute.path === path) {
	          // We are going to the same path, but we also have an ongoing but
	          // not-yet-validated transition. Abort that transition and reset to
	          // prev transition.
	          currentTransition.aborted = true;
	          this._currentTransition = this._prevTransition;
	          return;
	        } else {
	          // going to a totally different path. abort ongoing transition.
	          currentTransition.aborted = true;
	        }
	      }
	
	      // construct new route and transition context
	      var route = new Route(path, this);
	      var transition = new RouteTransition(this, route, currentRoute);
	
	      // current transition is updated right now.
	      // however, current route will only be updated after the transition has
	      // been validated.
	      this._prevTransition = currentTransition;
	      this._currentTransition = transition;
	
	      if (!this.app) {
	        (function () {
	          // initial render
	          var router = _this3;
	          _this3.app = new _this3._appConstructor({
	            el: _this3._appContainer,
	            created: function created() {
	              this.$router = router;
	            },
	            _meta: {
	              $route: route
	            }
	          });
	        })();
	      }
	
	      // check global before hook
	      var beforeHooks = this._beforeEachHooks;
	      var startTransition = function startTransition() {
	        transition.start(function () {
	          _this3._postTransition(route, state, anchor);
	        });
	      };
	
	      if (beforeHooks.length) {
	        transition.runQueue(beforeHooks, function (hook, _, next) {
	          if (transition === _this3._currentTransition) {
	            transition.callHook(hook, null, next, {
	              expectBoolean: true
	            });
	          }
	        }, startTransition);
	      } else {
	        startTransition();
	      }
	
	      if (!this._rendered && this._startCb) {
	        this._startCb.call(null);
	      }
	
	      // HACK:
	      // set rendered to true after the transition start, so
	      // that components that are acitvated synchronously know
	      // whether it is the initial render.
	      this._rendered = true;
	    };
	
	    /**
	     * Set current to the new transition.
	     * This is called by the transition object when the
	     * validation of a route has succeeded.
	     *
	     * @param {Transition} transition
	     */
	
	    Router.prototype._onTransitionValidated = function _onTransitionValidated(transition) {
	      // set current route
	      var route = this._currentRoute = transition.to;
	      // update route context for all children
	      if (this.app.$route !== route) {
	        this.app.$route = route;
	        this._children.forEach(function (child) {
	          child.$route = route;
	        });
	      }
	      // call global after hook
	      if (this._afterEachHooks.length) {
	        this._afterEachHooks.forEach(function (hook) {
	          return hook.call(null, {
	            to: transition.to,
	            from: transition.from
	          });
	        });
	      }
	      this._currentTransition.done = true;
	    };
	
	    /**
	     * Handle stuff after the transition.
	     *
	     * @param {Route} route
	     * @param {Object} [state]
	     * @param {String} [anchor]
	     */
	
	    Router.prototype._postTransition = function _postTransition(route, state, anchor) {
	      // handle scroll positions
	      // saved scroll positions take priority
	      // then we check if the path has an anchor
	      var pos = state && state.pos;
	      if (pos && this._saveScrollPosition) {
	        Vue.nextTick(function () {
	          window.scrollTo(pos.x, pos.y);
	        });
	      } else if (anchor) {
	        Vue.nextTick(function () {
	          var el = document.getElementById(anchor.slice(1));
	          if (el) {
	            window.scrollTo(window.scrollX, el.offsetTop);
	          }
	        });
	      }
	    };
	
	    return Router;
	  })();
	
	  function guardComponent(path, handler) {
	    var comp = handler.component;
	    if (Vue.util.isPlainObject(comp)) {
	      comp = handler.component = Vue.extend(comp);
	    }
	    /* istanbul ignore if */
	    if (typeof comp !== 'function') {
	      handler.component = null;
	      warn$1('invalid component for route "' + path + '".');
	    }
	  }
	
	  /* Installation */
	
	  Router.installed = false;
	
	  /**
	   * Installation interface.
	   * Install the necessary directives.
	   */
	
	  Router.install = function (externalVue) {
	    /* istanbul ignore if */
	    if (Router.installed) {
	      warn$1('already installed.');
	      return;
	    }
	    Vue = externalVue;
	    applyOverride(Vue);
	    View(Vue);
	    Link(Vue);
	    exports$1.Vue = Vue;
	    Router.installed = true;
	  };
	
	  // auto install
	  /* istanbul ignore if */
	  if (typeof window !== 'undefined' && window.Vue) {
	    window.Vue.use(Router);
	  }
	
	  return Router;
	
	}));

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Install plugin.
	 */
	
	function install(Vue) {
	
	    var _ = __webpack_require__(441);
	
	    _.config = Vue.config;
	    _.warning = Vue.util.warn;
	    _.nextTick = Vue.util.nextTick;
	
	    Vue.url = __webpack_require__(442);
	    Vue.http = __webpack_require__(448);
	    Vue.resource = __webpack_require__(463);
	    Vue.Promise = __webpack_require__(450);
	
	    Object.defineProperties(Vue.prototype, {
	
	        $url: {
	            get: function () {
	                return _.options(Vue.url, this, this.$options.url);
	            }
	        },
	
	        $http: {
	            get: function () {
	                return _.options(Vue.http, this, this.$options.http);
	            }
	        },
	
	        $resource: {
	            get: function () {
	                return Vue.resource.bind(this);
	            }
	        },
	
	        $promise: {
	            get: function () {
	                return function (executor) {
	                    return new Vue.Promise(executor, this);
	                }.bind(this);
	            }
	        }
	
	    });
	}
	
	if (window.Vue) {
	    Vue.use(install);
	}
	
	module.exports = install;


/***/ }),
/* 441 */
/***/ (function(module, exports) {

	/**
	 * Utility functions.
	 */
	
	var _ = exports, array = [], console = window.console;
	
	_.warn = function (msg) {
	    if (console && _.warning && (!_.config.silent || _.config.debug)) {
	        console.warn('[VueResource warn]: ' + msg);
	    }
	};
	
	_.error = function (msg) {
	    if (console) {
	        console.error(msg);
	    }
	};
	
	_.trim = function (str) {
	    return str.replace(/^\s*|\s*$/g, '');
	};
	
	_.toLower = function (str) {
	    return str ? str.toLowerCase() : '';
	};
	
	_.isArray = Array.isArray;
	
	_.isString = function (val) {
	    return typeof val === 'string';
	};
	
	_.isFunction = function (val) {
	    return typeof val === 'function';
	};
	
	_.isObject = function (obj) {
	    return obj !== null && typeof obj === 'object';
	};
	
	_.isPlainObject = function (obj) {
	    return _.isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
	};
	
	_.options = function (fn, obj, options) {
	
	    options = options || {};
	
	    if (_.isFunction(options)) {
	        options = options.call(obj);
	    }
	
	    return _.merge(fn.bind({$vm: obj, $options: options}), fn, {$options: options});
	};
	
	_.each = function (obj, iterator) {
	
	    var i, key;
	
	    if (typeof obj.length == 'number') {
	        for (i = 0; i < obj.length; i++) {
	            iterator.call(obj[i], obj[i], i);
	        }
	    } else if (_.isObject(obj)) {
	        for (key in obj) {
	            if (obj.hasOwnProperty(key)) {
	                iterator.call(obj[key], obj[key], key);
	            }
	        }
	    }
	
	    return obj;
	};
	
	_.defaults = function (target, source) {
	
	    for (var key in source) {
	        if (target[key] === undefined) {
	            target[key] = source[key];
	        }
	    }
	
	    return target;
	};
	
	_.extend = function (target) {
	
	    var args = array.slice.call(arguments, 1);
	
	    args.forEach(function (arg) {
	        merge(target, arg);
	    });
	
	    return target;
	};
	
	_.merge = function (target) {
	
	    var args = array.slice.call(arguments, 1);
	
	    args.forEach(function (arg) {
	        merge(target, arg, true);
	    });
	
	    return target;
	};
	
	function merge(target, source, deep) {
	    for (var key in source) {
	        if (deep && (_.isPlainObject(source[key]) || _.isArray(source[key]))) {
	            if (_.isPlainObject(source[key]) && !_.isPlainObject(target[key])) {
	                target[key] = {};
	            }
	            if (_.isArray(source[key]) && !_.isArray(target[key])) {
	                target[key] = [];
	            }
	            merge(target[key], source[key], deep);
	        } else if (source[key] !== undefined) {
	            target[key] = source[key];
	        }
	    }
	}


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Service for URL templating.
	 */
	
	var _ = __webpack_require__(441);
	var ie = document.documentMode;
	var el = document.createElement('a');
	
	function Url(url, params) {
	
	    var options = url, transform;
	
	    if (_.isString(url)) {
	        options = {url: url, params: params};
	    }
	
	    options = _.merge({}, Url.options, this.$options, options);
	
	    Url.transforms.forEach(function (handler) {
	        transform = factory(handler, transform, this.$vm);
	    }, this);
	
	    return transform(options);
	};
	
	/**
	 * Url options.
	 */
	
	Url.options = {
	    url: '',
	    root: null,
	    params: {}
	};
	
	/**
	 * Url transforms.
	 */
	
	Url.transforms = [
	    __webpack_require__(443),
	    __webpack_require__(445),
	    __webpack_require__(446),
	    __webpack_require__(447)
	];
	
	/**
	 * Encodes a Url parameter string.
	 *
	 * @param {Object} obj
	 */
	
	Url.params = function (obj) {
	
	    var params = [], escape = encodeURIComponent;
	
	    params.add = function (key, value) {
	
	        if (_.isFunction(value)) {
	            value = value();
	        }
	
	        if (value === null) {
	            value = '';
	        }
	
	        this.push(escape(key) + '=' + escape(value));
	    };
	
	    serialize(params, obj);
	
	    return params.join('&').replace(/%20/g, '+');
	};
	
	/**
	 * Parse a URL and return its components.
	 *
	 * @param {String} url
	 */
	
	Url.parse = function (url) {
	
	    if (ie) {
	        el.href = url;
	        url = el.href;
	    }
	
	    el.href = url;
	
	    return {
	        href: el.href,
	        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
	        port: el.port,
	        host: el.host,
	        hostname: el.hostname,
	        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
	        search: el.search ? el.search.replace(/^\?/, '') : '',
	        hash: el.hash ? el.hash.replace(/^#/, '') : ''
	    };
	};
	
	function factory(handler, next, vm) {
	    return function (options) {
	        return handler.call(vm, options, next);
	    };
	}
	
	function serialize(params, obj, scope) {
	
	    var array = _.isArray(obj), plain = _.isPlainObject(obj), hash;
	
	    _.each(obj, function (value, key) {
	
	        hash = _.isObject(value) || _.isArray(value);
	
	        if (scope) {
	            key = scope + '[' + (plain || hash ? key : '') + ']';
	        }
	
	        if (!scope && array) {
	            params.add(value.name, value.value);
	        } else if (hash) {
	            serialize(params, value, key);
	        } else {
	            params.add(key, value);
	        }
	    });
	}
	
	module.exports = _.url = Url;


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * URL Template (RFC 6570) Transform.
	 */
	
	var UrlTemplate = __webpack_require__(444);
	
	module.exports = function (options) {
	
	    var variables = [], url = UrlTemplate.expand(options.url, options.params, variables);
	
	    variables.forEach(function (key) {
	        delete options.params[key];
	    });
	
	    return url;
	};


/***/ }),
/* 444 */
/***/ (function(module, exports) {

	/**
	 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
	 */
	
	exports.expand = function (url, params, variables) {
	
	    var tmpl = this.parse(url), expanded = tmpl.expand(params);
	
	    if (variables) {
	        variables.push.apply(variables, tmpl.vars);
	    }
	
	    return expanded;
	};
	
	exports.parse = function (template) {
	
	    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];
	
	    return {
	        vars: variables,
	        expand: function (context) {
	            return template.replace(/\{([^\{\}]+)\}|([^\{\}]+)/g, function (_, expression, literal) {
	                if (expression) {
	
	                    var operator = null, values = [];
	
	                    if (operators.indexOf(expression.charAt(0)) !== -1) {
	                        operator = expression.charAt(0);
	                        expression = expression.substr(1);
	                    }
	
	                    expression.split(/,/g).forEach(function (variable) {
	                        var tmp = /([^:\*]*)(?::(\d+)|(\*))?/.exec(variable);
	                        values.push.apply(values, exports.getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
	                        variables.push(tmp[1]);
	                    });
	
	                    if (operator && operator !== '+') {
	
	                        var separator = ',';
	
	                        if (operator === '?') {
	                            separator = '&';
	                        } else if (operator !== '#') {
	                            separator = operator;
	                        }
	
	                        return (values.length !== 0 ? operator : '') + values.join(separator);
	                    } else {
	                        return values.join(',');
	                    }
	
	                } else {
	                    return exports.encodeReserved(literal);
	                }
	            });
	        }
	    };
	};
	
	exports.getValues = function (context, operator, key, modifier) {
	
	    var value = context[key], result = [];
	
	    if (this.isDefined(value) && value !== '') {
	        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
	            value = value.toString();
	
	            if (modifier && modifier !== '*') {
	                value = value.substring(0, parseInt(modifier, 10));
	            }
	
	            result.push(this.encodeValue(operator, value, this.isKeyOperator(operator) ? key : null));
	        } else {
	            if (modifier === '*') {
	                if (Array.isArray(value)) {
	                    value.filter(this.isDefined).forEach(function (value) {
	                        result.push(this.encodeValue(operator, value, this.isKeyOperator(operator) ? key : null));
	                    }, this);
	                } else {
	                    Object.keys(value).forEach(function (k) {
	                        if (this.isDefined(value[k])) {
	                            result.push(this.encodeValue(operator, value[k], k));
	                        }
	                    }, this);
	                }
	            } else {
	                var tmp = [];
	
	                if (Array.isArray(value)) {
	                    value.filter(this.isDefined).forEach(function (value) {
	                        tmp.push(this.encodeValue(operator, value));
	                    }, this);
	                } else {
	                    Object.keys(value).forEach(function (k) {
	                        if (this.isDefined(value[k])) {
	                            tmp.push(encodeURIComponent(k));
	                            tmp.push(this.encodeValue(operator, value[k].toString()));
	                        }
	                    }, this);
	                }
	
	                if (this.isKeyOperator(operator)) {
	                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
	                } else if (tmp.length !== 0) {
	                    result.push(tmp.join(','));
	                }
	            }
	        }
	    } else {
	        if (operator === ';') {
	            result.push(encodeURIComponent(key));
	        } else if (value === '' && (operator === '&' || operator === '?')) {
	            result.push(encodeURIComponent(key) + '=');
	        } else if (value === '') {
	            result.push('');
	        }
	    }
	
	    return result;
	};
	
	exports.isDefined = function (value) {
	    return value !== undefined && value !== null;
	};
	
	exports.isKeyOperator = function (operator) {
	    return operator === ';' || operator === '&' || operator === '?';
	};
	
	exports.encodeValue = function (operator, value, key) {
	
	    value = (operator === '+' || operator === '#') ? this.encodeReserved(value) : encodeURIComponent(value);
	
	    if (key) {
	        return encodeURIComponent(key) + '=' + value;
	    } else {
	        return value;
	    }
	};
	
	exports.encodeReserved = function (str) {
	    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
	        if (!/%[0-9A-Fa-f]/.test(part)) {
	            part = encodeURI(part);
	        }
	        return part;
	    }).join('');
	};


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Legacy Transform.
	 */
	
	var _ = __webpack_require__(441);
	
	module.exports = function (options, next) {
	
	    var variables = [], url = next(options);
	
	    url = url.replace(/(\/?):([a-z]\w*)/gi, function (match, slash, name) {
	
	        _.warn('The `:' + name + '` parameter syntax has been deprecated. Use the `{' + name + '}` syntax instead.');
	
	        if (options.params[name]) {
	            variables.push(name);
	            return slash + encodeUriSegment(options.params[name]);
	        }
	
	        return '';
	    });
	
	    variables.forEach(function (key) {
	        delete options.params[key];
	    });
	
	    return url;
	};
	
	function encodeUriSegment(value) {
	
	    return encodeUriQuery(value, true).
	        replace(/%26/gi, '&').
	        replace(/%3D/gi, '=').
	        replace(/%2B/gi, '+');
	}
	
	function encodeUriQuery(value, spaces) {
	
	    return encodeURIComponent(value).
	        replace(/%40/gi, '@').
	        replace(/%3A/gi, ':').
	        replace(/%24/g, '$').
	        replace(/%2C/gi, ',').
	        replace(/%20/g, (spaces ? '%20' : '+'));
	}


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Query Parameter Transform.
	 */
	
	var _ = __webpack_require__(441);
	
	module.exports = function (options, next) {
	
	    var urlParams = Object.keys(_.url.options.params), query = {}, url = next(options);
	
	   _.each(options.params, function (value, key) {
	        if (urlParams.indexOf(key) === -1) {
	            query[key] = value;
	        }
	    });
	
	    query = _.url.params(query);
	
	    if (query) {
	        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
	    }
	
	    return url;
	};


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Root Prefix Transform.
	 */
	
	var _ = __webpack_require__(441);
	
	module.exports = function (options, next) {
	
	    var url = next(options);
	
	    if (_.isString(options.root) && !url.match(/^(https?:)?\//)) {
	        url = options.root + '/' + url;
	    }
	
	    return url;
	};


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Service for sending network requests.
	 */
	
	var _ = __webpack_require__(441);
	var Client = __webpack_require__(449);
	var Promise = __webpack_require__(450);
	var interceptor = __webpack_require__(453);
	var jsonType = {'Content-Type': 'application/json'};
	
	function Http(url, options) {
	
	    var client = Client, request, promise;
	
	    Http.interceptors.forEach(function (handler) {
	        client = interceptor(handler, this.$vm)(client);
	    }, this);
	
	    options = _.isObject(url) ? url : _.extend({url: url}, options);
	    request = _.merge({}, Http.options, this.$options, options);
	    promise = client(request).bind(this.$vm).then(function (response) {
	
	        return response.ok ? response : Promise.reject(response);
	
	    }, function (response) {
	
	        if (response instanceof Error) {
	            _.error(response);
	        }
	
	        return Promise.reject(response);
	    });
	
	    if (request.success) {
	        promise.success(request.success);
	    }
	
	    if (request.error) {
	        promise.error(request.error);
	    }
	
	    return promise;
	}
	
	Http.options = {
	    method: 'get',
	    data: '',
	    params: {},
	    headers: {},
	    xhr: null,
	    jsonp: 'callback',
	    beforeSend: null,
	    crossOrigin: null,
	    emulateHTTP: false,
	    emulateJSON: false,
	    timeout: 0
	};
	
	Http.interceptors = [
	    __webpack_require__(454),
	    __webpack_require__(455),
	    __webpack_require__(456),
	    __webpack_require__(458),
	    __webpack_require__(459),
	    __webpack_require__(460),
	    __webpack_require__(461)
	];
	
	Http.headers = {
	    put: jsonType,
	    post: jsonType,
	    patch: jsonType,
	    delete: jsonType,
	    common: {'Accept': 'application/json, text/plain, */*'},
	    custom: {'X-Requested-With': 'XMLHttpRequest'}
	};
	
	['get', 'put', 'post', 'patch', 'delete', 'jsonp'].forEach(function (method) {
	
	    Http[method] = function (url, data, success, options) {
	
	        if (_.isFunction(data)) {
	            options = success;
	            success = data;
	            data = undefined;
	        }
	
	        if (_.isObject(success)) {
	            options = success;
	            success = undefined;
	        }
	
	        return this(url, _.extend({method: method, data: data, success: success}, options));
	    };
	});
	
	module.exports = _.http = Http;


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Base client.
	 */
	
	var _ = __webpack_require__(441);
	var Promise = __webpack_require__(450);
	var xhrClient = __webpack_require__(452);
	
	module.exports = function (request) {
	
	    var response = (request.client || xhrClient)(request);
	
	    return Promise.resolve(response).then(function (response) {
	
	        if (response.headers) {
	
	            var headers = parseHeaders(response.headers);
	
	            response.headers = function (name) {
	
	                if (name) {
	                    return headers[_.toLower(name)];
	                }
	
	                return headers;
	            };
	
	        }
	
	        response.ok = response.status >= 200 && response.status < 300;
	
	        return response;
	    });
	
	};
	
	function parseHeaders(str) {
	
	    var headers = {}, value, name, i;
	
	    if (_.isString(str)) {
	        _.each(str.split('\n'), function (row) {
	
	            i = row.indexOf(':');
	            name = _.trim(_.toLower(row.slice(0, i)));
	            value = _.trim(row.slice(i + 1));
	
	            if (headers[name]) {
	
	                if (_.isArray(headers[name])) {
	                    headers[name].push(value);
	                } else {
	                    headers[name] = [headers[name], value];
	                }
	
	            } else {
	
	                headers[name] = value;
	            }
	
	        });
	    }
	
	    return headers;
	}


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Promise adapter.
	 */
	
	var _ = __webpack_require__(441);
	var PromiseObj = window.Promise || __webpack_require__(451);
	
	function Promise(executor, context) {
	
	    if (executor instanceof PromiseObj) {
	        this.promise = executor;
	    } else {
	        this.promise = new PromiseObj(executor.bind(context));
	    }
	
	    this.context = context;
	}
	
	Promise.all = function (iterable, context) {
	    return new Promise(PromiseObj.all(iterable), context);
	};
	
	Promise.resolve = function (value, context) {
	    return new Promise(PromiseObj.resolve(value), context);
	};
	
	Promise.reject = function (reason, context) {
	    return new Promise(PromiseObj.reject(reason), context);
	};
	
	Promise.race = function (iterable, context) {
	    return new Promise(PromiseObj.race(iterable), context);
	};
	
	var p = Promise.prototype;
	
	p.bind = function (context) {
	    this.context = context;
	    return this;
	};
	
	p.then = function (fulfilled, rejected) {
	
	    if (fulfilled && fulfilled.bind && this.context) {
	        fulfilled = fulfilled.bind(this.context);
	    }
	
	    if (rejected && rejected.bind && this.context) {
	        rejected = rejected.bind(this.context);
	    }
	
	    this.promise = this.promise.then(fulfilled, rejected);
	
	    return this;
	};
	
	p.catch = function (rejected) {
	
	    if (rejected && rejected.bind && this.context) {
	        rejected = rejected.bind(this.context);
	    }
	
	    this.promise = this.promise.catch(rejected);
	
	    return this;
	};
	
	p.finally = function (callback) {
	
	    return this.then(function (value) {
	            callback.call(this);
	            return value;
	        }, function (reason) {
	            callback.call(this);
	            return PromiseObj.reject(reason);
	        }
	    );
	};
	
	p.success = function (callback) {
	
	    _.warn('The `success` method has been deprecated. Use the `then` method instead.');
	
	    return this.then(function (response) {
	        return callback.call(this, response.data, response.status, response) || response;
	    });
	};
	
	p.error = function (callback) {
	
	    _.warn('The `error` method has been deprecated. Use the `catch` method instead.');
	
	    return this.catch(function (response) {
	        return callback.call(this, response.data, response.status, response) || response;
	    });
	};
	
	p.always = function (callback) {
	
	    _.warn('The `always` method has been deprecated. Use the `finally` method instead.');
	
	    var cb = function (response) {
	        return callback.call(this, response.data, response.status, response) || response;
	    };
	
	    return this.then(cb, cb);
	};
	
	module.exports = Promise;


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
	 */
	
	var _ = __webpack_require__(441);
	
	var RESOLVED = 0;
	var REJECTED = 1;
	var PENDING  = 2;
	
	function Promise(executor) {
	
	    this.state = PENDING;
	    this.value = undefined;
	    this.deferred = [];
	
	    var promise = this;
	
	    try {
	        executor(function (x) {
	            promise.resolve(x);
	        }, function (r) {
	            promise.reject(r);
	        });
	    } catch (e) {
	        promise.reject(e);
	    }
	}
	
	Promise.reject = function (r) {
	    return new Promise(function (resolve, reject) {
	        reject(r);
	    });
	};
	
	Promise.resolve = function (x) {
	    return new Promise(function (resolve, reject) {
	        resolve(x);
	    });
	};
	
	Promise.all = function all(iterable) {
	    return new Promise(function (resolve, reject) {
	        var count = 0, result = [];
	
	        if (iterable.length === 0) {
	            resolve(result);
	        }
	
	        function resolver(i) {
	            return function (x) {
	                result[i] = x;
	                count += 1;
	
	                if (count === iterable.length) {
	                    resolve(result);
	                }
	            };
	        }
	
	        for (var i = 0; i < iterable.length; i += 1) {
	            Promise.resolve(iterable[i]).then(resolver(i), reject);
	        }
	    });
	};
	
	Promise.race = function race(iterable) {
	    return new Promise(function (resolve, reject) {
	        for (var i = 0; i < iterable.length; i += 1) {
	            Promise.resolve(iterable[i]).then(resolve, reject);
	        }
	    });
	};
	
	var p = Promise.prototype;
	
	p.resolve = function resolve(x) {
	    var promise = this;
	
	    if (promise.state === PENDING) {
	        if (x === promise) {
	            throw new TypeError('Promise settled with itself.');
	        }
	
	        var called = false;
	
	        try {
	            var then = x && x['then'];
	
	            if (x !== null && typeof x === 'object' && typeof then === 'function') {
	                then.call(x, function (x) {
	                    if (!called) {
	                        promise.resolve(x);
	                    }
	                    called = true;
	
	                }, function (r) {
	                    if (!called) {
	                        promise.reject(r);
	                    }
	                    called = true;
	                });
	                return;
	            }
	        } catch (e) {
	            if (!called) {
	                promise.reject(e);
	            }
	            return;
	        }
	
	        promise.state = RESOLVED;
	        promise.value = x;
	        promise.notify();
	    }
	};
	
	p.reject = function reject(reason) {
	    var promise = this;
	
	    if (promise.state === PENDING) {
	        if (reason === promise) {
	            throw new TypeError('Promise settled with itself.');
	        }
	
	        promise.state = REJECTED;
	        promise.value = reason;
	        promise.notify();
	    }
	};
	
	p.notify = function notify() {
	    var promise = this;
	
	    _.nextTick(function () {
	        if (promise.state !== PENDING) {
	            while (promise.deferred.length) {
	                var deferred = promise.deferred.shift(),
	                    onResolved = deferred[0],
	                    onRejected = deferred[1],
	                    resolve = deferred[2],
	                    reject = deferred[3];
	
	                try {
	                    if (promise.state === RESOLVED) {
	                        if (typeof onResolved === 'function') {
	                            resolve(onResolved.call(undefined, promise.value));
	                        } else {
	                            resolve(promise.value);
	                        }
	                    } else if (promise.state === REJECTED) {
	                        if (typeof onRejected === 'function') {
	                            resolve(onRejected.call(undefined, promise.value));
	                        } else {
	                            reject(promise.value);
	                        }
	                    }
	                } catch (e) {
	                    reject(e);
	                }
	            }
	        }
	    });
	};
	
	p.then = function then(onResolved, onRejected) {
	    var promise = this;
	
	    return new Promise(function (resolve, reject) {
	        promise.deferred.push([onResolved, onRejected, resolve, reject]);
	        promise.notify();
	    });
	};
	
	p.catch = function (onRejected) {
	    return this.then(undefined, onRejected);
	};
	
	module.exports = Promise;


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * XMLHttp client.
	 */
	
	var _ = __webpack_require__(441);
	var Promise = __webpack_require__(450);
	
	module.exports = function (request) {
	    return new Promise(function (resolve) {
	
	        var xhr = new XMLHttpRequest(), response = {request: request}, handler;
	
	        request.cancel = function () {
	            xhr.abort();
	        };
	
	        xhr.open(request.method, _.url(request), true);
	
	        if (_.isPlainObject(request.xhr)) {
	            _.extend(xhr, request.xhr);
	        }
	
	        _.each(request.headers || {}, function (value, header) {
	            xhr.setRequestHeader(header, value);
	        });
	
	        handler = function (event) {
	
	            response.data = xhr.responseText;
	            response.status = xhr.status;
	            response.statusText = xhr.statusText;
	            response.headers = xhr.getAllResponseHeaders();
	
	            resolve(response);
	        };
	
	        xhr.onload = handler;
	        xhr.onabort = handler;
	        xhr.onerror = handler;
	
	        xhr.send(request.data);
	    });
	};


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Interceptor factory.
	 */
	
	var _ = __webpack_require__(441);
	var Promise = __webpack_require__(450);
	
	module.exports = function (handler, vm) {
	
	    return function (client) {
	
	        if (_.isFunction(handler)) {
	            handler = handler.call(vm, Promise);
	        }
	
	        return function (request) {
	
	            if (_.isFunction(handler.request)) {
	                request = handler.request.call(vm, request);
	            }
	
	            return when(request, function (request) {
	                return when(client(request), function (response) {
	
	                    if (_.isFunction(handler.response)) {
	                        response = handler.response.call(vm, response);
	                    }
	
	                    return response;
	                });
	            });
	        };
	    };
	};
	
	function when(value, fulfilled, rejected) {
	
	    var promise = Promise.resolve(value);
	
	    if (arguments.length < 2) {
	        return promise;
	    }
	
	    return promise.then(fulfilled, rejected);
	}


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Before Interceptor.
	 */
	
	var _ = __webpack_require__(441);
	
	module.exports = {
	
	    request: function (request) {
	
	        if (_.isFunction(request.beforeSend)) {
	            request.beforeSend.call(this, request);
	        }
	
	        return request;
	    }
	
	};


/***/ }),
/* 455 */
/***/ (function(module, exports) {

	/**
	 * Timeout Interceptor.
	 */
	
	module.exports = function () {
	
	    var timeout;
	
	    return {
	
	        request: function (request) {
	
	            if (request.timeout) {
	                timeout = setTimeout(function () {
	                    request.cancel();
	                }, request.timeout);
	            }
	
	            return request;
	        },
	
	        response: function (response) {
	
	            clearTimeout(timeout);
	
	            return response;
	        }
	
	    };
	};


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * JSONP Interceptor.
	 */
	
	var jsonpClient = __webpack_require__(457);
	
	module.exports = {
	
	    request: function (request) {
	
	        if (request.method == 'JSONP') {
	            request.client = jsonpClient;
	        }
	
	        return request;
	    }
	
	};


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * JSONP client.
	 */
	
	var _ = __webpack_require__(441);
	var Promise = __webpack_require__(450);
	
	module.exports = function (request) {
	    return new Promise(function (resolve) {
	
	        var callback = '_jsonp' + Math.random().toString(36).substr(2), response = {request: request, data: null}, handler, script;
	
	        request.params[request.jsonp] = callback;
	        request.cancel = function () {
	            handler({type: 'cancel'});
	        };
	
	        script = document.createElement('script');
	        script.src = _.url(request);
	        script.type = 'text/javascript';
	        script.async = true;
	
	        window[callback] = function (data) {
	            response.data = data;
	        };
	
	        handler = function (event) {
	
	            if (event.type === 'load' && response.data !== null) {
	                response.status = 200;
	            } else if (event.type === 'error') {
	                response.status = 404;
	            } else {
	                response.status = 0;
	            }
	
	            resolve(response);
	
	            delete window[callback];
	            document.body.removeChild(script);
	        };
	
	        script.onload = handler;
	        script.onerror = handler;
	
	        document.body.appendChild(script);
	    });
	};


/***/ }),
/* 458 */
/***/ (function(module, exports) {

	/**
	 * HTTP method override Interceptor.
	 */
	
	module.exports = {
	
	    request: function (request) {
	
	        if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
	            request.headers['X-HTTP-Method-Override'] = request.method;
	            request.method = 'POST';
	        }
	
	        return request;
	    }
	
	};


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Mime Interceptor.
	 */
	
	var _ = __webpack_require__(441);
	
	module.exports = {
	
	    request: function (request) {
	
	        if (request.emulateJSON && _.isPlainObject(request.data)) {
	            request.headers['Content-Type'] = 'application/x-www-form-urlencoded';
	            request.data = _.url.params(request.data);
	        }
	
	        if (_.isObject(request.data) && /FormData/i.test(request.data.toString())) {
	            delete request.headers['Content-Type'];
	        }
	
	        if (_.isPlainObject(request.data)) {
	            request.data = JSON.stringify(request.data);
	        }
	
	        return request;
	    },
	
	    response: function (response) {
	
	        try {
	            response.data = JSON.parse(response.data);
	        } catch (e) {}
	
	        return response;
	    }
	
	};


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Header Interceptor.
	 */
	
	var _ = __webpack_require__(441);
	
	module.exports = {
	
	    request: function (request) {
	
	        request.method = request.method.toUpperCase();
	        request.headers = _.extend({}, _.http.headers.common,
	            !request.crossOrigin ? _.http.headers.custom : {},
	            _.http.headers[request.method.toLowerCase()],
	            request.headers
	        );
	
	        if (_.isPlainObject(request.data) && /^(GET|JSONP)$/i.test(request.method)) {
	            _.extend(request.params, request.data);
	            delete request.data;
	        }
	
	        return request;
	    }
	
	};


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * CORS Interceptor.
	 */
	
	var _ = __webpack_require__(441);
	var xdrClient = __webpack_require__(462);
	var xhrCors = 'withCredentials' in new XMLHttpRequest();
	var originUrl = _.url.parse(location.href);
	
	module.exports = {
	
	    request: function (request) {
	
	        if (request.crossOrigin === null) {
	            request.crossOrigin = crossOrigin(request);
	        }
	
	        if (request.crossOrigin) {
	
	            if (!xhrCors) {
	                request.client = xdrClient;
	            }
	
	            request.emulateHTTP = false;
	        }
	
	        return request;
	    }
	
	};
	
	function crossOrigin(request) {
	
	    var requestUrl = _.url.parse(_.url(request));
	
	    return (requestUrl.protocol !== originUrl.protocol || requestUrl.host !== originUrl.host);
	}


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * XDomain client (Internet Explorer).
	 */
	
	var _ = __webpack_require__(441);
	var Promise = __webpack_require__(450);
	
	module.exports = function (request) {
	    return new Promise(function (resolve) {
	
	        var xdr = new XDomainRequest(), response = {request: request}, handler;
	
	        request.cancel = function () {
	            xdr.abort();
	        };
	
	        xdr.open(request.method, _.url(request), true);
	
	        handler = function (event) {
	
	            response.data = xdr.responseText;
	            response.status = xdr.status;
	            response.statusText = xdr.statusText;
	
	            resolve(response);
	        };
	
	        xdr.timeout = 0;
	        xdr.onload = handler;
	        xdr.onabort = handler;
	        xdr.onerror = handler;
	        xdr.ontimeout = function () {};
	        xdr.onprogress = function () {};
	
	        xdr.send(request.data);
	    });
	};


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Service for interacting with RESTful services.
	 */
	
	var _ = __webpack_require__(441);
	
	function Resource(url, params, actions, options) {
	
	    var self = this, resource = {};
	
	    actions = _.extend({},
	        Resource.actions,
	        actions
	    );
	
	    _.each(actions, function (action, name) {
	
	        action = _.merge({url: url, params: params || {}}, options, action);
	
	        resource[name] = function () {
	            return (self.$http || _.http)(opts(action, arguments));
	        };
	    });
	
	    return resource;
	}
	
	function opts(action, args) {
	
	    var options = _.extend({}, action), params = {}, data, success, error;
	
	    switch (args.length) {
	
	        case 4:
	
	            error = args[3];
	            success = args[2];
	
	        case 3:
	        case 2:
	
	            if (_.isFunction(args[1])) {
	
	                if (_.isFunction(args[0])) {
	
	                    success = args[0];
	                    error = args[1];
	
	                    break;
	                }
	
	                success = args[1];
	                error = args[2];
	
	            } else {
	
	                params = args[0];
	                data = args[1];
	                success = args[2];
	
	                break;
	            }
	
	        case 1:
	
	            if (_.isFunction(args[0])) {
	                success = args[0];
	            } else if (/^(POST|PUT|PATCH)$/i.test(options.method)) {
	                data = args[0];
	            } else {
	                params = args[0];
	            }
	
	            break;
	
	        case 0:
	
	            break;
	
	        default:
	
	            throw 'Expected up to 4 arguments [params, data, success, error], got ' + args.length + ' arguments';
	    }
	
	    options.data = data;
	    options.params = _.extend({}, options.params, params);
	
	    if (success) {
	        options.success = success;
	    }
	
	    if (error) {
	        options.error = error;
	    }
	
	    return options;
	}
	
	Resource.actions = {
	
	    get: {method: 'GET'},
	    save: {method: 'POST'},
	    query: {method: 'GET'},
	    update: {method: 'PUT'},
	    remove: {method: 'DELETE'},
	    delete: {method: 'DELETE'}
	
	};
	
	module.exports = _.resource = Resource;


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _moment = __webpack_require__(465);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function plugin(Vue) {
	    if (Vue && Vue.filter) {
	
	        // filter to limit content to 100 strs
	        Vue.filter('cut', function (value) {
	            return value.length >= 100 ? value.substring(0, 100) + '...' : value;
	        });
	
	        Vue.filter('cut_len', function (value, ilen) {
	            if (!value) {
	                return '';
	            }
	            return value.length > ilen ? value.substring(0, ilen) + '...' : value;
	        });
	
	        // format date from iso8601 string
	        Vue.filter('formatDateByIso', function (value) {
	            return value && (0, _moment2.default)(value).format('YYYY-MM-DD HH:mm:ss');
	        });
	
	        Vue.filter('addtime', function (value, type) {
	            return value && value + (!type ? ' 00:00:00' : ' 24:00:00');
	        });
	
	        // format price 22 => 22.00
	        Vue.filter('priceformat', function (value) {
	            return Number(value).toFixed(2);
	        });
	
	        Vue.filter("url", function (value) {
	            if (arguments.length > 1) {
	                var reg = /\/$/;
	                if (reg.test(value) == false) {
	                    value = value + "/";
	                }
	                var url = value;
	                var ilen = arguments.length;
	                for (var i = 1; i < ilen; i++) {
	                    if (i < ilen - 1) {
	                        url += arguments[i] + "/";
	                    } else {
	                        url += arguments[i];
	                    }
	                }
	                return url;
	            }
	            return value;
	        });
	
	        Vue.filter("truncatechars", function (value, count) {
	            var str = value;
	            var reg = /[^\u0000-\u00ff]/;
	            var resStr = "";
	            var resCount = 0;
	            if (!count || str.length <= count) {
	                return str;
	            }
	            for (var i = 0; i < str.length; i++) {
	                var iStr = str[i];
	                if (reg.test(iStr)) {
	                    resCount += 1;
	                } else {
	                    resCount += 0.5;
	                }
	                resStr += iStr;
	                if (resCount >= count) {
	                    return resStr + '...';
	                }
	            }
	            return str;
	        });
	
	        Vue.filter("date", function (value, format_s) {
	            if (format_s == "H:i Y-m-d") {
	                return value && (0, _moment2.default)(value).format('HH:mm YYYY-MM-DD');
	            } else if (format_s) {
	                return value && (0, _moment2.default)(value).format(format_s);
	            }
	            return value;
	        });
	        Vue.filter("time", function (value, format_s) {
	            if (format_s == "H:i") {
	                return value && (0, _moment2.default)(value).format('HH:mm');
	            } else if (format_s) {
	                return value && (0, _moment2.default)(value).format(format_s);
	            }
	            return value;
	        });
	
	        // 问答详情页(qaitem.vue)过滤函数：将数组arr1(教师的回答)中出
	        // 现的arr2(已经偷看过的回答)中的相同id的元素去除后返回
	        Vue.filter("yankOut", function (arr1, arr2) {
	            var tempArr = [];
	            for (var i = 0; i < arr1.length; i++) {
	                tempArr.push(arr1[i].id);
	            };
	            for (var _i = 0; _i < arr2.length; _i++) {
	                var j = tempArr.indexOf(arr2[_i]);
	                if (j > -1) {
	                    arr1.splice(j, 1);
	                }
	            };
	            return arr1;
	        });
	
	        Vue.filter("scorepreci", function (score, defaultStr) {
	            if (+score) {
	                return (score / 100).toFixed(1).replace(/\.0$/, '');
	            }
	            return defaultStr || score;
	        });
	    }
	}
	
	if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	        return plugin;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	exports.default = plugin;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.29.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m),
	                parsedParts = some.call(flags.parsedDateParts, function (i) {
	                    return i != null;
	                }),
	                isNowValid =
	                    !isNaN(m._d.getTime()) &&
	                    flags.overflow < 0 &&
	                    !flags.empty &&
	                    !flags.invalidEra &&
	                    !flags.invalidMonth &&
	                    !flags.invalidWeekday &&
	                    !flags.weekdayMismatch &&
	                    !flags.nullInput &&
	                    !flags.invalidFormat &&
	                    !flags.userInvalidated &&
	                    (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            } else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key;
	                for (i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias(unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        return mom.isValid()
	            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
	            : NaN;
	    }
	
	    function set$1(mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (
	                unit === 'FullYear' &&
	                isLeapYear(mom.year()) &&
	                mom.month() === 1 &&
	                mom.date() === 29
	            ) {
	                value = toInt(value);
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
	                    value,
	                    mom.month(),
	                    daysInMonth(value, mom.month())
	                );
	            } else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i;
	            for (i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
	                    matched,
	                    p1,
	                    p2,
	                    p3,
	                    p4
	                ) {
	                    return p1 || p2 || p3 || p4;
	                })
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M', match1to2);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
	            '_'
	        ),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w', match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
	        input,
	        week,
	        config,
	        token
	    ) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	            ? weekdays[m.day()]
	            : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	            ? this._weekdaysShort[m.day()]
	            : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	            ? this._weekdaysMin[m.day()]
	            : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2);
	    addRegexToken('h', match1to2);
	    addRegexToken('k', match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(467)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                    ? DATE
	                    : a[HOUR] < 0 ||
	                      a[HOUR] > 24 ||
	                      (a[HOUR] === 24 &&
	                          (a[MINUTE] !== 0 ||
	                              a[SECOND] !== 0 ||
	                              a[MILLISECOND] !== 0))
	                    ? HOUR
	                    : a[MINUTE] < 0 || a[MINUTE] > 59
	                    ? MINUTE
	                    : a[SECOND] < 0 || a[SECOND] > 59
	                    ? SECOND
	                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                    ? MILLISECOND
	                    : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^)]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	            ? 'lastWeek'
	            : diff < 0
	            ? 'lastDay'
	            : diff < 1
	            ? 'sameDay'
	            : diff < 2
	            ? 'nextDay'
	            : diff < 7
	            ? 'nextWeek'
	            : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
	        input,
	        array,
	        config,
	        token
	    ) {
	        var era = config._locale.erasParse(input, token, config._strict);
	        if (era) {
	            getParsingFlags(config).era = era;
	        } else {
	            getParsingFlags(config).invalidEra = input;
	        }
	    });
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            namePieces.push(regexEscape(eras[i].name));
	            abbrPieces.push(regexEscape(eras[i].abbr));
	            narrowPieces.push(regexEscape(eras[i].narrow));
	
	            mixedPieces.push(regexEscape(eras[i].name));
	            mixedPieces.push(regexEscape(eras[i].abbr));
	            mixedPieces.push(regexEscape(eras[i].narrow));
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
	        input,
	        week,
	        config,
	        token
	    ) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D', match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m', match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s', match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1() {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y');
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.29.1';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(466)(module)))

/***/ }),
/* 466 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 468,
		"./af.js": 468,
		"./ar": 469,
		"./ar-dz": 470,
		"./ar-dz.js": 470,
		"./ar-kw": 471,
		"./ar-kw.js": 471,
		"./ar-ly": 472,
		"./ar-ly.js": 472,
		"./ar-ma": 473,
		"./ar-ma.js": 473,
		"./ar-sa": 474,
		"./ar-sa.js": 474,
		"./ar-tn": 475,
		"./ar-tn.js": 475,
		"./ar.js": 469,
		"./az": 476,
		"./az.js": 476,
		"./be": 477,
		"./be.js": 477,
		"./bg": 478,
		"./bg.js": 478,
		"./bm": 479,
		"./bm.js": 479,
		"./bn": 480,
		"./bn-bd": 481,
		"./bn-bd.js": 481,
		"./bn.js": 480,
		"./bo": 482,
		"./bo.js": 482,
		"./br": 483,
		"./br.js": 483,
		"./bs": 484,
		"./bs.js": 484,
		"./ca": 485,
		"./ca.js": 485,
		"./cs": 486,
		"./cs.js": 486,
		"./cv": 487,
		"./cv.js": 487,
		"./cy": 488,
		"./cy.js": 488,
		"./da": 489,
		"./da.js": 489,
		"./de": 490,
		"./de-at": 491,
		"./de-at.js": 491,
		"./de-ch": 492,
		"./de-ch.js": 492,
		"./de.js": 490,
		"./dv": 493,
		"./dv.js": 493,
		"./el": 494,
		"./el.js": 494,
		"./en-au": 495,
		"./en-au.js": 495,
		"./en-ca": 496,
		"./en-ca.js": 496,
		"./en-gb": 497,
		"./en-gb.js": 497,
		"./en-ie": 498,
		"./en-ie.js": 498,
		"./en-il": 499,
		"./en-il.js": 499,
		"./en-in": 500,
		"./en-in.js": 500,
		"./en-nz": 501,
		"./en-nz.js": 501,
		"./en-sg": 502,
		"./en-sg.js": 502,
		"./eo": 503,
		"./eo.js": 503,
		"./es": 504,
		"./es-do": 505,
		"./es-do.js": 505,
		"./es-mx": 506,
		"./es-mx.js": 506,
		"./es-us": 507,
		"./es-us.js": 507,
		"./es.js": 504,
		"./et": 508,
		"./et.js": 508,
		"./eu": 509,
		"./eu.js": 509,
		"./fa": 510,
		"./fa.js": 510,
		"./fi": 511,
		"./fi.js": 511,
		"./fil": 512,
		"./fil.js": 512,
		"./fo": 513,
		"./fo.js": 513,
		"./fr": 514,
		"./fr-ca": 515,
		"./fr-ca.js": 515,
		"./fr-ch": 516,
		"./fr-ch.js": 516,
		"./fr.js": 514,
		"./fy": 517,
		"./fy.js": 517,
		"./ga": 518,
		"./ga.js": 518,
		"./gd": 519,
		"./gd.js": 519,
		"./gl": 520,
		"./gl.js": 520,
		"./gom-deva": 521,
		"./gom-deva.js": 521,
		"./gom-latn": 522,
		"./gom-latn.js": 522,
		"./gu": 523,
		"./gu.js": 523,
		"./he": 524,
		"./he.js": 524,
		"./hi": 525,
		"./hi.js": 525,
		"./hr": 526,
		"./hr.js": 526,
		"./hu": 527,
		"./hu.js": 527,
		"./hy-am": 528,
		"./hy-am.js": 528,
		"./id": 529,
		"./id.js": 529,
		"./is": 530,
		"./is.js": 530,
		"./it": 531,
		"./it-ch": 532,
		"./it-ch.js": 532,
		"./it.js": 531,
		"./ja": 533,
		"./ja.js": 533,
		"./jv": 534,
		"./jv.js": 534,
		"./ka": 535,
		"./ka.js": 535,
		"./kk": 536,
		"./kk.js": 536,
		"./km": 537,
		"./km.js": 537,
		"./kn": 538,
		"./kn.js": 538,
		"./ko": 539,
		"./ko.js": 539,
		"./ku": 540,
		"./ku.js": 540,
		"./ky": 541,
		"./ky.js": 541,
		"./lb": 542,
		"./lb.js": 542,
		"./lo": 543,
		"./lo.js": 543,
		"./lt": 544,
		"./lt.js": 544,
		"./lv": 545,
		"./lv.js": 545,
		"./me": 546,
		"./me.js": 546,
		"./mi": 547,
		"./mi.js": 547,
		"./mk": 548,
		"./mk.js": 548,
		"./ml": 549,
		"./ml.js": 549,
		"./mn": 550,
		"./mn.js": 550,
		"./mr": 551,
		"./mr.js": 551,
		"./ms": 552,
		"./ms-my": 553,
		"./ms-my.js": 553,
		"./ms.js": 552,
		"./mt": 554,
		"./mt.js": 554,
		"./my": 555,
		"./my.js": 555,
		"./nb": 556,
		"./nb.js": 556,
		"./ne": 557,
		"./ne.js": 557,
		"./nl": 558,
		"./nl-be": 559,
		"./nl-be.js": 559,
		"./nl.js": 558,
		"./nn": 560,
		"./nn.js": 560,
		"./oc-lnc": 561,
		"./oc-lnc.js": 561,
		"./pa-in": 562,
		"./pa-in.js": 562,
		"./pl": 563,
		"./pl.js": 563,
		"./pt": 564,
		"./pt-br": 565,
		"./pt-br.js": 565,
		"./pt.js": 564,
		"./ro": 566,
		"./ro.js": 566,
		"./ru": 567,
		"./ru.js": 567,
		"./sd": 568,
		"./sd.js": 568,
		"./se": 569,
		"./se.js": 569,
		"./si": 570,
		"./si.js": 570,
		"./sk": 571,
		"./sk.js": 571,
		"./sl": 572,
		"./sl.js": 572,
		"./sq": 573,
		"./sq.js": 573,
		"./sr": 574,
		"./sr-cyrl": 575,
		"./sr-cyrl.js": 575,
		"./sr.js": 574,
		"./ss": 576,
		"./ss.js": 576,
		"./sv": 577,
		"./sv.js": 577,
		"./sw": 578,
		"./sw.js": 578,
		"./ta": 579,
		"./ta.js": 579,
		"./te": 580,
		"./te.js": 580,
		"./tet": 581,
		"./tet.js": 581,
		"./tg": 582,
		"./tg.js": 582,
		"./th": 583,
		"./th.js": 583,
		"./tk": 584,
		"./tk.js": 584,
		"./tl-ph": 585,
		"./tl-ph.js": 585,
		"./tlh": 586,
		"./tlh.js": 586,
		"./tr": 587,
		"./tr.js": 587,
		"./tzl": 588,
		"./tzl.js": 588,
		"./tzm": 589,
		"./tzm-latn": 590,
		"./tzm-latn.js": 590,
		"./tzm.js": 589,
		"./ug-cn": 591,
		"./ug-cn.js": 591,
		"./uk": 592,
		"./uk.js": 592,
		"./ur": 593,
		"./ur.js": 593,
		"./uz": 594,
		"./uz-latn": 595,
		"./uz-latn.js": 595,
		"./uz.js": 594,
		"./vi": 596,
		"./vi.js": 596,
		"./x-pseudo": 597,
		"./x-pseudo.js": 597,
		"./yo": 598,
		"./yo.js": 598,
		"./zh-cn": 599,
		"./zh-cn.js": 599,
		"./zh-hk": 600,
		"./zh-hk.js": 600,
		"./zh-mo": 601,
		"./zh-mo.js": 601,
		"./zh-tw": 602,
		"./zh-tw.js": 602
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 467;


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var af = moment.defineLocale('af', {
	        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM: function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Vandag om] LT',
	            nextDay: '[Môre om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[Gister om] LT',
	            lastWeek: '[Laas] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oor %s',
	            past: '%s gelede',
	            s: "'n paar sekondes",
	            ss: '%d sekondes',
	            m: "'n minuut",
	            mm: '%d minute',
	            h: "'n uur",
	            hh: '%d ure',
	            d: "'n dag",
	            dd: '%d dae',
	            M: "'n maand",
	            MM: '%d maande',
	            y: "'n jaar",
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            ); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week: {
	            dow: 1, // Maandag is die eerste dag van die week.
	            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        },
	    });
	
	    return af;
	
	})));


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var ar = moment.defineLocale('ar', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ar;
	
	})));


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Amine Roukh: https://github.com/Amine27
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'جانفي',
	            'فيفري',
	            'مارس',
	            'أفريل',
	            'ماي',
	            'جوان',
	            'جويلية',
	            'أوت',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arDz;
	
	})));


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arKw;
	
	})));


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '1',
	            2: '2',
	            3: '3',
	            4: '4',
	            5: '5',
	            6: '6',
	            7: '7',
	            8: '8',
	            9: '9',
	            0: '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arLy;
	
	})));


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arMa;
	
	})));


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arSa;
	
	})));


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arTn;
	
	})));


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı',
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays: 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
	            '_'
	        ),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'bir neçə saniyə',
	            ss: '%d saniyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il',
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function (number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = (number % 100) - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return az;
	
	})));


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            dd: 'дзень_дні_дзён',
	            MM: 'месяц_месяцы_месяцаў',
	            yy: 'год_гады_гадоў',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months: {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
	                '_'
	            ),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split(
	            '_'
	        ),
	        weekdays: {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
	                '_'
	            ),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
	        },
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) &&
	                        number % 100 !== 12 &&
	                        number % 100 !== 13
	                        ? number + '-і'
	                        : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return be;
	
	})));


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bg = moment.defineLocale('bg', {
	        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Днес в] LT',
	            nextDay: '[Утре в] LT',
	            nextWeek: 'dddd [в] LT',
	            lastDay: '[Вчера в] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Миналата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Миналия] dddd [в] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'след %s',
	            past: 'преди %s',
	            s: 'няколко секунди',
	            ss: '%d секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дена',
	            w: 'седмица',
	            ww: '%d седмици',
	            M: 'месец',
	            MM: '%d месеца',
	            y: 'година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bg;
	
	})));


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bm = moment.defineLocale('bm', {
	        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
	            '_'
	        ),
	        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'MMMM [tile] D [san] YYYY',
	            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bi lɛrɛ] LT',
	            nextDay: '[Sini lɛrɛ] LT',
	            nextWeek: 'dddd [don lɛrɛ] LT',
	            lastDay: '[Kunu lɛrɛ] LT',
	            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s kɔnɔ',
	            past: 'a bɛ %s bɔ',
	            s: 'sanga dama dama',
	            ss: 'sekondi %d',
	            m: 'miniti kelen',
	            mm: 'miniti %d',
	            h: 'lɛrɛ kelen',
	            hh: 'lɛrɛ %d',
	            d: 'tile kelen',
	            dd: 'tile %d',
	            M: 'kalo kelen',
	            MM: 'kalo %d',
	            y: 'san kelen',
	            yy: 'san %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return bm;
	
	})));


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	            '_'
	        ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bn;
	
	})));


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali (Bangladesh) [bn-bd]
	//! author : Asraf Hossain Patoary : https://github.com/ashwoolford
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bnBd = moment.defineLocale('bn-bd', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	            '_'
	        ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	
	        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'রাত') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ভোর') {
	                return hour;
	            } else if (meridiem === 'সকাল') {
	                return hour;
	            } else if (meridiem === 'দুপুর') {
	                return hour >= 3 ? hour : hour + 12;
	            } else if (meridiem === 'বিকাল') {
	                return hour + 12;
	            } else if (meridiem === 'সন্ধ্যা') {
	                return hour + 12;
	            }
	        },
	
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 6) {
	                return 'ভোর';
	            } else if (hour < 12) {
	                return 'সকাল';
	            } else if (hour < 15) {
	                return 'দুপুর';
	            } else if (hour < 18) {
	                return 'বিকাল';
	            } else if (hour < 20) {
	                return 'সন্ধ্যা';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bnBd;
	
	})));


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '༡',
	            2: '༢',
	            3: '༣',
	            4: '༤',
	            5: '༥',
	            6: '༦',
	            7: '༧',
	            8: '༨',
	            9: '༩',
	            0: '༠',
	        },
	        numberMap = {
	            '༡': '1',
	            '༢': '2',
	            '༣': '3',
	            '༤': '4',
	            '༥': '5',
	            '༦': '6',
	            '༧': '7',
	            '༨': '8',
	            '༩': '9',
	            '༠': '0',
	        };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
	            '_'
	        ),
	        monthsShort: 'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
	            '_'
	        ),
	        monthsShortRegex: /^(ཟླ་\d{1,2})/,
	        monthsParseExact: true,
	        weekdays: 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            ss: '%d སྐར་ཆ།',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ',
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bo;
	
	})));


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            mm: 'munutenn',
	            MM: 'miz',
	            dd: 'devezh',
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            m: 'v',
	            b: 'v',
	            d: 'z',
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var monthsParse = [
	            /^gen/i,
	            /^c[ʼ\']hwe/i,
	            /^meu/i,
	            /^ebr/i,
	            /^mae/i,
	            /^(mez|eve)/i,
	            /^gou/i,
	            /^eos/i,
	            /^gwe/i,
	            /^her/i,
	            /^du/i,
	            /^ker/i,
	        ],
	        monthsRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        monthsStrictRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
	        monthsShortStrictRegex = /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        fullWeekdaysParse = [
	            /^sul/i,
	            /^lun/i,
	            /^meurzh/i,
	            /^merc[ʼ\']her/i,
	            /^yaou/i,
	            /^gwener/i,
	            /^sadorn/i,
	        ],
	        shortWeekdaysParse = [
	            /^Sul/i,
	            /^Lun/i,
	            /^Meu/i,
	            /^Mer/i,
	            /^Yao/i,
	            /^Gwe/i,
	            /^Sad/i,
	        ],
	        minWeekdaysParse = [
	            /^Su/i,
	            /^Lu/i,
	            /^Me([^r]|$)/i,
	            /^Mer/i,
	            /^Ya/i,
	            /^Gw/i,
	            /^Sa/i,
	        ];
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
	            '_'
	        ),
	        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParse: minWeekdaysParse,
	        fullWeekdaysParse: fullWeekdaysParse,
	        shortWeekdaysParse: shortWeekdaysParse,
	        minWeekdaysParse: minWeekdaysParse,
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warcʼhoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Decʼh da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s ʼzo',
	            s: 'un nebeud segondennoù',
	            ss: '%d eilenn',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
	        isPM: function (token) {
	            return token === 'g.m.';
	        },
	        meridiem: function (hour, minute, isLower) {
	            return hour < 12 ? 'a.m.' : 'g.m.';
	        },
	    });
	
	    return br;
	
	})));


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bs;
	
	})));


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ca = moment.defineLocale('ca', {
	        months: {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
	                '_'
	            ),
	            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort: 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a les] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function () {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function () {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [passat a ' +
	                    (this.hours() !== 1 ? 'les' : 'la') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'uns segons',
	            ss: '%d segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ca;
	
	})));


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
	            '_'
	        ),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
	        monthsParse = [
	            /^led/i,
	            /^úno/i,
	            /^bře/i,
	            /^dub/i,
	            /^kvě/i,
	            /^(čvn|červen$|června)/i,
	            /^(čvc|červenec|července)/i,
	            /^srp/i,
	            /^zář/i,
	            /^říj/i,
	            /^lis/i,
	            /^pro/i,
	        ],
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex: /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex: /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	            l: 'D. M. YYYY',
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cs;
	
	})));


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
	            '_'
	        ),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays: 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
	            '_'
	        ),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (output) {
	                var affix = /сехет$/i.exec(output)
	                    ? 'рен'
	                    : /ҫул$/i.exec(output)
	                    ? 'тан'
	                    : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            ss: '%d ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return cv;
	
	})));


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
	            '_'
	        ),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
	            '_'
	        ),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact: true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '',
	                    'af',
	                    'il',
	                    'ydd',
	                    'ydd',
	                    'ed',
	                    'ed',
	                    'ed',
	                    'fed',
	                    'fed',
	                    'fed', // 1af to 10fed
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'fed', // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cy;
	
	})));


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var da = moment.defineLocale('da', {
	        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'på dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[i] dddd[s kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'få sekunder',
	            ss: '%d sekunder',
	            m: 'et minut',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dage',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'et år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return da;
	
	})));


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return de;
	
	})));


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deAt;
	
	})));


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deCh;
	
	})));


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'ޖެނުއަރީ',
	            'ފެބްރުއަރީ',
	            'މާރިޗު',
	            'އޭޕްރީލު',
	            'މޭ',
	            'ޖޫން',
	            'ޖުލައި',
	            'އޯގަސްޓު',
	            'ސެޕްޓެމްބަރު',
	            'އޮކްޓޯބަރު',
	            'ނޮވެމްބަރު',
	            'ޑިސެމްބަރު',
	        ],
	        weekdays = [
	            'އާދިއްތަ',
	            'ހޯމަ',
	            'އަންގާރަ',
	            'ބުދަ',
	            'ބުރާސްފަތި',
	            'ހުކުރު',
	            'ހޮނިހިރު',
	        ];
	
	    var dv = moment.defineLocale('dv', {
	        months: months,
	        monthsShort: months,
	        weekdays: weekdays,
	        weekdaysShort: weekdays,
	        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/M/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM: function (input) {
	            return 'މފ' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar: {
	            sameDay: '[މިއަދު] LT',
	            nextDay: '[މާދަމާ] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[އިއްޔެ] LT',
	            lastWeek: '[ފާއިތުވި] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ތެރޭގައި %s',
	            past: 'ކުރިން %s',
	            s: 'ސިކުންތުކޮޅެއް',
	            ss: 'd% ސިކުންތު',
	            m: 'މިނިޓެއް',
	            mm: 'މިނިޓު %d',
	            h: 'ގަޑިއިރެއް',
	            hh: 'ގަޑިއިރު %d',
	            d: 'ދުވަހެއް',
	            dd: 'ދުވަސް %d',
	            M: 'މަހެއް',
	            MM: 'މަސް %d',
	            y: 'އަހަރެއް',
	            yy: 'އަހަރު %d',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 7, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return dv;
	
	})));


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl: 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
	            '_'
	        ),
	        monthsGenitiveEl: 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
	            '_'
	        ),
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (
	                typeof format === 'string' &&
	                /D/.test(format.substring(0, format.indexOf('MMMM')))
	            ) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
	            '_'
	        ),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function (input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        calendar: function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            ss: '%d δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4st is the first week of the year.
	        },
	    });
	
	    return el;
	
	})));


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enAu;
	
	})));


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Israel) [en-il]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIl = moment.defineLocale('en-il', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enIl;
	
	})));


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (India) [en-in]
	//! author : Jatin Agrawal : https://github.com/jatinag22
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIn = moment.defineLocale('en-in', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return enIn;
	
	})));


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enNz;
	
	})));


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Singapore) [en-sg]
	//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enSg = moment.defineLocale('en-sg', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enSg;
	
	})));


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	//! comment : Vivakvo corrected the translation by colindean and miestasmia
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eo = moment.defineLocale('eo', {
	        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
	        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: '[la] D[-an de] MMMM, YYYY',
	            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
	            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
	            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar: {
	            sameDay: '[Hodiaŭ je] LT',
	            nextDay: '[Morgaŭ je] LT',
	            nextWeek: 'dddd[n je] LT',
	            lastDay: '[Hieraŭ je] LT',
	            lastWeek: '[pasintan] dddd[n je] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'post %s',
	            past: 'antaŭ %s',
	            s: 'kelkaj sekundoj',
	            ss: '%d sekundoj',
	            m: 'unu minuto',
	            mm: '%d minutoj',
	            h: 'unu horo',
	            hh: '%d horoj',
	            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
	            dd: '%d tagoj',
	            M: 'unu monato',
	            MM: '%d monatoj',
	            y: 'unu jaro',
	            yy: '%d jaroj',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal: '%da',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eo;
	
	})));


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return es;
	
	})));


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return esDo;
	
	})));


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Mexico) [es-mx]
	//! author : JC Franco : https://github.com/jcfranco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esMx = moment.defineLocale('es-mx', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return esMx;
	
	})));


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	//! author : chrisrodz : https://github.com/chrisrodz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'MM/DD/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return esUs;
	
	})));


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            ss: [number + 'sekundi', number + 'sekundit'],
	            m: ['ühe minuti', 'üks minut'],
	            mm: [number + ' minuti', number + ' minutit'],
	            h: ['ühe tunni', 'tund aega', 'üks tund'],
	            hh: [number + ' tunni', number + ' tundi'],
	            d: ['ühe päeva', 'üks päev'],
	            M: ['kuu aja', 'kuu aega', 'üks kuu'],
	            MM: [number + ' kuu', number + ' kuud'],
	            y: ['ühe aasta', 'aasta', 'üks aasta'],
	            yy: [number + ' aasta', number + ' aastat'],
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
	            '_'
	        ),
	        monthsShort: 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split(
	            '_'
	        ),
	        weekdays: 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
	            '_'
	        ),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return et;
	
	})));


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
	            '_'
	        ),
	        monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
	            '_'
	        ),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            ss: '%d segundo',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eu;
	
	})));


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '۱',
	            2: '۲',
	            3: '۳',
	            4: '۴',
	            5: '۵',
	            6: '۶',
	            7: '۷',
	            8: '۸',
	            9: '۹',
	            0: '۰',
	        },
	        numberMap = {
	            '۱': '1',
	            '۲': '2',
	            '۳': '3',
	            '۴': '4',
	            '۵': '5',
	            '۶': '6',
	            '۷': '7',
	            '۸': '8',
	            '۹': '9',
	            '۰': '0',
	        };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        monthsShort: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        weekdays: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	            '_'
	        ),
	        weekdaysShort: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	            '_'
	        ),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چند ثانیه',
	            ss: '%d ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[۰-۹]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return fa;
	
	})));


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
	            ' '
	        ),
	        numbersFuture = [
	            'nolla',
	            'yhden',
	            'kahden',
	            'kolmen',
	            'neljän',
	            'viiden',
	            'kuuden',
	            numbersPast[7],
	            numbersPast[8],
	            numbersPast[9],
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                result = isFuture ? 'sekunnin' : 'sekuntia';
	                break;
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10
	            ? isFuture
	                ? numbersFuture[number]
	                : numbersPast[number]
	            : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
	            '_'
	        ),
	        monthsShort: 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
	            '_'
	        ),
	        weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
	            '_'
	        ),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fi;
	
	})));


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Filipino [fil]
	//! author : Dan Hagman : https://github.com/hagmandan
	//! author : Matthew Co : https://github.com/matthewdeeco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fil = moment.defineLocale('fil', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fil;
	
	})));


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	//! author : Kristian Sakarisson : https://github.com/sakarisson
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays: 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
	            '_'
	        ),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            ss: '%d sekundir',
	            m: 'ein minuttur',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaður',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fo;
	
	})));


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsStrictRegex = /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsShortStrictRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
	        monthsRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsParse = [
	            /^janv/i,
	            /^févr/i,
	            /^mars/i,
	            /^avr/i,
	            /^mai/i,
	            /^juin/i,
	            /^juil/i,
	            /^août/i,
	            /^sept/i,
	            /^oct/i,
	            /^nov/i,
	            /^déc/i,
	        ];
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            w: 'une semaine',
	            ww: '%d semaines',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	    });
	
	    return frCa;
	
	})));


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return frCh;
	
	})));


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split(
	            '_'
	        );
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
	            '_'
	        ),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            ss: '%d sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fy;
	
	})));


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Irish or Irish Gaelic [ga]
	//! author : André Silva : https://github.com/askpt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Eanáir',
	            'Feabhra',
	            'Márta',
	            'Aibreán',
	            'Bealtaine',
	            'Meitheamh',
	            'Iúil',
	            'Lúnasa',
	            'Meán Fómhair',
	            'Deireadh Fómhair',
	            'Samhain',
	            'Nollaig',
	        ],
	        monthsShort = [
	            'Ean',
	            'Feabh',
	            'Márt',
	            'Aib',
	            'Beal',
	            'Meith',
	            'Iúil',
	            'Lún',
	            'M.F.',
	            'D.F.',
	            'Samh',
	            'Noll',
	        ],
	        weekdays = [
	            'Dé Domhnaigh',
	            'Dé Luain',
	            'Dé Máirt',
	            'Dé Céadaoin',
	            'Déardaoin',
	            'Dé hAoine',
	            'Dé Sathairn',
	        ],
	        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
	        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné ag] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d míonna',
	            y: 'bliain',
	            yy: '%d bliain',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ga;
	
	})));


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Am Faoilleach',
	            'An Gearran',
	            'Am Màrt',
	            'An Giblean',
	            'An Cèitean',
	            'An t-Ògmhios',
	            'An t-Iuchar',
	            'An Lùnastal',
	            'An t-Sultain',
	            'An Dàmhair',
	            'An t-Samhain',
	            'An Dùbhlachd',
	        ],
	        monthsShort = [
	            'Faoi',
	            'Gear',
	            'Màrt',
	            'Gibl',
	            'Cèit',
	            'Ògmh',
	            'Iuch',
	            'Lùn',
	            'Sult',
	            'Dàmh',
	            'Samh',
	            'Dùbh',
	        ],
	        weekdays = [
	            'Didòmhnaich',
	            'Diluain',
	            'Dimàirt',
	            'Diciadain',
	            'Diardaoin',
	            'Dihaoine',
	            'Disathairne',
	        ],
	        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
	        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[An-diugh aig] LT',
	            nextDay: '[A-màireach aig] LT',
	            nextWeek: 'dddd [aig] LT',
	            lastDay: '[An-dè aig] LT',
	            lastWeek: 'dddd [seo chaidh] [aig] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ann an %s',
	            past: 'bho chionn %s',
	            s: 'beagan diogan',
	            ss: '%d diogan',
	            m: 'mionaid',
	            mm: '%d mionaidean',
	            h: 'uair',
	            hh: '%d uairean',
	            d: 'latha',
	            dd: '%d latha',
	            M: 'mìos',
	            MM: '%d mìosan',
	            y: 'bliadhna',
	            yy: '%d bliadhna',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gd;
	
	})));


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var gl = moment.defineLocale('gl', {
	        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function () {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gl;
	
	})));


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Devanagari script [gom-deva]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
	            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
	            m: ['एका मिणटान', 'एक मिनूट'],
	            mm: [number + ' मिणटांनी', number + ' मिणटां'],
	            h: ['एका वरान', 'एक वर'],
	            hh: [number + ' वरांनी', number + ' वरां'],
	            d: ['एका दिसान', 'एक दीस'],
	            dd: [number + ' दिसांनी', number + ' दीस'],
	            M: ['एका म्हयन्यान', 'एक म्हयनो'],
	            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
	            y: ['एका वर्सान', 'एक वर्स'],
	            yy: [number + ' वर्सांनी', number + ' वर्सां'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomDeva = moment.defineLocale('gom-deva', {
	        months: {
	            standalone: 'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	                '_'
	            ),
	            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort: 'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
	        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
	        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [वाजतां]',
	            LTS: 'A h:mm:ss [वाजतां]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
	            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
	        },
	        calendar: {
	            sameDay: '[आयज] LT',
	            nextDay: '[फाल्यां] LT',
	            nextWeek: '[फुडलो] dddd[,] LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[फाटलो] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s आदीं',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'वेर' only applies to day of the month
	                case 'D':
	                    return number + 'वेर';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळीं') {
	                return hour;
	            } else if (meridiem === 'दनपारां') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'सांजे') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'राती';
	            } else if (hour < 12) {
	                return 'सकाळीं';
	            } else if (hour < 16) {
	                return 'दनपारां';
	            } else if (hour < 20) {
	                return 'सांजे';
	            } else {
	                return 'राती';
	            }
	        },
	    });
	
	    return gomDeva;
	
	})));


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['thoddea sekondamni', 'thodde sekond'],
	            ss: [number + ' sekondamni', number + ' sekond'],
	            m: ['eka mintan', 'ek minut'],
	            mm: [number + ' mintamni', number + ' mintam'],
	            h: ['eka voran', 'ek vor'],
	            hh: [number + ' voramni', number + ' voram'],
	            d: ['eka disan', 'ek dis'],
	            dd: [number + ' disamni', number + ' dis'],
	            M: ['eka mhoinean', 'ek mhoino'],
	            MM: [number + ' mhoineamni', number + ' mhoine'],
	            y: ['eka vorsan', 'ek voros'],
	            yy: [number + ' vorsamni', number + ' vorsam'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months: {
	            standalone: 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
	                '_'
	            ),
	            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort: 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
	        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [vazta]',
	            LTS: 'A h:mm:ss [vazta]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [vazta]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
	        },
	        calendar: {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Fuddlo] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fattlo] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s adim',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /rati|sokallim|donparam|sanje/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokallim') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokallim';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        },
	    });
	
	    return gomLatn;
	
	})));


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '૧',
	            2: '૨',
	            3: '૩',
	            4: '૪',
	            5: '૫',
	            6: '૬',
	            7: '૭',
	            8: '૮',
	            9: '૯',
	            0: '૦',
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0',
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
	            '_'
	        ),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
	            '_'
	        ),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પહેલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ',
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return gu;
	
	})));


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
	            '_'
	        ),
	        monthsShort: 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split(
	            '_'
	        ),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            ss: '%d שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            },
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM: function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        },
	    });
	
	    return he;
	
	})));


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        },
	        monthsParse = [
	            /^जन/i,
	            /^फ़र|फर/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सितं|सित/i,
	            /^अक्टू/i,
	            /^नव|नवं/i,
	            /^दिसं|दिस/i,
	        ],
	        shortMonthsParse = [
	            /^जन/i,
	            /^फ़र/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सित/i,
	            /^अक्टू/i,
	            /^नव/i,
	            /^दिस/i,
	        ];
	
	    var hi = moment.defineLocale('hi', {
	        months: {
	            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
	                '_'
	            ),
	            standalone: 'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split(
	            '_'
	        ),
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
	        },
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: shortMonthsParse,
	
	        monthsRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsShortRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsStrictRegex: /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
	
	        monthsShortStrictRegex: /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
	
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            ss: '%d सेकंड',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return hi;
	
	})));


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
	                '_'
	            ),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM YYYY',
	            LLL: 'Do MMMM YYYY H:mm',
	            LLLL: 'dddd, Do MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prošlu] [nedjelju] [u] LT';
	                    case 3:
	                        return '[prošlu] [srijedu] [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hr;
	
	})));


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	//! author : Peter Viszt  : https://github.com/passatgt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(
	        ' '
	    );
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix
	                    ? 'néhány másodperc'
	                    : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix)
	                    ? ' másodperc'
	                    : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (
	            (isFuture ? '' : '[múlt] ') +
	            '[' +
	            weekEndings[this.day()] +
	            '] LT[-kor]'
	        );
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm',
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function () {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function () {
	                return week.call(this, false);
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return hu;
	
	})));


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months: {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
	                '_'
	            ),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays: 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
	            '_'
	        ),
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            ss: '%d վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի',
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem: function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hyAm;
	
	})));


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var id = moment.defineLocale('id', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Besok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kemarin pukul] LT',
	            lastWeek: 'dddd [lalu pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lalu',
	            s: 'beberapa detik',
	            ss: '%d detik',
	            m: 'semenit',
	            mm: '%d menit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return id;
	
	})));


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nokkrar sekúndur'
	                    : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
	                    );
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return (
	                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
	                    );
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture
	                            ? 'klukkustundir'
	                            : 'klukkustundum')
	                    );
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays: 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
	            '_'
	        ),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return is;
	
	})));


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	//! author: Marco : https://github.com/Manfre98
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return (
	                    '[Oggi a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextDay: function () {
	                return (
	                    '[Domani a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextWeek: function () {
	                return (
	                    'dddd [a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastDay: function () {
	                return (
	                    '[Ieri a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return (
	                            '[La scorsa] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                    default:
	                        return (
	                            '[Lo scorso] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'tra %s',
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            w: 'una settimana',
	            ww: '%d settimane',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return it;
	
	})));


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian (Switzerland) [it-ch]
	//! author : xfh : https://github.com/xfh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var itCh = moment.defineLocale('it-ch', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return itCh;
	
	})));


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ja = moment.defineLocale('ja', {
	        eras: [
	            {
	                since: '2019-05-01',
	                offset: 1,
	                name: '令和',
	                narrow: '㋿',
	                abbr: 'R',
	            },
	            {
	                since: '1989-01-08',
	                until: '2019-04-30',
	                offset: 1,
	                name: '平成',
	                narrow: '㍻',
	                abbr: 'H',
	            },
	            {
	                since: '1926-12-25',
	                until: '1989-01-07',
	                offset: 1,
	                name: '昭和',
	                narrow: '㍼',
	                abbr: 'S',
	            },
	            {
	                since: '1912-07-30',
	                until: '1926-12-24',
	                offset: 1,
	                name: '大正',
	                narrow: '㍽',
	                abbr: 'T',
	            },
	            {
	                since: '1873-01-01',
	                until: '1912-07-29',
	                offset: 6,
	                name: '明治',
	                narrow: '㍾',
	                abbr: 'M',
	            },
	            {
	                since: '0001-01-01',
	                until: '1873-12-31',
	                offset: 1,
	                name: '西暦',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: '紀元前',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        eraYearOrdinalRegex: /(元|\d+)年/,
	        eraYearOrdinalParse: function (input, match) {
	            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
	        },
	        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日 dddd HH:mm',
	            l: 'YYYY/MM/DD',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日(ddd) HH:mm',
	        },
	        meridiemParse: /午前|午後/i,
	        isPM: function (input) {
	            return input === '午後';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar: {
	            sameDay: '[今日] LT',
	            nextDay: '[明日] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay: '[昨日] LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}日/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'y':
	                    return number === 1 ? '元年' : number + '年';
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '数秒',
	            ss: '%d秒',
	            m: '1分',
	            mm: '%d分',
	            h: '1時間',
	            hh: '%d時間',
	            d: '1日',
	            dd: '%d日',
	            M: '1ヶ月',
	            MM: '%dヶ月',
	            y: '1年',
	            yy: '%d年',
	        },
	    });
	
	    return ja;
	
	})));


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var jv = moment.defineLocale('jv', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar: {
	            sameDay: '[Dinten puniko pukul] LT',
	            nextDay: '[Mbenjang pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kala wingi pukul] LT',
	            lastWeek: 'dddd [kepengker pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'wonten ing %s',
	            past: '%s ingkang kepengker',
	            s: 'sawetawis detik',
	            ss: '%d detik',
	            m: 'setunggal menit',
	            mm: '%d menit',
	            h: 'setunggal jam',
	            hh: '%d jam',
	            d: 'sedinten',
	            dd: '%d dinten',
	            M: 'sewulan',
	            MM: '%d wulan',
	            y: 'setaun',
	            yy: '%d taun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return jv;
	
	})));


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/IrakliJani
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ka = moment.defineLocale('ka', {
	        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
	            '_'
	        ),
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
	                '_'
	            ),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
	                '_'
	            ),
	            isFormat: /(წინა|შემდეგ)/,
	        },
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return s.replace(/(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/, function (
	                    $0,
	                    $1,
	                    $2
	                ) {
	                    return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
	                });
	            },
	            past: function (s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	                return s;
	            },
	            s: 'რამდენიმე წამი',
	            ss: '%d წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი',
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (
	                number < 20 ||
	                (number <= 100 && number % 20 === 0) ||
	                number % 100 === 0
	            ) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7,
	        },
	    });
	
	    return ka;
	
	})));


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші',
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
	            '_'
	        ),
	        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
	            '_'
	        ),
	        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгін сағат] LT',
	            nextDay: '[Ертең сағат] LT',
	            nextWeek: 'dddd [сағат] LT',
	            lastDay: '[Кеше сағат] LT',
	            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ішінде',
	            past: '%s бұрын',
	            s: 'бірнеше секунд',
	            ss: '%d секунд',
	            m: 'бір минут',
	            mm: '%d минут',
	            h: 'бір сағат',
	            hh: '%d сағат',
	            d: 'бір күн',
	            dd: '%d күн',
	            M: 'бір ай',
	            MM: '%d ай',
	            y: 'бір жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return kk;
	
	})));


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '១',
	            2: '២',
	            3: '៣',
	            4: '៤',
	            5: '៥',
	            6: '៦',
	            7: '៧',
	            8: '៨',
	            9: '៩',
	            0: '០',
	        },
	        numberMap = {
	            '១': '1',
	            '២': '2',
	            '៣': '3',
	            '៤': '4',
	            '៥': '5',
	            '៦': '6',
	            '៧': '7',
	            '៨': '8',
	            '៩': '9',
	            '០': '0',
	        };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ',
	        },
	        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
	        ordinal: 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return km;
	
	})));


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '೧',
	            2: '೨',
	            3: '೩',
	            4: '೪',
	            5: '೫',
	            6: '೬',
	            7: '೭',
	            8: '೮',
	            9: '೯',
	            0: '೦',
	        },
	        numberMap = {
	            '೧': '1',
	            '೨': '2',
	            '೩': '3',
	            '೪': '4',
	            '೫': '5',
	            '೬': '6',
	            '೭': '7',
	            '೮': '8',
	            '೯': '9',
	            '೦': '0',
	        };
	
	    var kn = moment.defineLocale('kn', {
	        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
	            '_'
	        ),
	        monthsShort: 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[ಇಂದು] LT',
	            nextDay: '[ನಾಳೆ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ನಿನ್ನೆ] LT',
	            lastWeek: '[ಕೊನೆಯ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ನಂತರ',
	            past: '%s ಹಿಂದೆ',
	            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss: '%d ಸೆಕೆಂಡುಗಳು',
	            m: 'ಒಂದು ನಿಮಿಷ',
	            mm: '%d ನಿಮಿಷ',
	            h: 'ಒಂದು ಗಂಟೆ',
	            hh: '%d ಗಂಟೆ',
	            d: 'ಒಂದು ದಿನ',
	            dd: '%d ದಿನ',
	            M: 'ಒಂದು ತಿಂಗಳು',
	            MM: '%d ತಿಂಗಳು',
	            y: 'ಒಂದು ವರ್ಷ',
	            yy: '%d ವರ್ಷ',
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal: function (number) {
	            return number + 'ನೇ';
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return kn;
	
	})));


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ko = moment.defineLocale('ko', {
	        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
	            '_'
	        ),
	        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY년 MMMM D일',
	            LLL: 'YYYY년 MMMM D일 A h:mm',
	            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
	            l: 'YYYY.MM.DD.',
	            ll: 'YYYY년 MMMM D일',
	            lll: 'YYYY년 MMMM D일 A h:mm',
	            llll: 'YYYY년 MMMM D일 dddd A h:mm',
	        },
	        calendar: {
	            sameDay: '오늘 LT',
	            nextDay: '내일 LT',
	            nextWeek: 'dddd LT',
	            lastDay: '어제 LT',
	            lastWeek: '지난주 dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s 후',
	            past: '%s 전',
	            s: '몇 초',
	            ss: '%d초',
	            m: '1분',
	            mm: '%d분',
	            h: '한 시간',
	            hh: '%d시간',
	            d: '하루',
	            dd: '%d일',
	            M: '한 달',
	            MM: '%d달',
	            y: '일 년',
	            yy: '%d년',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse: /오전|오후/,
	        isPM: function (token) {
	            return token === '오후';
	        },
	        meridiem: function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        },
	    });
	
	    return ko;
	
	})));


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kurdish [ku]
	//! author : Shahram Mebashar : https://github.com/ShahramMebashar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        months = [
	            'کانونی دووەم',
	            'شوبات',
	            'ئازار',
	            'نیسان',
	            'ئایار',
	            'حوزەیران',
	            'تەمموز',
	            'ئاب',
	            'ئەیلوول',
	            'تشرینی یەكەم',
	            'تشرینی دووەم',
	            'كانونی یەکەم',
	        ];
	
	    var ku = moment.defineLocale('ku', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
	            '_'
	        ),
	        weekdaysShort: 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split(
	            '_'
	        ),
	        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar: {
	            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay: '[به‌یانی كاتژمێر] LT',
	            nextWeek: 'dddd [كاتژمێر] LT',
	            lastDay: '[دوێنێ كاتژمێر] LT',
	            lastWeek: 'dddd [كاتژمێر] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'له‌ %s',
	            past: '%s',
	            s: 'چه‌ند چركه‌یه‌ك',
	            ss: 'چركه‌ %d',
	            m: 'یه‌ك خوله‌ك',
	            mm: '%d خوله‌ك',
	            h: 'یه‌ك كاتژمێر',
	            hh: '%d كاتژمێر',
	            d: 'یه‌ك ڕۆژ',
	            dd: '%d ڕۆژ',
	            M: 'یه‌ك مانگ',
	            MM: '%d مانگ',
	            y: 'یه‌ك ساڵ',
	            yy: '%d ساڵ',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ku;
	
	})));


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү',
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
	            '_'
	        ),
	        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
	            '_'
	        ),
	        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгүн саат] LT',
	            nextDay: '[Эртең саат] LT',
	            nextWeek: 'dddd [саат] LT',
	            lastDay: '[Кечээ саат] LT',
	            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ичинде',
	            past: '%s мурун',
	            s: 'бирнече секунд',
	            ss: '%d секунд',
	            m: 'бир мүнөт',
	            mm: '%d мүнөт',
	            h: 'бир саат',
	            hh: '%d саат',
	            d: 'бир күн',
	            dd: '%d күн',
	            M: 'бир ай',
	            MM: '%d ай',
	            y: 'бир жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ky;
	
	})));


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eng Minutt', 'enger Minutt'],
	            h: ['eng Stonn', 'enger Stonn'],
	            d: ['een Dag', 'engem Dag'],
	            M: ['ee Mount', 'engem Mount'],
	            y: ['ee Joer', 'engem Joer'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            },
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            ss: '%d Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lb;
	
	})));


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var lo = moment.defineLocale('lo', {
	        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        monthsShort: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar: {
	            sameDay: '[ມື້ນີ້ເວລາ] LT',
	            nextDay: '[ມື້ອື່ນເວລາ] LT',
	            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ອີກ %s',
	            past: '%sຜ່ານມາ',
	            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss: '%d ວິນາທີ',
	            m: '1 ນາທີ',
	            mm: '%d ນາທີ',
	            h: '1 ຊົ່ວໂມງ',
	            hh: '%d ຊົ່ວໂມງ',
	            d: '1 ມື້',
	            dd: '%d ມື້',
	            M: '1 ເດືອນ',
	            MM: '%d ເດືອນ',
	            y: '1 ປີ',
	            yy: '%d ປີ',
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal: function (number) {
	            return 'ທີ່' + number;
	        },
	    });
	
	    return lo;
	
	})));


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundė_sekundžių_sekundes',
	        m: 'minutė_minutės_minutę',
	        mm: 'minutės_minučių_minutes',
	        h: 'valanda_valandos_valandą',
	        hh: 'valandos_valandų_valandas',
	        d: 'diena_dienos_dieną',
	        dd: 'dienos_dienų_dienas',
	        M: 'mėnuo_mėnesio_mėnesį',
	        MM: 'mėnesiai_mėnesių_mėnesius',
	        y: 'metai_metų_metus',
	        yy: 'metai_metų_metus',
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix
	            ? forms(key)[0]
	            : isFuture
	            ? forms(key)[1]
	            : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return (
	                result + translateSingular(number, withoutSuffix, key[0], isFuture)
	            );
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months: {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
	                '_'
	            ),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
	        },
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
	                '_'
	            ),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
	                '_'
	            ),
	            isFormat: /dddd HH:mm/,
	        },
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            ss: translate,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal: function (number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lt;
	
	})));


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        h: 'stundas_stundām_stunda_stundas'.split('_'),
	        hh: 'stundas_stundām_stunda_stundas'.split('_'),
	        d: 'dienas_dienām_diena_dienas'.split('_'),
	        dd: 'dienas_dienām_diena_dienas'.split('_'),
	        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        y: 'gada_gadiem_gads_gadi'.split('_'),
	        yy: 'gada_gadiem_gads_gadi'.split('_'),
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lv;
	
	})));


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return me;
	
	})));


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
	            '_'
	        ),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
	            '_'
	        ),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mi;
	
	})));


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	//! author : Sashko Todorov : https://github.com/bkyceh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mk = moment.defineLocale('mk', {
	        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Денес во] LT',
	            nextDay: '[Утре во] LT',
	            nextWeek: '[Во] dddd [во] LT',
	            lastDay: '[Вчера во] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пред %s',
	            s: 'неколку секунди',
	            ss: '%d секунди',
	            m: 'една минута',
	            mm: '%d минути',
	            h: 'еден час',
	            hh: '%d часа',
	            d: 'еден ден',
	            dd: '%d дена',
	            M: 'еден месец',
	            MM: '%d месеци',
	            y: 'една година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return mk;
	
	})));


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
	            '_'
	        ),
	        monthsShort: 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
	            '_'
	        ),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            ss: '%d സെക്കൻഡ്',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം',
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        },
	    });
	
	    return ml;
	
	})));


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Mongolian [mn]
	//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
	            '_'
	        ),
	        monthsShort: '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY оны MMMMын D',
	            LLL: 'YYYY оны MMMMын D HH:mm',
	            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM: function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar: {
	            sameDay: '[Өнөөдөр] LT',
	            nextDay: '[Маргааш] LT',
	            nextWeek: '[Ирэх] dddd LT',
	            lastDay: '[Өчигдөр] LT',
	            lastWeek: '[Өнгөрсөн] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s дараа',
	            past: '%s өмнө',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        },
	    });
	
	    return mn;
	
	})));


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंद';
	                    break;
	                case 'ss':
	                    output = '%d सेकंद';
	                    break;
	                case 'm':
	                    output = 'एक मिनिट';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटे';
	                    break;
	                case 'h':
	                    output = 'एक तास';
	                    break;
	                case 'hh':
	                    output = '%d तास';
	                    break;
	                case 'd':
	                    output = 'एक दिवस';
	                    break;
	                case 'dd':
	                    output = '%d दिवस';
	                    break;
	                case 'M':
	                    output = 'एक महिना';
	                    break;
	                case 'MM':
	                    output = '%d महिने';
	                    break;
	                case 'y':
	                    output = 'एक वर्ष';
	                    break;
	                case 'yy':
	                    output = '%d वर्षे';
	                    break;
	            }
	        } else {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंदां';
	                    break;
	                case 'ss':
	                    output = '%d सेकंदां';
	                    break;
	                case 'm':
	                    output = 'एका मिनिटा';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटां';
	                    break;
	                case 'h':
	                    output = 'एका तासा';
	                    break;
	                case 'hh':
	                    output = '%d तासां';
	                    break;
	                case 'd':
	                    output = 'एका दिवसा';
	                    break;
	                case 'dd':
	                    output = '%d दिवसां';
	                    break;
	                case 'M':
	                    output = 'एका महिन्या';
	                    break;
	                case 'MM':
	                    output = '%d महिन्यां';
	                    break;
	                case 'y':
	                    output = 'एका वर्षा';
	                    break;
	                case 'yy':
	                    output = '%d वर्षां';
	                    break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	            '_'
	        ),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr,
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
	                return hour;
	            } else if (
	                meridiem === 'दुपारी' ||
	                meridiem === 'सायंकाळी' ||
	                meridiem === 'रात्री'
	            ) {
	                return hour >= 12 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour >= 0 && hour < 6) {
	                return 'पहाटे';
	            } else if (hour < 12) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return mr;
	
	})));


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ms = moment.defineLocale('ms', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ms;
	
	})));


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var msMy = moment.defineLocale('ms-my', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return msMy;
	
	})));


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mt = moment.defineLocale('mt', {
	        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays: 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Illum fil-]LT',
	            nextDay: '[Għada fil-]LT',
	            nextWeek: 'dddd [fil-]LT',
	            lastDay: '[Il-bieraħ fil-]LT',
	            lastWeek: 'dddd [li għadda] [fil-]LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'f’ %s',
	            past: '%s ilu',
	            s: 'ftit sekondi',
	            ss: '%d sekondi',
	            m: 'minuta',
	            mm: '%d minuti',
	            h: 'siegħa',
	            hh: '%d siegħat',
	            d: 'ġurnata',
	            dd: '%d ġranet',
	            M: 'xahar',
	            MM: '%d xhur',
	            y: 'sena',
	            yy: '%d sni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mt;
	
	})));


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '၁',
	            2: '၂',
	            3: '၃',
	            4: '၄',
	            5: '၅',
	            6: '၆',
	            7: '၇',
	            8: '၈',
	            9: '၉',
	            0: '၀',
	        },
	        numberMap = {
	            '၁': '1',
	            '၂': '2',
	            '၃': '3',
	            '၄': '4',
	            '၅': '5',
	            '၆': '6',
	            '၇': '7',
	            '၈': '8',
	            '၉': '9',
	            '၀': '0',
	        };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
	            '_'
	        ),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
	            '_'
	        ),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss: '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်',
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return my;
	
	})));


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'noen sekunder',
	            ss: '%d sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dager',
	            w: 'en uke',
	            ww: '%d uker',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nb;
	
	})));


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
	            '_'
	        ),
	        monthsShort: 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
	            '_'
	        ),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोलि] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडि',
	            s: 'केही क्षण',
	            ss: '%d सेकेण्ड',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ne;
	
	})));


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            w: 'één week',
	            ww: '%d weken',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nl;
	
	})));


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nlBe;
	
	})));


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! authors : https://github.com/mechuwind
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s sidan',
	            s: 'nokre sekund',
	            ss: '%d sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            w: 'ei veke',
	            ww: '%d veker',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nn;
	
	})));


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Occitan, lengadocian dialecte [oc-lnc]
	//! author : Quentin PAGÈS : https://github.com/Quenty31
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ocLnc = moment.defineLocale('oc-lnc', {
	        months: {
	            standalone: 'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
	                '_'
	            ),
	            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort: 'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: '[uèi a] LT',
	            nextDay: '[deman a] LT',
	            nextWeek: 'dddd [a] LT',
	            lastDay: '[ièr a] LT',
	            lastWeek: 'dddd [passat a] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'unas segondas',
	            ss: '%d segondas',
	            m: 'una minuta',
	            mm: '%d minutas',
	            h: 'una ora',
	            hh: '%d oras',
	            d: 'un jorn',
	            dd: '%d jorns',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4,
	        },
	    });
	
	    return ocLnc;
	
	})));


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '੧',
	            2: '੨',
	            3: '੩',
	            4: '੪',
	            5: '੫',
	            6: '੬',
	            7: '੭',
	            8: '੮',
	            9: '੯',
	            0: '੦',
	        },
	        numberMap = {
	            '੧': '1',
	            '੨': '2',
	            '੩': '3',
	            '੪': '4',
	            '੫': '5',
	            '੬': '6',
	            '੭': '7',
	            '੮': '8',
	            '੯': '9',
	            '੦': '0',
	        };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        monthsShort: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm ਵਜੇ',
	            LTS: 'A h:mm:ss ਵਜੇ',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
	        },
	        calendar: {
	            sameDay: '[ਅਜ] LT',
	            nextDay: '[ਕਲ] LT',
	            nextWeek: '[ਅਗਲਾ] dddd, LT',
	            lastDay: '[ਕਲ] LT',
	            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ਵਿੱਚ',
	            past: '%s ਪਿਛਲੇ',
	            s: 'ਕੁਝ ਸਕਿੰਟ',
	            ss: '%d ਸਕਿੰਟ',
	            m: 'ਇਕ ਮਿੰਟ',
	            mm: '%d ਮਿੰਟ',
	            h: 'ਇੱਕ ਘੰਟਾ',
	            hh: '%d ਘੰਟੇ',
	            d: 'ਇੱਕ ਦਿਨ',
	            dd: '%d ਦਿਨ',
	            M: 'ਇੱਕ ਮਹੀਨਾ',
	            MM: '%d ਮਹੀਨੇ',
	            y: 'ਇੱਕ ਸਾਲ',
	            yy: '%d ਸਾਲ',
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return paIn;
	
	})));


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
	            '_'
	        ),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^sty/i,
	            /^lut/i,
	            /^mar/i,
	            /^kwi/i,
	            /^maj/i,
	            /^cze/i,
	            /^lip/i,
	            /^sie/i,
	            /^wrz/i,
	            /^paź/i,
	            /^lis/i,
	            /^gru/i,
	        ];
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'ww':
	                return result + (plural(number) ? 'tygodnie' : 'tygodni');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            w: 'tydzień',
	            ww: translate,
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pl;
	
	})));


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pt = moment.defineLocale('pt', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays: 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            w: 'uma semana',
	            ww: '%d semanas',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pt;
	
	})));


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays: 'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
	        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'poucos segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        invalidDate: 'Data inválida',
	    });
	
	    return ptBr;
	
	})));


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	//! author : Emanuel Cepoi : https://github.com/cepem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                ss: 'secunde',
	                mm: 'minute',
	                hh: 'ore',
	                dd: 'zile',
	                ww: 'săptămâni',
	                MM: 'luni',
	                yy: 'ani',
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
	            '_'
	        ),
	        monthsShort: 'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            ss: relativeTimeWithPlural,
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            w: 'o săptămână',
	            ww: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural,
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ro;
	
	})));


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            hh: 'час_часа_часов',
	            dd: 'день_дня_дней',
	            ww: 'неделя_недели_недель',
	            MM: 'месяц_месяца_месяцев',
	            yy: 'год_года_лет',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [
	        /^янв/i,
	        /^фев/i,
	        /^мар/i,
	        /^апр/i,
	        /^ма[йя]/i,
	        /^июн/i,
	        /^июл/i,
	        /^авг/i,
	        /^сен/i,
	        /^окт/i,
	        /^ноя/i,
	        /^дек/i,
	    ];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months: {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
	                '_'
	            ),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	                '_'
	            ),
	        },
	        monthsShort: {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	        },
	        weekdays: {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
	                '_'
	            ),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
	        },
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соответствует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., H:mm',
	            LLLL: 'dddd, D MMMM YYYY г., H:mm',
	        },
	        calendar: {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            w: 'неделя',
	            ww: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ru;
	
	})));


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوري',
	            'فيبروري',
	            'مارچ',
	            'اپريل',
	            'مئي',
	            'جون',
	            'جولاءِ',
	            'آگسٽ',
	            'سيپٽمبر',
	            'آڪٽوبر',
	            'نومبر',
	            'ڊسمبر',
	        ],
	        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
	
	    var sd = moment.defineLocale('sd', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[اڄ] LT',
	            nextDay: '[سڀاڻي] LT',
	            nextWeek: 'dddd [اڳين هفتي تي] LT',
	            lastDay: '[ڪالهه] LT',
	            lastWeek: '[گزريل هفتي] dddd [تي] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s پوء',
	            past: '%s اڳ',
	            s: 'چند سيڪنڊ',
	            ss: '%d سيڪنڊ',
	            m: 'هڪ منٽ',
	            mm: '%d منٽ',
	            h: 'هڪ ڪلاڪ',
	            hh: '%d ڪلاڪ',
	            d: 'هڪ ڏينهن',
	            dd: '%d ڏينهن',
	            M: 'هڪ مهينو',
	            MM: '%d مهينا',
	            y: 'هڪ سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sd;
	
	})));


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var se = moment.defineLocale('se', {
	        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
	            '_'
	        ),
	        monthsShort: 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split(
	            '_'
	        ),
	        weekdays: 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
	            '_'
	        ),
	        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'MMMM D. [b.] YYYY',
	            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s geažes',
	            past: 'maŋit %s',
	            s: 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m: 'okta minuhta',
	            mm: '%d minuhtat',
	            h: 'okta diimmu',
	            hh: '%d diimmut',
	            d: 'okta beaivi',
	            dd: '%d beaivvit',
	            M: 'okta mánnu',
	            MM: '%d mánut',
	            y: 'okta jahki',
	            yy: '%d jagit',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return se;
	
	})));


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
	            '_'
	        ),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
	            '_'
	        ),
	        weekdays: 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
	            '_'
	        ),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            ss: 'තත්පර %d',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal: function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM: function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        },
	    });
	
	    return si;
	
	})));


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
	            '_'
	        ),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sk;
	
	})));


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nekaj sekund'
	                    : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sl;
	
	})));


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sq = moment.defineLocale('sq', {
	        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
	            '_'
	        ),
	        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Sot në] LT',
	            nextDay: '[Nesër në] LT',
	            nextWeek: 'dddd [në] LT',
	            lastDay: '[Dje në] LT',
	            lastWeek: 'dddd [e kaluar në] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'në %s',
	            past: '%s më parë',
	            s: 'disa sekonda',
	            ss: '%d sekonda',
	            m: 'një minutë',
	            mm: '%d minuta',
	            h: 'një orë',
	            hh: '%d orë',
	            d: 'një ditë',
	            dd: '%d ditë',
	            M: 'një muaj',
	            MM: '%d muaj',
	            y: 'një vit',
	            yy: '%d vite',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sq;
	
	})));


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sr;
	
	})));


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
	            '_'
	        ),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'дан',
	            dd: translator.translate,
	            M: 'месец',
	            MM: translator.translate,
	            y: 'годину',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return srCyrl;
	
	})));


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ss = moment.defineLocale('ss', {
	        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
	            '_'
	        ),
	        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays: 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Namuhla nga] LT',
	            nextDay: '[Kusasa nga] LT',
	            nextWeek: 'dddd [nga] LT',
	            lastDay: '[Itolo nga] LT',
	            lastWeek: 'dddd [leliphelile] [nga] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'nga %s',
	            past: 'wenteka nga %s',
	            s: 'emizuzwana lomcane',
	            ss: '%d mzuzwana',
	            m: 'umzuzu',
	            mm: '%d emizuzu',
	            h: 'lihora',
	            hh: '%d emahora',
	            d: 'lilanga',
	            dd: '%d emalanga',
	            M: 'inyanga',
	            MM: '%d tinyanga',
	            y: 'umnyaka',
	            yy: '%d iminyaka',
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: '%d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ss;
	
	})));


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sv = moment.defineLocale('sv', {
	        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'för %s sedan',
	            s: 'några sekunder',
	            ss: '%d sekunder',
	            m: 'en minut',
	            mm: '%d minuter',
	            h: 'en timme',
	            hh: '%d timmar',
	            d: 'en dag',
	            dd: '%d dagar',
	            M: 'en månad',
	            MM: '%d månader',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? ':e'
	                        : b === 1
	                        ? ':a'
	                        : b === 2
	                        ? ':a'
	                        : b === 3
	                        ? ':e'
	                        : ':e';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sv;
	
	})));


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sw = moment.defineLocale('sw', {
	        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'hh:mm A',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[leo saa] LT',
	            nextDay: '[kesho saa] LT',
	            nextWeek: '[wiki ijayo] dddd [saat] LT',
	            lastDay: '[jana] LT',
	            lastWeek: '[wiki iliyopita] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s baadaye',
	            past: 'tokea %s',
	            s: 'hivi punde',
	            ss: 'sekunde %d',
	            m: 'dakika moja',
	            mm: 'dakika %d',
	            h: 'saa limoja',
	            hh: 'masaa %d',
	            d: 'siku moja',
	            dd: 'siku %d',
	            M: 'mwezi mmoja',
	            MM: 'miezi %d',
	            y: 'mwaka mmoja',
	            yy: 'miaka %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sw;
	
	})));


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '௧',
	            2: '௨',
	            3: '௩',
	            4: '௪',
	            5: '௫',
	            6: '௬',
	            7: '௭',
	            8: '௮',
	            9: '௯',
	            0: '௦',
	        },
	        numberMap = {
	            '௧': '1',
	            '௨': '2',
	            '௩': '3',
	            '௪': '4',
	            '௫': '5',
	            '௬': '6',
	            '௭': '7',
	            '௮': '8',
	            '௯': '9',
	            '௦': '0',
	        };
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        monthsShort: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        weekdays: 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
	            '_'
	        ),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
	            '_'
	        ),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm',
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            ss: '%d விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal: function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ta;
	
	})));


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var te = moment.defineLocale('te', {
	        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
	            '_'
	        ),
	        monthsShort: 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
	            '_'
	        ),
	        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[నేడు] LT',
	            nextDay: '[రేపు] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[నిన్న] LT',
	            lastWeek: '[గత] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s లో',
	            past: '%s క్రితం',
	            s: 'కొన్ని క్షణాలు',
	            ss: '%d సెకన్లు',
	            m: 'ఒక నిమిషం',
	            mm: '%d నిమిషాలు',
	            h: 'ఒక గంట',
	            hh: '%d గంటలు',
	            d: 'ఒక రోజు',
	            dd: '%d రోజులు',
	            M: 'ఒక నెల',
	            MM: '%d నెలలు',
	            y: 'ఒక సంవత్సరం',
	            yy: '%d సంవత్సరాలు',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}వ/,
	        ordinal: '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return te;
	
	})));


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	//! author : Sonia Simoes : https://github.com/soniasimoes
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tet = moment.defineLocale('tet', {
	        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'iha %s',
	            past: '%s liuba',
	            s: 'segundu balun',
	            ss: 'segundu %d',
	            m: 'minutu ida',
	            mm: 'minutu %d',
	            h: 'oras ida',
	            hh: 'oras %d',
	            d: 'loron ida',
	            dd: 'loron %d',
	            M: 'fulan ida',
	            MM: 'fulan %d',
	            y: 'tinan ida',
	            yy: 'tinan %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tet;
	
	})));


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tajik [tg]
	//! author : Orif N. Jr. : https://github.com/orif-jr
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум',
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months: {
	            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
	                '_'
	            ),
	            standalone: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
	            '_'
	        ),
	        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Имрӯз соати] LT',
	            nextDay: '[Фардо соати] LT',
	            lastDay: '[Дирӯз соати] LT',
	            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'баъди %s',
	            past: '%s пеш',
	            s: 'якчанд сония',
	            m: 'як дақиқа',
	            mm: '%d дақиқа',
	            h: 'як соат',
	            hh: '%d соат',
	            d: 'як рӯз',
	            dd: '%d рӯз',
	            M: 'як моҳ',
	            MM: '%d моҳ',
	            y: 'як сол',
	            yy: '%d сол',
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1th is the first week of the year.
	        },
	    });
	
	    return tg;
	
	})));


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
	            '_'
	        ),
	        monthsShort: 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H:mm',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            ss: '%d วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            w: '1 สัปดาห์',
	            ww: '%d สัปดาห์',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี',
	        },
	    });
	
	    return th;
	
	})));


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkmen [tk]
	//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inji",
	        5: "'inji",
	        8: "'inji",
	        70: "'inji",
	        80: "'inji",
	        2: "'nji",
	        7: "'nji",
	        20: "'nji",
	        50: "'nji",
	        3: "'ünji",
	        4: "'ünji",
	        100: "'ünji",
	        6: "'njy",
	        9: "'unjy",
	        10: "'unjy",
	        30: "'unjy",
	        60: "'ynjy",
	        90: "'ynjy",
	    };
	
	    var tk = moment.defineLocale('tk', {
	        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
	        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
	        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün sagat] LT',
	            nextDay: '[ertir sagat] LT',
	            nextWeek: '[indiki] dddd [sagat] LT',
	            lastDay: '[düýn] LT',
	            lastWeek: '[geçen] dddd [sagat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s soň',
	            past: '%s öň',
	            s: 'birnäçe sekunt',
	            m: 'bir minut',
	            mm: '%d minut',
	            h: 'bir sagat',
	            hh: '%d sagat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir aý',
	            MM: '%d aý',
	            y: 'bir ýyl',
	            yy: '%d ýyl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'unjy";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tk;
	
	})));


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlPh;
	
	})));


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'leS'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'waQ'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'nem'
	                : time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'Hu’'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'wen'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'ben'
	                : time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	            ten = Math.floor((number % 100) / 10),
	            one = number % 10,
	            word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[one];
	        }
	        return word === '' ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsShort: 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysShort: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysMin: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: translateFuture,
	            past: translatePast,
	            s: 'puS lup',
	            ss: translate,
	            m: 'wa’ tup',
	            mm: translate,
	            h: 'wa’ rep',
	            hh: translate,
	            d: 'wa’ jaj',
	            dd: translate,
	            M: 'wa’ jar',
	            MM: translate,
	            y: 'wa’ DIS',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlh;
	
	})));


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inci",
	        5: "'inci",
	        8: "'inci",
	        70: "'inci",
	        80: "'inci",
	        2: "'nci",
	        7: "'nci",
	        20: "'nci",
	        50: "'nci",
	        3: "'üncü",
	        4: "'üncü",
	        100: "'üncü",
	        6: "'ncı",
	        9: "'uncu",
	        10: "'uncu",
	        30: "'uncu",
	        60: "'ıncı",
	        90: "'ıncı",
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
	            '_'
	        ),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'öö' : 'ÖÖ';
	            } else {
	                return isLower ? 'ös' : 'ÖS';
	            }
	        },
	        meridiemParse: /öö|ÖÖ|ös|ÖS/,
	        isPM: function (input) {
	            return input === 'ös' || input === 'ÖS';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[gelecek] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            ss: '%d saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            w: 'bir hafta',
	            ww: '%d hafta',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'ıncı";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tr;
	
	})));


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM [dallas] YYYY',
	            LLL: 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM: function (input) {
	            return "d'o" === input.toLowerCase();
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? "d'o" : "D'O";
	            } else {
	                return isLower ? "d'a" : "D'A";
	            }
	        },
	        calendar: {
	            sameDay: '[oxhi à] LT',
	            nextDay: '[demà à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[ieiri à] LT',
	            lastWeek: '[sür el] dddd [lasteu à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'osprei %s',
	            past: 'ja%s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['viensas secunds', "'iensas secunds"],
	            ss: [number + ' secunds', '' + number + ' secunds'],
	            m: ["'n míut", "'iens míut"],
	            mm: [number + ' míuts', '' + number + ' míuts'],
	            h: ["'n þora", "'iensa þora"],
	            hh: [number + ' þoras', '' + number + ' þoras'],
	            d: ["'n ziua", "'iensa ziua"],
	            dd: [number + ' ziuas', '' + number + ' ziuas'],
	            M: ["'n mes", "'iens mes"],
	            MM: [number + ' mesen', '' + number + ' mesen'],
	            y: ["'n ar", "'iens ar"],
	            yy: [number + ' ars', '' + number + ' ars'],
	        };
	        return isFuture
	            ? format[key][0]
	            : withoutSuffix
	            ? format[key][0]
	            : format[key][1];
	    }
	
	    return tzl;
	
	})));


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        monthsShort: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            ss: '%d ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzm;
	
	})));


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        monthsShort: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            ss: '%d imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzmLatn;
	
	})));


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uyghur (China) [ug-cn]
	//! author: boyaq : https://github.com/boyaq
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل',
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return ugCn;
	
	})));


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            dd: 'день_дні_днів',
	            MM: 'місяць_місяці_місяців',
	            yy: 'рік_роки_років',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	                nominative: 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
	                    '_'
	                ),
	                accusative: 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
	                    '_'
	                ),
	                genitive: 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
	                    '_'
	                ),
	            },
	            nounCase;
	
	        if (m === true) {
	            return weekdays['nominative']
	                .slice(1, 7)
	                .concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
	            ? 'accusative'
	            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
	            ? 'genitive'
	            : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: {
	            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
	                '_'
	            ),
	            standalone: 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
	            '_'
	        ),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural,
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uk;
	
	})));


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوری',
	            'فروری',
	            'مارچ',
	            'اپریل',
	            'مئی',
	            'جون',
	            'جولائی',
	            'اگست',
	            'ستمبر',
	            'اکتوبر',
	            'نومبر',
	            'دسمبر',
	        ],
	        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
	
	    var ur = moment.defineLocale('ur', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[آج بوقت] LT',
	            nextDay: '[کل بوقت] LT',
	            nextWeek: 'dddd [بوقت] LT',
	            lastDay: '[گذشتہ روز بوقت] LT',
	            lastWeek: '[گذشتہ] dddd [بوقت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s بعد',
	            past: '%s قبل',
	            s: 'چند سیکنڈ',
	            ss: '%d سیکنڈ',
	            m: 'ایک منٹ',
	            mm: '%d منٹ',
	            h: 'ایک گھنٹہ',
	            hh: '%d گھنٹے',
	            d: 'ایک دن',
	            dd: '%d دن',
	            M: 'ایک ماہ',
	            MM: '%d ماہ',
	            y: 'ایک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ur;
	
	})));


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uz = moment.defineLocale('uz', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бугун соат] LT [да]',
	            nextDay: '[Эртага] LT [да]',
	            nextWeek: 'dddd [куни соат] LT [да]',
	            lastDay: '[Кеча соат] LT [да]',
	            lastWeek: '[Утган] dddd [куни соат] LT [да]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Якин %s ичида',
	            past: 'Бир неча %s олдин',
	            s: 'фурсат',
	            ss: '%d фурсат',
	            m: 'бир дакика',
	            mm: '%d дакика',
	            h: 'бир соат',
	            hh: '%d соат',
	            d: 'бир кун',
	            dd: '%d кун',
	            M: 'бир ой',
	            MM: '%d ой',
	            y: 'бир йил',
	            yy: '%d йил',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return uz;
	
	})));


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays: 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
	            '_'
	        ),
	        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bugun soat] LT [da]',
	            nextDay: '[Ertaga] LT [da]',
	            nextWeek: 'dddd [kuni soat] LT [da]',
	            lastDay: '[Kecha soat] LT [da]',
	            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Yaqin %s ichida',
	            past: 'Bir necha %s oldin',
	            s: 'soniya',
	            ss: '%d soniya',
	            m: 'bir daqiqa',
	            mm: '%d daqiqa',
	            h: 'bir soat',
	            hh: '%d soat',
	            d: 'bir kun',
	            dd: '%d kun',
	            M: 'bir oy',
	            MM: '%d oy',
	            y: 'bir yil',
	            yy: '%d yil',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uzLatn;
	
	})));


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	//! author : Chien Kira : https://github.com/chienkira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
	            '_'
	        ),
	        monthsShort: 'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
	            '_'
	        ),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /sa|ch/i,
	        isPM: function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần trước lúc] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            ss: '%d giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            w: 'một tuần',
	            ww: '%d tuần',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return vi;
	
	})));


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
	            '_'
	        ),
	        monthsShort: 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
	            '_'
	        ),
	        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[T~ódá~ý át] LT',
	            nextDay: '[T~ómó~rró~w át] LT',
	            nextWeek: 'dddd [át] LT',
	            lastDay: '[Ý~ést~érdá~ý át] LT',
	            lastWeek: '[L~ást] dddd [át] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'í~ñ %s',
	            past: '%s á~gó',
	            s: 'á ~féw ~sécó~ñds',
	            ss: '%d s~écóñ~ds',
	            m: 'á ~míñ~úté',
	            mm: '%d m~íñú~tés',
	            h: 'á~ñ hó~úr',
	            hh: '%d h~óúrs',
	            d: 'á ~dáý',
	            dd: '%d d~áýs',
	            M: 'á ~móñ~th',
	            MM: '%d m~óñt~hs',
	            y: 'á ~ýéár',
	            yy: '%d ý~éárs',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return xPseudo;
	
	})));


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var yo = moment.defineLocale('yo', {
	        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
	            '_'
	        ),
	        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Ònì ni] LT',
	            nextDay: '[Ọ̀la ni] LT',
	            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
	            lastDay: '[Àna ni] LT',
	            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ní %s',
	            past: '%s kọjá',
	            s: 'ìsẹjú aayá die',
	            ss: 'aayá %d',
	            m: 'ìsẹjú kan',
	            mm: 'ìsẹjú %d',
	            h: 'wákati kan',
	            hh: 'wákati %d',
	            d: 'ọjọ́ kan',
	            dd: 'ọjọ́ %d',
	            M: 'osù kan',
	            MM: 'osù %d',
	            y: 'ọdún kan',
	            yy: 'ọdún %d',
	        },
	        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
	        ordinal: 'ọjọ́ %d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return yo;
	
	})));


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	//! author : uu109 : https://github.com/uu109
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日Ah点mm分',
	            LLLL: 'YYYY年M月D日ddddAh点mm分',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[下]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            lastDay: '[昨天]LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[上]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s后',
	            past: '%s前',
	            s: '几秒',
	            ss: '%d 秒',
	            m: '1 分钟',
	            mm: '%d 分钟',
	            h: '1 小时',
	            hh: '%d 小时',
	            d: '1 天',
	            dd: '%d 天',
	            w: '1 周',
	            ww: '%d 周',
	            M: '1 个月',
	            MM: '%d 个月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return zhCn;
	
	})));


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	//! author : Anthony : https://github.com/anthonylau
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1200) {
	                return '上午';
	            } else if (hm === 1200) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhHk;
	
	})));


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Macau) [zh-mo]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Tan Yuanhong : https://github.com/le0tan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhMo = moment.defineLocale('zh-mo', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhMo;
	
	})));


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(465)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhTw;
	
	})));


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _utils = __webpack_require__(358);
	
	var _token = __webpack_require__(604);
	
	var _token2 = _interopRequireDefault(_token);
	
	var _android = __webpack_require__(605);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function plugin(Vue) {
	    if (Vue && Vue.http) {
	        Vue.http.interceptors.push({
	
	            request: function request(_request) {
	
	                // post请求加X-CSRFToken
	                // rel: https://docs.djangoproject.com/en/1.8/ref/csrf/
	                var params = _request.params;
	                if (_request.method === 'get') {
	                    if (_request.url.indexOf("?") > -1) {
	                        _request.url = _request.url + "&_date=" + new Date().valueOf();
	                    } else {
	                        _request.url = _request.url + "?_date=" + new Date().valueOf();
	                    }
	                    if (this.$route.query && this.$route.query.user_type) {
	                        _request.url += "&user_type=" + this.$route.query.user_type;
	                    }
	                    //添加loading router beforeeach的时候已经添加("#global_loading")了，不用新增dom
	                    var isLoading = _request.url.indexOf('noLoading') > -1 || params.noLoading;
	                    !isLoading && $("#global_loading").show();
	                }
	
	                if (_request.method === 'post' || _request.method === 'patch' || ("production") !== 'production') {
	                    _request.headers['X-CSRFToken'] = (0, _token2.default)();
	                }
	                // Flutter 设置 sessionid
	                if (localStorage) {
	                    var sessionid = localStorage.getItem('sessionid');
	                    var client = localStorage.getItem('x-client') || 'web';
	                    if (sessionid) {
	                        _request.headers['x-mobile-sessid'] = sessionid;
	                    }
	                    _request.headers['x-client'] = client;
	                }
	
	                // 获取云盘空间需要university-id
	                _request.headers['university-id'] = 0;
	                return _request;
	            },
	
	            response: function response(_response) {
	                //console.dir(response)
	                //移除loading
	                // $("#global_loading").remove();
	                $("#global_loading").hide();
	
	                if (_response.data.op && _response.data.op == 'redirect') {
	                    // 需要先登录
	                    window.location.href = '/login/weixinapp/?next=' + encodeURIComponent(window.location.href);
	
	                    // 订阅发布重新登录
	                    var pubSub = window.parent && window.parent.PubSub || null;
	                    pubSub && pubSub.publish('login', { msg: 'login' });
	
	                    return;
	                }
	
	                // fix 网页版中掉线后不知道跳转回扫码页面的情况
	                if (_response.data.op && _response.data.op == 'web_redirect') {
	                    // 需要先登录
	                    window.parent && window.parent.location.reload();
	                    return;
	                }
	                // 在手机但非微信的浏览器打开要跳走
	                // https://www.tapd.cn/20392061/bugtrace/bugs/view?bug_id=1120392061001002619
	                if (_response.data.op && _response.data.op == 'mobile_redirect') {
	                    // 需要先登录
	                    window.location.href = '/static/html/openinwx.html';
	                    return;
	                }
	                if (_response.data.op && _response.data.op == 'redirect_bind') {
	                    // 清华绑定提示页
	                    window.location.href = '/static/html/tsinghua_bind.html';
	                    return;
	                }
	
	                if (_response.data.op && _response.data.op == 'k12_redirect_bind') {
	                    // k12绑定页面
	                    window.location.href = '/v/index/need-bind';
	                    return;
	                }
	
	                // 云雨打通接口错误 根据sub_code 判断异常原因
	                if (_response.data.error_code === 40000 && _response.data.sub_code) {
	                    // sub_code为302 未做身份绑定 跳转至绑定提示页
	                    if (_response.data.sub_code === 302) {
	                        location.href = '/static/html/tsinghua_bind.html?from=2';
	                        return;
	                    }
	                }
	
	                var request = _response.request || {};
	                var data = _response.data || {};
	
	                // 请求参数skip,则跳过response处理
	                // rel: 个人信息编辑页面studentme api
	                // if (request.params.skip) {
	                //     return response
	                // }
	
	                // 接口404 500跳转到错误页面
	                // if (response.status === 404 || response.status === 500) {
	                //     pageTo(response.status)
	                // }
	
	                // 接口显示未登录， 跳转登录页
	                // if (data.error && data.error_code === 20005) {
	                //     pageTo('login')
	                // }
	                if (request.method == 'GET' && data.success == false && data.status_code > 0) {
	                    var root = Vue.config.vueRouterConfig.root == null ? "" : Vue.config.vueRouterConfig.root;
	                    var name = this.$route.name;
	                    var code = data.status_code;
	                    var params = this.$route.params;
	
	                    if (data.status_code == 5) {
	                        if ('normalcourse' === name) {
	                            return _response;
	                        }
	
	                        var nexturl = window.location.href;
	                        window.location.href = root + ('/edituserinfo_simple?next_url=' + nexturl);
	                        return;
	                    }
	
	                    if (request.url.indexOf("/notice_info") > -1) {
	                        window.location.href = root + "/error/" + code + "?from=notice_view";
	                        return;
	                    }
	                    window.location.href = root + "/error/" + code;
	                    return;
	                }
	
	                return _response;
	            }
	
	        });
	    }
	}
	
	exports.default = plugin;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _jsCookie = __webpack_require__(398);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// cookie中读取csrftoken
	// rel: https://docs.djangoproject.com/en/1.8/ref/csrf/
	// const token = Cookies.get('csrftoken') || ''
	var token = function token() {
		return _jsCookie2.default.get('csrftoken') || '';
	};
	
	exports.default = token;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.listenAndroidKeybord = exports.callFlutter = exports.isFlutterApp = exports.share = exports.backApp = exports.goAppLink = exports.isAndroid = undefined;
	
	var _stringify = __webpack_require__(364);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _appCompatible = __webpack_require__(606);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isAndroid = function () {
	  return !!(window.androidToJs && window.androidToJs.getAppName instanceof Function && window.androidToJs.getAppName() === 'com.xuetangx.ykt');
	}();
	function goAppLink(link, androidLink) {
	  if (isAndroid) {
	    // window.toLink(androidLink)
	  }
	}
	function backApp() {
	  window.androidToJs && window.androidToJs.closeActivity instanceof Function && window.androidToJs.closeActivity();
	}
	// 页面分享 
	function share() {
	  var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var desc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var link = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  var imgUrl = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	
	  window.androidToJs && window.androidToJs.shareWeixinConfig instanceof Function && window.androidToJs.shareWeixinConfig(title, desc, link, imgUrl);
	}
	/**
	 * Flutter 客户端里的功能设置
	 */
	var isFlutterApp = function isFlutterApp() {
	  return navigator.userAgent.indexOf('flutterApp') > -1;
	}();
	// Flutter 方法调用
	function callFlutter(method, data) {
	  if (isFlutterApp) {
	    var params = {
	      code: 0,
	      method: method,
	      data: data,
	      msg: 'success'
	    };
	    if (navigator.userAgent.toLocaleLowerCase().indexOf("iphone") > -1 || navigator.userAgent.toLocaleLowerCase().indexOf("ipad") > -1) {
	      try {
	        window.webkit.messageHandlers.JsCallFlutter.postMessage((0, _stringify2.default)(params));
	      } catch (error) {
	        console.log(error);
	      }
	    } else {
	      try {
	        JsCallFlutter.postMessage((0, _stringify2.default)(params));
	      } catch (error) {
	        console.log(error);
	      }
	    }
	  }
	}
	exports.isAndroid = isAndroid;
	exports.goAppLink = goAppLink;
	exports.backApp = backApp;
	exports.share = share;
	exports.isFlutterApp = isFlutterApp;
	exports.callFlutter = callFlutter;
	exports.listenAndroidKeybord = _appCompatible.listenAndroidKeybord;

/***/ }),
/* 606 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var judgeDeviceType = function () {
	  var deviceType = null;
	
	  return function () {
	    if (!deviceType) {
	      var ua = window.navigator.userAgent.toLocaleLowerCase();
	      var isIOS = /iphone|ipad|ipod/.test(ua);
	      var isAndroid = /android/.test(ua);
	      var isMiuiBrowser = /miuibrowser/.test(ua);
	      deviceType = {
	        isIOS: isIOS,
	        isAndroid: isAndroid,
	        isMiuiBrowser: isMiuiBrowser
	      };
	    }
	
	    return deviceType;
	  };
	}();
	
	function activeElementScrollIntoView() {
	  var activeEl = document.activeElement;
	  if (activeEl.tagName === 'INPUT' || activeEl.tagName === 'TEXTAREA') {
	    window.setTimeout(function () {
	      if ('scrollIntoView' in activeEl) {
	        activeEl.scrollIntoView();
	      } else {
	        activeEl.scrollIntoViewIfNeeded();
	      }
	    }, 100);
	  }
	}
	
	function listenAndroidKeybord() {
	  var _judgeDeviceType = judgeDeviceType(),
	      isAndroid = _judgeDeviceType.isAndroid,
	      isMiuiBrowser = _judgeDeviceType.isMiuiBrowser;
	
	  if (isAndroid) {
	    var androidResize = function androidResize() {
	      // 将当前焦点元素滚动到可视区
	      activeElementScrollIntoView();
	    };
	
	    // android 键盘弹出、收起，可视区高度会发生变化
	    window.addEventListener('resize', androidResize, false);
	
	    return function () {
	      window.removeEventListener('resize', androidResize, false);
	    };
	  } else if (isMiuiBrowser) {
	    var inputFocus = function inputFocus() {
	      document.body.style.marginBottom = '50px';
	      activeElementScrollIntoView();
	    };
	
	    var inputBlur = function inputBlur() {
	      document.body.style.marginBottom = '0px';
	      activeElementScrollIntoView();
	    };
	
	    var $inputs = document.getElementsByTagName('input');
	    for (var i = 0; i < $inputs.length; i++) {
	      $inputs[i].addEventListener('focus', inputFocus, false);
	      $inputs[i].addEventListener('blur', inputBlur, false);
	    }
	
	    return function () {
	      for (var _i = 0; _i < $inputs.length; _i++) {
	        $inputs[_i].removeEventListener('focus', inputFocus, false);
	        $inputs[_i].removeEventListener('blur', inputBlur, false);
	      }
	    };
	  }
	}
	
	exports.listenAndroidKeybord = listenAndroidKeybord;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	;(function () {
	
	  var vueTouch = {}
	  var Hammer =  true
	    ? __webpack_require__(608)
	    : window.Hammer
	  var gestures = ['tap', 'pan', 'pinch', 'press', 'rotate', 'swipe']
	  var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all']
	  var customEvents = {}
	
	  if (!Hammer) {
	    throw new Error('[vue-touch] cannot locate Hammer.js.')
	  }
	
	  // exposed global options
	  vueTouch.config = {}
	
	  vueTouch.install = function (Vue) {
	
	    Vue.directive('touch', {
	
	      isFn: true,
	      acceptStatement: true,
	      priority: Vue.directive('on').priority,
	
	      bind: function () {
	        if (!this.el.hammer) {
	          this.el.hammer = new Hammer.Manager(this.el)
	        }
	        var mc = this.mc = this.el.hammer
	        // determine event type
	        var event = this.arg
	        if (!event) {
	          console.warn('[vue-touch] event type argument is required.')
	        }
	        var recognizerType, recognizer
	
	        if (customEvents[event]) {
	          // custom event
	          var custom = customEvents[event]
	          recognizerType = custom.type
	          recognizer = new Hammer[capitalize(recognizerType)](custom)
	          recognizer.recognizeWith(mc.recognizers)
	          mc.add(recognizer)
	        } else {
	          // built-in event
	          for (var i = 0; i < gestures.length; i++) {
	            if (event.indexOf(gestures[i]) === 0) {
	              recognizerType = gestures[i]
	              break
	            }
	          }
	          if (!recognizerType) {
	            console.warn('[vue-touch] invalid event type: ' + event)
	            return
	          }
	          recognizer = mc.get(recognizerType)
	          if (!recognizer) {
	            // add recognizer
	            recognizer = new Hammer[capitalize(recognizerType)]()
	            // make sure multiple recognizers work together...
	            recognizer.recognizeWith(mc.recognizers)
	            mc.add(recognizer)
	          }
	          // apply global options
	          var globalOptions = vueTouch.config[recognizerType]
	          if (globalOptions) {
	            guardDirections(globalOptions)
	            recognizer.set(globalOptions)
	          }
	          // apply local options
	          var localOptions =
	            this.el.hammerOptions &&
	            this.el.hammerOptions[recognizerType]
	          if (localOptions) {
	            guardDirections(localOptions)
	            recognizer.set(localOptions)
	          }
	        }
	        this.recognizer = recognizer
	      },
	
	      update: function (fn) {
	        var mc = this.mc
	        var event = this.arg
	        // teardown old handler
	        if (this.handler) {
	          mc.off(event, this.handler)
	        }
	        if (typeof fn !== 'function') {
	          this.handler = null
	          console.warn(
	            '[vue-touch] invalid handler function for v-touch: ' +
	            this.arg + '="' + this.descriptor.raw
	          )
	        } else {
	          mc.on(event, (this.handler = fn))
	        }
	      },
	
	      unbind: function () {
	        if (this.handler) {
	          this.mc.off(this.arg, this.handler)
	        }
	        if (!Object.keys(this.mc.handlers).length) {
	          this.mc.destroy()
	          this.el.hammer = null
	        }
	      }
	    })
	
	    Vue.directive('touch-options', {
	      priority: Vue.directive('on').priority + 1,
	      update: function (options) {
	        var opts = this.el.hammerOptions || (this.el.hammerOptions = {})
	        if (!this.arg) {
	          console.warn('[vue-touch] recognizer type argument for v-touch-options is required.')
	        } else {
	          opts[this.arg] = options
	        }
	      }
	    })
	  }
	
	  /**
	   * Register a custom event.
	   *
	   * @param {String} event
	   * @param {Object} options - a Hammer.js recognizer option object.
	   *                           required fields:
	   *                           - type: the base recognizer to use for this event
	   */
	
	  vueTouch.registerCustomEvent = function (event, options) {
	    options.event = event
	    customEvents[event] = options
	  }
	
	  function capitalize (str) {
	    return str.charAt(0).toUpperCase() + str.slice(1)
	  }
	
	  function guardDirections (options) {
	    var dir = options.direction
	    if (typeof dir === 'string') {
	      var hammerDirection = 'DIRECTION_' + dir.toUpperCase()
	      if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
	        options.direction = Hammer[hammerDirection]
	      } else {
	        console.warn('[vue-touch] invalid direction: ' + dir)
	      }
	    }
	  }
	
	  if (true) {
	    module.exports = vueTouch
	  } else if (typeof define == "function" && define.amd) {
	    define([], function(){ return vueTouch })
	  } else if (window.Vue) {
	    window.VueTouch = vueTouch
	    Vue.use(vueTouch)
	  }
	
	})()


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
	 * http://hammerjs.github.io/
	 *
	 * Copyright (c) 2016 Jorik Tangelder;
	 * Licensed under the MIT license */
	(function(window, document, exportName, undefined) {
	  'use strict';
	
	var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
	var TEST_ELEMENT = document.createElement('div');
	
	var TYPE_FUNCTION = 'function';
	
	var round = Math.round;
	var abs = Math.abs;
	var now = Date.now;
	
	/**
	 * set a timeout with a given scope
	 * @param {Function} fn
	 * @param {Number} timeout
	 * @param {Object} context
	 * @returns {number}
	 */
	function setTimeoutContext(fn, timeout, context) {
	    return setTimeout(bindFn(fn, context), timeout);
	}
	
	/**
	 * if the argument is an array, we want to execute the fn on each entry
	 * if it aint an array we don't want to do a thing.
	 * this is used by all the methods that accept a single and array argument.
	 * @param {*|Array} arg
	 * @param {String} fn
	 * @param {Object} [context]
	 * @returns {Boolean}
	 */
	function invokeArrayArg(arg, fn, context) {
	    if (Array.isArray(arg)) {
	        each(arg, context[fn], context);
	        return true;
	    }
	    return false;
	}
	
	/**
	 * walk objects and arrays
	 * @param {Object} obj
	 * @param {Function} iterator
	 * @param {Object} context
	 */
	function each(obj, iterator, context) {
	    var i;
	
	    if (!obj) {
	        return;
	    }
	
	    if (obj.forEach) {
	        obj.forEach(iterator, context);
	    } else if (obj.length !== undefined) {
	        i = 0;
	        while (i < obj.length) {
	            iterator.call(context, obj[i], i, obj);
	            i++;
	        }
	    } else {
	        for (i in obj) {
	            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
	        }
	    }
	}
	
	/**
	 * wrap a method with a deprecation warning and stack trace
	 * @param {Function} method
	 * @param {String} name
	 * @param {String} message
	 * @returns {Function} A new function wrapping the supplied method.
	 */
	function deprecate(method, name, message) {
	    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
	    return function() {
	        var e = new Error('get-stack-trace');
	        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
	            .replace(/^\s+at\s+/gm, '')
	            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';
	
	        var log = window.console && (window.console.warn || window.console.log);
	        if (log) {
	            log.call(window.console, deprecationMessage, stack);
	        }
	        return method.apply(this, arguments);
	    };
	}
	
	/**
	 * extend object.
	 * means that properties in dest will be overwritten by the ones in src.
	 * @param {Object} target
	 * @param {...Object} objects_to_assign
	 * @returns {Object} target
	 */
	var assign;
	if (typeof Object.assign !== 'function') {
	    assign = function assign(target) {
	        if (target === undefined || target === null) {
	            throw new TypeError('Cannot convert undefined or null to object');
	        }
	
	        var output = Object(target);
	        for (var index = 1; index < arguments.length; index++) {
	            var source = arguments[index];
	            if (source !== undefined && source !== null) {
	                for (var nextKey in source) {
	                    if (source.hasOwnProperty(nextKey)) {
	                        output[nextKey] = source[nextKey];
	                    }
	                }
	            }
	        }
	        return output;
	    };
	} else {
	    assign = Object.assign;
	}
	
	/**
	 * extend object.
	 * means that properties in dest will be overwritten by the ones in src.
	 * @param {Object} dest
	 * @param {Object} src
	 * @param {Boolean} [merge=false]
	 * @returns {Object} dest
	 */
	var extend = deprecate(function extend(dest, src, merge) {
	    var keys = Object.keys(src);
	    var i = 0;
	    while (i < keys.length) {
	        if (!merge || (merge && dest[keys[i]] === undefined)) {
	            dest[keys[i]] = src[keys[i]];
	        }
	        i++;
	    }
	    return dest;
	}, 'extend', 'Use `assign`.');
	
	/**
	 * merge the values from src in the dest.
	 * means that properties that exist in dest will not be overwritten by src
	 * @param {Object} dest
	 * @param {Object} src
	 * @returns {Object} dest
	 */
	var merge = deprecate(function merge(dest, src) {
	    return extend(dest, src, true);
	}, 'merge', 'Use `assign`.');
	
	/**
	 * simple class inheritance
	 * @param {Function} child
	 * @param {Function} base
	 * @param {Object} [properties]
	 */
	function inherit(child, base, properties) {
	    var baseP = base.prototype,
	        childP;
	
	    childP = child.prototype = Object.create(baseP);
	    childP.constructor = child;
	    childP._super = baseP;
	
	    if (properties) {
	        assign(childP, properties);
	    }
	}
	
	/**
	 * simple function bind
	 * @param {Function} fn
	 * @param {Object} context
	 * @returns {Function}
	 */
	function bindFn(fn, context) {
	    return function boundFn() {
	        return fn.apply(context, arguments);
	    };
	}
	
	/**
	 * let a boolean value also be a function that must return a boolean
	 * this first item in args will be used as the context
	 * @param {Boolean|Function} val
	 * @param {Array} [args]
	 * @returns {Boolean}
	 */
	function boolOrFn(val, args) {
	    if (typeof val == TYPE_FUNCTION) {
	        return val.apply(args ? args[0] || undefined : undefined, args);
	    }
	    return val;
	}
	
	/**
	 * use the val2 when val1 is undefined
	 * @param {*} val1
	 * @param {*} val2
	 * @returns {*}
	 */
	function ifUndefined(val1, val2) {
	    return (val1 === undefined) ? val2 : val1;
	}
	
	/**
	 * addEventListener with multiple events at once
	 * @param {EventTarget} target
	 * @param {String} types
	 * @param {Function} handler
	 */
	function addEventListeners(target, types, handler) {
	    each(splitStr(types), function(type) {
	        target.addEventListener(type, handler, false);
	    });
	}
	
	/**
	 * removeEventListener with multiple events at once
	 * @param {EventTarget} target
	 * @param {String} types
	 * @param {Function} handler
	 */
	function removeEventListeners(target, types, handler) {
	    each(splitStr(types), function(type) {
	        target.removeEventListener(type, handler, false);
	    });
	}
	
	/**
	 * find if a node is in the given parent
	 * @method hasParent
	 * @param {HTMLElement} node
	 * @param {HTMLElement} parent
	 * @return {Boolean} found
	 */
	function hasParent(node, parent) {
	    while (node) {
	        if (node == parent) {
	            return true;
	        }
	        node = node.parentNode;
	    }
	    return false;
	}
	
	/**
	 * small indexOf wrapper
	 * @param {String} str
	 * @param {String} find
	 * @returns {Boolean} found
	 */
	function inStr(str, find) {
	    return str.indexOf(find) > -1;
	}
	
	/**
	 * split string on whitespace
	 * @param {String} str
	 * @returns {Array} words
	 */
	function splitStr(str) {
	    return str.trim().split(/\s+/g);
	}
	
	/**
	 * find if a array contains the object using indexOf or a simple polyFill
	 * @param {Array} src
	 * @param {String} find
	 * @param {String} [findByKey]
	 * @return {Boolean|Number} false when not found, or the index
	 */
	function inArray(src, find, findByKey) {
	    if (src.indexOf && !findByKey) {
	        return src.indexOf(find);
	    } else {
	        var i = 0;
	        while (i < src.length) {
	            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
	                return i;
	            }
	            i++;
	        }
	        return -1;
	    }
	}
	
	/**
	 * convert array-like objects to real arrays
	 * @param {Object} obj
	 * @returns {Array}
	 */
	function toArray(obj) {
	    return Array.prototype.slice.call(obj, 0);
	}
	
	/**
	 * unique array with objects based on a key (like 'id') or just by the array's value
	 * @param {Array} src [{id:1},{id:2},{id:1}]
	 * @param {String} [key]
	 * @param {Boolean} [sort=False]
	 * @returns {Array} [{id:1},{id:2}]
	 */
	function uniqueArray(src, key, sort) {
	    var results = [];
	    var values = [];
	    var i = 0;
	
	    while (i < src.length) {
	        var val = key ? src[i][key] : src[i];
	        if (inArray(values, val) < 0) {
	            results.push(src[i]);
	        }
	        values[i] = val;
	        i++;
	    }
	
	    if (sort) {
	        if (!key) {
	            results = results.sort();
	        } else {
	            results = results.sort(function sortUniqueArray(a, b) {
	                return a[key] > b[key];
	            });
	        }
	    }
	
	    return results;
	}
	
	/**
	 * get the prefixed property
	 * @param {Object} obj
	 * @param {String} property
	 * @returns {String|Undefined} prefixed
	 */
	function prefixed(obj, property) {
	    var prefix, prop;
	    var camelProp = property[0].toUpperCase() + property.slice(1);
	
	    var i = 0;
	    while (i < VENDOR_PREFIXES.length) {
	        prefix = VENDOR_PREFIXES[i];
	        prop = (prefix) ? prefix + camelProp : property;
	
	        if (prop in obj) {
	            return prop;
	        }
	        i++;
	    }
	    return undefined;
	}
	
	/**
	 * get a unique id
	 * @returns {number} uniqueId
	 */
	var _uniqueId = 1;
	function uniqueId() {
	    return _uniqueId++;
	}
	
	/**
	 * get the window object of an element
	 * @param {HTMLElement} element
	 * @returns {DocumentView|Window}
	 */
	function getWindowForElement(element) {
	    var doc = element.ownerDocument || element;
	    return (doc.defaultView || doc.parentWindow || window);
	}
	
	var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
	
	var SUPPORT_TOUCH = ('ontouchstart' in window);
	var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
	var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
	
	var INPUT_TYPE_TOUCH = 'touch';
	var INPUT_TYPE_PEN = 'pen';
	var INPUT_TYPE_MOUSE = 'mouse';
	var INPUT_TYPE_KINECT = 'kinect';
	
	var COMPUTE_INTERVAL = 25;
	
	var INPUT_START = 1;
	var INPUT_MOVE = 2;
	var INPUT_END = 4;
	var INPUT_CANCEL = 8;
	
	var DIRECTION_NONE = 1;
	var DIRECTION_LEFT = 2;
	var DIRECTION_RIGHT = 4;
	var DIRECTION_UP = 8;
	var DIRECTION_DOWN = 16;
	
	var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
	var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
	var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;
	
	var PROPS_XY = ['x', 'y'];
	var PROPS_CLIENT_XY = ['clientX', 'clientY'];
	
	/**
	 * create new input type manager
	 * @param {Manager} manager
	 * @param {Function} callback
	 * @returns {Input}
	 * @constructor
	 */
	function Input(manager, callback) {
	    var self = this;
	    this.manager = manager;
	    this.callback = callback;
	    this.element = manager.element;
	    this.target = manager.options.inputTarget;
	
	    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
	    // so when disabled the input events are completely bypassed.
	    this.domHandler = function(ev) {
	        if (boolOrFn(manager.options.enable, [manager])) {
	            self.handler(ev);
	        }
	    };
	
	    this.init();
	
	}
	
	Input.prototype = {
	    /**
	     * should handle the inputEvent data and trigger the callback
	     * @virtual
	     */
	    handler: function() { },
	
	    /**
	     * bind the events
	     */
	    init: function() {
	        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
	        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
	        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
	    },
	
	    /**
	     * unbind the events
	     */
	    destroy: function() {
	        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
	        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
	        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
	    }
	};
	
	/**
	 * create new input type manager
	 * called by the Manager constructor
	 * @param {Hammer} manager
	 * @returns {Input}
	 */
	function createInputInstance(manager) {
	    var Type;
	    var inputClass = manager.options.inputClass;
	
	    if (inputClass) {
	        Type = inputClass;
	    } else if (SUPPORT_POINTER_EVENTS) {
	        Type = PointerEventInput;
	    } else if (SUPPORT_ONLY_TOUCH) {
	        Type = TouchInput;
	    } else if (!SUPPORT_TOUCH) {
	        Type = MouseInput;
	    } else {
	        Type = TouchMouseInput;
	    }
	    return new (Type)(manager, inputHandler);
	}
	
	/**
	 * handle input events
	 * @param {Manager} manager
	 * @param {String} eventType
	 * @param {Object} input
	 */
	function inputHandler(manager, eventType, input) {
	    var pointersLen = input.pointers.length;
	    var changedPointersLen = input.changedPointers.length;
	    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
	    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));
	
	    input.isFirst = !!isFirst;
	    input.isFinal = !!isFinal;
	
	    if (isFirst) {
	        manager.session = {};
	    }
	
	    // source event is the normalized value of the domEvents
	    // like 'touchstart, mouseup, pointerdown'
	    input.eventType = eventType;
	
	    // compute scale, rotation etc
	    computeInputData(manager, input);
	
	    // emit secret event
	    manager.emit('hammer.input', input);
	
	    manager.recognize(input);
	    manager.session.prevInput = input;
	}
	
	/**
	 * extend the data with some usable properties like scale, rotate, velocity etc
	 * @param {Object} manager
	 * @param {Object} input
	 */
	function computeInputData(manager, input) {
	    var session = manager.session;
	    var pointers = input.pointers;
	    var pointersLength = pointers.length;
	
	    // store the first input to calculate the distance and direction
	    if (!session.firstInput) {
	        session.firstInput = simpleCloneInputData(input);
	    }
	
	    // to compute scale and rotation we need to store the multiple touches
	    if (pointersLength > 1 && !session.firstMultiple) {
	        session.firstMultiple = simpleCloneInputData(input);
	    } else if (pointersLength === 1) {
	        session.firstMultiple = false;
	    }
	
	    var firstInput = session.firstInput;
	    var firstMultiple = session.firstMultiple;
	    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
	
	    var center = input.center = getCenter(pointers);
	    input.timeStamp = now();
	    input.deltaTime = input.timeStamp - firstInput.timeStamp;
	
	    input.angle = getAngle(offsetCenter, center);
	    input.distance = getDistance(offsetCenter, center);
	
	    computeDeltaXY(session, input);
	    input.offsetDirection = getDirection(input.deltaX, input.deltaY);
	
	    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
	    input.overallVelocityX = overallVelocity.x;
	    input.overallVelocityY = overallVelocity.y;
	    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;
	
	    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
	    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;
	
	    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
	        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);
	
	    computeIntervalInputData(session, input);
	
	    // find the correct target
	    var target = manager.element;
	    if (hasParent(input.srcEvent.target, target)) {
	        target = input.srcEvent.target;
	    }
	    input.target = target;
	}
	
	function computeDeltaXY(session, input) {
	    var center = input.center;
	    var offset = session.offsetDelta || {};
	    var prevDelta = session.prevDelta || {};
	    var prevInput = session.prevInput || {};
	
	    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
	        prevDelta = session.prevDelta = {
	            x: prevInput.deltaX || 0,
	            y: prevInput.deltaY || 0
	        };
	
	        offset = session.offsetDelta = {
	            x: center.x,
	            y: center.y
	        };
	    }
	
	    input.deltaX = prevDelta.x + (center.x - offset.x);
	    input.deltaY = prevDelta.y + (center.y - offset.y);
	}
	
	/**
	 * velocity is calculated every x ms
	 * @param {Object} session
	 * @param {Object} input
	 */
	function computeIntervalInputData(session, input) {
	    var last = session.lastInterval || input,
	        deltaTime = input.timeStamp - last.timeStamp,
	        velocity, velocityX, velocityY, direction;
	
	    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
	        var deltaX = input.deltaX - last.deltaX;
	        var deltaY = input.deltaY - last.deltaY;
	
	        var v = getVelocity(deltaTime, deltaX, deltaY);
	        velocityX = v.x;
	        velocityY = v.y;
	        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
	        direction = getDirection(deltaX, deltaY);
	
	        session.lastInterval = input;
	    } else {
	        // use latest velocity info if it doesn't overtake a minimum period
	        velocity = last.velocity;
	        velocityX = last.velocityX;
	        velocityY = last.velocityY;
	        direction = last.direction;
	    }
	
	    input.velocity = velocity;
	    input.velocityX = velocityX;
	    input.velocityY = velocityY;
	    input.direction = direction;
	}
	
	/**
	 * create a simple clone from the input used for storage of firstInput and firstMultiple
	 * @param {Object} input
	 * @returns {Object} clonedInputData
	 */
	function simpleCloneInputData(input) {
	    // make a simple copy of the pointers because we will get a reference if we don't
	    // we only need clientXY for the calculations
	    var pointers = [];
	    var i = 0;
	    while (i < input.pointers.length) {
	        pointers[i] = {
	            clientX: round(input.pointers[i].clientX),
	            clientY: round(input.pointers[i].clientY)
	        };
	        i++;
	    }
	
	    return {
	        timeStamp: now(),
	        pointers: pointers,
	        center: getCenter(pointers),
	        deltaX: input.deltaX,
	        deltaY: input.deltaY
	    };
	}
	
	/**
	 * get the center of all the pointers
	 * @param {Array} pointers
	 * @return {Object} center contains `x` and `y` properties
	 */
	function getCenter(pointers) {
	    var pointersLength = pointers.length;
	
	    // no need to loop when only one touch
	    if (pointersLength === 1) {
	        return {
	            x: round(pointers[0].clientX),
	            y: round(pointers[0].clientY)
	        };
	    }
	
	    var x = 0, y = 0, i = 0;
	    while (i < pointersLength) {
	        x += pointers[i].clientX;
	        y += pointers[i].clientY;
	        i++;
	    }
	
	    return {
	        x: round(x / pointersLength),
	        y: round(y / pointersLength)
	    };
	}
	
	/**
	 * calculate the velocity between two points. unit is in px per ms.
	 * @param {Number} deltaTime
	 * @param {Number} x
	 * @param {Number} y
	 * @return {Object} velocity `x` and `y`
	 */
	function getVelocity(deltaTime, x, y) {
	    return {
	        x: x / deltaTime || 0,
	        y: y / deltaTime || 0
	    };
	}
	
	/**
	 * get the direction between two points
	 * @param {Number} x
	 * @param {Number} y
	 * @return {Number} direction
	 */
	function getDirection(x, y) {
	    if (x === y) {
	        return DIRECTION_NONE;
	    }
	
	    if (abs(x) >= abs(y)) {
	        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
	    }
	    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
	}
	
	/**
	 * calculate the absolute distance between two points
	 * @param {Object} p1 {x, y}
	 * @param {Object} p2 {x, y}
	 * @param {Array} [props] containing x and y keys
	 * @return {Number} distance
	 */
	function getDistance(p1, p2, props) {
	    if (!props) {
	        props = PROPS_XY;
	    }
	    var x = p2[props[0]] - p1[props[0]],
	        y = p2[props[1]] - p1[props[1]];
	
	    return Math.sqrt((x * x) + (y * y));
	}
	
	/**
	 * calculate the angle between two coordinates
	 * @param {Object} p1
	 * @param {Object} p2
	 * @param {Array} [props] containing x and y keys
	 * @return {Number} angle
	 */
	function getAngle(p1, p2, props) {
	    if (!props) {
	        props = PROPS_XY;
	    }
	    var x = p2[props[0]] - p1[props[0]],
	        y = p2[props[1]] - p1[props[1]];
	    return Math.atan2(y, x) * 180 / Math.PI;
	}
	
	/**
	 * calculate the rotation degrees between two pointersets
	 * @param {Array} start array of pointers
	 * @param {Array} end array of pointers
	 * @return {Number} rotation
	 */
	function getRotation(start, end) {
	    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
	}
	
	/**
	 * calculate the scale factor between two pointersets
	 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
	 * @param {Array} start array of pointers
	 * @param {Array} end array of pointers
	 * @return {Number} scale
	 */
	function getScale(start, end) {
	    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
	}
	
	var MOUSE_INPUT_MAP = {
	    mousedown: INPUT_START,
	    mousemove: INPUT_MOVE,
	    mouseup: INPUT_END
	};
	
	var MOUSE_ELEMENT_EVENTS = 'mousedown';
	var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';
	
	/**
	 * Mouse events input
	 * @constructor
	 * @extends Input
	 */
	function MouseInput() {
	    this.evEl = MOUSE_ELEMENT_EVENTS;
	    this.evWin = MOUSE_WINDOW_EVENTS;
	
	    this.pressed = false; // mousedown state
	
	    Input.apply(this, arguments);
	}
	
	inherit(MouseInput, Input, {
	    /**
	     * handle mouse events
	     * @param {Object} ev
	     */
	    handler: function MEhandler(ev) {
	        var eventType = MOUSE_INPUT_MAP[ev.type];
	
	        // on start we want to have the left mouse button down
	        if (eventType & INPUT_START && ev.button === 0) {
	            this.pressed = true;
	        }
	
	        if (eventType & INPUT_MOVE && ev.which !== 1) {
	            eventType = INPUT_END;
	        }
	
	        // mouse must be down
	        if (!this.pressed) {
	            return;
	        }
	
	        if (eventType & INPUT_END) {
	            this.pressed = false;
	        }
	
	        this.callback(this.manager, eventType, {
	            pointers: [ev],
	            changedPointers: [ev],
	            pointerType: INPUT_TYPE_MOUSE,
	            srcEvent: ev
	        });
	    }
	});
	
	var POINTER_INPUT_MAP = {
	    pointerdown: INPUT_START,
	    pointermove: INPUT_MOVE,
	    pointerup: INPUT_END,
	    pointercancel: INPUT_CANCEL,
	    pointerout: INPUT_CANCEL
	};
	
	// in IE10 the pointer types is defined as an enum
	var IE10_POINTER_TYPE_ENUM = {
	    2: INPUT_TYPE_TOUCH,
	    3: INPUT_TYPE_PEN,
	    4: INPUT_TYPE_MOUSE,
	    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
	};
	
	var POINTER_ELEMENT_EVENTS = 'pointerdown';
	var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';
	
	// IE10 has prefixed support, and case-sensitive
	if (window.MSPointerEvent && !window.PointerEvent) {
	    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
	    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
	}
	
	/**
	 * Pointer events input
	 * @constructor
	 * @extends Input
	 */
	function PointerEventInput() {
	    this.evEl = POINTER_ELEMENT_EVENTS;
	    this.evWin = POINTER_WINDOW_EVENTS;
	
	    Input.apply(this, arguments);
	
	    this.store = (this.manager.session.pointerEvents = []);
	}
	
	inherit(PointerEventInput, Input, {
	    /**
	     * handle mouse events
	     * @param {Object} ev
	     */
	    handler: function PEhandler(ev) {
	        var store = this.store;
	        var removePointer = false;
	
	        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
	        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
	        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
	
	        var isTouch = (pointerType == INPUT_TYPE_TOUCH);
	
	        // get index of the event in the store
	        var storeIndex = inArray(store, ev.pointerId, 'pointerId');
	
	        // start and mouse must be down
	        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
	            if (storeIndex < 0) {
	                store.push(ev);
	                storeIndex = store.length - 1;
	            }
	        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
	            removePointer = true;
	        }
	
	        // it not found, so the pointer hasn't been down (so it's probably a hover)
	        if (storeIndex < 0) {
	            return;
	        }
	
	        // update the event in the store
	        store[storeIndex] = ev;
	
	        this.callback(this.manager, eventType, {
	            pointers: store,
	            changedPointers: [ev],
	            pointerType: pointerType,
	            srcEvent: ev
	        });
	
	        if (removePointer) {
	            // remove from the store
	            store.splice(storeIndex, 1);
	        }
	    }
	});
	
	var SINGLE_TOUCH_INPUT_MAP = {
	    touchstart: INPUT_START,
	    touchmove: INPUT_MOVE,
	    touchend: INPUT_END,
	    touchcancel: INPUT_CANCEL
	};
	
	var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
	var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';
	
	/**
	 * Touch events input
	 * @constructor
	 * @extends Input
	 */
	function SingleTouchInput() {
	    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
	    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
	    this.started = false;
	
	    Input.apply(this, arguments);
	}
	
	inherit(SingleTouchInput, Input, {
	    handler: function TEhandler(ev) {
	        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];
	
	        // should we handle the touch events?
	        if (type === INPUT_START) {
	            this.started = true;
	        }
	
	        if (!this.started) {
	            return;
	        }
	
	        var touches = normalizeSingleTouches.call(this, ev, type);
	
	        // when done, reset the started state
	        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
	            this.started = false;
	        }
	
	        this.callback(this.manager, type, {
	            pointers: touches[0],
	            changedPointers: touches[1],
	            pointerType: INPUT_TYPE_TOUCH,
	            srcEvent: ev
	        });
	    }
	});
	
	/**
	 * @this {TouchInput}
	 * @param {Object} ev
	 * @param {Number} type flag
	 * @returns {undefined|Array} [all, changed]
	 */
	function normalizeSingleTouches(ev, type) {
	    var all = toArray(ev.touches);
	    var changed = toArray(ev.changedTouches);
	
	    if (type & (INPUT_END | INPUT_CANCEL)) {
	        all = uniqueArray(all.concat(changed), 'identifier', true);
	    }
	
	    return [all, changed];
	}
	
	var TOUCH_INPUT_MAP = {
	    touchstart: INPUT_START,
	    touchmove: INPUT_MOVE,
	    touchend: INPUT_END,
	    touchcancel: INPUT_CANCEL
	};
	
	var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';
	
	/**
	 * Multi-user touch events input
	 * @constructor
	 * @extends Input
	 */
	function TouchInput() {
	    this.evTarget = TOUCH_TARGET_EVENTS;
	    this.targetIds = {};
	
	    Input.apply(this, arguments);
	}
	
	inherit(TouchInput, Input, {
	    handler: function MTEhandler(ev) {
	        var type = TOUCH_INPUT_MAP[ev.type];
	        var touches = getTouches.call(this, ev, type);
	        if (!touches) {
	            return;
	        }
	
	        this.callback(this.manager, type, {
	            pointers: touches[0],
	            changedPointers: touches[1],
	            pointerType: INPUT_TYPE_TOUCH,
	            srcEvent: ev
	        });
	    }
	});
	
	/**
	 * @this {TouchInput}
	 * @param {Object} ev
	 * @param {Number} type flag
	 * @returns {undefined|Array} [all, changed]
	 */
	function getTouches(ev, type) {
	    var allTouches = toArray(ev.touches);
	    var targetIds = this.targetIds;
	
	    // when there is only one touch, the process can be simplified
	    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
	        targetIds[allTouches[0].identifier] = true;
	        return [allTouches, allTouches];
	    }
	
	    var i,
	        targetTouches,
	        changedTouches = toArray(ev.changedTouches),
	        changedTargetTouches = [],
	        target = this.target;
	
	    // get target touches from touches
	    targetTouches = allTouches.filter(function(touch) {
	        return hasParent(touch.target, target);
	    });
	
	    // collect touches
	    if (type === INPUT_START) {
	        i = 0;
	        while (i < targetTouches.length) {
	            targetIds[targetTouches[i].identifier] = true;
	            i++;
	        }
	    }
	
	    // filter changed touches to only contain touches that exist in the collected target ids
	    i = 0;
	    while (i < changedTouches.length) {
	        if (targetIds[changedTouches[i].identifier]) {
	            changedTargetTouches.push(changedTouches[i]);
	        }
	
	        // cleanup removed touches
	        if (type & (INPUT_END | INPUT_CANCEL)) {
	            delete targetIds[changedTouches[i].identifier];
	        }
	        i++;
	    }
	
	    if (!changedTargetTouches.length) {
	        return;
	    }
	
	    return [
	        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
	        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
	        changedTargetTouches
	    ];
	}
	
	/**
	 * Combined touch and mouse input
	 *
	 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
	 * This because touch devices also emit mouse events while doing a touch.
	 *
	 * @constructor
	 * @extends Input
	 */
	
	var DEDUP_TIMEOUT = 2500;
	var DEDUP_DISTANCE = 25;
	
	function TouchMouseInput() {
	    Input.apply(this, arguments);
	
	    var handler = bindFn(this.handler, this);
	    this.touch = new TouchInput(this.manager, handler);
	    this.mouse = new MouseInput(this.manager, handler);
	
	    this.primaryTouch = null;
	    this.lastTouches = [];
	}
	
	inherit(TouchMouseInput, Input, {
	    /**
	     * handle mouse and touch events
	     * @param {Hammer} manager
	     * @param {String} inputEvent
	     * @param {Object} inputData
	     */
	    handler: function TMEhandler(manager, inputEvent, inputData) {
	        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
	            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);
	
	        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
	            return;
	        }
	
	        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
	        if (isTouch) {
	            recordTouches.call(this, inputEvent, inputData);
	        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
	            return;
	        }
	
	        this.callback(manager, inputEvent, inputData);
	    },
	
	    /**
	     * remove the event listeners
	     */
	    destroy: function destroy() {
	        this.touch.destroy();
	        this.mouse.destroy();
	    }
	});
	
	function recordTouches(eventType, eventData) {
	    if (eventType & INPUT_START) {
	        this.primaryTouch = eventData.changedPointers[0].identifier;
	        setLastTouch.call(this, eventData);
	    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
	        setLastTouch.call(this, eventData);
	    }
	}
	
	function setLastTouch(eventData) {
	    var touch = eventData.changedPointers[0];
	
	    if (touch.identifier === this.primaryTouch) {
	        var lastTouch = {x: touch.clientX, y: touch.clientY};
	        this.lastTouches.push(lastTouch);
	        var lts = this.lastTouches;
	        var removeLastTouch = function() {
	            var i = lts.indexOf(lastTouch);
	            if (i > -1) {
	                lts.splice(i, 1);
	            }
	        };
	        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
	    }
	}
	
	function isSyntheticEvent(eventData) {
	    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
	    for (var i = 0; i < this.lastTouches.length; i++) {
	        var t = this.lastTouches[i];
	        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
	        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
	            return true;
	        }
	    }
	    return false;
	}
	
	var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
	var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;
	
	// magical touchAction value
	var TOUCH_ACTION_COMPUTE = 'compute';
	var TOUCH_ACTION_AUTO = 'auto';
	var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
	var TOUCH_ACTION_NONE = 'none';
	var TOUCH_ACTION_PAN_X = 'pan-x';
	var TOUCH_ACTION_PAN_Y = 'pan-y';
	var TOUCH_ACTION_MAP = getTouchActionProps();
	
	/**
	 * Touch Action
	 * sets the touchAction property or uses the js alternative
	 * @param {Manager} manager
	 * @param {String} value
	 * @constructor
	 */
	function TouchAction(manager, value) {
	    this.manager = manager;
	    this.set(value);
	}
	
	TouchAction.prototype = {
	    /**
	     * set the touchAction value on the element or enable the polyfill
	     * @param {String} value
	     */
	    set: function(value) {
	        // find out the touch-action by the event handlers
	        if (value == TOUCH_ACTION_COMPUTE) {
	            value = this.compute();
	        }
	
	        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
	            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
	        }
	        this.actions = value.toLowerCase().trim();
	    },
	
	    /**
	     * just re-set the touchAction value
	     */
	    update: function() {
	        this.set(this.manager.options.touchAction);
	    },
	
	    /**
	     * compute the value for the touchAction property based on the recognizer's settings
	     * @returns {String} value
	     */
	    compute: function() {
	        var actions = [];
	        each(this.manager.recognizers, function(recognizer) {
	            if (boolOrFn(recognizer.options.enable, [recognizer])) {
	                actions = actions.concat(recognizer.getTouchAction());
	            }
	        });
	        return cleanTouchActions(actions.join(' '));
	    },
	
	    /**
	     * this method is called on each input cycle and provides the preventing of the browser behavior
	     * @param {Object} input
	     */
	    preventDefaults: function(input) {
	        var srcEvent = input.srcEvent;
	        var direction = input.offsetDirection;
	
	        // if the touch action did prevented once this session
	        if (this.manager.session.prevented) {
	            srcEvent.preventDefault();
	            return;
	        }
	
	        var actions = this.actions;
	        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
	        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
	        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];
	
	        if (hasNone) {
	            //do not prevent defaults if this is a tap gesture
	
	            var isTapPointer = input.pointers.length === 1;
	            var isTapMovement = input.distance < 2;
	            var isTapTouchTime = input.deltaTime < 250;
	
	            if (isTapPointer && isTapMovement && isTapTouchTime) {
	                return;
	            }
	        }
	
	        if (hasPanX && hasPanY) {
	            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
	            return;
	        }
	
	        if (hasNone ||
	            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
	            (hasPanX && direction & DIRECTION_VERTICAL)) {
	            return this.preventSrc(srcEvent);
	        }
	    },
	
	    /**
	     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
	     * @param {Object} srcEvent
	     */
	    preventSrc: function(srcEvent) {
	        this.manager.session.prevented = true;
	        srcEvent.preventDefault();
	    }
	};
	
	/**
	 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
	 * @param {String} actions
	 * @returns {*}
	 */
	function cleanTouchActions(actions) {
	    // none
	    if (inStr(actions, TOUCH_ACTION_NONE)) {
	        return TOUCH_ACTION_NONE;
	    }
	
	    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
	    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);
	
	    // if both pan-x and pan-y are set (different recognizers
	    // for different directions, e.g. horizontal pan but vertical swipe?)
	    // we need none (as otherwise with pan-x pan-y combined none of these
	    // recognizers will work, since the browser would handle all panning
	    if (hasPanX && hasPanY) {
	        return TOUCH_ACTION_NONE;
	    }
	
	    // pan-x OR pan-y
	    if (hasPanX || hasPanY) {
	        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
	    }
	
	    // manipulation
	    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
	        return TOUCH_ACTION_MANIPULATION;
	    }
	
	    return TOUCH_ACTION_AUTO;
	}
	
	function getTouchActionProps() {
	    if (!NATIVE_TOUCH_ACTION) {
	        return false;
	    }
	    var touchMap = {};
	    var cssSupports = window.CSS && window.CSS.supports;
	    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {
	
	        // If css.supports is not supported but there is native touch-action assume it supports
	        // all values. This is the case for IE 10 and 11.
	        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
	    });
	    return touchMap;
	}
	
	/**
	 * Recognizer flow explained; *
	 * All recognizers have the initial state of POSSIBLE when a input session starts.
	 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
	 * Example session for mouse-input: mousedown -> mousemove -> mouseup
	 *
	 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
	 * which determines with state it should be.
	 *
	 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
	 * POSSIBLE to give it another change on the next cycle.
	 *
	 *               Possible
	 *                  |
	 *            +-----+---------------+
	 *            |                     |
	 *      +-----+-----+               |
	 *      |           |               |
	 *   Failed      Cancelled          |
	 *                          +-------+------+
	 *                          |              |
	 *                      Recognized       Began
	 *                                         |
	 *                                      Changed
	 *                                         |
	 *                                  Ended/Recognized
	 */
	var STATE_POSSIBLE = 1;
	var STATE_BEGAN = 2;
	var STATE_CHANGED = 4;
	var STATE_ENDED = 8;
	var STATE_RECOGNIZED = STATE_ENDED;
	var STATE_CANCELLED = 16;
	var STATE_FAILED = 32;
	
	/**
	 * Recognizer
	 * Every recognizer needs to extend from this class.
	 * @constructor
	 * @param {Object} options
	 */
	function Recognizer(options) {
	    this.options = assign({}, this.defaults, options || {});
	
	    this.id = uniqueId();
	
	    this.manager = null;
	
	    // default is enable true
	    this.options.enable = ifUndefined(this.options.enable, true);
	
	    this.state = STATE_POSSIBLE;
	
	    this.simultaneous = {};
	    this.requireFail = [];
	}
	
	Recognizer.prototype = {
	    /**
	     * @virtual
	     * @type {Object}
	     */
	    defaults: {},
	
	    /**
	     * set options
	     * @param {Object} options
	     * @return {Recognizer}
	     */
	    set: function(options) {
	        assign(this.options, options);
	
	        // also update the touchAction, in case something changed about the directions/enabled state
	        this.manager && this.manager.touchAction.update();
	        return this;
	    },
	
	    /**
	     * recognize simultaneous with an other recognizer.
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    recognizeWith: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
	            return this;
	        }
	
	        var simultaneous = this.simultaneous;
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        if (!simultaneous[otherRecognizer.id]) {
	            simultaneous[otherRecognizer.id] = otherRecognizer;
	            otherRecognizer.recognizeWith(this);
	        }
	        return this;
	    },
	
	    /**
	     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    dropRecognizeWith: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
	            return this;
	        }
	
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        delete this.simultaneous[otherRecognizer.id];
	        return this;
	    },
	
	    /**
	     * recognizer can only run when an other is failing
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    requireFailure: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
	            return this;
	        }
	
	        var requireFail = this.requireFail;
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        if (inArray(requireFail, otherRecognizer) === -1) {
	            requireFail.push(otherRecognizer);
	            otherRecognizer.requireFailure(this);
	        }
	        return this;
	    },
	
	    /**
	     * drop the requireFailure link. it does not remove the link on the other recognizer.
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    dropRequireFailure: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
	            return this;
	        }
	
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        var index = inArray(this.requireFail, otherRecognizer);
	        if (index > -1) {
	            this.requireFail.splice(index, 1);
	        }
	        return this;
	    },
	
	    /**
	     * has require failures boolean
	     * @returns {boolean}
	     */
	    hasRequireFailures: function() {
	        return this.requireFail.length > 0;
	    },
	
	    /**
	     * if the recognizer can recognize simultaneous with an other recognizer
	     * @param {Recognizer} otherRecognizer
	     * @returns {Boolean}
	     */
	    canRecognizeWith: function(otherRecognizer) {
	        return !!this.simultaneous[otherRecognizer.id];
	    },
	
	    /**
	     * You should use `tryEmit` instead of `emit` directly to check
	     * that all the needed recognizers has failed before emitting.
	     * @param {Object} input
	     */
	    emit: function(input) {
	        var self = this;
	        var state = this.state;
	
	        function emit(event) {
	            self.manager.emit(event, input);
	        }
	
	        // 'panstart' and 'panmove'
	        if (state < STATE_ENDED) {
	            emit(self.options.event + stateStr(state));
	        }
	
	        emit(self.options.event); // simple 'eventName' events
	
	        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
	            emit(input.additionalEvent);
	        }
	
	        // panend and pancancel
	        if (state >= STATE_ENDED) {
	            emit(self.options.event + stateStr(state));
	        }
	    },
	
	    /**
	     * Check that all the require failure recognizers has failed,
	     * if true, it emits a gesture event,
	     * otherwise, setup the state to FAILED.
	     * @param {Object} input
	     */
	    tryEmit: function(input) {
	        if (this.canEmit()) {
	            return this.emit(input);
	        }
	        // it's failing anyway
	        this.state = STATE_FAILED;
	    },
	
	    /**
	     * can we emit?
	     * @returns {boolean}
	     */
	    canEmit: function() {
	        var i = 0;
	        while (i < this.requireFail.length) {
	            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
	                return false;
	            }
	            i++;
	        }
	        return true;
	    },
	
	    /**
	     * update the recognizer
	     * @param {Object} inputData
	     */
	    recognize: function(inputData) {
	        // make a new copy of the inputData
	        // so we can change the inputData without messing up the other recognizers
	        var inputDataClone = assign({}, inputData);
	
	        // is is enabled and allow recognizing?
	        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
	            this.reset();
	            this.state = STATE_FAILED;
	            return;
	        }
	
	        // reset when we've reached the end
	        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
	            this.state = STATE_POSSIBLE;
	        }
	
	        this.state = this.process(inputDataClone);
	
	        // the recognizer has recognized a gesture
	        // so trigger an event
	        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
	            this.tryEmit(inputDataClone);
	        }
	    },
	
	    /**
	     * return the state of the recognizer
	     * the actual recognizing happens in this method
	     * @virtual
	     * @param {Object} inputData
	     * @returns {Const} STATE
	     */
	    process: function(inputData) { }, // jshint ignore:line
	
	    /**
	     * return the preferred touch-action
	     * @virtual
	     * @returns {Array}
	     */
	    getTouchAction: function() { },
	
	    /**
	     * called when the gesture isn't allowed to recognize
	     * like when another is being recognized or it is disabled
	     * @virtual
	     */
	    reset: function() { }
	};
	
	/**
	 * get a usable string, used as event postfix
	 * @param {Const} state
	 * @returns {String} state
	 */
	function stateStr(state) {
	    if (state & STATE_CANCELLED) {
	        return 'cancel';
	    } else if (state & STATE_ENDED) {
	        return 'end';
	    } else if (state & STATE_CHANGED) {
	        return 'move';
	    } else if (state & STATE_BEGAN) {
	        return 'start';
	    }
	    return '';
	}
	
	/**
	 * direction cons to string
	 * @param {Const} direction
	 * @returns {String}
	 */
	function directionStr(direction) {
	    if (direction == DIRECTION_DOWN) {
	        return 'down';
	    } else if (direction == DIRECTION_UP) {
	        return 'up';
	    } else if (direction == DIRECTION_LEFT) {
	        return 'left';
	    } else if (direction == DIRECTION_RIGHT) {
	        return 'right';
	    }
	    return '';
	}
	
	/**
	 * get a recognizer by name if it is bound to a manager
	 * @param {Recognizer|String} otherRecognizer
	 * @param {Recognizer} recognizer
	 * @returns {Recognizer}
	 */
	function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
	    var manager = recognizer.manager;
	    if (manager) {
	        return manager.get(otherRecognizer);
	    }
	    return otherRecognizer;
	}
	
	/**
	 * This recognizer is just used as a base for the simple attribute recognizers.
	 * @constructor
	 * @extends Recognizer
	 */
	function AttrRecognizer() {
	    Recognizer.apply(this, arguments);
	}
	
	inherit(AttrRecognizer, Recognizer, {
	    /**
	     * @namespace
	     * @memberof AttrRecognizer
	     */
	    defaults: {
	        /**
	         * @type {Number}
	         * @default 1
	         */
	        pointers: 1
	    },
	
	    /**
	     * Used to check if it the recognizer receives valid input, like input.distance > 10.
	     * @memberof AttrRecognizer
	     * @param {Object} input
	     * @returns {Boolean} recognized
	     */
	    attrTest: function(input) {
	        var optionPointers = this.options.pointers;
	        return optionPointers === 0 || input.pointers.length === optionPointers;
	    },
	
	    /**
	     * Process the input and return the state for the recognizer
	     * @memberof AttrRecognizer
	     * @param {Object} input
	     * @returns {*} State
	     */
	    process: function(input) {
	        var state = this.state;
	        var eventType = input.eventType;
	
	        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
	        var isValid = this.attrTest(input);
	
	        // on cancel input and we've recognized before, return STATE_CANCELLED
	        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
	            return state | STATE_CANCELLED;
	        } else if (isRecognized || isValid) {
	            if (eventType & INPUT_END) {
	                return state | STATE_ENDED;
	            } else if (!(state & STATE_BEGAN)) {
	                return STATE_BEGAN;
	            }
	            return state | STATE_CHANGED;
	        }
	        return STATE_FAILED;
	    }
	});
	
	/**
	 * Pan
	 * Recognized when the pointer is down and moved in the allowed direction.
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function PanRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	
	    this.pX = null;
	    this.pY = null;
	}
	
	inherit(PanRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof PanRecognizer
	     */
	    defaults: {
	        event: 'pan',
	        threshold: 10,
	        pointers: 1,
	        direction: DIRECTION_ALL
	    },
	
	    getTouchAction: function() {
	        var direction = this.options.direction;
	        var actions = [];
	        if (direction & DIRECTION_HORIZONTAL) {
	            actions.push(TOUCH_ACTION_PAN_Y);
	        }
	        if (direction & DIRECTION_VERTICAL) {
	            actions.push(TOUCH_ACTION_PAN_X);
	        }
	        return actions;
	    },
	
	    directionTest: function(input) {
	        var options = this.options;
	        var hasMoved = true;
	        var distance = input.distance;
	        var direction = input.direction;
	        var x = input.deltaX;
	        var y = input.deltaY;
	
	        // lock to axis?
	        if (!(direction & options.direction)) {
	            if (options.direction & DIRECTION_HORIZONTAL) {
	                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
	                hasMoved = x != this.pX;
	                distance = Math.abs(input.deltaX);
	            } else {
	                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
	                hasMoved = y != this.pY;
	                distance = Math.abs(input.deltaY);
	            }
	        }
	        input.direction = direction;
	        return hasMoved && distance > options.threshold && direction & options.direction;
	    },
	
	    attrTest: function(input) {
	        return AttrRecognizer.prototype.attrTest.call(this, input) &&
	            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
	    },
	
	    emit: function(input) {
	
	        this.pX = input.deltaX;
	        this.pY = input.deltaY;
	
	        var direction = directionStr(input.direction);
	
	        if (direction) {
	            input.additionalEvent = this.options.event + direction;
	        }
	        this._super.emit.call(this, input);
	    }
	});
	
	/**
	 * Pinch
	 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function PinchRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	}
	
	inherit(PinchRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof PinchRecognizer
	     */
	    defaults: {
	        event: 'pinch',
	        threshold: 0,
	        pointers: 2
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_NONE];
	    },
	
	    attrTest: function(input) {
	        return this._super.attrTest.call(this, input) &&
	            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
	    },
	
	    emit: function(input) {
	        if (input.scale !== 1) {
	            var inOut = input.scale < 1 ? 'in' : 'out';
	            input.additionalEvent = this.options.event + inOut;
	        }
	        this._super.emit.call(this, input);
	    }
	});
	
	/**
	 * Press
	 * Recognized when the pointer is down for x ms without any movement.
	 * @constructor
	 * @extends Recognizer
	 */
	function PressRecognizer() {
	    Recognizer.apply(this, arguments);
	
	    this._timer = null;
	    this._input = null;
	}
	
	inherit(PressRecognizer, Recognizer, {
	    /**
	     * @namespace
	     * @memberof PressRecognizer
	     */
	    defaults: {
	        event: 'press',
	        pointers: 1,
	        time: 251, // minimal time of the pointer to be pressed
	        threshold: 9 // a minimal movement is ok, but keep it low
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_AUTO];
	    },
	
	    process: function(input) {
	        var options = this.options;
	        var validPointers = input.pointers.length === options.pointers;
	        var validMovement = input.distance < options.threshold;
	        var validTime = input.deltaTime > options.time;
	
	        this._input = input;
	
	        // we only allow little movement
	        // and we've reached an end event, so a tap is possible
	        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
	            this.reset();
	        } else if (input.eventType & INPUT_START) {
	            this.reset();
	            this._timer = setTimeoutContext(function() {
	                this.state = STATE_RECOGNIZED;
	                this.tryEmit();
	            }, options.time, this);
	        } else if (input.eventType & INPUT_END) {
	            return STATE_RECOGNIZED;
	        }
	        return STATE_FAILED;
	    },
	
	    reset: function() {
	        clearTimeout(this._timer);
	    },
	
	    emit: function(input) {
	        if (this.state !== STATE_RECOGNIZED) {
	            return;
	        }
	
	        if (input && (input.eventType & INPUT_END)) {
	            this.manager.emit(this.options.event + 'up', input);
	        } else {
	            this._input.timeStamp = now();
	            this.manager.emit(this.options.event, this._input);
	        }
	    }
	});
	
	/**
	 * Rotate
	 * Recognized when two or more pointer are moving in a circular motion.
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function RotateRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	}
	
	inherit(RotateRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof RotateRecognizer
	     */
	    defaults: {
	        event: 'rotate',
	        threshold: 0,
	        pointers: 2
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_NONE];
	    },
	
	    attrTest: function(input) {
	        return this._super.attrTest.call(this, input) &&
	            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
	    }
	});
	
	/**
	 * Swipe
	 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function SwipeRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	}
	
	inherit(SwipeRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof SwipeRecognizer
	     */
	    defaults: {
	        event: 'swipe',
	        threshold: 10,
	        velocity: 0.3,
	        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
	        pointers: 1
	    },
	
	    getTouchAction: function() {
	        return PanRecognizer.prototype.getTouchAction.call(this);
	    },
	
	    attrTest: function(input) {
	        var direction = this.options.direction;
	        var velocity;
	
	        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
	            velocity = input.overallVelocity;
	        } else if (direction & DIRECTION_HORIZONTAL) {
	            velocity = input.overallVelocityX;
	        } else if (direction & DIRECTION_VERTICAL) {
	            velocity = input.overallVelocityY;
	        }
	
	        return this._super.attrTest.call(this, input) &&
	            direction & input.offsetDirection &&
	            input.distance > this.options.threshold &&
	            input.maxPointers == this.options.pointers &&
	            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
	    },
	
	    emit: function(input) {
	        var direction = directionStr(input.offsetDirection);
	        if (direction) {
	            this.manager.emit(this.options.event + direction, input);
	        }
	
	        this.manager.emit(this.options.event, input);
	    }
	});
	
	/**
	 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
	 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
	 * a single tap.
	 *
	 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
	 * multi-taps being recognized.
	 * @constructor
	 * @extends Recognizer
	 */
	function TapRecognizer() {
	    Recognizer.apply(this, arguments);
	
	    // previous time and center,
	    // used for tap counting
	    this.pTime = false;
	    this.pCenter = false;
	
	    this._timer = null;
	    this._input = null;
	    this.count = 0;
	}
	
	inherit(TapRecognizer, Recognizer, {
	    /**
	     * @namespace
	     * @memberof PinchRecognizer
	     */
	    defaults: {
	        event: 'tap',
	        pointers: 1,
	        taps: 1,
	        interval: 300, // max time between the multi-tap taps
	        time: 250, // max time of the pointer to be down (like finger on the screen)
	        threshold: 9, // a minimal movement is ok, but keep it low
	        posThreshold: 10 // a multi-tap can be a bit off the initial position
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_MANIPULATION];
	    },
	
	    process: function(input) {
	        var options = this.options;
	
	        var validPointers = input.pointers.length === options.pointers;
	        var validMovement = input.distance < options.threshold;
	        var validTouchTime = input.deltaTime < options.time;
	
	        this.reset();
	
	        if ((input.eventType & INPUT_START) && (this.count === 0)) {
	            return this.failTimeout();
	        }
	
	        // we only allow little movement
	        // and we've reached an end event, so a tap is possible
	        if (validMovement && validTouchTime && validPointers) {
	            if (input.eventType != INPUT_END) {
	                return this.failTimeout();
	            }
	
	            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
	            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;
	
	            this.pTime = input.timeStamp;
	            this.pCenter = input.center;
	
	            if (!validMultiTap || !validInterval) {
	                this.count = 1;
	            } else {
	                this.count += 1;
	            }
	
	            this._input = input;
	
	            // if tap count matches we have recognized it,
	            // else it has began recognizing...
	            var tapCount = this.count % options.taps;
	            if (tapCount === 0) {
	                // no failing requirements, immediately trigger the tap event
	                // or wait as long as the multitap interval to trigger
	                if (!this.hasRequireFailures()) {
	                    return STATE_RECOGNIZED;
	                } else {
	                    this._timer = setTimeoutContext(function() {
	                        this.state = STATE_RECOGNIZED;
	                        this.tryEmit();
	                    }, options.interval, this);
	                    return STATE_BEGAN;
	                }
	            }
	        }
	        return STATE_FAILED;
	    },
	
	    failTimeout: function() {
	        this._timer = setTimeoutContext(function() {
	            this.state = STATE_FAILED;
	        }, this.options.interval, this);
	        return STATE_FAILED;
	    },
	
	    reset: function() {
	        clearTimeout(this._timer);
	    },
	
	    emit: function() {
	        if (this.state == STATE_RECOGNIZED) {
	            this._input.tapCount = this.count;
	            this.manager.emit(this.options.event, this._input);
	        }
	    }
	});
	
	/**
	 * Simple way to create a manager with a default set of recognizers.
	 * @param {HTMLElement} element
	 * @param {Object} [options]
	 * @constructor
	 */
	function Hammer(element, options) {
	    options = options || {};
	    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
	    return new Manager(element, options);
	}
	
	/**
	 * @const {string}
	 */
	Hammer.VERSION = '2.0.7';
	
	/**
	 * default settings
	 * @namespace
	 */
	Hammer.defaults = {
	    /**
	     * set if DOM events are being triggered.
	     * But this is slower and unused by simple implementations, so disabled by default.
	     * @type {Boolean}
	     * @default false
	     */
	    domEvents: false,
	
	    /**
	     * The value for the touchAction property/fallback.
	     * When set to `compute` it will magically set the correct value based on the added recognizers.
	     * @type {String}
	     * @default compute
	     */
	    touchAction: TOUCH_ACTION_COMPUTE,
	
	    /**
	     * @type {Boolean}
	     * @default true
	     */
	    enable: true,
	
	    /**
	     * EXPERIMENTAL FEATURE -- can be removed/changed
	     * Change the parent input target element.
	     * If Null, then it is being set the to main element.
	     * @type {Null|EventTarget}
	     * @default null
	     */
	    inputTarget: null,
	
	    /**
	     * force an input class
	     * @type {Null|Function}
	     * @default null
	     */
	    inputClass: null,
	
	    /**
	     * Default recognizer setup when calling `Hammer()`
	     * When creating a new Manager these will be skipped.
	     * @type {Array}
	     */
	    preset: [
	        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
	        [RotateRecognizer, {enable: false}],
	        [PinchRecognizer, {enable: false}, ['rotate']],
	        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
	        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
	        [TapRecognizer],
	        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
	        [PressRecognizer]
	    ],
	
	    /**
	     * Some CSS properties can be used to improve the working of Hammer.
	     * Add them to this method and they will be set when creating a new Manager.
	     * @namespace
	     */
	    cssProps: {
	        /**
	         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
	         * @type {String}
	         * @default 'none'
	         */
	        userSelect: 'none',
	
	        /**
	         * Disable the Windows Phone grippers when pressing an element.
	         * @type {String}
	         * @default 'none'
	         */
	        touchSelect: 'none',
	
	        /**
	         * Disables the default callout shown when you touch and hold a touch target.
	         * On iOS, when you touch and hold a touch target such as a link, Safari displays
	         * a callout containing information about the link. This property allows you to disable that callout.
	         * @type {String}
	         * @default 'none'
	         */
	        touchCallout: 'none',
	
	        /**
	         * Specifies whether zooming is enabled. Used by IE10>
	         * @type {String}
	         * @default 'none'
	         */
	        contentZooming: 'none',
	
	        /**
	         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
	         * @type {String}
	         * @default 'none'
	         */
	        userDrag: 'none',
	
	        /**
	         * Overrides the highlight color shown when the user taps a link or a JavaScript
	         * clickable element in iOS. This property obeys the alpha value, if specified.
	         * @type {String}
	         * @default 'rgba(0,0,0,0)'
	         */
	        tapHighlightColor: 'rgba(0,0,0,0)'
	    }
	};
	
	var STOP = 1;
	var FORCED_STOP = 2;
	
	/**
	 * Manager
	 * @param {HTMLElement} element
	 * @param {Object} [options]
	 * @constructor
	 */
	function Manager(element, options) {
	    this.options = assign({}, Hammer.defaults, options || {});
	
	    this.options.inputTarget = this.options.inputTarget || element;
	
	    this.handlers = {};
	    this.session = {};
	    this.recognizers = [];
	    this.oldCssProps = {};
	
	    this.element = element;
	    this.input = createInputInstance(this);
	    this.touchAction = new TouchAction(this, this.options.touchAction);
	
	    toggleCssProps(this, true);
	
	    each(this.options.recognizers, function(item) {
	        var recognizer = this.add(new (item[0])(item[1]));
	        item[2] && recognizer.recognizeWith(item[2]);
	        item[3] && recognizer.requireFailure(item[3]);
	    }, this);
	}
	
	Manager.prototype = {
	    /**
	     * set options
	     * @param {Object} options
	     * @returns {Manager}
	     */
	    set: function(options) {
	        assign(this.options, options);
	
	        // Options that need a little more setup
	        if (options.touchAction) {
	            this.touchAction.update();
	        }
	        if (options.inputTarget) {
	            // Clean up existing event listeners and reinitialize
	            this.input.destroy();
	            this.input.target = options.inputTarget;
	            this.input.init();
	        }
	        return this;
	    },
	
	    /**
	     * stop recognizing for this session.
	     * This session will be discarded, when a new [input]start event is fired.
	     * When forced, the recognizer cycle is stopped immediately.
	     * @param {Boolean} [force]
	     */
	    stop: function(force) {
	        this.session.stopped = force ? FORCED_STOP : STOP;
	    },
	
	    /**
	     * run the recognizers!
	     * called by the inputHandler function on every movement of the pointers (touches)
	     * it walks through all the recognizers and tries to detect the gesture that is being made
	     * @param {Object} inputData
	     */
	    recognize: function(inputData) {
	        var session = this.session;
	        if (session.stopped) {
	            return;
	        }
	
	        // run the touch-action polyfill
	        this.touchAction.preventDefaults(inputData);
	
	        var recognizer;
	        var recognizers = this.recognizers;
	
	        // this holds the recognizer that is being recognized.
	        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
	        // if no recognizer is detecting a thing, it is set to `null`
	        var curRecognizer = session.curRecognizer;
	
	        // reset when the last recognizer is recognized
	        // or when we're in a new session
	        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
	            curRecognizer = session.curRecognizer = null;
	        }
	
	        var i = 0;
	        while (i < recognizers.length) {
	            recognizer = recognizers[i];
	
	            // find out if we are allowed try to recognize the input for this one.
	            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
	            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
	            //      that is being recognized.
	            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
	            //      this can be setup with the `recognizeWith()` method on the recognizer.
	            if (session.stopped !== FORCED_STOP && ( // 1
	                    !curRecognizer || recognizer == curRecognizer || // 2
	                    recognizer.canRecognizeWith(curRecognizer))) { // 3
	                recognizer.recognize(inputData);
	            } else {
	                recognizer.reset();
	            }
	
	            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
	            // current active recognizer. but only if we don't already have an active recognizer
	            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
	                curRecognizer = session.curRecognizer = recognizer;
	            }
	            i++;
	        }
	    },
	
	    /**
	     * get a recognizer by its event name.
	     * @param {Recognizer|String} recognizer
	     * @returns {Recognizer|Null}
	     */
	    get: function(recognizer) {
	        if (recognizer instanceof Recognizer) {
	            return recognizer;
	        }
	
	        var recognizers = this.recognizers;
	        for (var i = 0; i < recognizers.length; i++) {
	            if (recognizers[i].options.event == recognizer) {
	                return recognizers[i];
	            }
	        }
	        return null;
	    },
	
	    /**
	     * add a recognizer to the manager
	     * existing recognizers with the same event name will be removed
	     * @param {Recognizer} recognizer
	     * @returns {Recognizer|Manager}
	     */
	    add: function(recognizer) {
	        if (invokeArrayArg(recognizer, 'add', this)) {
	            return this;
	        }
	
	        // remove existing
	        var existing = this.get(recognizer.options.event);
	        if (existing) {
	            this.remove(existing);
	        }
	
	        this.recognizers.push(recognizer);
	        recognizer.manager = this;
	
	        this.touchAction.update();
	        return recognizer;
	    },
	
	    /**
	     * remove a recognizer by name or instance
	     * @param {Recognizer|String} recognizer
	     * @returns {Manager}
	     */
	    remove: function(recognizer) {
	        if (invokeArrayArg(recognizer, 'remove', this)) {
	            return this;
	        }
	
	        recognizer = this.get(recognizer);
	
	        // let's make sure this recognizer exists
	        if (recognizer) {
	            var recognizers = this.recognizers;
	            var index = inArray(recognizers, recognizer);
	
	            if (index !== -1) {
	                recognizers.splice(index, 1);
	                this.touchAction.update();
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * bind event
	     * @param {String} events
	     * @param {Function} handler
	     * @returns {EventEmitter} this
	     */
	    on: function(events, handler) {
	        if (events === undefined) {
	            return;
	        }
	        if (handler === undefined) {
	            return;
	        }
	
	        var handlers = this.handlers;
	        each(splitStr(events), function(event) {
	            handlers[event] = handlers[event] || [];
	            handlers[event].push(handler);
	        });
	        return this;
	    },
	
	    /**
	     * unbind event, leave emit blank to remove all handlers
	     * @param {String} events
	     * @param {Function} [handler]
	     * @returns {EventEmitter} this
	     */
	    off: function(events, handler) {
	        if (events === undefined) {
	            return;
	        }
	
	        var handlers = this.handlers;
	        each(splitStr(events), function(event) {
	            if (!handler) {
	                delete handlers[event];
	            } else {
	                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
	            }
	        });
	        return this;
	    },
	
	    /**
	     * emit event to the listeners
	     * @param {String} event
	     * @param {Object} data
	     */
	    emit: function(event, data) {
	        // we also want to trigger dom events
	        if (this.options.domEvents) {
	            triggerDomEvent(event, data);
	        }
	
	        // no handlers, so skip it all
	        var handlers = this.handlers[event] && this.handlers[event].slice();
	        if (!handlers || !handlers.length) {
	            return;
	        }
	
	        data.type = event;
	        data.preventDefault = function() {
	            data.srcEvent.preventDefault();
	        };
	
	        var i = 0;
	        while (i < handlers.length) {
	            handlers[i](data);
	            i++;
	        }
	    },
	
	    /**
	     * destroy the manager and unbinds all events
	     * it doesn't unbind dom events, that is the user own responsibility
	     */
	    destroy: function() {
	        this.element && toggleCssProps(this, false);
	
	        this.handlers = {};
	        this.session = {};
	        this.input.destroy();
	        this.element = null;
	    }
	};
	
	/**
	 * add/remove the css properties as defined in manager.options.cssProps
	 * @param {Manager} manager
	 * @param {Boolean} add
	 */
	function toggleCssProps(manager, add) {
	    var element = manager.element;
	    if (!element.style) {
	        return;
	    }
	    var prop;
	    each(manager.options.cssProps, function(value, name) {
	        prop = prefixed(element.style, name);
	        if (add) {
	            manager.oldCssProps[prop] = element.style[prop];
	            element.style[prop] = value;
	        } else {
	            element.style[prop] = manager.oldCssProps[prop] || '';
	        }
	    });
	    if (!add) {
	        manager.oldCssProps = {};
	    }
	}
	
	/**
	 * trigger dom event
	 * @param {String} event
	 * @param {Object} data
	 */
	function triggerDomEvent(event, data) {
	    var gestureEvent = document.createEvent('Event');
	    gestureEvent.initEvent(event, true, true);
	    gestureEvent.gesture = data;
	    data.target.dispatchEvent(gestureEvent);
	}
	
	assign(Hammer, {
	    INPUT_START: INPUT_START,
	    INPUT_MOVE: INPUT_MOVE,
	    INPUT_END: INPUT_END,
	    INPUT_CANCEL: INPUT_CANCEL,
	
	    STATE_POSSIBLE: STATE_POSSIBLE,
	    STATE_BEGAN: STATE_BEGAN,
	    STATE_CHANGED: STATE_CHANGED,
	    STATE_ENDED: STATE_ENDED,
	    STATE_RECOGNIZED: STATE_RECOGNIZED,
	    STATE_CANCELLED: STATE_CANCELLED,
	    STATE_FAILED: STATE_FAILED,
	
	    DIRECTION_NONE: DIRECTION_NONE,
	    DIRECTION_LEFT: DIRECTION_LEFT,
	    DIRECTION_RIGHT: DIRECTION_RIGHT,
	    DIRECTION_UP: DIRECTION_UP,
	    DIRECTION_DOWN: DIRECTION_DOWN,
	    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
	    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
	    DIRECTION_ALL: DIRECTION_ALL,
	
	    Manager: Manager,
	    Input: Input,
	    TouchAction: TouchAction,
	
	    TouchInput: TouchInput,
	    MouseInput: MouseInput,
	    PointerEventInput: PointerEventInput,
	    TouchMouseInput: TouchMouseInput,
	    SingleTouchInput: SingleTouchInput,
	
	    Recognizer: Recognizer,
	    AttrRecognizer: AttrRecognizer,
	    Tap: TapRecognizer,
	    Pan: PanRecognizer,
	    Swipe: SwipeRecognizer,
	    Pinch: PinchRecognizer,
	    Rotate: RotateRecognizer,
	    Press: PressRecognizer,
	
	    on: addEventListeners,
	    off: removeEventListeners,
	    each: each,
	    merge: merge,
	    extend: extend,
	    assign: assign,
	    inherit: inherit,
	    bindFn: bindFn,
	    prefixed: prefixed
	});
	
	// this prevents errors when Hammer is loaded in the presence of an AMD
	//  style loader but by script tag, not by the loader.
	var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
	freeGlobal.Hammer = Hammer;
	
	if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	        return Hammer;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module != 'undefined' && module.exports) {
	    module.exports = Hammer;
	} else {
	    window[exportName] = Hammer;
	}
	
	})(window, document, 'Hammer');


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * vue-i18n v4.10.0
	 * (c) 2017 kazuya kawaguchi
	 * Released under the MIT License.
	 */
	'use strict';
	
	var babelHelpers = {};
	babelHelpers.typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	babelHelpers;
	
	/**
	 * warn
	 *
	 * @param {String} msg
	 * @param {Error} [err]
	 *
	 */
	
	function warn(msg, err) {
	  if (window.console) {
	    console.warn('[vue-i18n] ' + msg);
	    if (err) {
	      console.warn(err.stack);
	    }
	  }
	}
	
	function Asset (Vue, langVM) {
	  /**
	   * Register or retrieve a global locale definition.
	   *
	   * @param {String} id
	   * @param {Object | Function | Promise} definition
	   * @param {Function} cb
	   */
	
	  Vue.locale = function (id, definition, cb) {
	    if (definition === undefined) {
	      // gettter
	      return langVM.locales[id];
	    } else {
	      // setter
	      if (definition === null) {
	        langVM.locales[id] = undefined;
	        delete langVM.locales[id];
	      } else {
	        setLocale(id, definition, function (locale) {
	          if (locale) {
	            langVM.locales[id] = locale;
	          } else {
	            warn('failed set `' + id + '` locale');
	          }
	          cb && cb();
	        });
	      }
	    }
	  };
	}
	
	function setLocale(id, definition, cb) {
	  var _this = this;
	
	  if ((typeof definition === 'undefined' ? 'undefined' : babelHelpers.typeof(definition)) === 'object') {
	    // sync
	    cb(definition);
	  } else {
	    (function () {
	      var future = definition.call(_this);
	      if (typeof future === 'function') {
	        if (future.resolved) {
	          // cached
	          cb(future.resolved);
	        } else if (future.requested) {
	          // pool callbacks
	          future.pendingCallbacks.push(cb);
	        } else {
	          (function () {
	            future.requested = true;
	            var cbs = future.pendingCallbacks = [cb];
	            future(function (locale) {
	              // resolve
	              future.resolved = locale;
	              for (var i = 0, l = cbs.length; i < l; i++) {
	                cbs[i](locale);
	              }
	            }, function () {
	              // reject
	              cb();
	            });
	          })();
	        }
	      } else if (isPromise(future)) {
	        // promise
	        future.then(function (locale) {
	          // resolve
	          cb(locale);
	        }, function () {
	          // reject
	          cb();
	        }).catch(function (err) {
	          console.error(err);
	          cb();
	        });
	      }
	    })();
	  }
	}
	
	/**
	 * Forgiving check for a promise
	 *
	 * @param {Object} p
	 * @return {Boolean}
	 */
	
	function isPromise(p) {
	  return p && typeof p.then === 'function';
	}
	
	function Override (Vue, langVM, version) {
	  function update(vm) {
	    if (version > 1) {
	      vm.$forceUpdate();
	    } else {
	      var i = vm._watchers.length;
	      while (i--) {
	        vm._watchers[i].update(true); // shallow updates
	      }
	    }
	  }
	
	  // override _init
	  var init = Vue.prototype._init;
	  Vue.prototype._init = function (options) {
	    var _this = this;
	
	    init.call(this, options);
	
	    if (!this.$parent) {
	      // root
	      this._$lang = langVM;
	      this._langUnwatch = this._$lang.$watch('$data', function (val, old) {
	        update(_this);
	      }, { deep: true });
	    }
	  };
	
	  // override _destroy
	  var destroy = Vue.prototype._destroy;
	  Vue.prototype._destroy = function () {
	    if (!this.$parent && this._langUnwatch) {
	      this._langUnwatch();
	      this._langUnwatch = null;
	      this._$lang = null;
	    }
	
	    destroy.apply(this, arguments);
	  };
	}
	
	/**
	 * Observer
	 */
	
	var Watcher = void 0;
	/**
	 * getWatcher
	 *
	 * @param {Vue} vm
	 * @return {Watcher}
	 */
	
	function getWatcher(vm) {
	  if (!Watcher) {
	    var unwatch = vm.$watch('__watcher__', function (a) {});
	    Watcher = vm._watchers[0].constructor;
	    unwatch();
	  }
	  return Watcher;
	}
	
	var Dep = void 0;
	/**
	 * getDep
	 *
	 * @param {Vue} vm
	 * @return {Dep}
	 */
	
	function getDep(vm) {
	  if (!Dep && vm && vm._data && vm._data.__ob__ && vm._data.__ob__.dep) {
	    Dep = vm._data.__ob__.dep.constructor;
	  }
	  return Dep;
	}
	
	var fallback = void 0; // fallback lang
	var missingHandler = null; // missing handler
	var i18nFormatter = null; // custom formatter
	
	function Config (Vue, langVM, lang) {
	  var bind = Vue.util.bind;
	
	  var Watcher = getWatcher(langVM);
	  var Dep = getDep(langVM);
	
	  function makeComputedGetter(getter, owner) {
	    var watcher = new Watcher(owner, getter, null, {
	      lazy: true
	    });
	
	    return function computedGetter() {
	      watcher.dirty && watcher.evaluate();
	      Dep && Dep.target && watcher.depend();
	      return watcher.value;
	    };
	  }
	
	  // define Vue.config.lang configration
	  Object.defineProperty(Vue.config, 'lang', {
	    enumerable: true,
	    configurable: true,
	    get: makeComputedGetter(function () {
	      return langVM.lang;
	    }, langVM),
	    set: bind(function (val) {
	      langVM.lang = val;
	    }, langVM)
	  });
	
	  // define Vue.config.fallbackLang configration
	  fallback = lang;
	  Object.defineProperty(Vue.config, 'fallbackLang', {
	    enumerable: true,
	    configurable: true,
	    get: function get() {
	      return fallback;
	    },
	    set: function set(val) {
	      fallback = val;
	    }
	  });
	
	  // define Vue.config.missingHandler configration
	  Object.defineProperty(Vue.config, 'missingHandler', {
	    enumerable: true,
	    configurable: true,
	    get: function get() {
	      return missingHandler;
	    },
	    set: function set(val) {
	      missingHandler = val;
	    }
	  });
	
	  // define Vue.config.i18Formatter configration
	  Object.defineProperty(Vue.config, 'i18nFormatter', {
	    enumerable: true,
	    configurable: true,
	    get: function get() {
	      return i18nFormatter;
	    },
	    set: function set(val) {
	      i18nFormatter = val;
	    }
	  });
	}
	
	/**
	 * utilites
	 */
	
	/**
	 * isNil
	 *
	 * @param {*} val
	 * @return Boolean
	 */
	function isNil(val) {
	  return val === null || val === undefined;
	}
	
	/**
	 *  String format template
	 *  - Inspired:
	 *    https://github.com/Matt-Esch/string-template/index.js
	 */
	
	var RE_NARGS = /(%|)\{([0-9a-zA-Z_]+)\}/g;
	
	function Format (Vue) {
	  var hasOwn = Vue.util.hasOwn;
	
	  /**
	   * template
	   *
	   * @param {String} string
	   * @param {Array} ...args
	   * @return {String}
	   */
	
	  function template(string) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    if (args.length === 1 && babelHelpers.typeof(args[0]) === 'object') {
	      args = args[0];
	    } else {
	      args = {};
	    }
	
	    if (!args || !args.hasOwnProperty) {
	      args = {};
	    }
	
	    return string.replace(RE_NARGS, function (match, prefix, i, index) {
	      var result = void 0;
	
	      if (string[index - 1] === '{' && string[index + match.length] === '}') {
	        return i;
	      } else {
	        result = hasOwn(args, i) ? args[i] : match;
	        if (isNil(result)) {
	          return '';
	        }
	
	        return result;
	      }
	    });
	  }
	
	  return template;
	}
	
	/**
	 *  Path paerser
	 *  - Inspired:  
	 *    Vue.js Path parser
	 */
	
	// cache
	var pathCache = Object.create(null);
	
	// actions
	var APPEND = 0;
	var PUSH = 1;
	var INC_SUB_PATH_DEPTH = 2;
	var PUSH_SUB_PATH = 3;
	
	// states
	var BEFORE_PATH = 0;
	var IN_PATH = 1;
	var BEFORE_IDENT = 2;
	var IN_IDENT = 3;
	var IN_SUB_PATH = 4;
	var IN_SINGLE_QUOTE = 5;
	var IN_DOUBLE_QUOTE = 6;
	var AFTER_PATH = 7;
	var ERROR = 8;
	
	var pathStateMachine = [];
	
	pathStateMachine[BEFORE_PATH] = {
	  'ws': [BEFORE_PATH],
	  'ident': [IN_IDENT, APPEND],
	  '[': [IN_SUB_PATH],
	  'eof': [AFTER_PATH]
	};
	
	pathStateMachine[IN_PATH] = {
	  'ws': [IN_PATH],
	  '.': [BEFORE_IDENT],
	  '[': [IN_SUB_PATH],
	  'eof': [AFTER_PATH]
	};
	
	pathStateMachine[BEFORE_IDENT] = {
	  'ws': [BEFORE_IDENT],
	  'ident': [IN_IDENT, APPEND],
	  '0': [IN_IDENT, APPEND],
	  'number': [IN_IDENT, APPEND]
	};
	
	pathStateMachine[IN_IDENT] = {
	  'ident': [IN_IDENT, APPEND],
	  '0': [IN_IDENT, APPEND],
	  'number': [IN_IDENT, APPEND],
	  'ws': [IN_PATH, PUSH],
	  '.': [BEFORE_IDENT, PUSH],
	  '[': [IN_SUB_PATH, PUSH],
	  'eof': [AFTER_PATH, PUSH]
	};
	
	pathStateMachine[IN_SUB_PATH] = {
	  "'": [IN_SINGLE_QUOTE, APPEND],
	  '"': [IN_DOUBLE_QUOTE, APPEND],
	  '[': [IN_SUB_PATH, INC_SUB_PATH_DEPTH],
	  ']': [IN_PATH, PUSH_SUB_PATH],
	  'eof': ERROR,
	  'else': [IN_SUB_PATH, APPEND]
	};
	
	pathStateMachine[IN_SINGLE_QUOTE] = {
	  "'": [IN_SUB_PATH, APPEND],
	  'eof': ERROR,
	  'else': [IN_SINGLE_QUOTE, APPEND]
	};
	
	pathStateMachine[IN_DOUBLE_QUOTE] = {
	  '"': [IN_SUB_PATH, APPEND],
	  'eof': ERROR,
	  'else': [IN_DOUBLE_QUOTE, APPEND]
	};
	
	/**
	 * Check if an expression is a literal value.
	 *
	 * @param {String} exp
	 * @return {Boolean}
	 */
	
	var literalValueRE = /^\s?(true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
	function isLiteral(exp) {
	  return literalValueRE.test(exp);
	}
	
	/**
	 * Strip quotes from a string
	 *
	 * @param {String} str
	 * @return {String | false}
	 */
	
	function stripQuotes(str) {
	  var a = str.charCodeAt(0);
	  var b = str.charCodeAt(str.length - 1);
	  return a === b && (a === 0x22 || a === 0x27) ? str.slice(1, -1) : str;
	}
	
	/**
	 * Determine the type of a character in a keypath.
	 *
	 * @param {Char} ch
	 * @return {String} type
	 */
	
	function getPathCharType(ch) {
	  if (ch === undefined) {
	    return 'eof';
	  }
	
	  var code = ch.charCodeAt(0);
	
	  switch (code) {
	    case 0x5B: // [
	    case 0x5D: // ]
	    case 0x2E: // .
	    case 0x22: // "
	    case 0x27: // '
	    case 0x30:
	      // 0
	      return ch;
	
	    case 0x5F: // _
	    case 0x24: // $
	    case 0x2D:
	      // -
	      return 'ident';
	
	    case 0x20: // Space
	    case 0x09: // Tab
	    case 0x0A: // Newline
	    case 0x0D: // Return
	    case 0xA0: // No-break space
	    case 0xFEFF: // Byte Order Mark
	    case 0x2028: // Line Separator
	    case 0x2029:
	      // Paragraph Separator
	      return 'ws';
	  }
	
	  // a-z, A-Z
	  if (code >= 0x61 && code <= 0x7A || code >= 0x41 && code <= 0x5A) {
	    return 'ident';
	  }
	
	  // 1-9
	  if (code >= 0x31 && code <= 0x39) {
	    return 'number';
	  }
	
	  return 'else';
	}
	
	/**
	 * Format a subPath, return its plain form if it is
	 * a literal string or number. Otherwise prepend the
	 * dynamic indicator (*).
	 *
	 * @param {String} path
	 * @return {String}
	 */
	
	function formatSubPath(path) {
	  var trimmed = path.trim();
	  // invalid leading 0
	  if (path.charAt(0) === '0' && isNaN(path)) {
	    return false;
	  }
	
	  return isLiteral(trimmed) ? stripQuotes(trimmed) : '*' + trimmed;
	}
	
	/**
	 * Parse a string path into an array of segments
	 *
	 * @param {String} path
	 * @return {Array|undefined}
	 */
	
	function parse(path) {
	  var keys = [];
	  var index = -1;
	  var mode = BEFORE_PATH;
	  var subPathDepth = 0;
	  var c = void 0,
	      newChar = void 0,
	      key = void 0,
	      type = void 0,
	      transition = void 0,
	      action = void 0,
	      typeMap = void 0;
	
	  var actions = [];
	
	  actions[PUSH] = function () {
	    if (key !== undefined) {
	      keys.push(key);
	      key = undefined;
	    }
	  };
	
	  actions[APPEND] = function () {
	    if (key === undefined) {
	      key = newChar;
	    } else {
	      key += newChar;
	    }
	  };
	
	  actions[INC_SUB_PATH_DEPTH] = function () {
	    actions[APPEND]();
	    subPathDepth++;
	  };
	
	  actions[PUSH_SUB_PATH] = function () {
	    if (subPathDepth > 0) {
	      subPathDepth--;
	      mode = IN_SUB_PATH;
	      actions[APPEND]();
	    } else {
	      subPathDepth = 0;
	      key = formatSubPath(key);
	      if (key === false) {
	        return false;
	      } else {
	        actions[PUSH]();
	      }
	    }
	  };
	
	  function maybeUnescapeQuote() {
	    var nextChar = path[index + 1];
	    if (mode === IN_SINGLE_QUOTE && nextChar === "'" || mode === IN_DOUBLE_QUOTE && nextChar === '"') {
	      index++;
	      newChar = '\\' + nextChar;
	      actions[APPEND]();
	      return true;
	    }
	  }
	
	  while (mode != null) {
	    index++;
	    c = path[index];
	
	    if (c === '\\' && maybeUnescapeQuote()) {
	      continue;
	    }
	
	    type = getPathCharType(c);
	    typeMap = pathStateMachine[mode];
	    transition = typeMap[type] || typeMap['else'] || ERROR;
	
	    if (transition === ERROR) {
	      return; // parse error
	    }
	
	    mode = transition[0];
	    action = actions[transition[1]];
	    if (action) {
	      newChar = transition[2];
	      newChar = newChar === undefined ? c : newChar;
	      if (action() === false) {
	        return;
	      }
	    }
	
	    if (mode === AFTER_PATH) {
	      keys.raw = path;
	      return keys;
	    }
	  }
	}
	
	/**
	 * External parse that check for a cache hit first
	 *
	 * @param {String} path
	 * @return {Array|undefined}
	 */
	
	function parsePath(path) {
	  var hit = pathCache[path];
	  if (!hit) {
	    hit = parse(path);
	    if (hit) {
	      pathCache[path] = hit;
	    }
	  }
	  return hit;
	}
	
	function Path (Vue) {
	  var _Vue$util = Vue.util,
	      isObject = _Vue$util.isObject,
	      isPlainObject = _Vue$util.isPlainObject,
	      hasOwn = _Vue$util.hasOwn;
	
	
	  function empty(target) {
	    if (target === null || target === undefined) {
	      return true;
	    }
	
	    if (Array.isArray(target)) {
	      if (target.length > 0) {
	        return false;
	      }
	      if (target.length === 0) {
	        return true;
	      }
	    } else if (isPlainObject(target)) {
	      /* eslint-disable prefer-const */
	      for (var key in target) {
	        if (hasOwn(target, key)) {
	          return false;
	        }
	      }
	      /* eslint-enable prefer-const */
	    }
	
	    return true;
	  }
	
	  /**
	   * Get value from path string
	   *
	   * @param {Object} obj
	   * @param {String} path
	   * @return value
	   */
	
	  function getValue(obj, path) {
	    if (!isObject(obj)) {
	      return null;
	    }
	
	    var paths = parsePath(path);
	    if (empty(paths)) {
	      return null;
	    }
	
	    var length = paths.length;
	    var ret = null;
	    var last = obj;
	    var i = 0;
	    while (i < length) {
	      var value = last[paths[i]];
	      if (value === undefined) {
	        last = null;
	        break;
	      }
	      last = value;
	      i++;
	    }
	
	    ret = last;
	    return ret;
	  }
	
	  return getValue;
	}
	
	/**
	 * extend
	 *
	 * @param {Vue} Vue
	 * @return {Vue}
	 */
	
	function Extend (Vue) {
	  var _Vue$util = Vue.util,
	      isObject = _Vue$util.isObject,
	      bind = _Vue$util.bind;
	
	  var format = Format(Vue);
	  var getValue = Path(Vue);
	
	  function parseArgs() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var lang = Vue.config.lang;
	    var fallback = Vue.config.fallbackLang;
	
	    if (args.length === 1) {
	      if (isObject(args[0]) || Array.isArray(args[0])) {
	        args = args[0];
	      } else if (typeof args[0] === 'string') {
	        lang = args[0];
	      }
	    } else if (args.length === 2) {
	      if (typeof args[0] === 'string') {
	        lang = args[0];
	      }
	      if (isObject(args[1]) || Array.isArray(args[1])) {
	        args = args[1];
	      }
	    }
	
	    return { lang: lang, fallback: fallback, params: args };
	  }
	
	  function exist(locale, key) {
	    if (!locale || !key) {
	      return false;
	    }
	    return !isNil(getValue(locale, key));
	  }
	
	  function interpolate(locale, key, args) {
	    if (!locale) {
	      return null;
	    }
	
	    var val = getValue(locale, key);
	    if (Array.isArray(val)) {
	      return val;
	    }
	    if (isNil(val)) {
	      val = locale[key];
	    }
	    if (isNil(val)) {
	      return null;
	    }
	    if (typeof val !== 'string') {
	      warn("Value of key '" + key + "' is not a string!");return null;
	    }
	
	    // Check for the existance of links within the translated string
	    if (val.indexOf('@:') >= 0) {
	      // Match all the links within the local
	      // We are going to replace each of
	      // them with its translation
	      var matches = val.match(/(@:[\w|.]+)/g);
	      for (var idx in matches) {
	        var link = matches[idx];
	        // Remove the leading @:
	        var linkPlaceholder = link.substr(2);
	        // Translate the link
	        var translatedstring = interpolate(locale, linkPlaceholder, args);
	        // Replace the link with the translated string
	        val = val.replace(link, translatedstring);
	      }
	    }
	
	    return !args ? val : Vue.config.i18nFormatter ? Vue.config.i18nFormatter.apply(null, [val].concat(args)) : format(val, args);
	  }
	
	  function translate(getter, lang, fallback, key, params) {
	    var res = null;
	    res = interpolate(getter(lang), key, params);
	    if (!isNil(res)) {
	      return res;
	    }
	
	    res = interpolate(getter(fallback), key, params);
	    if (!isNil(res)) {
	      if (false) {
	        warn('Fall back to translate the keypath "' + key + '" with "' + fallback + '" language.');
	      }
	      return res;
	    } else {
	      return null;
	    }
	  }
	
	  function warnDefault(lang, key, vm, result) {
	    if (!isNil(result)) {
	      return result;
	    }
	    if (Vue.config.missingHandler) {
	      Vue.config.missingHandler.apply(null, [lang, key, vm]);
	    } else {
	      if (false) {
	        warn('Cannot translate the value of keypath "' + key + '". ' + 'Use the value of keypath as default');
	      }
	    }
	    return key;
	  }
	
	  function getAssetLocale(lang) {
	    return Vue.locale(lang);
	  }
	
	  function getComponentLocale(lang) {
	    return this.$options.locales[lang];
	  }
	
	  function getOldChoiceIndexFixed(choice) {
	    return choice ? choice > 1 ? 1 : 0 : 1;
	  }
	
	  function getChoiceIndex(choice, choicesLength) {
	    choice = Math.abs(choice);
	
	    if (choicesLength === 2) {
	      return getOldChoiceIndexFixed(choice);
	    }
	
	    return choice ? Math.min(choice, 2) : 0;
	  }
	
	  function fetchChoice(locale, choice) {
	    if (!locale && typeof locale !== 'string') {
	      return null;
	    }
	    var choices = locale.split('|');
	
	    choice = getChoiceIndex(choice, choices.length);
	    if (!choices[choice]) {
	      return locale;
	    }
	    return choices[choice].trim();
	  }
	
	  /**
	   * Vue.t
	   *
	   * @param {String} key
	   * @param {Array} ...args
	   * @return {String}
	   */
	
	  Vue.t = function (key) {
	    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      args[_key2 - 1] = arguments[_key2];
	    }
	
	    if (!key) {
	      return '';
	    }
	
	    var _parseArgs = parseArgs.apply(undefined, args),
	        lang = _parseArgs.lang,
	        fallback = _parseArgs.fallback,
	        params = _parseArgs.params;
	
	    return warnDefault(lang, key, null, translate(getAssetLocale, lang, fallback, key, params));
	  };
	
	  /**
	   * Vue.tc
	   *
	   * @param {String} key
	   * @param {number|undefined} choice
	   * @param {Array} ...args
	   * @return {String}
	   */
	
	  Vue.tc = function (key, choice) {
	    for (var _len3 = arguments.length, args = Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
	      args[_key3 - 2] = arguments[_key3];
	    }
	
	    return fetchChoice(Vue.t.apply(Vue, [key].concat(args)), choice);
	  };
	
	  /**
	   * Vue.te
	   *
	   * @param {String} key
	   * @param {Array} ...args
	   * @return {Boolean}
	   */
	
	  Vue.te = function (key) {
	    for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	      args[_key4 - 1] = arguments[_key4];
	    }
	
	    var _parseArgs2 = parseArgs.apply(undefined, args),
	        lang = _parseArgs2.lang;
	
	    return exist(getAssetLocale(lang), key);
	  };
	
	  /**
	   * $t
	   *
	   * @param {String} key
	   * @param {Array} ...args
	   * @return {String}
	   */
	
	  Vue.prototype.$t = function (key) {
	    if (!key) {
	      return '';
	    }
	
	    for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	      args[_key5 - 1] = arguments[_key5];
	    }
	
	    var _parseArgs3 = parseArgs.apply(undefined, args),
	        lang = _parseArgs3.lang,
	        fallback = _parseArgs3.fallback,
	        params = _parseArgs3.params;
	
	    var res = null;
	    if (this.$options.locales) {
	      res = translate(bind(getComponentLocale, this), lang, fallback, key, params);
	      if (res) {
	        return res;
	      }
	    }
	    return warnDefault(lang, key, this, translate(getAssetLocale, lang, fallback, key, params));
	  };
	
	  /**
	   * $tc
	   *
	   * @param {String} key
	   * @param {number|undefined} choice
	   * @param {Array} ...args
	   * @return {String}
	   */
	
	  Vue.prototype.$tc = function (key, choice) {
	    if (typeof choice !== 'number' && typeof choice !== 'undefined') {
	      return key;
	    }
	
	    for (var _len6 = arguments.length, args = Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
	      args[_key6 - 2] = arguments[_key6];
	    }
	
	    return fetchChoice(this.$t.apply(this, [key].concat(args)), choice);
	  };
	
	  /**
	   * $te
	   *
	   * @param {String} key
	   * @param {Array} ...args
	   * @return {Boolean}
	   *
	   */
	
	  Vue.prototype.$te = function (key) {
	    for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
	      args[_key7 - 1] = arguments[_key7];
	    }
	
	    var _parseArgs4 = parseArgs.apply(undefined, args),
	        lang = _parseArgs4.lang;
	
	    var found = false;
	    if (this.$options.locales) {
	      // exist component locale
	      found = exist(bind(getComponentLocale)(lang), key);
	    }
	    if (!found) {
	      found = exist(getAssetLocale(lang), key);
	    }
	    return found;
	  };
	
	  Vue.mixin({
	    computed: {
	      $lang: function $lang() {
	        return Vue.config.lang;
	      }
	    }
	  });
	
	  return Vue;
	}
	
	var langVM = void 0; // singleton
	
	
	/**
	 * plugin
	 *
	 * @param {Object} Vue
	 * @param {Object} opts
	 */
	
	function plugin(Vue) {
	  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var version = Vue.version && Number(Vue.version.split('.')[0]) || -1;
	
	  if (false) {
	    warn('already installed.');
	    return;
	  }
	
	  if (false) {
	    warn('vue-i18n (' + plugin.version + ') need to use vue version 1.0 or later (vue version: ' + Vue.version + ').');
	    return;
	  }
	
	  var lang = 'en';
	  setupLangVM(Vue, lang);
	
	  Asset(Vue, langVM);
	  Override(Vue, langVM, version);
	  Config(Vue, langVM, lang);
	  Extend(Vue);
	}
	
	function setupLangVM(Vue, lang) {
	  var silent = Vue.config.silent;
	  Vue.config.silent = true;
	  if (!langVM) {
	    langVM = new Vue({ data: { lang: lang, locales: {} } });
	  }
	  Vue.config.silent = silent;
	}
	
	plugin.version = '__VERSION__';
	
	if (typeof window !== 'undefined' && window.Vue) {
	  window.Vue.use(plugin);
	}
	
	module.exports = plugin;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(4);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(367);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(611);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(612);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * 雨课堂 国际化静态文字
	 * @author: chenzhou
	 * @update: 2017.12.01
	 * @desc 国际化 命名空间格式 page-module-lable
	 *
	 */
	
	var Language = function () {
	  function Language() {
	    (0, _classCallCheck3.default)(this, Language);
	
	    this.options = {
	      default: 'zh_CN',
	      lang: 'zh_CN'
	    };
	
	    this.languageRes = null;
	  }
	
	  /*
	   * @method translated locales
	   * @param
	   */
	
	
	  (0, _createClass3.default)(Language, [{
	    key: 'getLocales',
	    value: function getLocales() {
	      var locales = {
	        en: __webpack_require__(615),
	        zh_CN: __webpack_require__(617)
	      };
	
	      return locales;
	    }
	
	    /*
	     * @method 设置本地语言
	     * @param
	     */
	
	  }, {
	    key: 'setLanguage',
	    value: function setLanguage(lng) {
	      // set locales
	      var locales = this.getLocales();
	
	      (0, _keys2.default)(locales).forEach(function (lang) {
	        Vue.locale(lang, locales[lang]);
	      });
	
	      Vue.config.lang = lng || 'zh_CN';
	    }
	
	    /*
	     * @method 请求语言资源
	     * @param lang 语言类型
	     */
	
	  }, {
	    key: 'requireRes',
	    value: function requireRes(lang) {
	      var self = this;
	
	      if (lang) {
	        this.options['lang'] = lang;
	
	        switch (lang) {
	          case 'zh_CN':
	            // 中文资源
	            // require(['@/language/zh_CN'], function(res) {
	            //   self.languageRes = res && res.default;
	            // })
	            break;
	          case 'en':
	            // 英文资源
	            // require(['@/language/en'], function(res) {
	            //   self.languageRes = res && res.default;
	            // })
	            break;
	          default:
	            break;
	        }
	      }
	    }
	
	    /*
	     * @method 翻译当前页面
	     * @param pageEl
	     */
	
	  }, {
	    key: 'translate',
	    value: function translate(pageEl) {
	      var _this = this;
	
	      var self = this;
	      // data-language-key
	      pageEl = pageEl || document;
	
	      if (!self.languageRes) {
	        setTimeout(function () {
	          self.translate(pageEl);
	        }, 1000);
	
	        return this;
	      }
	
	      // 标准的静态文字
	      var allEle = pageEl.querySelectorAll('[data-language-key]');
	
	      allEle = Array.prototype.slice.call(allEle);
	      allEle && allEle.forEach(function (element) {
	        var key = element.dataset.languageKey;
	        var value = _this.languageRes[key] || element.innerText;
	
	        element.innerText = value;
	      });
	
	      // 复杂模式 静态文字和业务数据混合在一起 暂定根据位置定位提取业务数据
	      allEle = pageEl.querySelectorAll('[data-language-complex]');
	
	      allEle = Array.prototype.slice.call(allEle);
	      allEle && allEle.forEach(function (element) {
	        var key = element.dataset.languageComplex;
	        var value = element.innerText;
	        var info = element.dataset;
	        var sTpl = _this.languageRes[key] || '';
	
	        // 根据特征或者规则 提取业务数据
	        var text = _this.temple(sTpl, info);
	        // console.log(text);
	
	        element.innerText = text || value;
	      });
	    }
	
	    /*
	     * @method 混合模式模板
	     * @param
	     */
	
	  }, {
	    key: 'temple',
	    value: function temple(tpl, value) {
	      return tpl.replace(/\$\w+\$/g, function (matchs) {
	        var returns = value[matchs.replace(/\$/g, '')];
	        return typeof returns === 'undefined' ? '' : returns;
	      });
	    }
	  }]);
	  return Language;
	}();
	
	if (true) {
	  // AMD. Register as an anonymous module.
	  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return new Language();
	  }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if ((typeof exports === 'undefined' ? 'undefined' : (0, _typeof3.default)(exports)) === 'object' && (typeof module === 'undefined' ? 'undefined' : (0, _typeof3.default)(module)) === 'object') {
	  module.exports = exports = pages; // CommonJS
	}
	
	exports.default = new Language();

/***/ }),
/* 611 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(613);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(614), __esModule: true };

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(8);
	module.exports = function defineProperty(it, key, desc){
	  return $.setDesc(it, key, desc);
	};

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof2 = __webpack_require__(4);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _defineProperty2 = __webpack_require__(616);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _common, _course, _quiz, _cards, _my, _student, _teacher, _pubnotice, _my_folder_manage, _newlogs, _setcourse, _pages;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * 雨课堂 国际化静态文字
	 * @author: chenzhou
	 * @update: 2017.12.01
	 * @desc 国际化 命名空间格式 page-module-lable
	 *
	 */
	
	var pages = (_pages = {
	    // 常用语
	    common: (_common = {
	        "lang": "english",
	        "ykt": "Rain Classroom",
	        "cancel": "Cancel",
	        "confirm": "OK",
	        "finishok": "Confirm",
	        "close": "Close",
	        "publish": "Publish",
	        "back": "Back",
	        "del": "Delete",
	        "remove": "Remove",
	        "point": "Point",
	        "score": "Score",
	        "name": "Name",
	        "anonymous": "Anonymous",
	        "unread": "Unread",
	        "anonymouspoll": "Anonymous Poll",
	        "poll": "Poll",
	        "option": "Option"
	    }, (0, _defineProperty3.default)(_common, "anonymous", "Anonymous Poll"), (0, _defineProperty3.default)(_common, "multiplem", "Multiple Question (Multiple answers)"), (0, _defineProperty3.default)(_common, "multiples", "Multiple Question (Single answer)"), (0, _defineProperty3.default)(_common, "subjective", "Subjective Question"), (0, _defineProperty3.default)(_common, "blank", "Blank"), (0, _defineProperty3.default)(_common, "chooselimit", "Select {count} options"), (0, _defineProperty3.default)(_common, "locate", "Question {index}"), (0, _defineProperty3.default)(_common, "quiz", "quiz"), (0, _defineProperty3.default)(_common, "slide", "slide"), (0, _defineProperty3.default)(_common, "searchone", "Search"), (0, _defineProperty3.default)(_common, "pull", "Pull down"), (0, _defineProperty3.default)(_common, "release", "Release"), (0, _defineProperty3.default)(_common, "loadingText", "Loading…"), (0, _defineProperty3.default)(_common, "Lotuspond", "Lotus Pond"), (0, _defineProperty3.default)(_common, "cancelselall", "Cancel"), (0, _defineProperty3.default)(_common, "continue", "Continue"), _common),
	
	    // 导航菜单
	    nav: {
	        "course": "Courses",
	        "discover": "Discover",
	        "message": "Messages",
	        "me": "Me",
	        // "myhomepage": "My Homepage",
	        "myhomepage": "Homepage",
	        "myslides": "My Slides",
	        "mytests": "My Tests",
	        "mysave": "Saved"
	    },
	
	    // 课程 教学日志 学习日志
	    course: (_course = {
	        "inclasstip": "Class has already started",
	        "courseandclass": "Courses",
	        "openclass": "Open Class",
	        "addacourse": "Create Course",
	        "coursejoinclass": "Join Class",
	        "inclass": "In class",
	        "coursemanage": "Manage",
	        "courseinclassstudent": "{count}",
	        "coursemanaged": "Managed",
	        "coursejoined": "Joined",
	        "coursequitclass": "Quit Class",
	        "coursequitcfm": "Are you sure to quit?",
	        "coursetips": "Tips",
	        "courseenterclasscode": "Enter invite code and join class.",
	        "classjoinfailed": "Join Class Failed",
	        "coursecreate": "Course",
	        "coursecreateexample": "e.g. Fluid Mechanics",
	        "classexample": "e.g. Class A",
	        "classcreate": "Class",
	        "courseaddclass": "Add Class",
	        "coursecreatedone": "Done",
	
	        "createOK": "Successful",
	        "tip_invitestudent": "You can enter class to invite students.",
	        "youcreateclass": "Class you create",
	        "enterclass": "Enter Class",
	        "returncourselist": "Return to Course List",
	        "rename": "Rename",
	        "classname": "Class Name",
	        "save": "Save",
	        "dialog_tip": "Tips",
	
	        "dellastclass": "One class in a course at least",
	        "courseaddcourse": "Add Course",
	        "courseeditcourse": "Edit Course",
	        "coursedelclasswarning": "Are you sure to delete?",
	        "entercoursename": "Please enter course name",
	        "enterclassname": "Please enter class name",
	        "coursedelcoursewarning": "Are you sure to delete?",
	        "coursedelcoursecfm": "Once you delete the course, all classes in that course will be deleted.",
	
	        "teachinghistory": "Activities",
	        "managestudent": "Students",
	        "learninghistory": "Activities",
	        "coursemyclassmate": "Classmates",
	        "courseinvitestudent": "Invite",
	        "coursepermission": "Permission",
	        "coursemanageagain": "Manage",
	        "coursequit": "Exit"
	    }, (0, _defineProperty3.default)(_course, "enterclass", "Enter Class"), (0, _defineProperty3.default)(_course, "coursepublishslides", "Slides"), (0, _defineProperty3.default)(_course, "coursepublishquiz", "Quizzes"), (0, _defineProperty3.default)(_course, "courseannounce", "Announcement"), (0, _defineProperty3.default)(_course, "courseno学习日志", "No 学习日志"), (0, _defineProperty3.default)(_course, "coursepublishintro", 'Click "+" to publish slides, quizzes or announcement~'), (0, _defineProperty3.default)(_course, "courseteachercheckall", "Check the published slides, teaching history and quizzes here~"), (0, _defineProperty3.default)(_course, "scheduledeliver", "Schedule Deliver"), (0, _defineProperty3.default)(_course, "scheduledeliverpublish", "You have {length} Schedule Delivers."), (0, _defineProperty3.default)(_course, "coursefold", "Fold"), (0, _defineProperty3.default)(_course, "courseunfold", "Unfold"), (0, _defineProperty3.default)(_course, "courseslides", "Slides"), (0, _defineProperty3.default)(_course, "coursequiz", "Quizzes"), (0, _defineProperty3.default)(_course, "courseedittitle", "Edit Title"), (0, _defineProperty3.default)(_course, "coursedel", "Delete"), (0, _defineProperty3.default)(_course, "courseinclass", "Lecture"), (0, _defineProperty3.default)(_course, "courseannounce2", "Announcement"), (0, _defineProperty3.default)(_course, "coursexperiment", "Experiment"), (0, _defineProperty3.default)(_course, "coursenostudentpush", "No student in class."), (0, _defineProperty3.default)(_course, "courserightnow", "Right Now"), (0, _defineProperty3.default)(_course, "courseinvite", "Invite"), (0, _defineProperty3.default)(_course, "coursesearch", "Search"), (0, _defineProperty3.default)(_course, "courseteacher", "Instructor"), (0, _defineProperty3.default)(_course, "coursecoteacher", "Co-instructor"), (0, _defineProperty3.default)(_course, "exitcourse", "Exit"), (0, _defineProperty3.default)(_course, "coursestudent", "Student"), (0, _defineProperty3.default)(_course, "coursenotbound", "Not bound"), (0, _defineProperty3.default)(_course, "coursegueststudent", "Guest Student"), (0, _defineProperty3.default)(_course, "coteachernoedit", "The co-teacher is not allowed to edit title."), (0, _defineProperty3.default)(_course, "coteachernodel", "The co-teacher is not allowed to delete teaching activities."), (0, _defineProperty3.default)(_course, "courseaddtitle", "Click to add new title~"), (0, _defineProperty3.default)(_course, "coursedelpubish", "Are you sure to delete?"), (0, _defineProperty3.default)(_course, "courseactivitydel", "Are you sure to delete the teaching activity?"), (0, _defineProperty3.default)(_course, "coursedelcfm", "Are you sure to delete the student?"), (0, _defineProperty3.default)(_course, "coursebecomecfm", "Are you confirming your transfer as a regular student?"), (0, _defineProperty3.default)(_course, "coursedelstudentfailed", "Delete Failed"), (0, _defineProperty3.default)(_course, "courseexitcfm", "Are you sure to exit?"), (0, _defineProperty3.default)(_course, "coursefailtoexit", "Exit Failed"), (0, _defineProperty3.default)(_course, "coursesun", "Sun"), (0, _defineProperty3.default)(_course, "coursemon", "Mon"), (0, _defineProperty3.default)(_course, "coursetue", "Tue"), (0, _defineProperty3.default)(_course, "coursewed", "Wed"), (0, _defineProperty3.default)(_course, "coursethu", "Thu"), (0, _defineProperty3.default)(_course, "coursefri", "Fri"), (0, _defineProperty3.default)(_course, "coursesat", "Sat"), (0, _defineProperty3.default)(_course, "appointmentmins", "Send in {minute} mins"), (0, _defineProperty3.default)(_course, "appointmenthours", "Send in {hour} hours"), (0, _defineProperty3.default)(_course, "appointmentdays", "Send in {days} days"), (0, _defineProperty3.default)(_course, "appointmentfailed", "Send Failed"), (0, _defineProperty3.default)(_course, "coteacherinclass", "Co-instructor"), (0, _defineProperty3.default)(_course, "addcoteacher", "Add Co-instructor"), (0, _defineProperty3.default)(_course, "setpermission", "Set Permission"), (0, _defineProperty3.default)(_course, "deletepermissioncfm", "Are you sure to delete?"), (0, _defineProperty3.default)(_course, "deletepermissionfailed", "Delete Failed"), (0, _defineProperty3.default)(_course, "selectall", "Select All"), (0, _defineProperty3.default)(_course, "selectnone", "Select None"), (0, _defineProperty3.default)(_course, "confirmdelete", "Delete"), (0, _defineProperty3.default)(_course, "confirmdelete1", "Remove"), (0, _defineProperty3.default)(_course, "managetips", "You can only manage guest students."), (0, _defineProperty3.default)(_course, "managetipshasadmin", "This course has opened up the ability for teachers to manage class members, both students and spectators"), (0, _defineProperty3.default)(_course, "auditorbecomes", "Auditor's transfer"), (0, _defineProperty3.default)(_course, "becomesregular", "Regularize"), (0, _defineProperty3.default)(_course, "managestudents", "Manage Students"), (0, _defineProperty3.default)(_course, "clear", "Clear"), (0, _defineProperty3.default)(_course, "noaddtests", "You haven't added any tests."), (0, _defineProperty3.default)(_course, "coursechooseslide", "Choose one slide only"), (0, _defineProperty3.default)(_course, "coursedelstudent", "Are you sure to delete?"), (0, _defineProperty3.default)(_course, "deleteOK", "OK"), (0, _defineProperty3.default)(_course, "saveOK", "OK"), (0, _defineProperty3.default)(_course, "invitestudent", "Invite Student"), (0, _defineProperty3.default)(_course, "ArchivedClasses", "Archived Classes"), (0, _defineProperty3.default)(_course, "no_guest_student_tip", "No guest student here"), (0, _defineProperty3.default)(_course, "pullrefresh", "Pull up to refresh"), (0, _defineProperty3.default)(_course, "toprelease", "Pull up to refresh"), (0, _defineProperty3.default)(_course, "toploading", "Loading..."), (0, _defineProperty3.default)(_course, "nonetwork", "Network unavailable"), (0, _defineProperty3.default)(_course, "loadmore", "Load more"), (0, _defineProperty3.default)(_course, "sending", 'sending'), (0, _defineProperty3.default)(_course, "new_onlessontip", "{length} class(es) on live"), (0, _defineProperty3.default)(_course, "new_teach", "Teach"), (0, _defineProperty3.default)(_course, "new_listen", "Listen"), (0, _defineProperty3.default)(_course, "new_myteach", "Managed"), (0, _defineProperty3.default)(_course, "new_mylisten", "Joined"), (0, _defineProperty3.default)(_course, "onlessonbar", "{count} class(es) on live"), (0, _defineProperty3.default)(_course, "onlessonbar2", "{count} class(es) on live"), (0, _defineProperty3.default)(_course, "semicolon", "; "), (0, _defineProperty3.default)(_course, "weekexam", "{count} exam(s) last week"), (0, _defineProperty3.default)(_course, "allname", "Full Name"), (0, _defineProperty3.default)(_course, "activeclass", "Available"), (0, _defineProperty3.default)(_course, "addclass", "Add Class"), (0, _defineProperty3.default)(_course, "alias", "Short name"), (0, _defineProperty3.default)(_course, "addalias", "Add class short name"), (0, _defineProperty3.default)(_course, "noclass", "No available class"), (0, _defineProperty3.default)(_course, "gotoset", "Jumping to course settings page…"), (0, _defineProperty3.default)(_course, "deleteclasstip", "All of the teaching activities will be deleted after deleting class"), (0, _defineProperty3.default)(_course, "deleteclasstip2", "All of the students will be removed after deleting class"), (0, _defineProperty3.default)(_course, "studenttotal", "Student Size"), (0, _defineProperty3.default)(_course, "activitytotal", "Teaching Activities"), (0, _defineProperty3.default)(_course, "classalias", "Class Short Name"), (0, _defineProperty3.default)(_course, "entername", "Please enter the name…"), (0, _defineProperty3.default)(_course, "setclassalias", "Set class short name"), (0, _defineProperty3.default)(_course, "archiveclasses", "Archive Class"), (0, _defineProperty3.default)(_course, "deleteclass", "Delete Class"), (0, _defineProperty3.default)(_course, "removearchive", "Remove archived class"), (0, _defineProperty3.default)(_course, "coteachernopermission", "No Permission"), (0, _defineProperty3.default)(_course, "pronopermission_rename", "This class name cannot be modified."), (0, _defineProperty3.default)(_course, "pronopermission_del", "This class can only be deleted from the educational administration"), (0, _defineProperty3.default)(_course, "archiveconfirm", "Are you sure to archive?"), (0, _defineProperty3.default)(_course, "removearchiveconfirm", "Are you sure to remove?"), (0, _defineProperty3.default)(_course, "deleteclassconfirm", "Are you sure to delete?"), (0, _defineProperty3.default)(_course, "delfail", "Delete Failed. Please try again later"), (0, _defineProperty3.default)(_course, "coursename", "Course Name"), (0, _defineProperty3.default)(_course, "courseshortname", "Course Short Name"), (0, _defineProperty3.default)(_course, "delcourse", "Delete Course"), (0, _defineProperty3.default)(_course, "deletecoursetip", "Classes and teaching activities can’t be restored after deleting course"), (0, _defineProperty3.default)(_course, "coursetotal", "Class Numbers"), (0, _defineProperty3.default)(_course, "gotolist", "Jumping to course list…"), (0, _defineProperty3.default)(_course, "delcourseconfirm", "Are you sure to delete?"), (0, _defineProperty3.default)(_course, "classaliasmaxlength", "Class Short Name"), (0, _defineProperty3.default)(_course, "classnamemaxlength", "Class Name"), (0, _defineProperty3.default)(_course, "courseshortnamemaxlength", "Course Short Name"), (0, _defineProperty3.default)(_course, "coursenamemaxlength", "Course Name"), (0, _defineProperty3.default)(_course, "classshortnametip", "If you set a short name, it will be priority display."), (0, _defineProperty3.default)(_course, "courseshortnametip", "If you set a short name, it will be priority display."), (0, _defineProperty3.default)(_course, "protips", "This course is imported by the educational administration system, course data will be synchronized regularly."), (0, _defineProperty3.default)(_course, "cannotrenamecourse", "This course name cannot be modified."), (0, _defineProperty3.default)(_course, "cannotchangecoursetype", "The course type cannot be modified"), (0, _defineProperty3.default)(_course, "proclasstips", "This class is imported by the educational administration system, class data will be synchronized regularly."), (0, _defineProperty3.default)(_course, "cannotchangeterm", "Semester information cannot be modified"), (0, _defineProperty3.default)(_course, "setcoursetype", "Please set course type first"), (0, _defineProperty3.default)(_course, 'gocomplete', 'Complete'), (0, _defineProperty3.default)(_course, 'completetitle', "Please complete your information"), (0, _defineProperty3.default)(_course, 'completemsg', "According to national policy requirements, this operation needs to complete your information."), (0, _defineProperty3.default)(_course, "gobind", "Bind"), (0, _defineProperty3.default)(_course, "authrealname", "Please bind your phone number"), (0, _defineProperty3.default)(_course, "bindphonetips", "According to national policy requirements, this operation needs to bind your phone number."), _course),
	
	    // 试卷 主观题等
	    quiz: (_quiz = {
	        "showqusetion": "Show",
	        "quizlocate": "Question {index}",
	        "quizpoint": "Point:{score}",
	        "datishic": "Duration:",
	
	        "quiztext": "Text",
	        "quizpic": "Picture",
	        "quizvoice": "Voice Message",
	        "quizadd": "Add",
	        "quizvoicelimit": "9 voice messages at most",
	        "quizback": "Back",
	        "quizpreview": "Preview",
	        "quizcorrect": "Correct Answer",
	        "quizkeepedit": "Edit",
	        "quizsubmit": "Submit",
	        "quizsave": "Save",
	
	        "quiztotalscore": "Total Score",
	        "quizfullmarks": "Full Marks",
	        "quiznogradesubjective": "Open Question: Not yet graded",
	        "quizgradingsubjective": "Open Question: Grading...",
	        "quizcheckobjective": "Objective Question",
	        "quizcheckscore": "Score",
	        "quizchecksubjective": "Open Question",
	        "quiznotgraded": "Not yet graded",
	        "curquiznotgraded": "本题未批阅",
	        "seeannotation": "View comment",
	
	        // 主观题作答
	        "timeupnoanswer": "Time up. You can't answer it.",
	        "quizanswer": "Answer",
	        "scoreofthispro": "Score",
	        "quizteachercomment": "Comment",
	        "quizanswerkey": "Answer Key",
	        "recording": "Recording...",
	        "holdtotalk": "Hold to Talk",
	        "releasetosend": "Release to Send",
	        "confirmanswer": "Please confirm the answer.",
	        "quizsubmitok": "Submit Successfully",
	        "delpiccfm": "Are you sure to delete?",
	        "delallpiccfm": "Are you sure to delete all?",
	        "deltextcfm": "Are you sure to delete?",
	        "delaudiocfm": "Are you sure to delete?",
	        "delallaudiocfm": "Are you sure to delete all?",
	        "quiznetworkerror": "Network unavailable, please check the system.",
	        "imgIllegal": "The image may be violated, please check and try again.",
	        "quizpiclimit": "9 pictures at most",
	        "reuploadpiconly": "We only support picture formats, please try again.",
	        "imagesizelimit": "Pictures should be less than 10 MB, please try again.",
	        "accessrecord": "If you want to add audios, you should allow Rain Classroom to access to the microphone.",
	        "takedifficult": "Unable to upload? Click here.",
	
	        //主观题上传附件
	        "upload_tip_mobil": "You can upload files on Rain Classroom web.",
	        "attachment_file": "files",
	        "add_attachment_file": "Upload Files",
	        "upload_tip0": "Tips: maximum one file and the total size should be no more than 100M.",
	        "upload_tip_quiz": "Tips: maximum one file and the total size should be no more than 300M.",
	        "upload_tip1": "Check required format",
	        "upload_tip2": "You can upload:",
	        "file_uploading": "Uploading...",
	        "file_upload_fail": "Failed",
	        "file_upload_complete": "OK",
	        "file_max_limit": "File size exceeds limit",
	        "file_format_limit": "Unqualified Format",
	        "downloadfile_tip": "Please use Rain Classroom web to download the files",
	
	        //new
	        "confirm_deletefile": "Are you sure to delete the file？",
	
	        // 主观题批改页
	        "graded": "Graded",
	        "isgrading": "Grading",
	        "quiznoanswer": "The student didn't answer this question.",
	        "quiztotalpoint": "Total {sourceScore} Score",
	        "quizentercomment": "Please enter comment",
	        "good": "Good!",
	        "comeon": "Great!",
	        "uniqueidea": "Fabulous!",
	        "excellent": "Excellent!",
	        "required": "Required",
	        "quizprevious": "Previous",
	        "quiznextpro": "Next Question",
	        "quiznext": "Next",
	        "quizedit": "Edit",
	        "quizcommentsaved": "The score and the comments will be saved automatically.",
	        "quizaudio": "9 audios at most",
	        "quizsubmitting": "Submitting",
	        "quizshowquestion": "Show Question",
	        "quizgradeinvite": "Please grade",
	        "notgraded": "Not graded yet.",
	
	        // 试卷反馈
	        "finisheddetails": "Finished Details",
	        "gradingdetails": "Grading Details",
	        "submission": "Submission",
	        "gradingtime": "Grading Time",
	        "noonefinished": "No student has finished",
	        "testfinisheddetails": "Test Completion"
	    }, (0, _defineProperty3.default)(_quiz, "finisheddetails", "Completion"), (0, _defineProperty3.default)(_quiz, "checktestpaper", "Checked"), (0, _defineProperty3.default)(_quiz, "graded", "Graded"), (0, _defineProperty3.default)(_quiz, "finishedtest", "Finished"), (0, _defineProperty3.default)(_quiz, "totalstudentone", "Total"), (0, _defineProperty3.default)(_quiz, "viewdetails", "View Details"), (0, _defineProperty3.default)(_quiz, "scoredistribution", "Score Distribution"), (0, _defineProperty3.default)(_quiz, "allvote", "Test Type: Polls"), (0, _defineProperty3.default)(_quiz, "ungradedsubjectiveproexist", "You still have ungraded Open questions."), (0, _defineProperty3.default)(_quiz, "clickbarcharttograde", "Click bar chart of Open questions to grade."), (0, _defineProperty3.default)(_quiz, "noonefinishedtest", "No student has finished."), (0, _defineProperty3.default)(_quiz, "answerdetails", "Answer Details"), (0, _defineProperty3.default)(_quiz, "grading", "Grading"), (0, _defineProperty3.default)(_quiz, "deletepulishcfm", "Are you sure to delete?"), (0, _defineProperty3.default)(_quiz, "deletepublishfailed", "Delete Failed"), (0, _defineProperty3.default)(_quiz, "noanswerforpoll", "There is no correct answer for poll"), (0, _defineProperty3.default)(_quiz, "anonymouspollnodetail", "This is an anonymous poll."), (0, _defineProperty3.default)(_quiz, "numberofvotes", "{count} vote(s)"), (0, _defineProperty3.default)(_quiz, "standardopt", "The correct answer is:"), (0, _defineProperty3.default)(_quiz, "numberofstudents", "{count} student(s)"), (0, _defineProperty3.default)(_quiz, "noanswers", "No answers yet."), (0, _defineProperty3.default)(_quiz, "loadingdata", "Loading"), (0, _defineProperty3.default)(_quiz, "answered", "Answered"), (0, _defineProperty3.default)(_quiz, "notansweredone", "Not answered"), (0, _defineProperty3.default)(_quiz, "gradeone", "Grading"), (0, _defineProperty3.default)(_quiz, "loadmore", "Load more"), (0, _defineProperty3.default)(_quiz, "okone", "OK"), (0, _defineProperty3.default)(_quiz, "positivescore", "Score must be positive."), (0, _defineProperty3.default)(_quiz, "exceedmaximumscore", "Exceed maximum score, please try again."), (0, _defineProperty3.default)(_quiz, "keepadecimal", "One decimal at most , please try again."), (0, _defineProperty3.default)(_quiz, "numberonlywarning", "Numbers only, please try again."), (0, _defineProperty3.default)(_quiz, "unclearstudents", '"Unclear" Students'), (0, _defineProperty3.default)(_quiz, "noquestiontoanswer", "The teacher didn't send any questions in this class."), (0, _defineProperty3.default)(_quiz, "noquestiontoanswer", "The teacher didn't send any questions in this class."), (0, _defineProperty3.default)(_quiz, "standardopt", "The correct answer is :"), (0, _defineProperty3.default)(_quiz, "noanswerforpoll", "No correct answer for the poll."), (0, _defineProperty3.default)(_quiz, "gradingtime", "Grading Time"), (0, _defineProperty3.default)(_quiz, "timelimitedtest", "This is a time-limited test."), (0, _defineProperty3.default)(_quiz, "min", "mins"), (0, _defineProperty3.default)(_quiz, "deadline", "Deadline"), (0, _defineProperty3.default)(_quiz, "testdeadline", "Test Deadline"), (0, _defineProperty3.default)(_quiz, "timelimitedtest", "This is a time-limited test."), (0, _defineProperty3.default)(_quiz, "checkhw", "Check"), (0, _defineProperty3.default)(_quiz, "finishedhw", "Submitted Assignments"), (0, _defineProperty3.default)(_quiz, "hwfinisheddetail", "Assignment Completion"), (0, _defineProperty3.default)(_quiz, "finishedhwstudent", "{count}students have finished the assignments"), (0, _defineProperty3.default)(_quiz, "gradedhwnumber", "assignments have been graded."), (0, _defineProperty3.default)(_quiz, "scorereport", "Score Report"), (0, _defineProperty3.default)(_quiz, "questionlocate", "Question {index}"), (0, _defineProperty3.default)(_quiz, "accuracyone", "Accuracy"), (0, _defineProperty3.default)(_quiz, "editpublishtitle", "Edit Title"), (0, _defineProperty3.default)(_quiz, "editpublishset", "Edit Set"), (0, _defineProperty3.default)(_quiz, "deletepublish", "Delete Publish"), (0, _defineProperty3.default)(_quiz, "deletepublishone", "Are you sure to delete?"), (0, _defineProperty3.default)(_quiz, "deletepublishfailed", "Delete Failed"), (0, _defineProperty3.default)(_quiz, "mailreceivedata", "Please type your email address to receive detailed data:"), (0, _defineProperty3.default)(_quiz, "enterfrequentmail", "Please write down your frequently used email address."), (0, _defineProperty3.default)(_quiz, "groupanswer", "Group Answer"), (0, _defineProperty3.default)(_quiz, "temporarygroup", "Temporary group"), (0, _defineProperty3.default)(_quiz, "submittips", "Each group has only one chance to answer the question, the answer can not be modified after submitting. Please have a fully communication before submitting"), (0, _defineProperty3.default)(_quiz, "check", "Back"), (0, _defineProperty3.default)(_quiz, "temporaryconfirm", "Are you sure to submit the answer as a temporary group (only yourself)?"), (0, _defineProperty3.default)(_quiz, "notingroup", "Not in any group"), (0, _defineProperty3.default)(_quiz, "contactteacher", "Contact the teacher to join a group or submit the answer in a temporary group (only yourself)"), (0, _defineProperty3.default)(_quiz, "iknow", "OK"), (0, _defineProperty3.default)(_quiz, "submitted", "The group has already submit the answer before you joined"), (0, _defineProperty3.default)(_quiz, "submitfail", "Failed"), (0, _defineProperty3.default)(_quiz, "onceTip", "Important"), (0, _defineProperty3.default)(_quiz, "gradetips", "Please grade open questions on Rain Classroom Web at {host}."), (0, _defineProperty3.default)(_quiz, "entertext", "Enter text"), (0, _defineProperty3.default)(_quiz, 'clicksave', 'Please save it in time after answering.'), (0, _defineProperty3.default)(_quiz, "Return", 'Return'), (0, _defineProperty3.default)(_quiz, "Returned", 'Returned'), _quiz),
	
	    // 课前预习 预习反馈 完成情况等
	    cards: (_cards = {
	        'sensitive_words': 'The input contains sensitive words, please check and try again',
	        "dyzgtwpgs": "The ranking may not be the final version if open questions have not been revised.",
	        "dfygdd": "Score (Descending)",
	        "dfyddg": "Score (Ascending)",
	        "qdsjpx": "Sign-In Time (Ascending)",
	        "wszxh": "Not Set",
	        "donealready": "Done",
	        "checkedpreview": "Checked",
	        "nocheckedpreview": "Not Checked",
	        "noonefinishpreview": "No student has finished studied.",
	        "noonepreviewing": "No student is studying.",
	        "allfinish": "All students have finished.",
	        "previewdetail": "Completion",
	        "finisheddetails": "Completion",
	        "finishedpreview": "Done",
	        "checkslides": "Check Slides",
	        "viewdetails": "View Details",
	        "studentscheckedslides": "Students checked slides",
	        "totalclassstudents": "Total Students",
	        "answerdetails": "Answer Details",
	        "subjectivepro": "Open Question",
	        "gradingrate": "Grading Rate",
	        "answerrate": "Answer Rate",
	        "averagescore": "Average Score",
	        "grading": "Grading",
	        "webgradetips": "Tips: try a more convenient way to grade Open questions on Rain Classroom Web at {url}.",
	        "accuracy": "Accuracy",
	        "objectivequestion": "Objective Question"
	    }, (0, _defineProperty3.default)(_cards, "answerrate", "Answer Rate"), (0, _defineProperty3.default)(_cards, "teacherdatacheck", "Check"), (0, _defineProperty3.default)(_cards, "studentfeedback", "Student Feedback"), (0, _defineProperty3.default)(_cards, "anonymous", "Anonymous"), (0, _defineProperty3.default)(_cards, "unread", "Unread"), (0, _defineProperty3.default)(_cards, "nostudentfeedback", "No feedback."), (0, _defineProperty3.default)(_cards, "detaileddata", "Detailed Data"), (0, _defineProperty3.default)(_cards, "webdownloadexcel", "Please download all Excel data on Rain Classroom Web at {url}."), (0, _defineProperty3.default)(_cards, "teachingdesign", "Instructional Design&Memo"), (0, _defineProperty3.default)(_cards, "teachingdesigntip", "You can take notes here. (Private)"), (0, _defineProperty3.default)(_cards, "teachingdesigntip2", "You can take notes here. (Private)"), (0, _defineProperty3.default)(_cards, "editpublishtitle", "Edit Title"), (0, _defineProperty3.default)(_cards, "editpublishset", "Edit Set"), (0, _defineProperty3.default)(_cards, "deletepublish", "Delete Publish"), (0, _defineProperty3.default)(_cards, "loadmore", "Load more"), (0, _defineProperty3.default)(_cards, "mailreceivedata", "Please type your email address to receive detailed data:"), (0, _defineProperty3.default)(_cards, "enterfrequentmail", "Please write down your frequently used email address:"), (0, _defineProperty3.default)(_cards, "mailformaterror", "Email Format Error"), (0, _defineProperty3.default)(_cards, "datasentok", "Sent Successfully"), (0, _defineProperty3.default)(_cards, "yktwebtips", "Tips: on Rain Classroom Web at {url}"), (0, _defineProperty3.default)(_cards, "deleteexcelnow", "You can download detailed Excel data directly."), (0, _defineProperty3.default)(_cards, "enternewtitle", "Please enter the new title."), (0, _defineProperty3.default)(_cards, "deletepulishcfm", "Are you sure to delete?"), (0, _defineProperty3.default)(_cards, "deletepublishfailed", "Delete Failed"), (0, _defineProperty3.default)(_cards, "previewdetails", "Details"), (0, _defineProperty3.default)(_cards, "previewtips", "Not supported"), (0, _defineProperty3.default)(_cards, "previewviewslides", "View Slides"), (0, _defineProperty3.default)(_cards, "previewduration", "Duration:"), (0, _defineProperty3.default)(_cards, "previewscore", "Score:"), (0, _defineProperty3.default)(_cards, "finishstudy", "Complete:"), (0, _defineProperty3.default)(_cards, "finishproblem", "Complete problems:"), (0, _defineProperty3.default)(_cards, "wgky", "Not checked:"), (0, _defineProperty3.default)(_cards, "answerdetails", "Answer Details"), (0, _defineProperty3.default)(_cards, "previewungraded", "Ungraded"), (0, _defineProperty3.default)(_cards, "previewnoquestion", "No questions in the contents."), (0, _defineProperty3.default)(_cards, "previewreporttoteacher", "Report to Instructor"), (0, _defineProperty3.default)(_cards, "anonymous", "Anonymous"), (0, _defineProperty3.default)(_cards, "unread", "Unread"), (0, _defineProperty3.default)(_cards, "reporttoteachertip", "Feel free to report to your teacher if you have any questions~"), (0, _defineProperty3.default)(_cards, "learningthoughts", "My Thoughts"), (0, _defineProperty3.default)(_cards, "teachingdesigntip", "You can take notes here. (Private)"), (0, _defineProperty3.default)(_cards, "previewhours", "{hour} hours"), (0, _defineProperty3.default)(_cards, "previewmins", "{minuts} mins"), (0, _defineProperty3.default)(_cards, "previewsecs", "{seconds} secs"), (0, _defineProperty3.default)(_cards, "previewfeedbacktip", "Please write your feedback here."), (0, _defineProperty3.default)(_cards, "anonymoussend", "Anonymous Send"), (0, _defineProperty3.default)(_cards, "previewcfm", "Confirm"), (0, _defineProperty3.default)(_cards, "previewsending", "Sending"), (0, _defineProperty3.default)(_cards, "previewentertip", "Please enter the content."), (0, _defineProperty3.default)(_cards, "sentok", "Sent Successfully"), (0, _defineProperty3.default)(_cards, "sendfailed", "Send Failed!"), (0, _defineProperty3.default)(_cards, "progress", "Progress: {depth}/{count}"), (0, _defineProperty3.default)(_cards, "completionprogress", "{depth}/{count}"), (0, _defineProperty3.default)(_cards, "unknownpagecount", '"Unclear" Pages'), (0, _defineProperty3.default)(_cards, "unknowntotalpage", "Total Slides"), (0, _defineProperty3.default)(_cards, "allslides", "Total"), (0, _defineProperty3.default)(_cards, "problemslides", "Questions"), (0, _defineProperty3.default)(_cards, "unknownslides", "Unclear"), (0, _defineProperty3.default)(_cards, "viewresult", "Check"), (0, _defineProperty3.default)(_cards, "slidesaudio", "Audio"), (0, _defineProperty3.default)(_cards, "viewall", "Total Questions"), (0, _defineProperty3.default)(_cards, "slidescomment", "Comment"), (0, _defineProperty3.default)(_cards, "sendbtn", "Send"), (0, _defineProperty3.default)(_cards, "commentfail", "Failed, please retry"), (0, _defineProperty3.default)(_cards, "commenting", "loading"), (0, _defineProperty3.default)(_cards, "commentok", "Success"), (0, _defineProperty3.default)(_cards, "xcxzwfbfwlsp", "ERROR!"), (0, _defineProperty3.default)(_cards, "qnzgzhgk", "Watch via Rain Classroom Official Account."), (0, _defineProperty3.default)(_cards, "rhcz", "HELP"), (0, _defineProperty3.default)(_cards, "completionprogress", "{depth}/{count}"), (0, _defineProperty3.default)(_cards, "miniprogramlinktip", "The external links cannot be opened in Mini Program. Please open them via Rain Classroom Official Account. "), (0, _defineProperty3.default)(_cards, "studentId", "Students ID"), (0, _defineProperty3.default)(_cards, "progressinstruction", "Learning progress instruction:"), (0, _defineProperty3.default)(_cards, "graphicpages", "1. The graphic pages"), (0, _defineProperty3.default)(_cards, "watching3stocomplete", "When the courseware page contains only pictures and text, watching 1s is considered complete"), (0, _defineProperty3.default)(_cards, "viewingmorethan1stocomplete", "When the courseware page contains only background picture and less than 20 words, viewing more than 1s is considered complete"), (0, _defineProperty3.default)(_cards, "problempages", "2. The problem pages"), (0, _defineProperty3.default)(_cards, "needtocompleteexercisestocomplete", "It means that the courseware page contains exercises and you need to complete the exercises to complete the study"), (0, _defineProperty3.default)(_cards, "videopage", "3. The video page"), (0, _defineProperty3.default)(_cards, "watchthevideotocomplete", "It means that the courseware page contains a video, and you need to watch more than 90% of the video to complete the study; <br/> If there are more than 1 video in a page, you need to watch 90% of all videos; Viewing time will not be counted by dragging"), (0, _defineProperty3.default)(_cards, "specialinstructions", "4. Special instructions"), (0, _defineProperty3.default)(_cards, "specialinstructionsdesc", "When the courseware page contains exercises and other categories, the completion of the courseware page is subject to the completion of exercises; <br/> When the courseware page contains videos and text, the completion of the courseware page is subject to the completion of the video"), (0, _defineProperty3.default)(_cards, "inputPassword", "Please enter password"), (0, _defineProperty3.default)(_cards, "inputPassword2", "Please enter a four-digit password"), (0, _defineProperty3.default)(_cards, "password", "Password"), (0, _defineProperty3.default)(_cards, "passwordIncorrect", "The password format is incorrect"), _cards),
	
	    // 我的模块 主页 钱包 收藏 我的试卷 课件
	    my: (_my = {
	        "bonusexpenditure": "Bonus Expenditure",
	        "withdraw": "Withdraw",
	        "topup": "Top Up",
	        "bonusincome": "Bonus Income",
	        "bonusrefund": "Bonus Refund",
	        "wallet": "Wallet",
	        "bonus": "Bonus",
	
	        "myyktwallet": "Wallet",
	        "myslides": " My Slides",
	        "mytests": "My Tests",
	        "mysave": "Saved",
	        "schoolbinding": "School Binding",
	        "evaluation": "Evaluation",
	        "reciveQuestionnaire": "我收到的问卷",
	        "questionnairefeedback": "评价我的问卷",
	        "editpersonalinfo": "Edit personal information",
	        "saveinfo": "OK",
	        "name": "Name",
	        "nameeg": "Enter your name",
	        "gender": "Gender",
	        "gendermale": "Male",
	        "genderfemale": "Female",
	        "birthofdate": "Birth of Date",
	        "role": "Role",
	        "pleaseselect": "Please select",
	        "student": "Student",
	        "teacher": "Instructor",
	        "otherrole": "Others",
	        "school": "School",
	        "schooleg": "Enter your school",
	        "department": "Department",
	        "departmenteg": "Enter your department",
	        "company": "Company",
	        "companyeg": "e.g. Tsinghua University",
	        "studentid": "ID",
	        "studentidnote": "Please write down Student ID",
	        "email": "Email",
	        "frequentemailnote": "Please write down Email",
	        "finishok": "OK",
	        "myhomepage": "My Homepage",
	        "changesaved": "The change has been saved.",
	        "uploadingimage": "Uploading image",
	        "networkerror": "Network Error. Please check it.",
	        "imageonly": "Only support image format, please try again.",
	        "imagesizelimit": "Pictures should be less than 10 MB, please try again.",
	        "profile": "Profile",
	        "select": "Select",
	        "cancel": "Cancel",
	        "typeprofile": "Fill in the blank",
	        "leavetrace": "Spend 30secs to leave your trace",
	        "askforfeedback": "Help us improve by sharing your feedback.",
	        "entername": "Enter your name",
	        "enterschool": "Enter your school",
	        "enterstudentid": "Please write down your Student ID.",
	        "submitfailed": "Submission failed.",
	        "connectionfailed": "Connection Failed, please try again later.",
	
	        "bill": "Bill",
	        "mybalance": "Balance"
	    }, (0, _defineProperty3.default)(_my, "topup", "Top Up"), (0, _defineProperty3.default)(_my, "withdraw", "Withdraw"), (0, _defineProperty3.default)(_my, "withdrawnotice", "Withdraw Notice"), (0, _defineProperty3.default)(_my, "questionwithdraw", "Q1: How to withdraw from the Wallet?"), (0, _defineProperty3.default)(_my, "answerwithdraw", "Click 『withdraw』in 『My Wallet』if your wallet balance is greater than ¥2 CNY. Money will be transfered to your Wechat Wallet in 3 days once submitted successfully."), (0, _defineProperty3.default)(_my, "questioncharge", "Q2: Why charge 2% extra fee?"), (0, _defineProperty3.default)(_my, "answercharge", "This is the fee due to Wechat Transactions. RainClassroom won't make a profit from it."), (0, _defineProperty3.default)(_my, "questionwithdrawlimit", "Is there a withdrawal upper limit?"), (0, _defineProperty3.default)(_my, "answerwithdrawlimit", "User can withdraw up to ¥2000 CNY per day due to Wechat limit."), (0, _defineProperty3.default)(_my, "mywallet", "Rain Classrooom Wallet"), (0, _defineProperty3.default)(_my, "nobillfound", "No bill found"), (0, _defineProperty3.default)(_my, "thismonth", "This month"), (0, _defineProperty3.default)(_my, "banktip", "Tips: instructor can use the money to send class bonus."), (0, _defineProperty3.default)(_my, "bankhowbonus", "How to send class bonus?"), (0, _defineProperty3.default)(_my, "bankquestionwithdraw", "How to withdraw from the Wallet?"), (0, _defineProperty3.default)(_my, "bankanswerwithdraw", "Click 『withdraw』in 『My Wallet』if your wallet balance is greater than ¥2 CNY. Money will be transfered to your Wechat Wallet in 3 days once submitted successfully."), (0, _defineProperty3.default)(_my, "bankquestioncharge", "Why charge 2% extra fee?"), (0, _defineProperty3.default)(_my, "bankanswercharge", "This is the fee due to Wechat Transactions. RainClassroom won't make a profit from it."), (0, _defineProperty3.default)(_my, "bankquestionwithdrawlimit", "Is there a withdrawal upper limit?"), (0, _defineProperty3.default)(_my, "bankanswerwithdrawlimit", "User can withdraw up to ¥2000 CNY per day due to Wechat limit."), (0, _defineProperty3.default)(_my, "bankclose", "Close"), (0, _defineProperty3.default)(_my, "today", "Today"), (0, _defineProperty3.default)(_my, "choosetopupamount", "Please choose top-up amount"), (0, _defineProperty3.default)(_my, "moreamountchoice", "More"), (0, _defineProperty3.default)(_my, "entertopupamount", "Please enter top-up amount"), (0, _defineProperty3.default)(_my, "back", "Back"), (0, _defineProperty3.default)(_my, "confirmtopup", "Confirm"), (0, _defineProperty3.default)(_my, "tipsinwallet", "Tips"), (0, _defineProperty3.default)(_my, "yktbalanceuse", "The balance can be used to send bonus or purchase open classes."), (0, _defineProperty3.default)(_my, "enterwithdrawamount", "Please enter withdrawal amount."), (0, _defineProperty3.default)(_my, "currentbalance", "Balance: {balance} CNY"), (0, _defineProperty3.default)(_my, "confirmwithdraw", "Confirm"), (0, _defineProperty3.default)(_my, "withdrawrules", "Withdraw Rules"), (0, _defineProperty3.default)(_my, "withdrawtips", "Tips: 2% of the withdrawal amount will be charged."), (0, _defineProperty3.default)(_my, "rechargetips", "Tips: Users should recharge no more than ¥10000 CNY each time."), (0, _defineProperty3.default)(_my, "transfertimetips", "Money will be transfered to your Wechat account in 3 weekdays."), (0, _defineProperty3.default)(_my, "failtowithdraw", "Failed. The withdrawal limit is ¥2000 CNY per day."), (0, _defineProperty3.default)(_my, "decimalwarning", "Sorry, the amount should not be decimal."), (0, _defineProperty3.default)(_my, "withdrawmin", "User should withdraw no less than ¥2 CNY per day."), (0, _defineProperty3.default)(_my, "insufficentbalance", "Sorry, insufficient balance in your wallet."), (0, _defineProperty3.default)(_my, "balanceerror", "Balance Error"), (0, _defineProperty3.default)(_my, "systemerror", "System Error"), (0, _defineProperty3.default)(_my, "morningsaves", "No saved content found"), (0, _defineProperty3.default)(_my, "morningwords", "Morning Time-Words"), (0, _defineProperty3.default)(_my, "morningpoem", "Morning Time-Poems"), (0, _defineProperty3.default)(_my, "morningbooks", "Morning Time-Books&Films"), (0, _defineProperty3.default)(_my, "anonymous", "Anonymous"), (0, _defineProperty3.default)(_my, "answer", "Answer"), (0, _defineProperty3.default)(_my, "mysave", "Saved"), (0, _defineProperty3.default)(_my, "addtag", "Add Tags"), (0, _defineProperty3.default)(_my, "myslides", "My Slides"), (0, _defineProperty3.default)(_my, "chosennumber", "{chosenNumber} Selected"), (0, _defineProperty3.default)(_my, "selectall", "Select All"), (0, _defineProperty3.default)(_my, "confirmdelete", "OK"), (0, _defineProperty3.default)(_my, "choosemoreslide", "Please select at least one slide."), (0, _defineProperty3.default)(_my, "deleteslidescfm", "Are you sure to delete?"), (0, _defineProperty3.default)(_my, "plugintips", "Tips"), (0, _defineProperty3.default)(_my, "manage", "Manage"), (0, _defineProperty3.default)(_my, "delete", "Delete"), (0, _defineProperty3.default)(_my, "noslidesfound", "No slides found"), (0, _defineProperty3.default)(_my, "pluginykt", "Try Rain Classroom plug-in in your computer"), (0, _defineProperty3.default)(_my, "mytests", "My Tests"), (0, _defineProperty3.default)(_my, "notest", "No test found"), (0, _defineProperty3.default)(_my, "deletetestcfm", "Are you sure to delete?"), (0, _defineProperty3.default)(_my, "medeletetestfailed", " Delete Failed"), (0, _defineProperty3.default)(_my, "medelslidescfm", "Are you sure to delete?"), (0, _defineProperty3.default)(_my, "medelslidesfailed", "Delete Failed"), (0, _defineProperty3.default)(_my, "tips", "Tips"), (0, _defineProperty3.default)(_my, "chooseonemoretest", "Please choose at least one test."), (0, _defineProperty3.default)(_my, "medelquiz", "Are you sure to delete?"), (0, _defineProperty3.default)(_my, "mewallettopup", "Top Up"), (0, _defineProperty3.default)(_my, "mewithdraw", "Withdraw"), (0, _defineProperty3.default)(_my, "withdrawmorethantwo", "User should withdraw no less than ¥2 CNY."), (0, _defineProperty3.default)(_my, "receivedanddeducted", "Received ${getMoney}, deducted commission ${fee}."), (0, _defineProperty3.default)(_my, "ykttopup", "Rain Classroom-Top Up"), (0, _defineProperty3.default)(_my, "mebill", "My Bill"), (0, _defineProperty3.default)(_my, "meupdatingprofilepic", 'Updating profile photo'), (0, _defineProperty3.default)(_my, "merealname", 'Name'), (0, _defineProperty3.default)(_my, "meschoolbelongs", 'School'), (0, _defineProperty3.default)(_my, "merole", 'Role'), (0, _defineProperty3.default)(_my, "meteacher", 'Instructor'), (0, _defineProperty3.default)(_my, "meothers", 'Others'), (0, _defineProperty3.default)(_my, "mestudentid", 'Student ID'), (0, _defineProperty3.default)(_my, "schoolstudent", 'Student'), (0, _defineProperty3.default)(_my, "schoolteacher", 'Instructor'), (0, _defineProperty3.default)(_my, "universitybelongs", 'School'), (0, _defineProperty3.default)(_my, "userunbind", 'Unbind'), (0, _defineProperty3.default)(_my, "addschool", 'Add a school'), (0, _defineProperty3.default)(_my, "setting", 'Setting'), (0, _defineProperty3.default)(_my, "selectlang", 'Language'), (0, _defineProperty3.default)(_my, "savelang", 'Save'), (0, _defineProperty3.default)(_my, "savinglang", 'Setting...'), (0, _defineProperty3.default)(_my, "savesuccess", 'Successful'), (0, _defineProperty3.default)(_my, 'infocosttime', 'Fill in your personal information in 30sec'), (0, _defineProperty3.default)(_my, 'infogood', ''), (0, _defineProperty3.default)(_my, 'infogoodteacher', ''), (0, _defineProperty3.default)(_my, 'infoorg', 'Organ.'), (0, _defineProperty3.default)(_my, 'infoorgtip', 'Not required'), (0, _defineProperty3.default)(_my, 'infonumbereg', 'Please write down your Student ID'), (0, _defineProperty3.default)(_my, 'infotip', 'You can change the information at any time in "My Homepage"'), (0, _defineProperty3.default)(_my, 'backtomini', 'Saved. Please go back and pull down to release.'), (0, _defineProperty3.default)(_my, 'backtominiok', 'I know'), (0, _defineProperty3.default)(_my, 'payfailtip', 'Please top up on Rain Classroom Official Account.'), (0, _defineProperty3.default)(_my, "storeboards", "Saved Board（Total {total}）"), (0, _defineProperty3.default)(_my, 'moreSchool', 'More schools to add…'), (0, _defineProperty3.default)(_my, 'accountsetting', "Account and Binding Settings"), (0, _defineProperty3.default)(_my, 'gosetting', 'Set'), (0, _defineProperty3.default)(_my, 'languagelabel', 'Language'), (0, _defineProperty3.default)(_my, 'language', 'English'), (0, _defineProperty3.default)(_my, 'subscribe_manage', '订阅通知管理'), (0, _defineProperty3.default)(_my, 'hasbeenset', 'Set'), (0, _defineProperty3.default)(_my, 'wechat', 'WeChat'), (0, _defineProperty3.default)(_my, 'phone', 'Phone'), (0, _defineProperty3.default)(_my, 'gobind', 'Bind'), (0, _defineProperty3.default)(_my, "email", 'Email'), (0, _defineProperty3.default)(_my, 'password', 'Password'), (0, _defineProperty3.default)(_my, 'settips', '* After binding the mobile phone number/Email and setting the password, you could use “account + password”to log in to the RainClassroom and the XuetangX website.'), (0, _defineProperty3.default)(_my, 'settips_thu', '* After binding the mobile phone number/Email and setting the password, you could use “account + password”to log in to the Lotus Pond.'), (0, _defineProperty3.default)(_my, 'settips_changjiang', '* After binding the mobile phone number/Email and setting the password, you could use “account + password”to log in to the Changjiang Rainclassroom'), (0, _defineProperty3.default)(_my, 'settips_huanghe', '* After binding the mobile phone number/Email and setting the password, you could use “account + password”to log in to the Huanghe Rainclassroom'), (0, _defineProperty3.default)(_my, 'bindemail', 'Bind Email'), (0, _defineProperty3.default)(_my, 'emailplaceholder', "Email Address Here"), (0, _defineProperty3.default)(_my, 'verifyplaceholder', 'Verification Code Here'), (0, _defineProperty3.default)(_my, 'getcode', 'Get Code'), (0, _defineProperty3.default)(_my, 'bind', 'Bind'), (0, _defineProperty3.default)(_my, 'verifycodeerror', 'Verification code error'), (0, _defineProperty3.default)(_my, 'emailerror', "Please enter a valid Email address"), (0, _defineProperty3.default)(_my, 'bindsuccess', "Success"), (0, _defineProperty3.default)(_my, 'hasbound', 'This Email has been bound before'), (0, _defineProperty3.default)(_my, 'youhavebound', 'You have bound a Email'), (0, _defineProperty3.default)(_my, 'replaceemail', 'Replace the bound'), (0, _defineProperty3.default)(_my, 'setpassword', 'Set Password'), (0, _defineProperty3.default)(_my, 'reenter', 'Re-enter'), (0, _defineProperty3.default)(_my, 'confirm', 'Confirm'), (0, _defineProperty3.default)(_my, 'changepassword', 'Change Password'), (0, _defineProperty3.default)(_my, 'oldpassword', 'Old Password'), (0, _defineProperty3.default)(_my, 'newpassword', 'New Password'), (0, _defineProperty3.default)(_my, 'enter', 'Enter'), (0, _defineProperty3.default)(_my, 'oldpassworderror', 'Old Password Error'), (0, _defineProperty3.default)(_my, 'newpassworderror', 'New passwords are inconsistent'), (0, _defineProperty3.default)(_my, 'setsuccess', 'Success'), (0, _defineProperty3.default)(_my, 'lengthlimit', '8-16 characters，contains  numbers and upper and lower case letters.'), (0, _defineProperty3.default)(_my, 'phoneerror', 'Please enter an available number'), (0, _defineProperty3.default)(_my, "bindPhone", "Bind Phone"), (0, _defineProperty3.default)(_my, "bound", "You have bound a phone number"), (0, _defineProperty3.default)(_my, "replacePhone", "Replace the Bound Number"), (0, _defineProperty3.default)(_my, "bindPhone2", "Bind Phone"), (0, _defineProperty3.default)(_my, "verifiplaceholder", "Verification Code Here"), (0, _defineProperty3.default)(_my, "getVerificationCode", "Get Code"), (0, _defineProperty3.default)(_my, "bind", "Bind"), (0, _defineProperty3.default)(_my, "regain", "Regain"), (0, _defineProperty3.default)(_my, "lawtips", "Real-name authentication is required by law. Please bind your phone number to ensure the availability and security of your account."), (0, _defineProperty3.default)(_my, "second", "s"), (0, _defineProperty3.default)(_my, "receivecode", "Can't receive the verification code"), (0, _defineProperty3.default)(_my, "extractminiprogram", "Extract the mini program code to bind the phone"), (0, _defineProperty3.default)(_my, "closewindow", "Close this window after binding complete"), (0, _defineProperty3.default)(_my, "pleasebindfirst", "Please bind first"), (0, _defineProperty3.default)(_my, "wrongemail", "Wrong format"), (0, _defineProperty3.default)(_my, "wrongphone", "Wrong format"), (0, _defineProperty3.default)(_my, "emailhasbond", "Email has been bond"), (0, _defineProperty3.default)(_my, "codeexpired", "Code expired"), (0, _defineProperty3.default)(_my, "wrongcode", "Wrong code"), (0, _defineProperty3.default)(_my, "wrongoldpassword", "Wrong old password"), (0, _defineProperty3.default)(_my, "invalidnewpassword", "Invalid new password"), (0, _defineProperty3.default)(_my, "codefailedtobesent", "Code failed to be sent"), (0, _defineProperty3.default)(_my, "forgetpassword", "Forget password?"), (0, _defineProperty3.default)(_my, "resetpassword", "Reset password"), (0, _defineProperty3.default)(_my, "verifyphonenumber", "Verify phone number"), (0, _defineProperty3.default)(_my, "besenttotheboundphonenumber", "Verification code will be sent to the bound phone number"), (0, _defineProperty3.default)(_my, "pleasebindyourphonefirst", "Please bind your phone first"), (0, _defineProperty3.default)(_my, "notblankspaces", "Password cannot include blank spaces"), (0, _defineProperty3.default)(_my, "ruleerror", "Wrong password format"), (0, _defineProperty3.default)(_my, "notchinese", "Password must not contain Chinese."), (0, _defineProperty3.default)(_my, "minlength8", "Password must be 8-16 characters."), (0, _defineProperty3.default)(_my, "errornewpassword", "Unqualified password. Please try again."), (0, _defineProperty3.default)(_my, "bindthirdaccount", "Bound third-party account"), (0, _defineProperty3.default)(_my, "txmeet", "Tencent meeting"), (0, _defineProperty3.default)(_my, "gotobind", "Go to bind"), (0, _defineProperty3.default)(_my, "changebindtitle", "This mobile phone number has been bound to another {env} account. If you continue to operate, the original account will be automatically unbound. Whether to continue?"), (0, _defineProperty3.default)(_my, "changebinddesc", "Tips:After changing the binding, the original account will not be able to use the mobile number to log in, You may not be able to access the original account data."), (0, _defineProperty3.default)(_my, "smscodeerr", "Verification code error"), (0, _defineProperty3.default)(_my, "samephone", "The phone number is the same as the currently bound phone number"), (0, _defineProperty3.default)(_my, "xuetangoryktsamephone", "This mobile number has been bound to another account"), (0, _defineProperty3.default)(_my, "checkcourselist", "View {count} courses"), (0, _defineProperty3.default)(_my, "accountnocourse", "The account has no course selection. It is recommended to change to the current account."), (0, _defineProperty3.default)(_my, "originaccountjiebang", "The original account (ID {id}) will be unbound. If it is not bound to WeChat/Email and other login methods, the original account will not be able to log in. Do you want to continue?"), (0, _defineProperty3.default)(_my, "mergeaccount", "It is recommended to merge data into this account (ID {oid}). After merging, the current account (ID {nid}) will be discarded, and all your course selection and learning data will be retained."), (0, _defineProperty3.default)(_my, "continuenext", ""), (0, _defineProperty3.default)(_my, "merge", "Merging"), (0, _defineProperty3.default)(_my, "changebind", "Changebind"), (0, _defineProperty3.default)(_my, "coursecount", "(ID {id}) There are {count} classes"), (0, _defineProperty3.default)(_my, "ykt", "Rainclassroom"), (0, _defineProperty3.default)(_my, "teach", "Managed"), (0, _defineProperty3.default)(_my, "learn", "Joined"), (0, _defineProperty3.default)(_my, "xuetangx", "xuetangX"), (0, _defineProperty3.default)(_my, "mergeerror", "Account consolidation cannot be performed. Please change the phone number and rebind."), (0, _defineProperty3.default)(_my, "bindemailtologin", "Please bind mailbox for ID {id}"), (0, _defineProperty3.default)(_my, "notbindemail", "No mailbox, I want to discard ID {id}"), _my),
	
	    // 预约发布 试卷发布
	    publish: {
	        "scheduledeliverfailedone": "Scheduled deliver failed, please try again.",
	        "publishname": "Publish Name",
	        "quizone": "Quizzes",
	        "timetopublish": "Time to publish",
	        "deadlineone": "Complete deadline",
	        "quizdurationone": "Quiz Duration (mins)",
	        "quizdurationone2": "Quiz Duration",
	        "releasetimeone": "Time to release answer",
	        "publishclassone": "Class",
	        "totalclassesone": "Total Classes: {length}",
	        "deletepublishone": "Are you sure to delete?",
	        "cancelone": "Cancel",
	        "okone": "OK",
	        "delete": "delete",
	        "confirmone": "OK",
	        "publishinstruction": 'How to publish {name}',
	
	        "setdeadlinetips": "If complete deadline is set, students will not able to answer questions, and the data will not be updated, but slides can still be viewed within the view deadline;",
	        "nosetdeadlinetips": "If complete deadline is not set, students can view the slides and answer the questions at any time during the view deadline, and the data will be updated in real time; ",
	        "systemsubmitanswers": "After the deadline, students can still check the answers, but unable to answer or submit. The test data and score distribution will not be updated, and students' answers will be submitted automatically.",
	        "timernostop": "Students must submit answers by the deadline. The timer will not stop if you exit. Students' answers will be submitted automatically at the end of test.",
	        "releasetips": "The correct answers will be released after the selected time. Until then, students will not be able to know the answer key.",
	        "releasetips_col": "The correct answers will be released after the selected time. Until then, students will not be able to know the answer key.",
	        "close": "Close",
	        "publish": "Release",
	        "publish1": "Publish",
	        "none": "None",
	        "publishnow": "Publish Now",
	        "nowtime": "Current Time",
	        // "": "["日","一","二","三","四","五","六"]", Sun. Mon. Tue. Wed. Thu. Fri. Sat.
	        "notimelimitone": "No Time Limit",
	        "showaftersubmission": "Show after submission",
	        "showaftersubmission_col": "Show after submission",
	        "nochooseclass": "You haven't chosen a class to publish",
	        "publishtimenoearliernow": "No earlier than current time.",
	        "ddltimenoearliernow": "No earlier than current time.",
	        "ddltimetip": "Invalid time! Please reset the deadline.",
	        "testdurationzero": "Test duration can't be 0",
	        "noearlierthanpublishtime": "No earlier than publish time. \r\n Please reset.",
	        "changecfmone": "Are you sure to change?",
	        "publishcfmone": "Are you sure to publish?",
	        "deletecfmone": "Are you sure to delete？",
	        "hour": "Hour",
	        "min": "Min.",
	        "min1": "",
	        "hour2": "Hour",
	        "selecttime": "Select Time",
	        "today": "Today",
	        "tommrrow": "Tomorrow",
	        "thedayaftertommorrow": "The day after tomorrow",
	        "monthdayweek": "month day week",
	
	        "hasbeensent": "",
	        "classes": "classes have received",
	        "failSendClasses": " class(es) have received",
	        "sendLoading": "loading...",
	        "sendWaitTip": "It takes longer to wait in the queue when there are a lot of courseware being sent.",
	        "sendWaitPlease": "Close this page, does not affect your sending<br/>After successful sending, we will send a notification to your WeChat</br> Please do not repeat the operation to avoid congestion.",
	
	        // 课下主观题分组作答
	        "answerway": "Ways of Answer",
	        "totalgroup": "{count}groups",
	        "changegroup": "Change",
	        "nogroup": "No Grouping",
	        "archivetips": "You have to remove the classrooms from the Archive",
	        "answerwaydesc": "When the slides contains open questions and the target class has at least one group, you can select the group answer.All open questions in the slides will be answered according to the selected group",
	        "hassubject": "Just all open questions are allowed to answer by groups",
	        "nosubject": "There is no open question in the slides",
	        "answerway_person": "Personal Answer",
	        "nogrouptips": "There is no groups in the class, add group first or choose personal answer",
	        "choosegroup": "Select",
	        "maximum": "Select a maximum of 5 classes",
	        "coursewarecheckauth": "Permission of view courseware",
	        "endnolimit": "Invisible when finished",
	        "setimelimit": "Invisible after setting time",
	        "coursewarechecktime": "View deadline",
	        "checklimitneed": "Please select viewing time",
	        "checklimitnow": "Viewing time cannot be earlier than current time.",
	        "checklimitpub": "Viewing time cannot be earlier than publish time.",
	        "checklimitdeadline": "Viewing time cannot be earlier than deadline.",
	        "curpptnotcheck": "The courseware can not be viewed at present.",
	        "curpptnotcheckbr": "The courseware can<br/>not be viewed at present.",
	        "exercisenocheck": "The exercise can not be viewed at present.",
	        "curexercisenocheck": "The exercise can not be viewed at present.",
	        "answertimedeadline": "Announce the answer time >= deadline",
	        "setpptchecktips": "If view deadline is set, students will not able to view the slides;",
	        "changepptchecktips": "After changing view deadline，it will be applied to all students",
	        "limited": "Limited",
	        "applyforthepermission": "The previous teaching activities have been completed. If you need to continue teaching in a large class, please contact <span style=\"font-weight: bold;\">yuketang@xuetangx.com</span> to apply for the permission.",
	        'viewhelp': 'View help'
	    },
	
	    //学生小结
	    student: (_student = {
	        "way_qrcode": "Scan QR code",
	        "way_invite_code": "Class Code",
	        "way_inclass_tips": 'Class Tip',
	        "way_other": "Other",
	        "minishare": "MiniProgram Share",
	        "viewplayback": "Replay",
	        "manualmark": "Manual mark",
	        "lessonreminder": "Lesson Reminder",
	        "tencentmeeting": "Tencent meeting",
	        "transcript": "Transcript",
	        'joinclassInfo': 'You enter the class at <span class="blackText">{time} </span>by“<span class="blackText">{way}</span>”',
	        "noquestions": "No questions here",
	        "personalscore": "Your Score",
	        "averageclassscore": "Class Average",
	        "timespent": "Your Time",
	        "classaveragetime": "Class Average",
	        "summarycorrectno": "Correct",
	        "summarywrongno": "Wrong",
	        "summaryungraded": "Ungraded",
	        "questionsnumber": "Questions Number",
	        "unclearslides": "Unclear",
	        "savedslides": "Favorite",
	        "markinclass": "Click ",
	        "unclear": "Unclear",
	        "and": " and ",
	        "save": "Favorite",
	        "afterclassreview": " for your after-class review",
	        "noattendclass": "You haven't attended this class",
	        "noattendbyteacher": 'You are absent from this class，noted by your teacher.',
	        "tutorlesson": "Remember to learn it in time",
	        "studycontent": "Study Content",
	        "noreleasedslides": "Instructor didn't release any slide",
	        "summaryquiz": "Quiz",
	        "studentsummaryscore": "{score} points",
	        "nowanswered": "Unanswered",
	
	        "questiondetails": "Question Details",
	        "wrongquestion": "Wrong Questions",
	        "subjectivequestion": "Open Question",
	        "fillblank": "Completion",
	        "notanswered": "Unanswered",
	        "youranswer": "Yours:",
	        "loadmore": "Load more",
	        "allcorrectcongrats": "Congrats, all your answers are correct.",
	        "ungraded": "Ungraded",
	        "correctanswer": "Correct:"
	    }, (0, _defineProperty3.default)(_student, "unclearslides", "Unclear"), (0, _defineProperty3.default)(_student, "studentsummarynounclearslides", "No unclear slides in this class."), (0, _defineProperty3.default)(_student, "saveslides", "Saved slides"), (0, _defineProperty3.default)(_student, "summarynosavedslides", "No favorite slides in this class"), (0, _defineProperty3.default)(_student, "myposts", "My posts"), (0, _defineProperty3.default)(_student, "learningthoughts", "My thoughts"), (0, _defineProperty3.default)(_student, "writetips", "Write something"), (0, _defineProperty3.default)(_student, "brilliantstudent", "Brilliant Student"), (0, _defineProperty3.default)(_student, "amongbeststudents", "You're among the best students"), (0, _defineProperty3.default)(_student, "carryon", "Carry on"), (0, _defineProperty3.default)(_student, "underperformstudent", "Underperforming Student"), (0, _defineProperty3.default)(_student, "encourgestudent", "You can do better next time."), (0, _defineProperty3.default)(_student, "cheerup", "Cheer Up"), (0, _defineProperty3.default)(_student, "summaryallquestions", "All Questions"), (0, _defineProperty3.default)(_student, "previewdetails", "Preview Details"), (0, _defineProperty3.default)(_student, "pagetotal", "Total Slides:{count} "), (0, _defineProperty3.default)(_student, "nounderstandslide", "No Unclear slides"), (0, _defineProperty3.default)(_student, "pageno", "Page{page}"), (0, _defineProperty3.default)(_student, "subject_noanswer", "Not answered."), (0, _defineProperty3.default)(_student, "fillblank_noanswer", "Not answered."), (0, _defineProperty3.default)(_student, "seedetail", "View Details"), (0, _defineProperty3.default)(_student, "thisanswer", "The correct answer is:"), (0, _defineProperty3.default)(_student, "nosentclass", 'Not send in class'), (0, _defineProperty3.default)(_student, "thisresult", "Your Answer:"), (0, _defineProperty3.default)(_student, "no_answer", "Not answered yet."), (0, _defineProperty3.default)(_student, "answer", "Answer"), (0, _defineProperty3.default)(_student, "correct", "Correct"), (0, _defineProperty3.default)(_student, "wrong", "Wrong"), (0, _defineProperty3.default)(_student, "allslides", "Total"), (0, _defineProperty3.default)(_student, "nostoreslide", "No favorite slides."), (0, _defineProperty3.default)(_student, "toup_noanswer", "No correct answers for poll."), (0, _defineProperty3.default)(_student, "fullscreenexit", "Click the black area to exit."), (0, _defineProperty3.default)(_student, "myscore", "Score(Total{score})）"), (0, _defineProperty3.default)(_student, "score", ""), (0, _defineProperty3.default)(_student, "remark", "Comment"), (0, _defineProperty3.default)(_student, "no_setscore", "Not graded yet."), (0, _defineProperty3.default)(_student, "answeranaly", "Answer Key"), (0, _defineProperty3.default)(_student, "seeanaly", "Answer Key"), (0, _defineProperty3.default)(_student, 'acrossSingleChoice', 'Please check your answer under portrait mode'), (0, _defineProperty3.default)(_student, "myanswer", "My Answer"), (0, _defineProperty3.default)(_student, "close", "Close"), (0, _defineProperty3.default)(_student, "answertype_group", "Groups"), (0, _defineProperty3.default)(_student, "newscore", "Score"), (0, _defineProperty3.default)(_student, "blanksnotanswer", "Not all of the blanks had been filled. Are you sure to submit?"), (0, _defineProperty3.default)(_student, "screenshot", "Screenshot"), (0, _defineProperty3.default)(_student, "blackboard", "Blackboard writing"), (0, _defineProperty3.default)(_student, "lessonshare", "Share"), (0, _defineProperty3.default)(_student, "liveplayback", "Replay"), (0, _defineProperty3.default)(_student, "boardplayback", "Replay"), (0, _defineProperty3.default)(_student, "haveliveclickcheck", "View live playback of this lesson"), (0, _defineProperty3.default)(_student, 'fulltext', "Full text"), (0, _defineProperty3.default)(_student, 'fold', "Collapse"), (0, _defineProperty3.default)(_student, "undone", "Undone"), (0, _defineProperty3.default)(_student, "done", "Done"), (0, _defineProperty3.default)(_student, "pno", "Page {number}"), (0, _defineProperty3.default)(_student, "totalprob", "Total Questions:{number}"), (0, _defineProperty3.default)(_student, "unknown", "Unclear"), (0, _defineProperty3.default)(_student, "favorite", "Favorite"), (0, _defineProperty3.default)(_student, "newprob", "Hi, you have a new question"), (0, _defineProperty3.default)(_student, "newvote", "Hi, you have a new vote."), (0, _defineProperty3.default)(_student, "recvbonus", "Hi, answer the question correctly and bonus awaits you!"), (0, _defineProperty3.default)(_student, "gainbonus", "{number} students won bonus."), (0, _defineProperty3.default)(_student, "cantintoteam", "The co-instructor does not belong to any groups."), (0, _defineProperty3.default)(_student, "cantintoteam2", "No authority"), (0, _defineProperty3.default)(_student, "sharepostpush", "Hi, the teacher is sharing post."), (0, _defineProperty3.default)(_student, "sharesubjective", "Hi, the instructor posts an answer."), (0, _defineProperty3.default)(_student, "randomized", "Random grouping is launched"), (0, _defineProperty3.default)(_student, "freegrouping", "Free grouping is launched"), (0, _defineProperty3.default)(_student, "launchedgrading", "A peer grading is launched."), (0, _defineProperty3.default)(_student, "viewresults", "check"), (0, _defineProperty3.default)(_student, "enterpassword", "Enter a password"), (0, _defineProperty3.default)(_student, "LESSON_START", "Start Class!"), (0, _defineProperty3.default)(_student, "SHOW_PRESENTATION", "New Slide: {0}"), (0, _defineProperty3.default)(_student, "LESSON_FINISH", "End Class!"), (0, _defineProperty3.default)(_student, "DANMU_ON", "Danmu On"), (0, _defineProperty3.default)(_student, "DANMU_OFF", "Danmu Off"), (0, _defineProperty3.default)(_student, "RANDOM_PICK", "Random Roll Call: {0}{1}"), (0, _defineProperty3.default)(_student, "SHOW_FINISH", "End Show"), (0, _defineProperty3.default)(_student, "QUIZ_FINISH", "The quiz has been collected."), (0, _defineProperty3.default)(_student, "FREE_GROUP_CANCEL", "Free grouping has been cancelled"), (0, _defineProperty3.default)(_student, "RANDOM_GROUP_CANCEL", "Random grouping has been cancelled"), (0, _defineProperty3.default)(_student, "LIVE_ON", "Live On"), (0, _defineProperty3.default)(_student, "LIVE_OFF", "Live Off"), (0, _defineProperty3.default)(_student, "INTERACTIVE_ON", "Interactive On"), (0, _defineProperty3.default)(_student, "INTERACTIVE_OFF", "Interactive Off"), (0, _defineProperty3.default)(_student, "TencentInteractive_ON", "Tencent Meeting is on."), (0, _defineProperty3.default)(_student, "TencentInteractive_OFF", "Tencent Meeting is off."), (0, _defineProperty3.default)(_student, "howtoprint", "How to Print"), (0, _defineProperty3.default)(_student, "added", "Added"), (0, _defineProperty3.default)(_student, "canceled", "Cancel"), (0, _defineProperty3.default)(_student, "cannotbecanceled", "Unclear slides cannot be cancelled"), (0, _defineProperty3.default)(_student, "nothinghere", "Nothing here~"), (0, _defineProperty3.default)(_student, "videotranscoded", "Playback video is being transcoded, please try later"), (0, _defineProperty3.default)(_student, "waiting", "The playback generation will be slow. Please wait patiently ~"), (0, _defineProperty3.default)(_student, "audioplayback", "Audio playback"), (0, _defineProperty3.default)(_student, "set", "Set"), (0, _defineProperty3.default)(_student, "definition", "Definition"), (0, _defineProperty3.default)(_student, "high", "High"), (0, _defineProperty3.default)(_student, "standard", "Standard"), (0, _defineProperty3.default)(_student, "smooth", "Smooth"), (0, _defineProperty3.default)(_student, "speed", "Speed"), (0, _defineProperty3.default)(_student, "playback", "Class live playback"), (0, _defineProperty3.default)(_student, "watchplayback", "Watch class live playback"), (0, _defineProperty3.default)(_student, "fold", "fold"), (0, _defineProperty3.default)(_student, "play", "Play"), (0, _defineProperty3.default)(_student, "backtocurrent", "Back to current position"), (0, _defineProperty3.default)(_student, "audiotranscoded", "Playback audio is being transcoded, please wait..."), (0, _defineProperty3.default)(_student, "reload", "Try to visit or reload this page later ~"), (0, _defineProperty3.default)(_student, "board", "Board"), (0, _defineProperty3.default)(_student, "dataabnormal", "Data abnormal"), (0, _defineProperty3.default)(_student, "cannotaccesstencent", "Unable to access the Tencent Meeting replay，please replace the playback via Manage Live Replay-Replace playback on webside."), (0, _defineProperty3.default)(_student, "cannotaccesstencentstu", "Unable to access the Tencent Meeting replay , please contact teacher to go to the  Manage Live Replay on webside to replace the playback."), (0, _defineProperty3.default)(_student, "manage", "Manage"), (0, _defineProperty3.default)(_student, "audiospeed", "speed"), (0, _defineProperty3.default)(_student, "savecloud", "save to cloud"), (0, _defineProperty3.default)(_student, "downloadtip", "please download replay on Web"), (0, _defineProperty3.default)(_student, "deleteurl", "delete replay"), (0, _defineProperty3.default)(_student, "allcheck", "all"), (0, _defineProperty3.default)(_student, "replayurl", "replay"), (0, _defineProperty3.default)(_student, "duration", "Play Time"), (0, _defineProperty3.default)(_student, "saving", "saving"), (0, _defineProperty3.default)(_student, "offload", "offload"), (0, _defineProperty3.default)(_student, "nonsupport", "nonsupport"), (0, _defineProperty3.default)(_student, "iknow", "I know"), (0, _defineProperty3.default)(_student, "notvip", " you're not a member"), (0, _defineProperty3.default)(_student, "viptip", "You cann't save to cloud unless you are a vip member. You can  follow \"\u96E8\u8BFE\u5802\" on wechat,  send \"VIP\" and click the received link to apply."), (0, _defineProperty3.default)(_student, "tips", "tips"), (0, _defineProperty3.default)(_student, "issaviing", "The replay is being  saved to cloud, please check it in the cloud later"), (0, _defineProperty3.default)(_student, "spacefull", "Storage space is full"), (0, _defineProperty3.default)(_student, "fulltip", "The space is full, you can try again after you have cleared enough space"), (0, _defineProperty3.default)(_student, "deleteallreplay", "Are you sure to delete all replays?"), (0, _defineProperty3.default)(_student, "deletealltip", "After deletion, neither teachers nor students can watch the replay , and it cannot be recovered"), (0, _defineProperty3.default)(_student, "deletereplay", "Are you sure to delete the  replays?"), (0, _defineProperty3.default)(_student, "deletetip", "After deletion, neither teachers nor students can watch the replay , and it cannot be recovered"), (0, _defineProperty3.default)(_student, "deletesuccess", "Delete Success"), (0, _defineProperty3.default)(_student, "servicenonsupport", "The service provider does not support it"), (0, _defineProperty3.default)(_student, "servicenonsupportdel", "The current replay can not be deleted"), (0, _defineProperty3.default)(_student, "servicenonsupporthidden", "The current replay can not be hidden"), (0, _defineProperty3.default)(_student, "repeatsave", "Please do not repeat submit"), (0, _defineProperty3.default)(_student, "checkinweb", "It has been saved, please check it in the Web cloud"), (0, _defineProperty3.default)(_student, "replayisprocessed", "replay is being processed please save later"), (0, _defineProperty3.default)(_student, "playtype1", "[audio]"), (0, _defineProperty3.default)(_student, "playtype2", "[video]"), (0, _defineProperty3.default)(_student, "noaccess", "Sorry, you do not have administrative rights, you can contact the lecturer to manage."), (0, _defineProperty3.default)(_student, "setviewstatus", "Set visible state"), (0, _defineProperty3.default)(_student, "playbackentry", "Entrance of playback"), (0, _defineProperty3.default)(_student, "audioplayback", "Audio playback"), (0, _defineProperty3.default)(_student, "videoplayback", "Video playback"), (0, _defineProperty3.default)(_student, "confirmcloseentry", "Are you sure to close the entrance of playback?"), (0, _defineProperty3.default)(_student, "closeentryresult", "Students will not be able to watch all playback paragraphs after closing."), (0, _defineProperty3.default)(_student, "confirmhiddenplayback", "Are you sure to hide the playback paragraph?"), (0, _defineProperty3.default)(_student, "hiddenresult", "The playback paragraph will not be visible to students after hiding."), (0, _defineProperty3.default)(_student, "setsuccess", "Set successfully"), (0, _defineProperty3.default)(_student, "playbackallhiddentip", "* All playbacks of this lecture are currently unavailable"), (0, _defineProperty3.default)(_student, "cannotplaycuritem", "The current playback paragraph has been hidden or deleted, locating function cannot be used"), (0, _defineProperty3.default)(_student, "exam_desc", "Information for Candidates"), (0, _defineProperty3.default)(_student, "nodesc", "No tips"), (0, _defineProperty3.default)(_student, "score_finished", "My score"), (0, _defineProperty3.default)(_student, "score_unstart", "Score"), (0, _defineProperty3.default)(_student, "wrongproblems", "Errors"), (0, _defineProperty3.default)(_student, "datishu", "Groups"), (0, _defineProperty3.default)(_student, "xitishuliang", "Questions"), (0, _defineProperty3.default)(_student, "problems", "Questions"), (0, _defineProperty3.default)(_student, "exam_notanswer", "No answer"), (0, _defineProperty3.default)(_student, "start_time", "Start Time"), (0, _defineProperty3.default)(_student, "end_time", "Deadline"), (0, _defineProperty3.default)(_student, "end_lesson_time", "结课时间"), (0, _defineProperty3.default)(_student, "exam_limit", "Duration"), (0, _defineProperty3.default)(_student, "exam_notlimit", "No limit"), (0, _defineProperty3.default)(_student, "answer_time", "Score will be released after {time}"), (0, _defineProperty3.default)(_student, "exam_start", "Start exam"), (0, _defineProperty3.default)(_student, "exam_continue", "Continue answering"), (0, _defineProperty3.default)(_student, "exam_notbegin", "Not started"), (0, _defineProperty3.default)(_student, "exam_check", "Check quiz"), (0, _defineProperty3.default)(_student, "exam_nodata", "暂无数据"), (0, _defineProperty3.default)(_student, "exam_notview", "Invisible when submitted"), (0, _defineProperty3.default)(_student, "sun", "Sunday"), (0, _defineProperty3.default)(_student, "mon", "Monday"), (0, _defineProperty3.default)(_student, "tue", "Tuesday"), (0, _defineProperty3.default)(_student, "wed", "Wednesday"), (0, _defineProperty3.default)(_student, "thu", "Thrusday"), (0, _defineProperty3.default)(_student, "fri", "Friday"), (0, _defineProperty3.default)(_student, "sat", "Saturday"), (0, _defineProperty3.default)(_student, "watchedreplay", "You have watched the class replay"), (0, _defineProperty3.default)(_student, "partpagenoview", "部分页面当前已不可见"), (0, _defineProperty3.default)(_student, "coverentertips", "Unable to start the examination"), _student),
	
	    //消息
	    message: {
	        "infoassignment": "Assignments",
	        "infomessage": "Messages",
	        "infofollowers": "Followers",
	        "chat": "Chat",
	        "comment": "Comment",
	        "repliedToYou": "replied to you",
	        "commentedOnYourComment": "commented on your comment",
	        "likedYou": "liked you ",
	        "NoMessage": "No Message",
	        "loading": "Loading",
	        "nomessage": "You have no messages.",
	        "infocoteacher": "You have became a co-teacher.",
	        "removecoteacher": "You have been removed as a co-teacher.",
	
	        "infopromotecoteacher": " {courseTitle} 's leading teacher has made you the co-teacher.",
	        "inforemovecoteacher": "{courseTitle} 's leading teacher has removed you from co-teacher.",
	        "receivepreclassinfo": "Received preview feedback.",
	        "inforeceivereport": "received {feedbackCnt} preview messages, please check.",
	
	        "replypreviewreport": "received a teacher's reply.",
	        "receiveteacherreply": "received a teacher's reply, check it!",
	
	        "pullRefresh": "Pull down",
	        "releaseUpdate": "Release",
	        "markasread": "Mark as Read",
	        "hasMarked": "All marked as read",
	        "message": "Message",
	        "notification": "Notification",
	
	        "infonofollowers": "You have no followers.",
	        "infoyourquestionanswered": "{respondent} answered your question.",
	        "infoquestionname": "The question is {question}",
	        "inforeplytou": "replied to you",
	
	        "noassignment": "You have finished all assignments.",
	        "publishslidespush": " {teacherName} published new slides.",
	        "published": " has been published",
	        "slidesddlpush": "Deadline: {deadline}",
	        "previewpush": "Please finish before {deadline}",
	        "unclearremind": "You have unclear slides.",
	        "figureoutunclears": " Figure out the unclear slides. You can do it!",
	        "publishquizpush": " Instructor {teacherName} published a new test.",
	        "publishedpush": "  please check it.",
	        "assignmentddlpush": "Please finish before {deadline}.",
	        "inforeceiveslidespush": "Start to study {courseTitle}-{chapterTitle}{sectionTitle}~",
	        "unclearset": "Students' Unclear Slides Set",
	        "checkstudentunclear": "Check students' unclear slides!",
	        "infobeinvited": "{inviter} invites you to answer a question.",
	
	        "booking_down": "The open class you booked has updated.",
	        "image": "pic",
	        "NoMessageTips": "You can chat with others by clicking members' photos on member list.",
	        "commentdel": "comment deleted"
	    },
	
	    // 教师端页面
	    teacher: (_teacher = {
	        "yijiaojuan": "Submitted",
	        "weijiaojuan": "Unsubmitted",
	        "unclearlist": "“Unclear” List",
	        "standardopt": "The correct answer is :",
	        "nameone": "Name",
	        "optionone": "Option",
	        "notansweredone": "Not Answered.",
	        "wrongquestionone": "Question Wrong",
	        "slidewrongone": "Slide Unclear",
	        "studentnumber": "Number of students",
	        "wrongone": "Wrong",
	        "unclearone": "Unclear: ",
	        "uncleartwo": "Unclear",
	        "searchone": "Search",
	        "rankingone": "Ranking",
	        "totalscoreone": "Scores",
	        "timespentone": "Time Spent",
	        "questionandpage": "No.",
	        "tihao": "No.",
	        "correctanswertwo": "Correct Answer",
	        "submitone": "Submit",
	        "submit": "Submit",
	        "correctanswerthree": "Correct Answer",
	        "scoreone": "Score",
	        "subjectivequestionone": "Open question",
	        "inclassquiz": "In-class Quiz",
	        "notansweredtwo": "Not Answered",
	        "notansweredblanks": "Not answered",
	        "detailsone": "Details",
	        "checkone": "Check",
	        "sentokone": "",
	        "sentoktwo": "Sent successfully:",
	        "scheduledeliverfailedone": "Scheduled Deliver failed, please try again.",
	        "publishname": "Publish Name",
	        "quizone": "Quizzes",
	        "timetopublish": "Time to publish",
	        "timetopublish1": "Time to release",
	        "deadlineone": "Deadline",
	        "quizdurationone": "Quiz Duration (mins)",
	        "releasetimeone": "Time to release answer",
	        "publishclassone": "Class",
	        "totalclassesone": "Total Classes: {length}",
	        "pagetotal": "Total Slides:{count} ",
	        "deletepublishone": "Are you sure to delete?",
	        "cancelone": "Cancel",
	        "okone": "OK",
	        "delete": "delete",
	        "confirmone": "ok",
	        "publishinstruction": "How to publish {\"quiz\" : \"slide\"}?",
	        "setdeadlinetips": "If you set the deadline, students can still check the slides after the deadline, but not able to answer questions. And the data is no longer updated.",
	        "nosetdeadlinetips": " If you do not set the deadline, students can check the slides and answer questions at any time, and the data will be updated in real time.",
	        "systemsubmitanswers": "After the deadline, students can still check the answers, but unable to answer or submit. The test data and score distribution will not be updated, and students' answers will be submitted automatically.",
	        "timernostop": "Students must submit answers by the deadline. The timer will not stop if you exit. Students' answers will be submitted automatically at the end of test.",
	        "releasetips": "The correct answers will be released after the selected time. Until then, students will not be able to know the answer key.",
	        "close": "Close",
	        "publish": "Release",
	        "none": "None",
	        "publishnow": "Release Now",
	        "": "[\"Sun.\",\"Mon.\",\"Tue.\",\"Wed.\",\"Thu.\",\"Fri.\",\"Sat.\"]",
	        "notimelimitone": "No Time Limit",
	        "showaftersubmission": "Show after submission",
	        "nochooseclass": "You haven't chosen a class to publish",
	        "publishtimenoearliernow": "No earlier than current time.",
	        "ddltimenoearliernow": "No earlier than current time.",
	        "testdurationzero": "Test duration can't be 0",
	        "noearlierthanpublishtime": "No earlier than publish time. \\r\\n Please reset.",
	        "changecfmone": "Are you sure to change?",
	        "publishcfmone": "Are you sure to publish?",
	        "deletecfmone": "Are you sure to delete？",
	        "hour": "Hour",
	        "min": "Min.",
	        "min1": "Min.",
	        "hour1": "",
	        "today": "Today",
	        "tommrrow": "Tomorrow",
	        "thedayaftertommorrow": "The day after tomorrow",
	        "tips1": "Tips: you can release answers at a certain time.",
	        "chengjidantips": "The system will automatically calculate points according to the assessment settings. You can view and manage assessment program on the web.",
	        "monthdayweek": "month day week",
	        "anonymouspollnodetail": "This is an anonymous poll.",
	        "numberofvotes": "{count} votes"
	    }, (0, _defineProperty3.default)(_teacher, "standardopt", "The correct answer is:"), (0, _defineProperty3.default)(_teacher, "numberofstudents", " {count} student(s)"), (0, _defineProperty3.default)(_teacher, "numberofstudents1", "student(s)"), (0, _defineProperty3.default)(_teacher, "noanswers", "No answers yet."), (0, _defineProperty3.default)(_teacher, "answerdetails", ""), (0, _defineProperty3.default)(_teacher, "submittime", "Submit Time"), (0, _defineProperty3.default)(_teacher, "numberviewedpage", "Page viewed"), (0, _defineProperty3.default)(_teacher, "content", "Content"), (0, _defineProperty3.default)(_teacher, "senttime", "Sent Time"), (0, _defineProperty3.default)(_teacher, "saved", "Saved"), (0, _defineProperty3.default)(_teacher, "save", "Save"), (0, _defineProperty3.default)(_teacher, "whatispost", "What is Post?"), (0, _defineProperty3.default)(_teacher, "post", "Post"), (0, _defineProperty3.default)(_teacher, "coteacherinclass", "Co-instructor"), (0, _defineProperty3.default)(_teacher, "addcoteacher", "Add Co-instructorr"), (0, _defineProperty3.default)(_teacher, "setpermission", "Set Permission"), (0, _defineProperty3.default)(_teacher, "deletepermissioncfm", "Are you sure to delete?"), (0, _defineProperty3.default)(_teacher, "deletepermissionfailed", "Delete Failed"), (0, _defineProperty3.default)(_teacher, "selectall", "Select All"), (0, _defineProperty3.default)(_teacher, "confirmdelete", "Confirm"), (0, _defineProperty3.default)(_teacher, "", "You can only manage guest students."), (0, _defineProperty3.default)(_teacher, "managestudents", "Manage Students"), (0, _defineProperty3.default)(_teacher, "clear", "Clear"), (0, _defineProperty3.default)(_teacher, "readnumber", "read"), (0, _defineProperty3.default)(_teacher, "unreadnumber", "unread"), (0, _defineProperty3.default)(_teacher, "slidecover", "Slide Cover"), (0, _defineProperty3.default)(_teacher, "slidename", "Slide Name"), (0, _defineProperty3.default)(_teacher, "yearmonthday", "year month day"), (0, _defineProperty3.default)(_teacher, "selectclass", "Select Class"), (0, _defineProperty3.default)(_teacher, "done", "Done"), (0, _defineProperty3.default)(_teacher, "addnewclassinjoined", "Click \"Manage\" to add a new class"), (0, _defineProperty3.default)(_teacher, "enterslidetitle", "Please enter the slide title"), (0, _defineProperty3.default)(_teacher, "noclasschosen", " You have not chosen a class to publish."), (0, _defineProperty3.default)(_teacher, "publishfailed", "Publish Failed"), (0, _defineProperty3.default)(_teacher, "selectclasstopublish", "Select class to publish"), (0, _defineProperty3.default)(_teacher, "nocreatedcourse", "You have not created a course."), (0, _defineProperty3.default)(_teacher, "createaacourse", "Create Course"), (0, _defineProperty3.default)(_teacher, "publishname", "Publish Name"), (0, _defineProperty3.default)(_teacher, "noclassyet", "No class in this course, please add a class."), (0, _defineProperty3.default)(_teacher, "tocreatecourse", "Create Course"), (0, _defineProperty3.default)(_teacher, "cfmpublish", "Confirm"), (0, _defineProperty3.default)(_teacher, "enterslidetitle", "Please enter slide title"), (0, _defineProperty3.default)(_teacher, "selectclassplease", "Please select class"), (0, _defineProperty3.default)(_teacher, "announcementlimit", "You can only send two announcements for each class per day, you can still send _."), (0, _defineProperty3.default)(_teacher, "anouncementnumbers", "announcements"), (0, _defineProperty3.default)(_teacher, "requiredtitle", "Title (required)"), (0, _defineProperty3.default)(_teacher, "spaceorentertosend", "You can send texts, images, links to students (please add a space or press Enter to confirm before and after entering the link address)"), (0, _defineProperty3.default)(_teacher, "sendto", "Send to："), (0, _defineProperty3.default)(_teacher, "backtoedit", "Back to edit"), (0, _defineProperty3.default)(_teacher, "confirmok", "OK"), (0, _defineProperty3.default)(_teacher, "classesreceiveok", "It has been successfully sent to the following classes:："), (0, _defineProperty3.default)(_teacher, "gotit", "Got it"), (0, _defineProperty3.default)(_teacher, "deletepiccfm", "Are you sure to delete？"), (0, _defineProperty3.default)(_teacher, "quiteditcfm", "Discard the changes?"), (0, _defineProperty3.default)(_teacher, "noannouncementcansend", "You can send 0 announcement."), (0, _defineProperty3.default)(_teacher, "titlenotnull", "The title should not be null."), (0, _defineProperty3.default)(_teacher, "announcementnotnull", "The announcement should not be null."), (0, _defineProperty3.default)(_teacher, "reachupperlimit", "Unable to send. Reached the upper limit."), (0, _defineProperty3.default)(_teacher, "announceanswertip", "Tips: The answer will be announced after this date, otherwise it will be displayed directly after submission.\n"), (0, _defineProperty3.default)(_teacher, "notimelimitdetail", "No Time Limit. 5 mins 15 mins 30 mins 45 mins 60 mins 90 mins 120 mins 150 mins 4 hours 6 hours 8 hours 2 hours 24 hours 48 hours."), (0, _defineProperty3.default)(_teacher, "enterquizname", "Please enter the test name"), (0, _defineProperty3.default)(_teacher, "setdateaftertoday", "Please set a date after today"), (0, _defineProperty3.default)(_teacher, "teachingdatapoll", "Poll"), (0, _defineProperty3.default)(_teacher, "chooseupperlimit", "Choose no more than ..."), (0, _defineProperty3.default)(_teacher, "teachingdataoption", "Option"), (0, _defineProperty3.default)(_teacher, "multiplem", "Multiple Choice (multiple)"), (0, _defineProperty3.default)(_teacher, "multiples", "Multiple Choice (single)"), (0, _defineProperty3.default)(_teacher, "subjectivepro", "Open Question"), (0, _defineProperty3.default)(_teacher, "point", "Point"), (0, _defineProperty3.default)(_teacher, "anonymouspollnodetail", "This is an anonymous poll."), (0, _defineProperty3.default)(_teacher, "votenumber", "votes"), (0, _defineProperty3.default)(_teacher, "standardopt", "The correct answer is"), (0, _defineProperty3.default)(_teacher, "notansweredone", "Not answered"), (0, _defineProperty3.default)(_teacher, "teacherdatastudents", "students"), (0, _defineProperty3.default)(_teacher, "teacherdatastudentscount", "{count}student(s)"), (0, _defineProperty3.default)(_teacher, "weidatitishi", "*Unanswered questions do not include students who are not signed in."), (0, _defineProperty3.default)(_teacher, "zuodashichang", "Length of response time"), (0, _defineProperty3.default)(_teacher, "noanswers", "No answers yet."), (0, _defineProperty3.default)(_teacher, "answerdetails", "Answer Details"), (0, _defineProperty3.default)(_teacher, "noaddslides", "You have not added any slides yet."), (0, _defineProperty3.default)(_teacher, "selectslideoneonly", "Select Slide (1 only)"), (0, _defineProperty3.default)(_teacher, "coursechooseslide", "Select Quiz (1 only)"), (0, _defineProperty3.default)(_teacher, "year", "Year"), (0, _defineProperty3.default)(_teacher, "month", "Month"), (0, _defineProperty3.default)(_teacher, "day", "Day"), (0, _defineProperty3.default)(_teacher, "publishname", "Publish Name"), (0, _defineProperty3.default)(_teacher, "deadline", "Deadline"), (0, _defineProperty3.default)(_teacher, "enterslidenameplease", "Please enter slide title"), (0, _defineProperty3.default)(_teacher, "datedetail", "／ ／"), (0, _defineProperty3.default)(_teacher, "cfmpublish", "Confirm"), (0, _defineProperty3.default)(_teacher, "slidepublish", "Publish"), (0, _defineProperty3.default)(_teacher, "sending", "Sending"), (0, _defineProperty3.default)(_teacher, "noaddtests", "You haven't added any tests yet."), (0, _defineProperty3.default)(_teacher, "selectslideoneonly", "Select Slide ( 1 only )"), (0, _defineProperty3.default)(_teacher, "sendnow", "Send Now"), (0, _defineProperty3.default)(_teacher, "testduration", "Duration(mins)"), (0, _defineProperty3.default)(_teacher, "notimelimitone", "No Time Limit"), (0, _defineProperty3.default)(_teacher, "releasetimeone", "Time to release answer"), (0, _defineProperty3.default)(_teacher, "showaftersubmission", "Show after submission"), (0, _defineProperty3.default)(_teacher, "announceanswertip", "Tips: The answer will be announced after this date, otherwise it will be displayed directly after submission."), (0, _defineProperty3.default)(_teacher, "cfmpublish", "Confirm"), (0, _defineProperty3.default)(_teacher, "publishtest", "Publish Test"), (0, _defineProperty3.default)(_teacher, "setdateaftertoday", "Please set a date after today."), (0, _defineProperty3.default)(_teacher, "sending", "Sending"), (0, _defineProperty3.default)(_teacher, "notimelimitdetails ", "No Time Limit 5mins 15mins 30 mins 45mins 60 mins 90mins 120mins 150mins 4hours 6hours 9hours 12hours 24hours 48hours"), (0, _defineProperty3.default)(_teacher, "donealready", "Done"), (0, _defineProperty3.default)(_teacher, "checkedpreview", "Checked"), (0, _defineProperty3.default)(_teacher, "nocheckedpreview", "Not Checked"), (0, _defineProperty3.default)(_teacher, "noonefinishpreview", "No student has finished studied."), (0, _defineProperty3.default)(_teacher, "noonepreviewing", "No student is studying."), (0, _defineProperty3.default)(_teacher, "allfinish", "All students have finished."), (0, _defineProperty3.default)(_teacher, "previewdetail", "Completion"), (0, _defineProperty3.default)(_teacher, "finisheddetails", "Completion"), (0, _defineProperty3.default)(_teacher, "finishedpreview", "Done"), (0, _defineProperty3.default)(_teacher, "checkslides", "Check Slides"), (0, _defineProperty3.default)(_teacher, "viewdetails", "View Details"), (0, _defineProperty3.default)(_teacher, "studentscheckedslides", "Students checked slides"), (0, _defineProperty3.default)(_teacher, "totalclassstudents", "Total Students"), (0, _defineProperty3.default)(_teacher, "answerdetails", "Answer Details"), (0, _defineProperty3.default)(_teacher, "subjectivepro", "Open Question"), (0, _defineProperty3.default)(_teacher, "gradingrate", "Grading Rate"), (0, _defineProperty3.default)(_teacher, "answerrate", "Answer Rate"), (0, _defineProperty3.default)(_teacher, "averagescore", "Average Score"), (0, _defineProperty3.default)(_teacher, "poll", "Poll"), (0, _defineProperty3.default)(_teacher, "grading", "Grading"), (0, _defineProperty3.default)(_teacher, "webgradetips", "Tips: try a more convenient way to grade Open questions on Rain Classroom Web at {url}."), (0, _defineProperty3.default)(_teacher, "accuracy", "Accuracy"), (0, _defineProperty3.default)(_teacher, "objectivequestion", "Objective Question"), (0, _defineProperty3.default)(_teacher, "answerrate", "Answer Rate"), (0, _defineProperty3.default)(_teacher, "teacherdatacheck", "Check"), (0, _defineProperty3.default)(_teacher, "studentfeedback", "Student Feedback"), (0, _defineProperty3.default)(_teacher, "anonymous", "Anonymous"), (0, _defineProperty3.default)(_teacher, "unread", "Unread"), (0, _defineProperty3.default)(_teacher, "nostudentfeedback", "No feedback."), (0, _defineProperty3.default)(_teacher, "detaileddata", "Detailed Data"), (0, _defineProperty3.default)(_teacher, "webdownloadexcel", "Please download all Excel data on Rain Classroom Web at {url}."), (0, _defineProperty3.default)(_teacher, "teachingdesign", "Instructional Design&Memo"), (0, _defineProperty3.default)(_teacher, "teachingdesigntip", "You can take notes here. (Private)"), (0, _defineProperty3.default)(_teacher, "editpublishtitle", "Edit Title"), (0, _defineProperty3.default)(_teacher, "deletepublish", "Delete Publish"), (0, _defineProperty3.default)(_teacher, "loadmore", "Load more"), (0, _defineProperty3.default)(_teacher, "mailreceivedata", "Please type your email address to receive detailed data:"), (0, _defineProperty3.default)(_teacher, "enterfrequentmail", "Please write down your frequently used email address:"), (0, _defineProperty3.default)(_teacher, "mailformaterror", "Email Format Error"), (0, _defineProperty3.default)(_teacher, "datasentok", "Sent Successfully"), (0, _defineProperty3.default)(_teacher, "yktwebtips", "Tips: on Rain Classroom Web at {url}"), (0, _defineProperty3.default)(_teacher, "enternewtitle", "Please enter the new title."), (0, _defineProperty3.default)(_teacher, "deletepulishcfm", "Are you sure to delete?"), (0, _defineProperty3.default)(_teacher, "deletepublishfailed", "Delete Failed"), (0, _defineProperty3.default)(_teacher, "previewdetails", "Preview Details"), (0, _defineProperty3.default)(_teacher, "finisheddetails", "Finished Details"), (0, _defineProperty3.default)(_teacher, "gradingdetails", "Grading Details"), (0, _defineProperty3.default)(_teacher, "name", "Name"), (0, _defineProperty3.default)(_teacher, "score", "Score"), (0, _defineProperty3.default)(_teacher, "submission", "Submission"), (0, _defineProperty3.default)(_teacher, "gradingtime", "Grading Time"), (0, _defineProperty3.default)(_teacher, "noonefinished", "No student has finished"), (0, _defineProperty3.default)(_teacher, "testfinisheddetails", "Test Completion"), (0, _defineProperty3.default)(_teacher, "finisheddetails", "Completion"), (0, _defineProperty3.default)(_teacher, "checktestpaper", "Check Test Paper"), (0, _defineProperty3.default)(_teacher, "graded", "Graded"), (0, _defineProperty3.default)(_teacher, "finishedtest", "Finished Test"), (0, _defineProperty3.default)(_teacher, "checktestpaper", "Check Test Paper"), (0, _defineProperty3.default)(_teacher, "totalstudentone", "Total Students"), (0, _defineProperty3.default)(_teacher, "viewdetails", "View Details"), (0, _defineProperty3.default)(_teacher, "scoredistribution", "Score Distribution"), (0, _defineProperty3.default)(_teacher, "allvote", "Test Type: Polls"), (0, _defineProperty3.default)(_teacher, "ungradedsubjectiveproexist", "You still have ungraded Open questions."), (0, _defineProperty3.default)(_teacher, "clickbarcharttograde.", "Click bar chart of Open questions to grade."), (0, _defineProperty3.default)(_teacher, "noonefinishedtest", "No student has finished."), (0, _defineProperty3.default)(_teacher, "qbxsyjj", "All students have submitted."), (0, _defineProperty3.default)(_teacher, "answerdetails", "Answer Details"), (0, _defineProperty3.default)(_teacher, "grading", "Grading"), (0, _defineProperty3.default)(_teacher, "deleteexcelnow", "You can download detailed Excel data directly."), (0, _defineProperty3.default)(_teacher, "deletepulishcfm", "Are you sure to delete?"), (0, _defineProperty3.default)(_teacher, "deletepublishfailed", "Delete Failed"), (0, _defineProperty3.default)(_teacher, "standardopt", "The correct answer is:"), (0, _defineProperty3.default)(_teacher, "noanswerforpoll", "There is no correct answer for poll"), (0, _defineProperty3.default)(_teacher, "option", "Option"), (0, _defineProperty3.default)(_teacher, "name", "Name"), (0, _defineProperty3.default)(_teacher, "loadingdata", "Loading..."), (0, _defineProperty3.default)(_teacher, "answered", "Answered"), (0, _defineProperty3.default)(_teacher, "notansweredone", "Not answered"), (0, _defineProperty3.default)(_teacher, "lessonexciese", "Questions"), (0, _defineProperty3.default)(_teacher, "lessonquiz", "Quizzes"), (0, _defineProperty3.default)(_teacher, "score", "Score"), (0, _defineProperty3.default)(_teacher, "gradeone", "Grading"), (0, _defineProperty3.default)(_teacher, "stick", ""), (0, _defineProperty3.default)(_teacher, "loadmore", "Load more"), (0, _defineProperty3.default)(_teacher, "okone", "OK"), (0, _defineProperty3.default)(_teacher, "thisquestion", "thisquestion"), (0, _defineProperty3.default)(_teacher, "point", "Point"), (0, _defineProperty3.default)(_teacher, "cancel", "Cancel"), (0, _defineProperty3.default)(_teacher, "positivescore", "Score must be positive."), (0, _defineProperty3.default)(_teacher, "exceedmaximumscore", "Exceed maximum score, please try again."), (0, _defineProperty3.default)(_teacher, "keepadecimal", "One decimal at most , please try again."), (0, _defineProperty3.default)(_teacher, "numberonlywarning", "Numbers only, please try again."), (0, _defineProperty3.default)(_teacher, "unclearstudents", "\"Unclear\" Students"), (0, _defineProperty3.default)(_teacher, "unclearstudents1", "\"Unclear\" Students<span class=\"font18\">{count}</span>student(s)"), (0, _defineProperty3.default)(_teacher, "noquestiontoanswer", "The teacher didn't send any questions in this class."), (0, _defineProperty3.default)(_teacher, "nounclearslides", "No Unclear Slides"), (0, _defineProperty3.default)(_teacher, "nocommentslides", "Nothing Here~"), (0, _defineProperty3.default)(_teacher, "commentcount", "Comment"), (0, _defineProperty3.default)(_teacher, "quantityone", "Bonus Quantity："), (0, _defineProperty3.default)(_teacher, "noquestiontoanswer", "The teacher didn't send any questions in this class."), (0, _defineProperty3.default)(_teacher, "standardopt", "The correct answer is :"), (0, _defineProperty3.default)(_teacher, "noanswerforpoll", "No correct answer for the poll."), (0, _defineProperty3.default)(_teacher, "gradingtime", "Grading Time"), (0, _defineProperty3.default)(_teacher, "timelimitedtest", "This is a time-limited test."), (0, _defineProperty3.default)(_teacher, "min", "mins"), (0, _defineProperty3.default)(_teacher, "deadline", "Deadline"), (0, _defineProperty3.default)(_teacher, "testdeadline", "Test Deadline"), (0, _defineProperty3.default)(_teacher, "timelimitedtest", "This is a time-limited test."), (0, _defineProperty3.default)(_teacher, "checkhw", "Check"), (0, _defineProperty3.default)(_teacher, "finishedhw", "Submitted Assignments"), (0, _defineProperty3.default)(_teacher, "hwfinisheddetail", "Assignment Completion"), (0, _defineProperty3.default)(_teacher, "finishedhwstudent", "students have finished the assignments"), (0, _defineProperty3.default)(_teacher, "gradedhwnumber", "assignments have been graded."), (0, _defineProperty3.default)(_teacher, "scorereport", "Score Report"), (0, _defineProperty3.default)(_teacher, "questionlocate", "Question"), (0, _defineProperty3.default)(_teacher, "accuracyone", "Accuracy"), (0, _defineProperty3.default)(_teacher, "editpublishtitle", "Edit Title"), (0, _defineProperty3.default)(_teacher, "deletepublish", "Delete Publish"), (0, _defineProperty3.default)(_teacher, "deletepublishone", "Are you sure to delete?"), (0, _defineProperty3.default)(_teacher, "deletepublishfailed", "Delete Failed"), (0, _defineProperty3.default)(_teacher, "mailreceivedata", "Please type your email address to receive detailed data:"), (0, _defineProperty3.default)(_teacher, "enterfrequentmail", "Please write down your frequently used email address."), (0, _defineProperty3.default)(_teacher, "datasentok", "Sent Successfully"), (0, _defineProperty3.default)(_teacher, "submission", "Submission"), (0, _defineProperty3.default)(_teacher, "searchname", "Search Name"), (0, _defineProperty3.default)(_teacher, "checktestpaper", "Check Test Paper"), (0, _defineProperty3.default)(_teacher, "randomrollcallinthisclass", "Random Roll Call"), (0, _defineProperty3.default)(_teacher, "signedinstudent", "Attended"), (0, _defineProperty3.default)(_teacher, "totalsignedstudent", "Total: X students"), (0, _defineProperty3.default)(_teacher, "signin", "Sign In"), (0, _defineProperty3.default)(_teacher, "dot", ""), (0, _defineProperty3.default)(_teacher, "person", ""), (0, _defineProperty3.default)(_teacher, "ci", ""), (0, _defineProperty3.default)(_teacher, "nistudenttocall", "No student in the class"), (0, _defineProperty3.default)(_teacher, "correctopt", "Correct Answer"), (0, _defineProperty3.default)(_teacher, "wrongopt", "Wrong Answer"), (0, _defineProperty3.default)(_teacher, "anonymouspollnodetail", "This is an anonymous poll."), (0, _defineProperty3.default)(_teacher, "totalamountofbonus", "Total Amount"), (0, _defineProperty3.default)(_teacher, "rmb", "CNY"), (0, _defineProperty3.default)(_teacher, "bonusnotopened", "Not Opened"), (0, _defineProperty3.default)(_teacher, "notansweredtwo", "Not Answered"), (0, _defineProperty3.default)(_teacher, "votemost", "Most Voted:"), (0, _defineProperty3.default)(_teacher, "standardopt", "The correct answer is:"), (0, _defineProperty3.default)(_teacher, "voteoption", "Vote Option"), (0, _defineProperty3.default)(_teacher, "nostudentanswered", " No answers"), (0, _defineProperty3.default)(_teacher, "studentfinishedpreview", "Finished"), (0, _defineProperty3.default)(_teacher, "previewdetail", "Details"), (0, _defineProperty3.default)(_teacher, "finishpreview", "Finished"), (0, _defineProperty3.default)(_teacher, "privateteachingnote", "You can take notes here. (Private)"), (0, _defineProperty3.default)(_teacher, "mailreceivedata", "Please type your email address to receive detailed data:"), (0, _defineProperty3.default)(_teacher, "activestudent", "Active Students"), (0, _defineProperty3.default)(_teacher, "enterclass", "In Class"), (0, _defineProperty3.default)(_teacher, "activestudentnumber", "Active"), (0, _defineProperty3.default)(_teacher, "totalclassstudent", "Total"), (0, _defineProperty3.default)(_teacher, "studentdata", "Student Data"), (0, _defineProperty3.default)(_teacher, "notfinalrank", "The ranking might change due to ungraded Open questions."), (0, _defineProperty3.default)(_teacher, "totalrank", "Ranking"), (0, _defineProperty3.default)(_teacher, "notfinalrank", "The ranking might change due to ungraded Open questions."), (0, _defineProperty3.default)(_teacher, "brilliantstudent ", "Brilliant Students"), (0, _defineProperty3.default)(_teacher, "timespenttwo", "Time Spent"), (0, _defineProperty3.default)(_teacher, "warningstudent", "Underperforming Students"), (0, _defineProperty3.default)(_teacher, "trackstudentprogress", "Track student progress by sending questions in class"), (0, _defineProperty3.default)(_teacher, "studentanswerdata", "Answer Details"), (0, _defineProperty3.default)(_teacher, "barcharttograde", "Click bar chart to grade"), (0, _defineProperty3.default)(_teacher, "totalquestions", "Total Questions"), (0, _defineProperty3.default)(_teacher, "teachingunclearpage", "\"Unclear\" Pages"), (0, _defineProperty3.default)(_teacher, "teachingtotalslidesno", "Total Slides"), (0, _defineProperty3.default)(_teacher, "teachingsubjectiveproungraded", "You have ungraded Open questions."), (0, _defineProperty3.default)(_teacher, "classdanmu", "Danmu"), (0, _defineProperty3.default)(_teacher, "classpost", "Posts"), (0, _defineProperty3.default)(_teacher, "randomrollcall", "Random Roll Call"), (0, _defineProperty3.default)(_teacher, "senddetaileddata", "Send detailed data"), (0, _defineProperty3.default)(_teacher, "teachingcontents", "Teaching Content"), (0, _defineProperty3.default)(_teacher, "totalpagenumber", "Total Pages:"), (0, _defineProperty3.default)(_teacher, "teachingdesign", "Instructional Design&Memo"), (0, _defineProperty3.default)(_teacher, "privateteachingnote", "You can take notes here. (Private)"), (0, _defineProperty3.default)(_teacher, "coteacherlimit", "The co-teacher is not allowed to delete teaching activities."), (0, _defineProperty3.default)(_teacher, "deletepublishone", "Are you sure to delete?"), (0, _defineProperty3.default)(_teacher, "coteacherlimit", "The co-teacher is not allowed to delete teaching activities."), (0, _defineProperty3.default)(_teacher, "deletefailedretry", "Delete Failed. Please try again later."), (0, _defineProperty3.default)(_teacher, "one", ""), (0, _defineProperty3.default)(_teacher, "countone", "{count}个"), (0, _defineProperty3.default)(_teacher, "tipsdownloadwebdata", "Tips: please download all Excel data on Rain Classroom Web at {url}."), (0, _defineProperty3.default)(_teacher, "notsignedin", "Absenced"), (0, _defineProperty3.default)(_teacher, "total", "Total"), (0, _defineProperty3.default)(_teacher, "totalone", "Total"), (0, _defineProperty3.default)(_teacher, "pro", "Questions"), (0, _defineProperty3.default)(_teacher, "teachingcheck", "Check"), (0, _defineProperty3.default)(_teacher, "slidesdetail", "Slides Details"), (0, _defineProperty3.default)(_teacher, "inclassquiz", "Quizzes"), (0, _defineProperty3.default)(_teacher, "quizedit", "Edit"), (0, _defineProperty3.default)(_teacher, "comment", "Comment"), (0, _defineProperty3.default)(_teacher, "good", "Good!"), (0, _defineProperty3.default)(_teacher, "comeon", "Come on!"), (0, _defineProperty3.default)(_teacher, "uniqueidea", "Extraordinary!"), (0, _defineProperty3.default)(_teacher, "excellent", "Excellent!"), (0, _defineProperty3.default)(_teacher, "enterscoretip", "Please enter score."), (0, _defineProperty3.default)(_teacher, "invaildinput", "Invalid input, please try again."), (0, _defineProperty3.default)(_teacher, "positivescore", "Score must be positive."), (0, _defineProperty3.default)(_teacher, "exceedmaximumscore", "Exceed maximum score, please try again."), (0, _defineProperty3.default)(_teacher, "keepadecimal", "One decimal at most , please try again."), (0, _defineProperty3.default)(_teacher, "sendprotips", "How to send questions?"), (0, _defineProperty3.default)(_teacher, "slidesdetails", "Slides Details"), (0, _defineProperty3.default)(_teacher, "inclassquiz", "Quizzes"), (0, _defineProperty3.default)(_teacher, "emptyhelp", "Click here to get help"), (0, _defineProperty3.default)(_teacher, "emptysildes", "No sildes here"), (0, _defineProperty3.default)(_teacher, "emptysildesupload", "Try to upload Slides on PowerPoint(Rain Classroom)"), (0, _defineProperty3.default)(_teacher, "emptyquiz", "No tests here"), (0, _defineProperty3.default)(_teacher, "emptyquizupload", "Try to upload Tests on PowerPoint(Rain Classroom)"), (0, _defineProperty3.default)(_teacher, "studentsVisible", "Visible to Students"), (0, _defineProperty3.default)(_teacher, "visibleAll", "All Slides"), (0, _defineProperty3.default)(_teacher, "visibleStu", "In-class slides"), (0, _defineProperty3.default)(_teacher, "visibleAllnot", "All invisible"), (0, _defineProperty3.default)(_teacher, "visiblepart", "Partly visible"), (0, _defineProperty3.default)(_teacher, "pointnotviewpage", "Click to select the invisible pages"), (0, _defineProperty3.default)(_teacher, "nocheck", "Invisible"), (0, _defineProperty3.default)(_teacher, "editviewpage", "Edit"), (0, _defineProperty3.default)(_teacher, "stucheckauth", "学生查看权限"), (0, _defineProperty3.default)(_teacher, "ppt_limit_ques1", "Please confirm that all slides are visible to students."), (0, _defineProperty3.default)(_teacher, "ppt_limit_ques2", "Please confirm that only the slides interpreted in class are visible to students."), (0, _defineProperty3.default)(_teacher, "ppt_limit_ques3", "Please confirm that all slides are not visible to students."), (0, _defineProperty3.default)(_teacher, "nextDefault", "Remember this option"), (0, _defineProperty3.default)(_teacher, "setSuc", "OK"), (0, _defineProperty3.default)(_teacher, "paperLookLimit", "View Limit"), (0, _defineProperty3.default)(_teacher, "lookLimit", "View Limit"), (0, _defineProperty3.default)(_teacher, "alwaysLook", "Always visible"), (0, _defineProperty3.default)(_teacher, "afterHand", "Invisible when submitted"), (0, _defineProperty3.default)(_teacher, "afterHandTips", "After the deadline, students are unable to view the test even If they didn’t submit"), (0, _defineProperty3.default)(_teacher, "afterCannot", "Students are unable to view the test after setting. Only test result shown. "), (0, _defineProperty3.default)(_teacher, "changeForNot", "After changing complete deadline, it will be only applied to the students who have not completed it"), (0, _defineProperty3.default)(_teacher, "changeForNot1", "The new deadline is only valid for unsubmitted students. "), (0, _defineProperty3.default)(_teacher, "addBlack", "Add to Blacklist（After that, students are unable add class.）"), (0, _defineProperty3.default)(_teacher, "blackList", "Blacklist"), (0, _defineProperty3.default)(_teacher, "checkblackList", "Check Blacklist"), (0, _defineProperty3.default)(_teacher, "haimeiyouStu", "No Students in the class"), (0, _defineProperty3.default)(_teacher, "remove", "Remove"), (0, _defineProperty3.default)(_teacher, "confirmRemove", "Are you sure to remove the student from blacklist?"), (0, _defineProperty3.default)(_teacher, "removeTips", "Students are able to add to class via QR code or class code when removed"), (0, _defineProperty3.default)(_teacher, "quanweida", "No one answered"), (0, _defineProperty3.default)(_teacher, "quanyida", "All answered "), (0, _defineProperty3.default)(_teacher, "newtotalscore", "The total score is {total} point(s)"), (0, _defineProperty3.default)(_teacher, "hupingtotalscore", "The total score is {total} point(s), {groupReviewProportion}% from peer grading and {teacherProportion}% from teacher grading"), (0, _defineProperty3.default)(_teacher, "finalscore", "Final score"), (0, _defineProperty3.default)(_teacher, "teachergrading", "Teacher grading"), (0, _defineProperty3.default)(_teacher, "peergrading", "Peer grading"), (0, _defineProperty3.default)(_teacher, "totalmembers", "{num} people"), (0, _defineProperty3.default)(_teacher, "noComment", "No comment"), (0, _defineProperty3.default)(_teacher, "newpoint", ""), (0, _defineProperty3.default)(_teacher, "fulltext", "Full text"), (0, _defineProperty3.default)(_teacher, "fold", "fold"), (0, _defineProperty3.default)(_teacher, "correctcount", "correct"), (0, _defineProperty3.default)(_teacher, "sendtokfail", " class(es) have not received"), (0, _defineProperty3.default)(_teacher, "sentokthree", "Send failed:"), (0, _defineProperty3.default)(_teacher, "touchtoresend", "(Resend by clicking the right button)"), (0, _defineProperty3.default)(_teacher, "touchtoresend2", "(Unlimited classes can resend by clicking the right button.)"), (0, _defineProperty3.default)(_teacher, "showquestion", "Show Question"), (0, _defineProperty3.default)(_teacher, "tocorrect", "Are you sure to correct?"), (0, _defineProperty3.default)(_teacher, "addcorrectanswer", "Add correct answer(regrade all the answers)"), (0, _defineProperty3.default)(_teacher, "regradeanswers", "Click to regrade the answers"), (0, _defineProperty3.default)(_teacher, "submitone2", "Submit"), (0, _defineProperty3.default)(_teacher, "notallow", "Not allow to add the correct answer if the answers are out of order"), (0, _defineProperty3.default)(_teacher, "nonickname", "nickname not set"), (0, _defineProperty3.default)(_teacher, "tips2", "Tips:Extension of the deadline only works for the unsubmitted students."), (0, _defineProperty3.default)(_teacher, "watchedreplay", "Replayed"), (0, _defineProperty3.default)(_teacher, "replayed", "Replayed"), (0, _defineProperty3.default)(_teacher, "signinempty", "Nothing Here"), (0, _defineProperty3.default)(_teacher, "unsignempty", "Nothing Here"), (0, _defineProperty3.default)(_teacher, "watchempty", "Nothing Here"), (0, _defineProperty3.default)(_teacher, "xingmingzimu", "By initials"), (0, _defineProperty3.default)(_teacher, "xuehaoxiaodaoda", "Ascending"), (0, _defineProperty3.default)(_teacher, "xuehaodadaoxiao", "Descending"), (0, _defineProperty3.default)(_teacher, "meiyoushuju", "No data"), (0, _defineProperty3.default)(_teacher, "clickloadmore", "Load more"), (0, _defineProperty3.default)(_teacher, "live", "Live"), (0, _defineProperty3.default)(_teacher, "livemin", "min"), (0, _defineProperty3.default)(_teacher, "totalduration", "Total:"), (0, _defineProperty3.default)(_teacher, "liveduration", "Duration:"), (0, _defineProperty3.default)(_teacher, "online", "Online Person:"), (0, _defineProperty3.default)(_teacher, "livetip", "The total time refers to the sum of the online duration of all the users who joined the interactive live (including the teacher), and Rain Classroom uses this total time to calculate the traffic consumed."), (0, _defineProperty3.default)(_teacher, "hideproblemtips", "No exercise data will be displayed for classes with more than 3000 students."), (0, _defineProperty3.default)(_teacher, "txmeetingsuccess", "Tentcent meeting replay has been saved to Rain Classroom"), (0, _defineProperty3.default)(_teacher, "txmeetingfail", "Tentcent meeting replay not saved to Rain Classroom"), (0, _defineProperty3.default)(_teacher, "txmeetingcannotdel", "The replay not saved to Rain Classroom,deleted in Tencent meeting will not be recovered, please delete it carefully."), (0, _defineProperty3.default)(_teacher, "txmeetingcandel", "The replay has been saved to Rain Classroom.Deleting it in Tencent meeting will not affect the normal viewing of the replay."), _teacher),
	
	    //群发公告
	    pubnotice: (_pubnotice = {
	        'successTop': 'Successfully',
	        'successCancle': 'Successfully',
	        'failTop': 'Unsuccessful',
	        'failCancle': 'Unsuccessful',
	
	        "topNotice": 'Top',
	        'success': 'Successfully',
	        'fail': 'Unsuccessful',
	        'cancleNotice': 'Cancel',
	        "cancelTop": 'Cancel Top',
	        "showall": "Show All",
	        "totalattachment": "Total {length} attachments",
	        "downloadfromyktweb": "You can download it from {url}",
	        "delannoucement": "Delete",
	        "teachernameann": "Instructor {teacherName}'s announcement",
	        "ykt": "Rain Classroom",
	        "noundocfm": "You can't undo this action.",
	        "confirmdel": " Are you sure to delete this announcement?",
	        "fileunablepreview": "The file cannot be previewed.",
	        "readynum": "{ready_num} read",
	
	        'commenttitle': 'Are you sure to delete the comment？',
	        "replytitle": 'Are you sure to delete the comment',
	        "delreplyreplyoptions": 'It cannot be recovered after deletion',
	        "delcommentoptions": 'It cannot be recovered after deletion.Replies under this comment will also be deleted',
	
	        "announcementlimit": "Tips:Two for each class per day.",
	        "announcementquota": "",
	        "msunit": "left",
	        "titlerequired": "Title (Required)",
	        "selectTime": "Select delivery time",
	        "sendannouncementtips": "You can send texts, images, links to students (please add a space or press Enter to confirm before and after entering the link address)",
	        "cancel": "Cancel",
	        "send": "Send",
	        "sendto": "Send to：",
	        "title": "Title",
	        "backtoedit": "Back to edit",
	        "cfmtosend": "Confirm",
	        "sendok": "Sent Successfully",
	        "notempty": 'The announcement’s content cannot be empty.',
	        "gotit": "Got it",
	        "sendoktoclass": "Sent Successfully：",
	        "publishannouncement": "Publish Annoucement",
	        "delpiccfm": "Are you sure to delete?",
	        "exiteditcfm": " Are you sure to exit?",
	        "timerequred": "The posting time must be filled in and cannot be earlier than the current time",
	        "unabletosendannouncement": "You can't send any announcements.",
	        "titlenullwarning": " The title must not be null",
	        "announcementnullwarning": "The announcement must not be null.",
	        "golimit": "Announcement limit exceeded. Failed to send.",
	
	        "allclass": "{course_name}'s class",
	        "entertitle": "Please enter a title",
	        "entercontent": "Please enter content",
	        "selectclassplease": "Please select a class",
	        "faileduploadnotsend": "The attachment will not be sent once failed to upload.",
	        "selectclasstopublish": "Please select a class",
	        "selectedclass": "Selected Class"
	    }, (0, _defineProperty3.default)(_pubnotice, "cancel", "Cancel"), (0, _defineProperty3.default)(_pubnotice, "announcementok", "OK"), (0, _defineProperty3.default)(_pubnotice, "maxfilesize", "Max: 10 attachment, 30M per file, 100M in total."), (0, _defineProperty3.default)(_pubnotice, "attachnumberselected", "{ilen} attachments selected"), (0, _defineProperty3.default)(_pubnotice, "fileselectleft", "You can choose {ilen} more."), (0, _defineProperty3.default)(_pubnotice, "addattachedment", "Add Attachments"), (0, _defineProperty3.default)(_pubnotice, "del", "Delete"), (0, _defineProperty3.default)(_pubnotice, "reupload", "Re-upload"), (0, _defineProperty3.default)(_pubnotice, "uploadfailed", "Upload Failed"), (0, _defineProperty3.default)(_pubnotice, "delundocfm", "Are you sure to delete? You can't undo this action."), (0, _defineProperty3.default)(_pubnotice, "maxuploadfilenumber", "Maximum {max_fileCount} files"), (0, _defineProperty3.default)(_pubnotice, "totaluploadmaxsize", "The total size should be no more than {totalFileSize}M"), (0, _defineProperty3.default)(_pubnotice, "waiting", "Waiting ..."), (0, _defineProperty3.default)(_pubnotice, "uploadcompleted", "Completed"), (0, _defineProperty3.default)(_pubnotice, "filesizeexceedlimit", "File size exceeds limit"), (0, _defineProperty3.default)(_pubnotice, "sendtofollowingclass", "Sent to the following class:"), (0, _defineProperty3.default)(_pubnotice, "edit", "Edit"), (0, _defineProperty3.default)(_pubnotice, "cannotoplink", "Link cannot be opened"), (0, _defineProperty3.default)(_pubnotice, "miniprogramtip", "The external links cannot be opened in Mini Program. Please open them via Rain Classroom Official Account. "), (0, _defineProperty3.default)(_pubnotice, "miniprogramhelp", "HELP"), (0, _defineProperty3.default)(_pubnotice, "fileformatlimit", "Unqualified Format"), (0, _defineProperty3.default)(_pubnotice, "maxcharnum_tip", "You have entered {ilen} characters.  Exceed maximum limit（1000 characters),  please reduce content"), (0, _defineProperty3.default)(_pubnotice, "clickShowClasses_1", "Click "), (0, _defineProperty3.default)(_pubnotice, "clickShowClasses_2", " to show all classes of the course"), (0, _defineProperty3.default)(_pubnotice, "noRight", "You don't have permission to publish any announcement to this classroom"), (0, _defineProperty3.default)(_pubnotice, "webuptips", "Tips: You can upload attachments to publish annoucement on web."), (0, _defineProperty3.default)(_pubnotice, "sendclass", "Send Classes"), (0, _defineProperty3.default)(_pubnotice, "addclass", "Add Classes"), (0, _defineProperty3.default)(_pubnotice, "noticetitle", "Announcement Title"), (0, _defineProperty3.default)(_pubnotice, "titleplaceholder", "Please input the title of the announcement"), (0, _defineProperty3.default)(_pubnotice, "linktips", "Tip: If you enter the link address manually, please add a space or carriage return before and after the link address to confirm."), (0, _defineProperty3.default)(_pubnotice, "previewsend", "Preview and Send"), (0, _defineProperty3.default)(_pubnotice, "createnew", "Create a Announcement"), (0, _defineProperty3.default)(_pubnotice, "archiveclass", "You have to remove the classrooms from the Archive"), _pubnotice),
	
	    //课件、试卷文件夹管理
	    my_folder_manage: {
	        'notempty': 'Name cannot be empty',
	        "myupload": "Uploaded",
	        "myreceived": "Received",
	        "chosequiz": "Choose Tests",
	        "singlechose": "one only",
	        "choseslide": "Choose Slides",
	        "noslide": "No slides here",
	        "tryuploadslide": "Try to upload Slides on PowerPoint (Rain Classroom) ",
	        "nouploadquiz": "No Tests here",
	        "tryuploadquiz": "Try to upload Tests on PowerPoint (Rain Classroom) ",
	        "seehelp": "Click here to get help",
	        "createOK": "Successful",
	        "updateOK": "Successful",
	
	        "noslidereceived": "No slides here",
	        "inyourclass": "All slides you received will be displayed here.",
	        "inyourclass_quiz": "All quizzes you received will be displayed here.",
	        "mobileslide": "",
	        "and": "",
	        "lessonslide": "",
	        "comehere": "",
	        "noquiz": "No tests here",
	        "mobilequiz": "",
	        "lessonquiz": "",
	
	        "newfolder": "New Folder",
	        "movefolder": "Move to Folder",
	        "deletequiz": "Delete Tests",
	        "deleteslide": "Delete Slides",
	        "management": "Manage",
	        "foldername": "Enter here",
	        "complete": "OK",
	        "inputlenlimited": "12 characters limit. Please try again.",
	
	        "folderempty": "Empty here",
	        "folderempty1": "You can move slides to folder for better management.",
	        "folderempty1_quiz": "You can move tests to folder for better management.",
	        "renamefloder": "Rename",
	        "moveoutquiz": "Move to...",
	        "moveoutslide": "Move to...",
	        "deletefolder": "Delete",
	        "deletefoldertip": "All slides will be deleted with the folder",
	        "tips": "Tips",
	        "deleteok": "OK",
	
	        "chosefolder": "Choose the target folder",
	        "mycollections": "My Slides",
	        "rootdir": "Root Directory",
	        "move": "Move",
	        "choseonefolder": "Choose a  Folder",
	        "moveok": "OK",
	
	        "chosealready": "Chosen: ",
	        "nextstep": "Next",
	        "deleteslidetip": " Are you sure to delete these slides?",
	        "deletequiztip": "Are you sure to delete these tests?"
	    }
	
	}, (0, _defineProperty3.default)(_pages, "my_folder_manage", (_my_folder_manage = {
	    'notempty': 'Name cannot be empty',
	    "myupload": "Uploaded",
	    "myreceived": "Received",
	    "chosequiz": "Choose Tests",
	    "singlechose": "one only",
	    "choseslide": "Choose Slides",
	    "noslide": "No slides here",
	    "tryuploadslide": "Try to upload Slides on PowerPoint (Rain Classroom) ",
	    "noquiz": "No Tests here",
	    "nouploadquiz": "No Tests here",
	    "tryuploadquiz": "Try to upload Tests on PowerPoint (Rain Classroom) ",
	    "seehelp": "Click here to get help",
	    "createOK": "Successful",
	    "updateOK": "Successful",
	
	    "noslidereceived": "No slides here",
	    "inyourclass": "All slides you received will be displayed here.",
	    "inyourclass_quiz": "All quizzes you received will be displayed here.",
	    "mobileslide": "",
	    "and": "",
	    "lessonslide": "",
	    "comehere": ""
	}, (0, _defineProperty3.default)(_my_folder_manage, "noquiz", "No tests here"), (0, _defineProperty3.default)(_my_folder_manage, "mobilequiz", ""), (0, _defineProperty3.default)(_my_folder_manage, "lessonquiz", ""), (0, _defineProperty3.default)(_my_folder_manage, "newfolder", "New Folder"), (0, _defineProperty3.default)(_my_folder_manage, "newfolderlimit", "New Folder (within 64)"), (0, _defineProperty3.default)(_my_folder_manage, "movefolder", "Move to Folder"), (0, _defineProperty3.default)(_my_folder_manage, "deletequiz", "Delete Tests"), (0, _defineProperty3.default)(_my_folder_manage, "deleteslide", "Delete Slides"), (0, _defineProperty3.default)(_my_folder_manage, "management", "Manage"), (0, _defineProperty3.default)(_my_folder_manage, "foldername", "Please enter..."), (0, _defineProperty3.default)(_my_folder_manage, "complete", "OK"), (0, _defineProperty3.default)(_my_folder_manage, "inputlenlimited", "12 characters limit. Please try again."), (0, _defineProperty3.default)(_my_folder_manage, "folderempty", "Empty here"), (0, _defineProperty3.default)(_my_folder_manage, "folderempty1", "You can move slides to folder for better management."), (0, _defineProperty3.default)(_my_folder_manage, "folderempty1_quiz", "You can move tests to folder for better management."), (0, _defineProperty3.default)(_my_folder_manage, "renamefloder", "Rename"), (0, _defineProperty3.default)(_my_folder_manage, "renamefloderlimit", "Rename (within 64)"), (0, _defineProperty3.default)(_my_folder_manage, "renamefile", "Rename (within 64)"), (0, _defineProperty3.default)(_my_folder_manage, "filename", "Please enter..."), (0, _defineProperty3.default)(_my_folder_manage, "moveoutquiz", "Move to..."), (0, _defineProperty3.default)(_my_folder_manage, "moveoutslide", "Move to..."), (0, _defineProperty3.default)(_my_folder_manage, "deletefolder", "Delete"), (0, _defineProperty3.default)(_my_folder_manage, "deletefoldertip", "All slides will be deleted with the folder"), (0, _defineProperty3.default)(_my_folder_manage, "tips", "Tips"), (0, _defineProperty3.default)(_my_folder_manage, "deleteok", "OK"), (0, _defineProperty3.default)(_my_folder_manage, "chosefolder", "Choose the target folder"), (0, _defineProperty3.default)(_my_folder_manage, "mycollections", "My Slides"), (0, _defineProperty3.default)(_my_folder_manage, "rootdir", "Root Directory"), (0, _defineProperty3.default)(_my_folder_manage, "move", "Move"), (0, _defineProperty3.default)(_my_folder_manage, "choseonefolder", "Choose a  Folder"), (0, _defineProperty3.default)(_my_folder_manage, "moveok", "OK"), (0, _defineProperty3.default)(_my_folder_manage, "chosealready", "Chosen: "), (0, _defineProperty3.default)(_my_folder_manage, "nextstep", "Next"), (0, _defineProperty3.default)(_my_folder_manage, "deleteslidetip", " Are you sure to delete these slides?"), (0, _defineProperty3.default)(_my_folder_manage, "deletequiztip", "Are you sure to delete these tests?"), (0, _defineProperty3.default)(_my_folder_manage, "deleteslidesingletip", "Are you sure to delete？"), (0, _defineProperty3.default)(_my_folder_manage, "deletequizsingletip", "Are you sure to delete？"), (0, _defineProperty3.default)(_my_folder_manage, "swipLeftDelRename", "Swipe Left to delete or rename"), (0, _defineProperty3.default)(_my_folder_manage, "swipLeftDelRename1", "Swipe Left to delete or rename"), (0, _defineProperty3.default)(_my_folder_manage, "rename", "Rename"), (0, _defineProperty3.default)(_my_folder_manage, "toolong", "Text too long"), (0, _defineProperty3.default)(_my_folder_manage, "delete", "delete"), (0, _defineProperty3.default)(_my_folder_manage, "random", "Random"), (0, _defineProperty3.default)(_my_folder_manage, "updateApp", "更新APP版本后可参加在线监考"), (0, _defineProperty3.default)(_my_folder_manage, "dati", "Dict"), (0, _defineProperty3.default)(_my_folder_manage, "zuhe", "Group"), (0, _defineProperty3.default)(_my_folder_manage, "paperPublishTips", "Cannot publish: incorrect group of papers"), _my_folder_manage)), (0, _defineProperty3.default)(_pages, "img", {
	    empty_colletion: "https://qn-sfe.yuketang.cn/o_1c2tpurrvhn8aum1j5epq9ktn9.png",
	    empty_class: "https://qn-sfe.yuketang.cn/o_1c2vgkbhp12o41nbl9hl1g11a6va.png",
	    empty_student_blank: "https://qn-sfe.yuketang.cn/o_1c2vgkbhp146f1obn1apcgm5ug4b.png",
	    empty_score_detail: "https://qn-sfe.yuketang.cn/o_1c2vi9a4910iq1npkuau13bc1gr512.png",
	    empty_task: "https://qn-sfe.yuketang.cn/o_1c2vipfihnoi77ed8218i61fng9.png",
	    empty_msg: "https://qn-sfe.yuketang.cn/o_1c2vipr7e1re31ors1f54150a5hae.png",
	    notice_delete: "https://qn-sfe.yuketang.cn/o_1c2virdfs11ahnoa1j8j7cpm21j.png",
	    notice_forbidden: "https://qn-sfe.yuketang.cn/o_1c2vkeka313b1oln1b34189i5si1c.png",
	    notice_alllook: "https://qn-sfe.yuketang.cn/o_1c2vv8gp110g81saqghr1jgd1hbhl.png",
	    notice_allnotsee: "https://qn-sfe.yuketang.cn/o_1c2vv8gp1iav1icb1qv191a1bi8k.png",
	    tougao_student: "https://qn-sfe.yuketang.cn/o_1c2vtgl92fc11pofoot1ggv1clc9.png",
	    tougao_teacher: "https://qn-sfe.yuketang.cn/o_1c2vtgl92fc11pofoot1ggv1clc9.png",
	    empty_teach_log: "https://qn-sfe.yuketang.cn/o_1c2vu3suq1n301udr167h1io61r78o.png",
	    empty_store: "https://qn-sfe.yuketang.cn/o_1c2vuha452lvh8656b18e71ppv9.png",
	    empty_bill: "https://qn-sfe.yuketang.cn/o_1c2vvp4al1ttqbgv1dq48j01ug5t.png",
	    empty_paper: "https://qn-sfe.yuketang.cn/o_1c2vi9a4910iq1npkuau13bc1gr512.png",
	    learning_complete: "https://qn-sfe.yuketang.cn/o_1c300slik11qr5e5i8af7qssdk.png",
	    learning_uncomplete: "https://qn-sfe.yuketang.cn/o_1c300slik1oocfgs61b70culfl.png",
	    teacher_allsign: "https://qn-sfe.yuketang.cn/o_1c5khl7ikf0t1g6mm00v9s1s6q9.png",
	    teacher_allnotsign: "https://qn-sfe.yuketang.cn/o_1c2vv8gp1iav1icb1qv191a1bi8k.png",
	    gkk_log_empty: "https://qn-sfe.yuketang.cn/o_1c304p03sju232qdi722r1hf817.png",
	    fans_empty: "https://qn-sfe.yuketang.cn/o_1c5ktqueq1me6144g111fpfc1mq19.png",
	    batch_log: "https://qn-sfe.yuketang.cn/o_1emtrsdqra3n11ta13c51cm107vb.5x.png",
	    noupload_img: "https://qn-sfe.yuketang.cn/o_1fu69dk83psqvmp1bqmucp1uigc.png",
	    noupload_img_shu: "https://qn-sfe.yuketang.cn/o_1fu69dk83e1i68mch71h5pmuge.png"
	}), (0, _defineProperty3.default)(_pages, "error", {
	    "contentdel": "This content has been deleted by the teacher.",
	    "checkfromactivity": "Please check slides from Activities.",
	    "noauthslides": "You are not allowed to check it.",
	    "classdel": "The class has been deleted.",
	    "nocontent": "Page Not Found ~",
	    "cannotlearnclassend": "The course is currently over, the learning unit is not supported learning."
	}), (0, _defineProperty3.default)(_pages, "problemset", {
	    "myquestions": "My Questions",
	    "wrongquestionno": "Wrong",
	    "totalquestionno": "Total",
	    "errorrate": "Error Rate",
	    "questionupdatetime": "Update",
	    "total": "Total",
	    "wrongquestion": "Wrong",
	    "markquestions": "Starred",
	    // "tests": "Test",
	    // "slides": "Slides",
	    "viewhistory": "Start From Last Time",
	    "noquestion": "Nothing Here",
	    "nowrongquestion": "No wrong questions yet",
	    "nomarkquestion": "No starred questions yet.",
	    "questionno": "Question{index}",
	    "mark": "Star",
	    "viewdetails": "Check",
	    "takenotes": "Take Note",
	    "redo": "Re-do",
	    "goanswering": "Answer",
	    "answerdetails": "Answer Details",
	    "correctanswer": "Correct Answer",
	    "answerforfirsttime": "Your First Answer",
	    "correct": "Correct",
	    "wrong": "Wrong",
	    "answernotreleased": "Not released it.",
	    "notanswered": "Not Answered",
	    "score": "Score",
	    "point": "Points: {count}",
	    "specificstudentscore": "{count}",
	    "comment": "Comment",
	    "answerkey": "Answer Key",
	    "myanswer": "My Answer",
	    "redotips": "Re-do is only for self-test, results will not be submitted to the teacher.",
	    "gotit": "Got it",
	    "comfirm": "OK",
	    "answercorrect": "Correct",
	    "answerwrong": "Wrong",
	    "note": "Note",
	    "takenotestips": "You can take notes here(private)",
	    "save": "Save",
	    "edit": "Edit",
	    "checknotes": "Check Note",
	    "nosetscore": "Not graded yet.",
	    "datacollecting": "Data collecting…",
	    "noqustions": "No questions yet.",
	    "groupanswered": "Group answer:"
	}), (0, _defineProperty3.default)(_pages, "discusstion", {
	    'Me': 'me',
	    'releaseSuccess': 'Successfully',
	    'releaseFaild': 'Failed',
	    "releaseFaildclass": "Failed classes:",
	    "releasefinish": "Release completed.",
	    "sendsuc": "{succount}/{total} classes have received.",
	    "comment": "Comments",
	    "digg": "Like",
	    "commentplaceholder": "Enter here...",
	    "send": "Send",
	    "reply": "Reply",
	    "edit": "Edit",
	    "delete": "Delete",
	    "from": "From {name}",
	    "delconfirm": "Are you sure to delete?",
	    "expand": "Show All",
	    'unexpand': 'close',
	    "replyallcount": "View More",
	    "loadmore": "Load More",
	    "commentsuccess": "Successful",
	    "replysuccess": "Successful",
	    "replycomment": "Reply...",
	    "backtopic": "back to topic",
	    "youropinion": "Add a comment",
	    "viewimage": "Image",
	    "imagelimit": " No more than {count} pictures",
	
	    //列表页
	    "loaddata": "Loading...",
	    "publishtime": "Published Time",
	    "empty_tip": "No comment here",
	    "empty_tip2": "",
	    "discussion": "Discussion",
	    "new_idea": "Enter here...",
	    "publishbtn": "Post",
	    "new_discussion": "Discussion",
	    "pic_max": "9 pictures at most",
	    "waitloading": "Uploading...",
	    "deletedtip": "All content related will be deleted",
	    "onlypic": "[pic]",
	    'loading': 'loading...',
	    end: 'end'
	}), (0, _defineProperty3.default)(_pages, "plupload", {
	    'Select_files': 'Select files',
	    'Add_files_to_queue': 'Add files to the upload queue and click the start button.',
	    'Filename': 'Filename',
	    'Status': 'Status',
	    'Size': 'Size',
	    'Add_Files': 'Add Files',
	    'Stop_Upload': 'Stop Upload',
	    'Start_Upload': 'Start Upload',
	    'Add_files': 'Add files',
	    'Add_files2': 'Add files.',
	    'Stop_current_upload': 'Stop current upload',
	    'Start_uploading_queue': 'Start uploading queue',
	    'Stop_upload': 'Stop upload',
	    'Start_upload': 'Start upload',
	    'Uploaded_files': 'Uploaded %d/%d files',
	    'N_A': 'N/A',
	    'Drag_files_here': 'Drag files here.',
	    'File_extension_error': 'File extension error',
	    'File_size_error': 'File size error.',
	    'File_count_error': 'File count error.',
	    'Init_error': 'Init error.',
	    'HTTP_Error': 'HTTP Error.',
	    'Security_error': 'Security error.',
	    'Generic_error': 'Generic error.',
	    'IO_error': 'IO error.',
	    'File_s': 'File: %s',
	    'Close': 'Close',
	    'files_queued': '%d files queued',
	    'Using_runtime: ': 'Using runtime: ',
	    'File_size_max_file_size': 'File: %f, size: %s, max file size: %m',
	    'Upload_element_accepts': 'Upload element accepts only %d file(s) at a time. Extra files were stripped.',
	    'Upload_URL_might': 'Upload URL might be wrong or doesn\'t exist',
	    'Error_File_too_large': 'Error: File too large: ',
	    'Error_Invalid_file_extension': 'Error: Invalid file extension: '
	}), (0, _defineProperty3.default)(_pages, "newlogs", (_newlogs = {
	    "transcript": "Transcript",
	    "student": "Members",
	    "discussion": "Discussion",
	    "task": "Tasks",
	    "setting": "Settings",
	    "xiti": "Questions",
	    "classmate": "Classmates",
	    "teachinglog": "Activities",
	    "learinglog": "Activities",
	    "publish": "Publish",
	    "all": "Total",
	    "lesson": "Lecture",
	    "slide": "Slides",
	    "quiz": "Quizzes",
	    "notice": "Announcement",
	    "loading": "Loading......",
	    "clicktopublish_t": "Click \"+\" to publish teaching activities to students",
	    "clicktopublish_s": "No teaching activity yet",
	    "clicktopublish_exp": "No Experiment Here",
	    "publishslide": "Slides",
	    "publishquiz": "Quizzes",
	    "publishnotice": "Announcement",
	    "term": "Semester: 2017-2018 Spring Term",
	    "onlessontip": "You have {length} lessons in class",
	    "appointment": "Scheduled Delivery",
	    "top": 'TOP',
	    "appointmenttip": "You have {length} Scheduled Deliveries",
	    'topAnnouncement': 'You have {length} top announcement(s)',
	    'unreadByTopNotice': '{length} unread',
	    "unread": "unread",
	    "courseedittitle": "Edit Title",
	    "delete": "Delete",
	    "week": "",
	    "month": "",
	    "day": "",
	    "onlesson": "In class",
	    "publishaftermin": "Send in {minute} mins",
	    "publishafterhour": "Send in {hour} hours",
	    "publishafterday": "Send in {days} days"
	}, (0, _defineProperty3.default)(_newlogs, "publishafterhour", "Send Failed"), (0, _defineProperty3.default)(_newlogs, "experiment", "Experiment"), (0, _defineProperty3.default)(_newlogs, "entertitle", "Enter a new title~"), (0, _defineProperty3.default)(_newlogs, "conotedit", "The co-instructor is not allowed to edit title"), (0, _defineProperty3.default)(_newlogs, "conotdel", "The co-instructor is not allowed to delete teaching activities"), (0, _defineProperty3.default)(_newlogs, "coursedelpubish", "Once you delete it, all teaching data of this activity will be deleted"), (0, _defineProperty3.default)(_newlogs, "confirmdelete", "Are you sure to delete the teaching activity？"), (0, _defineProperty3.default)(_newlogs, "exp", "Experiment"), (0, _defineProperty3.default)(_newlogs, "syllabus", "Syllabus"), (0, _defineProperty3.default)(_newlogs, "group", "Group"), (0, _defineProperty3.default)(_newlogs, "livereplay", "Replay of Live"), (0, _defineProperty3.default)(_newlogs, "exam", "Exam"), (0, _defineProperty3.default)(_newlogs, "video", "Video"), (0, _defineProperty3.default)(_newlogs, "audio", "Audio"), (0, _defineProperty3.default)(_newlogs, "discuss", "Discussion"), (0, _defineProperty3.default)(_newlogs, "article", "Reading"), (0, _defineProperty3.default)(_newlogs, "homework", "Assignment"), (0, _defineProperty3.default)(_newlogs, "online", "Study Online"), (0, _defineProperty3.default)(_newlogs, "live", "Live"), (0, _defineProperty3.default)(_newlogs, "notallowededit", "Not allowed to edit title."), (0, _defineProperty3.default)(_newlogs, "studydeadline", "Please complete your studies by {deadline}"), (0, _defineProperty3.default)(_newlogs, "integrityagreement", 'Integrity Agreement'), (0, _defineProperty3.default)(_newlogs, "learnagreenment", 'Integrity Agreement'), (0, _defineProperty3.default)(_newlogs, "agreen", 'Agree'), (0, _defineProperty3.default)(_newlogs, 'cancel', 'Cancel'), (0, _defineProperty3.default)(_newlogs, "logs_start_time", "Start Time: "), (0, _defineProperty3.default)(_newlogs, "logs_end_time", "No End Time"), (0, _defineProperty3.default)(_newlogs, "logs_to", "to"), _newlogs)), (0, _defineProperty3.default)(_pages, "manage_coteacher", {
	    "sendletter_tip": "You can chat with others by clicking members’ photos",
	    "promotebtn": "Add",
	    "invitebtn": "Add",
	    "managemenu": "Manage",
	    "addstudent": "Add Student",
	    "studentlimit": "(Class size can not be more than {count}.)",
	    "delstudent": "Delete Student",
	    "addcoteacher": "Add Co-instructor",
	    "delcoteacher": "Remove Co-instructor",
	    "delcoteacher1": "Remove Co-instructor",
	    "delcoteachertip": "Once removed, the co-instructor will be in class as a student.",
	    "coteachertit": "Tips",
	    "coteacherintor1": "1. Co-instuctor can start class, publish teaching activities, and manage students.",
	    "coteacherintor2": "2. Co-instuctor can enter class, but cannot answer questions and quizzes.",
	    "coteacherintor3": "3. Co-instuctor cannot add new co-instructors or create new class, but can delete teaching activities only.",
	    "nocoteacher": "No co-instructor in this class",
	    "noStudent": "No student in this class",
	    "cancel_check": "Clear",
	    "confirmdelete": "Are you sure to delete the teaching activity？",
	    "exp": "Experiment"
	}), (0, _defineProperty3.default)(_pages, "setcourse", (_setcourse = {
	    "liveStatus0": 'Permission denied',
	    "liveStatus1": 'In review',
	    "liveStatus2": 'Application failed',
	    "liveStatus3": 'Permission',
	    "livePermission": 'Live permission',
	    "fullname": "Full Name",
	    "shortname": "Short Name",
	    "optional": "Optional",
	    "shortname_tip": "Please fill in the short name of the course.",
	    "coursetype": "Course Type",
	    "required": "Required",
	    "k12": "K-12",
	    "university": "University",
	    "other": "Others",
	    "next": "Next",
	    "shortname_placeholder": "Enter a short name (6 characters limit)",
	    "full_tip": "Full Name",
	    "edit": "Edit",
	    "classname": "Class Name",
	    "semester": "Semester",
	    "join_limit": "Join Limit",
	    "limit_tip1": "Once enabled,student can't join class by entering class code or scaning QR codes.",
	    "limit_tip2": "You can change this limit by setting in Teaching History of this class.",
	    "complete": "OK",
	    "editable": "editable",
	    "pro_coursetip": "Rain Classroom Pro does not support modification of course name or type.",
	
	    "noset": "Not set"
	}, (0, _defineProperty3.default)(_setcourse, "k12", "K-12"), (0, _defineProperty3.default)(_setcourse, "university", "University"), (0, _defineProperty3.default)(_setcourse, "others", "Others"), (0, _defineProperty3.default)(_setcourse, "semester1", "Semester 1"), (0, _defineProperty3.default)(_setcourse, "semester2", "Semester 2"), (0, _defineProperty3.default)(_setcourse, "spring", "Spring"), (0, _defineProperty3.default)(_setcourse, "summer", "Summer"), (0, _defineProperty3.default)(_setcourse, "fall", "Fall"), (0, _defineProperty3.default)(_setcourse, "winter", "Winter"), (0, _defineProperty3.default)(_setcourse, "pre", "Previous"), (0, _defineProperty3.default)(_setcourse, "courseInfo", "Set the class type before the course semester."), (0, _defineProperty3.default)(_setcourse, "fallterm", "Fall Semester {year}"), (0, _defineProperty3.default)(_setcourse, "springterm", "Spring Semester {year}"), (0, _defineProperty3.default)(_setcourse, "summerterm", "Summer Semester {year}"), (0, _defineProperty3.default)(_setcourse, "clickhere", "Click here"), (0, _defineProperty3.default)(_setcourse, "viptips", " to apply for the Rain Class member.You can live broadcast in all class if you be a member."), (0, _defineProperty3.default)(_setcourse, "studentlimits", "The limit is on."), (0, _defineProperty3.default)(_setcourse, "limitstoast", "You can not close the limit."), (0, _defineProperty3.default)(_setcourse, "classfeatures", "Features available to Class"), (0, _defineProperty3.default)(_setcourse, "unavailablefeatures", "Unavailable features will no longer be shown."), (0, _defineProperty3.default)(_setcourse, "notopenfforum", "You cannot open the discussion as school required"), (0, _defineProperty3.default)(_setcourse, "notopenall", "You cannot open the function because the number of people has reached the limit"), (0, _defineProperty3.default)(_setcourse, "allnotjoin", "Can't join"), (0, _defineProperty3.default)(_setcourse, "nojoinafterend", "Can't join after lesson"), (0, _defineProperty3.default)(_setcourse, "outsidetheschoolcannotjoin", "Outsiders can‘t join"), (0, _defineProperty3.default)(_setcourse, "unselectedstudentsjoinautomatic", "Students can choose courses"), (0, _defineProperty3.default)(_setcourse, "studentsnotsupportedtoselect", "Students can't choose courses"), (0, _defineProperty3.default)(_setcourse, "studyunitlimit", "Learning Unit Viewing Limits"), (0, _defineProperty3.default)(_setcourse, "canstudyafterclass", "Can viewing after course"), (0, _defineProperty3.default)(_setcourse, "cannotstudyafterclass", "Can’t viewing after course"), _setcourse)), (0, _defineProperty3.default)(_pages, "letter", {
	    "role": "Role",
	    "school": "School",
	    "studentid": "Student ID",
	    "organ": "Organ.",
	    "email": "Email",
	    "chat": "Chat",
	    "saysomething": "Say something here~",
	    "bindingtip": "You can only send message to binding school users."
	}), (0, _defineProperty3.default)(_pages, "grading", {
	    "scoreofpeergrading": "Score of Peer Grading",
	    "scoreofteachergrading": "Score of Teacher Grading",
	    "pointsofgrading": "Grading Criteria",
	    "textareaplaceholder": "Please enter the key or points for students' reference.",
	    "hupingguize": "Rules of Peer Grading",
	    "rule1": "<i>＊</i>Groups can take part in peer grading only after answer submission. Each group will receive <span class='f15'>One</span> answer from other groups.",
	    "rule2": "The peer grading is anonymous.",
	    "rule3": "The teacher can change the proportion of peer grading to teacher grading or edit the final score at any time.",
	    "faqihuping": "Launch",
	    "cancel": "Cancel",
	    "save": "Save",
	    "launchedgrading": "A peer grading is launched.",
	    "pointsgrading": "Points for Grading",
	    "grade": "Grade",
	    "answer": "Answer",
	    "gradingscore": "Peer grading score: {score} point(s)",
	    "gradingtotalscore": "Enter the score (total score is {score} point(s))",
	    "notice": "Notice",
	    "noticecontent": "This question is graded by groups. Each student has only one chance to grade the question, and only the last submission in each group will be accepted as the final score.",
	    "close": "Close",
	    "gradedalready": "Graded Already",
	    "gradedoverwrite": "Your submission will overwrite the present grading.",
	    "pleasescore": "Please grading now",
	    "updateOK": "Successful"
	}), (0, _defineProperty3.default)(_pages, "platform", {
	    "moretoweb": "更多批改请使用雨课堂网页版",
	    "mustpoint": "Required Points: {count}"
	}), (0, _defineProperty3.default)(_pages, "bindmobile", {
	    "bindPhone": "Bind Phone",
	    "lawtips": "Real-name authentication is required by law. Please bind your phone number to ensure the availability and security of your account.",
	    "extractminiprogram": "Extract the mini program code to bind the phone",
	    "closewindow": "Close this window after binding complete"
	}), (0, _defineProperty3.default)(_pages, "identifyAudit", {
	    'infoMsg': 'Please complete the identity verification truthfully,otherwise it will be rejected.',
	    'realName': 'Real Name',
	    'placeholder1': 'Enter your real name',
	    'placeholder2': 'Bind phone',
	    'placeholder3': 'Unverified',
	    "hasBind": "Completed",
	    'phoneNumber': 'Phone Number',
	    'idCard': 'Upload your ID card ',
	    'workCard': 'Upload your Employee’s card ',
	    'idCardDetail': 'Please read the tips and upload photos as required.',
	    'emailDetail': 'If you are a college teacher, it is recommended to fill in the school mailbox and verify the email address.~',
	    'email': 'School-mailbox(optional)',
	    'btn': 'Submit',
	    'clickExplain1': "Take photo of personal details",
	    'clickExplain2': "Take photo of front cover",
	    'clickExplain3': "Take photo of Employee’s card",
	    'identifyAudit': 'Identity Verification ',
	    'warmInfo': "Tips",
	    'warmInfoDetail': "Please refer to the following figure to upload the Employee’s card in the correct way. The picture is no more than 10M, so be sure to collect the information of the Employee’s card only itself.",
	    'uploadImage': "upload photos",
	    "requestError": "Request failed,please refresh and try again.",
	    'backhomepage': 'Back to home page'
	}), (0, _defineProperty3.default)(_pages, "mystore", {
	    'tsinghuabindtitle': 'Welcome to 「Lotus Pond」!',
	    'tsinghuacontent': 'Please verify Tsinghua University identity first.',
	    'bind': 'Bind'
	}), (0, _defineProperty3.default)(_pages, "liveAudit", {
	    "liveApply": 'Live application',
	    'rowLabel1': 'Name',
	    'rowLabel2': 'Course',
	    'rowLabel3': 'Class',
	    'applyReason': 'Reason for application:',
	    'btn1': 'Submit',
	    'btn2': 'Back',
	    'fail': 'Failed',
	    'success': 'Success',
	    'info': 'The review will be completed in 7 weekdays.',
	    'tip2': 'Your application has been submitted successfully and the review will be completed in 7 weekdays.You will rereceive the notice in Rain Classroom if it finished.Thanks for your using！',
	    'placeholder1': 'Please describe the reasons for the application in detail,including but not limited to live users,live content and the live broadcast times.',
	    'tip': 'Special note: Users must use the live broadcast service to abide by relevant national laws and policies, and assume all responsibilities arising from users illegal use or violation of the original intention of the broadcast (including but not limited to speech, transmission, etc.) The user is fully responsible.',
	    'viptips': 'Tips:The personal information you provide will be strictly protected and will only be used for identity verification. We will not use the information for other purposes without your permission.'
	}), (0, _defineProperty3.default)(_pages, "behavior", {
	    "bonuspoint": "Bonus",
	    "addpoints": "+{count}",
	    "howtoaddpoints": "How to add Bonus Point?",
	    "backtoclass": "Back to Class",
	    "remarks": "Remarks",
	    "entername": "Enter student's name",
	    "points": "",
	    "changethestate1": "Present",
	    "changethestate2": "Absent",
	    "nobonuspoint": "No Bonus Point",
	    "tag": "Tag",
	    "save": "Save",
	    "edittag": "Edit Tag",
	    "addtag": "Add tag",
	    "afterclasstips": "You can find this in your Class Report",
	    "entercontent": "Please enter the content",
	    "noquizzes": "No quizzes in this class",
	    "noeligiblestudents": "No Eligible Students",
	    "performance": "Performance",
	    "present": "present",
	    "absent": "absent",
	    "yiqiandao": "Signed In",
	    "weiqiandao": "Not Signed in",
	    "changetosignin": "Present",
	    "changetonotsignin": "Absent",
	    "bonus": "Bonus",
	    "pleaseenterinteger": "Integer required",
	    "systemtag": "System Labels are not editable",
	    "tagexists": "The same tag already exists",
	    "edit": "Edit",
	    "other": "Other",
	    "qr": "Scan QR code",
	    "classcode": "'Class Code",
	    "share": "Share",
	    "manualmark": "Manual mark",
	    "classtip": "Class Tip"
	}), (0, _defineProperty3.default)(_pages, "vipAudit", {
	    "applyReason": "Reason for application:",
	    "placeholder1": "Please describe the reasons for the application in detail,including but not limited to the function you want to use,the usage and the purpose…",
	    "vipApply": "Application",
	    "experienceinadvance": "Experience in advance",
	    "boardonPC": "Board on PC",
	    "insertaudio": "Insert local audio and video into the slides",
	    "livebroadcastinclass": "Live broadcast in class",
	    "morefeaturescomingsoon": "More features coming soon!",
	    "distinguishedmembers": "Hello! VIP",
	    "periodofvalidity": "period of validity",
	    "advance1": "",
	    "advance2": "",
	    "advance3": "",
	    "btn1": "Submit",
	    "btn2": "Back",
	    "fail": "Failed",
	    "success": "Success",
	    "info": "We will review your application information as soon as possible",
	    "tip2": "Your application has been submitted successfully. Due to a large number of applicants during the outbreak,We will review your application information as soon as possible. You will rereceive the notice in Rain Classroom if it finished.Thanks for your using！",
	    'interactiveinclass': 'Interactive in class',
	    'invigilatingexam': 'Invigilating Exam',
	    'downloadpapers': 'Download Papers',
	    "advance4": "",
	    "advance5": "",
	    "advance6": "",
	    "chujihuiyuan": "Hello! Primary Members",
	    "zhongjihuiyuan": "Hello! Intermediate Members",
	    "gaojihuiyuan": "Hello! Advanced Members",
	    "chaojihuiyuan": "Hello! SVIP",
	    "cloudsave": "Cloud Storage",
	    "advance7": ""
	}), (0, _defineProperty3.default)(_pages, "bindschool", {
	    "addschool": "Add school",
	    "shenfenbang": "Identity binding",
	    "bindtipsshow": "<div class=\"pt10 landscape_p20 text-left\">The school work ID / student ID and course data can be synchronized after binding.</div><div class=\"mt5 landscape_p20 text-left\"> If you need to open it, please contact 400-689-1199 by your school administration.</div>",
	    "binded": "Bound.",
	    "weiguixiao": "It is not connected with the educational administration system of your school and identity binding is not supported yet.",
	    "search": "Search",
	    "xuehao": "Student ID",
	    "gonghao": "Work ID",
	    "yuanxi": "Faculty",
	    "sureunbind": "Are you sure to unbind {name}",
	    "unbindinacc": "Unbinding account",
	    "canceunbinding": "Cancel unbinding",
	    "jiechuchenggong": "Unbinding account successfully",
	    "qxiaoyouhui": "Tsinghua Alumni Association",
	    "pleasepc": "Please visit on computer.",
	    "qufendaxiao": "Case sensitive",
	    "beishistep": "Step 1:<br/>please verify your identity in the \"Enterprise  Account of Beijing Normal University\".<br/> If you have verified, please skip this step.",
	    "beishiqr": "Keep pressing the QR code to enter the \"Enterprise  Account of Beijing Normal University\".",
	    "bindstep": "Step 2:<br/>Please click to bind your identity of Rain Classroom.",
	    "bindid": "Identity bind",
	    "weibindtips": "You haven’t bound the school account, please bind first.",
	    "phonenum": "Phone number",
	    "zmindenti": "Work ID",
	    "identi": "Identity",
	    "plid": "Please select identity.",
	    "account": "Account",
	    "password": "Password",
	    "verificode": "Verification Code",
	    "tipscode": "Tips:Please enter the verification code shown on the right.",
	    "plenterphone": "Please enter phone number",
	    "tips": "Tips:",
	    "xiaoneitips": "Only school account login is supported. For self-registered account, please go to account login for verification.",
	    "confirmbind": "Confirm binding",
	    "cancelbind": "Cancel binding",
	    "verisuc": "Verification successful",
	    "numhouback": "Return automatically in {num} second(s)",
	    "cmycourse": "Check my courses",
	    "yiaccount": "Abnormal account ",
	    "renzheng1": "1.You have passed the identity authentication, but your account information is not found in the “{name}-Rain Classroom” system. The system automatically creates<span class='color63'> a school  account for you as a student</span>.",
	    "renzheng2": "2.The school account created by the system will take the account you used for authentication as your student ID , the name is your WeChat nickname, and the year of enrollment is the top four student ID by default.",
	    "renzheng3": "3.This kind of account cannot be associated with school data. If you join the school course now, you will attend the class as a <span class='color63'>guest student, and the learning data will be recorded.",
	    "xuyaoacteacher": "If necessary, please contact the school teacher of educational administration to update the information.",
	    "gotit": "Got it.",
	    "bindfaied": "Failed to bind",
	    "rebind": "Rebind",
	    "getcode": "Get verification code",
	    "num6last": "The last 6 phone numbers",
	    "guoguan": "School of International Relations",
	    "inputpass1": "Please enter the password used to log in  the school educational administration system.",
	    "numberwrong": "Wrong phone number",
	    "resend": "Resend",
	    "idnoempty": "Student ID cannot be empty.",
	    "passnoempty": "Password cannot be empty.",
	    "selcode": "Please enter verification code.",
	    "verifying": "Verifying",
	    "wrongcode": "Wrong verification code ",
	    "reginfo": "Registration information",
	    "gotobind": "Go to bind",
	    "plphonenum": "Please enter phone number",
	    "backreg": "返回注册页面",
	    "yibangdingzhanghao": "You have been bound to the <span class=\"color3 font-weight-600\">{name}</span> of Technology account,<br/> If you need to modify, please unbind the account first.",
	    "gaixuexiaobushuzai": "This school is deployed on the \"{enName}\" server, please go to the {name} official account to complete the identity verification.",
	    "changanshibie": "Long press to identify, the QR code is valid until {expire}",
	    "qiehuanservertips": "Are you sure to switch server?",
	    "gaixuexiaobushuzaichongxindenglu": "This school is deployed on the \"{enName}\" server, and you need to switch to the \"{name}\" server to log in again.",
	    "qiehuan": "Switch server",
	    "emailverify": "Email",
	    "informationnotfill": "The information is not completely filled in",
	    "emailformatwrong": "Incorrect email format"
	}), (0, _defineProperty3.default)(_pages, "mobile", {
	    // account-logout.vue
	    "viewdetail": "view details",
	    "logouttips": "ID\u3010{userid}\u3011The application for canceling the account is being confirmed. The expected effective time is: {date}",
	    "accountcancellationinprogress": "Account cancellation in progress",
	    "userID": "User ID: ",
	    "expectedeffectivetime": "The expected effective time: ",
	    "unrecoverableafterlogout": "Unrecoverable after completing the logout process",
	    "cancellogoutsuccess": "Cancelling logout succeeded!",
	    "cancellogout": "cancel logout"
	}), _pages);
	
	if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	        return pages;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if ((typeof exports === "undefined" ? "undefined" : (0, _typeof3.default)(exports)) === 'object' && (typeof module === "undefined" ? "undefined" : (0, _typeof3.default)(module)) === 'object') {
	    module.exports = exports = pages; // CommonJS
	}
	
	exports.default = pages;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(613);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof2 = __webpack_require__(4);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _defineProperty2 = __webpack_require__(616);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _course, _quiz, _cards, _my, _student, _teacher, _pubnotice, _newlogs, _setcourse;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * @Author: renjianshu
	 * @Date: 2019-01-25 14:11:44
	 * @LastEditors: gengming
	 * @LastEditTime: 2020-12-03 17:01:30
	 * @Description: file content
	 */
	/*
	 * 雨课堂 国际化静态文字
	 * @author: chenzhou
	 * @update: 2017.12.05
	 * @desc 国际化 命名空间格式 page-module-lable
	 *
	 */
	
	var pages = {
	    // 常用语
	    common: {
	        "lang": "cn", //用来判断当前语言显示
	        "ykt": "雨课堂",
	        "cancel": "取消",
	        "confirm": "确定",
	        "finishok": "确认",
	        "close": "关闭",
	        "publish": "发布",
	        "back": "返回",
	        "del": "删除",
	        "remove": "移除",
	        "point": "分",
	        "score": "得分",
	        "name": "姓名",
	        "anonymous": "匿名",
	        "unread": "未读",
	        "anonymouspoll": "匿名投票",
	        "poll": "投票题",
	        "option": "选项",
	        "multiplem": "多选题",
	        "multiples": "单选题",
	        "subjective": "主观题",
	        "blank": "填空",
	        "chooselimit": "最多可选{count}项",
	        "locate": "第{index}题",
	        "quiz": "试卷",
	        "slide": "课件",
	        "searchone": "搜索",
	        "pull": "下拉刷新",
	        "release": "释放更新",
	        "loadingText": "正在加载…",
	        "Lotuspond": "荷塘雨课堂",
	        "cancelselall": "取消全选",
	        "continue": "继续"
	    },
	
	    // 导航菜单
	    nav: {
	        "course": "课程",
	        "discover": "发现",
	        "message": "消息",
	        "me": "我",
	        "myhomepage": "我的主页",
	        "myslides": "我的课件库",
	        "mytests": "我的试卷库",
	        "mysave": "我的收藏"
	    },
	
	    // 课程 教学日志 学习日志
	    course: (_course = {
	        "inclasstip": "当前班级正在上课，进入课堂",
	        "courseandclass": "班级课程",
	        "openclass": "公开课",
	        "addacourse": "我要开课",
	        "coursejoinclass": "加入班级",
	        "inclass": "正在上课中",
	        "coursemanage": "管理",
	        "courseinclassstudent": "{count}人",
	        "coursemanaged": "我管理的课",
	        "coursejoined": "我听的课",
	        "coursequitclass": "退出班级",
	        "coursequitcfm": "确认退出该班级吗",
	        "coursetips": "提示",
	        "courseenterclasscode": "输入班级邀请码, 即刻加入班级~",
	        "classjoinfailed": "加入班级失败",
	        "coursecreate": "课程",
	        "coursecreateexample": "如：流体力学",
	        "classexample": "如： A班",
	        "classcreate": "班级",
	        "courseaddclass": "新增班级",
	        "coursecreatedone": "完成",
	
	        "createOK": "创建成功",
	        "tip_invitestudent": "您可以进入班级邀请学生",
	        "youcreateclass": "您创建的班级",
	        "enterclass": "进入班级",
	        "returncourselist": "返回课程列表",
	        "rename": "重命名",
	        "classname": "班级名称",
	        "save": "保存",
	        "dialog_tip": "提示",
	
	        "dellastclass": "课程至少要有一个班级~",
	        "courseaddcourse": "新建课程信息",
	        "courseeditcourse": "编辑课程信息",
	        "coursedelclasswarning": "确认删除该班级吗?",
	        "entercoursename": "请输入课程名称",
	        "enterclassname": "请输入完整班级名称",
	        "coursedelcoursewarning": "确认删除该课程吗",
	        "coursedelcoursecfm": "课程删除后，该课程所有班级将被删除",
	
	        "teachinghistory": "教学日志",
	        "managestudent": "学生管理",
	        "learninghistory": "学习日志",
	        "coursemyclassmate": "我的同学",
	        "courseinvitestudent": "邀请",
	        "coursepermission": "权限",
	        "coursemanageagain": "管理",
	        "coursequit": "退出"
	    }, (0, _defineProperty3.default)(_course, "enterclass", "进入课堂"), (0, _defineProperty3.default)(_course, "coursepublishslides", "发布课件"), (0, _defineProperty3.default)(_course, "coursepublishquiz", "发布试卷"), (0, _defineProperty3.default)(_course, "courseannounce", "发送公告"), (0, _defineProperty3.default)(_course, "courseno学习日志", "还没有学习日志"), (0, _defineProperty3.default)(_course, "coursepublishintro", "点击+号尝试将课件、试卷或公告发布到班级吧"), (0, _defineProperty3.default)(_course, "courseteachercheckall", "老师发布的课件、课堂教学、试卷等教学活动都会记录在这里"), (0, _defineProperty3.default)(_course, "scheduledeliver", "预约"), (0, _defineProperty3.default)(_course, "scheduledeliverpublish", "你有{length}个预约发布"), (0, _defineProperty3.default)(_course, "coursefold", "收起"), (0, _defineProperty3.default)(_course, "courseunfold", "展开"), (0, _defineProperty3.default)(_course, "courseslides", "课件"), (0, _defineProperty3.default)(_course, "coursequiz", "试卷"), (0, _defineProperty3.default)(_course, "courseedittitle", "编辑标题"), (0, _defineProperty3.default)(_course, "coursedel", "删除"), (0, _defineProperty3.default)(_course, "courseinclass", "课堂"), (0, _defineProperty3.default)(_course, "courseannounce2", "公告"), (0, _defineProperty3.default)(_course, "coursexperiment", "实验"), (0, _defineProperty3.default)(_course, "coursenostudentpush", "您还没有邀请学生"), (0, _defineProperty3.default)(_course, "courserightnow", "立即去"), (0, _defineProperty3.default)(_course, "courseinvite", "邀请"), (0, _defineProperty3.default)(_course, "coursesearch", "搜索"), (0, _defineProperty3.default)(_course, "courseteacher", "授课教师"), (0, _defineProperty3.default)(_course, "coursecoteacher", "协同教师"), (0, _defineProperty3.default)(_course, "exitcourse", "退出班级"), (0, _defineProperty3.default)(_course, "coursestudent", "学生"), (0, _defineProperty3.default)(_course, "coursenotbound", "未绑定"), (0, _defineProperty3.default)(_course, "coursegueststudent", "旁听生"), (0, _defineProperty3.default)(_course, "coteachernoedit", "协同教师无法编辑标题"), (0, _defineProperty3.default)(_course, "coteachernodel", "协同教师无法删除此教学活动"), (0, _defineProperty3.default)(_course, "courseaddtitle", "输入新的标题~"), (0, _defineProperty3.default)(_course, "coursedelpubish", "确认删除这次发布吗?"), (0, _defineProperty3.default)(_course, "courseactivitydel", "确认删除这次教学活动吗?"), (0, _defineProperty3.default)(_course, "coursedelcfm", "确认删除该学生吗?"), (0, _defineProperty3.default)(_course, "coursebecomecfm", "确认转正为正式学生吗？"), (0, _defineProperty3.default)(_course, "coursedelstudentfailed", "删除学生失败"), (0, _defineProperty3.default)(_course, "courseexitcfm", "确认退出班级吗?"), (0, _defineProperty3.default)(_course, "coursefailtoexit", "退出该班级失败"), (0, _defineProperty3.default)(_course, "coursesun", "周日"), (0, _defineProperty3.default)(_course, "coursemon", "周一"), (0, _defineProperty3.default)(_course, "coursetue", "周二"), (0, _defineProperty3.default)(_course, "coursewed", "周三"), (0, _defineProperty3.default)(_course, "coursethu", "周四"), (0, _defineProperty3.default)(_course, "coursefri", "周五"), (0, _defineProperty3.default)(_course, "coursesat", "周六"), (0, _defineProperty3.default)(_course, "appointmentmins", "约{minute}分钟后发布"), (0, _defineProperty3.default)(_course, "appointmenthours", "约{hour}小时后发布"), (0, _defineProperty3.default)(_course, "appointmentdays", "约{days}天后发布"), (0, _defineProperty3.default)(_course, "appointmentfailed", "发送失败"), (0, _defineProperty3.default)(_course, "coteacherinclass", "本班协同教师"), (0, _defineProperty3.default)(_course, "addcoteacher", "添加协同教师"), (0, _defineProperty3.default)(_course, "setpermission", "设置权限"), (0, _defineProperty3.default)(_course, "deletepermissioncfm", "确认移除该协同教师吗？"), (0, _defineProperty3.default)(_course, "deletepermissionfailed", "删除该老师权限失败"), (0, _defineProperty3.default)(_course, "selectall", "全选"), (0, _defineProperty3.default)(_course, "selectnone", "不选"), (0, _defineProperty3.default)(_course, "confirmdelete", "删除"), (0, _defineProperty3.default)(_course, "confirmdelete1", "移除"), (0, _defineProperty3.default)(_course, "managetips", "此课程选课信息由教务系统直接导入雨课堂中,只可对旁听生进行管理"), (0, _defineProperty3.default)(_course, "managetipshasadmin", "此课程已经开放教师管理班级成员，可以对学生和旁听生进行管理"), (0, _defineProperty3.default)(_course, "auditorbecomes", "旁听生转正"), (0, _defineProperty3.default)(_course, "managestudents", "学生管理"), (0, _defineProperty3.default)(_course, "becomesregular", "转正"), (0, _defineProperty3.default)(_course, "clear", "清空"), (0, _defineProperty3.default)(_course, "noaddtests", "您还没有添加任何试卷喔"), (0, _defineProperty3.default)(_course, "coursechooseslide", "选择课件(单选)"), (0, _defineProperty3.default)(_course, "coursedelstudent", "确认删除所选学生吗"), (0, _defineProperty3.default)(_course, "deleteOK", "删除成功"), (0, _defineProperty3.default)(_course, "saveOK", "保存成功"), (0, _defineProperty3.default)(_course, "invitestudent", "邀请学生加入"), (0, _defineProperty3.default)(_course, "ArchivedClasses", "已归档班级"), (0, _defineProperty3.default)(_course, "no_guest_student_tip", "当前无旁听生"), (0, _defineProperty3.default)(_course, "pullrefresh", "上拉刷新"), (0, _defineProperty3.default)(_course, "toprelease", "释放更新"), (0, _defineProperty3.default)(_course, "toploading", "加载中..."), (0, _defineProperty3.default)(_course, "nonetwork", "网络不给力~"), (0, _defineProperty3.default)(_course, "loadmore", "加载更多"), (0, _defineProperty3.default)(_course, "sending", '发送中'), (0, _defineProperty3.default)(_course, "new_onlessontip", "你有{length}个课正在上课"), (0, _defineProperty3.default)(_course, "new_teach", "教"), (0, _defineProperty3.default)(_course, "new_listen", "听"), (0, _defineProperty3.default)(_course, "new_myteach", "我教的课"), (0, _defineProperty3.default)(_course, "new_mylisten", "我听的课"), (0, _defineProperty3.default)(_course, "onlessonbar", "你有 {count} 个班级正在上课"), (0, _defineProperty3.default)(_course, "onlessonbar2", "有 {count} 个班级正在上课"), (0, _defineProperty3.default)(_course, "semicolon", "；"), (0, _defineProperty3.default)(_course, "weekexam", "最近一周有 {count} 门考试"), (0, _defineProperty3.default)(_course, "allname", "全称"), (0, _defineProperty3.default)(_course, "activeclass", "活跃班级"), (0, _defineProperty3.default)(_course, "addclass", "添加班级"), (0, _defineProperty3.default)(_course, "alias", "简称"), (0, _defineProperty3.default)(_course, "addalias", "添加简称"), (0, _defineProperty3.default)(_course, "noclass", "暂无活跃班级"), (0, _defineProperty3.default)(_course, "gotoset", "自动跳转到课程设置页"), (0, _defineProperty3.default)(_course, "deleteclasstip", "删除班级后，班级中所有的教学数据将一同被删除"), (0, _defineProperty3.default)(_course, "deleteclasstip2", "删除班级后，班级中所有学生将被移出此班级"), (0, _defineProperty3.default)(_course, "studenttotal", "学生总人数"), (0, _defineProperty3.default)(_course, "activitytotal", "教学活动总计"), (0, _defineProperty3.default)(_course, "classalias", "班级简称"), (0, _defineProperty3.default)(_course, "entername", "请输入名称"), (0, _defineProperty3.default)(_course, "setclassalias", "设置班级简称"), (0, _defineProperty3.default)(_course, "archiveclasses", "归档班级"), (0, _defineProperty3.default)(_course, "deleteclass", "删除班级"), (0, _defineProperty3.default)(_course, "removearchive", "移出归档"), (0, _defineProperty3.default)(_course, "coteachernopermission", "协同教师不可操作此项"), (0, _defineProperty3.default)(_course, "pronopermission_rename", "该班级由教务系统导入，班级名称不能修改"), (0, _defineProperty3.default)(_course, "pronopermission_del", "该班级由教务系统导入，只能从教务端删除"), (0, _defineProperty3.default)(_course, "archiveconfirm", "确定要归档该班级吗？"), (0, _defineProperty3.default)(_course, "removearchiveconfirm", "确定要将该班级移出归档吗？"), (0, _defineProperty3.default)(_course, "deleteclassconfirm", "确定删除此班级？"), (0, _defineProperty3.default)(_course, "delfail", "删除失败，请重试"), (0, _defineProperty3.default)(_course, "coursename", "课程名称"), (0, _defineProperty3.default)(_course, "courseshortname", "课程简称"), (0, _defineProperty3.default)(_course, "delcourse", "删除本课程"), (0, _defineProperty3.default)(_course, "deletecoursetip", "删除课程后，该课程下的所有班级和教学数据都将被删除且不可恢复"), (0, _defineProperty3.default)(_course, "coursetotal", "课程下共有班级"), (0, _defineProperty3.default)(_course, "gotolist", "自动跳转到课程列表"), (0, _defineProperty3.default)(_course, "delcourseconfirm", "确定删除课程？"), (0, _defineProperty3.default)(_course, "classaliasmaxlength", "班级简称 (最多16个字)"), (0, _defineProperty3.default)(_course, "classnamemaxlength", "班级名称 (最多28个字)"), (0, _defineProperty3.default)(_course, "courseshortnamemaxlength", "课程简称 (最多16个字)"), (0, _defineProperty3.default)(_course, "coursenamemaxlength", "课程名称 (最多28个字)"), (0, _defineProperty3.default)(_course, "classshortnametip", "若您设置了班级简称，显示班级名称时会优先取简称。"), (0, _defineProperty3.default)(_course, "courseshortnametip", "若您设置了课程简称，显示课程名称时会优先取简称。"), (0, _defineProperty3.default)(_course, "protips", "本课程由教务系统导入，班级和选课数据定期从教务系统同步"), (0, _defineProperty3.default)(_course, "cannotrenamecourse", "该课程由教务系统导入，课程名称不能修改"), (0, _defineProperty3.default)(_course, "cannotchangecoursetype", "该课程由教务系统导入，课程类型不能修改"), (0, _defineProperty3.default)(_course, "proclasstips", "本班级由教务系统导入，班级信息和选课数据定期从教务系统同步"), (0, _defineProperty3.default)(_course, "cannotchangeterm", "学期信息由教务端设置，教师端不能修改"), (0, _defineProperty3.default)(_course, "setcoursetype", "请先前往课程管理页，设置课程类型"), (0, _defineProperty3.default)(_course, 'gocomplete', '去完善'), (0, _defineProperty3.default)(_course, 'completetitle', '请完善个人信息'), (0, _defineProperty3.default)(_course, 'completemsg', '根据国家政策要求，该操作需要实名认证。为保障您的账户安全及正常使用，请完善个人信息。'), (0, _defineProperty3.default)(_course, "gobind", "去绑定"), (0, _defineProperty3.default)(_course, "authrealname", "请绑定手机号"), (0, _defineProperty3.default)(_course, "bindphonetips", "根据国家政策要求, 该操作需要实名认证, 为保障您的账户安全及正常使用, 请完成手机号绑定。"), _course),
	
	    // 试卷 主观题等
	    quiz: (_quiz = {
	        "showqusetion": "显示题目",
	        "quizlocate": "第{index}题",
	        "quizpoint": "{score}分",
	        "datishic": "答题时长：",
	
	        "quiztext": "文本",
	        "quizpic": "图片",
	        "quizvoice": "音频",
	        "quizadd": "添加",
	        "quizvoicelimit": "音频仅支持9条",
	        "quizback": "返回题目",
	        "quizpreview": "提交预览",
	        "quizcorrect": "答案",
	        "quizkeepedit": "继续编辑",
	        "quizsubmit": "提交答案",
	        "quizsave": "保存答案",
	
	        "quiztotalscore": "总分",
	        "quizfullmarks": "满分",
	        "quiznogradesubjective": "主观题未批阅",
	        "quizgradingsubjective": "主观题批改中",
	        "quizcheckobjective": "客观题",
	        "quizcheckscore": "得分",
	        "quizchecksubjective": "主观题",
	        "quiznotgraded": "未批阅",
	        "curquiznotgraded": "本题未批阅",
	        "seeannotation": "点击查看批注",
	
	        // 主观题作答
	        "timeupnoanswer": "已经过期，不能答题",
	        "quizanswer": "作答",
	        "scoreofthispro": "本题得分",
	        "quizteachercomment": "教师评语",
	        "quizanswerkey": "答案解析",
	        "recording": "录音中 (最长60s)",
	        "holdtotalk": "按住说话",
	        "releasetosend": "松开完成",
	        "confirmanswer": "请确认答案",
	        "quizsubmitok": "提交成功",
	        "delpiccfm": "确定删除图片？",
	        "delallpiccfm": "确定删除所有图片？",
	        "deltextcfm": "确定删除文本",
	        "delaudiocfm": "确定删除语音？",
	        "delallaudiocfm": "确定删除所有语音？",
	        "quiznetworkerror": "当前网络不畅，请检查系统",
	        "imgIllegal": "图片可能存在违规，请检查后重试",
	        "quizpiclimit": "图片不能超过九张",
	        "reuploadpiconly": "当前仅支持图片格式，请重新上传",
	        "imagesizelimit": "图片不可超过10M，请重试",
	        "accessrecord": "添加语音答案，需允许雨课堂使用录音功能",
	        "takedifficult": "上传有问题？点击这里",
	
	        //主观题上传附件
	        "upload_tip_mobil": "提示：使用网页版可以上传附件噢！",
	        "attachment_file": "附件",
	        "add_attachment_file": "添加附件",
	        "upload_tip0": "提示：附件允许上传1个，大小100M以内",
	        "upload_tip_quiz": "提示：附件允许上传1个，大小300M以内",
	        "upload_tip1": "查看可上传的格式",
	        "upload_tip2": "可以上传的文件类型包括：",
	        "file_uploading": "附件上传中...",
	        "file_upload_fail": "附件上传失败",
	        "file_upload_complete": "上传成功",
	        "file_max_limit": "文件大小超过限制",
	        "file_format_limit": "文件格式不符合要求",
	        "downloadfile_tip": "请使用雨课堂网页版下载附件",
	
	        //new
	        "confirm_deletefile": "确定删除附件？",
	
	        // 主观题批改页
	        "graded": "已批改",
	        "isgrading": "批改中",
	        "quiznoanswer": "该学生没有作答题目",
	        "quiztotalpoint": "本题共{sourceScore}分",
	        "quizentercomment": "请输入评语",
	        "good": "写得不错",
	        "comeon": "继续加油",
	        "uniqueidea": "想法很独特",
	        "excellent": "小红花",
	        "required": "必填",
	        "quizprevious": "上一位",
	        "quiznextpro": "下一题",
	        "quiznext": "下一位",
	        "quizedit": "修改",
	        "quizcommentsaved": "当前分数和评语将被自动保存",
	        "quizaudio": "录音不能超过九条",
	        "quizsubmitting": "提交中",
	        "quizshowquestion": "显示题目",
	        "quizgradeinvite": "请您打分",
	        "notgraded": "老师还未打分",
	
	        // 试卷反馈
	        "finisheddetails": "完成详情",
	        "gradingdetails": "批改详情",
	        "submission": "交卷时间",
	        "gradingtime": "批复时间",
	        "noonefinished": "还没有学生完成",
	        "testfinisheddetails": "试卷完成情况"
	    }, (0, _defineProperty3.default)(_quiz, "finisheddetails", "完成情况"), (0, _defineProperty3.default)(_quiz, "checktestpaper", "查看试卷"), (0, _defineProperty3.default)(_quiz, "graded", "已批改"), (0, _defineProperty3.default)(_quiz, "finishedtest", "完成试卷"), (0, _defineProperty3.default)(_quiz, "totalstudentone", "班级人数"), (0, _defineProperty3.default)(_quiz, "viewdetails", "查看详情"), (0, _defineProperty3.default)(_quiz, "scoredistribution", "总分分布"), (0, _defineProperty3.default)(_quiz, "allvote", "此试卷全部为投票题"), (0, _defineProperty3.default)(_quiz, "ungradedsubjectiveproexist", "您还有主观题尚未批改"), (0, _defineProperty3.default)(_quiz, "clickbarcharttograde", "点击下面主观题柱状图进行批改"), (0, _defineProperty3.default)(_quiz, "noonefinishedtest", "还没有学生完成试卷"), (0, _defineProperty3.default)(_quiz, "answerdetails", "答题情况"), (0, _defineProperty3.default)(_quiz, "deletepulishcfm", "是否删除本次发布"), (0, _defineProperty3.default)(_quiz, "deletepublishfailed", "删除发布失败"), (0, _defineProperty3.default)(_quiz, "noanswerforpoll", "本题为投票，没有正确答案"), (0, _defineProperty3.default)(_quiz, "anonymouspollnodetail", "本题为匿名投票，不显示投票人"), (0, _defineProperty3.default)(_quiz, "numberofvotes", "{count}票"), (0, _defineProperty3.default)(_quiz, "standardopt", "本题正确选项为: "), (0, _defineProperty3.default)(_quiz, "numberofstudents", "{count}人"), (0, _defineProperty3.default)(_quiz, "noanswers", "还没有学生作答"), (0, _defineProperty3.default)(_quiz, "loadingdata", "正在加载数据..."), (0, _defineProperty3.default)(_quiz, "answered", "已作答"), (0, _defineProperty3.default)(_quiz, "notansweredone", "未答题"), (0, _defineProperty3.default)(_quiz, "gradeone", "打分"), (0, _defineProperty3.default)(_quiz, "", "条"), (0, _defineProperty3.default)(_quiz, "loadmore", "加载更多"), (0, _defineProperty3.default)(_quiz, "okone", "确定"), (0, _defineProperty3.default)(_quiz, "thisquestion", "本题"), (0, _defineProperty3.default)(_quiz, "cancel", "取消"), (0, _defineProperty3.default)(_quiz, "positivescore", "分数必须为正数"), (0, _defineProperty3.default)(_quiz, "exceedmaximumscore", "分数超过最大本题分值，请重新输入"), (0, _defineProperty3.default)(_quiz, "keepadecimal", "分数最多保留一位小数，请重新输入"), (0, _defineProperty3.default)(_quiz, "numberonlywarning", "所输分数必须为数字，请重新输入"), (0, _defineProperty3.default)(_quiz, "unclearstudents", "不懂人数"), (0, _defineProperty3.default)(_quiz, "noquestiontoanswer", "本堂课没有习题"), (0, _defineProperty3.default)(_quiz, "nounclearslides", "没有被点击『不懂』的课件"), (0, _defineProperty3.default)(_quiz, "quantityone", "红包个数："), (0, _defineProperty3.default)(_quiz, "standardopt", "本题正确选项为:"), (0, _defineProperty3.default)(_quiz, "noanswerforpoll", "本题为投票，没有正确答案"), (0, _defineProperty3.default)(_quiz, "gradingtime", "批复时间"), (0, _defineProperty3.default)(_quiz, "timelimitedtest", "本套试卷限时"), (0, _defineProperty3.default)(_quiz, "min", "分钟"), (0, _defineProperty3.default)(_quiz, "deadline", "截止日期"), (0, _defineProperty3.default)(_quiz, "testdeadline", "本套试卷截止时间"), (0, _defineProperty3.default)(_quiz, "timelimitedtest", "本套试卷限时"), (0, _defineProperty3.default)(_quiz, "checkhw", "查看作业"), (0, _defineProperty3.default)(_quiz, "finishedhw", "已完成作业"), (0, _defineProperty3.default)(_quiz, "hwfinisheddetail", "作业完成情况"), (0, _defineProperty3.default)(_quiz, "finishedhwstudent", "n位同学完成作业"), (0, _defineProperty3.default)(_quiz, "gradedhwnumber", "份作业已经批复"), (0, _defineProperty3.default)(_quiz, "scorereport", "得分情况"), (0, _defineProperty3.default)(_quiz, "questionlocate", "第2题"), (0, _defineProperty3.default)(_quiz, "accuracyone", "正确答题率"), (0, _defineProperty3.default)(_quiz, "editpublishtitle", "编辑本次发布标题"), (0, _defineProperty3.default)(_quiz, "deletepublish", "删除本次发布"), (0, _defineProperty3.default)(_quiz, "deletepublishone", "确认删除本次发布吗?"), (0, _defineProperty3.default)(_quiz, "deletepublishfailed", "删除发布失败"), (0, _defineProperty3.default)(_quiz, "groupanswer", "本题为小组作答"), (0, _defineProperty3.default)(_quiz, "temporarygroup", "临时组"), (0, _defineProperty3.default)(_quiz, "submittips", "每个小组仅一次提交答案的机会，提交后答案和答题成员都不可修改，请组员间充分沟通后再提交"), (0, _defineProperty3.default)(_quiz, "check", "返回检查"), (0, _defineProperty3.default)(_quiz, "temporaryconfirm", "确定以临时组(仅你自己)提交答案？"), (0, _defineProperty3.default)(_quiz, "notingroup", "未进组"), (0, _defineProperty3.default)(_quiz, "contactteacher", "联系老师将你加入其他小组或以临时组(仅你自己)提交答案"), (0, _defineProperty3.default)(_quiz, "iknow", "我知道了"), (0, _defineProperty3.default)(_quiz, "submitted", "在你加入前小组已交过答案"), (0, _defineProperty3.default)(_quiz, "submitfail", "提交失败"), (0, _defineProperty3.default)(_quiz, "onceTip", "重要提示"), (0, _defineProperty3.default)(_quiz, "gradetips", "* 请前往网页版{host}批改主观题"), (0, _defineProperty3.default)(_quiz, "entertext", "输入答案"), (0, _defineProperty3.default)(_quiz, 'clicksave', '答完请点保存，避免自动保存不及时'), (0, _defineProperty3.default)(_quiz, "Return", '发回修改'), (0, _defineProperty3.default)(_quiz, "Returned", '已发回修改'), _quiz),
	
	    // 课前预习 预习反馈 完成情况等
	    cards: (_cards = {
	        'sensitive_words': '输入内容含敏感词，请检查后重试',
	        "dyzgtwpgs": "当有主观题未批改时，此排名可能不是最终排名",
	        "dfygdd": "得分由高到低",
	        "dfyddg": "得分由低到高",
	        "qdsjpx": "签到时间排序",
	        "wszxh": "未设置学号",
	        "donealready": "已完成",
	        "checkedpreview": "已查看",
	        "nocheckedpreview": "未查看",
	        "noonefinishpreview": "还没有学生完成学习",
	        "noonepreviewing": "还没有学生正在进行",
	        "allfinish": "全部学生已开始学习",
	        "previewdetail": "完成情况",
	        "finisheddetails": "完成情况",
	        "finishedpreview": "已完成",
	        "checkslides": "查看课件",
	        "viewdetails": "查看详情",
	        "studentscheckedslides": "已查看",
	        "totalclassstudents": "总人数",
	        "answerdetails": "答题情况",
	        "subjectivepro": "主观题",
	        "gradingrate": "批改率",
	        "answerrate": "答题率",
	        "averagescore": "平均分",
	        // "poll": "投票题",
	        "grading": "批改",
	        "webgradetips": "温馨提示：网页版（{url}）批改主观题更便捷",
	        "accuracy": "正确率",
	        "objectivequestion": "客观题"
	    }, (0, _defineProperty3.default)(_cards, "answerrate", "答题率"), (0, _defineProperty3.default)(_cards, "teacherdatacheck", "查看"), (0, _defineProperty3.default)(_cards, "studentfeedback", "学生反馈"), (0, _defineProperty3.default)(_cards, "nostudentfeedback", "目前还没有学生反馈信息"), (0, _defineProperty3.default)(_cards, "detaileddata", "详细数据"), (0, _defineProperty3.default)(_cards, "webdownloadexcel", "下载多次Excel数据 请登录网页版 {url}"), (0, _defineProperty3.default)(_cards, "teachingdesign", "教学设计与备忘"), (0, _defineProperty3.default)(_cards, "teachingdesigntip", "您可以在这里可以记录教学设计和心得等笔记，内容仅自己可见"), (0, _defineProperty3.default)(_cards, "teachingdesigntip2", "您可以在这里可以记录学习内容和心得等笔记，内容仅自己可见。"), (0, _defineProperty3.default)(_cards, "editpublishtitle", "编辑发布标题"), (0, _defineProperty3.default)(_cards, "deletepublish", "删除本次发布"), (0, _defineProperty3.default)(_cards, "editpublishset", "编辑发布设置"), (0, _defineProperty3.default)(_cards, "loadmore", "加载更多"), (0, _defineProperty3.default)(_cards, "mailreceivedata", "本次详细数据将会发送至以下邮箱"), (0, _defineProperty3.default)(_cards, "enterfrequentmail", "请你输入常用邮箱"), (0, _defineProperty3.default)(_cards, "mailformaterror", "邮件格式错误"), (0, _defineProperty3.default)(_cards, "datasentok", "数据已发送"), (0, _defineProperty3.default)(_cards, "yktwebtips", "温馨提示：在雨课堂网页版 {url}"), (0, _defineProperty3.default)(_cards, "deleteexcelnow", "可直接下载多次详细数据的Excel文件哦～"), (0, _defineProperty3.default)(_cards, "enternewtitle", "输入新的标题~"), (0, _defineProperty3.default)(_cards, "deletepulishcfm", "是否删除本次发布"), (0, _defineProperty3.default)(_cards, "deletepublishfailed", "删除发布失败"), (0, _defineProperty3.default)(_cards, "previewdetails", "学习详情"), (0, _defineProperty3.default)(_cards, "previewtips", "随机-规则组卷暂不支持查看"), (0, _defineProperty3.default)(_cards, "previewviewslides", "查看课件"), (0, _defineProperty3.default)(_cards, "previewduration", "观看时长："), (0, _defineProperty3.default)(_cards, "previewscore", "习题得分："), (0, _defineProperty3.default)(_cards, "finishstudy", "完成学习："), (0, _defineProperty3.default)(_cards, "finishproblem", "完成习题："), (0, _defineProperty3.default)(_cards, "wgky", "未观看页："), (0, _defineProperty3.default)(_cards, "answerdetails", "答题情况"), (0, _defineProperty3.default)(_cards, "previewungraded", "未批"), (0, _defineProperty3.default)(_cards, "previewnoquestion", "本次课件中没有习题。"), (0, _defineProperty3.default)(_cards, "previewreporttoteacher", "报告老师"), (0, _defineProperty3.default)(_cards, "anonymous", "匿名"), (0, _defineProperty3.default)(_cards, "unread", "未读"), (0, _defineProperty3.default)(_cards, "reporttoteachertip", "有什么问题可以直接报告给老师哦"), (0, _defineProperty3.default)(_cards, "learningthoughts", "学习心得"), (0, _defineProperty3.default)(_cards, "teachingdesigntip", "您可以在这里可以记录教学设计和心得等笔记，内容仅自己可见"), (0, _defineProperty3.default)(_cards, "previewhours", "{hour}小时"), (0, _defineProperty3.default)(_cards, "previewmins", "{minuts}分钟"), (0, _defineProperty3.default)(_cards, "previewsecs", "{seconds}秒"), (0, _defineProperty3.default)(_cards, "previewfeedbacktip", "输入意见，反馈给老师"), (0, _defineProperty3.default)(_cards, "anonymoussend", "匿名发送"), (0, _defineProperty3.default)(_cards, "previewcfm", "确认发送"), (0, _defineProperty3.default)(_cards, "previewsending", "正在发送..."), (0, _defineProperty3.default)(_cards, "previewentertip", "请输入内容"), (0, _defineProperty3.default)(_cards, "sentok", "发送成功"), (0, _defineProperty3.default)(_cards, "sendfailed", "发送失败！"), (0, _defineProperty3.default)(_cards, "progress", "进度：{depth}/{count}页"), (0, _defineProperty3.default)(_cards, "completionprogress", "{depth}/{count}页"), (0, _defineProperty3.default)(_cards, "unknownpagecount", '点不懂页数'), (0, _defineProperty3.default)(_cards, "unknowntotalpage", '课件总页数'), (0, _defineProperty3.default)(_cards, "allslides", "全部"), (0, _defineProperty3.default)(_cards, "problemslides", "习题"), (0, _defineProperty3.default)(_cards, "unknownslides", "不懂"), (0, _defineProperty3.default)(_cards, "viewresult", "查看结果"), (0, _defineProperty3.default)(_cards, "slidesaudio", "语音"), (0, _defineProperty3.default)(_cards, "favorite", "收藏"), (0, _defineProperty3.default)(_cards, "slidescomment", "评论"), (0, _defineProperty3.default)(_cards, "viewall", "查看全部"), (0, _defineProperty3.default)(_cards, "sendbtn", "发送"), (0, _defineProperty3.default)(_cards, "commentfail", "评论失败，请重新发送"), (0, _defineProperty3.default)(_cards, "commenting", "评论中"), (0, _defineProperty3.default)(_cards, "commentok", "评论成功"), (0, _defineProperty3.default)(_cards, "xcxzwfbfwlsp", "小程序中无法播放网络视频"), (0, _defineProperty3.default)(_cards, "qnzgzhgk", "请您在雨课堂公众号中观看"), (0, _defineProperty3.default)(_cards, "rhcz", "如何操作"), (0, _defineProperty3.default)(_cards, "miniprogramlinktip", "小程序中无法打开外部链接，请您在雨课堂公众号中查看"), (0, _defineProperty3.default)(_cards, "studentId", "按学号排序"), (0, _defineProperty3.default)(_cards, "progressinstruction", "学习进度说明："), (0, _defineProperty3.default)(_cards, "graphicpages", "1.图文页"), (0, _defineProperty3.default)(_cards, "watching3stocomplete", "指课件页仅包含图片和文字，观看1s以上算完成学习"), (0, _defineProperty3.default)(_cards, "viewingmorethan1stocomplete", "当课件页仅包含背景图及20个以内的文字时，观看1s以上即算完成"), (0, _defineProperty3.default)(_cards, "problempages", "2.习题页"), (0, _defineProperty3.default)(_cards, "needtocompleteexercisestocomplete", "指课件页包含习题，需完成习题作答算完成学习"), (0, _defineProperty3.default)(_cards, "videopage", "3.视频页"), (0, _defineProperty3.default)(_cards, "watchthevideotocomplete", "指课件页包含视频，需观看视频90%以上算完成学习，有多个视频时需全部观看90%以上；拖拽视频则不计入观看时长"), (0, _defineProperty3.default)(_cards, "specialinstructions", "4.特殊说明"), (0, _defineProperty3.default)(_cards, "specialinstructionsdesc", "当课件页包含习题和其他类别时，课件页完成情况以习题完成情况为准；<br/>当课件页包含视频和图文时，课件页完成情况以视频完成情况为准"), (0, _defineProperty3.default)(_cards, "inputPassword", "请输入试卷密码"), (0, _defineProperty3.default)(_cards, "inputPassword2", "请输入四位密码"), (0, _defineProperty3.default)(_cards, "password", "密码"), (0, _defineProperty3.default)(_cards, "passwordIncorrect", "密码格式不正确"), _cards),
	
	    // 我的模块 主页 钱包 收藏 我的试卷 课件
	    my: (_my = {
	        "bonusexpenditure": "红包支出",
	        "withdraw": "提现",
	        "topup": "充值",
	        "bonusincome": "红包收入",
	        "bonusrefund": "红包退款",
	        "wallet": "钱包",
	        "bonus": "红包",
	
	        "myyktwallet": "我的钱包",
	        "myslides": " 我的课件库",
	        "mytests": "我的试卷库",
	        "mysave": "我的收藏",
	        "schoolbinding": "身份绑定",
	        "evaluation": "评教",
	        "reciveQuestionnaire": "我收到的问卷",
	        "questionnairefeedback": "评价我的问卷",
	        "editpersonalinfo": "编辑个人信息",
	        "saveinfo": "保存",
	        "name": "姓名",
	        "nameeg": "请输入姓名",
	        "gender": "性别",
	        "gendermale": "男",
	        "genderfemale": "女",
	        "birthofdate": "出生日期",
	        "role": "身份",
	        "pleaseselect": "请选择",
	        "student": "学生",
	        "teacher": "老师",
	        "otherrole": "其他人员",
	        "school": "院校",
	        "schooleg": "请输入学校",
	        "department": "学院",
	        "departmenteg": "请输入学院",
	        "company": "单位",
	        "companyeg": "如：清华大学",
	        "studentid": "学号",
	        "studentidnote": "学生身份请输入学号",
	        "email": "邮箱",
	        "frequentemailnote": "请填写常用邮箱",
	        "finishok": "确认",
	        "myhomepage": "我的主页",
	        "changesaved": "本次修改已保存",
	        "uploadingimage": "正在上传图片...",
	        "networkerror": "当前网络不畅，请检查系统",
	        "imageonly": "当前仅支持图片格式，请重新上传",
	        "imagesizelimit": "图片不可超过10M，请重试",
	        "profile": "个人信息",
	        "select": "选取",
	        "cancel": "取消",
	        "typeprofile": "填写信息",
	        "leavetrace": "花30秒留下足迹",
	        "askforfeedback": "以便为您提供更好的功能服务",
	        "entername": "请输入姓名",
	        "enterschool": "请输入学校",
	        "enterstudentid": "学生身份请输入学号",
	        "submitfailed": "提交个人信息失败",
	        "connectionfailed": "网络连接错误，请稍后重试。",
	
	        "bill": "账单",
	        "mybalance": "我的余额"
	    }, (0, _defineProperty3.default)(_my, "topup", "充值"), (0, _defineProperty3.default)(_my, "withdraw", "提现"), (0, _defineProperty3.default)(_my, "withdrawnotice", "提现须知"), (0, _defineProperty3.default)(_my, "questionwithdraw", "问题1 钱包的余额如何提现？"), (0, _defineProperty3.default)(_my, "answerwithdraw", "在『我的钱包』中点击『提现』，余额超过2元方可发起提现申请。提交成功后，金额将于三个工作日内进入您的微信零钱。"), (0, _defineProperty3.default)(_my, "questioncharge", "问题2 为什么提现需要收取2%的手续费？"), (0, _defineProperty3.default)(_my, "answercharge", "这是微信转账在过程中收取的手续费，雨课堂不会从中获利。"), (0, _defineProperty3.default)(_my, "questionwithdrawlimit", "问题3 提现是否有上限？"), (0, _defineProperty3.default)(_my, "answerwithdrawlimit", "由于微信的限制，每位用户单日最高可提现金额为2000元。"), (0, _defineProperty3.default)(_my, "mywallet", "我的钱包"), (0, _defineProperty3.default)(_my, "nobillfound", "还没有任何账单信息"), (0, _defineProperty3.default)(_my, "thismonth", "本月"), (0, _defineProperty3.default)(_my, "banktip", "温馨提示：老师可以使用钱包的钱发送课堂红包"), (0, _defineProperty3.default)(_my, "bankhowbonus", "如何发送课堂红包？"), (0, _defineProperty3.default)(_my, "bankquestionwithdraw", "钱包的余额如何提现？"), (0, _defineProperty3.default)(_my, "bankanswerwithdraw", "在『我的钱包』中点击『提现』，余额超过2元方可发起提现申请。提交成功后，金额将于三个工作日内进入您的微信零钱。"), (0, _defineProperty3.default)(_my, "bankquestioncharge", "为什么提现需要收取2%的手续费？"), (0, _defineProperty3.default)(_my, "bankanswercharge", "这是微信转账在过程中收取的手续费，雨课堂不会从中获利。"), (0, _defineProperty3.default)(_my, "bankquestionwithdrawlimit", "提现是否有上限？"), (0, _defineProperty3.default)(_my, "bankanswerwithdrawlimit", "由于微信的限制，每位用户单日最高可提现金额为2000元。"), (0, _defineProperty3.default)(_my, "bankclose", "关闭"), (0, _defineProperty3.default)(_my, "today", "今天"), (0, _defineProperty3.default)(_my, "choosetopupamount", "请选择您要充值的金额"), (0, _defineProperty3.default)(_my, "moreamountchoice", "其他"), (0, _defineProperty3.default)(_my, "entertopupamount", "请输入您要充值的金额"), (0, _defineProperty3.default)(_my, "back", "返回"), (0, _defineProperty3.default)(_my, "confirmtopup", "确认充值"), (0, _defineProperty3.default)(_my, "tipsinwallet", "温馨提示"), (0, _defineProperty3.default)(_my, "yktbalanceuse", "钱包里的余额可用于课堂中发红包或购买公开课程"), (0, _defineProperty3.default)(_my, "enterwithdrawamount", "请输入您要提现的金额"), (0, _defineProperty3.default)(_my, "currentbalance", "当前余额： {balance}元"), (0, _defineProperty3.default)(_my, "confirmwithdraw", "确认提现"), (0, _defineProperty3.default)(_my, "withdrawrules", "提现须知"), (0, _defineProperty3.default)(_my, "withdrawtips", "温馨提示：将扣除提现金额的2%作为手续费"), (0, _defineProperty3.default)(_my, "rechargetips", "充值金额单次最高限额为10000元，请核实金额"), (0, _defineProperty3.default)(_my, "transfertimetips", "零钱将在3个工作日内到达您的微信账户。"), (0, _defineProperty3.default)(_my, "failtowithdraw", "抱歉，单日提现上限为2000元，您已超支。"), (0, _defineProperty3.default)(_my, "decimalwarning", "抱歉，资金不能为小数"), (0, _defineProperty3.default)(_my, "withdrawmin", "单笔提现金额至少为2元"), (0, _defineProperty3.default)(_my, "insufficentbalance", "抱歉，您的钱包余额不足。"), (0, _defineProperty3.default)(_my, "balanceerror", "账户余额异常"), (0, _defineProperty3.default)(_my, "systemerror", "系统发生了错误"), (0, _defineProperty3.default)(_my, "morningsaves", "你还没有任何收藏"), (0, _defineProperty3.default)(_my, "morningwords", "早起时刻-单词部落"), (0, _defineProperty3.default)(_my, "morningpoem", "早起时刻-诗词小栈"), (0, _defineProperty3.default)(_my, "morningbooks", "早起时刻-书影时光"), (0, _defineProperty3.default)(_my, "anonymous", "匿名"), (0, _defineProperty3.default)(_my, "answer", "回答"), (0, _defineProperty3.default)(_my, "mysave", "我的收藏"), (0, _defineProperty3.default)(_my, "addtag", "添加标签"), (0, _defineProperty3.default)(_my, "myslides", "我的课件库"), (0, _defineProperty3.default)(_my, "chosennumber", "已选 {chosenNumber} 个"), (0, _defineProperty3.default)(_my, "selectall", "全选"), (0, _defineProperty3.default)(_my, "confirmdelete", "确认删除"), (0, _defineProperty3.default)(_my, "choosemoreslide", "请至少选择一个课件"), (0, _defineProperty3.default)(_my, "deleteslidescfm", "确认删除所选课件吗?"), (0, _defineProperty3.default)(_my, "plugintips", "提示"), (0, _defineProperty3.default)(_my, "manage", "管理"), (0, _defineProperty3.default)(_my, "delete", "删除"), (0, _defineProperty3.default)(_my, "noslidesfound", "你还没有任何课件"), (0, _defineProperty3.default)(_my, "pluginykt", "去试试雨课堂桌面端插件吧"), (0, _defineProperty3.default)(_my, "mytests", "我的试卷库"), (0, _defineProperty3.default)(_my, "notest", "你还没有任何试卷"), (0, _defineProperty3.default)(_my, "deletetestcfm", "确认删除该试卷吗?"), (0, _defineProperty3.default)(_my, "medeletetestfailed", "删除试卷失败"), (0, _defineProperty3.default)(_my, "medelslidescfm", "确认删除该课件吗？"), (0, _defineProperty3.default)(_my, "medelslidesfailed", "删除课件失败"), (0, _defineProperty3.default)(_my, "tips", "提示"), (0, _defineProperty3.default)(_my, "chooseonemoretest", "请至少选择一个试卷"), (0, _defineProperty3.default)(_my, "medelquiz", "确认删除所选试卷吗?"), (0, _defineProperty3.default)(_my, "mewallettopup", "钱包充值"), (0, _defineProperty3.default)(_my, "mewithdraw", "钱包提现"), (0, _defineProperty3.default)(_my, "withdrawmorethantwo", "提现金额最低为2元，请核实金额"), (0, _defineProperty3.default)(_my, "receivedanddeducted", "到账金额￥{getMoney}元，扣除手续费￥{fee}元"), (0, _defineProperty3.default)(_my, "ykttopup", "雨课堂-钱包充值"), (0, _defineProperty3.default)(_my, "mebill", "我的账单"), (0, _defineProperty3.default)(_my, "meupdatingprofilepic", '正在更新头像...'), (0, _defineProperty3.default)(_my, "merealname", '真实姓名'), (0, _defineProperty3.default)(_my, "meschoolbelongs", '所属学校'), (0, _defineProperty3.default)(_my, "merole", '社会身份'), (0, _defineProperty3.default)(_my, "meteacher", '教师'), (0, _defineProperty3.default)(_my, "meothers", '其他'), (0, _defineProperty3.default)(_my, "mestudentid", '在校学号'), (0, _defineProperty3.default)(_my, "schoolstudent", '在校学生'), (0, _defineProperty3.default)(_my, "schoolteacher", '在校老师'), (0, _defineProperty3.default)(_my, "universitybelongs", '所属院校'), (0, _defineProperty3.default)(_my, "userunbind", '解绑账号'), (0, _defineProperty3.default)(_my, "addschool", '增加学校'), (0, _defineProperty3.default)(_my, "setting", '设置'), (0, _defineProperty3.default)(_my, "selectlang", '多语言'), (0, _defineProperty3.default)(_my, "savelang", '保存设置'), (0, _defineProperty3.default)(_my, "savinglang", '正在设置语言...'), (0, _defineProperty3.default)(_my, "savesuccess", '设置成功'), (0, _defineProperty3.default)(_my, 'infocosttime', '花30秒完善你的信息'), (0, _defineProperty3.default)(_my, 'infogood', '方便老师快速认识你'), (0, _defineProperty3.default)(_my, 'infogoodteacher', '方便学生了解授课教师'), (0, _defineProperty3.default)(_my, 'infoorg', '组织/机构'), (0, _defineProperty3.default)(_my, 'infoorgtip', '可以为空'), (0, _defineProperty3.default)(_my, 'infonumbereg', '学生身份请输入学号'), (0, _defineProperty3.default)(_my, 'infotip', '* 你可以在“我的主页”中随时修改个人信息'), (0, _defineProperty3.default)(_my, 'backtomini', '信息已修改成功，返回后下拉刷新即可'), (0, _defineProperty3.default)(_my, 'backtominiok', '我知道了'), (0, _defineProperty3.default)(_my, 'payfailtip', '小程序中暂不支持充值，请前往雨课堂公众号操作~'), (0, _defineProperty3.default)(_my, "storeboards", "板书收藏（共{total}页）"), (0, _defineProperty3.default)(_my, 'moreSchool', '更多学校添加中…'), (0, _defineProperty3.default)(_my, 'accountsetting', "账号及绑定设置"), (0, _defineProperty3.default)(_my, 'gosetting', '去设置'), (0, _defineProperty3.default)(_my, 'languagelabel', '语言'), (0, _defineProperty3.default)(_my, 'language', '中文'), (0, _defineProperty3.default)(_my, 'subscribe_manage', '订阅通知管理'), (0, _defineProperty3.default)(_my, 'hasbeenset', '已设置'), (0, _defineProperty3.default)(_my, 'wechat', '微信'), (0, _defineProperty3.default)(_my, 'phone', '手机号'), (0, _defineProperty3.default)(_my, 'gobind', '去绑定'), (0, _defineProperty3.default)(_my, "email", '邮箱'), (0, _defineProperty3.default)(_my, 'password', '登录密码'), (0, _defineProperty3.default)(_my, 'settips', '* 绑定手机号/邮箱并设置登录密码，可以使⽤账号+密码的⽅式登录⾬课堂和学堂在线网站'), (0, _defineProperty3.default)(_my, 'settips_thu', '* 绑定手机号/邮箱并设置登录密码，可以使⽤账号+密码的⽅式登录荷塘雨课堂'), (0, _defineProperty3.default)(_my, 'settips_changjiang', '* 绑定手机号/邮箱并设置登录密码，可以使⽤账号+密码的⽅式登录长江雨课堂'), (0, _defineProperty3.default)(_my, 'settips_huanghe', '* 绑定手机号/邮箱并设置登录密码，可以使⽤账号+密码的⽅式登录黄河雨课堂'), (0, _defineProperty3.default)(_my, 'bindemail', '绑定登录邮箱'), (0, _defineProperty3.default)(_my, 'emailplaceholder', "请输入邮箱地址"), (0, _defineProperty3.default)(_my, 'verifyplaceholder', '请输入验证码'), (0, _defineProperty3.default)(_my, 'getcode', '获取验证码'), (0, _defineProperty3.default)(_my, 'bind', '绑定'), (0, _defineProperty3.default)(_my, 'verifycodeerror', '验证码错误'), (0, _defineProperty3.default)(_my, 'emailerror', "请输入正确的邮箱"), (0, _defineProperty3.default)(_my, 'bindsuccess', "绑定成功"), (0, _defineProperty3.default)(_my, 'hasbound', '该邮箱已经绑定过雨课堂ID'), (0, _defineProperty3.default)(_my, 'youhavebound', '您已经绑定邮箱'), (0, _defineProperty3.default)(_my, 'replaceemail', '更换邮箱'), (0, _defineProperty3.default)(_my, 'setpassword', '设置密码'), (0, _defineProperty3.default)(_my, 'reenter', '确认密码'), (0, _defineProperty3.default)(_my, 'confirm', '确定'), (0, _defineProperty3.default)(_my, 'changepassword', '修改登录密码'), (0, _defineProperty3.default)(_my, 'oldpassword', '原密码'), (0, _defineProperty3.default)(_my, 'newpassword', '新密码'), (0, _defineProperty3.default)(_my, 'enter', '请输入'), (0, _defineProperty3.default)(_my, 'oldpassworderror', '原密码错误'), (0, _defineProperty3.default)(_my, 'newpassworderror', '新密码两次输入不一致'), (0, _defineProperty3.default)(_my, 'setsuccess', '设置密码成功'), (0, _defineProperty3.default)(_my, 'lengthlimit', '8-16位，同时包含小写字母、大写字母和数字。'), (0, _defineProperty3.default)(_my, 'phoneerror', '请输入正确的手机号'), (0, _defineProperty3.default)(_my, "bindPhone", "绑定手机"), (0, _defineProperty3.default)(_my, "bound", "您已经绑定手机号"), (0, _defineProperty3.default)(_my, "replacePhone", "更换手机"), (0, _defineProperty3.default)(_my, "bindPhone2", "绑定手机号"), (0, _defineProperty3.default)(_my, "verifiplaceholder", "请输入验证码"), (0, _defineProperty3.default)(_my, "getVerificationCode", "获取验证码"), (0, _defineProperty3.default)(_my, "bind", "绑定"), (0, _defineProperty3.default)(_my, "regain", "重新获取"), (0, _defineProperty3.default)(_my, "lawtips", "根据法律要求，互联网账号需实名认证，为保障您的账户安全及正常使用，请完成手机号绑定。"), (0, _defineProperty3.default)(_my, "second", "秒"), (0, _defineProperty3.default)(_my, "receivecode", "收不到验证码"), (0, _defineProperty3.default)(_my, "extractminiprogram", "长按识别小程序码绑定手机"), (0, _defineProperty3.default)(_my, "closewindow", "绑定完成后，请关闭此窗口"), (0, _defineProperty3.default)(_my, "pleasebindfirst", "请先绑定"), (0, _defineProperty3.default)(_my, "wrongemail", "错误的邮箱格式"), (0, _defineProperty3.default)(_my, "wrongphone", "错误的手机号格式"), (0, _defineProperty3.default)(_my, "emailhasbond", "邮箱已被绑定"), (0, _defineProperty3.default)(_my, "codeexpired", "验证码已过期"), (0, _defineProperty3.default)(_my, "wrongcode", "错误的验证码"), (0, _defineProperty3.default)(_my, "wrongoldpassword", "错误的旧密码"), (0, _defineProperty3.default)(_my, "invalidnewpassword", "无效的新密码"), (0, _defineProperty3.default)(_my, "codefailedtobesent", "短信验证码发送失败"), (0, _defineProperty3.default)(_my, "forgetpassword", "忘记密码？"), (0, _defineProperty3.default)(_my, "resetpassword", "重设密码"), (0, _defineProperty3.default)(_my, "verifyphonenumber", "验证手机号"), (0, _defineProperty3.default)(_my, "besenttotheboundphonenumber", "验证码将发送至绑定的手机号"), (0, _defineProperty3.default)(_my, "pleasebindyourphonefirst", "请先绑定手机"), (0, _defineProperty3.default)(_my, "notblankspaces", "密码中不能包含空格"), (0, _defineProperty3.default)(_my, "ruleerror", "密码格式错误"), (0, _defineProperty3.default)(_my, "notchinese", "密码不能包括中文字符"), (0, _defineProperty3.default)(_my, "minlength8", "密码长度不能小于8个字符"), (0, _defineProperty3.default)(_my, "errornewpassword", "密码不符合要求，请重新输入"), (0, _defineProperty3.default)(_my, "bindthirdaccount", "绑定的第三方账号"), (0, _defineProperty3.default)(_my, "txmeet", "腾讯会议"), (0, _defineProperty3.default)(_my, "gotobind", "去绑定"), (0, _defineProperty3.default)(_my, "changebindtitle", "该手机号已绑定其他{env}账号，如果继续操作，原账号将自动解绑。是否继续？"), (0, _defineProperty3.default)(_my, "changebinddesc", "注：换绑后原账号将不能使用该手机号登录，如果其未绑定微信、邮箱等登录方式，将无法访问原账号数据。"), (0, _defineProperty3.default)(_my, "smscodeerr", "短信验证码错误"), (0, _defineProperty3.default)(_my, "samephone", "该手机号与当前已绑定的手机号相同"), (0, _defineProperty3.default)(_my, "xuetangoryktsamephone", "该手机号已绑定其他雨课堂或学堂在线账号"), (0, _defineProperty3.default)(_my, "checkcourselist", "查看{count}门课程 "), (0, _defineProperty3.default)(_my, "accountnocourse", "该账号下无选课记录，建议换绑手机号到新账号。"), (0, _defineProperty3.default)(_my, "originaccountjiebang", "换绑后原账号（ID{id}）将会自动解绑，如果其未绑定微信、邮箱等登录方式，原账号将无法登录。是否继续？"), (0, _defineProperty3.default)(_my, "mergeaccount", "建议合并数据到该账号（ID{oid}）。合并后，当前账号（ID{nid}）将被弃用，您所有的选课及学习数据都会被保留。"), (0, _defineProperty3.default)(_my, "continuenext", "继续，我要"), (0, _defineProperty3.default)(_my, "merge", "合并"), (0, _defineProperty3.default)(_my, "changebind", "换绑"), (0, _defineProperty3.default)(_my, "coursecount", "该账号（ID{id}）下共{count}个教学班"), (0, _defineProperty3.default)(_my, "ykt", "雨课堂平台"), (0, _defineProperty3.default)(_my, "teach", "我教的课"), (0, _defineProperty3.default)(_my, "learn", "我听的课"), (0, _defineProperty3.default)(_my, "xuetangx", "学堂在线平台"), (0, _defineProperty3.default)(_my, "mergeerror", "原绑定账号已关联有微信相关信息，无法合并。请更换手机号重新绑定。"), (0, _defineProperty3.default)(_my, "bindemailtologin", "建议为ID{id}绑定邮箱，以用于登录查看数据。"), (0, _defineProperty3.default)(_my, "notbindemail", "不绑定邮箱，自愿弃用ID{id}"), _my),
	
	    // 预约发布 试卷发布
	    publish: {
	        "scheduledeliverfailedone": "预约发送失败，请重新发送",
	        "publishname": "发布名称",
	        "quizone": "试卷",
	        "timetopublish": "发布时间",
	        "deadlineone": "完成截止时间",
	        "quizdurationone": "考试时长（分钟）",
	        "quizdurationone2": "考试时长",
	        "releasetimeone": "公布答案时间",
	        "publishclassone": "发布班级",
	        "totalclassesone": "共 {length} 个班",
	        "deletepublishone": "删除本次发布",
	        "cancelone": "取消",
	        "okone": "确定",
	        "delete": "删除",
	        "confirmone": "确认",
	        "publishinstruction": '发布{name}帮助说明',
	
	        "setdeadlinetips": "若设定完成截止时间，到期后学生将不能答题，完成后数据也不再更新，但在课件查看截止时间内仍能查看课件；",
	        "nosetdeadlinetips": "若不设定完成截止时间，学生在课件查看截止时间内随时可以查看课件并答题，完成后数据将实时更新；",
	        "systemsubmitanswers": "设定截止时间后，到期学生将仍能看到试卷，但无法继续作答或提交试卷，试卷完成数据及得分分布也不再更新。到截止时间时，系统将自动提交学生所作答的全部内容。",
	        "timernostop": " 学生必须在规定的时间长度内提交试卷。点击作答开始计时，若中途退出，计时不停止。到时后系统将自动提交学生所作答的全部内容。",
	        "releasetips": "正确答案将在到达此时间时向学生公布，在此之前，学生即使提交试卷也无法知晓正确答案及相关答案解析。",
	        "releasetips_col": "正确答案将在到达此时间时向学生公布，在此之前，学生即使提交后也无法知晓正确答案及相关答案解析。",
	        "close": "关闭",
	        "publish": "发布",
	        "publish1": "发布",
	        "none": "无",
	        "publishnow": "立即发布",
	        "nowtime": "当前时间",
	        "": '["日","一","二","三","四","五","六"]',
	        "notimelimitone": "不限时",
	        "showaftersubmission": "交卷后立即显示",
	        "showaftersubmission_col": "提交后立即显示",
	        "nochooseclass": "您还未选择发布的班级",
	        "publishtimenoearliernow": "发布时间不能早于当前时间",
	        "ddltimenoearliernow": "截止时间不能早于当前时间",
	        "ddltimetip": "当前截止时间过早，不满足考试时长",
	        "testdurationzero": "考试时长不能为0",
	        "noearlierthanpublishtime": "截止时间应在发布时间之后\r\n请重新设置",
	        "changecfmone": "是否确认修改发布信息",
	        "publishcfmone": "确认发布到班级",
	        "deletecfmone": "是否确认删除本次预约",
	        "hour": "小时",
	        "min": "分钟",
	        "min1": "分",
	        "hour2": "点",
	        "selecttime": "选择时间",
	        "today": "今天",
	        "tommrrow": "明天",
	        "thedayaftertommorrow": "后天",
	        "monthdayweek": "月 日 周",
	
	        "hasbeensent": "已发送",
	        "classes": "个班级",
	        "failSendClasses": "个班级",
	        "sendLoading": '发送中...',
	        "sendWaitTip": "当前发送的课件较多时，排队等候需要较长的时间",
	        "sendWaitPlease": "关闭本页面，不影响您的发送<br/>发送成功后，我们会给您的微信发送通知</br>请您不要重复操作，避免拥堵",
	
	        // 课下主观题分组作答
	        "answerway": "作答方式",
	        "totalgroup": "共{count}组",
	        "changegroup": "换组",
	        "nogroup": "暂无分组",
	        "archivetips": "有班级已归档，需要发布课件请先将其移出归档",
	        "answerwaydesc": "当课件中含有主观题，且目标班级拥有至少一个分组时，可选择分组作答。该课件中的全部主观题，都将按照所选分组进行作答。",
	        "hassubject": "课件中仅全部主观题支持小组作答",
	        "nosubject": "课件中不含有主观题不支持小组作答",
	        "answerway_person": "个人作答",
	        "nogrouptips": "当前班级暂无分组，请先分组或选择个人作答",
	        "choosegroup": "选择分组",
	        "maximum": "最多只能选择5个班级",
	        "coursewarecheckauth": "课件查看截止时间",
	        "endnolimit": "完成后不可见",
	        "setimelimit": "设定时间后不可见",
	        "coursewarechecktime": "课件查看截止时间",
	        "checklimitneed": "请选择可查看时间",
	        "checklimitnow": "课件查看截止时间不能早于当前时间",
	        "checklimitpub": "可查看时间不能早于发布时间",
	        "checklimitdeadline": "课件查看截止时间不能早于完成截止时间",
	        "curpptnotcheck": "该课件当前已不可查看",
	        "curpptnotcheckbr": "该课件当前<br/>已不可查看",
	        "exercisenocheck": "习题当前已不可查看",
	        "curexercisenocheck": "该习题当前已不可查看",
	        "answertimedeadline": "公布答案时间需 >= 截止时间",
	        "setpptchecktips": "若设定课件查看截止时间，到期后学生将不能查看课件；",
	        "changepptchecktips": "更改课件查看截止时间后，对全部学生生效。",
	        "limited": "受限",
	        "applyforthepermission": "\u76F8\u5173\u6559\u5B66\u6D3B\u52A8\u5DF2\u5B8C\u6210\uFF0C\u5982\u9700\u7EE7\u7EED\u4F7F\u7528\u8D85\u5927\u73ED\u5F00\u5C55\u6388\u8BFE\uFF0C\u8BF7\u8054\u7CFB <span style=\"font-weight: bold;\">yuketang@xuetangx.com</span> \u91CD\u65B0\u7533\u8BF7\u76F8\u5173\u6743\u9650\u3002",
	        'viewhelp': '查看帮助'
	    },
	
	    //学生小结
	    student: (_student = {
	        "transcript": "成绩单",
	        "joinclassInfo": '你在 <span class="blackText">{time} </span>通过“<span class="blackText">{way}</span>”进入课堂',
	
	        'way_qrcode': "扫二维码",
	        "way_invite_code": "课堂暗号",
	        "way_inclass_tips": '"正在上课"提示',
	        "way_other": "其他",
	        "minishare": "小程序分享",
	        "viewplayback": "观看直播回放",
	        "manualmark": "教师手动修改",
	        "lessonreminder": "上课提醒",
	        "tencentmeeting": "腾讯会议",
	
	        "noquestions": "无习题",
	        "personalscore": "个人总分",
	        "averageclassscore": "班级平均",
	        "timespent": "个人用时",
	        "classaveragetime": "班级平均",
	        "summarycorrectno": "正确题数",
	        "summarywrongno": "错误题数",
	        "summaryungraded": "未批改数",
	        "questionsnumber": "习题数",
	        "unclearslides": "不懂课件",
	        "savedslides": "收藏课件",
	        "markinclass": "课上标记",
	        "unclear": "不懂",
	        "and": "及",
	        "save": "收藏",
	        "afterclassreview": "课件，方便课后复习～",
	        "noattendclass": "您错过了本次授课,",
	        'noattendbyteacher': '老师备注你本次课缺勤',
	        "tutorlesson": "记得及时补习这节课的内容哦",
	        "studycontent": "学习内容",
	        "noreleasedslides": "老师没有发布课件～",
	        "summaryquiz": "课堂考试",
	        "studentsummaryscore": "{score}分",
	        "nowanswered": "未答题",
	
	        "questiondetails": "习题信息",
	        "wrongquestion": "错误习题",
	        "subjectivequestion": "主观题",
	        "fillblank": "填空题",
	        "notanswered": "未作答",
	        "youranswer": "你的选择",
	        "loadmore": "加载更多",
	        "allcorrectcongrats": "恭喜你本节课没有错误习题，再接再厉！",
	        "ungraded": "未批改",
	        "correctanswer": "正确答案"
	    }, (0, _defineProperty3.default)(_student, "unclearslides", "不懂课件"), (0, _defineProperty3.default)(_student, "studentsummarynounclearslides", "本节课没有不懂课件"), (0, _defineProperty3.default)(_student, "saveslides", "收藏课件"), (0, _defineProperty3.default)(_student, "summarynosavedslides", "本节课没有收藏课件"), (0, _defineProperty3.default)(_student, "myposts", "我的投稿"), (0, _defineProperty3.default)(_student, "learningthoughts", "学习心得"), (0, _defineProperty3.default)(_student, "writetips", "现在感觉怎么样？写下两笔吧！"), (0, _defineProperty3.default)(_student, "brilliantstudent", "优秀学生"), (0, _defineProperty3.default)(_student, "amongbeststudents", "这次名列前茅"), (0, _defineProperty3.default)(_student, "carryon", "再接再厉！"), (0, _defineProperty3.default)(_student, "underperformstudent", "预警学生"), (0, _defineProperty3.default)(_student, "encourgestudent", "这次成绩不甚理想"), (0, _defineProperty3.default)(_student, "cheerup", "要加油噢！"), (0, _defineProperty3.default)(_student, "summaryallquestions", "全部习题"), (0, _defineProperty3.default)(_student, "pagetotal", "共{count}页"), (0, _defineProperty3.default)(_student, "nounderstandslide", "没有不懂的幻灯片"), (0, _defineProperty3.default)(_student, "pageno", "第{page}页"), (0, _defineProperty3.default)(_student, "subject_noanswer", "本题为主观题，您没有作答。"), (0, _defineProperty3.default)(_student, "fillblank_noanswer", "本题为填空题，您没有作答。"), (0, _defineProperty3.default)(_student, "seedetail", "查看详情"), (0, _defineProperty3.default)(_student, "thisanswer", "正确答案: "), (0, _defineProperty3.default)(_student, "nosentclass", '课上未发布'), (0, _defineProperty3.default)(_student, "thisresult", "你的答案: "), (0, _defineProperty3.default)(_student, "no_answer", "您没有作答."), (0, _defineProperty3.default)(_student, "answer", "回答"), (0, _defineProperty3.default)(_student, "correct", "正确"), (0, _defineProperty3.default)(_student, "wrong", "错误"), (0, _defineProperty3.default)(_student, "allslides", "全部"), (0, _defineProperty3.default)(_student, "nostoreslide", "没有收藏的幻灯片"), (0, _defineProperty3.default)(_student, "toup_noanswer", "本题为投票，没有正确答案。"), (0, _defineProperty3.default)(_student, "fullscreenexit", "轻触黑色区域即可退出全屏"), (0, _defineProperty3.default)(_student, "myscore", "得分（本题{score}分）"), (0, _defineProperty3.default)(_student, "score", "分"), (0, _defineProperty3.default)(_student, "remark", "评语"), (0, _defineProperty3.default)(_student, "no_setscore", "老师暂未打分"), (0, _defineProperty3.default)(_student, "answeranaly", "答案解析"), (0, _defineProperty3.default)(_student, "seeanaly", "查看解析"), (0, _defineProperty3.default)(_student, 'acrossSingleChoice', '当前为横屏模式，请在竖屏情况下查看作答情况'), (0, _defineProperty3.default)(_student, "myanswer", "我的答案"), (0, _defineProperty3.default)(_student, "close", "关闭"), (0, _defineProperty3.default)(_student, "answertype_group", "小组作答"), (0, _defineProperty3.default)(_student, "newscore", "分数"), (0, _defineProperty3.default)(_student, "blanksnotanswer", "有空格未填写，确认提交吗？"), (0, _defineProperty3.default)(_student, "screenshot", "截图分享"), (0, _defineProperty3.default)(_student, "blackboard", "板书分享"), (0, _defineProperty3.default)(_student, "lessonshare", "课堂分享"), (0, _defineProperty3.default)(_student, "liveplayback", "直播回放"), (0, _defineProperty3.default)(_student, "boardplayback", "课程回放"), (0, _defineProperty3.default)(_student, "haveliveclickcheck", "本次授课有直播回放，点击查看"), (0, _defineProperty3.default)(_student, 'fulltext', "全文"), (0, _defineProperty3.default)(_student, 'fold', "收起"), (0, _defineProperty3.default)(_student, "undone", "未完成"), (0, _defineProperty3.default)(_student, "done", "已完成"), (0, _defineProperty3.default)(_student, "pno", "第{number}页"), (0, _defineProperty3.default)(_student, "totalprob", "共{number}题"), (0, _defineProperty3.default)(_student, "unknown", "不懂"), (0, _defineProperty3.default)(_student, "favorite", "收藏"), (0, _defineProperty3.default)(_student, "newprob", "Hi,你有新的课堂习题"), (0, _defineProperty3.default)(_student, "newvote", "Hi,你有新的投票"), (0, _defineProperty3.default)(_student, "recvbonus", "Hi，本题有课堂红包发送"), (0, _defineProperty3.default)(_student, "gainbonus", "{number}位同学已赢得课堂红包"), (0, _defineProperty3.default)(_student, "cantintoteam", "当前是协同教师身份，不参与分组"), (0, _defineProperty3.default)(_student, "cantintoteam2", "你不在本组，无权限进入"), (0, _defineProperty3.default)(_student, "sharepostpush", "Hi, 老师正在分享课堂投稿"), (0, _defineProperty3.default)(_student, "sharesubjective", "Hi, 老师正在分享主观题答案"), (0, _defineProperty3.default)(_student, "randomized", "Hi，老师进行了随机分组"), (0, _defineProperty3.default)(_student, "freegrouping", "Hi，老师进行了自由分组"), (0, _defineProperty3.default)(_student, "launchedgrading", "Hi,老师发起了互评"), (0, _defineProperty3.default)(_student, "viewresults", "查看结果"), (0, _defineProperty3.default)(_student, "enterpassword", "输入口令"), (0, _defineProperty3.default)(_student, "LESSON_START", "上课啦！"), (0, _defineProperty3.default)(_student, "SHOW_PRESENTATION", "新幻灯片：{0}"), (0, _defineProperty3.default)(_student, "LESSON_FINISH", "下课啦！"), (0, _defineProperty3.default)(_student, "DANMU_ON", "老师已开启弹幕"), (0, _defineProperty3.default)(_student, "DANMU_OFF", "老师已关闭弹幕"), (0, _defineProperty3.default)(_student, "RANDOM_PICK", "随机点名选中：{0}{1}"), (0, _defineProperty3.default)(_student, "SHOW_FINISH", "幻灯片 {0} 结束放映"), (0, _defineProperty3.default)(_student, "QUIZ_FINISH", "试卷 {0} 已收卷"), (0, _defineProperty3.default)(_student, "FREE_GROUP_CANCEL", "老师取消了自由分组"), (0, _defineProperty3.default)(_student, "RANDOM_GROUP_CANCEL", "老师取消了随机分组"), (0, _defineProperty3.default)(_student, "LIVE_ON", "老师开启了直播"), (0, _defineProperty3.default)(_student, "LIVE_OFF", "老师结束了直播"), (0, _defineProperty3.default)(_student, "INTERACTIVE_ON", "老师已开启互动"), (0, _defineProperty3.default)(_student, "INTERACTIVE_OFF", "老师已关闭互动"), (0, _defineProperty3.default)(_student, "TencentInteractive_ON", "老师已开启腾讯会议"), (0, _defineProperty3.default)(_student, "TencentInteractive_OFF", "老师已关闭腾讯会议"), (0, _defineProperty3.default)(_student, "howtoprint", "如何打印课件"), (0, _defineProperty3.default)(_student, "added", "收藏成功"), (0, _defineProperty3.default)(_student, "canceled", "收藏取消"), (0, _defineProperty3.default)(_student, "cannotbecanceled", "课上不懂不支持取消"), (0, _defineProperty3.default)(_student, "nothinghere", "一无所有～"), (0, _defineProperty3.default)(_student, "videotranscoded", "回放视频正在转码生成中，请稍后查看..."), (0, _defineProperty3.default)(_student, "waiting", "直播时间长，回放生成也会较慢，请耐心等待~"), (0, _defineProperty3.default)(_student, "audioplayback", "音频播放"), (0, _defineProperty3.default)(_student, "set", "设置"), (0, _defineProperty3.default)(_student, "definition", "清晰度"), (0, _defineProperty3.default)(_student, "high", "高清"), (0, _defineProperty3.default)(_student, "standard", "标清"), (0, _defineProperty3.default)(_student, "smooth", "流畅"), (0, _defineProperty3.default)(_student, "speed", "倍速"), (0, _defineProperty3.default)(_student, "playback", "课堂直播回放"), (0, _defineProperty3.default)(_student, "watchplayback", "观看课堂直播回放"), (0, _defineProperty3.default)(_student, "fold", "收起"), (0, _defineProperty3.default)(_student, "play", "播放"), (0, _defineProperty3.default)(_student, "backtocurrent", "回到当前播放"), (0, _defineProperty3.default)(_student, "audiotranscoded", "音频转码中，请稍后…"), (0, _defineProperty3.default)(_student, "reload", "如一直不能播放，刷新本页面试试～"), (0, _defineProperty3.default)(_student, "board", "板书"), (0, _defineProperty3.default)(_student, "dataabnormal", "数据异常"), (0, _defineProperty3.default)(_student, "cannotaccesstencent", "无法获取腾讯会议回放，请通过网页端的直播回放管理-替换回放进行视频替换"), (0, _defineProperty3.default)(_student, "cannotaccesstencentstu", "当前无法获取腾讯会议回放，请联系本节课授课教师，前往网页端的回放管理进行视频替换"), (0, _defineProperty3.default)(_student, "manage", "管理"), (0, _defineProperty3.default)(_student, "audiospeed", "音频倍速"), (0, _defineProperty3.default)(_student, "savecloud", "转存至云盘"), (0, _defineProperty3.default)(_student, "downloadtip", "如需下载请访问雨课堂网页版"), (0, _defineProperty3.default)(_student, "deleteurl", "删除回放段落"), (0, _defineProperty3.default)(_student, "allcheck", "全选"), (0, _defineProperty3.default)(_student, "replayurl", "回放段落"), (0, _defineProperty3.default)(_student, "duration", "时长"), (0, _defineProperty3.default)(_student, "saving", "转存中"), (0, _defineProperty3.default)(_student, "offload", "已转存"), (0, _defineProperty3.default)(_student, "nonsupport", "不支持"), (0, _defineProperty3.default)(_student, "iknow", "我知道了"), (0, _defineProperty3.default)(_student, "notvip", "您暂未拥有会员权限"), (0, _defineProperty3.default)(_student, "viptip", "转存至云盘是会员专享功能，您暂未拥有会员权限。您可进入雨课堂公众号，发送“会员”两个字，打开收到的链接申请开通"), (0, _defineProperty3.default)(_student, "tips", "提示"), (0, _defineProperty3.default)(_student, "issaviing", "回放正在转存至云盘，稍后可登录web端去云盘查看"), (0, _defineProperty3.default)(_student, "spacefull", "云盘储存空间不足"), (0, _defineProperty3.default)(_student, "fulltip", "您的云盘剩余可用空间不足，您可以在整理出足够空间后重试"), (0, _defineProperty3.default)(_student, "deleteallreplay", "确认删除所有回放吗？"), (0, _defineProperty3.default)(_student, "deletealltip", "删除后，教师和学生在课后小结中都无法再观看本段直播回放，且不可恢复"), (0, _defineProperty3.default)(_student, "deletereplay", "确认删除该段回放吗？"), (0, _defineProperty3.default)(_student, "deletetip", "删除后，教师和学生在课后小结中都无法再观看本段直播回放，且不可恢复"), (0, _defineProperty3.default)(_student, "deletesuccess", "删除成功"), (0, _defineProperty3.default)(_student, "servicenonsupport", "服务商无法支持转存"), (0, _defineProperty3.default)(_student, "servicenonsupportdel", "当前回放段落不支持删除"), (0, _defineProperty3.default)(_student, "servicenonsupporthidden", "当前回放段落不支持隐藏"), (0, _defineProperty3.default)(_student, "repeatsave", "正在转存，不可重复操作"), (0, _defineProperty3.default)(_student, "checkinweb", "已转存，请在web端云盘中查看"), (0, _defineProperty3.default)(_student, "replayisprocessed", "回放正在生成，请稍后转存"), (0, _defineProperty3.default)(_student, "playtype1", "[音频]"), (0, _defineProperty3.default)(_student, "playtype2", "[视频]"), (0, _defineProperty3.default)(_student, "noaccess", "您不是主讲老师，暂无管理权限"), (0, _defineProperty3.default)(_student, "setviewstatus", "设置可见状态"), (0, _defineProperty3.default)(_student, "playbackentry", "直播回放入口"), (0, _defineProperty3.default)(_student, "audioplayback", "音频回放"), (0, _defineProperty3.default)(_student, "videoplayback", "视频回放"), (0, _defineProperty3.default)(_student, "confirmcloseentry", "确认关闭直播回放入口吗？"), (0, _defineProperty3.default)(_student, "closeentryresult", "关闭后，学生将无法看到全部回放段落"), (0, _defineProperty3.default)(_student, "confirmhiddenplayback", "确认隐藏该直播回放段落吗？"), (0, _defineProperty3.default)(_student, "hiddenresult", "隐藏后，该回放段落对学生不可见"), (0, _defineProperty3.default)(_student, "setsuccess", "设置成功"), (0, _defineProperty3.default)(_student, "playbackallhiddentip", "* 本次课堂的全部回放片段当前已不可查看"), (0, _defineProperty3.default)(_student, "cannotplaycuritem", "当前回放片段已被隐藏或删除，无法使用定位功能"), (0, _defineProperty3.default)(_student, "exam_desc", "考生须知"), (0, _defineProperty3.default)(_student, "nodesc", "暂无说明"), (0, _defineProperty3.default)(_student, "score_finished", "试卷得分"), (0, _defineProperty3.default)(_student, "score_unstart", "试卷分数"), (0, _defineProperty3.default)(_student, "wrongproblems", "错题数"), (0, _defineProperty3.default)(_student, "datishu", "大题数量"), (0, _defineProperty3.default)(_student, "xitishuliang", "习题数量"), (0, _defineProperty3.default)(_student, "problems", "题数"), (0, _defineProperty3.default)(_student, "exam_notanswer", "未作答"), (0, _defineProperty3.default)(_student, "start_time", "开始时间"), (0, _defineProperty3.default)(_student, "end_time", "截止时间"), (0, _defineProperty3.default)(_student, "end_lesson_time", "结课时间"), (0, _defineProperty3.default)(_student, "exam_limit", "考试限时"), (0, _defineProperty3.default)(_student, "exam_notlimit", "不限时"), (0, _defineProperty3.default)(_student, "answer_time", "成绩将于{time}公布"), (0, _defineProperty3.default)(_student, "exam_start", "开始答题"), (0, _defineProperty3.default)(_student, "exam_continue", "继续答题"), (0, _defineProperty3.default)(_student, "exam_notbegin", "考试未开始"), (0, _defineProperty3.default)(_student, "exam_check", "查看试卷"), (0, _defineProperty3.default)(_student, "exam_nodata", "暂无数据"), (0, _defineProperty3.default)(_student, "exam_notview", "老师设置不可查看"), (0, _defineProperty3.default)(_student, "sun", "星期日"), (0, _defineProperty3.default)(_student, "mon", "星期一"), (0, _defineProperty3.default)(_student, "tue", "星期二"), (0, _defineProperty3.default)(_student, "wed", "星期三"), (0, _defineProperty3.default)(_student, "thu", "星期四"), (0, _defineProperty3.default)(_student, "fri", "星期五"), (0, _defineProperty3.default)(_student, "sat", "星期六"), (0, _defineProperty3.default)(_student, "watchedreplay", "本节课已观看过回放"), (0, _defineProperty3.default)(_student, "partpagenoview", "部分页面当前已不可见"), (0, _defineProperty3.default)(_student, "coverentertips", "未达到考试条件"), _student),
	
	    //消息
	    message: {
	        "infoassignment": "任务",
	        "infomessage": "通知",
	        "infofollowers": "粉丝",
	        "chat": "私信",
	        "comment": "评论",
	        "repliedToYou": "回复了你",
	        "commentedOnYourComment": "评论了你",
	        "likedYou": "点赞了你",
	        "NoMessage": "还没有任何消息",
	        "loading": "加载中",
	        "nomessage": "你还没有任何消息",
	        "infocoteacher": "已成为协同教师身份",
	        "removecoteacher": "已被移除协同教师",
	
	        "infopromotecoteacher": "{courseTitle}的主讲教师已提拔您为协同教师",
	        "inforemovecoteacher": "{courseTitle}的主讲教师已将您移除协同教师",
	        "receivepreclassinfo": "收到课前反馈",
	        "inforeceivereport": "收到{feedbackCnt}条报告老师，请您查看",
	
	        "replypreviewreport": "报告老师收到回复",
	        "receiveteacherreply": "收到老师回复，速速去查看吧",
	        "pullRefresh": "下拉刷新",
	        "releaseUpdate": "释放更新",
	        "markasread": "全部标记为已读",
	        "hasMarked": "已全部标记为已读",
	        "message": "消息",
	        "notification": "通知",
	
	        "infonofollowers": "你还没有任何粉丝",
	        "infoyourquestionanswered": "{respondent}回答了你的提问",
	        "infoquestionname": "问题是{question}",
	        "inforeplytou": "评论了你的回答",
	
	        "noassignment": "你还没有任何任务",
	        "publishslidespush": "{teacherName}老师发布了新课件",
	        "published": " 已发布",
	        "slidesddlpush": "{deadline}请尽快完成",
	        "previewpush": "在{deadline}之前完成噢",
	        "unclearremind": "课堂上遗留了不懂",
	        "figureoutunclears": "别把问题留到下节课，赶紧消灭吧",
	        "publishquizpush": "{teacherName}老师发布了新试卷",
	        "publishedpush": "抓紧时间尽快完成吧",
	        "assignmentddlpush": "在{deadline}之前完成作业噢",
	        "inforeceiveslidespush": "{courseTitle}-{chapterTitle}{sectionTitle} 已到达，可以开始学习啦",
	        "unclearset": "课堂不懂集中反馈",
	        "checkstudentunclear": "学生有部分存疑，去看看吧",
	        "infobeinvited": "{inviter}邀请您回答问题",
	        "newLearnWarnningTitle": "{inviter}老师提醒你关注学情",
	        "newLearnWarnningContent": "请关注你的课程学习情况，在结课前尽快提升成绩",
	        "booking_down": "预约的新章节到了",
	        "image": "图片",
	        "NoMessageTips": "你可在班级内的成员列表处点击头像发送私信",
	
	        "commentdel": "内容已被删除"
	    },
	
	    //教师端页面
	    teacher: (_teacher = {
	        "yijiaojuan": "已交卷",
	        "weijiaojuan": "未交卷",
	        "unclearlist": "“不懂”名单",
	        "standardopt": "本题正确选项为:",
	        "nameone": "姓名",
	        "optionone": "选项",
	        "notansweredone": "未作答",
	        "wrongquestionone": "习题“错误”",
	        "slidewrongone": "课件“不懂”",
	        "studentnumber": "人数",
	        "wrongone": "错误: ",
	        "unclearone": "不懂: ",
	        "uncleartwo": "不懂",
	        "searchone": "搜索",
	        "rankingone": "排名",
	        "totalscoreone": "总分",
	        "timespentone": "用时",
	        "questionandpage": "题号/页码",
	        "tihao": "题号",
	        "correctanswertwo": "正确答案",
	        "submitone": "提交选项",
	        "submit": "提交",
	        "correctanswerthree": "正确答案",
	        "scoreone": "得分",
	        "subjectivequestionone": "主观题",
	        "inclassquiz": "课堂考试",
	        "notansweredtwo": "未答题",
	        "notansweredblanks": "未答",
	        "detailsone": "详情",
	        "checkone": "查看",
	        "sentokone": "已成功发送至",
	        "sentoktwo": "已成功送达：",
	        "scheduledeliverfailedone": "预约发送失败，请重新发送",
	        "publishname": "发布名称",
	        "quizone": "试卷",
	        "timetopublish": "发布时间",
	        "timetopublish1": "发布时间",
	        "deadlineone": "截止时间",
	        "quizdurationone": "考试时长（分钟）",
	        "releasetimeone": "公布答案时间",
	        "publishclassone": "发布班级",
	        "totalclassesone": "共 {length} 个班",
	        "pagetotal": "共{count}页",
	        "deletepublishone": "删除本次发布",
	        "cancelone": "取消",
	        "okone": "确定",
	        "delete": "删除",
	        "confirmone": "确认",
	        "publishinstruction": "发布{\"试卷\" : \"课件\"}帮助说明",
	        "setdeadlinetips": "若设定完成截止时间，到期后学生将不能答题，完成后数据也不再更新，但在课件查看截止时间内仍能查看课件；",
	        "nosetdeadlinetips": "若不设定完成截止时间，学生在课件查看截止时间内随时可以查看课件并答题，完成后数据将实时更新；",
	        "systemsubmitanswers": "设定截止时间后，到期学生将仍能看到试卷，但无法继续作答或提交试卷，试卷完成数据及得分分布也不再更新。到截止时间时，系统将自动提交学生所作答的全部内容。",
	        "timernostop": " 学生必须在规定的时间长度内提交试卷。点击作答开始计时，若中途退出，计时不停止。到时后系统将自动提交学生所作答的全部内容。",
	        "releasetips": "正确答案将在到达此时间时向学生公布，在此之前，学生即使提交试卷也无法知晓正确答案及相关答案解析。",
	        "close": "关闭",
	        "publish": "发布",
	        "none": "无",
	        "publishnow": "立即发布",
	        "": "[\"日\",\"一\",\"二\",\"三\",\"四\",\"五\",\"六\"]",
	        "notimelimitone": "不限时",
	        "showaftersubmission": "交卷后立即显示",
	        "nochooseclass": "您还未选择发布的班级",
	        "publishtimenoearliernow": "发布时间不能早于当前时间",
	        "ddltimenoearliernow": "截止时间不能早于当前时间"
	    }, (0, _defineProperty3.default)(_teacher, "", "当前截止时间过早，不满足考试时长"), (0, _defineProperty3.default)(_teacher, "testdurationzero", "考试时长不能为0"), (0, _defineProperty3.default)(_teacher, "noearlierthanpublishtime", "截止时间应在发布时间之后\r\n请重新设置"), (0, _defineProperty3.default)(_teacher, "changecfmone", "是否确认修改发布信息"), (0, _defineProperty3.default)(_teacher, "publishcfmone", "确认发布到班级"), (0, _defineProperty3.default)(_teacher, "deletecfmone", "是否确认删除本次预约"), (0, _defineProperty3.default)(_teacher, "hour", "小时"), (0, _defineProperty3.default)(_teacher, "min", "分钟"), (0, _defineProperty3.default)(_teacher, "", "点"), (0, _defineProperty3.default)(_teacher, "today", "今天"), (0, _defineProperty3.default)(_teacher, "tommrrow", "明天"), (0, _defineProperty3.default)(_teacher, "thedayaftertommorrow", "后天"), (0, _defineProperty3.default)(_teacher, "tips1", "提示：课件中含有习题，您可以在此设置公布答案的时间"), (0, _defineProperty3.default)(_teacher, "chengjidantips", "系统将根据考核设置自动出成绩，您可以在网页端“班级成绩单”模块查看或管理班级考核方案。"), (0, _defineProperty3.default)(_teacher, "monthdayweek", "月 日 周"), (0, _defineProperty3.default)(_teacher, "anonymouspollnodetail", "本题为匿名投票，不显示投票人"), (0, _defineProperty3.default)(_teacher, "numberofvotes", "{count}票"), (0, _defineProperty3.default)(_teacher, "standardopt", "本题正确选项为: "), (0, _defineProperty3.default)(_teacher, "numberofstudents", "{count} 人"), (0, _defineProperty3.default)(_teacher, "numberofstudents1", "人"), (0, _defineProperty3.default)(_teacher, "noanswers", "还没有学生作答"), (0, _defineProperty3.default)(_teacher, "answerdetails", "答题情况"), (0, _defineProperty3.default)(_teacher, "submittime", "完成时间"), (0, _defineProperty3.default)(_teacher, "numberviewedpage", "已查看页数"), (0, _defineProperty3.default)(_teacher, "content", "内容"), (0, _defineProperty3.default)(_teacher, "senttime", "发送时间"), (0, _defineProperty3.default)(_teacher, "saved", "已收藏"), (0, _defineProperty3.default)(_teacher, "save", "收藏"), (0, _defineProperty3.default)(_teacher, "whatispost", "什么是投稿？"), (0, _defineProperty3.default)(_teacher, "post", "投稿"), (0, _defineProperty3.default)(_teacher, "coteacherinclass", "本班协同教师"), (0, _defineProperty3.default)(_teacher, "addcoteacher", "添加协同教师"), (0, _defineProperty3.default)(_teacher, "setpermission", "设置权限"), (0, _defineProperty3.default)(_teacher, "deletepermissioncfm", "确认删除该老师权限吗?"), (0, _defineProperty3.default)(_teacher, "deletepermissionfailed", "删除该老师权限失败"), (0, _defineProperty3.default)(_teacher, "selectall", "全选"), (0, _defineProperty3.default)(_teacher, "confirmdelete", "确认删除"), (0, _defineProperty3.default)(_teacher, "", "此课程选课信息由教务系统直接导入雨课堂中,只可对旁听生进行管理"), (0, _defineProperty3.default)(_teacher, "managestudents", "学生管理"), (0, _defineProperty3.default)(_teacher, "clear", "清空"), (0, _defineProperty3.default)(_teacher, "readnumber", "人已读"), (0, _defineProperty3.default)(_teacher, "unreadnumber", "人未读"), (0, _defineProperty3.default)(_teacher, "slidecover", "雨课堂课件封面"), (0, _defineProperty3.default)(_teacher, "slidename", "演示文稿名称"), (0, _defineProperty3.default)(_teacher, "yearmonthday", "年 月 日"), (0, _defineProperty3.default)(_teacher, "selectclass", "选择班级"), (0, _defineProperty3.default)(_teacher, "done", "完成"), (0, _defineProperty3.default)(_teacher, "addnewclassinjoined", "添加新班级请到我的课程管理添加"), (0, _defineProperty3.default)(_teacher, "enterslidetitle", "请输入课件名称"), (0, _defineProperty3.default)(_teacher, "noclasschosen", "您还未选择发布班级"), (0, _defineProperty3.default)(_teacher, "publishfailed", "发布失败"), (0, _defineProperty3.default)(_teacher, "selectclasstopublish", "选择发布班级"), (0, _defineProperty3.default)(_teacher, "nocreatedcourse", "您还没有创建课程"), (0, _defineProperty3.default)(_teacher, "createaacourse", "创建课程"), (0, _defineProperty3.default)(_teacher, "noclassyet", "课程无班级,请增加班级"), (0, _defineProperty3.default)(_teacher, "tocreatecourse", "去新建课程"), (0, _defineProperty3.default)(_teacher, "selectclassplease", "请选择班级"), (0, _defineProperty3.default)(_teacher, "announcementlimit", "每班每日可发送2条公告，你还可以发送"), (0, _defineProperty3.default)(_teacher, "anouncementnumbers", "条"), (0, _defineProperty3.default)(_teacher, "requiredtitle", "标题(必填)"), (0, _defineProperty3.default)(_teacher, "spaceorentertosend", "您可以向学生发送文字、图片、链接（请在输入链接地址的前后，均添加空格或回车以确认）"), (0, _defineProperty3.default)(_teacher, "sendto", "发送至："), (0, _defineProperty3.default)(_teacher, "backtoedit", "返回编辑"), (0, _defineProperty3.default)(_teacher, "confirmok", "确定发送"), (0, _defineProperty3.default)(_teacher, "classesreceiveok", "已成功发送给以下班级："), (0, _defineProperty3.default)(_teacher, "gotit", "我知道了"), (0, _defineProperty3.default)(_teacher, "deletepiccfm", "确定删除图片？"), (0, _defineProperty3.default)(_teacher, "quiteditcfm", "是否放弃本次编辑?"), (0, _defineProperty3.default)(_teacher, "noannouncementcansend", "您还可以发送0条"), (0, _defineProperty3.default)(_teacher, "titlenotnull", "标题不能为空"), (0, _defineProperty3.default)(_teacher, "announcementnotnull", "公告不能为空"), (0, _defineProperty3.default)(_teacher, "reachupperlimit", "该班级已经超过发送次数，不能发送。"), (0, _defineProperty3.default)(_teacher, "announceanswertip", "说明：答案将在此日期后公布，否则提交后直接显示"), (0, _defineProperty3.default)(_teacher, "notimelimitdetail", "不限时 5分钟 15分钟 30分钟 45分钟 60分钟 90分钟 120分钟 150分钟 4小时 6小时 8小时 12小时 24小时 48小时"), (0, _defineProperty3.default)(_teacher, "enterquizname", "请输入试卷名称"), (0, _defineProperty3.default)(_teacher, "setdateaftertoday", "请设置今天之后的日期"), (0, _defineProperty3.default)(_teacher, "teachingdatapoll", "投票"), (0, _defineProperty3.default)(_teacher, "chooseupperlimit", "最多可选"), (0, _defineProperty3.default)(_teacher, "teachingdataoption", "项"), (0, _defineProperty3.default)(_teacher, "multiplem", "多选题"), (0, _defineProperty3.default)(_teacher, "multiples", "单选题"), (0, _defineProperty3.default)(_teacher, "subjectivepro", "主观题"), (0, _defineProperty3.default)(_teacher, "point", "分"), (0, _defineProperty3.default)(_teacher, "anonymouspollnodetail", "本题为匿名投票，不显示投票人"), (0, _defineProperty3.default)(_teacher, "votenumber", "票"), (0, _defineProperty3.default)(_teacher, "standardopt", "本题正确选项为"), (0, _defineProperty3.default)(_teacher, "notansweredone", "未作答"), (0, _defineProperty3.default)(_teacher, "teacherdatastudents", "人"), (0, _defineProperty3.default)(_teacher, "teacherdatastudentscount", "{count}人"), (0, _defineProperty3.default)(_teacher, "zuodashichang", "作答时长"), (0, _defineProperty3.default)(_teacher, "weidatitishi", "*未答题不包含未签到的学生"), (0, _defineProperty3.default)(_teacher, "noanswers", "还没有学生作答"), (0, _defineProperty3.default)(_teacher, "answerdetails", "答题情况"), (0, _defineProperty3.default)(_teacher, "noaddslides", "您还没有添加任何课件喔"), (0, _defineProperty3.default)(_teacher, "year", "年"), (0, _defineProperty3.default)(_teacher, "month", "月"), (0, _defineProperty3.default)(_teacher, "day", "日"), (0, _defineProperty3.default)(_teacher, "deadline", "截止时间"), (0, _defineProperty3.default)(_teacher, "enterslidenameplease", "请输入课件的名称"), (0, _defineProperty3.default)(_teacher, "datedetail", "年／月／日"), (0, _defineProperty3.default)(_teacher, "slidepublish", "课件发布"), (0, _defineProperty3.default)(_teacher, "sending", "正在发送..."), (0, _defineProperty3.default)(_teacher, "noaddtests", "您还没有添加任何试卷喔"), (0, _defineProperty3.default)(_teacher, "selectslideoneonly", "选择课件(单选)"), (0, _defineProperty3.default)(_teacher, "coursechooseslide", "选择试卷(单选)"), (0, _defineProperty3.default)(_teacher, "sendnow", "立即发出"), (0, _defineProperty3.default)(_teacher, "testduration", "考试时长(分钟)"), (0, _defineProperty3.default)(_teacher, "notimelimitone", "不限时"), (0, _defineProperty3.default)(_teacher, "releasetimeone", "公布答案时间"), (0, _defineProperty3.default)(_teacher, "showaftersubmission", "提交后立即显示"), (0, _defineProperty3.default)(_teacher, "announceanswertip", "说明：答案将在此日期后公布，否则提交后直接显示"), (0, _defineProperty3.default)(_teacher, "cfmpublish", "确认发布"), (0, _defineProperty3.default)(_teacher, "publishtest", "试卷发布"), (0, _defineProperty3.default)(_teacher, "setdateaftertoday", "请设置今天之后的日期"), (0, _defineProperty3.default)(_teacher, "sending", "正在发送..."), (0, _defineProperty3.default)(_teacher, "notimelimitdetails ", "不限时 5分钟 15分钟 30分钟 45分钟 60分钟 90分钟 120分钟 150分钟 4小时 6小时 8小时 12小时 24小时 48小时"), (0, _defineProperty3.default)(_teacher, "donealready", "已完成"), (0, _defineProperty3.default)(_teacher, "checkedpreview", "已查看"), (0, _defineProperty3.default)(_teacher, "nocheckedpreview", "未查看"), (0, _defineProperty3.default)(_teacher, "noonefinishpreview", "还没有学生完成"), (0, _defineProperty3.default)(_teacher, "noonepreviewing", "还没有学生正在进行"), (0, _defineProperty3.default)(_teacher, "allfinish", "全部学生已完成"), (0, _defineProperty3.default)(_teacher, "previewdetail", "完成情况"), (0, _defineProperty3.default)(_teacher, "finisheddetails", "完成情况"), (0, _defineProperty3.default)(_teacher, "finishedpreview", "已完成"), (0, _defineProperty3.default)(_teacher, "checkslides", "查看课件"), (0, _defineProperty3.default)(_teacher, "viewdetails", "查看详情"), (0, _defineProperty3.default)(_teacher, "studentscheckedslides", "查看课件人数"), (0, _defineProperty3.default)(_teacher, "totalclassstudents", "班级总人数"), (0, _defineProperty3.default)(_teacher, "answerdetails", "答题情况"), (0, _defineProperty3.default)(_teacher, "subjectivepro", "主观题"), (0, _defineProperty3.default)(_teacher, "gradingrate", "批改率"), (0, _defineProperty3.default)(_teacher, "answerrate", "答题率"), (0, _defineProperty3.default)(_teacher, "averagescore", "平均分"), (0, _defineProperty3.default)(_teacher, "poll", "投票题"), (0, _defineProperty3.default)(_teacher, "grading", "批改"), (0, _defineProperty3.default)(_teacher, "webgradetips", "温馨提示：网页版（{url}）批改主观题更便捷"), (0, _defineProperty3.default)(_teacher, "accuracy", "正确率"), (0, _defineProperty3.default)(_teacher, "objectivequestion", "客观题"), (0, _defineProperty3.default)(_teacher, "answerrate", "答题率"), (0, _defineProperty3.default)(_teacher, "teacherdatacheck", "查看"), (0, _defineProperty3.default)(_teacher, "studentfeedback", "学生反馈"), (0, _defineProperty3.default)(_teacher, "anonymous", "匿名"), (0, _defineProperty3.default)(_teacher, "unread", "未读"), (0, _defineProperty3.default)(_teacher, "nostudentfeedback", "目前还没有学生反馈信息"), (0, _defineProperty3.default)(_teacher, "detaileddata", "详细数据"), (0, _defineProperty3.default)(_teacher, "webdownloadexcel", "下载多次Excel数据 请登录网页版 {url}"), (0, _defineProperty3.default)(_teacher, "teachingdesign", "教学设计与备忘"), (0, _defineProperty3.default)(_teacher, "teachingdesigntip", "您可以在这里可以记录教学设计和心得等笔记，内容仅自己可见"), (0, _defineProperty3.default)(_teacher, "editpublishtitle", "编辑发布标题"), (0, _defineProperty3.default)(_teacher, "deletepublish", "删除本次发布"), (0, _defineProperty3.default)(_teacher, "loadmore", "加载更多"), (0, _defineProperty3.default)(_teacher, "mailreceivedata", "本次详细数据将会发送至以下邮箱"), (0, _defineProperty3.default)(_teacher, "enterfrequentmail", "请你输入常用邮箱"), (0, _defineProperty3.default)(_teacher, "mailformaterror", "邮件格式错误"), (0, _defineProperty3.default)(_teacher, "datasentok", "数据已发送"), (0, _defineProperty3.default)(_teacher, "yktwebtips", "温馨提示：在雨课堂网页版 {url}"), (0, _defineProperty3.default)(_teacher, "enternewtitle", "输入新的标题~"), (0, _defineProperty3.default)(_teacher, "deletepulishcfm", "是否删除本次发布"), (0, _defineProperty3.default)(_teacher, "deletepublishfailed", "删除发布失败"), (0, _defineProperty3.default)(_teacher, "previewdetails", "学习详情"), (0, _defineProperty3.default)(_teacher, "finisheddetails", "完成详情"), (0, _defineProperty3.default)(_teacher, "gradingdetails", "批改详情"), (0, _defineProperty3.default)(_teacher, "name", "姓名"), (0, _defineProperty3.default)(_teacher, "score", "得分"), (0, _defineProperty3.default)(_teacher, "submission", "交卷时间"), (0, _defineProperty3.default)(_teacher, "gradingtime", "批复时间"), (0, _defineProperty3.default)(_teacher, "noonefinished", "还没有学生完成"), (0, _defineProperty3.default)(_teacher, "testfinisheddetails", "试卷完成情况"), (0, _defineProperty3.default)(_teacher, "finisheddetails", "完成情况"), (0, _defineProperty3.default)(_teacher, "checktestpaper", "查看试卷"), (0, _defineProperty3.default)(_teacher, "graded", "已批改"), (0, _defineProperty3.default)(_teacher, "finishedtest", "完成试卷"), (0, _defineProperty3.default)(_teacher, "checktestpaper", "查看试卷"), (0, _defineProperty3.default)(_teacher, "totalstudentone", "班级人数"), (0, _defineProperty3.default)(_teacher, "viewdetails", "查看详情"), (0, _defineProperty3.default)(_teacher, "scoredistribution", "总分分布"), (0, _defineProperty3.default)(_teacher, "allvote", "此试卷全部为投票题"), (0, _defineProperty3.default)(_teacher, "ungradedsubjectiveproexist", "您还有主观题尚未批改"), (0, _defineProperty3.default)(_teacher, "clickbarcharttograde.", "点击下面主观题柱状图进行批改"), (0, _defineProperty3.default)(_teacher, "noonefinishedtest", "还没有学生完成试卷"), (0, _defineProperty3.default)(_teacher, "qbxsyjj", "全部学生已交卷"), (0, _defineProperty3.default)(_teacher, "answerdetails", "答题情况"), (0, _defineProperty3.default)(_teacher, "grading", "批改"), (0, _defineProperty3.default)(_teacher, "deleteexcelnow", "可直接下载多次详细数据的Excel文件哦～"), (0, _defineProperty3.default)(_teacher, "deletepulishcfm", "是否删除本次发布"), (0, _defineProperty3.default)(_teacher, "deletepublishfailed", "删除发布失败"), (0, _defineProperty3.default)(_teacher, "standardopt", "本题正确选项为"), (0, _defineProperty3.default)(_teacher, "noanswerforpoll", "本题为投票，没有正确答案"), (0, _defineProperty3.default)(_teacher, "option", "选项"), (0, _defineProperty3.default)(_teacher, "name", "姓名"), (0, _defineProperty3.default)(_teacher, "loadingdata", "正在加载数据..."), (0, _defineProperty3.default)(_teacher, "answered", "已作答"), (0, _defineProperty3.default)(_teacher, "notansweredone", "未作答"), (0, _defineProperty3.default)(_teacher, "lessonexciese", "课堂习题"), (0, _defineProperty3.default)(_teacher, "lessonquiz", "课堂试卷"), (0, _defineProperty3.default)(_teacher, "score", "得分"), (0, _defineProperty3.default)(_teacher, "gradeone", "打分"), (0, _defineProperty3.default)(_teacher, "stick", "条"), (0, _defineProperty3.default)(_teacher, "loadmore", "加载更多"), (0, _defineProperty3.default)(_teacher, "okone", "确定"), (0, _defineProperty3.default)(_teacher, "thisquestion", "本题"), (0, _defineProperty3.default)(_teacher, "point", "分"), (0, _defineProperty3.default)(_teacher, "cancel", "取消"), (0, _defineProperty3.default)(_teacher, "positivescore", "分数必须为正数"), (0, _defineProperty3.default)(_teacher, "exceedmaximumscore", "分数超过最大本题分值，请重新输入"), (0, _defineProperty3.default)(_teacher, "keepadecimal", "分数最多保留一位小数，请重新输入"), (0, _defineProperty3.default)(_teacher, "numberonlywarning", "所输分数必须为数字，请重新输入"), (0, _defineProperty3.default)(_teacher, "unclearstudents", "不懂人数"), (0, _defineProperty3.default)(_teacher, "unclearstudents1", "不懂人数<span class=\"font18\">{count}</span>人"), (0, _defineProperty3.default)(_teacher, "noquestiontoanswer", "本堂课没有习题"), (0, _defineProperty3.default)(_teacher, "nounclearslides", "没有被点击『不懂』的课件"), (0, _defineProperty3.default)(_teacher, "nocommentslides", "没有带「评论」的幻灯片~"), (0, _defineProperty3.default)(_teacher, "commentcount", "评论条数"), (0, _defineProperty3.default)(_teacher, "quantityone", "红包个数："), (0, _defineProperty3.default)(_teacher, "noquestiontoanswer", "本堂课没有习题"), (0, _defineProperty3.default)(_teacher, "standardopt", "本题正确选项为:"), (0, _defineProperty3.default)(_teacher, "noanswerforpoll", "本题为投票，没有正确答案"), (0, _defineProperty3.default)(_teacher, "gradingtime", "批复时间"), (0, _defineProperty3.default)(_teacher, "timelimitedtest", "本套试卷限时"), (0, _defineProperty3.default)(_teacher, "min", "分钟"), (0, _defineProperty3.default)(_teacher, "deadline", "截止日期"), (0, _defineProperty3.default)(_teacher, "testdeadline", "本套试卷截止时间"), (0, _defineProperty3.default)(_teacher, "timelimitedtest", "本套试卷限时"), (0, _defineProperty3.default)(_teacher, "checkhw", "查看作业"), (0, _defineProperty3.default)(_teacher, "finishedhw", "已完成作业"), (0, _defineProperty3.default)(_teacher, "hwfinisheddetail", "作业完成情况"), (0, _defineProperty3.default)(_teacher, "finishedhwstudent", "n位同学完成作业"), (0, _defineProperty3.default)(_teacher, "gradedhwnumber", "份作业已经批复"), (0, _defineProperty3.default)(_teacher, "scorereport", "得分情况"), (0, _defineProperty3.default)(_teacher, "questionlocate", "第2题"), (0, _defineProperty3.default)(_teacher, "accuracyone", "正确答题率"), (0, _defineProperty3.default)(_teacher, "editpublishtitle", "编辑本次发布标题"), (0, _defineProperty3.default)(_teacher, "deletepublish", "删除本次发布"), (0, _defineProperty3.default)(_teacher, "deletepublishone", "确认删除本次发布吗?"), (0, _defineProperty3.default)(_teacher, "deletepublishfailed", "删除发布失败"), (0, _defineProperty3.default)(_teacher, "mailreceivedata", "本次详细数据将会发送至以下邮箱"), (0, _defineProperty3.default)(_teacher, "enterfrequentmail", "请你输入常用邮箱"), (0, _defineProperty3.default)(_teacher, "datasentok", "数据已发送"), (0, _defineProperty3.default)(_teacher, "submission", "交卷时间"), (0, _defineProperty3.default)(_teacher, "searchname", "搜索姓名"), (0, _defineProperty3.default)(_teacher, "checktestpaper", "查看卷面"), (0, _defineProperty3.default)(_teacher, "randomrollcallinthisclass", "本节课随机点名"), (0, _defineProperty3.default)(_teacher, "signedinstudent", "已签到"), (0, _defineProperty3.default)(_teacher, "totalsignedstudent", "共2人"), (0, _defineProperty3.default)(_teacher, "signin", "签"), (0, _defineProperty3.default)(_teacher, "dot", "点"), (0, _defineProperty3.default)(_teacher, "person", "人"), (0, _defineProperty3.default)(_teacher, "ci", "次"), (0, _defineProperty3.default)(_teacher, "nistudenttocall", "没有点名学生～"), (0, _defineProperty3.default)(_teacher, "correctopt", "正确选项"), (0, _defineProperty3.default)(_teacher, "wrongopt", "错误选项"), (0, _defineProperty3.default)(_teacher, "anonymouspollnodetail", "本题为匿名投票，不显示投票人"), (0, _defineProperty3.default)(_teacher, "totalamountofbonus", "总金额"), (0, _defineProperty3.default)(_teacher, "rmb", "元"), (0, _defineProperty3.default)(_teacher, "bonusnotopened", "未领取"), (0, _defineProperty3.default)(_teacher, "notansweredtwo", "未答题"), (0, _defineProperty3.default)(_teacher, "votemost", "投票题，最高得票选项为："), (0, _defineProperty3.default)(_teacher, "standardopt", "本题正确选项为"), (0, _defineProperty3.default)(_teacher, "voteoption", "投票的选项"), (0, _defineProperty3.default)(_teacher, "nostudentanswered", "还没有学生答题"), (0, _defineProperty3.default)(_teacher, "studentfinishedpreview", "已完成"), (0, _defineProperty3.default)(_teacher, "previewdetail", "课件学习情况"), (0, _defineProperty3.default)(_teacher, "finishpreview", "完成学习"), (0, _defineProperty3.default)(_teacher, "privateteachingnote", "您可以在这里记录教学设计和心得等笔记，内容仅自己可见。"), (0, _defineProperty3.default)(_teacher, "mailreceivedata", "本次详细数据将会发送至以下邮箱"), (0, _defineProperty3.default)(_teacher, "activestudent", "课堂人数"), (0, _defineProperty3.default)(_teacher, "enterclass", "进入课堂"), (0, _defineProperty3.default)(_teacher, "activestudentnumber", "进入课堂人数"), (0, _defineProperty3.default)(_teacher, "totalclassstudent", "班级总人数"), (0, _defineProperty3.default)(_teacher, "studentdata", "学生数据"), (0, _defineProperty3.default)(_teacher, "notfinalrank", "有主观题未批改，此排名可能不是最终排名"), (0, _defineProperty3.default)(_teacher, "totalrank", "全部排名"), (0, _defineProperty3.default)(_teacher, "notfinalrank", "有主观题未批改，此排名可能不是最终排名"), (0, _defineProperty3.default)(_teacher, "brilliantstudent ", "优秀学生"), (0, _defineProperty3.default)(_teacher, "timespenttwo", "用时"), (0, _defineProperty3.default)(_teacher, "warningstudent", "“预警\"学生"), (0, _defineProperty3.default)(_teacher, "trackstudentprogress", "在课堂上通过习题更好了解学生状态~"), (0, _defineProperty3.default)(_teacher, "studentanswerdata", "习题数据"), (0, _defineProperty3.default)(_teacher, "barcharttograde", "（点击柱状图可批改）"), (0, _defineProperty3.default)(_teacher, "totalquestions", "全部习题"), (0, _defineProperty3.default)(_teacher, "teachingunclearpage", "点不懂页数"), (0, _defineProperty3.default)(_teacher, "teachingtotalslidesno", "课件总页数"), (0, _defineProperty3.default)(_teacher, "teachingsubjectiveproungraded", "有主观题未批改"), (0, _defineProperty3.default)(_teacher, "classdanmu", "课堂弹幕"), (0, _defineProperty3.default)(_teacher, "classpost", "课堂投稿"), (0, _defineProperty3.default)(_teacher, "randomrollcall", "随机点名"), (0, _defineProperty3.default)(_teacher, "senddetaileddata", "发送详细数据"), (0, _defineProperty3.default)(_teacher, "teachingcontents", "教学内容"), (0, _defineProperty3.default)(_teacher, "totalpagenumber", "共1页"), (0, _defineProperty3.default)(_teacher, "teachingdesign", "教学设计与备忘"), (0, _defineProperty3.default)(_teacher, "privateteachingnote", "您可以在这里记录教学设计和心得等笔记，内容仅自己可见。"), (0, _defineProperty3.default)(_teacher, "coteacherlimit", "协同教师无法删除此教学活动"), (0, _defineProperty3.default)(_teacher, "deletepublishone", "确认删除本次发布吗"), (0, _defineProperty3.default)(_teacher, "coteacherlimit", "协同教师无法删除此教学活动"), (0, _defineProperty3.default)(_teacher, "deletefailedretry", "删除失败，请稍后重试"), (0, _defineProperty3.default)(_teacher, "one", "个"), (0, _defineProperty3.default)(_teacher, "countone", "{count}个"), (0, _defineProperty3.default)(_teacher, "tipsdownloadwebdata", "温馨提示：在雨课堂网页版 {url}可直接下载多次详细数据的Excel文件哦～"), (0, _defineProperty3.default)(_teacher, "notsignedin", "未签到"), (0, _defineProperty3.default)(_teacher, "total", "全部"), (0, _defineProperty3.default)(_teacher, "totalone", "共"), (0, _defineProperty3.default)(_teacher, "pro", "习题"), (0, _defineProperty3.default)(_teacher, "teachingcheck", "查看结果"), (0, _defineProperty3.default)(_teacher, "slidesdetail", "课件数据"), (0, _defineProperty3.default)(_teacher, "quizedit", "修改"), (0, _defineProperty3.default)(_teacher, "comment", "评语"), (0, _defineProperty3.default)(_teacher, "good", "写得不错"), (0, _defineProperty3.default)(_teacher, "comeon", "继续加油"), (0, _defineProperty3.default)(_teacher, "uniqueidea", "想法很独特"), (0, _defineProperty3.default)(_teacher, "excellent", "小红花"), (0, _defineProperty3.default)(_teacher, "enterscoretip", "请输入分值"), (0, _defineProperty3.default)(_teacher, "comment", "评语"), (0, _defineProperty3.default)(_teacher, "invaildinput", "输入无效，请重新输入"), (0, _defineProperty3.default)(_teacher, "positivescore", "分数必须为正数"), (0, _defineProperty3.default)(_teacher, "exceedmaximumscore", "分数超过最大本题分值，请重新输入"), (0, _defineProperty3.default)(_teacher, "sendprotips", "怎样布置习题？"), (0, _defineProperty3.default)(_teacher, "slidesdetails", "课件数据"), (0, _defineProperty3.default)(_teacher, "emptyhelp", "戳这里看帮助"), (0, _defineProperty3.default)(_teacher, "emptysildes", "还没有上传的课件"), (0, _defineProperty3.default)(_teacher, "emptysildesupload", "尝试从电脑端上传课件吧"), (0, _defineProperty3.default)(_teacher, "emptyquiz", "还没有上传的试卷"), (0, _defineProperty3.default)(_teacher, "emptyquizupload", "尝试从电脑端上传试卷吧"), (0, _defineProperty3.default)(_teacher, "studentsVisible", "学生可见"), (0, _defineProperty3.default)(_teacher, "visibleAll", "全部课件"), (0, _defineProperty3.default)(_teacher, "visibleStu", "课上讲解的"), (0, _defineProperty3.default)(_teacher, "visibleAllnot", "全部不可见"), (0, _defineProperty3.default)(_teacher, "visiblepart", "部分可见"), (0, _defineProperty3.default)(_teacher, "pointnotviewpage", "点击选中不可见的页面"), (0, _defineProperty3.default)(_teacher, "nocheck", "不可见"), (0, _defineProperty3.default)(_teacher, "editviewpage", "编辑可见页面"), (0, _defineProperty3.default)(_teacher, "stucheckauth", "学生查看权限"), (0, _defineProperty3.default)(_teacher, "ppt_limit_ques1", "确认学生可见<span style='color: #333;font-weight: 500;'>“全部课件”</span>吗？"), (0, _defineProperty3.default)(_teacher, "ppt_limit_ques2", "确认学生只可见<span style='color: #333;font-weight: 500;'>“课上讲解部分的课件”</span>吗？"), (0, _defineProperty3.default)(_teacher, "ppt_limit_ques3", "确定课件对学生<span style='color: #F84F41;font-weight: 500;'>“全部不可见”</span>吗？"), (0, _defineProperty3.default)(_teacher, "nextDefault", "下次授课默认使用该选择"), (0, _defineProperty3.default)(_teacher, "setSuc", "设置成功"), (0, _defineProperty3.default)(_teacher, "lookLimit", "查看限制"), (0, _defineProperty3.default)(_teacher, "paperLookLimit", "试卷查看限制"), (0, _defineProperty3.default)(_teacher, "alwaysLook", "始终可见"), (0, _defineProperty3.default)(_teacher, "afterHand", "交卷后不可见"), (0, _defineProperty3.default)(_teacher, "afterHandTips", "截止后，未交卷学生也不可见"), (0, _defineProperty3.default)(_teacher, "afterCannot", "设置不可见后，学生将无法查看试卷内容，仅可查看答题结果。"), (0, _defineProperty3.default)(_teacher, "changeForNot1", "更改截止时间后，仅对未交卷学生生效。"), (0, _defineProperty3.default)(_teacher, "changeForNot", "更改完成截止时间后，仅对未完成学习的学生生效。"), (0, _defineProperty3.default)(_teacher, "addBlack", "加入黑名单（加入黑名单后该学生将无法再加入班级）"), (0, _defineProperty3.default)(_teacher, "blackList", "黑名单"), (0, _defineProperty3.default)(_teacher, "haimeiyouStu", "还没有学生<br/>赶紧邀请学生加入班级～"), (0, _defineProperty3.default)(_teacher, "checkblackList", "查看黑名单"), (0, _defineProperty3.default)(_teacher, "remove", "移出"), (0, _defineProperty3.default)(_teacher, "confirmRemove", "确定将学生移出黑名单吗？"), (0, _defineProperty3.default)(_teacher, "removeTips", "移出后，学生可通过扫码、输入课堂暗号等方式加入班级"), (0, _defineProperty3.default)(_teacher, "quanweida", "还没有学生作答"), (0, _defineProperty3.default)(_teacher, "quanyida", "您的学生已全部作答"), (0, _defineProperty3.default)(_teacher, "newtotalscore", "本题总分{total}分"), (0, _defineProperty3.default)(_teacher, "hupingtotalscore", "本题总分{total}分，互评占比{groupReviewProportion}%，教师占比{teacherProportion}%"), (0, _defineProperty3.default)(_teacher, "finalscore", "最终得分"), (0, _defineProperty3.default)(_teacher, "teachergrading", "教师评分"), (0, _defineProperty3.default)(_teacher, "peergrading", "互评得分"), (0, _defineProperty3.default)(_teacher, "totalmembers", "共{num}人"), (0, _defineProperty3.default)(_teacher, "noComment", "暂无评语"), (0, _defineProperty3.default)(_teacher, "newpoint", "分"), (0, _defineProperty3.default)(_teacher, "fulltext", "全文"), (0, _defineProperty3.default)(_teacher, "fold", "收起"), (0, _defineProperty3.default)(_teacher, "correctcount", "正确人数"), (0, _defineProperty3.default)(_teacher, "sendtokfail", "个班级未送达"), (0, _defineProperty3.default)(_teacher, "sentokthree", "未送达班级："), (0, _defineProperty3.default)(_teacher, "touchtoresend", "（可点击班级右侧按钮重新发送）"), (0, _defineProperty3.default)(_teacher, "touchtoresend2", "（非受限班级可点击右侧按钮重新发送）"), (0, _defineProperty3.default)(_teacher, "showquestion", "查看题目"), (0, _defineProperty3.default)(_teacher, "tocorrect", "确定修改为正确吗？"), (0, _defineProperty3.default)(_teacher, "addcorrectanswer", "添加为正确答案（同时重新批改其他同学的作答）"), (0, _defineProperty3.default)(_teacher, "regradeanswers", "选中学生可手动批改填空题"), (0, _defineProperty3.default)(_teacher, "submitone2", "提交答案"), (0, _defineProperty3.default)(_teacher, "notallow", "本题答案允许乱序，暂无法直接添加为正确答案"), (0, _defineProperty3.default)(_teacher, "nonickname", "未设置昵称"), (0, _defineProperty3.default)(_teacher, "tips2", "提示：延长考试截止时间，仅对未交卷的学生有效。对自动交卷或被系统自动收卷的学生不生效。"), (0, _defineProperty3.default)(_teacher, "watchedreplay", "观看回放人数"), (0, _defineProperty3.default)(_teacher, "replayed", "观看回放"), (0, _defineProperty3.default)(_teacher, "signinempty", "没有学生签到"), (0, _defineProperty3.default)(_teacher, "unsignempty", "没有学生未签到"), (0, _defineProperty3.default)(_teacher, "watchempty", "没有学生观看了回放"), (0, _defineProperty3.default)(_teacher, "xingmingzimu", "按姓名首字母"), (0, _defineProperty3.default)(_teacher, "xuehaoxiaodaoda", "学号从小到大"), (0, _defineProperty3.default)(_teacher, "xuehaodadaoxiao", "学号从大到小"), (0, _defineProperty3.default)(_teacher, "meiyoushuju", "没有数据了"), (0, _defineProperty3.default)(_teacher, "clickloadmore", "点击加载更多"), (0, _defineProperty3.default)(_teacher, "live", "直播数据"), (0, _defineProperty3.default)(_teacher, "livemin", "分钟"), (0, _defineProperty3.default)(_teacher, "totalduration", "总在线时长："), (0, _defineProperty3.default)(_teacher, "liveduration", "时长："), (0, _defineProperty3.default)(_teacher, "online", "在线："), (0, _defineProperty3.default)(_teacher, "livetip", "总在线时长指本次授课中所有加入互动直播的用户在线时长之和（包括老师），雨课堂以此总时长计算消耗的流量。"), (0, _defineProperty3.default)(_teacher, "hideproblemtips", "超过3000人班级暂不展示习题数据。"), (0, _defineProperty3.default)(_teacher, "txmeetingsuccess", "腾讯会议回放已保存到雨课堂"), (0, _defineProperty3.default)(_teacher, "txmeetingfail", "腾讯会议回放未保存到雨课堂"), (0, _defineProperty3.default)(_teacher, "txmeetingcannotdel", "回放视频未保存到雨课堂，在腾讯会议中删除将无法恢复，请谨慎删除"), (0, _defineProperty3.default)(_teacher, "txmeetingcandel", "回放视频已保存到雨课堂，在腾讯会议中删除不影响回放的正常观看"), _teacher),
	    //群发公告
	    pubnotice: (_pubnotice = {
	        'successTop': '置顶成功',
	        'successCancle': '取消置顶成功',
	        'failTop': '置顶失败',
	        'failCancle': '取消置顶失败',
	        "showall": "显示全文",
	        "totalattachment": "共有{length}个附件",
	        "downloadfromyktweb": "可在网页版{url}下载",
	        "delannoucement": "删除本次公告",
	        "teachernameann": "{teacherName}老师发布的公告",
	        "ykt": "雨课堂",
	        "noundocfm": "删除后将不可恢复",
	        "confirmdel": "是否确认删除此公告？",
	        "fileunablepreview": "该格式文件无法预览",
	        "readynum": "{ready_num}人已读",
	
	        'commenttitle': '确认删除此评论？',
	        "replytitle": '确认删除此回复？',
	        "delreplyreplyoptions": '删除后不可恢复',
	        "delcommentoptions": '删除后将不可恢复，评论下的回复也将一并删除。',
	
	        "announcementlimit": "每班每日可发送2条公告，",
	        "announcementquota": "你还可以发送",
	        "msunit": "条",
	        "titlerequired": "标题(必填)",
	        "selectTime": "选择发送时间",
	        "sendannouncementtips": "你可以直接输入文字向学生发布公告，也可以通过分享链接的方式，向学生推荐网页。",
	        "cancel": "取消",
	        "send": "发送",
	        "sendto": "发送至：",
	        "title": "标题",
	        "backtoedit": "返回编辑",
	        "cfmtosend": "确定发送",
	        "sendok": "发送成功",
	        "notempty": '公告正文不能为空',
	        "gotit": "我知道了",
	        "sendoktoclass": "已成功发送给以下班级：",
	        "publishannouncement": "发布公告",
	        "delpiccfm": "确定删除图片",
	        "exiteditcfm": "是否放弃本次编辑?",
	        "timerequred": "发布时间必须填写且不能早于当前时间",
	        "unabletosendannouncement": "您还可以发送0条",
	        "titlenullwarning": "标题不能为空",
	        "announcementnullwarning": "公告不能为空",
	        "golimit": "该班级已经超过发送次数，不能发送。",
	
	        "allclass": "{course_name}的所有班级",
	        "entertitle": "请录入通知标题",
	        "entercontent": "请录入通知内容",
	        "selectclassplease": "请选择班级",
	        "faileduploadnotsend": "上传失败的附件将不会被发送",
	
	        "selectclasstopublish": "选择发送班级",
	        "selectedclass": "已选班级"
	    }, (0, _defineProperty3.default)(_pubnotice, "cancel", "取消"), (0, _defineProperty3.default)(_pubnotice, "announcementok", "确定"), (0, _defineProperty3.default)(_pubnotice, "maxfilesize", "可上传10个附件，单个文件不超过30M，累计不超过100M"), (0, _defineProperty3.default)(_pubnotice, "attachnumberselected", "已选择{ilen}个附件"), (0, _defineProperty3.default)(_pubnotice, "fileselectleft", "还可选择{ilen}个文件"), (0, _defineProperty3.default)(_pubnotice, "addattachedment", "添加附件"), (0, _defineProperty3.default)(_pubnotice, "del", "删除"), (0, _defineProperty3.default)(_pubnotice, "reupload", "重新上传"), (0, _defineProperty3.default)(_pubnotice, "uploadfailed", "上传失败"), (0, _defineProperty3.default)(_pubnotice, "delundocfm", "删除后将不可恢复，是否确认删除？"), (0, _defineProperty3.default)(_pubnotice, "maxuploadfilenumber", "一次最多可上传{max_fileCount}个文件"), (0, _defineProperty3.default)(_pubnotice, "totaluploadmaxsize", "累计上传附件不超过{totalFileSize}M"), (0, _defineProperty3.default)(_pubnotice, "waiting", "等待..."), (0, _defineProperty3.default)(_pubnotice, "uploadcompleted", "上传完成"), (0, _defineProperty3.default)(_pubnotice, "filesizeexceedlimit", "文件大小超过限制"), (0, _defineProperty3.default)(_pubnotice, "fileformatlimit", "文件格式不符合要求"), (0, _defineProperty3.default)(_pubnotice, "sendtofollowingclass", "发送到以下班级："), (0, _defineProperty3.default)(_pubnotice, "edit", "编辑"), (0, _defineProperty3.default)(_pubnotice, "maxcharnum_tip", "您已输入{ilen}个字符，超过最大10000字符限制<br/>请适当缩减公告内容"), (0, _defineProperty3.default)(_pubnotice, "cannotoplink", "无法打开超链接"), (0, _defineProperty3.default)(_pubnotice, "miniprogramtip", "小程序无法打开外部链接，如公告中含有超链接，请您在雨课堂公众号中查看"), (0, _defineProperty3.default)(_pubnotice, "miniprogramhelp", "如何操作"), (0, _defineProperty3.default)(_pubnotice, "clickShowClasses_1", "点击"), (0, _defineProperty3.default)(_pubnotice, "clickShowClasses_2", "可展开该课程的全部班级"), (0, _defineProperty3.default)(_pubnotice, "noRight", "你没有权限向此班级发布公告"), (0, _defineProperty3.default)(_pubnotice, "webuptips", "温馨提示：Web端发公告可以上传附件噢~"), (0, _defineProperty3.default)(_pubnotice, "topNotice", '置顶本公告'), (0, _defineProperty3.default)(_pubnotice, 'cancleNotice', '取消置顶'), (0, _defineProperty3.default)(_pubnotice, "cancelTop", '取消置顶'), (0, _defineProperty3.default)(_pubnotice, "sendclass", "发送班级"), (0, _defineProperty3.default)(_pubnotice, "addclass", "添加班级"), (0, _defineProperty3.default)(_pubnotice, "noticetitle", "公告标题"), (0, _defineProperty3.default)(_pubnotice, "titleplaceholder", "请输入通知标题"), (0, _defineProperty3.default)(_pubnotice, "linktips", "提示：若手动输入链接地址，请在链接地址前后均添加空格或回车以确认。"), (0, _defineProperty3.default)(_pubnotice, "previewsend", "预览并发送"), (0, _defineProperty3.default)(_pubnotice, "createnew", "创建群发公告"), (0, _defineProperty3.default)(_pubnotice, "archiveclass", "有班级已归档，需要发送公告请先将其移出归档"), _pubnotice),
	
	    // 图片资源
	    img: {
	        empty_colletion: "https://qn-sfe.yuketang.cn/o_1c2tq4l86182t1r0jv3dvgb1c99e.png",
	        empty_class: "https://qn-sfe.yuketang.cn/o_1c2vgq3pi1299dfp1g1imd5tjmj.png",
	        empty_student_blank: "https://qn-sfe.yuketang.cn/o_1c2vgqthm1imkk9rakp9h91pvco.png",
	        empty_score_detail: "https://qn-sfe.yuketang.cn/o_1c2vi8omc1m8nd2d1h0mqfjfsjt.png",
	        empty_task: "https://qn-sfe.yuketang.cn/o_1c2vis7le1mdm3nessckvl1g08o.png",
	        empty_msg: "https://qn-sfe.yuketang.cn/o_1c2vjnbud9u51kd61vqs18p2stst.png",
	        notice_delete: "https://qn-sfe.yuketang.cn/o_1c2vjvlnktmv192vhlm1mnhi0q12.png",
	        notice_forbidden: "https://qn-sfe.yuketang.cn/o_1c2vjvqn8dnk1cu8ag0rc87op17.png",
	        notice_alllook: "https://qn-sfe.yuketang.cn/o_1c2vv7qcv16thqlq1q1h1qkb1dcka.png",
	        notice_allnotsee: "https://qn-sfe.yuketang.cn/o_1c2vv7qcv8os14r1jmf1b6s1455b.png",
	        tougao_student: "https://qn-sfe.yuketang.cn/o_1c2vthnov1a761h2acpd29t1oqmf.png",
	        tougao_teacher: "https://qn-sfe.yuketang.cn/o_1c2vthnov10cck5t1cil16upbohg.png",
	        empty_teach_log: "https://qn-sfe.yuketang.cn/o_1bkduf96pgadvdbr7m1afi8v09.png",
	        empty_store: "https://qn-sfe.yuketang.cn/o_1c2vui47hujgkrvf9e1tjssb9e.png",
	        empty_bill: "https://qn-sfe.yuketang.cn/bill_empty.png",
	        empty_paper: "https://qn-sfe.yuketang.cn/o_1c3009o01vqnbqnh5h1d5a1ndo9.png",
	        learning_complete: "https://qn-sfe.yuketang.cn/o_1c300rq1h1fhj1rki1ppt1smdjb19.png",
	        learning_uncomplete: "https://qn-sfe.yuketang.cn/o_1c300s1if1j7k5cb1lsm1g3p64ke.png",
	        teacher_allsign: "https://qn-sfe.yuketang.cn/o_1c303acid1q1rpcr1bj21asjnqv12.png",
	        teacher_allnotsign: "https://qn-sfe.yuketang.cn/o_1c303a45v1qiem573qumkj8hot.png",
	        gkk_log_empty: "https://qn-sfe.yuketang.cn/o_1c30503dk1utp9pv8hrdtki1k1c.png",
	        fans_empty: "https://qn-sfe.yuketang.cn/o_1c5ku05jr1tccqc2191bq0nunfe.png",
	        batch_log: "https://qn-sfe.yuketang.cn/o_1emtrsdqrvvi1u5c16mov1m1s1ja.5x.png",
	        noupload_img: "https://qn-sfe.yuketang.cn/o_1fu69dk831e8mpgbu0j4251l4kf.png",
	        noupload_img_shu: "https://qn-sfe.yuketang.cn/o_1fu69dk831d48m061lttmh2e7rd.png"
	    },
	
	    // 错误提示信息
	    error: {
	        "contentdel": "此内容已被老师删除。",
	        "checkfromactivity": "请从班级学习日志中查看课件。",
	        "noauthslides": "啊噢，你没有权限查看此课件。",
	        "classdel": "您已删除此班级。",
	        "nocontent": "你想访问的内容不存在",
	        "cannotlearnclassend": "当前课程已结课 无法继续学习啦"
	    },
	    //课件、试卷文件夹管理
	    my_folder_manage: {
	        'notempty': '名称不可为空',
	        "myupload": "我上传的",
	        "myreceived": "我收到的",
	        "chosequiz": "选择试卷",
	        "singlechose": "单选",
	        "choseslide": "选择课件",
	        "noslide": "还没有上传的课件",
	        "tryuploadslide": "尝试从电脑端上传课件吧",
	        "nouploadquiz": "还没有上传的试卷",
	        "tryuploadquiz": "尝试从电脑端上传试卷吧",
	        "seehelp": "戳这里看帮助",
	        "createOK": "创建成功",
	        "updateOK": "修改成功",
	        "noslidereceived": "还没有收到的课件",
	        "inyourclass": "你所在班级里的",
	        "inyourclass_quiz": "你所在班级里的",
	        "mobileslide": "手机课件",
	        "and": "和",
	        "lessonslide": "课堂授课的课件",
	        "comehere": "都会出现在这里",
	        "noquiz": "还没有收到的试卷",
	        "mobilequiz": "手机试卷",
	        "lessonquiz": "课堂授课的试卷",
	
	        "newfolder": "新建文件夹",
	        "newfolderlimit": "新建文件夹（64字以内）",
	        "movefolder": "移动到文件夹",
	        "deletequiz": "删除试卷",
	        "deleteslide": "删除课件",
	        "management": "管理",
	        "foldername": "请输入文件夹名称",
	        "complete": "完成",
	        "inputlenlimited": "名称限制12个汉字，请重新输入",
	
	        "folderempty": "这个文件夹是空的",
	        "folderempty1": "你可以将课件库的课件移动到文件夹里以方便管理",
	        "folderempty1_quiz": "你可以将试卷库的试卷移动到文件夹里以方便管理",
	        "renamefloder": "重命名文件夹",
	        "renamefloderlimit": "重命名文件夹（64字以内）",
	        "renamefile": "重命名（64字以内）",
	        "filename": "请输入...",
	        "moveoutquiz": "移出试卷到",
	        "moveoutslide": "移出课件到",
	        "deletefolder": "删除文件夹",
	        "deletefoldertip": "删除文件夹，将同时删除文件夹内的所有课件。",
	        "tips": "提示",
	        "deleteok": "删除成功",
	
	        "chosefolder": "选择要移动到的文件夹",
	        "mycollections": "我的课件库",
	        "rootdir": "根目录",
	        "move": "移动",
	        "choseonefolder": "请选择一个文件夹",
	        "moveok": "移动成功",
	
	        "chosealready": "已选: ",
	        "nextstep": "下一步",
	        "deleteslidetip": "删除已选{selectCount}个课件？",
	        "deletequiztip": "删除已选{selectCount}个试卷？",
	        "deleteslidesingletip": "是否删除已选课件？",
	        "deletequizsingletip": "是否删除已选试卷？",
	        "swipLeftDelRename": "左滑可删除课件或重命名课件名称",
	        "swipLeftDelRename1": "左滑可删除试卷或重命名试卷名称",
	        "rename": "修改名称",
	        "toolong": "字数超长，保存失败",
	        "delete": "删除",
	        "random": "随机",
	        "updateApp": "更新APP版本后可参加在线监考",
	        "dati": "大题",
	        "zuhe": "组合卷",
	        "paperPublishTips": "组合卷设置有误，无法发布"
	    },
	
	    // 习题集
	    problemset: {
	        "myquestions": "我的习题集",
	        "wrongquestionno": "错题数",
	        "totalquestionno": "总题数",
	        "errorrate": "错误率",
	        "questionupdatetime": "更新时间",
	        "total": "全部",
	        "wrongquestion": "错题",
	        "markquestions": "加星题",
	        // "tests": "试卷",
	        // "slides": "课件",
	        "viewhistory": "继续上次浏览",
	        "noquestion": "你还没有习题",
	        "nowrongquestion": "你还没有错题",
	        "nomarkquestion": "你还没有加星题",
	        "questionno": "第{index}题",
	        "mark": "加星",
	        "viewdetails": "查看详情",
	        "takenotes": "记笔记",
	        "redo": "重新做",
	        "goanswering": "去作答",
	        "answerdetails": "答题详情",
	        "correctanswer": "正确答案",
	        "answerforfirsttime": "您首次做题的答案",
	        "correct": "正确",
	        "wrong": "错误",
	        "answernotreleased": "老师暂未公布答案",
	        "notanswered": "未作答",
	        "score": "得分",
	        "point": "本题{count}分",
	        "specificstudentscore": "{count}分",
	        "comment": "评语",
	        "answerkey": "答案解析",
	        "myanswer": "我的答案",
	        "redotips": '"重新做"只用于帮您自测，新的结果<br/>不会提交给老师。',
	        "gotit": "知道了",
	        "comfirm": "确定",
	        "answercorrect": "回答正确",
	        "answerwrong": "回答错误",
	        "note": "笔记",
	        "takenotestips": "您可以在这里记录考点及心得，内容仅自己可见",
	        "save": "保存",
	        "edit": "编辑",
	        "checknotes": "看笔记",
	        "nosetscore": "老师暂未打分",
	        "datacollecting": "数据正在收集中...",
	        "noqustions": "你还没有习题",
	        "groupanswered": "小组作答："
	    },
	
	    plupload: {
	        'Select_files': '选择文件',
	        'Add_files_to_queue': '添加文件到上传队列，然后点击启动按钮。',
	        'Filename': '文件名',
	        'Status': '状态',
	        'Size': '大小',
	        'Add_Files': '添加文件',
	        'Stop_Upload': '停止上传',
	        'Start_Upload': '开始上传',
	        'Add_files': '添加文件',
	        'Add_files2': '添加文件。',
	        'Stop_current_upload': '停止当前上传',
	        'Start_uploading_queue': '开始上传队列',
	        'Stop_upload': '停止上传',
	        'Start_upload': '开始上传',
	        'Uploaded_files': '已经上传 %d/%d 个文件',
	        'N_A': 'N/A',
	        'Drag_files_here': '拖动文件到这里',
	        'File_extension_error': '文件格式不符合要求',
	        'File_size_error': '文件大小超过限制',
	        'File_count_error': '文件数量错误',
	        'Init_error': '初始化错误',
	        'HTTP_Error': '网络链接有误',
	        'Security_error': '安全错误',
	        'Generic_error': '常见错误',
	        'IO_error': 'IO错误',
	        'File_s': '文件百分比 : %s',
	        'Close': '关闭',
	        'files_queued': '%d 个队列中',
	        'Using_runtime: ': '使用运行时: ',
	        'File_size_max_file_size': '文件名: %f, 大小: %s, 文件最大值: %m',
	        'Upload_element_accepts': '上传文件只接受%d，其他的文件被忽略',
	        'Upload_URL_might': '上传文件有错误或者文件不存在',
	        'Error_File_too_large': '文件大小超过限制',
	        'Error_Invalid_file_extension': '文件格式不符合要求'
	    },
	
	    // 讨论区
	    discusstion: {
	        'Me': '我',
	        'releaseSuccess': '发布成功',
	        'touchtoresend': '发布失败',
	        "releaseFaildclass": "发布失败班级：",
	        "releasefinish": "发布完成",
	        "sendsuc": "已成功发送{succount}/{total}个班级",
	        "comment": "评论",
	        "digg": "赞",
	        "commentplaceholder": "写评论…",
	        "send": "发送",
	        "reply": "回复",
	        "edit": "编辑",
	        "delete": "删除",
	        "from": "来自 {name}的课件",
	        "delconfirm": "确定要删除吗？",
	        "expand": "展开全部",
	        'unexpand': '收起',
	        "replyallcount": "查看共{count}条回复",
	        "loadmore": "加载更多",
	        "commentsuccess": "评论成功",
	        "replysuccess": "回复成功",
	        "replycomment": "回复评论…",
	        "backtopic": "查看主贴",
	        "youropinion": "发表你的观点",
	        "viewimage": "查看图片",
	        "imagelimit": "图片不能超过{count}张",
	
	        //列表页和编辑页
	        "loaddata": "数据加载中...",
	        "publishtime": "发布于",
	        "empty_tip": "讨论区空空的",
	        "empty_tip2": "做第一个发帖的人吧~",
	        "discussion": "课程讨论",
	        "new_idea": "写下这一刻的想法...",
	        "publishbtn": "发表",
	        "new_discussion": "发起讨论",
	        "pic_max": "图片不能超过九张",
	        "waitloading": "等待图片上传",
	        "deletedtip": "删除后该评论的回复和赞将一并被删除",
	        "onlypic": "[图片]",
	        'loading': '加载中...',
	        end: '没有更多了'
	    },
	
	    //新教学日志学习日志
	    newlogs: (_newlogs = {
	        "top": '置顶',
	        "transcript": "成绩单",
	        "student": "成员管理",
	        "discussion": "讨论区",
	        "task": "任务",
	        "setting": "设置",
	        "xiti": "习题集",
	        "classmate": "成员",
	        "teachinglog": "教学日志",
	        "learinglog": "学习日志",
	        "publish": "发布",
	        "all": "全部",
	        "lesson": "课堂",
	        "slide": "课件",
	        "quiz": "试卷",
	        "notice": "公告",
	        "loading": "加载中...",
	        "clicktopublish_t": "点击右上方发布按钮发布教学活动",
	        "clicktopublish_s": "老师还没有发布教学活动",
	        "clicktopublish_exp": "目前没有已发布的实验",
	        "publishslide": "发布课件",
	        "publishquiz": "发布试卷",
	        "publishnotice": "发布公告",
	        "term": "学期：2017-2018学年度春季学期（第二学期）",
	        "onlessontip": "你有{length}个课正在上课",
	        "appointment": "预约",
	        "appointmenttip": "您有{length}个预约发布",
	        'topAnnouncement': '你有{length}条置顶公告',
	        'unreadByTopNotice': '其中{length}条未读',
	        "unread": "未读",
	        "courseedittitle": "编辑标题",
	        "delete": "删除",
	        "week": "星期",
	        "month": "月",
	        "day": "日",
	        "onlesson": "正在上课",
	        "publishaftermin": "约{minute}分钟后发布",
	        "publishafterhour": "约{hour}小时后发布",
	        "publishafterday": "约{day}小时后发布"
	    }, (0, _defineProperty3.default)(_newlogs, "publishafterhour", "发送失败"), (0, _defineProperty3.default)(_newlogs, "experiment", "实验"), (0, _defineProperty3.default)(_newlogs, "entertitle", "输入新的标题~"), (0, _defineProperty3.default)(_newlogs, "conotedit", "协同教师无法编辑标题"), (0, _defineProperty3.default)(_newlogs, "conotdel", "协同教师无法删除此教学活动"), (0, _defineProperty3.default)(_newlogs, "coursedelpubish", "删除后，该教学活动所有数据都将被删除且不可恢复"), (0, _defineProperty3.default)(_newlogs, "confirmdelete", "确认删除该教学活动吗？"), (0, _defineProperty3.default)(_newlogs, "exp", "实验"), (0, _defineProperty3.default)(_newlogs, "syllabus", "课简介"), (0, _defineProperty3.default)(_newlogs, "group", "分组"), (0, _defineProperty3.default)(_newlogs, "livereplay", "直播回放"), (0, _defineProperty3.default)(_newlogs, "exam", "考试"), (0, _defineProperty3.default)(_newlogs, "video", "视频"), (0, _defineProperty3.default)(_newlogs, "audio", "音频"), (0, _defineProperty3.default)(_newlogs, "discuss", "讨论"), (0, _defineProperty3.default)(_newlogs, "article", "图文"), (0, _defineProperty3.default)(_newlogs, "homework", "作业"), (0, _defineProperty3.default)(_newlogs, "online", "线上学习"), (0, _defineProperty3.default)(_newlogs, "live", "直播"), (0, _defineProperty3.default)(_newlogs, "notallowededit", "暂不支持修改考试标题~"), (0, _defineProperty3.default)(_newlogs, "studydeadline", "请在「{deadline}」前完成学习"), (0, _defineProperty3.default)(_newlogs, 'integrityagreement', "诚信协议"), (0, _defineProperty3.default)(_newlogs, "learnagreenment", '学习承诺书'), (0, _defineProperty3.default)(_newlogs, "agreen", '同意'), (0, _defineProperty3.default)(_newlogs, 'cancel', '取消'), (0, _defineProperty3.default)(_newlogs, "logs_start_time", "开课时间："), (0, _defineProperty3.default)(_newlogs, "logs_end_time", "无结课时间"), (0, _defineProperty3.default)(_newlogs, "logs_to", "至"), _newlogs),
	    //协同教师管理
	    manage_coteacher: {
	        "sendletter_tip": "可点击头像查看个人资料并发送私信",
	        "promotebtn": "提拔",
	        "invitebtn": "邀请",
	        "managemenu": "管理",
	        "addstudent": "邀请学生",
	        "studentlimit": "(若班级人数已达系统上限{count}人，则学生无法加入班级)",
	        "delstudent": "删除学生",
	        "addcoteacher": "提拔协同教师",
	        "delcoteacher": "移除协同教师",
	        "delcoteacher1": "取消协同教师",
	        "delcoteachertip": "协同教师被移除后，将恢复为学生身份",
	        "coteachertit": "协同教师说明",
	        "coteacherintor1": "1、协同教师是教师身份，可发布教学任务和授课，同时可添加或删除班级中学生。",
	        "coteacherintor2": "2、协同教师可以以学生身份进入到课堂中，但无法作答课堂习题和试卷。",
	        "coteacherintor3": "3、协同教师不能提拔新的协同教师，也无法在课程下创建新的班级，只可删除自己发起的教学活动。",
	        "nocoteacher": "您当前未添加协同教师",
	        "noStudent": "您当前未添加学生",
	        "cancel_check": "取消选中",
	        "confirmdelete": "确认删除该教学活动吗？",
	        "exp": "实验"
	    },
	    setcourse: (_setcourse = {
	        "liveStatus0": '未开通',
	        "liveStatus1": '审核中',
	        "liveStatus2": '申请失败',
	        "liveStatus3": '已开通',
	        "livePermission": '直播权限',
	        "fullname": "课程全称",
	        "shortname": "课程简称",
	        "optional": "选填",
	        "shortname_tip": "课程全称过长，建议填写简称，将在必要的地方显示。",
	        "coursetype": "课程类型",
	        "required": "必填",
	        "k12": "中小学",
	        "university": "高校",
	        "other": "其他",
	        "next": "下一步",
	        "shortname_placeholder": "请输入简称 最多6个字",
	        "full_tip": "全称",
	        "edit": "编辑",
	        "classname": "班级名称",
	        "semester": "开学学期",
	        "join_limit": "加入限制",
	        "limit_tip1": "开启后学生将不能通过扫码或暗号加入此班级",
	        "limit_tip2": "您可以在教学日志页，通过设置，更改此限制",
	        "complete": "完成",
	        "editable": "可编辑",
	        "pro_coursetip": "专业版课程不可修改课程全称和课程类型",
	
	        "noset": "未设置"
	    }, (0, _defineProperty3.default)(_setcourse, "k12", "中小学"), (0, _defineProperty3.default)(_setcourse, "university", "高校"), (0, _defineProperty3.default)(_setcourse, "others", "其他"), (0, _defineProperty3.default)(_setcourse, "semester1", "第一学期"), (0, _defineProperty3.default)(_setcourse, "semester2", "第二学期"), (0, _defineProperty3.default)(_setcourse, "spring", "春"), (0, _defineProperty3.default)(_setcourse, "summer", "夏"), (0, _defineProperty3.default)(_setcourse, "fall", "秋"), (0, _defineProperty3.default)(_setcourse, "winter", "冬"), (0, _defineProperty3.default)(_setcourse, "pre", '上一步'), (0, _defineProperty3.default)(_setcourse, "courseInfo", '设置开课学期前需先设置开课类型'), (0, _defineProperty3.default)(_setcourse, "fallterm", "{year}学年度秋季学期"), (0, _defineProperty3.default)(_setcourse, "springterm", "{year}学年度春季学期"), (0, _defineProperty3.default)(_setcourse, "summerterm", "{year}学年度夏季学期"), (0, _defineProperty3.default)(_setcourse, "clickhere", "点击此处"), (0, _defineProperty3.default)(_setcourse, "viptips", "申请会员，审核通过后所有班级都拥有音频和视频直播权限。"), (0, _defineProperty3.default)(_setcourse, "studentlimits", "班级人数已达上限{count}人，开启加入限制"), (0, _defineProperty3.default)(_setcourse, "limitstoast", "班级人数已达上限{count}人无法关闭限制"), (0, _defineProperty3.default)(_setcourse, "classfeatures", "班级开放功能"), (0, _defineProperty3.default)(_setcourse, "unavailablefeatures", "学生端将不展示已被关闭的功能"), (0, _defineProperty3.default)(_setcourse, "notopenfforum", "学校统一关闭了讨论区，您暂时无法开启"), (0, _defineProperty3.default)(_setcourse, "notopenall", "班级人数已达上限，您无法开启功能"), (0, _defineProperty3.default)(_setcourse, "allnotjoin", "都不能加入"), (0, _defineProperty3.default)(_setcourse, "nojoinafterend", "课堂结束后不能加入"), (0, _defineProperty3.default)(_setcourse, "outsidetheschoolcannotjoin", "校外人员不能加入"), (0, _defineProperty3.default)(_setcourse, "unselectedstudentsjoinautomatic", "未选课学生加入自动选课"), (0, _defineProperty3.default)(_setcourse, "studentsnotsupportedtoselect", "不支持学生自主选课"), (0, _defineProperty3.default)(_setcourse, "studyunitlimit", "学习单元查看限制"), (0, _defineProperty3.default)(_setcourse, "canstudyafterclass", "结课后学习单元支持学生查看"), (0, _defineProperty3.default)(_setcourse, "cannotstudyafterclass", "结课后学习单元不支持学生查看"), _setcourse),
	    letter: {
	        "role": "身份",
	        "school": "院校",
	        "studentid": "学号",
	        "organ": "组织机构",
	        "email": "邮箱",
	        "chat": "私信戳ta",
	        "saysomething": "说点什么~",
	        "bindingtip": "仅可对已绑定用户发送私信"
	    },
	    // 互评
	    grading: {
	        "scoreofpeergrading": "互评分数占比",
	        "scoreofteachergrading": "教师分数占比",
	        "pointsofgrading": "评分要点",
	        "textareaplaceholder": "请输入您的参考答案或评分要点，供学生参考",
	        "hupingguize": "互评规则",
	        "rule1": "<i>＊</i>已提交答案的各组才能参加互评，每个组将收到<span class='f15'>一份</span>非本组的作答内容",
	        "rule2": "各组之间相互匿名",
	        "rule3": "教师可随时修改互评占比或者直接修改总得分",
	        "faqihuping": "发起互评",
	        "cancel": "取消",
	        "save": "保存",
	        "launchedgrading": "Hi，老师发起了互评",
	        "pointsgrading": "评分要点",
	        "grade": "打分",
	        "answer": "答案",
	        "gradingscore": "互评得分：{score}分",
	        "gradingtotalscore": "请输入互评分数（满分{score}分）",
	        "notice": "注意",
	        "noticecontent": "本题以小组形式批改，每人只有一次评分机会<br>成绩以最后一次提交为主",
	        "close": "关闭",
	        "gradedalready": "已有人批改",
	        "gradedoverwrite": "提交后将会覆盖之前的评分",
	        "pleasescore": "请打分",
	        "updateOK": "修改成功"
	    },
	    // 开放平台
	    platform: {
	        "moretoweb": "更多批改请使用雨课堂网页版",
	        "mustpoint": "必填 本题{count}分"
	    },
	    // 手机号绑定
	    bindmobile: {
	        "bindPhone": "绑定手机",
	        "lawtips": "根据法律要求，互联网账号需实名认证，为保障您的账户安全及正常使用，请完成手机号绑定。",
	        "extractminiprogram": "长按识别小程序码绑定手机",
	        "closewindow": "绑定完成后，请关闭此窗口"
	    },
	    //身份认证
	    identifyAudit: {
	        'infoMsg': '请您如实准确完成身份认证，否则将会驳回',
	        'realName': '真实姓名',
	        'placeholder1': '请输入您的真实姓名',
	        'placeholder2': '绑定手机号',
	        'placeholder3': '未验证',
	        "hasBind": "已绑定",
	        'phoneNumber': '手机号',
	        'idCard': '上传您的二代身份证照片',
	        'workCard': '上传您的工作证',
	        'idCardDetail': '点击上传图标后请仔细阅读温馨提示后按要求上传照片',
	        'emailDetail': '如果您是高校教师，建议填写学校邮箱并进行邮箱验证，会加速您的身份认证哦~',
	        'email': '学校邮箱验证(选填)',
	        'btn': '提交',
	        'clickExplain1': "点击拍摄/上传人像面",
	        'clickExplain2': "点击拍摄/上传国徽面",
	        'clickExplain3': "点击拍摄/上传工作证",
	        'identifyAudit': '身份认证',
	        'warmInfo': "温馨提示",
	        'warmInfoDetail': "请参考下图按照正确的方式上传身份证件，图片大小不大于10MB，确保仅采集身份证本身的信息。",
	        'uploadImage': "上传照片",
	        "requestError": "请求失败，请刷新后重试",
	        'backhomepage': '回到课程首页'
	    },
	    mystore: {
	        'tsinghuabindtitle': '欢迎使用「荷塘·雨课堂」',
	        'tsinghuacontent': '使用须完成清华大学身份验证',
	        'bind': '身份绑定'
	    },
	    //直播审核
	    liveAudit: {
	        "liveApply": '直播申请',
	        'rowLabel1': '姓名',
	        'rowLabel2': '课程',
	        'rowLabel3': '班级',
	        'applyReason': '申请理由:',
	        'btn1': '提交申请',
	        'btn2': '返回',
	        'fail': '失败',
	        'success': '提交成功',
	        'info': '审核将在自提交之日起，7个工作日内完成',
	        'tip2': '您的实名认证已成功提交，我们将会在7个工作日内对您提交的信息进行审核，届时您将在微信公众号中收到审核通知，感谢您的使用！',
	        'placeholder1': '请您详细描述申请理由，包括但不限于：直播面向的用户、直播内容、预计直播的次数等。',
	        'tip': '特别说明：用户使用直播服务必须遵守国家有关法律和政策等，维护国家利益，保护国家安全，对于用户违法或违反直播初衷的使用(包括但不限于言论发表、传送等)而引起的一切责任，由用户负全部责任。',
	        'viptips': '特别说明：根据国家工信部对于网络直播实名制的规定，用户申请直播（会员功能）时，需提供手机号、本人身份证等身份关联认证信息，以确保对用户进行真实身份核验。您提供的个人信息将受到严格保护，仅用于身份验证，未经本人许可不会用于其他用途。'
	    },
	
	    // 给学生增加备注需求增加
	    behavior: {
	        "bonuspoint": "课堂加分",
	        "addpoints": "+{count}分",
	        "howtoaddpoints": "如何加分？",
	        "backtoclass": "继续上课",
	        "remarks": "加备注",
	        "entername": "输入学生姓名",
	        "points": "分",
	        "changethestate1": "修改为已出勤",
	        "changethestate2": "修改为未出勤",
	        "nobonuspoint": "暂无加分",
	        "tag": "标签",
	        "save": "保存",
	        "edittag": "编辑标签",
	        "addtag": "添加标签",
	        "afterclasstips": "此备注课下可在课后小结中查看",
	        "entercontent": "请输入标签内容",
	        "noquizzes": "本节课没有发布习题",
	        "noeligiblestudents": "没有符合的学生",
	        "performance": "课堂表现",
	        "present": "已出勤",
	        "absent": "未出勤",
	        "yiqiandao": "已签到",
	        "weiqiandao": "未签到",
	        "changetosignin": "修改为已签到",
	        "changetonotsignin": "修改为未签到",
	        "bonus": "加分",
	        "pleaseenterinteger": "请输入整数",
	        "systemtag": "系统标签不可编辑",
	        "tagexists": "已存在相同标签",
	        "edit": "编辑",
	        "other": "其他",
	        "qr": "扫二维码",
	        "classcode": "课堂暗号",
	        "share": "转发分享",
	        "manualmark": "教师手动修改",
	        "classtip": "“正在上课”提示"
	    },
	
	    // 会员审核
	    vipAudit: {
	        "applyReason": "申请理由:",
	        "placeholder1": "请输入申请理由，包含但不限于：您想体验的功能、使用场景、具体用途…",
	        "vipApply": "会员申请",
	        "experienceinadvance": "会员功能抢先看",
	        "boardonPC": "课堂板书:",
	        "insertaudio": "课件插入慕课视频:",
	        "livebroadcastinclass": "音视频直播:",
	        "morefeaturescomingsoon": "更多功能敬请期待…",
	        "distinguishedmembers": "恭喜您已成为雨课堂会员",
	        "periodofvalidity": "会员有效期",
	        "advance1": "课上随时启用，学生端课上实时观看，课后还能回放过程，配合触控笔和直播效果更佳。",
	        "advance2": "制作课件时，可直接插入慕课视频，无需其它视频网站中转，使用更方便。",
	        "advance3": "教师可在课堂中开启音视频直播，远程上课的同学同样可以看到课堂，深度参与。",
	        'btn1': '提交申请',
	        'btn2': '返回',
	        'fail': '失败',
	        'success': '提交成功',
	        'info': '您的申请已提交，我们将尽快为您审核信息',
	        'tip2': '您的会员申请已成功提交，由于疫情期间申请人数太多，我们将尽快对您的信息进行审核，届时您将在微信公众号中收到审核通知，感谢您的使用！',
	        'interactiveinclass': '互动直播：',
	        'invigilatingexam': '在线监考：',
	        'downloadpapers': '试卷PDF存档',
	        "advance4": "零延时互动直播。老师可共享电脑屏幕，学生可开启麦克风和摄像头与老师互动。",
	        "advance5": "覆盖考试前中后全过程。通过行为检测+智能分析，为线考试提供远程监考服务。",
	        "advance6": "考试结束后，可以下载学生试卷。每场考试一个文件夹，查找更方便，存档更安心。",
	        "chujihuiyuan": "恭喜您已成为雨课堂初级会员",
	        "zhongjihuiyuan": "恭喜您已成为雨课堂中级会员",
	        "gaojihuiyuan": "恭喜您已成为雨课堂高级会员",
	        "chaojihuiyuan": "恭喜您已成为雨课堂超级会员",
	        "cloudsave": "云盘存储",
	        "advance7": "支持音视频、文档等多类型文件的云端存储。云盘内容与教学过程互通，使用更方便。"
	    },
	
	    bindschool: {
	        "addschool": "增加学校",
	        "shenfenbang": "进行身份绑定",
	        "bindtipsshow": "<div class=\"pt10\">\u7ED1\u5B9A\u540E\u53EF\u4EE5\u540C\u6B65\u6821\u5185\u5DE5\u53F7/\u5B66\u53F7\u3001\u8BFE\u7A0B\u6570\u636E</div><div>\u5982\u9700\u5F00\u901A\uFF0C\u8BF7\u7531\u672C\u6821\u6559\u52A1\u7535\u8BDD\u8054\u7CFB400-689-1199</div>",
	        "binded": "已绑定",
	        "weiguixiao": "未和贵校教务系统对接，暂不支持身份绑定",
	        "search": "搜索",
	        "xuehao": "学号",
	        "gonghao": "工号",
	        "yuanxi": "院系",
	        "sureunbind": "确认解绑{name}?",
	        "unbindinacc": "解绑账号",
	        "canceunbinding": "取消解绑",
	        "jiechuchenggong": "解除账号成功",
	        "qxiaoyouhui": "清华校友总会",
	        "pleasepc": "请在PC端访问",
	        "qufendaxiao": "区分大小写",
	        "beishistep": "步骤一：<br/>请先在“北师大企业号”内进行身份验证，<br/>如已验证可跳过此步骤。",
	        "beishiqr": "\u957F\u6309\u8BC6\u522B\u4E8C\u7EF4\u7801\u53EF\u8FDB\u5165\u5317\u5E08\u5927\u4F01\u4E1A\u53F7",
	        "bindstep": "步骤二：<br/>请点击进行雨课堂身份绑定。",
	        "bindid": "身份绑定",
	        "weibindtips": "您还未绑定学校账号，请先绑定",
	        "phonenum": "手机号认证",
	        "zmindenti": "账密认证",
	        "identi": "身份",
	        "plid": "请选择身份",
	        "account": "账号",
	        "password": "密码",
	        "verificode": "验证码",
	        "tipscode": "提示：请输入右边显示的验证码",
	        "plenterphone": "提示：请输入右边显示的验证码",
	        "tips": "提示",
	        "xiaoneitips": "此处只支持校内账号登录，自主注册账号请前往账号登录进行验证登录",
	        "confirmbind": "确认绑定",
	        "cancelbind": "取消绑定",
	        "verisuc": "验证成功",
	        "numhouback": "{num}秒后自动返回",
	        "cmycourse": "查看我的课程",
	        "yiaccount": "账号异常",
	        "renzheng1": "1\u3001\u60A8\u5DF2\u901A\u8FC7\u8EAB\u4EFD\u8BA4\u8BC1\uFF0C\u4F46\u5728\u201C{name}-\u96E8\u8BFE\u5802\u201D\u7CFB\u7EDF\u4E2D\u6CA1\u6709\u67E5\u8BE2\u5230\u60A8\u7684\u8D26\u53F7\u4FE1\u606F\uFF0C\u7CFB\u7EDF\u4E3A\u60A8\u81EA\u52A8\u521B\u5EFA\u4E86<span class=\"color63\">\u5B66\u751F\u8EAB\u4EFD</span>\u7684\u6821\u5185\u8D26\u53F7\uFF1B",
	        "renzheng2": "2、系统自动创建的校内账号，默认学号为您认证使用的账号，姓名为您的微信昵称，入学年份默认为学号前四位；",
	        "renzheng3": "3\u3001\u6B64\u7C7B\u8D26\u53F7\u65E0\u6CD5\u5173\u8054\u6821\u5185\u6570\u636E\uFF0C\u5982\u60A8\u73B0\u5728\u52A0\u5165\u6821\u5185\u8BFE\u7A0B\uFF0C\u5C06\u4EE5<span class=\"color63\">\u65C1\u542C\u751F\u8EAB\u4EFD</span>\u542C\u8BFE\uFF0C\u542C\u8BFE\u6570\u636E\u4F1A\u88AB\u8BB0\u5F55\uFF1B",
	        "xuyaoacteacher": "如有需要，请联系学校教务老师更新人员信息。",
	        "gotit": "我知道了",
	        "bindfaied": "绑定失败",
	        "rebind": "重新绑定",
	        "getcode": "获取验证码",
	        "num6last": "手机号后6位",
	        "guoguan": "国际关系学院",
	        "inputpass1": "请输入用于登录校内教务系统的密码",
	        "numberwrong": "手机号错误",
	        "resend": "重新发送",
	        "idnoempty": "学号不能为空",
	        "passnoempty": "密码不能为空",
	        "selcode": "请录入验证码",
	        "verifying": "认证中…",
	        "wrongcode": "验证码错误",
	        "reginfo": "报名信息",
	        "gotobind": "前往绑定",
	        "plphonenum": "请输入手机号",
	        "backreg": "返回注册页面",
	        "yibangdingzhanghao": "\u60A8\u5DF2\u7ED1\u5B9A <span class=\"color3 font-weight-600\">{name}</span>\u6821\u5185\u5E10\u53F7\uFF0C<br/> \u5982\u9700\u4FEE\u6539\uFF0C\u8BF7\u5148\u89E3\u7ED1\u5E10\u53F7\u3002",
	        "gaixuexiaobushuzai": "该学校部署在“{enName}”服务器，请前往{name}公众号完成身份认证。首次访问需关注公众号。",
	        "changanshibie": "长按识别，二维码有效期截至{expire}",
	        "qiehuanservertips": "切换服务器会重新登录确定切换吗？",
	        "gaixuexiaobushuzaichongxindenglu": "该学校部署在“{enName}”服务器，需切换至“{name}”服务器重新登录。",
	        "qiehuan": "切换服务器",
	        "emailverify": "邮箱认证",
	        "informationnotfill": "信息未全部填写",
	        "emailformatwrong": "邮箱格式错误"
	    },
	
	    // 新版首页同步过来的组件
	    mobile: {
	        // account-logout.vue
	        "viewdetail": "查看详情",
	        "logouttips": "\u8D26\u53F7\u3010{userid}\u3011\u6B63\u5728\u6CE8\u9500\u786E\u8BA4\u4E2D\uFF0C\u9884\u8BA1\u751F\u6548\u65F6\u95F4\uFF1A{date}\u3002",
	        "accountcancellationinprogress": "账号注销中",
	        "userID": "注销账号：",
	        "expectedeffectivetime": "预计注销生效时间：",
	        "unrecoverableafterlogout": "完成注销后不可恢复",
	        "cancellogoutsuccess": "取消注销成功",
	        "cancellogout": "取消注销"
	    }
	};
	
	if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	        return pages;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if ((typeof exports === "undefined" ? "undefined" : (0, _typeof3.default)(exports)) === 'object' && (typeof module === "undefined" ? "undefined" : (0, _typeof3.default)(module)) === 'object') {
	    module.exports = exports = pages; // CommonJS
	}
	
	exports.default = pages;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	!function(t,e){ true?module.exports=e(__webpack_require__(438)):"function"==typeof define&&define.amd?define("MINT",["vue"],e):"object"==typeof exports?exports.MINT=e(require("vue")):t.MINT=e(t.Vue)}(this,function(t){return function(t){function e(i){if(n[i])return n[i].exports;var o=n[i]={exports:{},id:i,loaded:!1};return t[i].call(o.exports,o,o.exports,e),o.loaded=!0,o.exports}var n={};return e.m=t,e.c=n,e.p="",e(0)}([function(t,e,n){t.exports=n(104)},function(t,e,n){"use strict";t.exports=n(45)},function(e,n){e.exports=t},function(t,e,n){var i,o;i=n(126),t.exports=i||{},t.exports.__esModule&&(t.exports=t.exports["default"]),o&&(("function"==typeof t.exports?t.exports.options||(t.exports.options={}):t.exports).template=o)},function(t,e){},function(t,e,n){!function(e,i){t.exports=i(n(2))}(this,function(t){return function(t){function e(i){if(n[i])return n[i].exports;var o=n[i]={exports:{},id:i,loaded:!1};return t[i].call(o.exports,o,o.exports,e),o.loaded=!0,o.exports}var n={};return e.m=t,e.c=n,e.p="",e(0)}([function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0});var o=n(4),s=i(o),a=n(2),r=n(1),l=i(r);n(3);var u=1,c=[],d=function(t){if(-1===c.indexOf(t)){var e=function(t){var e=t.__vue__;if(!e){var n=t.previousSibling;n.__vue__&&(e=n.__vue__)}return e};s["default"].transition(t,{afterEnter:function(t){var n=e(t);n&&n.doAfterOpen&&n.doAfterOpen()},afterLeave:function(t){var n=e(t);n&&n.doAfterClose&&n.doAfterClose()}})}},p=function(t){return 3===t.nodeType?t.nextElementSibling:t};e["default"]={props:{visible:{type:Boolean,twoWay:!0,"default":!1},transition:{type:String,"default":""},openDelay:{},closeDelay:{},zIndex:{},modal:{type:Boolean,"default":!1},modalClass:{},closeOnPressEscape:{type:Boolean,"default":!1},closeOnClickModal:{type:Boolean,"default":!1}},created:function(){this.transition&&d(this.transition)},compiled:function(){this._popupId="popup-"+u++,l["default"].register(this._popupId,this)},beforeDestroy:function(){l["default"].deregister(this._popupId),l["default"].closeModal(this._popupId)},data:function(){return{bodyOverflow:null,rendered:!1}},watch:{visible:function(t){var e=this;if(t){if(this._opening)return;this.rendered?this.open():(this.rendered=!0,s["default"].nextTick(function(){e.open()}))}else this.close()}},methods:{open:function(t){var e=this;if(!this.rendered)return this.rendered=!0,void(this.visible=!0);var n=(0,a.merge)({},this,t);this._closeTimer&&(clearTimeout(this._closeTimer),this._closeTimer=null),clearTimeout(this._openTimer);var i=Number(n.openDelay);i>0?this._openTimer=setTimeout(function(){e._openTimer=null,e.doOpen(n)},i):this.doOpen(n)},doOpen:function(t){if(!this.willOpen||this.willOpen()){this._opening=!0,this.visible=!0;var e=p(this.$el),n=t.modal;n&&(this._closing&&(l["default"].closeModal(this._popupId),this._closing=!1),l["default"].openModal(this._popupId,l["default"].nextZIndex(),e,t.modalClass),this.bodyOverflow||(this.bodyOverflow=document.body.style.overflow),document.body.style.overflow="hidden"),"static"===getComputedStyle(e).position&&(e.style.position="absolute");var i=t.zIndex;n?e.style.zIndex=l["default"].nextZIndex():i&&(e.style.zIndex=i),this.onOpen&&this.onOpen(),this.transition||this.doAfterOpen()}},doAfterOpen:function(){this._opening=!1},close:function(){var t=this;if(!this.willClose||this.willClose()){null!==this._openTimer&&(clearTimeout(this._openTimer),this._openTimer=null),clearTimeout(this._closeTimer);var e=Number(this.closeDelay);e>0?this._closeTimer=setTimeout(function(){t._closeTimer=null,t.doClose()},e):this.doClose()}},doClose:function(){this.visible=!1,this._closing=!0,this.onClose&&this.onClose(),this.modal&&(document.body.style.overflow=this.bodyOverflow),this.transition||this.doAfterClose()},doAfterClose:function(){l["default"].closeModal(this._popupId),this._closing=!1}}}},function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=function(){var t=o.modalDom;return t||(t=document.createElement("div"),o.modalDom=t,t.addEventListener("touchmove",function(t){t.preventDefault(),t.stopPropagation()}),t.addEventListener("click",function(){o.doOnModalClick&&o.doOnModalClick()})),t},i={},o={zIndex:1e3,getInstance:function(t){return i[t]},register:function(t,e){t&&e&&(i[t]=e)},deregister:function(t){t&&(i[t]=null,delete i[t])},nextZIndex:function(){return o.zIndex++},modalStack:[],doOnModalClick:function(){var t=o.modalStack[o.modalStack.length-1];if(t){var e=o.getInstance(t.id);e&&e.closeOnClickModal&&e.close()}},openModal:function(t,e,i,o){if(t&&void 0!==e){for(var s=this.modalStack,a=0,r=s.length;r>a;a++){var l=s[a];if(l.id===t)return}var u=n();if(u.classList.add("v-modal"),u.classList.add("v-modal-enter"),o){var c=o.trim().split(/\s+/);c.forEach(function(t){return u.classList.add(t)})}setTimeout(function(){u.classList.remove("v-modal-enter")},200),i&&i.parentNode&&11!==i.parentNode.nodeType?i.parentNode.appendChild(u):document.body.appendChild(u),e&&(u.style.zIndex=e),u.style.display="",this.modalStack.push({id:t,zIndex:e,modalClass:o})}},closeModal:function(t){var e=this.modalStack,i=n();if(e.length>0){var o=e[e.length-1];if(o.id===t){if(o.modalClass){var s=o.modalClass.trim().split(/\s+/);s.forEach(function(t){return i.classList.remove(t)})}e.pop(),e.length>0&&(i.style.zIndex=e[e.length-1].zIndex)}else for(var a=e.length-1;a>=0;a--)if(e[a].id===t){e.splice(a,1);break}}0===e.length&&(i.classList.add("v-modal-leave"),setTimeout(function(){0===e.length&&(i.parentNode&&i.parentNode.removeChild(i),i.style.display="none"),i.classList.remove("v-modal-leave")},200))}};window.addEventListener("keydown",function(t){if(27===t.keyCode&&o.modalStack.length>0){var e=o.modalStack[o.modalStack.length-1];if(!e)return;var n=o.getInstance(e.id);n.closeOnPressEscape&&n.close()}}),e["default"]=o},function(t,e){"use strict";function n(t){for(var e=1,n=arguments.length;n>e;e++){var i=arguments[e];for(var o in i)if(i.hasOwnProperty(o)){var s=i[o];void 0!==s&&(t[o]=s)}}return t}Object.defineProperty(e,"__esModule",{value:!0}),e.merge=n},function(t,e){},function(e,n){e.exports=t}])})},function(t,e,n){var i,o;n(155),i=n(128),o=n(34),t.exports=i||{},t.exports.__esModule&&(t.exports=t.exports["default"]),o&&(("function"==typeof t.exports?t.exports.options||(t.exports.options={}):t.exports).template=o)},function(t,e,n){"use strict";t.exports=n(54)},function(t,e,n){"use strict";t.exports=n(55)},function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{"default":t}}var o=n(60),s=i(o);s["default"].install=function(t){t.component(s["default"].name,s["default"])},t.exports=s["default"]},function(t,e){},function(t,e){},function(t,e,n){!function(e,n){t.exports=n()}(this,function(){return function(t){function e(i){if(n[i])return n[i].exports;var o=n[i]={exports:{},id:i,loaded:!1};return t[i].call(o.exports,o,o.exports,e),o.loaded=!0,o.exports}var n={};return e.m=t,e.c=n,e.p="",e(0)}([function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0}),e.SwipeItem=e.Swipe=void 0;var o=n(12),s=i(o),a=n(11),r=i(a);e.Swipe=s["default"],e.SwipeItem=r["default"]},function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e["default"]={name:"mt-swipe-item",ready:function(){this.$dispatch("swipeItemCreated",this)},detached:function(){this.$dispatch("swipeItemDestroyed",this)},destroyed:function(){this.$dispatch("swipeItemDestroyed",this)}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var i=n(6);e["default"]={name:"mt-swipe",created:function(){this.dragState={}},data:function(){return{ready:!1,dragging:!1,userScrolling:!1,animating:!1,index:0,pages:[],timer:null,reInitTimer:null,noDrag:!1}},props:{speed:{type:Number,"default":300},auto:{type:Number,"default":3e3},continuous:{type:Boolean,"default":!0},showIndicators:{type:Boolean,"default":!0},noDragWhenSingle:{type:Boolean,"default":!0},prevent:{type:Boolean,"default":!1}},events:{swipeItemCreated:function(){var t=this;this.ready&&(clearTimeout(this.reInitTimer),this.reInitTimer=setTimeout(function(){t.reInitPages()},100))},swipeItemDestroyed:function(){var t=this;this.ready&&(clearTimeout(this.reInitTimer),this.reInitTimer=setTimeout(function(){t.reInitPages()},100))}},methods:{translate:function(t,e,n,o){var s=this,a=arguments;if(n){this.animating=!0,t.style.webkitTransition="-webkit-transform "+n+"ms ease-in-out",setTimeout(function(){return t.style.webkitTransform="translate3d("+e+"px, 0, 0)"},50);var r=!1,l=function(){r||(r=!0,s.animating=!1,t.style.webkitTransition="",t.style.webkitTransform="",o&&o.apply(s,a))};(0,i.once)(t,"webkitTransitionEnd",l),setTimeout(l,n+100)}else t.style.webkitTransition="",t.style.webkitTransform="translate3d("+e+"px, 0, 0)"},reInitPages:function(){var t=this.$children;this.noDrag=1===t.length&&this.noDragWhenSingle;var e=[];this.index=0,t.forEach(function(t,n){e.push(t.$el),(0,i.removeClass)(t.$el,"active"),0===n&&(0,i.addClass)(t.$el,"active")}),this.pages=e},doAnimate:function(t,e){var n=this;if(0!==this.$children.length&&(e||!(this.$children.length<2))){var o,s,a,r,l,u=this.speed||300,c=this.index,d=this.pages,p=d.length;e?(o=e.prevPage,a=e.currentPage,s=e.nextPage,r=e.pageWidth,l=e.offsetLeft):(r=this.$el.clientWidth,a=d[c],o=d[c-1],s=d[c+1],this.continuous&&d.length>1&&(o||(o=d[d.length-1]),s||(s=d[0])),o&&(o.style.display="block",this.translate(o,-r)),s&&(s.style.display="block",this.translate(s,r)));var f,h=this.$children[c].$el;"prev"===t?(c>0&&(f=c-1),this.continuous&&0===c&&(f=p-1)):"next"===t&&(p-1>c&&(f=c+1),this.continuous&&c===p-1&&(f=0));var m=function(){if(void 0!==f){var t=n.$children[f].$el;(0,i.removeClass)(h,"active"),(0,i.addClass)(t,"active"),n.index=f}o&&(o.style.display=""),s&&(s.style.display="")};setTimeout(function(){"next"===t?(n.translate(a,-r,u,m),s&&n.translate(s,0,u)):"prev"===t?(n.translate(a,r,u,m),o&&n.translate(o,0,u)):(n.translate(a,0,u,m),"undefined"!=typeof l?(o&&l>0&&n.translate(o,-1*r,u),s&&0>l&&n.translate(s,r,u)):(o&&n.translate(o,-1*r,u),s&&n.translate(s,r,u)))},10)}},next:function(){this.doAnimate("next")},prev:function(){this.doAnimate("prev")},doOnTouchStart:function(t){if(!this.noDrag){var e=this.$el,n=this.dragState,i=t.touches[0];n.startTime=new Date,n.startLeft=i.pageX,n.startTop=i.pageY,n.startTopAbsolute=i.clientY,n.pageWidth=e.offsetWidth,n.pageHeight=e.offsetHeight;var o=this.$children[this.index-1],s=this.$children[this.index],a=this.$children[this.index+1];this.continuous&&this.pages.length>1&&(o||(o=this.$children[this.$children.length-1]),a||(a=this.$children[0])),n.prevPage=o?o.$el:null,n.dragPage=s?s.$el:null,n.nextPage=a?a.$el:null,n.prevPage&&(n.prevPage.style.display="block"),n.nextPage&&(n.nextPage.style.display="block")}},doOnTouchMove:function(t){if(!this.noDrag){var e=this.dragState,n=t.touches[0];e.currentLeft=n.pageX,e.currentTop=n.pageY,e.currentTopAbsolute=n.clientY;var i=e.currentLeft-e.startLeft,o=e.currentTopAbsolute-e.startTopAbsolute,s=Math.abs(i),a=Math.abs(o);if(5>s||s>=5&&a>=1.73*s)return void(this.userScrolling=!0);this.userScrolling=!1,t.preventDefault(),i=Math.min(Math.max(-e.pageWidth+1,i),e.pageWidth-1);var r=0>i?"next":"prev";e.prevPage&&"prev"===r&&this.translate(e.prevPage,i-e.pageWidth),this.translate(e.dragPage,i),e.nextPage&&"next"===r&&this.translate(e.nextPage,i+e.pageWidth)}},doOnTouchEnd:function(){if(!this.noDrag){var t=this.dragState,e=new Date-t.startTime,n=null,i=t.currentLeft-t.startLeft,o=t.currentTop-t.startTop,s=t.pageWidth,a=this.index,r=this.pages.length;if(300>e){var l=Math.abs(i)<5&&Math.abs(o)<5;(isNaN(i)||isNaN(o))&&(l=!0),l&&this.$children[this.index].$emit("tap")}300>e&&void 0===t.currentLeft||((300>e||Math.abs(i)>s/2)&&(n=0>i?"next":"prev"),this.continuous||(0===a&&"prev"===n||a===r-1&&"next"===n)&&(n=null),this.$children.length<2&&(n=null),this.doAnimate(n,{offsetLeft:i,pageWidth:t.pageWidth,prevPage:t.prevPage,currentPage:t.dragPage,nextPage:t.nextPage}),this.dragState={})}}},destroyed:function(){this.timer&&(clearInterval(this.timer),this.timer=null),this.reInitTimer&&(clearTimeout(this.reInitTimer),this.reInitTimer=null)},ready:function(){var t=this;this.ready=!0,this.auto>0&&(this.timer=setInterval(function(){t.dragging||t.animating||t.next()},this.auto)),this.reInitPages();var e=this.$el;e.addEventListener("touchstart",function(e){t.prevent&&e.preventDefault(),t.animating||(t.dragging=!0,t.userScrolling=!1,t.doOnTouchStart(e))}),e.addEventListener("touchmove",function(e){t.dragging&&t.doOnTouchMove(e)}),e.addEventListener("touchend",function(e){return t.userScrolling?(t.dragging=!1,void(t.dragState={})):void(t.dragging&&(t.doOnTouchEnd(e),t.dragging=!1))})}}},function(t,e){"use strict";var n=function(t){return(t||"").replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g,"")},i=function(t,e){if(!t||!e)return!1;if(-1!=e.indexOf(" "))throw new Error("className should not contain space.");return t.classList?t.classList.contains(e):(" "+t.className+" ").indexOf(" "+e+" ")>-1},o=function(t,e){if(t){for(var n=t.className,o=(e||"").split(" "),s=0,a=o.length;a>s;s++){var r=o[s];r&&(t.classList?t.classList.add(r):i(t,r)||(n+=" "+r))}t.classList||(t.className=n)}},s=function(t,e){if(t&&e){for(var o=e.split(" "),s=" "+t.className+" ",a=0,r=o.length;r>a;a++){var l=o[a];l&&(t.classList?t.classList.remove(l):i(t,l)&&(s=s.replace(" "+l+" "," ")))}t.classList||(t.className=n(s))}};t.exports={hasClass:i,addClass:o,removeClass:s}},function(t,e){"use strict";var n=function i(t,e){if(!t)return null;var n,o;if("string"==typeof t)return document.createTextNode(t);if(t.tag){n=document.createElement(t.tag);for(var s in t)if(t.hasOwnProperty(s)){if("content"===s||"tag"===s)continue;if("key"===s&&e){var a=t[s];a&&(e[a]=n);continue}n[s]=t[s]}var r=t.content;if(r)if("string"==typeof r)o=document.createTextNode(r),n.appendChild(o);else{r instanceof Array||(r=[r]);for(var l=0,u=r.length;u>l;l++){var c=r[l];o=i(c,e),n.appendChild(o)}}}return n};t.exports=n},function(t,e){"use strict";var n=function(){return document.addEventListener?function(t,e,n){t&&e&&n&&t.addEventListener(e,n,!1)}:function(t,e,n){t&&e&&n&&t.attachEvent("on"+e,n)}}(),i=function(){return document.removeEventListener?function(t,e,n){t&&e&&t.removeEventListener(e,n,!1)}:function(t,e,n){t&&e&&t.detachEvent("on"+e,n)}}(),o=function(t,e,o){var s=function a(){o&&o.apply(this,arguments),i(t,e,a)};n(t,e,s)};t.exports={on:n,off:i,once:o}},function(t,e,n){"use strict";var i=n(3),o=n(5),s=n(7),a=n(4);t.exports={on:o.on,off:o.off,once:o.once,getStyle:s.getStyle,setStyle:s.setStyle,removeClass:i.removeClass,addClass:i.addClass,hasClass:i.hasClass,create:a}},function(t,e){"use strict";function n(t){return t.replace(o,function(t,e,n,i){return i?n.toUpperCase():n}).replace(s,"Moz$1")}var i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol?"symbol":typeof t},o=/([\:\-\_]+(.))/g,s=/^moz([A-Z])/,a=Number(document.documentMode),r=9>a?function(t,e){if(!t||!e)return null;e=n(e),"float"===e&&(e="styleFloat");try{switch(e){case"opacity":try{return t.filters.item("alpha").opacity/100}catch(i){return 1}break;default:return t.style[e]||t.currentStyle?t.currentStyle[e]:null}}catch(i){return t.style[e]}}:function(t,e){if(!t||!e)return null;e=n(e),"float"===e&&(e="cssFloat");try{var i=document.defaultView.getComputedStyle(t,"");return t.style[e]||i?i[e]:null}catch(o){return t.style[e]}},l=function u(t,e,o){if(t&&e)if("object"===("undefined"==typeof e?"undefined":i(e)))for(var s in e)e.hasOwnProperty(s)&&u(t,s,e[s]);else e=n(e),"opacity"===e&&9>a?t.style.filter=isNaN(o)?"":"alpha(opacity="+100*o+")":t.style[e]=o};t.exports={getStyle:r,setStyle:l}},function(t,e){},function(t,e){t.exports="<div class=swipe-item> <slot></slot> </div>"},function(t,e){t.exports='<div class=swipe> <div class=swipe-items-wrap v-el:wrap> <slot></slot> </div> <div class=swipe-indicators v-show=showIndicators> <div class=swipe-indicator v-for="page in pages" :class="{ active: $index === index }"></div> </div> </div>'},function(t,e,n){var i,o;i=n(1),o=n(9),t.exports=i||{},t.exports.__esModule&&(t.exports=t.exports["default"]),o&&(("function"==typeof t.exports?t.exports.options:t.exports).template=o)},function(t,e,n){var i,o;n(8),i=n(2),o=n(10),t.exports=i||{},t.exports.__esModule&&(t.exports=t.exports["default"]),o&&(("function"==typeof t.exports?t.exports.options:t.exports).template=o)}])})},function(t,e){t.exports=" <div class=msgbox-wrapper> <div class=msgbox v-if=rendered v-show=visible transition=pop-bounce> <div class=msgbox-header v-if=\"title !== ''\"> <div class=msgbox-title>{{ title }}</div> </div> <div class=msgbox-content v-if=\"message !== ''\"> <div class=\"msgbox-status d-icon {{ type ? 'icon-' + type : '' }}\"></div> <div class=msgbox-message><p>{{ message }}</p></div> <div class=msgbox-input v-show=showInput> <input type=text v-model=inputValue :placeholder=inputPlaceholder v-el:input/> <div class=msgbox-errormsg :style=\"{ visibility: !!editorErrorMessage ? 'visible' : 'hidden' }\">{{editorErrorMessage}}</div> </div> </div> <div class=msgbox-btns :class=\"{ 'msgbox-btns-reverse': confirmButtonPosition === 'left' }\"> <button class=\"{{ cancelButtonClasses }}\" v-show=showCancelButton @click=\"handleAction('cancel')\">{{ cancelButtonText }}</button> <button class=\"{{ confirmButtonClasses }}\" v-show=showConfirmButton @click=\"handleAction('confirm')\">{{ confirmButtonText }}</button> </div> </div> </div> "},function(t,e){t.exports=" <div v-show=visible class=mint-actionsheet transition=actionsheet-float> <ul class=mint-actionsheet-list :style=\"{ 'margin-bottom': cancelText ? '5px' : '0' }\"> <li v-for=\"item in actions\" class=mint-actionsheet-listitem @click=itemClick(item)>{{ item.name }}</li> </ul> <a class=mint-actionsheet-button @click=\"visible = false\" v-if=cancelText>{{ cancelText }}</a> </div> "},function(t,e){t.exports=" <span class=mint-badge :style=\"{ 'background-color': color }\" :class=\"['is-' + type, 'is-size-' + size]\"> <slot></slot> </span> "},function(t,e){t.exports=" <button class=mint-button :class=\"['mint-button--' + type, 'mint-button--' + size, {\n      'is-disabled': disabled,\n      'is-plain': plain\n    }]\" @touchstart=handleClick> <span class=mint-button-icon v-if=\"icon || _slotContents.icon\"> <slot name=icon> <i v-if=icon class=mintui :class=\"'mintui-' + icon\"></i> </slot> </span> <label class=mint-button-text><slot></slot></label> </button> "},function(t,e){t.exports=" <a class=mint-cell> <span class=mint-cell-mask v-if=isLink></span> <label class=mint-cell-title> <slot name=icon> <i v-if=icon class=mintui :class=\"'mintui-' + icon\"></i> </slot> <slot name=title> <span class=mint-cell-text v-text=title></span> <span v-if=label class=mint-cell-label v-text=label></span> </slot> </label> <div class=mint-cell-value> <slot> <span v-text=value></span> </slot> </div> <i v-if=isLink class=mint-cell-allow-right></i> </a> "},function(t,e){t.exports=' <div class=mint-checklist :class="{ \'is-limit\': max <= value.length }"> <label class=mint-checklist-title v-text=title></label> <x-cell v-for="option in options"> <div slot=title> <label> <span :class="{\'is-right\': align === \'right\'}" class=mint-checkbox> <input class=mint-checkbox-core type=checkbox v-model=value :disabled=option.disabled :value="option.value || option"> </span> <span class=mint-checkbox-label v-text="option.label || option"></span> </label> </div> </x-cell> </div> '},function(t,e){t.exports=' <mt-popup :visible.sync=visible position=bottom class=mint-datetime> <mt-picker :slots=dateSlots @change=onChange :visible-item-count=7 class=mint-datetime-picker v-ref:picker show-toolbar> <span class="mint-datetime-action mint-datetime-cancel" @click="visible = false">{{ cancelText }}</span> <span class="mint-datetime-action mint-datetime-confirm" @click=confirm>{{ confirmText }}</span> </mt-picker> </mt-popup> '},function(t,e){t.exports=' <div class=mint-field> <x-cell class=mint-field-cell :title=label v-clickoutside="active = false" :class="[{ \'is-nolabel\': !label }, {\n      \'is-textarea\': type === \'textarea\'\n    }]"> <textarea class=mint-field-core :placeholder=placeholder v-if="type === \'textarea\'" :rows=rows v-model=value>\n    </textarea> <input class=mint-field-core :placeholder=placeholder :number="type === \'number\'" v-else :type=type @focus="active = true" v-model=value> <div @click="value = \'\'" class=mint-field-clear v-show="value && type !== \'textarea\' && active"> <i class="mintui mintui-field-error"></i> </div> <span class=mint-field-state v-if=state :class="[\'is-\' + state]"> <i class=mintui :class="[\'mintui-field-\' + state]"></i> </span> </x-cell> <slot></slot> </div> '},function(t,e){t.exports=' <header class=mint-header :class="{ \'is-fixed\': fixed }"> <div class="mint-header-button is-left"> <slot name=left></slot> </div> <h1 class=mint-header-title v-text=title></h1> <div class="mint-header-button is-right"> <slot name=right></slot> </div> </header> '},function(t,e){t.exports=" <div class=mint-indicator v-show=visible transition=mint-indicator> <div class=mint-indicator-wrapper :style=\"{ 'padding': text ? '20px' : '15px' }\"> <spinner class=mint-indicator-spin :type=convertedSpinnerType :size=32></spinner> <span class=mint-indicator-text v-show=text>{{ text }}</span> </div> <div class=mint-indicator-mask @touchmove.stop.prevent></div> </div> "},function(t,e){t.exports=" <div class=mint-loadmore> <div class=mint-loadmore-content :class=\"{ 'is-dropped': topDropped || bottomDropped}\" :style=\"{ 'transform': 'translate3d(0, ' + translate + 'px, 0)' }\" v-el:loadmore-content> <slot name=top> <div class=mint-loadmore-top v-if=topMethod> <spinner v-if=\"topStatus === 'loading'\" class=mint-loadmore-spinner :size=20 type=fading-circle></spinner> <span class=mint-loadmore-text>{{ topText }}</span> </div> </slot> <slot></slot> <slot name=bottom> <div class=mint-loadmore-bottom v-if=bottomMethod> <spinner v-if=\"bottomStatus === 'loading'\" class=mint-loadmore-spinner :size=20 type=fading-circle></spinner> <span class=mint-loadmore-text>{{ bottomText }}</span> </div> </slot> </div> </div> "},function(t,e){t.exports=" <div class=mint-navbar :class=\"{ 'is-fixed': fixed }\"> <slot></slot> </div> "},function(t,e){t.exports=' <div class="picker-slot {{classNames}}" :style="{ flex: flex }"> <div v-if=!divider v-el:wrapper class=picker-slot-wrapper :class="{ dragging: dragging }" :style="{ height: contentHeight + \'px\' }"> <div class=picker-item v-for="itemValue in values" :class="{ \'picker-selected\': itemValue === value }">{{ itemValue }}</div> </div> <div v-if=divider>{{ content }}</div> </div> '},function(t,e){t.exports=' <div class=picker :class="{ \'picker-3d\': rotateEffect }"> <div class=picker-toolbar v-if=showToolbar><slot></slot></div> <div class=picker-items> <picker-slot v-for="slot in slots" :values="slot.values || []" :text-align="slot.textAlign || \'center\'" :visible-item-count=visibleItemCount :class-name=slot.className :flex=slot.flex :value.sync=values[slot.valueIndex] :rotate-effect=rotateEffect :divider=slot.divider :content=slot.content></picker-slot> <div class=picker-center-highlight></div> </div> </div> '},function(t,e){t.exports=" <div v-show=visible class=mint-popup :class=\"[position ? 'mint-popup-' + position : '']\" :transition=popupTransition> <slot></slot> </div> "},function(t,e){t.exports=" <div class=mt-progress> <slot name=start></slot> <div class=mt-progress-content v-el:content> <div class=mt-progress-runway :style=\"{ height: barHeight + 'px' }\"></div> <div class=mt-progress-progress :style=\"{ width: value + '%', height: barHeight + 'px' }\"></div> </div> <slot name=end></slot> </div> "},function(t,e){t.exports=' <div class=mint-radiolist> <label class=mint-radiolist-title v-text=title></label> <x-cell v-for="option in options"> <div slot=title> <label> <span :class="{\'is-right\': align === \'right\'}" class=mint-radio> <input class=mint-radio-core type=radio v-model=value :disabled=option.disabled :value="option.value || option"> </span> <span class=mint-radio-label v-text="option.label || option"></span> </label> </div> </x-cell> </div> '},function(t,e){t.exports=" <div class=mt-range :class=\"{ 'mt-range--disabled': disabled }\"> <slot name=start></slot> <div class=mt-range-content v-el:content> <div class=mt-range-runway :style=\"{ 'border-top-width': barHeight + 'px' }\"></div> <div class=mt-range-progress :style=\"{ width: progress + '%', height: barHeight + 'px' }\"></div> <div class=mt-range-thumb v-el:thumb :style=\"{ left: progress + '%' }\"></div> </div> <slot name=end></slot> </div> "},function(t,e){t.exports=' <div class=mint-search> <div class=mint-searchbar> <div class=mint-searchbar-inner> <i class="mintui mintui-search" v-show=visible></i> <input v-el:input @click="visible = true" type=search v-model=value :placeholder="visible ? placeholder : \'\'" class=mint-searchbar-core> </div> <a class=mint-searchbar-cancel @click="visible = false, value = \'\'" v-show=visible v-text=cancelText> </a> <label @click="visible = true, $els.input.focus()" class=mint-searchbar-placeholder v-show=!visible> <i class="mintui mintui-search"></i> <span class=mint-searchbar-text v-text=placeholder></span> </label> </div> <div class=mint-search-list v-show=value> <div class=mint-search-list-warp> <slot> <x-cell v-for="item in result" track-by=$index :title=item></x-cell> </slot> </div> </div> </div> '},function(t,e){t.exports=" <span><component :is=spinner></component></span> "},function(t,e){t.exports=' <div class=kebab-spinner-double-bounce :style="{\n    width: spinnerSize,\n    height: spinnerSize\n  }"> <div class=kebab-spinner-double-bounce-bounce1 :style="{ backgroundColor: spinnerColor }"></div> <div class=kebab-spinner-double-bounce-bounce2 :style="{ backgroundColor: spinnerColor }"></div> </div> '},function(t,e){t.exports=' <div class="kebab-spinner-fading-circle circle-color-{{_uid}}" :style="{\n    width: spinnerSize,\n    height: spinnerSize\n  }"> <style>.circle-color-{{_uid}} > div::before { background-color: {{ spinnerColor }}; }</style> <div class="is-circle1 kebab-spinner-fading-circle-circle"></div> <div class="is-circle2 kebab-spinner-fading-circle-circle"></div> <div class="is-circle3 kebab-spinner-fading-circle-circle"></div> <div class="is-circle4 kebab-spinner-fading-circle-circle"></div> <div class="is-circle5 kebab-spinner-fading-circle-circle"></div> <div class="is-circle6 kebab-spinner-fading-circle-circle"></div> <div class="is-circle7 kebab-spinner-fading-circle-circle"></div> <div class="is-circle8 kebab-spinner-fading-circle-circle"></div> <div class="is-circle9 kebab-spinner-fading-circle-circle"></div> <div class="is-circle10 kebab-spinner-fading-circle-circle"></div> <div class="is-circle11 kebab-spinner-fading-circle-circle"></div> <div class="is-circle12 kebab-spinner-fading-circle-circle"></div> </div> '},function(t,e){t.exports=" <div class=kebab-spinner-snake :style=\"{\n  'border-top-color': spinnerColor,\n  'border-left-color': spinnerColor,\n  'border-bottom-color': spinnerColor,\n  'height': spinnerSize,\n  'width': spinnerSize\n  }\"> </div> "},function(t,e){t.exports=" <div class=kebab-spinner-triple-bounce> <div class=kebab-spinner-triple-bounce-bounce1 :style=bounceStyle></div> <div class=kebab-spinner-triple-bounce-bounce2 :style=bounceStyle></div> <div class=kebab-spinner-triple-bounce-bounce3 :style=bounceStyle></div> </div> "},function(t,e){t.exports=" <div class=mint-switch> <input class=mint-switch-core type=checkbox v-model=value> <div class=mint-switch-label><slot></slot></div> </div> "},function(t,e){t.exports=' <div v-show="id === $parent.active" class=mint-tab-container-item><slot></slot></div> '},function(t,e){t.exports=" <div class=mint-tab-container><slot></slot></div> "},function(t,e){t.exports=' <a class=mint-tab-item @click="$parent.selected = id" :class="{ \'is-selected\': $parent.selected === id }"> <div class=mint-tab-item-icon><slot name=icon></slot></div> <div class=mint-tab-item-label><slot></slot></div> </a> '},function(t,e){t.exports=" <div class=mint-tabbar :class=\"{\n    'is-fixed': fixed\n  }\"> <slot></slot> </div> "},function(t,e,n){var i,o;n(137),i=n(107),o=n(14),t.exports=i||{},t.exports.__esModule&&(t.exports=t.exports["default"]),o&&(("function"==typeof t.exports?t.exports.options||(t.exports.options={}):t.exports).template=o)},function(t,e,n){var i,o;n(138),i=n(108),o=n(15),t.exports=i||{},t.exports.__esModule&&(t.exports=t.exports["default"]),o&&(("function"==typeof t.exports?t.exports.options||(t.exports.options={}):t.exports).template=o)},function(t,e,n){var i,o;n(139),i=n(109),o=n(16),t.exports=i||{},t.exports.__esModule&&(t.exports=t.exports["default"]),o&&(("function"==typeof t.exports?t.exports.options||(t.exports.options={}):t.exports).template=o)},function(t,e,n){var i,o;n(140),i=n(110),o=n(17),t.exports=i||{},t.exports.__esModule&&(t.exports=t.exports["default"]),o&&(("function"==typeof t.exports?t.exports.options||(t.exports.options={}):t.exports).template=o)},function(t,e,n){var i,o;n(141),i=n(111),o=n(18),t.exports=i||{},t.exports.__esModule&&(t.exports=t.exports["default"]),o&&(("function"==typeof t.exports?t.exports.options||(t.exports.options={}):t.exports).template=o)},function(t,e,n){var i,o;n(142),i=n(112),o=n(19),t.exports=i||{},t.exports.__esModule&&(t.exports=t.exports["default"]),o&&(("function"==typeof t.exports?t.exports.options||(t.exports.options={}):t.exports).template=o)},function(t,e,n){var i,o;n(143),i=n(113),o=n(20),t.exports=i||{},t.exports.__esModule&&(t.exports=t.exports["default"]),o&&(("function"==typeof t.exports?t.exports.options||(t.exports.options={}):t.exports).template=o)},function(t,e,n){var i,o;n(144),i=n(114),o=n(21),t.exports=i||{},t.exports.__esModule&&(t.exports=t.exports["default"]),o&&(("function"==typeof t.exports?t.exports.options||(t.exports.options={}):t.exports).template=o)},function(t,e,n){var i,o;i=n(115),o=n(22),t.exports=i||{},t.exports.__esModule&&(t.exports=t.exports["default"]),o&&(("function"==typeof t.exports?t.exports.options||(t.exports.options={}):t.exports).template=o)},function(t,e,n){var i,o;n(145),i=n(116),o=n(23),t.exports=i||{},t.exports.__esModule&&(t.exports=t.exports["default"]),o&&(("function"==typeof t.exports?t.exports.options||(t.exports.options={}):t.exports).template=o)},function(t,e,n){var i,o;n(146),i=n(117),o=n(24),t.exports=i||{},t.exports.__esModule&&(t.exports=t.exports["default"]),o&&(("function"==typeof t.exports?t.exports.options||(t.exports.options={}):t.exports).template=o)},function(t,e,n){var i,o;n(147),i=n(118),o=n(25),t.exports=i||{},t.exports.__esModule&&(t.exports=t.exports["default"]),o&&(("function"==typeof t.exports?t.exports.options||(t.exports.options={}):t.exports).template=o)},function(t,e,n){var i,o;n(148),i=n(119),o=n(26),t.exports=i||{},t.exports.__esModule&&(t.exports=t.exports["default"]),o&&(("function"==typeof t.exports?t.exports.options||(t.exports.options={}):t.exports).template=o)},function(t,e,n){var i,o;n(149),i=n(120),o=n(27),t.exports=i||{},t.exports.__esModule&&(t.exports=t.exports["default"]),o&&(("function"==typeof t.exports?t.exports.options||(t.exports.options={}):t.exports).template=o)},function(t,e,n){var i,o;n(150),i=n(121),o=n(28),t.exports=i||{},t.exports.__esModule&&(t.exports=t.exports["default"]),o&&(("function"==typeof t.exports?t.exports.options||(t.exports.options={}):t.exports).template=o)},function(t,e,n){var i,o;n(151),i=n(122),o=n(29),t.exports=i||{},t.exports.__esModule&&(t.exports=t.exports["default"]),o&&(("function"==typeof t.exports?t.exports.options||(t.exports.options={}):t.exports).template=o)},function(t,e,n){var i,o;n(152),i=n(123),o=n(30),t.exports=i||{},t.exports.__esModule&&(t.exports=t.exports["default"]),o&&(("function"==typeof t.exports?t.exports.options||(t.exports.options={}):t.exports).template=o);
	},function(t,e,n){var i,o;n(153),i=n(124),o=n(31),t.exports=i||{},t.exports.__esModule&&(t.exports=t.exports["default"]),o&&(("function"==typeof t.exports?t.exports.options||(t.exports.options={}):t.exports).template=o)},function(t,e,n){var i,o;i=n(125),o=n(32),t.exports=i||{},t.exports.__esModule&&(t.exports=t.exports["default"]),o&&(("function"==typeof t.exports?t.exports.options||(t.exports.options={}):t.exports).template=o)},function(t,e,n){var i,o;n(154),i=n(127),o=n(33),t.exports=i||{},t.exports.__esModule&&(t.exports=t.exports["default"]),o&&(("function"==typeof t.exports?t.exports.options||(t.exports.options={}):t.exports).template=o)},function(t,e,n){var i,o;n(156),i=n(129),o=n(35),t.exports=i||{},t.exports.__esModule&&(t.exports=t.exports["default"]),o&&(("function"==typeof t.exports?t.exports.options||(t.exports.options={}):t.exports).template=o)},function(t,e,n){var i,o;n(157),i=n(130),o=n(36),t.exports=i||{},t.exports.__esModule&&(t.exports=t.exports["default"]),o&&(("function"==typeof t.exports?t.exports.options||(t.exports.options={}):t.exports).template=o)},function(t,e,n){var i,o;n(158),i=n(131),o=n(37),t.exports=i||{},t.exports.__esModule&&(t.exports=t.exports["default"]),o&&(("function"==typeof t.exports?t.exports.options||(t.exports.options={}):t.exports).template=o)},function(t,e,n){var i,o;i=n(132),o=n(38),t.exports=i||{},t.exports.__esModule&&(t.exports=t.exports["default"]),o&&(("function"==typeof t.exports?t.exports.options||(t.exports.options={}):t.exports).template=o)},function(t,e,n){var i,o;i=n(133),o=n(39),t.exports=i||{},t.exports.__esModule&&(t.exports=t.exports["default"]),o&&(("function"==typeof t.exports?t.exports.options||(t.exports.options={}):t.exports).template=o)},function(t,e,n){var i,o;n(159),i=n(134),o=n(40),t.exports=i||{},t.exports.__esModule&&(t.exports=t.exports["default"]),o&&(("function"==typeof t.exports?t.exports.options||(t.exports.options={}):t.exports).template=o)},function(t,e,n){var i,o;n(160),i=n(135),o=n(41),t.exports=i||{},t.exports.__esModule&&(t.exports=t.exports["default"]),o&&(("function"==typeof t.exports?t.exports.options||(t.exports.options={}):t.exports).template=o)},function(t,e,n){var i,o;n(161),n(136),i=n(105),o=n(13),t.exports=i||{},t.exports.__esModule&&(t.exports=t.exports["default"]),o&&(("function"==typeof t.exports?t.exports.options||(t.exports.options={}):t.exports).template=o)},function(t,e,n){"use strict";t.exports=n(42)},function(t,e,n){"use strict";t.exports=n(43)},function(t,e,n){"use strict";t.exports=n(44)},function(t,e,n){"use strict";t.exports=n(46)},function(t,e,n){"use strict";t.exports=n(47)},function(t,e,n){"use strict";t.exports=n(48)},function(t,e,n){"use strict";t.exports=n(49)},function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{"default":t}}var o=n(2),s=i(o);n(163);var a=s["default"].extend(n(50)),r=void 0,l=void 0;t.exports={open:function(t){r||(r=new a({el:document.createElement("div")})),r.visible||("string"==typeof t?(r.text=t,r.spinnerType="snake"):"[object Object]"===Object.prototype.toString.call(t)?(r.text=t.text||"",r.spinnerType=t.spinnerType||"snake"):(r.text="",r.spinnerType="snake"),r.$appendTo(document.body),l&&clearTimeout(l),s["default"].nextTick(function(){r.visible=!0}))},close:function(){r&&s["default"].nextTick(function(){r.visible=!1,l=setTimeout(function(){r.$el&&(r.$el.style.display="none")},400)})}}},function(t,e,n){"use strict";t.exports=n(79)},function(t,e,n){"use strict";var i=n(168);n(4),i.infiniteScroll.name="infinite-scroll",i.infiniteScroll.install=i.install,t.exports=i.infiniteScroll},function(t,e,n){"use strict";t.exports=n(81)},function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{"default":t}}var o=n(169),s=i(o);n(4),s["default"].name="lazy",t.exports=s["default"]},function(t,e,n){"use strict";t.exports=n(51)},function(t,e,n){"use strict";t.exports=n(84)},function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{"default":t}}var o=n(106),s=i(o);n(164),t.exports=s["default"]},function(t,e,n){"use strict";t.exports=n(52)},function(t,e){"use strict";e.__esModule=!0,e["default"]=function(t,e){var o=function(t){e.drag&&e.drag(i?t.changedTouches[0]||t.touches[0]:t)},s=function a(t){i||(document.removeEventListener("mousemove",o),document.removeEventListener("mouseup",a)),document.onselectstart=null,document.ondragstart=null,n=!1,e.end&&e.end(i?t.changedTouches[0]||t.touches[0]:t)};t.addEventListener(i?"touchstart":"mousedown",function(t){n||(document.onselectstart=function(){return!1},document.ondragstart=function(){return!1},i||(document.addEventListener("mousemove",o),document.addEventListener("mouseup",s)),n=!0,e.start&&(t.preventDefault(),e.start(i?t.changedTouches[0]||t.touches[0]:t)))}),i&&(t.addEventListener("touchmove",o),t.addEventListener("touchend",s),t.addEventListener("touchcancel",s))};var n=!1,i="ontouchstart"in window},function(t,e){"use strict";e.__esModule=!0;var n,i=document.documentElement.style,o=!1;window.opera&&"[object Opera]"===Object.prototype.toString.call(opera)?n="presto":"MozAppearance"in i?n="gecko":"WebkitAppearance"in i?n="webkit":"string"==typeof navigator.cpuClass&&(n="trident");var s={trident:"-ms-",gecko:"-moz-",webkit:"-webkit-",presto:"-o-"}[n],a={trident:"ms",gecko:"Moz",webkit:"Webkit",presto:"O"}[n],r=document.createElement("div"),l=a+"Perspective",u=a+"Transform",c=s+"transform",d=a+"Transition",p=s+"transition",f=a.toLowerCase()+"TransitionEnd";void 0!==r.style[l]&&(o=!0);var h=function(t){var e={left:0,top:0};if(null===t||null===t.style)return e;var n=t.style[u],i=/translate\(\s*(-?\d+(\.?\d+?)?)px,\s*(-?\d+(\.\d+)?)px\)\s*translateZ\(0px\)/g.exec(n);return i&&(e.left=+i[1],e.top=+i[3]),e},m=function(t,e,n){if((null!==e||null!==n)&&null!==t&&null!==t.style&&(t.style[u]||0!==e||0!==n)){if(null===e||null===n){var i=h(t);null===e&&(e=i.left),null===n&&(n=i.top)}v(t),o?t.style[u]+=" translate("+(e?e+"px":"0px")+","+(n?n+"px":"0px")+") translateZ(0px)":t.style[u]+=" translate("+(e?e+"px":"0px")+","+(n?n+"px":"0px")+")"}},v=function(t){if(null!==t&&null!==t.style){var e=t.style[u];e&&(e=e.replace(/translate\(\s*(-?\d+(\.?\d+?)?)px,\s*(-?\d+(\.\d+)?)px\)\s*translateZ\(0px\)/g,""),t.style[u]=e)}};e["default"]={transformProperty:u,transformStyleName:c,transitionProperty:d,transitionStyleName:p,transitionEndProperty:f,getElementTranslate:h,translateElement:m,cancelTranslateElement:v}},function(t,e,n){"use strict";t.exports=n(56)},function(t,e,n){"use strict";t.exports=n(57)},function(t,e,n){"use strict";var i=n(58);i.install=function(t){t.component(i.name,i)},t.exports=i},function(t,e){"use strict";e.__esModule=!0,e["default"]=function(t,e){var o=function(t){e.drag&&e.drag(i?t.changedTouches[0]||t.touches[0]:t)},s=function a(t){i||(document.removeEventListener("mousemove",o),document.removeEventListener("mouseup",a)),document.onselectstart=null,document.ondragstart=null,n=!1,e.end&&e.end(i?t.changedTouches[0]||t.touches[0]:t)};t.addEventListener(i?"touchstart":"mousedown",function(t){n||(t.preventDefault(),document.onselectstart=function(){return!1},document.ondragstart=function(){return!1},i||(document.addEventListener("mousemove",o),document.addEventListener("mouseup",s)),n=!0,e.start&&e.start(i?t.changedTouches[0]||t.touches[0]:t))}),i&&(t.addEventListener("touchmove",o),t.addEventListener("touchend",s),t.addEventListener("touchcancel",s))};var n=!1,i="ontouchstart"in window},function(t,e,n){"use strict";t.exports=n(59)},function(t,e,n){"use strict";t.exports=n(94)},function(t,e,n){"use strict";var i=n(12);n(11),i.SwipeItem.name="mt-swipe-item",t.exports=i.SwipeItem},function(t,e,n){"use strict";t.exports=n(96)},function(t,e,n){"use strict";var i=n(12);n(11),i.Swipe.name="mt-swipe",t.exports=i.Swipe},function(t,e,n){"use strict";t.exports=n(64)},function(t,e,n){"use strict";t.exports=n(65)},function(t,e,n){"use strict";t.exports=n(66)},function(t,e,n){"use strict";t.exports=n(67)},function(t,e,n){"use strict";t.exports=n(68)},function(t,e,n){"use strict";t.exports=n(103)},function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{"default":t}}var o=n(170),s=i(o);n(162),t.exports=s["default"]},function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{"default":t}}var o=n(76),s=i(o),a=n(72),r=i(a),l=n(1),u=i(l),c=n(75),d=i(c),p=n(71),f=i(p),h=n(97),m=i(h),v=n(9),g=i(v),x=n(100),b=i(x),y=n(98),T=i(y),S=n(99),w=i(S),_=n(85),M=i(_),C=n(101),k=i(C),E=n(92),I=i(E),A=n(73),P=i(A),O=n(89),L=i(O),B=n(82),D=i(B),N=n(70),$=i(N),j=n(8),F=i(j),V=n(95),z=i(V),H=n(93),Y=i(H),R=n(90),W=i(R),Z=n(7),X=i(Z),G=n(88),q=i(G),U=n(102),Q=i(U),J=n(77),K=i(J),tt=n(83),et=i(tt),nt=n(78),it=i(nt),ot=n(80),st=i(ot),at=n(74),rt=i(at);n(165);var lt=function(t){t.component(s["default"].name,s["default"]),t.component(r["default"].name,r["default"]),t.component(u["default"].name,u["default"]),t.component(d["default"].name,d["default"]),t.component(f["default"].name,f["default"]),t.component(m["default"].name,m["default"]),t.component(g["default"].name,g["default"]),t.component(b["default"].name,b["default"]),t.component(T["default"].name,T["default"]),t.component(w["default"].name,w["default"]),t.component(M["default"].name,M["default"]),t.component(k["default"].name,k["default"]),t.component(I["default"].name,I["default"]),t.component(P["default"].name,P["default"]),t.component(L["default"].name,L["default"]),t.component(D["default"].name,D["default"]),t.component($["default"].name,$["default"]),t.component(F["default"].name,F["default"]),t.component(z["default"].name,z["default"]),t.component(Y["default"].name,Y["default"]),t.component(W["default"].name,W["default"]),t.component(X["default"].name,X["default"]),t.component(q["default"].name,q["default"]),t.component(Q["default"].name,Q["default"]),t.component(K["default"].name,K["default"]),t.component(et["default"].name,et["default"]),t.component(rt["default"].name,rt["default"]),t.use(it["default"]),t.use(st["default"],{loading:n(166),"try":3})};"undefined"!=typeof window&&window.Vue&&lt(window.Vue),t.exports={install:lt,Header:s["default"],Button:r["default"],Cell:u["default"],Field:d["default"],Badge:f["default"],Switch:m["default"],Spinner:g["default"],TabItem:b["default"],TabContainerItem:T["default"],TabContainer:w["default"],Navbar:M["default"],Tabbar:k["default"],Search:I["default"],Checklist:P["default"],Radio:L["default"],Loadmore:D["default"],Actionsheet:$["default"],Popup:F["default"],Swipe:z["default"],SwipeItem:Y["default"],Range:W["default"],Picker:X["default"],Progress:q["default"],Toast:Q["default"],Indicator:K["default"],MessageBox:et["default"],InfiniteScroll:it["default"],Lazyload:st["default"],DatetimePicker:rt["default"]}},function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0});var o=n(5),s=i(o),a="确定",r="取消";e["default"]={mixins:[s["default"]],props:{modal:{"default":!0},closeOnPressEscape:{"default":!0}},computed:{confirmButtonClasses:function(){var t="msgbox-btn msgbox-confirm "+this.confirmButtonClass;return this.confirmButtonHighlight&&(t+=" msgbox-confirm-highlight"),t},cancelButtonClasses:function(){var t="msgbox-btn msgbox-cancel "+this.cancelButtonClass;return this.cancelButtonHighlight&&(t+=" msgbox-cancel-highlight"),t}},methods:{handleAction:function(t){if("prompt"!==this.$type||"confirm"!==t||this.validate()){var e=this.callback;this.visible=!1,e(t)}},validate:function(){if("prompt"===this.$type){var t=this.inputPattern;if(t&&!t.test(this.inputValue||""))return this.editorErrorMessage=this.inputErrorMessage||"输入的数据不合法!",!1;var e=this.inputValidator;if("function"==typeof e){var n=e(this.inputValue);if(n===!1)return this.editorErrorMessage=this.inputErrorMessage||"输入的数据不合法!",!1;if("string"==typeof n)return this.editorErrorMessage=n,!1}}return this.editorErrorMessage="",!0}},watch:{inputValue:function(){"prompt"===this.$type&&this.validate()},visible:function(t){var e=this;t&&"prompt"===this.$type&&setTimeout(function(){e.$els.input&&e.$els.input.focus()},500)}},data:function(){return{title:"",message:"",type:"",showInput:!1,inputValue:null,inputPlaceholder:"",inputPattern:null,inputValidator:null,inputErrorMessage:"",showConfirmButton:!0,showCancelButton:!1,confirmButtonText:a,cancelButtonText:r,confirmButtonPosition:"right",confirmButtonHighlight:!1,confirmButtonClass:"",confirmButtonDisabled:!1,cancelButtonClass:"",cancelButtonHighlight:!1,editorErrorMessage:null,callback:null}}}},function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0}),e.MessageBox=void 0;var o,s,a="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol?"symbol":typeof t},r=n(2),l=i(r),u=n(69),c=i(u),d="确定",p="取消",f={title:"",message:"",type:"",showInput:!1,inputValue:null,inputPlaceholder:"",inputPattern:null,inputValidator:null,inputErrorMessage:"",showConfirmButton:!0,showCancelButton:!1,confirmButtonPosition:"right",confirmButtonHighlight:!1,cancelButtonHighlight:!1,confirmButtonText:d,cancelButtonText:p,confirmButtonClass:"",cancelButtonClass:""},h=function(t){for(var e=1,n=arguments.length;e<n;e++){var i=arguments[e];for(var o in i)if(i.hasOwnProperty(o)){var s=i[o];void 0!==s&&(t[o]=s)}}return t},m=l["default"].extend(c["default"]),v=[],g=function(){s=new m({el:document.createElement("div")}),s.callback=function(t){if(o){var e=o.callback;if("function"==typeof e&&(s.showInput?e(s.inputValue,t):e(t)),o.resolve){var n=o.options.$type;"confirm"===n||"prompt"===n?"confirm"===t?s.showInput?o.resolve({value:s.inputValue,action:t}):o.resolve(t):"cancel"===t&&o.reject&&o.reject(t):o.resolve(t)}}}},x=function(){if(s||g(),(!s.visible||s.closeTimer)&&v.length>0){o=v.shift();var t=o.options;for(var e in t)t.hasOwnProperty(e)&&(s[e]=t[e]);s.$appendTo(document.body),l["default"].nextTick(function(){s.visible=!0})}},b=function y(t,e){return"string"==typeof t?(t={title:t},arguments[1]&&(t.message=arguments[1]),arguments[2]&&(t.type=arguments[2])):t.callback&&!e&&(e=t.callback),"undefined"!=typeof Promise?new Promise(function(n,i){v.push({options:h({},f,y.defaults||{},t),callback:e,resolve:n,reject:i}),x()}):(v.push({options:h({},f,y.defaults||{},t),callback:e}),void x())};b.setDefaults=function(t){b.defaults=t},b.alert=function(t,e,n){return"object"===("undefined"==typeof e?"undefined":a(e))&&(n=e,e=""),b(h({title:e,message:t,$type:"alert"},n))},b.confirm=function(t,e,n){return"object"===("undefined"==typeof e?"undefined":a(e))&&(n=e,e=""),b(h({title:e,message:t,$type:"confirm",showCancelButton:!0},n))},b.prompt=function(t,e,n){return"object"===("undefined"==typeof e?"undefined":a(e))&&(n=e,e=""),b(h({title:e,message:t,showCancelButton:!0,showInput:!0,$type:"prompt"},n))},b.close=function(){s.visible=!1,v=[],o=null},e["default"]=b,e.MessageBox=b},function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0});var o=n(5),s=i(o);n(10),e["default"]={name:"mt-actionsheet",mixins:[s["default"]],props:{modal:{"default":!0},closeOnClickModal:{"default":!0},cancelText:{type:String,"default":"取消"},actions:{type:Array,"default":function(){return[]}}},methods:{itemClick:function(t){t.method&&"function"==typeof t.method&&t.method(),this.visible=!1}}}},function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e["default"]={name:"mt-badge",props:{color:String,type:{type:String,"default":"primary"},size:{type:String,"default":"normal"}}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e["default"]={name:"mt-button",props:{icon:String,disabled:Boolean,plain:Boolean,type:{type:String,"default":"default",validator:function(t){return["default","danger","primary"].indexOf(t)>-1}},size:{type:String,"default":"normal",validator:function(t){return["small","normal","large"].indexOf(t)>-1}}},methods:{handleClick:function(t){this.disabled&&(t.preventDefault(),t.stopPropagation())}}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e["default"]={name:"mt-cell",props:{icon:String,title:String,label:String,isLink:Boolean,value:String}}},function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),s=i(o);e["default"]={name:"mt-checklist",props:{max:Number,title:String,align:String,options:{type:Array,required:!0},value:Array},components:{XCell:s["default"]},computed:{limit:function(){return this.max<this.value.length}},watch:{value:function(){this.limit&&this.value.pop()}}}},function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0});var o=n(7),s=i(o),a=n(8),r=i(a),l={Y:"year",M:"month",D:"date",H:"hour",m:"minute"};e["default"]={name:"mt-datetime-picker",props:{visible:{type:Boolean,"default":!1},cancelText:{type:String,"default":"取消"},confirmText:{type:String,"default":"确定"},type:{type:String,"default":"datetime"},startYear:{type:Number,"default":2e3},endYear:{type:Number,"default":(new Date).getFullYear()},startHour:{type:Number,"default":0},endHour:{type:Number,"default":23},yearFormat:{type:String,"default":"{value}"},monthFormat:{type:String,"default":"{value}"},dateFormat:{type:String,"default":"{value}"},hourFormat:{type:String,"default":"{value}"},minuteFormat:{type:String,"default":"{value}"},value:null},data:function(){return{isSlotChange:!1,dateSlots:[],shortMonthDates:[],longMonthDates:[],febDates:[],leapFebDates:[]}},components:{"mt-picker":s["default"],"mt-popup":r["default"]},methods:{isLeapYear:function(t){return t%400===0||t%100!==0&&t%4===0},isShortMonth:function(t){return[4,6,9,11].indexOf(t)>-1},getTrueValue:function(t){for(;isNaN(parseInt(t,10));)t=t.slice(1);return parseInt(t,10)},getValue:function(t){var e=this,n=void 0;if("time"===this.type)n=t.map(function(t){return("0"+e.getTrueValue(t)).slice(-2)}).join(":");else{var i=this.getTrueValue(t[0]),o=this.getTrueValue(t[1]),s=this.getTrueValue(t[2]),a=this.typeStr.indexOf("H")>-1?this.getTrueValue(t[this.typeStr.indexOf("H")]):0,r=this.typeStr.indexOf("m")>-1?this.getTrueValue(t[this.typeStr.indexOf("m")]):0;n=new Date(i,o-1,s,a,r)}return n},onChange:function(t,e){if(this.isSlotChange=!0,this.type.indexOf("date")>-1)if(this.isShortMonth(this.getTrueValue(e[1]))){if(this.shortMonthDates.indexOf(e[2])===-1)return void t.setSlotValue(2,this.dateSlots[2].values[0]);this.dateSlots[2].values=this.shortMonthDates}else if(2===this.getTrueValue(e[1]))if(this.isLeapYear(this.getTrueValue(e[0]))){if(this.leapFebDates.indexOf(e[2])===-1)return void t.setSlotValue(2,this.dateSlots[2].values[0]);this.dateSlots[2].values=this.leapFebDates}else{if(this.febDates.indexOf(e[2])===-1)return void t.setSlotValue(2,this.dateSlots[2].values[0]);this.dateSlots[2].values=this.febDates}else this.dateSlots[2].values=this.longMonthDates;this.value=this.getValue(e),this.$emit("change",this.value)},fillValues:function(t,e,n){for(var i=[],o=e;o<=n;o++)o<10?i.push(this[l[t]+"Format"].replace("{value}",("0"+o).slice(-2))):i.push(this[l[t]+"Format"].replace("{value}",o));return i},pushSlots:function(t,e,n){this.dateSlots.push({flex:1,values:this.fillValues(t,e,n)})},generateSlots:function(){var t=this,e={Y:[this.startYear,this.endYear],M:[1,12],D:[1,31],H:[this.startHour,this.endHour],m:[0,59]},n=this.typeStr.split("");n.forEach(function(n){e[n]&&t.pushSlots.apply(null,[n].concat(e[n]))}),"Hm"===this.typeStr&&this.dateSlots.splice(1,0,{divider:!0,content:":"})},setSlots:function(){var t=this.$refs.picker.setSlotValue;if("time"===this.type&&"string"==typeof this.value){var e=this.value.split(":");t(0,this.hourFormat.replace("{value}",e[0])),t(1,this.minuteFormat.replace("{value}",e[1]))}if("time"!==this.type&&"[object Date]"==={}.toString.call(this.value)){var n=this.value.getFullYear(),i=this.value.getMonth()+1,o=this.value.getDate();if(t(0,this.yearFormat.replace("{value}",n)),t(1,this.monthFormat.replace("{value}",("0"+i).slice(-2))),t(2,this.dateFormat.replace("{value}",("0"+o).slice(-2))),"datetime"===this.type){var s=this.value.getHours(),a=this.value.getMinutes();t(3,this.hourFormat.replace("{value}",("0"+s).slice(-2))),t(4,this.minuteFormat.replace("{value}",("0"+a).slice(-2)))}}},confirm:function(){this.visible=!1,this.$emit("confirm",this.value)}},computed:{typeStr:function(){return"time"===this.type?"Hm":"date"===this.type?"YMD":"YMDHm"}},watch:{value:function(){this.isSlotChange?this.isSlotChange=!1:this.setSlots()}},created:function(){for(var t=1;t<=28;t++)this.febDates.push(this.dateFormat.replace("{value}",("0"+t).slice(-2)));this.leapFebDates=this.febDates.concat(this.dateFormat.replace("{value}","29")),this.shortMonthDates=this.leapFebDates.concat(this.dateFormat.replace("{value}","30")),this.longMonthDates=this.shortMonthDates.concat(this.dateFormat.replace("{value}","31")),this.generateSlots()},ready:function(){this.setSlots()}}},function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),s=i(o),a=n(167),r=i(a);e["default"]={name:"mt-field",data:function(){return{active:!1}},directives:{Clickoutside:r["default"]},props:{type:{type:String,"default":"text"},rows:String,label:String,placeholder:String,state:{type:String,"default":"default"},value:""},components:{XCell:s["default"]}}},function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e["default"]={name:"mt-header",props:{fixed:Boolean,title:String}}},function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0});var o=n(9),s=i(o);e["default"]={data:function(){return{visible:!1}},components:{Spinner:s["default"]},computed:{convertedSpinnerType:function(){switch(this.spinnerType){case"double-bounce":return 1;case"triple-bounce":return 2;case"fading-circle":return 3;default:return 0}}},props:{text:String,spinnerType:{type:String,"default":"snake"}}}},function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0});var o=n(6),s=i(o);e["default"]={name:"mt-loadmore",components:{spinner:s["default"]},props:{autoFill:{type:Boolean,"default":!0},topPullText:{type:String,"default":"下拉刷新"},topDropText:{type:String,"default":"释放更新"},topLoadingText:{type:String,"default":"加载中..."},topDistance:{type:Number,"default":70},topMethod:{type:Function},topStatus:{type:String,"default":""},bottomPullText:{type:String,"default":"上拉刷新"},bottomDropText:{type:String,"default":"释放更新"},bottomLoadingText:{type:String,"default":"加载中..."},bottomDistance:{type:Number,"default":70},bottomMethod:{type:Function},bottomStatus:{type:String,"default":""},bottomAllLoaded:{type:Boolean,"default":!1}},data:function(){return{uuid:null,translate:0,scrollEventTarget:null,containerFilled:!1,topText:"",topDropped:!1,bottomText:"",bottomDropped:!1,bottomReached:!1,direction:"",startY:0,startScrollTop:0,currentY:0}},watch:{topStatus:function(t){switch(t){case"pull":this.topText=this.topPullText;break;case"drop":this.topText=this.topDropText;break;case"loading":this.topText=this.topLoadingText}},bottomStatus:function(t){switch(t){case"pull":this.bottomText=this.bottomPullText;break;case"drop":this.bottomText=this.bottomDropText;break;case"loading":this.bottomText=this.bottomLoadingText}}},events:{onTopLoaded:function(t){var e=this;t===this.uuid&&(this.translate=0,setTimeout(function(){e.topStatus="pull"},200))},onBottomLoaded:function(t){var e=this;this.bottomStatus="pull",this.bottomDropped=!1,t===this.uuid&&this.$nextTick(function(){e.scrollEventTarget===window?document.body.scrollTop+=50:e.scrollEventTarget.scrollTop+=50,e.translate=0}),this.bottomAllLoaded||this.containerFilled||this.fillContainer()}},methods:{getScrollEventTarget:function(t){for(var e=t;e&&"HTML"!==e.tagName&&"BODY"!==e.tagName&&1===e.nodeType;){var n=document.defaultView.getComputedStyle(e).overflowY;if("scroll"===n||"auto"===n)return e;e=e.parentNode}return window},getScrollTop:function(t){return t===window?Math.max(window.pageYOffset||0,document.documentElement.scrollTop):t.scrollTop},bindTouchEvents:function(){this.$el.addEventListener("touchstart",this.handleTouchStart),this.$el.addEventListener("touchmove",this.handleTouchMove),this.$el.addEventListener("touchend",this.handleTouchEnd)},init:function(){this.topStatus="pull",this.bottomStatus="pull",this.topText=this.topPullText,this.scrollEventTarget=this.getScrollEventTarget(this.$el),"function"==typeof this.bottomMethod&&(this.fillContainer(),this.bindTouchEvents()),"function"==typeof this.topMethod&&this.bindTouchEvents()},fillContainer:function(){var t=this;this.autoFill&&this.$nextTick(function(){t.scrollEventTarget===window?t.containerFilled=t.$el.getBoundingClientRect().bottom>=document.documentElement.getBoundingClientRect().bottom:t.containerFilled=t.$el.getBoundingClientRect().bottom>=t.scrollEventTarget.getBoundingClientRect().bottom,t.containerFilled||(t.bottomStatus="loading",t.bottomMethod(t.uuid))})},checkBottomReached:function(){return this.scrollEventTarget===window?document.body.scrollTop+document.documentElement.clientHeight===document.body.scrollHeight:this.$el.getBoundingClientRect().bottom<=this.scrollEventTarget.getBoundingClientRect().bottom},handleTouchStart:function(t){this.startY=t.touches[0].clientY,this.startScrollTop=this.getScrollTop(this.scrollEventTarget),this.bottomReached=!1,"loading"!==this.topStatus&&(this.topStatus="pull",this.topDropped=!1),"loading"!==this.bottomStatus&&(this.bottomStatus="pull",this.bottomDropped=!1)},handleTouchMove:function(t){if(!(this.startY<this.$el.getBoundingClientRect().top&&this.startY>this.$el.getBoundingClientRect().bottom)){this.currentY=t.touches[0].clientY;var e=this.currentY-this.startY;this.direction=e>0?"down":"up","function"==typeof this.topMethod&&"down"===this.direction&&0===this.getScrollTop(this.scrollEventTarget)&&"loading"!==this.topStatus&&(t.preventDefault(),t.stopPropagation(),this.translate=e-this.startScrollTop,this.translate<0&&(this.translate=0),this.topStatus=this.translate>=this.topDistance?"drop":"pull"),"up"===this.direction&&(this.bottomReached=this.bottomReached||this.checkBottomReached()),"function"==typeof this.bottomMethod&&"up"===this.direction&&this.bottomReached&&"loading"!==this.bottomStatus&&!this.bottomAllLoaded&&(t.preventDefault(),t.stopPropagation(),this.translate=this.getScrollTop(this.scrollEventTarget)-this.startScrollTop+e,this.translate>0&&(this.translate=0),this.bottomStatus=-this.translate>=this.bottomDistance?"drop":"pull")}},handleTouchEnd:function(){"down"===this.direction&&0===this.getScrollTop(this.scrollEventTarget)&&this.translate>0&&(this.topDropped=!0,"drop"===this.topStatus?(this.translate="50",this.topStatus="loading",this.topMethod(this.uuid)):(this.translate="0",this.topStatus="pull")),"up"===this.direction&&this.bottomReached&&this.translate<0&&(this.bottomDropped=!0,this.bottomReached=!1,"drop"===this.bottomStatus?(this.translate="-50",this.bottomStatus="loading",this.bottomMethod(this.uuid)):(this.translate="0",this.bottomStatus="pull")),this.direction=""}},ready:function(){this.uuid=Math.random().toString(36).substring(3,8),this.init()}}},function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e["default"]={name:"mt-navbar",props:{fixed:Boolean,selected:""}}},function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0});var o=n(2),s=i(o),a=n(86),r=i(a),l=n(87),u=i(l),c=n(174);n(176);var d=function(t,e){if(t){var n=u["default"].transformProperty;t.style[n]=t.style[n].replace(/rotateX\(.+?deg\)/gi,"")+(" rotateX("+e+"deg)")}},p=36,f={3:-45,5:-20,7:-15};e["default"]={props:{values:{type:Array,"default":function(){return[]}},value:{},visibleItemCount:{type:Number,"default":5},rotateEffect:{type:Boolean,"default":!1},divider:{type:Boolean,"default":!1},textAlign:{type:String,"default":"center"},flex:{},className:{},content:{}},data:function(){return{dragging:!1,animationFrameId:null}},computed:{classNames:function(){var t="picker-slot-",e=[];this.rotateEffect&&e.push(t+"absolute");var n=this.textAlign||"center";return e.push(t+n),this.divider&&e.push(t+"divider"),this.className&&e.push(this.className),e.join(" ")},contentHeight:function(){return p*this.visibleItemCount},valueIndex:function(){return this.values.indexOf(this.value)},dragRange:function(){var t=this.values,e=this.visibleItemCount;return[-p*(t.length-Math.ceil(e/2)),p*Math.floor(e/2)]}},methods:{value2Translate:function(t){var e=this.values,n=e.indexOf(t),i=Math.floor(this.visibleItemCount/2);if(n!==-1)return(n-i)*-p},translate2Value:function(t){t=Math.round(t/p)*p;var e=-(t-Math.floor(this.visibleItemCount/2)*p)/p;return this.values[e]},updateRotate:function(t,e){if(!this.divider){var n=this.dragRange,i=this.$els.wrapper;e||(e=i.querySelectorAll(".picker-item")),void 0===t&&(t=u["default"].getElementTranslate(i).top);var o=Math.ceil(this.visibleItemCount/2),s=f[this.visibleItemCount]||-20;[].forEach.call(e,function(e,i){var a=i*p,r=n[1]-t,l=a-r,u=l/p,f=s*u;f>180&&(f=180),f<-180&&(f=-180),d(e,f),Math.abs(u)>o?(0,c.addClass)(e,"picker-item-far"):(0,c.removeClass)(e,"picker-item-far")})}},planUpdateRotate:function(){var t=this,e=this.$els.wrapper;cancelAnimationFrame(this.animationFrameId),this.animationFrameId=requestAnimationFrame(function(){t.updateRotate()}),(0,c.once)(e,u["default"].transitionEndProperty,function(){t.animationFrameId=null,cancelAnimationFrame(t.animationFrameId)})},initEvents:function(){var t,e,n,i=this,o=this.$els.wrapper,a={};(0,r["default"])(o,{start:function(t){cancelAnimationFrame(i.animationFrameId),i.animationFrameId=null,a={range:i.dragRange,start:new Date,startLeft:t.pageX,startTop:t.pageY,startTranslateTop:u["default"].getElementTranslate(o).top},n=o.querySelectorAll(".picker-item")},drag:function(s){i.dragging=!0,a.left=s.pageX,a.top=s.pageY;var r=a.top-a.startTop,l=a.startTranslateTop+r;u["default"].translateElement(o,null,l),t=l-e||l,e=l,i.rotateEffect&&i.updateRotate(e,n)},end:function(){i.dragging=!1;var e,n=7,r=u["default"].getElementTranslate(o).top,l=new Date-a.start;l<300&&(e=r+t*n);var c=a.range;s["default"].nextTick(function(){var t;t=e?Math.round(e/p)*p:Math.round(r/p)*p,t=Math.max(Math.min(t,c[1]),c[0]),u["default"].translateElement(o,null,t),i.value=i.translate2Value(t),i.rotateEffect&&i.planUpdateRotate()}),a={}}})},doOnValueChange:function(){var t=this.value,e=this.$els.wrapper;u["default"].translateElement(e,null,this.value2Translate(t))},doOnValuesChange:function(){var t=this.$el,e=t.querySelectorAll(".picker-item");[].forEach.call(e,function(t,e){u["default"].translateElement(t,null,p*e)}),this.rotateEffect&&this.planUpdateRotate()}},ready:function(){this.ready=!0,this.divider||(this.initEvents(),this.doOnValueChange()),this.rotateEffect&&this.doOnValuesChange()},watch:{values:function(t){var e=this;this.valueIndex===-1&&(this.value=(t||[])[0]),this.rotateEffect&&s["default"].nextTick(function(){e.doOnValuesChange()})},value:function(){this.doOnValueChange(),this.rotateEffect&&this.planUpdateRotate(),this.$dispatch("slotValueChange",this)}}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e["default"]={name:"mt-picker",props:{slots:{type:Array},showToolbar:{type:Boolean,"default":!1},visibleItemCount:{type:Number,"default":5},rotateEffect:{type:Boolean,"default":!1}},beforeCompile:function(){var t=this.slots||[];this.values=[];var e=this.values,n=0;t.forEach(function(t){t.divider||(t.valueIndex=n++,e[t.valueIndex]=(t.values||[])[t.defaultIndex||0])})},methods:{getSlot:function(t){var e,n=this.slots||[],i=0,o=this.$children;return n.forEach(function(n,s){n.divider||(t===i&&(e=o[s]),i++)}),e},getSlotValue:function(t){var e=this.getSlot(t);return e?e.value:null},setSlotValue:function(t,e){
	var n=this.getSlot(t);n&&(n.value=e)},getSlotValues:function(t){var e=this.getSlot(t);return e?e.values:null},setSlotValues:function(t,e){var n=this.getSlot(t);n&&(n.values=e)},getValues:function(){return this.values},setValues:function(t){var e=this,n=this.slotCount;if(t=t||[],n!==t.length)throw new Error("values length is not equal slot count.");t.forEach(function(t,n){e.setSlotValue(n,t)})}},events:{slotValueChange:function(){this.$emit("change",this,this.values)}},computed:{values:function i(){var t=this.slots||[],i=[];return t.forEach(function(t){t.divider||i.push(t.value)}),i},slotCount:function(){var t=this.slots||[],e=0;return t.forEach(function(t){t.divider||e++}),e}},components:{PickerSlot:n(53)}}},function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0});var o=n(5),s=i(o);n(10),e["default"]={name:"mt-popup",mixins:[s["default"]],props:{modal:{"default":!0},closeOnClickModal:{"default":!0},popupTransition:{type:String,"default":"popup-slide"},position:{type:String,"default":""}},compiled:function(){"popup-fade"!==this.popupTransition&&(this.popupTransition="popup-slide-"+this.position)}}},function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e["default"]={name:"mt-progress",props:{value:{type:Number},barHeight:{type:Number,"default":3}}}},function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),s=i(o);e["default"]={name:"mt-radio",props:{title:String,align:String,options:{type:Array,required:!0},value:String},components:{XCell:s["default"]}}},function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0});var o=n(91),s=i(o);e["default"]={name:"mt-range",props:{min:{type:Number,"default":0},max:{type:Number,"default":100},step:{type:Number,"default":1},disabled:{type:Boolean,"default":!1},value:{type:Number},barHeight:{type:Number,"default":1}},computed:{progress:function(){var t=this.value;return"undefined"==typeof t||null===t?0:Math.floor((t-this.min)/(this.max-this.min)*100)}},ready:function(){var t=this,e=this.$els,n=e.thumb,i=e.content,o=function(){var t=i.getBoundingClientRect(),e=n.getBoundingClientRect();return{left:e.left-t.left,top:e.top-t.top}},a={};(0,s["default"])(n,{start:function(){if(!t.disabled){var e=o();a={thumbStartLeft:e.left,thumbStartTop:e.top}}},drag:function(e){if(!t.disabled){var n=i.getBoundingClientRect(),o=e.pageX-n.left-a.thumbStartLeft,s=Math.ceil((t.max-t.min)/t.step),r=a.thumbStartLeft+o-(a.thumbStartLeft+o)%(n.width/s),l=r/n.width;l<0?l=0:l>1&&(l=1),t.value=Math.round(t.min+l*(t.max-t.min))}},end:function(){t.disabled||(a={})}})}}},function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),s=i(o);e["default"]={name:"mt-search",data:function(){return{visible:!1}},components:{XCell:s["default"]},props:{value:String,cancelText:{"default":"取消"},placeholder:{"default":"搜索"},result:Array}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var i=["snake","double-bounce","triple-bounce","fading-circle"],o=function(t){return"[object Number]"==={}.toString.call(t)?(i.length<=t&&(console.warn("'"+t+"' spinner not found, use the default spinner."),t=0),i[t]):(i.indexOf(t)===-1&&(console.warn("'"+t+"' spinner not found, use the default spinner."),t=i[0]),t)};e["default"]={name:"mt-spinner",computed:{spinner:function(){return"spinner-"+o(this.type)}},components:{SpinnerSnake:n(62),SpinnerDoubleBounce:n(61),SpinnerTripleBounce:n(63),SpinnerFadingCircle:n(6)},props:{type:{"default":0},size:{type:Number,"default":28},color:{type:String,"default":"#ccc"}}}},function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e["default"]={computed:{spinnerColor:function(){return this.color||this.$parent.color||"#ccc"},spinnerSize:function(){return(this.size||this.$parent.size||28)+"px"}},props:{size:Number,color:String}}},function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0});var o=n(3),s=i(o);e["default"]={name:"double-bounce",mixins:[s["default"]]}},function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0});var o=n(3),s=i(o);e["default"]={name:"fading-circle",mixins:[s["default"]]}},function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0});var o=n(3),s=i(o);e["default"]={name:"snake",mixins:[s["default"]]}},function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0});var o=n(3),s=i(o);e["default"]={name:"triple-bounce",mixins:[s["default"]],computed:{spinnerSize:function(){return(this.size||this.$parent.size||28)/3+"px"},bounceStyle:function(){return{width:this.spinnerSize,height:this.spinnerSize,backgroundColor:this.spinnerColor}}}}},function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e["default"]={name:"mt-switch",props:{value:Boolean}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),n(4),e["default"]={name:"mt-tab-container-item",props:{id:""}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),n(4),e["default"]={name:"mt-tab-container",props:{active:""}}},function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e["default"]={name:"mt-tab-item",props:{id:""}}},function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e["default"]={name:"mt-tabbar",props:{fixed:Boolean,selected:""}}},function(t,e){},function(t,e){},function(t,e){},function(t,e){},function(t,e){},function(t,e){},function(t,e){},function(t,e){},function(t,e){},function(t,e){},function(t,e){},function(t,e){},function(t,e){},function(t,e){},function(t,e){},function(t,e){},function(t,e){},function(t,e){},function(t,e){},function(t,e){},function(t,e){},function(t,e){},function(t,e){},function(t,e){},function(t,e){},function(t,e){},function(t,e){},function(t,e){},function(t,e){},function(t,e){},function(t,e){t.exports="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiIgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiBmaWxsPSJ3aGl0ZSI+CiAgPHBhdGggb3BhY2l0eT0iLjI1IiBkPSJNMTYgMCBBMTYgMTYgMCAwIDAgMTYgMzIgQTE2IDE2IDAgMCAwIDE2IDAgTTE2IDQgQTEyIDEyIDAgMCAxIDE2IDI4IEExMiAxMiAwIDAgMSAxNiA0Ii8+CiAgPHBhdGggZD0iTTE2IDAgQTE2IDE2IDAgMCAxIDMyIDE2IEwyOCAxNiBBMTIgMTIgMCAwIDAgMTYgNHoiPgogICAgPGFuaW1hdGVUcmFuc2Zvcm0gYXR0cmlidXRlTmFtZT0idHJhbnNmb3JtIiB0eXBlPSJyb3RhdGUiIGZyb209IjAgMTYgMTYiIHRvPSIzNjAgMTYgMTYiIGR1cj0iMC44cyIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIC8+CiAgPC9wYXRoPgo8L3N2Zz4K"},function(t,e,n){!function(e,n){t.exports=n()}(this,function(){"use strict";var t={bind:function(){var t=this;this.handler=function(e){t.vm&&!t.el.contains(e.target)&&t.vm.$eval(t.expression)},document.addEventListener("click",this.handler)},unbind:function(){document.removeEventListener("click",this.handler)},install:function(t){t.directive("clickoutside",{bind:this.bind,unbind:this.unbind})}};return t})},function(t,e,n){!function(t,n){n(e)}(this,function(t){"use strict";function e(t){t.directive("infiniteScroll",u)}var n=function(t,e){var n,i,o,s,a,r=function(){t.apply(s,a),i=n};return function(){if(s=this,a=arguments,n=Date.now(),o&&(clearTimeout(o),o=null),i){var t=e-(n-i);t<0?r():o=setTimeout(function(){r()},t)}else r()}},i=function(t){return t===window?Math.max(window.pageYOffset||0,document.documentElement.scrollTop):t.scrollTop},o=document.defaultView.getComputedStyle,s=function(t){for(var e=t;e&&"HTML"!==e.tagName&&"BODY"!==e.tagName&&1===e.nodeType;){var n=o(e).overflowY;if("scroll"===n||"auto"===n)return e;e=e.parentNode}return window},a=function(t){return t===window?document.documentElement.clientHeight:t.clientHeight},r=function(t){return t===window?i(window):t.getBoundingClientRect().top+i(window)},l=function(t){for(var e=t.parentNode;e;){if("HTML"===e.tagName)return!0;if(11===e.nodeType)return!1;e=e.parentNode}return!1},u={doBind:function(){if(!this.binded){this.binded=!0;var t=this,e=t.el;t.scrollEventTarget=s(e),t.scrollListener=n(t.doCheck.bind(t),200),t.scrollEventTarget.addEventListener("scroll",t.scrollListener);var i=e.getAttribute("infinite-scroll-disabled"),o=!1;i&&(this.vm.$watch(i,function(e){t.disabled=e,!e&&t.immediateCheck&&t.doCheck()}),o=Boolean(t.vm.$get(i))),t.disabled=o;var a=e.getAttribute("infinite-scroll-distance"),r=0;a&&(r=Number(t.vm.$get(a)),isNaN(r)&&(r=0)),t.distance=r;var l=e.getAttribute("infinite-scroll-immediate-check"),u=!0;l&&(u=Boolean(t.vm.$get(l))),t.immediateCheck=u,u&&t.doCheck();var c=e.getAttribute("infinite-scroll-listen-for-event");c&&t.vm.$on(c,function(){t.doCheck()})}},doCheck:function(t){var e=this.scrollEventTarget,n=this.el,o=this.distance;if(t===!0||!this.disabled){var s=i(e),l=s+a(e),u=!1;if(e===n)u=e.scrollHeight-l<=o;else{var c=r(n)-r(e)+n.offsetHeight+s;u=l+o>=c}u&&this.expression&&this.vm.$get(this.expression)}},bind:function(){var t=this,e=this.el;t.vm.$on("hook:ready",function(){l(e)&&t.doBind()}),this.bindTryCount=0;var n=function i(){t.bindTryCount>10||(t.bindTryCount++,l(e)?t.doBind():setTimeout(i,50))};n()},unbind:function(){this.scrollEventTarget.removeEventListener("scroll",this.scrollListener)}};window.Vue&&(window.infiniteScroll=u,Vue.use(e)),t.install=e,t.infiniteScroll=u})},function(t,e){"use strict";e.install=function(t,e){var n="data:img/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABAQMAAAAl21bKAAAAA1BMVEXs7Oxc9QatAAAACklEQVQI12NgAAAAAgAB4iG8MwAAAABJRU5ErkJggg==";e||(e={error:n,loading:n,"try":3});var i={error:e.error?e.error:n,loading:e.loading?e.loading:n,hasbind:!1,isInChild:!1,childEl:null,"try":e["try"]?e["try"]:1},o=[],s=function(t,e){var n=void 0;return function(){var i=this,o=arguments;clearTimeout(n),n=setTimeout(function(){t.apply(i,o)},e)}},a=s(function(){for(var t=0;t<o.length;++t){var e=o[t];r(e)}},300),r=function(t){var e=void 0,n=void 0;t.parentEl?(e=t.parentEl.offsetHeight,n=t.parentEl.scrollTop):(e=window.screen.availHeight,n=document.documentElement.scrollTop||document.body.scrollTop);var i=(n+e)*window.devicePixelRatio*1.3;t.y<i&&l(t)},l=function(t){return!(t["try"]>=i["try"])&&(t["try"]++,void u(t).then(function(e){var n=o.indexOf(t);n!==-1&&o.splice(n,1),t.bindType?t.el.setAttribute("style",t.bindType+": url("+t.src+")"):t.el.setAttribute("src",t.src),t.el.setAttribute("lazy","loaded")})["catch"](function(e){t.bindType?t.el.setAttribute("style",t.bindType+": url("+i.error+")"):t.el.setAttribute("src",i.error),t.el.setAttribute("lazy","error")}))},u=function(t){return t.bindType?t.el.setAttribute("style",t.bindType+": url("+i.loading+")"):t.el.setAttribute("src",i.loading),new Promise(function(e,n){var i=new Image;i.src=t.src,i.onload=function(){e(t.src)},i.onerror=function(){n()}})},c=function(t){var e=void 0,i=o.length;for(t=t||n,e=0;e<i;e++)o[e].src==t&&o.splice(e,1);0==o.length&&(window.removeEventListener("scroll",a),window.removeEventListener("wheel",a),window.removeEventListener("mousewheel",a),window.removeEventListener("resize",a))},d=function(t){var e=t.offsetTop,n=t.offsetHeight;for(e;t=t.offsetParent;)e+=t.offsetTop;return{y:(e+n)*window.devicePixelRatio}};t.directive("lazy",{bind:function(){var e=this;i.hasbind||t.nextTick(function(){document.getElementById(Object.keys(e.modifiers)[0])&&(i.isInChild=!0,i.childEl=document.getElementById(Object.keys(e.modifiers)[0])),i.hasbind=!0,i.isInChild&&i.childEl.addEventListener("scroll",a),window.addEventListener("scroll",a),window.addEventListener("wheel",a),window.addEventListener("mousewheel",a),window.addEventListener("resize",a),a()})},update:function(t,e){var n=this;this.el.setAttribute("lazy","loading"),this.arg?this.el.setAttribute("style",this.arg+": url("+i.loading+")"):this.el.setAttribute("src",i.loading);var s=null;this.vm.$nextTick(function(){document.getElementById(Object.keys(n.modifiers)[0])&&(s=document.getElementById(Object.keys(n.modifiers)[0]));var e=d(n.el);o.push({bindType:n.arg,"try":0,parentEl:s,el:n.el,src:t,y:e.y}),a()})},unbind:function(t){c(t)}})}},function(t,e,n){!function(e,i){t.exports=i(n(2))}(this,function(t){return function(t){function e(i){if(n[i])return n[i].exports;var o=n[i]={exports:{},id:i,loaded:!1};return t[i].call(o.exports,o,o.exports,e),o.loaded=!0,o.exports}var n={};return e.m=t,e.c=n,e.p="/lib/",e(0)}([function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0}),e["default"]=function(t){t=t||{};var e=void 0,n=void 0,i=void 0,o=void 0,a=void 0;"string"==typeof t?(e=t,i=3e3,n="middle",o="",a=""):(e=t.message,i=t.duration||3e3,n=t.position||"middle",o=t.className||"",a=t.iconClass||"");var r=l();r.message=e,r.position=n,r.className=o,r.iconClass=a,s["default"].nextTick(function(){r.$appendTo(document.body),setTimeout(function(){r.$remove(),u(r)},i)})};var o=n(5),s=i(o),a=s["default"].extend(n(3)),r=[],l=function(){if(r.length>0){var t=r[0];return r.splice(0,1),t}return new a({el:document.createElement("div")})},u=function(t){t&&r.push(t)}},function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e["default"]={props:{message:String,className:{type:String,"default":""},position:{type:String,"default":"middle"},iconClass:{type:String,"default":""}},computed:{customClass:function(){var t=[];switch(this.position){case"top":t.push("is-placetop");break;case"bottom":t.push("is-placebottom");break;default:t.push("is-placemiddle")}return t.push(this.className),t.join(" ")}}}},function(t,e){t.exports="<div class=\"mint-toast {{ customClass }}\" transition=mint-toast-pop :style=\"{ 'padding': iconClass === '' ? '10px' : '20px' }\"> <i class=\"mint-toast-icon {{ iconClass }}\" v-if=\"iconClass !== ''\"></i> <span class=mint-toast-text :style=\"{ 'padding-top': iconClass === '' ? '0' : '10px' }\">{{ message }}</span> </div>"},function(t,e,n){var i,o;n(4),i=n(1),o=n(2),t.exports=i||{},t.exports.__esModule&&(t.exports=t.exports["default"]),o&&(("function"==typeof t.exports?t.exports.options:t.exports).template=o)},function(t,e){},function(e,n){e.exports=t}])})},function(t,e){var n=function(t){return(t||"").replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g,"")},i=function(t,e){if(!t||!e)return!1;if(e.indexOf(" ")!=-1)throw new Error("className should not contain space.");return t.classList?t.classList.contains(e):(" "+t.className+" ").indexOf(" "+e+" ")>-1},o=function(t,e){if(t){for(var n=t.className,o=(e||"").split(" "),s=0,a=o.length;s<a;s++){var r=o[s];r&&(t.classList?t.classList.add(r):i(t,r)||(n+=" "+r))}t.classList||(t.className=n)}},s=function(t,e){if(t&&e){for(var o=e.split(" "),s=" "+t.className+" ",a=0,r=o.length;a<r;a++){var l=o[a];l&&(t.classList?t.classList.remove(l):i(t,l)&&(s=s.replace(" "+l+" "," ")))}t.classList||(t.className=n(s))}};t.exports={hasClass:i,addClass:o,removeClass:s}},function(t,e){var n=function(t,e){if(!t)return null;var i,o;if("string"==typeof t)return document.createTextNode(t);if(t.tag){i=document.createElement(t.tag);for(var s in t)if(t.hasOwnProperty(s)){if("content"===s||"tag"===s)continue;if("key"===s&&e){var a=t[s];a&&(e[a]=i);continue}i[s]=t[s]}var r=t.content;if(r)if("string"==typeof r)o=document.createTextNode(r),i.appendChild(o);else{r instanceof Array||(r=[r]);for(var l=0,u=r.length;l<u;l++){var c=r[l];o=n(c,e),i.appendChild(o)}}}return i};t.exports=n},function(t,e){var n=function(){return document.addEventListener?function(t,e,n){t&&e&&n&&t.addEventListener(e,n,!1)}:function(t,e,n){t&&e&&n&&t.attachEvent("on"+e,n)}}(),i=function(){return document.removeEventListener?function(t,e,n){t&&e&&t.removeEventListener(e,n,!1)}:function(t,e,n){t&&e&&t.detachEvent("on"+e,n)}}(),o=function(t,e,o){var s=function(){o&&o.apply(this,arguments),i(t,e,s)};n(t,e,s)};t.exports={on:n,off:i,once:o}},function(t,e,n){var i=n(171),o=n(173),s=n(175),a=n(172);t.exports={on:o.on,off:o.off,once:o.once,getStyle:s.getStyle,setStyle:s.setStyle,removeClass:i.removeClass,addClass:i.addClass,hasClass:i.hasClass,create:a}},function(t,e){function n(t){return t.replace(i,function(t,e,n,i){return i?n.toUpperCase():n}).replace(o,"Moz$1")}var i=/([\:\-\_]+(.))/g,o=/^moz([A-Z])/,s=Number(document.documentMode),a=s<9?function(t,e){if(!t||!e)return null;e=n(e),"float"===e&&(e="styleFloat");try{switch(e){case"opacity":try{return t.filters.item("alpha").opacity/100}catch(i){return 1}break;default:return t.style[e]||t.currentStyle?t.currentStyle[e]:null}}catch(i){return t.style[e]}}:function(t,e){if(!t||!e)return null;e=n(e),"float"===e&&(e="cssFloat");try{var i=document.defaultView.getComputedStyle(t,"");return t.style[e]||i?i[e]:null}catch(o){return t.style[e]}},r=function(t,e,i){if(t&&e)if("object"==typeof e)for(var o in e)e.hasOwnProperty(o)&&r(t,o,e[o]);else e=n(e),"opacity"===e&&s<9?t.style.filter=isNaN(i)?"":"alpha(opacity="+100*i+")":t.style[e]=i};t.exports={getStyle:a,setStyle:r}},function(t,e){!function(t){for(var e=0,n=["webkit","moz"],i=t.requestAnimationFrame,o=t.cancelAnimationFrame,s=n.length;--s>=0&&!i;)i=t[n[s]+"RequestAnimationFrame"],o=t[n[s]+"CancelAnimationFrame"];i&&o||(i=function(t){var n=+new Date,i=Math.max(e+16,n);return setTimeout(function(){t(e=i)},i-n)},o=clearTimeout),t.requestAnimationFrame=i,t.cancelAnimationFrame=o}(window)}])});

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _token = __webpack_require__(604);
	
	var _token2 = _interopRequireDefault(_token);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function plugin() {
	    if ($) {
	        var csrfSafeMethod = function csrfSafeMethod(method) {
	            // these HTTP methods do not require CSRF protection
	            return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method)
	            );
	        };
	
	        $(document).on('ajaxBeforeSend', function (e, xhr, settings) {
	            //console.log("heelo");
	            if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
	                xhr.setRequestHeader("X-CSRFToken", (0, _token2.default)());
	            }
	        });
	    }
	} /**
	   * Created by yanguoxu on 16/7/26.
	   */
	exports.default = plugin;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 620 */
/***/ (function(module, exports) {

	module.exports = "<div style=height:100%> <router-view></router-view> </div>";

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(359);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _typeof2 = __webpack_require__(4);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _stringify = __webpack_require__(364);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _axios = __webpack_require__(371);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getUUID() {
	  var _uuid = null;
	  if (window.localStorage) {
	    _uuid = window.localStorage.getItem('_uuid');
	  }
	
	  if (!_uuid) {
	    _uuid = 'xxxxxyxxxxxyxx4xxxyxxxxxyxxxxxyxxxxx'.replace(/[xy]/g, function (c) {
	      var r = Math.random() * 16 | 0,
	          v = c == 'x' ? r : r & 0x3 | 0x8;
	      return v.toString(16);
	    });
	
	    try {
	      window.localStorage.setItem('_uuid', _uuid);
	    } catch (error) {}
	  }
	
	  return _uuid;
	} /*
	   * pageview 日活上报
	   * @author: chenzhou
	   * @update: 2021.9.1
	   * @desc
	   */
	
	var dailyReport = {
	  options: {
	    // 上报数据结构
	    log: {
	      // 平台 1：学堂 2：雨课堂 3：学堂云 ...
	      platform: 2,
	      terminal_type: 'h5',
	      time: new Date().getTime(),
	      language: 'zh_CN',
	      // 原始ID 默认UUID
	      original_id: getUUID(),
	      // 用户ID
	      distinct_id: '',
	      event: 'page_view',
	      properties: {
	        channel: ''
	      }
	    }
	  },
	
	  /**
	   * @method 用户ID读取
	   * @params
	   */
	  getUserId: function getUserId(data) {
	    try {
	      var key = 'Report.Daily.User';
	      var user = null;
	      var uid = data && data.userId || window.user_id;
	
	      try {
	        // 本地缓存查找用户信息
	        if (window.localStorage && window.localStorage[key]) {
	          user = JSON.parse(window.localStorage.getItem(key));
	        }
	
	        // 用户ID缓存到本地
	        if (!user && uid) {
	          window.localStorage.setItem(key, (0, _stringify2.default)({ id: uid }));
	        }
	      } catch (error) {
	        console.error(error);
	      }
	
	      if (!uid) {
	        // 查找本地缓存 还是 请求接口读取
	        if (user && user.id) {
	          uid = user.id;
	        }
	      }
	
	      return uid;
	    } catch (error) {
	      return null;
	    }
	  },
	
	
	  /**
	   * @method 更新日志数据
	   * @params
	   */
	  updateLog: function updateLog(data, updateProperties) {
	    var log = this.options.log;
	
	    if (updateProperties && (typeof data === 'undefined' ? 'undefined' : (0, _typeof3.default)(data)) === 'object') {
	      log.properties = (0, _assign2.default)(log.properties, data);
	      return;
	    }
	
	    if (log && (typeof data === 'undefined' ? 'undefined' : (0, _typeof3.default)(data)) === 'object') {
	      (0, _assign2.default)(log, data);
	    }
	  },
	
	
	  /**
	   * @method 更新用户Id
	   * @params
	   */
	  updateUserId: function updateUserId(data) {
	    var log = this.options.log;
	    var uid = this.getUserId(data);
	
	    // 大数据要求未登录时distinct_id 传空
	    // if(!uid) {
	    //   // 上报的用户Id不存在 使用设备ID保底
	    //   if(!log.distinct_id) {
	    //     uid = log.original_id;
	    //   }
	    // }
	
	    uid && this.updateLog({ distinct_id: uid });
	  },
	
	
	  /**
	   * @method 打点
	   * @params
	   */
	  initLog: function initLog() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var log = this.options.log;
	
	    try {
	      // 各项目需要根据项目store取
	      // let uid = data && data.userId || window.user_id || log.original_id;
	
	      // 检测矫正UserId
	      this.updateUserId(data);
	
	      var properties = (0, _assign2.default)(log.properties, data.properties, {
	        channel: '',
	        user_agent: navigator.userAgent,
	        page_name: document.title,
	        host: location.host,
	        url: location.href,
	        referer: document.referrer,
	        original_referrer: document.referrer
	      });
	
	      this.options.log = (0, _assign2.default)({}, log, {
	        time: new Date().getTime(),
	        // distinct_id: uid,
	        properties: properties
	      });
	
	      return this.options.log;
	    } catch (error) {
	      console.error('[initLog] exception:%s', error);
	
	      return log;
	    }
	  },
	
	
	  /**
	   * @method 上报
	   * @params
	   */
	  reportLog: function reportLog(data) {
	    var URL = '/video-log/log/track/';
	
	    var log = this.initLog(data);
	    if (!log) {
	      log = this.options.log;
	    }
	
	    var params = {
	      'uip': '',
	      'data': log,
	      'ts_ms': new Date().getTime()
	    };
	
	    _axios2.default.post(URL, params);
	  }
	};
	
	exports.default = dailyReport;

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(359);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _axios = __webpack_require__(371);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getUUID() {
	  var _uuid = null;
	  if (window.localStorage) {
	    _uuid = window.localStorage.getItem('_uuid');
	  }
	
	  if (!_uuid) {
	    _uuid = 'xxxxxyxxxxxyxx4xxxyxxxxxyxxxxxyxxxxx'.replace(/[xy]/g, function (c) {
	      var r = Math.random() * 16 | 0,
	          v = c == 'x' ? r : r & 0x3 | 0x8;
	      return v.toString(16);
	    });
	
	    try {
	      window.localStorage.setItem('_uuid', _uuid);
	    } catch (error) {}
	  }
	
	  return _uuid;
	} /**
	   * @author [tuqiushuang]
	   * @email [tuqiushuang@xuetangx.com]
	   * @create date 2022-01-05 10:57:25
	   * @modify date 2022-01-05 10:57:25
	   * @desc [埋点上报]
	   */
	
	var sensorsDataReprot = {
	  options: {
	    // 上报数据结构
	    log: {
	      // 平台 1：学堂 2：雨课堂 3：学堂云 ...
	      platform: 2,
	      terminal_type: function () {
	        var sUserAgent = navigator.userAgent.toLowerCase();
	        if (sUserAgent && /flutterapp/i.test(sUserAgent)) {
	          return 'app-h5';
	        } else if (window.__wxjs_environment && window.__wxjs_environment === 'miniprogram') {
	          return 'minimp-h5';
	        } else if (sUserAgent && /MicroMessenger/i.test(sUserAgent)) {
	          return 'gzh-h5';
	        } else if (sUserAgent && /(ipad|iphone os|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile|webview)/i.test(sUserAgent)) {
	          return 'h5';
	        }
	        return "web";
	      }(),
	      app_name: 'ykt',
	      time: new Date().getTime(),
	      language: 'zh_CN',
	      // 原始ID 默认UUID
	      original_id: getUUID(),
	      // 用户ID
	      distinct_id: '',
	      environment: function () {
	        var hostname = window.location.hostname;
	        if (/^(www.xuetangx.com|next.xuetangx.com|www.yuketang.cn)$/.test(hostname)) {
	          return 'rain';
	        } else if (/^(pre-apple-www.xuetangonline.com|pre-apple-ykt.xuetangonline.com)$/.test(hostname)) {
	          return 'wind';
	        } else if (/^(huanghe.yuketang.cn)$/.test(hostname)) {
	          return 'huanghe';
	        } else if (/^(pro.yuketang.cn)$/.test(hostname)) {
	          return 'thu';
	        } else if (/^(changjiang.yuketang.cn)$/.test(hostname)) {
	          return 'changjiang';
	        } else if (/^(rain.xuetangonline.com|gdufe.xuetangonline.com)$/.test(hostname)) {
	          return 'gc';
	        } else {
	          return 'thunder';
	        }
	      }(),
	      app_version: 'v2.0'
	    }
	  },
	
	  /**
	   * @method 用户ID读取
	   * @params
	   */
	  getUserId: function getUserId(data) {
	    try {
	      var uid = data && data.userId || window.userId;
	      if (!uid) {
	        // 各项目需要根据项目store取
	        // 新web
	        if (window.localStorage && window.localStorage.vuex) {
	          var store = JSON.parse(window.localStorage.vuex);
	          if (store && store.userInfo && store.userInfo.user_id) {
	            uid = store.userInfo.user_id;
	          }
	        }
	
	        // 新版h5
	        if (window.localStorage && window.localStorage['new-mobile-vuex']) {
	          var _store = JSON.parse(window.localStorage['new-mobile-vuex']);
	          if (_store && _store.user && _store.user.id) {
	            uid = _store.user.id;
	          }
	        }
	      }
	
	      return uid;
	    } catch (error) {
	      return null;
	    }
	  },
	
	
	  /**
	   * @method 直播打点
	   * @params
	   */
	  initLog: function initLog(data) {
	    var log = this.options.log;
	
	    try {
	
	      var uid = this.getUserId(data) || log.original_id;
	      var presetProperties = sensors.getPresetProperties();
	      if (uid) {
	        delete presetProperties._distinct_id;
	        presetProperties.distinct_id = uid;
	      } else {
	        presetProperties.distinct_id = presetProperties._distinct_id;
	        delete presetProperties._distinct_id;
	      }
	
	      log = (0, _assign2.default)({}, log, data, presetProperties, {
	        time: new Date().getTime(),
	        is_register: this.getUserId() ? true : false
	      });
	
	      return log;
	    } catch (error) {
	      console.error('[initLog] exception:%s', error.message);
	
	      return log;
	    }
	  },
	
	
	  /**
	   * @method 上报
	   * @params
	   */
	  reportLog: function reportLog(data) {
	    var URL = '/video-log/log/track/';
	
	    if (!window.sensors) return;
	
	    var log = this.initLog(data);
	    if (!log) {
	      log = this.options.log;
	    }
	
	    var params = {
	      'uip': '',
	      'data': log,
	      'ts_ms': new Date().getTime()
	    };
	
	    _axios2.default.post(URL, params);
	  }
	};
	
	exports.default = sensorsDataReprot;

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = setDocumentTitle;
	
	var _vue = __webpack_require__(438);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function setDocumentTitle() {
	    if (_vue2.default.prototype.isThu) {
	        $.resetTitle(_vue2.default.config.lang == 'zh_CN' ? '荷塘雨课堂' : 'Hetang Rainclassroom');
	    } else if (_vue2.default.prototype.isChangjiang) {
	        $.resetTitle(_vue2.default.config.lang == 'zh_CN' ? '长江雨课堂' : 'Changjiang Rainclassroom');
	    } else if (_vue2.default.prototype.isHuanghe) {
	        $.resetTitle(_vue2.default.config.lang == 'zh_CN' ? '黄河雨课堂' : 'Huanghe Rainclassroom');
	    } else if (_vue2.default.prototype.isGC) {
	        $.resetTitle(_vue2.default.config.lang == 'zh_CN' ? '广财慕课' : 'GDUFE MOOC');
	    } else if (_vue2.default.prototype.isPro) {
	        $.resetTitle(_vue2.default.config.lang == 'zh_CN' ? '云的测试' : 'QijianTest');
	    } else if (_vue2.default.prototype.isWind) {
	        $.resetTitle(_vue2.default.config.lang == 'zh_CN' ? '风测试' : 'FengTest');
	    } else if (_vue2.default.prototype.isYD) {
	        $.resetTitle(_vue2.default.config.lang == 'zh_CN' ? '雨豆' : 'Yudou');
	    } else {
	        $.resetTitle(_vue2.default.config.lang == 'zh_CN' ? '雨课堂' : 'Rain Classroom');
	    }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e=e||self,e.sensorsDataAnalytic201505=t())}(this,function(){function e(e,t,r){if(null==e)return!1;if(Ut&&e.forEach===Ut)e.forEach(t,r);else if(Ft(e)&&e.length===+e.length){for(var i=0,n=e.length;i<n;i++)if(i in e&&t.call(r,e[i],i,e)===Vt)return!1}else for(var a in e)if(qt.call(e,a)&&t.call(r,e[a],a,e)===Vt)return!1}function t(t,r){var i=[];return null==t?i:Array.prototype.map&&t.map===Array.prototype.map?t.map(r):(e(t,function(e,t,n){i.push(r(e,t,n))}),i)}function r(t){return e(Rt.call(arguments,1),function(e){for(var r in e)qt.call(e,r)&&void 0!==e[r]&&(t[r]=e[r])}),t}function i(t){return e(Rt.call(arguments,1),function(e){for(var i in e)void 0!==e[i]&&(f(e[i])&&f(t[i])?r(t[i],e[i]):t[i]=e[i])}),t}function n(t){return e(Rt.call(arguments,1),function(e){for(var r in e)void 0!==e[r]&&void 0===t[r]&&(t[r]=e[r])}),t}function a(e){if(!e)return!1;var t=Wt.call(e);return"[object Function]"==t||"[object AsyncFunction]"==t}function s(e){return!(!e||!qt.call(e,"callee"))}function l(e){return e?e.toArray?e.toArray():Ft(e)?Rt.call(e):s(e)?Rt.call(e):c(e):[]}function c(t){var r=[];return null==t?r:(e(t,function(e){r[r.length]=e}),r)}function u(e,t){var r=e.indexOf;if(r)return r.call(e,t);for(var i=0;i<e.length;i++)if(t===e[i])return i;return-1}function d(e,t,r){var i=Object.prototype.hasOwnProperty;if(e.filter)return e.filter(t);for(var n=[],a=0;a<e.length;a++)if(i.call(e,a)){var s=e[a];t.call(r,s,a,e)&&n.push(s)}return n}function p(e,t){return e.prototype=new t,e.prototype.constructor=e,e.superclass=t.prototype,e}function _(e){return e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,"")}function f(e){return null!=e&&"[object Object]"==Wt.call(e)}function g(e){if(f(e)){for(var t in e)if(qt.call(e,t))return!1;return!0}return!1}function h(e){return void 0===e}function v(e){return"[object String]"==Wt.call(e)}function y(e){return"[object Date]"==Wt.call(e)}function w(e){return"[object Boolean]"==Wt.call(e)}function S(e){return"[object Number]"==Wt.call(e)&&/[\d\.]+/.test(String(e))}function b(e){return!(!e||1!==e.nodeType)}function k(e){try{JSON.parse(e)}catch(t){return!1}return!0}function P(e){var t=null;try{t=JSON.parse(e)}catch(r){return!1}return t}function D(e,t,r){var i,n,a,s=null,o=0;r||(r={});var l=function(){o=r.leading===!1?0:Xt(),s=null,a=e.apply(i,n),s||(i=n=null)};return function(){var c=Xt();o||r.leading!==!1||(o=c);var u=t-(c-o);return i=this,n=arguments,u<=0||u>t?(s&&(clearTimeout(s),s=null),o=c,a=e.apply(i,n),s||(i=n=null)):s||r.trailing===!1||(s=setTimeout(l,u)),a}}function N(e){if("string"!=typeof e)return 0;var t=0,r=null;if(0==e.length)return t;for(var i=0;i<e.length;i++)r=e.charCodeAt(i),t=(t<<5)-t+r,t&=t;return t}function C(e){var t=9007199254740992,r=-9007199254740992,i=31,n=0;if(e.length>0)for(var a=e.split(""),s=0;s<a.length;s++){var o=a[s].charCodeAt(),l=i*n+o;if(l>t)for(n=r+n;l=i*n+o,l<r;)n=n/2+o;if(l<r)for(n=t+n;l=i*n+o,l>t;)n=n/2+o;n=i*n+o}return n}function $(){if("function"==typeof Uint32Array){var e="";if("undefined"!=typeof crypto?e=crypto:"undefined"!=typeof msCrypto&&(e=msCrypto),f(e)&&e.getRandomValues){var t=new Uint32Array(1),r=e.getRandomValues(t)[0],i=Math.pow(2,32);return r/i}}return zt(1e19)/1e19}function A(e){try{return JSON.stringify(e,null,"  ")}catch(t){return JSON.stringify(e)}}function j(e){for(var t,r=[],i={},n=0;n<e.length;n++)t=e[n],t in i||(i[t]=!0,r.push(t));return r}function O(e){var t="";try{t=btoa(encodeURIComponent(e).replace(/%([0-9A-F]{2})/g,function(e,t){return String.fromCharCode("0x"+t)}))}catch(r){t=e}return t}function I(e){var r=[];try{r=t(atob(e).split(""),function(e){return"%"+("00"+e.charCodeAt(0).toString(16)).slice(-2)})}catch(i){r=[]}try{return decodeURIComponent(r.join(""))}catch(i){return r.join("")}}function T(e,t){e=String(e),t="number"==typeof t?t:13;for(var r=126,i=e.split(""),n=0,a=i.length;n<a;n++){var s=i[n].charCodeAt(0);s<r&&(i[n]=String.fromCharCode((i[n].charCodeAt(0)+t)%r))}return i.join("")}function L(e){var t=13,r=126;return e=String(e),T(e,r-t)}function x(e){var t="t6KJCZa5pDdQ9khoEM3Tj70fbP2eLSyc4BrsYugARqFIw1mzlGNVXOHiWvxUn8",r=t.length-1,i={},n=0;for(n=0;n<t.length;n++)i[t.charAt(n)]=t.charAt(r-n);var a="";for(n=0;n<e.length;n++)a+=e.charAt(n)in i?i[e.charAt(n)]:e.charAt(n);return a}function E(e,t){if("string"!=typeof e)return t("\u8f6c\u6362unicode\u9519\u8bef",e),e;for(var r="",i=0;i<e.length;i++)r+="\\"+e.charCodeAt(i).toString(16);return r}function H(){var e=!0,t="__sensorsdatasupport__",r="testIsSupportStorage";try{sessionStorage&&sessionStorage.setItem?(sessionStorage.setItem(t,r),sessionStorage.removeItem(t,r),e=!0):e=!1}catch(i){e=!1}return e}function J(){if((H()&&"true"===sessionStorage.getItem("sensorsdata_jssdk_debug")||Zt.show_log)&&(!f(arguments[0])||Zt.show_log!==!0&&"string"!==Zt.show_log&&Zt.show_log!==!1||(arguments[0]=A(arguments[0])),"object"==typeof console&&console.log))try{return console.log.apply(console,arguments)}catch(e){console.log(arguments[0])}}function B(e,t){if("string"==typeof t)return U(e,t);if(Ft(t)){for(var r=!1,i=0;i<t.length;i++){var n=U(e,t[i]);if(n){r=!0;break}}return r}}function U(e,t){return e.hasAttribute?e.hasAttribute(t):e.attributes?!(!e.attributes[t]||!e.attributes[t].specified):void 0}function R(e,t){var r="",i="";return e.textContent?r=_(e.textContent):e.innerText&&(r=_(e.innerText)),r&&(r=r.replace(/[\r\n]/g," ").replace(/[ ]+/g," ").substring(0,255)),i=r||"","input"!==t&&"INPUT"!==t||("button"===e.type||"submit"===e.type?i=e.value||"":Zt.heatmap&&"function"==typeof Zt.heatmap.collect_input&&Zt.heatmap.collect_input(e)&&(i=e.value||"")),i}function M(e){e=r({success:function(){},error:function(){},appendCall:function(e){document.getElementsByTagName("head")[0].appendChild(e)}},e);var t=null;"css"===e.type&&(t=document.createElement("link"),t.rel="stylesheet",t.href=e.url),"js"===e.type&&(t=document.createElement("script"),t.async="async",t.setAttribute("charset","UTF-8"),t.src=e.url,t.type="text/javascript"),t.onload=t.onreadystatechange=function(){this.readyState&&"loaded"!==this.readyState&&"complete"!==this.readyState||(e.success(),t.onload=t.onreadystatechange=null)},t.onerror=function(){e.error(),t.onerror=null},e.appendCall(t)}function K(e){return new K.init(e)}function W(e){var t=document.createElement("style");t.type="text/css";try{t.appendChild(document.createTextNode(e))}catch(r){t.styleSheet.cssText=e}var i=document.getElementsByTagName("head")[0],n=document.getElementsByTagName("script")[0];i?i.children.length?i.insertBefore(t,i.children[0]):i.appendChild(t):n.parentNode.insertBefore(t,n)}function q(e){function t(e,t){e=_(e);var r;if("body"===e)return document.getElementsByTagName("body")[0];if(0===e.indexOf("#"))e=e.slice(1),r=document.getElementById(e);else if(e.indexOf(":nth-of-type")>-1){var i=e.split(":nth-of-type");if(!i[0]||!i[1])return null;var n=i[0],a=i[1].match(/\(([0-9]+)\)/);if(!a||!a[1])return null;var s=Number(a[1]);if(!(b(t)&&t.children&&t.children.length>0))return null;for(var o=t.children,l=0;l<o.length;l++)if(b(o[l])){var c=o[l].tagName.toLowerCase();if(c===n&&(s--,0===s)){r=o[l];break}}if(s>0)return null}return r?r:null}function r(e){var n,a=i.shift();if(!a)return e;try{n=t(a,e)}catch(s){J(s)}return n&&b(n)?r(n):null}if(!v(e))return null;var i=e.split(">"),n=null;return n=r(),n&&b(n)?n:null}function V(e){var t=e;try{t=decodeURIComponent(e)}catch(r){t=e}return t}function F(e){var t=e;try{t=decodeURI(e)}catch(r){t=e}return t}function z(e,t){t=t.replace(/[\[]/,"\\[").replace(/[\]]/,"\\]"),e=V(e);var r="[\\?&]"+t+"=([^&#]*)",i=new RegExp(r),n=i.exec(e);return null===n||n&&"string"!=typeof n[1]&&n[1].length?"":V(n[1])}function X(e){var t=function(e){this._fields={Username:4,Password:5,Port:7,Protocol:2,Host:6,Path:8,URL:0,QueryString:9,Fragment:10},this._values={},this._regex=null,this._regex=/^((\w+):\/\/)?((\w+):?(\w+)?@)?([^\/\?:]+):?(\d+)?(\/?[^\?#]+)?\??([^#]+)?#?(\w*)/,"undefined"!=typeof e&&this._parse(e)};return t.prototype.setUrl=function(e){this._parse(e)},t.prototype._initValues=function(){for(var e in this._fields)this._values[e]=""},t.prototype.addQueryString=function(e){if("object"!=typeof e)return!1;var t=this._values.QueryString||"";for(var r in e)t=new RegExp(r+"[^&]+").test(t)?t.replace(new RegExp(r+"[^&]+"),r+"="+e[r]):"&"===t.slice(-1)?t+r+"="+e[r]:""===t?r+"="+e[r]:t+"&"+r+"="+e[r];this._values.QueryString=t},t.prototype.getUrl=function(){var e="";return e+=this._values.Origin,e+=this._values.Port?":"+this._values.Port:"",e+=this._values.Path,e+=this._values.QueryString?"?"+this._values.QueryString:"",e+=this._values.Fragment?"#"+this._values.Fragment:""},t.prototype.getUrl=function(){var e="";return e+=this._values.Origin,e+=this._values.Port?":"+this._values.Port:"",e+=this._values.Path,e+=this._values.QueryString?"?"+this._values.QueryString:""},t.prototype._parse=function(e){this._initValues();var t=this._regex.exec(e);t||J("DPURLParser::_parse -> Invalid URL");for(var r in this._fields)"undefined"!=typeof t[this._fields[r]]&&(this._values[r]=t[this._fields[r]]);this._values.Hostname=this._values.Host.replace(/:\d+$/,""),this._values.Origin=this._values.Protocol+"://"+this._values.Hostname},new t(e)}function Z(e){e=e||"";for(var t=function(e){return V(e)},r={},i=e.substring(1),n=i.split("&"),a=0;a<n.length;a++){var s=n[a].indexOf("=");if(s!==-1){var o=n[a].substring(0,s),l=n[a].substring(s+1);o=t(o),l=t(l),r[o]=l}}return r}function Q(e){var t={},r=function(){var e;try{return e=new URL("http://modernizr.com/"),"http://modernizr.com/"===e.href}catch(t){return!1}};if("function"==typeof window.URL&&r())t=new URL(e),t.searchParams||(t.searchParams=function(){var e=Z(t.search);return{get:function(t){return e[t]}}}());else{var i=/^https?:\/\/.+/;i.test(e)===!1&&J("Invalid URL");var n=X(e);t.hash="",t.host=n._values.Host?n._values.Host+(n._values.Port?":"+n._values.Port:""):"",t.href=n._values.URL,t.password=n._values.Password,t.pathname=n._values.Path,t.port=n._values.Port,t.search=n._values.QueryString?"?"+n._values.QueryString:"",t.username=n._values.Username,t.hostname=n._values.Hostname,t.protocol=n._values.Protocol?n._values.Protocol+":":"",t.origin=n._values.Origin?n._values.Origin+(n._values.Port?":"+n._values.Port:""):"",t.searchParams=function(){var e=Z("?"+n._values.QueryString);return{get:function(t){return e[t]}}}()}return t}function Y(e,t){t&&"string"==typeof t||(t="hostname\u89e3\u6790\u5f02\u5e38");var r=null;try{r=Q(e).hostname}catch(i){J("getHostname\u4f20\u5165\u7684url\u53c2\u6570\u4e0d\u5408\u6cd5\uff01")}return r||t}function G(e){var t={},r=e.split("?"),i=r[1]||"";return i&&(t=Z("?"+i)),t}function ee(e){return F(v(e)?e:location.href)}function te(t){return e(t,function(e,r){y(e)?t[r]=re(e):f(e)&&(t[r]=te(e))}),t}function re(e){function t(e){return e<10?"0"+e:e}return e.getFullYear()+"-"+t(e.getMonth()+1)+"-"+t(e.getDate())+" "+t(e.getHours())+":"+t(e.getMinutes())+":"+t(e.getSeconds())+"."+t(e.getMilliseconds())}function ie(t){f(t)&&e(t,function(e,r){f(e)?ie(t[r]):y(e)&&(t[r]=re(e))})}function ne(t){var r=t.properties,i=JSON.parse(JSON.stringify(t));f(r)&&e(r,function(e,t){if(a(e))try{r[t]=e(i),a(r[t])&&(J("\u60a8\u7684\u5c5e\u6027- "+t+" \u683c\u5f0f\u4e0d\u6ee1\u8db3\u8981\u6c42\uff0c\u6211\u4eec\u5df2\u7ecf\u5c06\u5176\u5220\u9664"),delete r[t])}catch(n){delete r[t],J("\u60a8\u7684\u5c5e\u6027- "+t+" \u629b\u51fa\u4e86\u5f02\u5e38\uff0c\u6211\u4eec\u5df2\u7ecf\u5c06\u5176\u5220\u9664")}})}function ae(e){if("object"==typeof e&&e.$option){var t=e.$option;return delete e.$option,t}return{}}function se(t){var r={};return e(t,function(e,t){null!=e&&(r[t]=e)}),r}function oe(e){var t=Zt.current_domain;switch(typeof t){case"function":var r=t();return""===r||""===_(r)?"url\u89e3\u6790\u5931\u8d25":r.indexOf(".")!==-1?r:"url\u89e3\u6790\u5931\u8d25";case"string":return""===t||""===_(t)?"url\u89e3\u6790\u5931\u8d25":t.indexOf(".")!==-1?t:"url\u89e3\u6790\u5931\u8d25";default:var i=pe();return""===e?"url\u89e3\u6790\u5931\u8d25":""===i?"url\u89e3\u6790\u5931\u8d25":i}}function le(e){if(!e.target)return!1;var t=e.target,r=t.tagName.toLowerCase(),i={};return i.$element_type=r,i.$element_name=t.getAttribute("name"),i.$element_id=t.getAttribute("id"),i.$element_class_name="string"==typeof t.className?t.className:null,i.$element_target_url=t.getAttribute("href"),i.$element_content=R(t,r),i=se(i),i.$url=ee(),i.$url_path=location.pathname,i.$title=document.title,i}function ce(){var e=document.referrer,t="baidu.com";if(!e)return!1;try{var r=Q(e).hostname;return r&&r.substring(r.length-t.length)===t}catch(i){return!1}}function ue(){var e=G(document.referrer);return g(e)||!e.eqid?ir().replace(/-/g,""):e.eqid}function de(){var e=G(document.referrer);if(g(e)||!e.eqid){var t=G(location.href);return e.ck||t.utm_source?"baidu_sem_keyword_id":"baidu_other_keyword_id"}return"baidu_seo_keyword_id"}function pe(e){function t(e){return!!e&&e}e=e||location.hostname;var r=t(e);if(!r)return"";var i=r.split(".");if(Ft(i)&&i.length>=2&&!/^(\d+\.)+\d+$/.test(r))for(var n="."+i.splice(i.length-1,1);i.length>0;)if(n="."+i.splice(i.length-1,1)+n,document.cookie="sensorsdata_domain_test=true; path=/; domain="+n,document.cookie.indexOf("sensorsdata_domain_test=true")!==-1){var a=new Date;return a.setTime(a.getTime()-1e3),document.cookie="sensorsdata_domain_test=true; expires="+a.toGMTString()+"; path=/; domain="+n,n}return""}function _e(e){return e=e||document.referrer,""===e||pe(Y(e))!==pe()}function fe(e,t){return e=e||document.referrer,"string"!=typeof e?"\u53d6\u503c\u5f02\u5e38_referrer\u5f02\u5e38_"+String(e):(e=F(e),0!==e.indexOf("https://www.baidu.com/")||t||(e=e.split("?")[0]),e=e.slice(0,Zt.max_referrer_string_length),"string"==typeof e?e:"")}function ge(e){var t=Y(e);if(!t||"hostname\u89e3\u6790\u5f02\u5e38"===t)return"";var r={baidu:[/^.*\.baidu\.com$/],bing:[/^.*\.bing\.com$/],google:[/^www\.google\.com$/,/^www\.google\.com\.[a-z]{2}$/,/^www\.google\.[a-z]{2}$/],sm:[/^m\.sm\.cn$/],so:[/^.+\.so\.com$/],sogou:[/^.*\.sogou\.com$/],yahoo:[/^.*\.yahoo\.com$/]};for(var i in r)for(var n=r[i],a=0,s=n.length;a<s;a++)if(n[a].test(t))return i;return"\u672a\u77e5\u641c\u7d22\u5f15\u64ce"}function he(e,t){e=e||document.referrer;var r=Zt.source_type.keyword;if(document&&"string"==typeof e){if(0===e.indexOf("http")){var i=ge(e),n=G(e);if(g(n))return Zt.preset_properties.search_keyword_baidu&&ce()?void 0:"\u672a\u53d6\u5230\u503c";var a=null;for(var s in r)if(i===s&&"object"==typeof n)if(a=r[s],Ft(a))for(s=0;s<a.length;s++){var o=n[a[s]];if(o)return t?{active:o}:o}else if(n[a])return t?{active:n[a]}:n[a];return Zt.preset_properties.search_keyword_baidu&&ce()?void 0:"\u672a\u53d6\u5230\u503c"}return""===e?"\u672a\u53d6\u5230\u503c_\u76f4\u63a5\u6253\u5f00":"\u672a\u53d6\u5230\u503c_\u975ehttp\u7684url"}return"\u53d6\u503c\u5f02\u5e38_referrer\u5f02\u5e38_"+String(e)}function me(e){var t=z(e,"gdt_vid"),r=z(e,"hash_key"),i=z(e,"callbacks"),n={click_id:"",hash_key:"",callbacks:""};return v(t)&&t.length&&(n.click_id=16==t.length||18==t.length?t:"\u53c2\u6570\u89e3\u6790\u4e0d\u5408\u6cd5",v(r)&&r.length&&(n.hash_key=r),v(i)&&i.length&&(n.callbacks=i)),n}function ve(){function e(e,t){for(var r=0;r<e.length;r++)if(t.split("?")[0].indexOf(e[r])!==-1)return!0}var t="("+Zt.source_type.utm.join("|")+")\\=[^&]+",r=Zt.source_type.search,i=Zt.source_type.social,n=document.referrer||"",a=ar.pageProp.url;if(a){var s=a.match(new RegExp(t));return s&&s[0]?"\u4ed8\u8d39\u5e7f\u544a\u6d41\u91cf":e(r,n)?"\u81ea\u7136\u641c\u7d22\u6d41\u91cf":e(i,n)?"\u793e\u4ea4\u7f51\u7ad9\u6d41\u91cf":""===n?"\u76f4\u63a5\u6d41\u91cf":"\u5f15\u8350\u6d41\u91cf"}return"\u83b7\u53d6url\u5f02\u5e38"}function ye(){var e={items:[],enqueue:function(e){this.items.push(e),this.start()},dequeue:function(){return this.items.shift()},getCurrentItem:function(){return this.items[0]},isRun:!1,start:function(){this.items.length>0&&!this.isRun&&(this.isRun=!0,this.getCurrentItem().start())},close:function(){this.dequeue(),this.isRun=!1,this.start()}};return e}function we(){return"undefined"!=typeof window.matchMedia||"undefined"!=typeof window.msMatchMedia}function Se(){var e=screen.msOrientation||screen.mozOrientation||(screen.orientation||{}).type,t="\u672a\u53d6\u5230\u503c";if(e)t=e.indexOf("landscape")>-1?"landscape":"portrait";else if(we()){var r=window.matchMedia||window.msMatchMedia;r("(orientation: landscape)").matches?t="landscape":r("(orientation: portrait)").matches&&(t="portrait")}return t}function be(){return"undefined"!=typeof window.XMLHttpRequest&&("withCredentials"in new XMLHttpRequest||"undefined"!=typeof XDomainRequest)}function ke(){return!!navigator.userAgent.match(/iPhone|iPad|iPod/i)}function Pe(){try{var e=navigator.appVersion.match(/OS (\d+)[._](\d+)[._]?(\d+)?/);return e&&e[1]?Number.parseInt(e[1],10):""}catch(t){return""}}function De(){var e,t={},r=navigator.userAgent.toLowerCase();return(e=r.match(/opera.([\d.]+)/))?t.opera=Number(e[1].split(".")[0]):(e=r.match(/msie ([\d.]+)/))?t.ie=Number(e[1].split(".")[0]):(e=r.match(/edge.([\d.]+)/))?t.edge=Number(e[1].split(".")[0]):(e=r.match(/firefox\/([\d.]+)/))?t.firefox=Number(e[1].split(".")[0]):(e=r.match(/chrome\/([\d.]+)/))?t.chrome=Number(e[1].split(".")[0]):(e=r.match(/version\/([\d.]+).*safari/))?t.safari=Number(e[1].match(/^\d*.\d*/)):(e=r.match(/trident\/([\d.]+)/))&&(t.ie=11),t}function Ne(){var e=!1;if("object"!=typeof navigator||"function"!=typeof navigator.sendBeacon)return e;var t=De(),r=navigator.userAgent.toLowerCase();if(/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)){var i=/os [\d._]*/gi,n=r.match(i),a=(n+"").replace(/[^0-9|_.]/gi,"").replace(/_/gi,"."),s=a.split(".");"undefined"==typeof t.safari&&(t.safari=s[0]),s[0]&&s[0]<13?(t.chrome>41||t.firefox>30||t.opera>25||t.safari>12)&&(e=!0):(t.chrome>41||t.firefox>30||t.opera>25||t.safari>11.3)&&(e=!0)}else(t.chrome>38||t.edge>13||t.firefox>30||t.opera>25||t.safari>11)&&(e=!0);return e}function Ce(){function e(t){return t&&(t.preventDefault=e.preventDefault,t.stopPropagation=e.stopPropagation,t._getPath=e._getPath),t}function t(t,r,i,n){var a=function(a){if(a=a||e(window.event)){a.target=a.srcElement;var s,o,l=!0;return"function"==typeof i&&(s=i(a)),o=r.call(t,a),"beforeunload"!==n?(!1!==s&&!1!==o||(l=!1),l):void 0}};return a}e._getPath=function(){var e=this;return this.path||this.composedPath&&this.composedPath()||K(e.target).getParents()},e.preventDefault=function(){this.returnValue=!1},e.stopPropagation=function(){this.cancelBubble=!0};var r=function(r,i,n){var a=!(!f(Zt.heatmap)||!Zt.heatmap.useCapture);if(f(Zt.heatmap)&&"undefined"==typeof Zt.heatmap.useCapture&&"click"===i&&(a=!0),r&&r.addEventListener)r.addEventListener(i,function(t){t._getPath=e._getPath,n.call(this,t)},a);else{var s="on"+i,o=r[s];r[s]=t(r,n,o,i)}};r.apply(null,arguments)}function $e(e){var t="pushState"in window.history?"popstate":"hashchange";Ce(window,t,e)}function Ae(e){cr.subscribe(e)}function je(e){var t={visibleHandler:a(e.visible)?e.visible:function(){},hiddenHandler:a(e.hidden)?e.hidden:function(){},visibilityChange:null,hidden:null,isSupport:function(){return"undefined"!=typeof document[this.hidden]},init:function(){"undefined"!=typeof document.hidden?(this.hidden="hidden",this.visibilityChange="visibilitychange"):"undefined"!=typeof document.mozHidden?(this.hidden="mozHidden",this.visibilityChange="mozvisibilitychange"):"undefined"!=typeof document.msHidden?(this.hidden="msHidden",this.visibilityChange="msvisibilitychange"):"undefined"!=typeof document.webkitHidden&&(this.hidden="webkitHidden",this.visibilityChange="webkitvisibilitychange"),this.listen()},listen:function(){if(this.isSupport()){var e=this;Ce(document,this.visibilityChange,function(){document[e.hidden]?e.hiddenHandler():e.visibleHandler()},1)}else Ce(window,"focus",this.visibleHandler),Ce(window,"blur",this.hiddenHandler)}};t.init()}function Oe(e,t){t=t||window;var r=!1,i=!0,n=t.document,a=n.documentElement,s=n.addEventListener,o=s?"addEventListener":"attachEvent",l=s?"removeEventListener":"detachEvent",c=s?"":"on",u=function(i){"readystatechange"==i.type&&"complete"!=n.readyState||(("load"==i.type?t:n)[l](c+i.type,u,!1),!r&&(r=!0)&&e.call(t,i.type||i))},d=function(){try{a.doScroll("left")}catch(e){return void setTimeout(d,50)}u("poll")};if("complete"==n.readyState)e.call(t,"lazy");else{if(!s&&a.doScroll){try{i=!t.frameElement}catch(p){J(p)}i&&d()}n[o](c+"DOMContentLoaded",u,!1),n[o](c+"readystatechange",u,!1),t[o](c+"load",u,!1)}}function Ie(e){if(e)return"undefined"!=typeof window.XMLHttpRequest&&"withCredentials"in new XMLHttpRequest?new XMLHttpRequest:"undefined"!=typeof XDomainRequest?new XDomainRequest:null;if("undefined"!=typeof window.XMLHttpRequest)return new XMLHttpRequest;if(window.ActiveXObject)try{return new ActiveXObject("Msxml2.XMLHTTP")}catch(t){try{return new ActiveXObject("Microsoft.XMLHTTP")}catch(t){J(t)}}}function Te(t){function i(e){if(!e)return"";try{return JSON.parse(e)}catch(t){return{}}}function n(){try{f(a)&&a.abort&&a.abort()}catch(e){J(e)}s&&(clearTimeout(s),s=null,t.error&&t.error(),a.onreadystatechange=null,a.onload=null,a.onerror=null)}t.timeout=t.timeout||2e4,t.credentials="undefined"==typeof t.credentials||t.credentials;var a=Ie(t.cors);if(!a)return!1;t.type||(t.type=t.data?"POST":"GET"),t=r({success:function(){},error:function(){}},t),er.protocol.ajax(t.url);var s,o=t.success,l=t.error;t.success=function(e){o(e),s&&(clearTimeout(s),s=null)},t.error=function(e){l(e),s&&(clearTimeout(s),s=null)},s=setTimeout(function(){n()},t.timeout),"undefined"!=typeof XDomainRequest&&a instanceof XDomainRequest&&(a.onload=function(){t.success&&t.success(i(a.responseText)),a.onreadystatechange=null,a.onload=null,a.onerror=null},a.onerror=function(){t.error&&t.error(i(a.responseText),a.status),a.onreadystatechange=null,a.onerror=null,a.onload=null}),a.onreadystatechange=function(){try{4==a.readyState&&(a.status>=200&&a.status<300||304==a.status?t.success(i(a.responseText)):t.error(i(a.responseText),a.status),a.onreadystatechange=null,a.onload=null)}catch(e){a.onreadystatechange=null,a.onload=null}},a.open(t.type,t.url,!0);try{t.credentials&&(a.withCredentials=!0),f(t.header)&&e(t.header,function(e,t){a.setRequestHeader&&a.setRequestHeader(t,e)}),t.data&&(t.cors||a.setRequestHeader&&a.setRequestHeader("X-Requested-With","XMLHttpRequest"),"application/json"===t.contentType?a.setRequestHeader&&a.setRequestHeader("Content-type","application/json; charset=UTF-8"):a.setRequestHeader&&a.setRequestHeader("Content-type","application/x-www-form-urlencoded"))}catch(c){J(c)}a.send(t.data||null)}function Le(t){if(!f(t)||!v(t.callbackName))return J("JSONP \u8bf7\u6c42\u7f3a\u5c11 callbackName"),!1;t.success=a(t.success)?t.success:function(){},t.error=a(t.error)?t.error:function(){},t.data=t.data||"";var r=document.createElement("script"),i=document.getElementsByTagName("head")[0],n=null,s=!1;if(i.appendChild(r),S(t.timeout)&&(n=setTimeout(function(){return!s&&(t.error("timeout"),window[t.callbackName]=function(){J("call jsonp error")},n=null,i.removeChild(r),void(s=!0))},t.timeout)),window[t.callbackName]=function(){clearTimeout(n),n=null,t.success.apply(null,arguments),window[t.callbackName]=function(){J("call jsonp error")},i.removeChild(r)},t.url.indexOf("?")>-1?t.url+="&callbackName="+t.callbackName:t.url+="?callbackName="+t.callbackName,f(t.data)){var o=[];e(t.data,function(e,t){o.push(t+"="+e)}),t.data=o.join("&"),t.url+="&"+t.data}r.onerror=function(e){return!s&&(window[t.callbackName]=function(){J("call jsonp error")},clearTimeout(n),n=null,i.removeChild(r),t.error(e),void(s=!0))},r.src=t.url}function xe(e,t){for(var r in e)if(Object.prototype.hasOwnProperty.call(e,r)&&!hr.check(r,e[r],t))return!1;return!0}function Ee(t){return f(t)?(e(t,function(r,i){if(Ft(r)){var n=[];e(r,function(e){v(e)?n.push(e):J("\u60a8\u7684\u6570\u636e-",i,r,"\u7684\u6570\u7ec4\u91cc\u7684\u503c\u5fc5\u987b\u662f\u5b57\u7b26\u4e32,\u5df2\u7ecf\u5c06\u5176\u5220\u9664")}),t[i]=n}v(r)||S(r)||y(r)||w(r)||Ft(r)||a(r)||"$option"===i||(J("\u60a8\u7684\u6570\u636e-",i,r,"-\u683c\u5f0f\u4e0d\u6ee1\u8db3\u8981\u6c42\uff0c\u6211\u4eec\u5df2\u7ecf\u5c06\u5176\u5220\u9664"),delete t[i])}),t):t}function He(e,t){return S(t)&&e.length>t?(J("\u5b57\u7b26\u4e32\u957f\u5ea6\u8d85\u8fc7\u9650\u5236\uff0c\u5df2\u7ecf\u505a\u622a\u53d6--"+e),e.slice(0,t)):e}function Je(t){var r=["distinct_id","user_id","id","date","datetime","event","events","first_id","original_id","device_id","properties","second_id","time","users"];f(t)&&e(r,function(e,r){e in t&&(r<3?(delete t[e],J("\u60a8\u7684\u5c5e\u6027- "+e+"\u662f\u4fdd\u7559\u5b57\u6bb5\uff0c\u6211\u4eec\u5df2\u7ecf\u5c06\u5176\u5220\u9664")):J("\u60a8\u7684\u5c5e\u6027- "+e+"\u662f\u4fdd\u7559\u5b57\u6bb5\uff0c\u8bf7\u907f\u514d\u5176\u4f5c\u4e3a\u5c5e\u6027\u540d"))})}function Be(t){var r=["$element_selector","$element_path"],i=["sensorsdata_app_visual_properties"];f(t)&&e(t,function(e,n){if(f(e))Be(t[n]);else if(v(e)){if(u(i,n)>-1)return;t[n]=He(e,u(r,n)>-1?1024:Zt.max_string_length)}})}function Ue(e){"undefined"!=typeof e.properties.$project&&(e.project=e.properties.$project,delete e.properties.$project),"undefined"!=typeof e.properties.$token&&(e.token=e.properties.$token,delete e.properties.$token)}function Re(e){if("item_type"in e){var t=e.item_type,r=function(t){return t||delete e.item_type,!0};xe({item_type:t},r)}if("item_id"in e){var i=e.item_id,n=function(t,r,i){return t||"string"!==i||delete e.item_id,!0};xe({item_id:i},n)}}function Me(t){e(t,function(e,r){var i=function(e,i,n){return e||"keyLength"===n||delete t[r],!0};xe({propertyKey:r},i)})}function Ke(e){var t=e.properties;f(t)?(Ee(t),Je(t),Ue(e),Me(t),Be(t)):"properties"in e&&(e.properties={}),ie(e),Re(e)}function We(e){var t=!e.type||"profile"!==e.type.slice(0,7),r="\u53d6\u503c\u5f02\u5e38";f(e.properties)&&(e.properties.$first_referrer&&(e.properties.$first_referrer_host=Y(e.properties.$first_referrer,r)),t&&("$referrer"in e.properties&&(e.properties.$referrer_host=""===e.properties.$referrer?"":Y(e.properties.$referrer,r)),Jt.para.preset_properties.latest_referrer&&Jt.para.preset_properties.latest_referrer_host&&(e.properties.$latest_referrer_host=""===e.properties.$latest_referrer?"":Y(e.properties.$latest_referrer,r))))}function qe(e){var t=!e.type||"profile"!==e.type.slice(0,7),r=Jt.para.preset_properties&&t;r&&Jt.para.preset_properties.url&&"undefined"==typeof e.properties.$url&&(e.properties.$url=ee()),r&&Jt.para.preset_properties.title&&"undefined"==typeof e.properties.$title&&(e.properties.$title=document.title)}function Ve(t){r(Zt,t||Jt.para||{}),Jt.para=Zt;var i={};if(f(Jt.para.is_track_latest))for(var n in Jt.para.is_track_latest)i["latest_"+n]=Jt.para.is_track_latest[n];Jt.para.preset_properties=r({},Jt.para_default.preset_properties,i,Jt.para.preset_properties||{});var a;for(a in Jt.para_default)void 0===Jt.para[a]&&(Jt.para[a]=Jt.para_default[a]);"string"==typeof Jt.para.server_url&&(Jt.para.server_url=_(Jt.para.server_url),Jt.para.server_url&&("://"===Jt.para.server_url.slice(0,3)?Jt.para.server_url=location.protocol.slice(0,-1)+Jt.para.server_url:"//"===Jt.para.server_url.slice(0,2)?Jt.para.server_url=location.protocol+Jt.para.server_url:"http"!==Jt.para.server_url.slice(0,4)&&(Jt.para.server_url=""))),"string"!=typeof Jt.para.web_url||"://"!==Jt.para.web_url.slice(0,3)&&"//"!==Jt.para.web_url.slice(0,2)||("://"===Jt.para.web_url.slice(0,3)?Jt.para.web_url=location.protocol.slice(0,-1)+Jt.para.web_url:Jt.para.web_url=location.protocol+Jt.para.web_url),"image"!==Jt.para.send_type&&"ajax"!==Jt.para.send_type&&"beacon"!==Jt.para.send_type&&(Jt.para.send_type="image"),mr.check({loginIdKey:Jt.para.login_id_key})||(Jt.para.login_id_key="$identity_login_id"),Jt.debug.protocol.serverUrl(),Jt.bridge.initPara(),Jt.bridge.initState();var s={datasend_timeout:6e3,send_interval:6e3};or.isSupport()&&be()&&"object"==typeof localStorage?Jt.para.batch_send===!0?Jt.para.batch_send=r({},s):"object"==typeof Jt.para.batch_send&&(Jt.para.batch_send=r({},s,Jt.para.batch_send)):Jt.para.batch_send=!1;var o=["utm_source","utm_medium","utm_campaign","utm_content","utm_term"],l=["www.baidu.","m.baidu.","m.sm.cn","so.com","sogou.com","youdao.com","google.","yahoo.com/","bing.com/","ask.com/"],c=["weibo.com","renren.com","kaixin001.com","douban.com","qzone.qq.com","zhihu.com","tieba.baidu.com","weixin.qq.com"],p={baidu:["wd","word","kw","keyword"],google:"q",bing:"q",yahoo:"p",sogou:["query","keyword"],so:"q",sm:"q"};"object"==typeof Jt.para.source_type&&(Jt.para.source_type.utm=Ft(Jt.para.source_type.utm)?Jt.para.source_type.utm.concat(o):o,Jt.para.source_type.search=Ft(Jt.para.source_type.search)?Jt.para.source_type.search.concat(l):l,Jt.para.source_type.social=Ft(Jt.para.source_type.social)?Jt.para.source_type.social.concat(c):c,Jt.para.source_type.keyword=f(Jt.para.source_type.keyword)?r(p,Jt.para.source_type.keyword):p);var g={div:!1},h=["mark","/mark","strong","b","em","i","u","abbr","ins","del","s","sup"];if(Jt.para.heatmap&&!f(Jt.para.heatmap)&&(Jt.para.heatmap={}),f(Jt.para.heatmap)){Jt.para.heatmap.clickmap=Jt.para.heatmap.clickmap||"default",Jt.para.heatmap.scroll_notice_map=Jt.para.heatmap.scroll_notice_map||"default",Jt.para.heatmap.scroll_delay_time=Jt.para.heatmap.scroll_delay_time||4e3,Jt.para.heatmap.scroll_event_duration=Jt.para.heatmap.scroll_event_duration||18e3,Jt.para.heatmap.renderRefreshTime=Jt.para.heatmap.renderRefreshTime||1e3,Jt.para.heatmap.loadTimeout=Jt.para.heatmap.loadTimeout||1e3,Jt.para.heatmap.get_vtrack_config!==!0&&(Jt.para.heatmap.get_vtrack_config=!1);var m=Ft(Jt.para.heatmap.track_attr)?d(Jt.para.heatmap.track_attr,function(e){return e&&"string"==typeof e}):[];if(m.push("data-sensors-click"),Jt.para.heatmap.track_attr=m,f(Jt.para.heatmap.collect_tags))if(Jt.para.heatmap.collect_tags.div===!0)Jt.para.heatmap.collect_tags.div={ignore_tags:h,max_level:1};else if(f(Jt.para.heatmap.collect_tags.div)){if(Jt.para.heatmap.collect_tags.div.ignore_tags?Ft(Jt.para.heatmap.collect_tags.div.ignore_tags)||(Jt.log("ignore_tags \u53c2\u6570\u5fc5\u987b\u662f\u6570\u7ec4\u683c\u5f0f"),Jt.para.heatmap.collect_tags.div.ignore_tags=h):Jt.para.heatmap.collect_tags.div.ignore_tags=h,Jt.para.heatmap.collect_tags.div.max_level){var v=[1,2,3];u(v,Jt.para.heatmap.collect_tags.div.max_level)===-1&&(Jt.para.heatmap.collect_tags.div.max_level=1)}}else Jt.para.heatmap.collect_tags.div=!1;else Jt.para.heatmap.collect_tags=g}if(Ft(Jt.para.server_url)&&Jt.para.server_url.length)for(a=0;a<Jt.para.server_url.length;a++)/sa\.gif[^\/]*$/.test(Jt.para.server_url[a])||(Jt.para.server_url[a]=Jt.para.server_url[a].replace(/\/sa$/,"/sa.gif").replace(/(\/sa)(\?[^\/]+)$/,"/sa.gif$2"));else/sa\.gif[^\/]*$/.test(Jt.para.server_url)||"string"!=typeof Jt.para.server_url||(Jt.para.server_url=Jt.para.server_url.replace(/\/sa$/,"/sa.gif").replace(/(\/sa)(\?[^\/]+)$/,"/sa.gif$2"));"string"==typeof Jt.para.server_url&&(Jt.para.debug_mode_url=Jt.para.debug_mode_url||Jt.para.server_url.replace("sa.gif","debug")),Jt.para.noCache===!0?Jt.para.noCache="?"+(new Date).getTime():Jt.para.noCache="",Jt.para.callback_timeout>Jt.para.datasend_timeout&&(Jt.para.datasend_timeout=Jt.para.callback_timeout),Jt.para.heatmap&&Jt.para.heatmap.collect_tags&&f(Jt.para.heatmap.collect_tags)&&e(Jt.para.heatmap.collect_tags,function(e,t){"div"!==t&&e&&Jt.heatmap.otherTags.push(t)})}function Fe(){Jt._t=Jt._t||1*new Date,Jt.lib_version=rr,Jt.is_first_visitor=!1,Jt.source_channel_standard=tr}function ze(){if(lr.isSupport())try{sessionStorage.setItem("sensorsdata_jssdk_debug","true")}catch(e){Jt.log("enableLocalLog error: "+e.message)}}function Xe(){lr.isSupport()&&sessionStorage.removeItem("sensorsdata_jssdk_debug")}function Ze(){var e=Array.prototype.slice.call(arguments),t=e[0],r=e.slice(1);return"string"==typeof t&&yr[t]?yr[t].apply(yr,r):void("function"==typeof t?t.apply(Jt,r):Jt.log("quick\u65b9\u6cd5\u4e2d\u6ca1\u6709\u8fd9\u4e2a\u529f\u80fd"+e[0]))}function Qe(e,t){return v(e)?f(window.SensorsDataWebJSSDKPlugin)&&f(window.SensorsDataWebJSSDKPlugin[e])&&a(window.SensorsDataWebJSSDKPlugin[e].init)?(window.SensorsDataWebJSSDKPlugin[e].init(Jt,t),window.SensorsDataWebJSSDKPlugin[e]):f(Jt.modules)&&f(Jt.modules[e])&&a(Jt.modules[e].init)?(Jt.modules[e].init(Jt,t),Jt.modules[e]):void Jt.log(e+"\u6ca1\u6709\u83b7\u53d6\u5230,\u8bf7\u67e5\u9605\u6587\u6863\uff0c\u8c03\u6574"+e+"\u7684\u5f15\u5165\u987a\u5e8f\uff01"):(Jt.log("use\u63d2\u4ef6\u540d\u79f0\u5fc5\u987b\u662f\u5b57\u7b26\u4e32\uff01"),!1)}function Ye(e,t,r){mr.check({event:e,properties:t})&&mr.send({type:"track",event:e,properties:t},r)}function Ge(e,t){return!!mr.check({bindKey:e,bindValue:t})&&(Jt.store._state.identities[e]=t,Jt.store.save(),void mr.send({type:"track_id_bind",event:"$BindID",properties:{}}))}function et(e,t){if(!mr.check({bindKey:e,bindValue:t}))return!1;f(Jt.store._state.identities)&&Jt.store._state.identities.hasOwnProperty(e)&&Jt.store._state.identities[e]===t&&(delete Jt.store._state.identities[e],Jt.store.save());var r={};r[e]=t,mr.send({identities:r,type:"track_id_unbind",event:"$UnbindID",properties:{}})}function tt(e,t,r){function i(e,t,r){function i(e){function i(){a||(a=!0,location.href=n.href)}e.stopPropagation(),e.preventDefault();var a=!1;setTimeout(i,1e3),Jt.track(t,r,i)}e=e||{};var n=null;return e.ele&&(n=e.ele),e.event&&(n=e.target?e.target:e.event.target),r=r||{},!(!n||"object"!=typeof n)&&(!n.href||/^javascript/.test(n.href)||n.target||n.download||n.onclick?(Jt.track(t,r),
	!1):(e.event&&i(e.event),void(e.ele&&Ce(e.ele,"click",function(e){i(e)}))))}"object"==typeof e&&e.tagName?i({ele:e},t,r):"object"==typeof e&&e.target&&e.event&&i(e,t,r)}function rt(e,t,r){return r=r||{},!(!e||"object"!=typeof e)&&(!(!e.href||/^javascript/.test(e.href)||e.target)&&void Ce(e,"click",function(i){function n(){a||(a=!0,location.href=e.href)}i.preventDefault();var a=!1;setTimeout(n,1e3),Jt.track(t,r,n)}))}function it(e,t,r){mr.check({item_type:e,item_id:t,properties:r})&&mr.sendItem({type:"item_set",item_type:e,item_id:t,properties:r||{}})}function nt(e,t){mr.check({item_type:e,item_id:t})&&mr.sendItem({type:"item_delete",item_type:e,item_id:t})}function at(e,t){mr.check({propertiesMust:e})&&mr.send({type:"profile_set",properties:e},t)}function st(e,t){mr.check({propertiesMust:e})&&mr.send({type:"profile_set_once",properties:e},t)}function ot(t,r){mr.check({propertiesMust:t})&&(e(t,function(e,r){v(e)?t[r]=[e]:Ft(e)?t[r]=e:(delete t[r],Jt.log("appendProfile\u5c5e\u6027\u7684\u503c\u5fc5\u987b\u662f\u5b57\u7b26\u4e32\u6216\u8005\u6570\u7ec4"))}),g(t)||mr.send({type:"profile_append",properties:t},r))}function lt(e,t){function r(e){for(var t in e)if(Object.prototype.hasOwnProperty.call(e,t)&&!/-*\d+/.test(String(e[t])))return!1;return!0}var i=e;v(e)&&(e={},e[i]=1),mr.check({propertiesMust:e})&&(r(e)?mr.send({type:"profile_increment",properties:e},t):Jt.log("profile_increment\u7684\u503c\u53ea\u80fd\u662f\u6570\u5b57"))}function ct(e){mr.send({type:"profile_delete"},e),_r.set("distinct_id",ir()),_r.set("first_id","")}function ut(t,r){var i=t,n={};v(t)&&(t=[],t.push(i)),Ft(t)?(e(t,function(e){v(e)?n[e]=!0:Jt.log("profile_unset\u7ed9\u7684\u6570\u7ec4\u91cc\u9762\u7684\u503c\u5fc5\u987b\u65f6string,\u5df2\u7ecf\u8fc7\u6ee4\u6389",e)}),mr.send({type:"profile_unset",properties:n},r)):Jt.log("profile_unset\u7684\u53c2\u6570\u662f\u6570\u7ec4")}function dt(e,t){"number"==typeof e&&(e=String(e));var r=_r.getFirstId();if("undefined"==typeof e){var i=ir();r?_r.set("first_id",i):_r.set("distinct_id",i),Jt.store.identities.set("identify",i)}else mr.check({distinct_id:e})&&(t===!0?r?_r.set("first_id",e):_r.set("distinct_id",e):r?_r.change("first_id",e):_r.change("distinct_id",e))}function pt(e,t,r,i){var n=_r.getFirstId()||_r.getDistinctId();_r.set("distinct_id",e),mr.send({original_id:n,distinct_id:e,type:"track_signup",event:t,properties:r},i)}function _t(e,t,r,i){"number"==typeof e&&(e=String(e)),mr.check({distinct_id:e,event:t,properties:r})&&pt(e,t,r,i)}function ft(e){mr.check({properties:e})?r(ar.currentProps,e):Jt.log("register\u8f93\u5165\u7684\u53c2\u6570\u6709\u8bef")}function gt(e){_r.clearAllProps(e)}function ht(e){var t;if(Ft(e)&&e.length>0)for(t=0;t<e.length;t++)v(e[t])&&e[t]in ar.currentProps&&delete ar.currentProps[e[t]];else if(e===!0)for(t in ar.currentProps)delete ar.currentProps[t]}function mt(e){mr.check({properties:e})?_r.setProps(e):Jt.log("register\u8f93\u5165\u7684\u53c2\u6570\u6709\u8bef")}function vt(e){mr.check({properties:e})?_r.setPropsOnce(e):Jt.log("registerOnce\u8f93\u5165\u7684\u53c2\u6570\u6709\u8bef")}function yt(e){mr.check({properties:e})?_r.setSessionProps(e):Jt.log("registerSession\u8f93\u5165\u7684\u53c2\u6570\u6709\u8bef")}function wt(e){mr.check({properties:e})?_r.setSessionPropsOnce(e):Jt.log("registerSessionOnce\u8f93\u5165\u7684\u53c2\u6570\u6709\u8bef")}function St(e,t){if("number"==typeof e&&(e=String(e)),mr.check({distinct_id:e})&&e!==Jt.store.getDistinctId()){if(f(Jt.store._state.identities)&&Jt.store._state.identities.hasOwnProperty(Jt.para.login_id_key)&&e===Jt.store._state.first_id)return a(t)&&t(),!1;var r=Jt.store._state.history_login_id.name!==Jt.para.login_id_key||e!==Jt.store._state.history_login_id.value;if(r){Jt.store._state.identities[Jt.para.login_id_key]=e;var i=_r.getFirstId(),n=_r.getDistinctId();i||_r.set("first_id",n),pt(e,"$SignUp",{},t),Jt.store.identities.set("login",e),Jt.store.set("history_login_id",{name:Jt.para.login_id_key,value:e})}}else a(t)&&t()}function bt(e){var t=_r.getFirstId();if(t)if(_r.set("first_id",""),e===!0){var r=ir();_r.set("distinct_id",r)}else _r.set("distinct_id",t);Jt.store.identities.set("logout"),Jt.store.set("history_login_id",{name:"",value:""})}function kt(){function t(){var t=ar.campaignParams(),r={};return e(t,function(e,t,i){(" "+Jt.source_channel_standard+" ").indexOf(" "+t+" ")!==-1?r["$"+t]=i[t]:r[t]=i[t]}),r}var i={$is_first_day:sr.getNewUser(),$is_first_time:pr.is_page_first_visited,$referrer:ar.pageProp.referrer||"",$referrer_host:ar.pageProp.referrer?Y(ar.pageProp.referrer):"",$url:ee(),$url_path:location.pathname,$title:document.title||"",_distinct_id:_r.getDistinctId()},n=r({},ar.properties(),Jt.store.getProps(),t(),i);return Jt.para.preset_properties.latest_referrer&&Jt.para.preset_properties.latest_referrer_host&&(n.$latest_referrer_host=""===n.$latest_referrer?"":Y(n.$latest_referrer)),n}function Pt(){var t="",r=" { cursor: pointer; -webkit-tap-highlight-color: rgba(0,0,0,0); }";Jt.heatmap&&Ft(Jt.heatmap.otherTags)&&e(Jt.heatmap.otherTags,function(e){t+=e+r}),Jt._.isIOS()&&Jt._.getIOSVersion()&&Jt._.getIOSVersion()<13&&(Jt.para.heatmap&&Jt.para.heatmap.collect_tags&&Jt.para.heatmap.collect_tags.div&&Jt._.setCssStyle("div, [data-sensors-click]"+r),Jt.para.heatmap&&Jt.para.heatmap.track_attr&&Jt._.setCssStyle("["+Jt.para.heatmap.track_attr.join("], [")+"]"+r),""!==t&&Jt._.setCssStyle(t))}function Dt(e,t){var r=kr.encodeTrackData(t);return e.indexOf("?")!==-1?e+"&"+r:e+"?"+r}function Nt(e){return kr.encodeTrackData(e)}function Ct(e){var t=["image","ajax","beacon"],r=t[0];return r=e.config&&u(t,e.config.send_type)>-1?e.config.send_type:Jt.para.send_type,"beacon"===r&&Ne()===!1&&(r="image"),"ajax"===r&&be()===!1&&(r="image"),r}function $t(e){var t=Ct(e);switch(t){case"image":return new Pr(e);case"ajax":return new Dr(e);case"beacon":return new Nr(e);default:return new Pr(e)}}function At(e){var t=$t(e),r=t.start;return t.start=function(){var e=this;r.apply(this,arguments),setTimeout(function(){e.isEnd(!0)},Jt.para.callback_timeout)},t.end=function(){this.callback&&this.callback();var e=this;setTimeout(function(){e.lastClear&&e.lastClear()},Jt.para.datasend_timeout-Jt.para.callback_timeout)},t.isEnd=function(){this.received||(this.received=!0,this.end())},t}function jt(){this.sendingData=0,this.sendingItemKeys=[]}function Ot(e){function t(){var e=[];r.touch_app_bridge||e.push(Jt.debug.defineMode("1")),f(Jt.para.app_js_bridge)||(e.push(Jt.debug.defineMode("2")),r.verify_success=!1),f(Jt.para.heatmap)&&"default"==Jt.para.heatmap.clickmap||e.push(Jt.debug.defineMode("3")),"fail"===r.verify_success&&e.push(Jt.debug.defineMode("4"));var t={callType:"app_alert",data:e};SensorsData_App_Visual_Bridge&&SensorsData_App_Visual_Bridge.sensorsdata_visualized_alert_info?SensorsData_App_Visual_Bridge.sensorsdata_visualized_alert_info(JSON.stringify(t)):window.webkit&&window.webkit.messageHandlers&&window.webkit.messageHandlers.sensorsdataNativeTracker&&window.webkit.messageHandlers.sensorsdataNativeTracker.postMessage&&window.webkit.messageHandlers.sensorsdataNativeTracker.postMessage(JSON.stringify(t))}var r=Jt.bridge.bridge_info;if(f(window.SensorsData_App_Visual_Bridge)&&window.SensorsData_App_Visual_Bridge.sensorsdata_visualized_mode&&(window.SensorsData_App_Visual_Bridge.sensorsdata_visualized_mode===!0||window.SensorsData_App_Visual_Bridge.sensorsdata_visualized_mode()))if(f(Jt.para.heatmap)&&"default"==Jt.para.heatmap.clickmap)if(f(Jt.para.app_js_bridge)&&"success"===r.verify_success)if(e)sa_jssdk_app_define_mode(Jt,e);else{var i=location.protocol,n=["http:","https:"];i=u(n,i)>-1?i:"https:",M({success:function(){setTimeout(function(){"undefined"!=typeof sa_jssdk_app_define_mode&&sa_jssdk_app_define_mode(Jt,e)},0)},error:function(){},type:"js",url:i+"//static.sensorsdata.cn/sdk/"+Jt.lib_version+"/vapph5define.min.js"})}else t();else t()}function It(){Jt.para.is_track_single_page&&Ae(function(e){var t=function(t){t=t||{},e!==location.href&&(ar.pageProp.referrer=ee(e),Jt.quick("autoTrack",r({$url:ee(),$referrer:ee(e)},t)))};if("boolean"==typeof Jt.para.is_track_single_page)t();else if("function"==typeof Jt.para.is_track_single_page){var i=Jt.para.is_track_single_page();f(i)?t(i):i===!0&&t()}})}function Tt(){Jt._q&&Ft(Jt._q)&&Jt._q.length>0&&e(Jt._q,function(e){Jt[e[0]].apply(Jt,Array.prototype.slice.call(e[1]))}),f(Jt.para.heatmap)&&(vr.initHeatmap(),vr.initScrollmap())}function Lt(){Jt.readyState.setState(3),new Jt.JSBridge({type:"visualized",app_call_js:function(){Ot("undefined"!=typeof sa_jssdk_app_define_mode?!0:!1)}}),Ot(!1),Jt.bridge.app_js_bridge_v1(),ar.initPage(),It(),Jt.para.batch_send&&(Ce(window,"onpagehide"in window?"pagehide":"unload",function(){Jt.batchSend.clearPendingStatus()}),Jt.batchSend.batchInterval()),Jt.store.init(),Jt.vtrackBase.init(),Jt.readyState.setState(4),Tt()}function xt(){Hr.isSeachHasKeyword()?Hr.hasKeywordHandle():window.parent!==self&&Jr.isSearchHasKeyword()?Jr.verifyVtrackMode():Hr.isStorageHasKeyword()?Hr.storageHasKeywordHandle():window.parent!==self&&Jr.isStorageHasKeyword()?Jr.verifyVtrackMode():(Lt(),Jr.notifyUser())}function Et(){e(Br,function(e){var t=Jt[e];Jt[e]=function(){if(Jt.readyState.state<3)return Ft(Jt._q)||(Jt._q=[]),Jt._q.push([e,arguments]),!1;{if(Jt.readyState.getState())return t.apply(Jt,arguments);try{console.error("\u8bf7\u5148\u521d\u59cb\u5316\u795e\u7b56JS SDK")}catch(r){Jt.log(r)}}}})}function Ht(e){e&&(Jt._=dr,Jt.kit=kr,Jt.saEvent=mr,Jt.sendState=Cr,Jt.events=new ur,Jt.batchSend=$r,Jt.bridge=Ar,Jt.JSBridge=jr,Jt.store=_r,Jt.vtrackBase=Or,Jt.unlimitedDiv=Ir,Jt.customProp=Tr,Jt.vtrackcollect=Lr,Jt.vapph5collect=Er,Jt.heatmap=vr,Jt.detectMode=xt);var t=e?br:Ur;for(var r in t)Jt[r]=t[r]}var Jt={};(function(){function e(i,n){function a(e,t){try{e()}catch(r){t&&t()}}function s(e){if(null!=s[e])return s[e];var t;if("bug-string-char-index"==e)t="a"!="a"[0];else if("json"==e)t=s("json-stringify")&&s("date-serialization")&&s("json-parse");else if("date-serialization"==e){if(t=s("json-stringify")&&w){var r=n.stringify;a(function(){t='"-271821-04-20T00:00:00.000Z"'==r(new d((-864e13)))&&'"+275760-09-13T00:00:00.000Z"'==r(new d(864e13))&&'"-000001-01-01T00:00:00.000Z"'==r(new d((-621987552e5)))&&'"1969-12-31T23:59:59.999Z"'==r(new d((-1)))})}}else{var i,o='{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}';if("json-stringify"==e){var r=n.stringify,u="function"==typeof r;u&&((i=function(){return 1}).toJSON=i,a(function(){u="0"===r(0)&&"0"===r(new l)&&'""'==r(new c)&&r(v)===h&&r(h)===h&&r()===h&&"1"===r(i)&&"[1]"==r([i])&&"[null]"==r([h])&&"null"==r(null)&&"[null,null,null]"==r([h,v,null])&&r({a:[i,!0,!1,null,"\0\b\n\f\r\t"]})==o&&"1"===r(null,i)&&"[\n 1,\n 2\n]"==r([1,2],null,1)},function(){u=!1})),t=u}if("json-parse"==e){var p,_=n.parse;"function"==typeof _&&a(function(){0!==_("0")||_(!1)||(i=_(o),p=5==i.a.length&&1===i.a[0],p&&(a(function(){p=!_('"\t"')}),p&&a(function(){p=1!==_("01")}),p&&a(function(){p=1!==_("1.")})))},function(){p=!1}),t=p}}return s[e]=!!t}function o(e){return I(this)}i||(i=r.Object()),n||(n=r.Object());var l=i.Number||r.Number,c=i.String||r.String,u=i.Object||r.Object,d=i.Date||r.Date,p=i.SyntaxError||r.SyntaxError,_=i.TypeError||r.TypeError,f=i.Math||r.Math,g=i.JSON||r.JSON;"object"==typeof g&&g&&(n.stringify=g.stringify,n.parse=g.parse);var h,m=u.prototype,v=m.toString,y=m.hasOwnProperty,w=new d((-0xc782b5b800cec));if(a(function(){w=w.getUTCFullYear()==-109252&&0===w.getUTCMonth()&&1===w.getUTCDate()&&10==w.getUTCHours()&&37==w.getUTCMinutes()&&6==w.getUTCSeconds()&&708==w.getUTCMilliseconds()}),s["bug-string-char-index"]=s["date-serialization"]=s.json=s["json-stringify"]=s["json-parse"]=null,!s("json")){var S="[object Function]",b="[object Date]",k="[object Number]",P="[object String]",D="[object Array]",N="[object Boolean]",C=s("bug-string-char-index"),$=function(e,r){var i,n,a,s=0;(i=function(){this.valueOf=0}).prototype.valueOf=0,n=new i;for(a in n)y.call(n,a)&&s++;return i=n=null,s?$=function(e,t){var r,i,n=v.call(e)==S;for(r in e)n&&"prototype"==r||!y.call(e,r)||(i="constructor"===r)||t(r);(i||y.call(e,r="constructor"))&&t(r)}:(n=["valueOf","toString","toLocaleString","propertyIsEnumerable","isPrototypeOf","hasOwnProperty","constructor"],$=function(e,r){var i,a,s=v.call(e)==S,o=!s&&"function"!=typeof e.constructor&&t[typeof e.hasOwnProperty]&&e.hasOwnProperty||y;for(i in e)s&&"prototype"==i||!o.call(e,i)||r(i);for(a=n.length;i=n[--a];)o.call(e,i)&&r(i)}),$(e,r)};if(!s("json-stringify")&&!s("date-serialization")){var A={92:"\\\\",34:'\\"',8:"\\b",12:"\\f",10:"\\n",13:"\\r",9:"\\t"},j="000000",O=function(e,t){return(j+(t||0)).slice(-e)},I=function(e){var t,r,i,n,a,s,o,l,c;if(w)t=function(e){r=e.getUTCFullYear(),i=e.getUTCMonth(),n=e.getUTCDate(),s=e.getUTCHours(),o=e.getUTCMinutes(),l=e.getUTCSeconds(),c=e.getUTCMilliseconds()};else{var u=f.floor,d=[0,31,59,90,120,151,181,212,243,273,304,334],p=function(e,t){return d[t]+365*(e-1970)+u((e-1969+(t=+(t>1)))/4)-u((e-1901+t)/100)+u((e-1601+t)/400)};t=function(e){for(n=u(e/864e5),r=u(n/365.2425)+1970-1;p(r+1,0)<=n;r++);for(i=u((n-p(r,0))/30.42);p(r,i+1)<=n;i++);n=1+n-p(r,i),a=(e%864e5+864e5)%864e5,s=u(a/36e5)%24,o=u(a/6e4)%60,l=u(a/1e3)%60,c=a%1e3}}return(I=function(e){return e>-1/0&&e<1/0?(t(e),e=(r<=0||r>=1e4?(r<0?"-":"+")+O(6,r<0?-r:r):O(4,r))+"-"+O(2,i+1)+"-"+O(2,n)+"T"+O(2,s)+":"+O(2,o)+":"+O(2,l)+"."+O(3,c)+"Z",r=i=n=s=o=l=c=null):e=null,e})(e)};if(s("json-stringify")&&!s("date-serialization")){var T=n.stringify;n.stringify=function(e,t,r){var i=d.prototype.toJSON;d.prototype.toJSON=o;var n=T(e,t,r);return d.prototype.toJSON=i,n}}else{var L="\\u00",x=function(e){var t=e.charCodeAt(0),r=A[t];return r?r:L+O(2,t.toString(16))},E=/[\x00-\x1f\x22\x5c]/g,H=function(e){return E.lastIndex=0,'"'+(E.test(e)?e.replace(E,x):e)+'"'},J=function(e,t,r,i,n,s,o){var l,c,u,p,f,g,m,y,w;if(a(function(){l=t[e]}),"object"==typeof l&&l&&(l.getUTCFullYear&&v.call(l)==b&&l.toJSON===d.prototype.toJSON?l=I(l):"function"==typeof l.toJSON&&(l=l.toJSON(e))),r&&(l=r.call(t,e,l)),l==h)return l===h?l:"null";switch(c=typeof l,"object"==c&&(u=v.call(l)),u||c){case"boolean":case N:return""+l;case"number":case k:return l>-1/0&&l<1/0?""+l:"null";case"string":case P:return H(""+l)}if("object"==typeof l){for(m=o.length;m--;)if(o[m]===l)throw _();if(o.push(l),p=[],y=s,s+=n,u==D){for(g=0,m=l.length;g<m;g++)f=J(g,l,r,i,n,s,o),p.push(f===h?"null":f);w=p.length?n?"[\n"+s+p.join(",\n"+s)+"\n"+y+"]":"["+p.join(",")+"]":"[]"}else $(i||l,function(e){var t=J(e,l,r,i,n,s,o);t!==h&&p.push(H(e)+":"+(n?" ":"")+t)}),w=p.length?n?"{\n"+s+p.join(",\n"+s)+"\n"+y+"}":"{"+p.join(",")+"}":"{}";return o.pop(),w}};n.stringify=function(e,r,i){var n,a,s,o;if(t[typeof r]&&r)if(o=v.call(r),o==S)a=r;else if(o==D){s={};for(var l,c=0,u=r.length;c<u;)l=r[c++],o=v.call(l),"[object String]"!=o&&"[object Number]"!=o||(s[l]=1)}if(i)if(o=v.call(i),o==k){if((i-=i%1)>0)for(i>10&&(i=10),n="";n.length<i;)n+=" "}else o==P&&(n=i.length<=10?i:i.slice(0,10));return J("",(l={},l[""]=e,l),a,s,n,"",[])}}}if(!s("json-parse")){var B,U,R=c.fromCharCode,M={92:"\\",34:'"',47:"/",98:"\b",116:"\t",110:"\n",102:"\f",114:"\r"},K=function(){throw B=U=null,p()},W=function(){for(var e,t,r,i,n,a=U,s=a.length;B<s;)switch(n=a.charCodeAt(B)){case 9:case 10:case 13:case 32:B++;break;case 123:case 125:case 91:case 93:case 58:case 44:return e=C?a.charAt(B):a[B],B++,e;case 34:for(e="@",B++;B<s;)if(n=a.charCodeAt(B),n<32)K();else if(92==n)switch(n=a.charCodeAt(++B)){case 92:case 34:case 47:case 98:case 116:case 110:case 102:case 114:e+=M[n],B++;break;case 117:for(t=++B,r=B+4;B<r;B++)n=a.charCodeAt(B),n>=48&&n<=57||n>=97&&n<=102||n>=65&&n<=70||K();e+=R("0x"+a.slice(t,B));break;default:K()}else{if(34==n)break;for(n=a.charCodeAt(B),t=B;n>=32&&92!=n&&34!=n;)n=a.charCodeAt(++B);e+=a.slice(t,B)}if(34==a.charCodeAt(B))return B++,e;K();default:if(t=B,45==n&&(i=!0,n=a.charCodeAt(++B)),n>=48&&n<=57){for(48==n&&(n=a.charCodeAt(B+1),n>=48&&n<=57)&&K(),i=!1;B<s&&(n=a.charCodeAt(B),n>=48&&n<=57);B++);if(46==a.charCodeAt(B)){for(r=++B;r<s&&(n=a.charCodeAt(r),!(n<48||n>57));r++);r==B&&K(),B=r}if(n=a.charCodeAt(B),101==n||69==n){for(n=a.charCodeAt(++B),43!=n&&45!=n||B++,r=B;r<s&&(n=a.charCodeAt(r),!(n<48||n>57));r++);r==B&&K(),B=r}return+a.slice(t,B)}i&&K();var o=a.slice(B,B+4);if("true"==o)return B+=4,!0;if("fals"==o&&101==a.charCodeAt(B+4))return B+=5,!1;if("null"==o)return B+=4,null;K()}return"$"},q=function(e){var t,r;if("$"==e&&K(),"string"==typeof e){if("@"==(C?e.charAt(0):e[0]))return e.slice(1);if("["==e){for(t=[];e=W(),"]"!=e;)r?","==e?(e=W(),"]"==e&&K()):K():r=!0,","==e&&K(),t.push(q(e));return t}if("{"==e){for(t={};e=W(),"}"!=e;)r?","==e?(e=W(),"}"==e&&K()):K():r=!0,","!=e&&"string"==typeof e&&"@"==(C?e.charAt(0):e[0])&&":"==W()||K(),t[e.slice(1)]=q(W());return t}K()}return e},V=function(e,t,r){var i=F(e,t,r);i===h?delete e[t]:e[t]=i},F=function(e,t,r){var i,n=e[t];if("object"==typeof n&&n)if(v.call(n)==D)for(i=n.length;i--;)V(v,$,n,i,r);else $(n,function(e){V(n,e,r)});return r.call(e,t,n)};n.parse=function(e,t){var r,i;return B=0,U=""+e,r=q(W()),"$"!=W()&&K(),B=U=null,t&&v.call(t)==S?F((i={},i[""]=r,i),"",t):r}}}return n.runInContext=e,n}var t={"function":!0,object:!0},r=t[typeof window]&&window||this,i=r.JSON,n=r.JSON3,a=!1,s=e(r,r.JSON3={noConflict:function(){return a||(a=!0,r.JSON=i,r.JSON3=n,i=n=null),s}});r.JSON={parse:s.parse,stringify:s.stringify}}).call(window),function(e,t){t(e)}(window,function(e){if(e.atob)try{e.atob(" ")}catch(t){e.atob=function(e){var t=function(t){return e(String(t).replace(/[\t\n\f\r ]+/g,""))};return t.original=e,t}(e.atob)}else{var r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",i=/^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/;e.btoa=function(e){e=String(e);for(var t,i,n,a,s="",o=0,l=e.length%3;o<e.length;){if((i=e.charCodeAt(o++))>255||(n=e.charCodeAt(o++))>255||(a=e.charCodeAt(o++))>255)return"";t=i<<16|n<<8|a,s+=r.charAt(t>>18&63)+r.charAt(t>>12&63)+r.charAt(t>>6&63)+r.charAt(63&t)}return l?s.slice(0,l-3)+"===".substring(l):s},e.atob=function(e){if(e=String(e).replace(/[\t\n\f\r ]+/g,""),!i.test(e))return"";e+="==".slice(2-(3&e.length));for(var t,n,a,s="",o=0;o<e.length;)t=r.indexOf(e.charAt(o++))<<18|r.indexOf(e.charAt(o++))<<12|(n=r.indexOf(e.charAt(o++)))<<6|(a=r.indexOf(e.charAt(o++))),s+=64===n?String.fromCharCode(t>>16&255):64===a?String.fromCharCode(t>>16&255,t>>8&255):String.fromCharCode(t>>16&255,t>>8&255,255&t);return s}}}),function(){String.prototype.replaceAll||(String.prototype.replaceAll=function(e,t){return"[object regexp]"===Object.prototype.toString.call(e).toLowerCase()?this.replace(e,t):this.replace(new RegExp(e,"g"),t)})}();var Bt=Array.prototype,Ut=Bt.forEach,Rt=Bt.slice,Mt=Array.isArray,Kt=Object.prototype,Wt=Kt.toString,qt=Kt.hasOwnProperty,Vt={},Ft=Mt||function(e){return"[object Array]"===Wt.call(e)},zt=function(){function e(){return r=(9301*r+49297)%233280,r/233280}var t=new Date,r=t.getTime();return function(t){return Math.ceil(e()*t)}}(),Xt=Date.now||function(){return(new Date).getTime()},Zt={},Qt={preset_properties:{search_keyword_baidu:!1,latest_utm:!0,latest_traffic_source_type:!0,latest_search_keyword:!0,latest_referrer:!0,latest_referrer_host:!1,latest_landing_page:!1,latest_wx_ad_click_id:void 0,url:!0,title:!0},encrypt_cookie:!1,enc_cookie:!1,login_id_key:"$identity_login_id",img_use_crossorigin:!1,name:"sa",max_referrer_string_length:200,max_string_length:500,max_id_length:255,max_key_length:100,cross_subdomain:!0,show_log:!1,is_debug:!1,debug_mode:!1,debug_mode_upload:!1,source_channel:[],sdk_id:"",send_type:"image",vtrack_ignore:{},auto_init:!0,is_track_single_page:!1,is_single_page:!1,batch_send:!1,source_type:{},callback_timeout:200,datasend_timeout:8e3,is_track_device_id:!1,ignore_oom:!0,app_js_bridge:!1};K.init=function(e){this.ele=e},K.init.prototype={addClass:function(e){var t=" "+this.ele.className+" ";return t.indexOf(" "+e+" ")===-1&&(this.ele.className=this.ele.className+(""===this.ele.className?"":" ")+e),this},removeClass:function(e){var t=" "+this.ele.className+" ";return t.indexOf(" "+e+" ")!==-1&&(this.ele.className=t.replace(" "+e+" "," ").slice(1,-1)),this},hasClass:function(e){var t=" "+this.ele.className+" ";return t.indexOf(" "+e+" ")!==-1},attr:function(e,t){return"string"==typeof e&&h(t)?this.ele.getAttribute(e):("string"==typeof e&&(t=String(t),this.ele.setAttribute(e,t)),this)},offset:function(){var e=this.ele.getBoundingClientRect();if(e.width||e.height){var t=this.ele.ownerDocument,r=t.documentElement;return{top:e.top+window.pageYOffset-r.clientTop,left:e.left+window.pageXOffset-r.clientLeft}}return{top:0,left:0}},getSize:function(){if(!window.getComputedStyle)return{width:this.ele.offsetWidth,height:this.ele.offsetHeight};try{var e=this.ele.getBoundingClientRect();return{width:e.width,height:e.height}}catch(t){return{width:0,height:0}}},getStyle:function(e){return this.ele.currentStyle?this.ele.currentStyle[e]:this.ele.ownerDocument.defaultView.getComputedStyle(this.ele,null).getPropertyValue(e)},wrap:function(e){var t=document.createElement(e);return this.ele.parentNode.insertBefore(t,this.ele),t.appendChild(this.ele),K(t)},getCssStyle:function(e){var t=this.ele.style.getPropertyValue(e);if(t)return t;var r=null;if("function"==typeof window.getMatchedCSSRules&&(r=window.getMatchedCSSRules(this.ele)),!r||!Ft(r))return null;for(var i=r.length-1;i>=0;i--){var n=r[i];if(t=n.style.getPropertyValue(e))return t}},sibling:function(e,t){for(;(e=e[t])&&1!==e.nodeType;);return e},next:function(){return this.sibling(this.ele,"nextSibling")},prev:function(){return this.sibling(this.ele,"previousSibling")},siblings:function(){return this.siblings((this.ele.parentNode||{}).firstChild,this.ele)},children:function(){return this.siblings(this.ele.firstChild)},parent:function(){var e=this.ele.parentNode;return e=e&&11!==e.nodeType?e:null,K(e)},previousElementSibling:function(){var e=this.ele;if("previousElementSibling"in document.documentElement)return K(e.previousElementSibling);for(;e=e.previousSibling;)if(1===e.nodeType)return K(e);return K(null)},getSameTypeSiblings:function(){for(var e=this.ele,t=e.parentNode,r=e.tagName.toLowerCase(),i=[],n=0;n<t.children.length;n++){var a=t.children[n];1===a.nodeType&&a.tagName.toLowerCase()===r&&i.push(t.children[n])}return i},getParents:function(){try{var e=this.ele;if(!b(e))return[];var t=[e];if(null===e||null===e.parentElement)return[];for(;null!==e.parentElement;)e=e.parentElement,t.push(e);return t}catch(r){return[]}}};var Yt={isHttpUrl:function(e){if("string"!=typeof e)return!1;var t=/^https?:\/\/.+/;return t.test(e)!==!1||(J("Invalid URL"),!1)},removeScriptProtocol:function(e){if("string"!=typeof e)return"";for(var t=/^\s*javascript/i;t.test(e);)e=e.replace(t,"");return e}},Gt=function(){var e={"+":"-","/":"_","=":"."},t={"-":"+",_:"/",".":"="},r=function(t){return t.replace(/[+\/=]/g,function(t){return e[t]})},i=function(e){return e.replace(/[-_.]/g,function(e){return t[e]})},n=function(e){return e.replace(/[.=]{1,2}$/,"")},a=function(e){return/^[A-Za-z0-9+\/]*[=]{0,2}$/.test(e)},s=function(e){return/^[A-Za-z0-9_-]*[.]{0,2}$/.test(e)};return{encode:r,decode:i,trim:n,isBase64:a,isUrlSafeBase64:s}}(),er={distinct_id:function(){},jssdkDebug:function(){},_sendDebug:function(e){},apph5:function(e){var t="app_h5\u6253\u901a\u5931\u8d25-",r={1:t+"use_app_track\u4e3afalse",2:t+"Android\u6216\u8005iOS\uff0c\u6ca1\u6709\u66b4\u9732\u76f8\u5e94\u65b9\u6cd5",3.1:t+"Android\u6821\u9a8cserver_url\u5931\u8d25",3.2:t+"iOS\u6821\u9a8cserver_url\u5931\u8d25",4.1:t+"H5 \u6821\u9a8c iOS server_url \u5931\u8d25",4.2:t+"H5 \u6821\u9a8c Android server_url \u5931\u8d25"},i=e.output,n=e.step,a=e.data||"";"all"!==i&&"console"!==i||J(r[n]),("all"===i||"code"===i)&&f(Zt.is_debug)&&Zt.is_debug.apph5&&(a.type&&"profile"===a.type.slice(0,7)||(a.properties._jssdk_debug_info="apph5-"+String(n)))},defineMode:function(e){var t={1:{title:"\u5f53\u524d\u9875\u9762\u65e0\u6cd5\u8fdb\u884c\u53ef\u89c6\u5316\u5168\u57cb\u70b9",message:"App SDK \u4e0e Web JS SDK \u6ca1\u6709\u8fdb\u884c\u6253\u901a\uff0c\u8bf7\u8054\u7cfb\u8d35\u65b9\u6280\u672f\u4eba\u5458\u4fee\u6b63 App SDK \u7684\u914d\u7f6e\uff0c\u8be6\u7ec6\u4fe1\u606f\u8bf7\u67e5\u770b\u6587\u6863\u3002",link_text:"\u914d\u7f6e\u6587\u6863",link_url:"https://manual.sensorsdata.cn/sa/latest/tech_sdk_client_link-1573913.html"},2:{title:"\u5f53\u524d\u9875\u9762\u65e0\u6cd5\u8fdb\u884c\u53ef\u89c6\u5316\u5168\u57cb\u70b9",message:"App SDK \u4e0e Web JS SDK \u6ca1\u6709\u8fdb\u884c\u6253\u901a\uff0c\u8bf7\u8054\u7cfb\u8d35\u65b9\u6280\u672f\u4eba\u5458\u4fee\u6b63 Web JS SDK \u7684\u914d\u7f6e\uff0c\u8be6\u7ec6\u4fe1\u606f\u8bf7\u67e5\u770b\u6587\u6863\u3002",link_text:"\u914d\u7f6e\u6587\u6863",link_url:"https://manual.sensorsdata.cn/sa/latest/tech_sdk_client_link-1573913.html"},3:{title:"\u5f53\u524d\u9875\u9762\u65e0\u6cd5\u8fdb\u884c\u53ef\u89c6\u5316\u5168\u57cb\u70b9",message:"Web JS SDK \u6ca1\u6709\u5f00\u542f\u5168\u57cb\u70b9\u914d\u7f6e\uff0c\u8bf7\u8054\u7cfb\u8d35\u65b9\u5de5\u4f5c\u4eba\u5458\u4fee\u6b63 SDK \u7684\u914d\u7f6e\uff0c\u8be6\u7ec6\u4fe1\u606f\u8bf7\u67e5\u770b\u6587\u6863\u3002",link_text:"\u914d\u7f6e\u6587\u6863",link_url:"https://manual.sensorsdata.cn/sa/latest/tech_sdk_client_web_all-1573964.html"},4:{title:"\u5f53\u524d\u9875\u9762\u65e0\u6cd5\u8fdb\u884c\u53ef\u89c6\u5316\u5168\u57cb\u70b9",message:"Web JS SDK \u914d\u7f6e\u7684\u6570\u636e\u6821\u9a8c\u5730\u5740\u4e0e App SDK \u914d\u7f6e\u7684\u6570\u636e\u6821\u9a8c\u5730\u5740\u4e0d\u4e00\u81f4\uff0c\u8bf7\u8054\u7cfb\u8d35\u65b9\u5de5\u4f5c\u4eba\u5458\u4fee\u6b63 SDK \u7684\u914d\u7f6e\uff0c\u8be6\u7ec6\u4fe1\u606f\u8bf7\u67e5\u770b\u6587\u6863\u3002",link_text:"\u914d\u7f6e\u6587\u6863",link_url:"https://manual.sensorsdata.cn/sa/latest/tech_sdk_client_link-1573913.html"}};return!(!e||!t[e])&&t[e]},protocol:{protocolIsSame:function(e,t){try{if(Q(e).protocol!==Q(t).protocol)return!1}catch(r){return J("\u4e0d\u652f\u6301 _.URL \u65b9\u6cd5"),!1}return!0},serverUrl:function(){v(Zt.server_url)&&""!==Zt.server_url&&!this.protocolIsSame(Zt.server_url,location.href)&&J("SDK \u68c0\u6d4b\u5230\u60a8\u7684\u6570\u636e\u53d1\u9001\u5730\u5740\u548c\u5f53\u524d\u9875\u9762\u5730\u5740\u7684\u534f\u8bae\u4e0d\u4e00\u81f4\uff0c\u5efa\u8bae\u60a8\u4fee\u6539\u6210\u4e00\u81f4\u7684\u534f\u8bae\u3002\n\u56e0\u4e3a\uff1a1\u3001https \u4e0b\u9762\u53d1\u9001 http \u7684\u56fe\u7247\u8bf7\u6c42\u4f1a\u5931\u8d25\u30022\u3001http \u9875\u9762\u4f7f\u7528 https + ajax \u65b9\u5f0f\u53d1\u6570\u636e\uff0c\u5728 ie9 \u53ca\u4ee5\u4e0b\u4f1a\u4e22\u5931\u6570\u636e\u3002")},ajax:function(e){return e!==Zt.server_url&&void(v(e)&&""!==e&&!this.protocolIsSame(e,location.href)&&J("SDK \u68c0\u6d4b\u5230\u60a8\u7684\u6570\u636e\u53d1\u9001\u5730\u5740\u548c\u5f53\u524d\u9875\u9762\u5730\u5740\u7684\u534f\u8bae\u4e0d\u4e00\u81f4\uff0c\u5efa\u8bae\u60a8\u4fee\u6539\u6210\u4e00\u81f4\u7684\u534f\u8bae\u3002\u56e0\u4e3a http \u9875\u9762\u4f7f\u7528 https + ajax \u65b9\u5f0f\u53d1\u6570\u636e\uff0c\u5728 ie9 \u53ca\u4ee5\u4e0b\u4f1a\u4e22\u5931\u6570\u636e\u3002"))}}},tr="utm_source utm_medium utm_campaign utm_content utm_term",rr="1.21.6",ir=function(){var e=function(){for(var e=1*new Date,t=0;e==1*new Date;)t++;return e.toString(16)+t.toString(16)},t=function(){return $().toString(16).replace(".","")},r=function(){function e(e,t){var r,i=0;for(r=0;r<t.length;r++)i|=n[r]<<8*r;return e^i}var t,r,i=navigator.userAgent,n=[],a=0;for(t=0;t<i.length;t++)r=i.charCodeAt(t),n.unshift(255&r),n.length>=4&&(a=e(a,n),n=[]);return n.length>0&&(a=e(a,n)),a.toString(16)};return function(){var i=String(screen.height*screen.width);i=i&&/\d{5,}/.test(i)?i.toString(16):String(31242*$()).replace(".","").slice(0,8);var n=e()+"-"+t()+"-"+r()+"-"+i+"-"+e();return n?n:(String($())+String($())+String($())).slice(2,15)}}(),nr={data:{},id:function(){return this.data.id?this.data.id:(this.data.id=ue(),this.data.id)},type:function(){return this.data.type?this.data.type:(this.data.type=de(),this.data.type)}},ar={initPage:function(){var e=fe(),t=ee(),r=oe(t);r||er.jssdkDebug("url_domain\u5f02\u5e38_"+t+"_"+r),this.pageProp={referrer:e,referrer_host:e?Y(e):"",url:t,url_host:Y(t,"url_host\u53d6\u503c\u5f02\u5e38"),url_domain:r}},pageProp:{},campaignParams:function(){var t=tr.split(" "),r="",i={};return Ft(Zt.source_channel)&&Zt.source_channel.length>0&&(t=t.concat(Zt.source_channel),t=j(t)),e(t,function(e){r=z(location.href,e),r.length&&(i[e]=r)}),i},campaignParamsStandard:function(t,r){t=t||"",r=r||"";var i=ar.campaignParams(),n={},a={};return e(i,function(e,i,s){(" "+tr+" ").indexOf(" "+i+" ")!==-1?n[t+i]=s[i]:a[r+i]=s[i]}),{$utms:n,otherUtms:a}},properties:function(){var e=window.innerHeight||document.documentElement.clientHeight||document.body.clientHeight||0,t=window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth||0,r={$timezone_offset:(new Date).getTimezoneOffset(),$screen_height:Number(screen.height)||0,$screen_width:Number(screen.width)||0,$viewport_height:e,$viewport_width:t,$lib:"js",$lib_version:rr};return r},currentProps:{},register:function(e){r(ar.currentProps,e)}},sr={get:function(e){for(var t=e+"=",r=document.cookie.split(";"),i=0;i<r.length;i++){for(var n=r[i];" "==n.charAt(0);)n=n.substring(1,n.length);if(0==n.indexOf(t))return V(n.substring(t.length,n.length))}return null},set:function(e,t,r,i){function n(e){return!!e&&e.replaceAll(/\r\n/g,"")}i="undefined"==typeof i?Zt.cross_subdomain:i;var a="",s="",o="",l="";if(r=null==r?73e3:r,i){var c=oe(location.href);"url\u89e3\u6790\u5931\u8d25"===c&&(c=""),a=c?"; domain="+c:""}if(0!==r){var u=new Date;"s"===String(r).slice(-1)?u.setTime(u.getTime()+1e3*Number(String(r).slice(0,-1))):u.setTime(u.getTime()+24*r*60*60*1e3),s="; expires="+u.toGMTString()}v(Zt.set_cookie_samesite)&&""!==Zt.set_cookie_samesite&&(l="; SameSite="+Zt.set_cookie_samesite),Zt.is_secure_cookie&&(o="; secure");var d="",p="",_="";e&&(d=n(e)),t&&(p=n(t)),a&&(_=n(a)),d&&p&&(document.cookie=d+"="+encodeURIComponent(p)+s+"; path=/"+_+l+o)},encrypt:function(e){return"dfm-enc-"+x(e)},decrypt:function(e){return 0===e.indexOf("data:enc;")?(e=e.substring("data:enc;".length),e=L(e)):0===e.indexOf("dfm-enc-")&&(e=e.substring("dfm-enc-".length),e=x(e)),e},resolveValue:function(e){var t="data:enc;",r="dfm-enc-";return!v(e)||0!==e.indexOf(t)&&0!==e.indexOf(r)||(e=sr.decrypt(e)),e},remove:function(e,t){t="undefined"==typeof t?Zt.cross_subdomain:t,sr.set(e,"",-1,t)},getCookieName:function(e,t){var r="";if(t=t||location.href,Zt.cross_subdomain===!1){try{r=Q(t).hostname}catch(i){J(i)}r="string"==typeof r&&""!==r?"sajssdk_2015_"+Zt.sdk_id+e+"_"+r.replace(/\./g,"_"):"sajssdk_2015_root_"+Zt.sdk_id+e}else r="sajssdk_2015_cross_"+Zt.sdk_id+e;return r},getNewUser:function(){var e="new_user";return null!==this.get("sensorsdata_is_new_user")||null!==this.get(this.getCookieName(e))}},or={get:function(e){return window.localStorage.getItem(e)},parse:function(e){var t;try{t=JSON.parse(or.get(e))||null}catch(r){J(r)}return t},set:function(e,t){window.localStorage.setItem(e,t)},remove:function(e){window.localStorage.removeItem(e)},isSupport:function(){var e=!0;try{var t="__sensorsdatasupport__",r="testIsSupportStorage";or.set(t,r),or.get(t)!==r&&(e=!1),or.remove(t)}catch(i){e=!1}return e}},lr={isSupport:function(){var e=!0,t="__sensorsdatasupport__",r="testIsSupportStorage";try{sessionStorage&&sessionStorage.setItem?(sessionStorage.setItem(t,r),sessionStorage.removeItem(t,r),e=!0):e=!1}catch(i){e=!1}return e}},cr={is_create:!1,current_url:location.href,eventList:[],create:function(){function t(){e(r.eventList,function(e){a(e)&&e(r.current_url)}),r.current_url=location.href}var r=this,i=window.history.pushState,n=window.history.replaceState;a(window.history.pushState)&&(window.history.pushState=function(){i.apply(window.history,arguments),t()}),a(window.history.replaceState)&&(window.history.replaceState=function(){n.apply(window.history,arguments),t()});var s;s=window.document.documentMode?"hashchange":i?"popstate":"hashchange",Ce(window,s,function(){t()}),this.is_create=!0},subscribe:function(e){this.is_create||this.create(),a(e)&&this.eventList.push(e)},prepend:function(e){this.is_create||this.create(),a(e)&&this.eventList.unshift(e)}},ur=function(){this._events=[],this.pendingEvents=[]};ur.prototype={emit:function(t){var r=[].slice.call(arguments,1);e(this._events,function(e){e.type===t&&e.callback.apply(e.context,r)}),this.pendingEvents.push({type:t,data:r}),this.pendingEvents.length>20?this.pendingEvents.shift():null},on:function(t,r,i,n){"function"==typeof r&&(this._events.push({type:t,callback:r,context:i||this}),n=n!==!1,this.pendingEvents.length>0&&n&&e(this.pendingEvents,function(e){e.type===t&&r.apply(i,e.data)}))},tempAdd:function(e,t){if(t&&e)return this.emit(e,t)},isReady:function(){}};var dr={__proto__:null,each:e,map:t,extend:r,extend2Lev:i,coverExtend:n,isArray:Ft,isFunction:a,isArguments:s,toArray:l,values:c,indexOf:u,filter:d,inherit:p,trim:_,isObject:f,isEmptyObject:g,isUndefined:h,isString:v,isDate:y,isBoolean:w,isNumber:S,isElement:b,isJSONString:k,safeJSONParse:P,throttle:D,hashCode:N,getRandomBasic:zt,getRandom:$,formatJsonString:A,unique:j,base64Decode:I,base64Encode:O,now:Xt,rot13obfs:T,rot13defs:L,dfmapping:x,strToUnicode:E,hashCode53:C,hasAttributes:B,hasAttribute:U,getElementContent:R,loadScript:M,ry:K,setCssStyle:W,getDomBySelector:q,decodeURIComponent:V,decodeURI:F,getQueryParam:z,urlParse:X,getURLSearchParams:Z,URL:Q,getHostname:Y,getQueryParamsFromUrl:G,urlSafeBase64:Gt,secCheck:Yt,getURL:ee,encodeDates:te,formatDate:re,searchObjDate:ie,mediaQueriesSupported:we,getScreenOrientation:Se,cookie:sr,localStorage:or,sessionStorage:lr,isSupportCors:be,isIOS:ke,getUA:De,getIOSVersion:Pe,isSupportBeaconSend:Ne,parseSuperProperties:ne,searchConfigData:ae,strip_empty_properties:se,UUID:ir,getCurrentDomain:oe,getEleInfo:le,isBaiduTraffic:ce,getReferrerEqid:ue,getReferrerEqidType:de,getBaiduKeyword:nr,getCookieTopLevelDomain:pe,isReferralTraffic:_e,getReferrer:fe,getKeywordFromReferrer:he,getWxAdIdFromUrl:me,getReferSearchEngine:ge,getSourceFromReferrer:ve,info:ar,autoExeQueue:ye,addEvent:Ce,addHashEvent:$e,addSinglePageEvent:Ae,listenPageState:je,bindReady:Oe,singlePage:cr,xhr:Ie,ajax:Te,jsonp:Le,eventEmitter:ur},pr={checkIsAddSign:function(e){"track"===e.type&&(sr.getNewUser()?e.properties.$is_first_day=!0:e.properties.$is_first_day=!1);
	},is_first_visit_time:!1,is_page_first_visited:!1,checkIsFirstTime:function(e){"track"===e.type&&"$pageview"===e.event&&(this.is_first_visit_time?(e.properties.$is_first_time=!0,this.is_first_visit_time=!1):e.properties.$is_first_time=!1)},setDeviceId:function(e){var t=null,r=sr.get("sensorsdata2015jssdkcross"+Jt.para.sdk_id);r=sr.resolveValue(r);var i={};null!=r&&k(r)&&(i=JSON.parse(r),i.$device_id&&(t=i.$device_id)),t=t||e,Jt.para.cross_subdomain===!0?Jt.store.set("$device_id",t):(i.$device_id=t,i=JSON.stringify(i),Jt.para.encrypt_cookie&&(i=sr.encrypt(i)),sr.set("sensorsdata2015jssdkcross"+Jt.para.sdk_id,i,null,!0)),Jt.para.is_track_device_id&&(ar.currentProps.$device_id=t)},storeInitCheck:function(){if(Jt.is_first_visitor){var e=new Date,t={h:23-e.getHours(),m:59-e.getMinutes(),s:59-e.getSeconds()};sr.set(sr.getCookieName("new_user"),"1",3600*t.h+60*t.m+t.s+"s"),this.is_first_visit_time=!0,this.is_page_first_visited=!0}else sr.getNewUser()||(this.checkIsAddSign=function(e){"track"===e.type&&(e.properties.$is_first_day=!1)}),this.checkIsFirstTime=function(e){"track"===e.type&&"$pageview"===e.event&&(e.properties.$is_first_time=!1)}},checkIsFirstLatest:function(){var t=ar.pageProp.url_domain,r={};""===t&&(t="url\u89e3\u6790\u5931\u8d25");var i=he(document.referrer,!0);if(Jt.para.preset_properties.search_keyword_baidu?_e(document.referrer)&&(!ce()||f(i)&&i.active?Jt.store._state&&Jt.store._state.props&&(Jt.store._state.props.$search_keyword_id&&delete Jt.store._state.props.$search_keyword_id,Jt.store._state.props.$search_keyword_id_type&&delete Jt.store._state.props.$search_keyword_id_type,Jt.store._state.props.$search_keyword_id_hash&&delete Jt.store._state.props.$search_keyword_id_hash):(r.$search_keyword_id=nr.id(),r.$search_keyword_id_type=nr.type(),r.$search_keyword_id_hash=C(r.$search_keyword_id))):Jt.store._state&&Jt.store._state.props&&(Jt.store._state.props.$search_keyword_id&&delete Jt.store._state.props.$search_keyword_id,Jt.store._state.props.$search_keyword_id_type&&delete Jt.store._state.props.$search_keyword_id_type,Jt.store._state.props.$search_keyword_id_hash&&delete Jt.store._state.props.$search_keyword_id_hash),Jt.store.save(),e(Jt.para.preset_properties,function(i,n){if(n.indexOf("latest_")===-1)return!1;if(n=n.slice(7),i){if("wx_ad_click_id"===n&&"not_collect"===i)return!1;if("utm"!==n&&"url\u89e3\u6790\u5931\u8d25"===t)"wx_ad_click_id"===n?(r._latest_wx_ad_click_id="url\u7684domain\u89e3\u6790\u5931\u8d25",r._latest_wx_ad_hash_key="url\u7684domain\u89e3\u6790\u5931\u8d25",r._latest_wx_ad_callbacks="url\u7684domain\u89e3\u6790\u5931\u8d25"):r["$latest_"+n]="url\u7684domain\u89e3\u6790\u5931\u8d25";else if(_e(document.referrer))switch(n){case"traffic_source_type":r.$latest_traffic_source_type=ve();break;case"referrer":r.$latest_referrer=ar.pageProp.referrer;break;case"search_keyword":he()?r.$latest_search_keyword=he():f(Jt.store._state)&&f(Jt.store._state.props)&&Jt.store._state.props.$latest_search_keyword&&delete Jt.store._state.props.$latest_search_keyword;break;case"landing_page":r.$latest_landing_page=ee();break;case"wx_ad_click_id":var a=me(location.href);r._latest_wx_ad_click_id=a.click_id,r._latest_wx_ad_hash_key=a.hash_key,r._latest_wx_ad_callbacks=a.callbacks}}else if("utm"===n&&Jt.store._state&&Jt.store._state.props)for(var s in Jt.store._state.props)(0===s.indexOf("$latest_utm")||0===s.indexOf("_latest_")&&s.indexOf("_latest_wx_ad_")<0)&&delete Jt.store._state.props[s];else if(Jt.store._state&&Jt.store._state.props&&"$latest_"+n in Jt.store._state.props)delete Jt.store._state.props["$latest_"+n];else if("wx_ad_click_id"==n&&Jt.store._state&&Jt.store._state.props&&i===!1){var o=["_latest_wx_ad_click_id","_latest_wx_ad_hash_key","_latest_wx_ad_callbacks"];e(o,function(e){e in Jt.store._state.props&&delete Jt.store._state.props[e]})}}),Jt.register(r),Jt.para.preset_properties.latest_utm){var n=ar.campaignParamsStandard("$latest_","_latest_"),a=n.$utms,s=n.otherUtms;g(a)||Jt.register(a),g(s)||Jt.register(s)}}},_r={identities:{set:function(e,t){var r={};switch(e){case"login":r[Jt.para.login_id_key]=t,r.$identity_cookie_id=Jt.store._state.identities.$identity_cookie_id;break;case"logout":r.$identity_cookie_id=Jt.store._state.identities.$identity_cookie_id;break;case"identify":r=JSON.parse(JSON.stringify(Jt.store._state.identities)),r.$identity_anonymous_id=t}Jt.store._state.identities=r,Jt.store.save()}},requests:[],_sessionState:{},_state:{distinct_id:"",first_id:"",props:{},identities:{}},getProps:function(){return this._state.props||{}},getSessionProps:function(){return this._sessionState},getDistinctId:function(){return this._state._distinct_id||this._state.distinct_id},getUnionId:function(e){var t={};e=e||this._state;var r=e._first_id||e.first_id,i=e._distinct_id||e.distinct_id;return r&&i?(t.login_id=i,t.anonymous_id=r):t.anonymous_id=i,t},getFirstId:function(){return this._state._first_id||this._state.first_id},initSessionState:function(){var e=sr.get("sensorsdata2015session"),t=null;null!==e&&"object"==typeof(t=JSON.parse(e))&&(this._sessionState=t||{})},setOnce:function(e,t){e in this._state||this.set(e,t)},set:function(e,t){this._state=this._state||{};var r=this._state.distinct_id;this._state[e]=t,"first_id"===e?delete this._state._first_id:"distinct_id"===e&&delete this._state._distinct_id,this.save(),"distinct_id"===e&&r&&Jt.events.tempAdd("changeDistinctId",t)},change:function(e,t){this._state["_"+e]=t},setSessionProps:function(e){var t=this._sessionState;r(t,e),this.sessionSave(t)},setSessionPropsOnce:function(e){var t=this._sessionState;n(t,e),this.sessionSave(t)},setProps:function(e,t){var i={};i=t?e:r(this._state.props||{},e);for(var n in i)"string"==typeof i[n]&&(i[n]=i[n].slice(0,Jt.para.max_referrer_string_length));this.set("props",i)},setPropsOnce:function(e){var t=this._state.props||{};n(t,e),this.set("props",t)},clearAllProps:function(e){this._sessionState={};var t;if(Ft(e)&&e.length>0)for(t=0;t<e.length;t++)v(e[t])&&e[t].indexOf("latest_")===-1&&f(this._state.props)&&e[t]in this._state.props&&delete this._state.props[e[t]];else if(f(this._state.props))for(t in this._state.props)1!==t.indexOf("latest_")&&delete this._state.props[t];this.sessionSave({}),this.save()},sessionSave:function(e){this._sessionState=e,sr.set("sensorsdata2015session",JSON.stringify(this._sessionState),0)},save:function(){var e=JSON.parse(JSON.stringify(this._state));delete e._first_id,delete e._distinct_id,e.identities&&(e.identities=O(JSON.stringify(e.identities)));var t=JSON.stringify(e);Jt.para.encrypt_cookie&&(t=sr.encrypt(t)),sr.set(this.getCookieName(),t,73e3,Jt.para.cross_subdomain)},getCookieName:function(){var e="";if(Jt.para.cross_subdomain===!1){try{e=Q(location.href).hostname}catch(t){Jt.log(t)}e="string"==typeof e&&""!==e?"sa_jssdk_2015_"+Jt.para.sdk_id+e.replace(/\./g,"_"):"sa_jssdk_2015_root"+Jt.para.sdk_id}else e="sensorsdata2015jssdkcross"+Jt.para.sdk_id;return e},init:function(){function e(e){var t;e.identities&&(0===e.identities.indexOf("\n/")?e.identities=P(L(e.identities)):e.identities=P(I(e.identities)));var r=_r.getUnionId(e);e.identities&&f(e.identities)&&!g(e.identities)?e.identities.$identity_anonymous_id&&e.identities.$identity_anonymous_id!==r.anonymous_id&&(e.identities.$identity_anonymous_id=r.anonymous_id):(e.identities={},e.identities.$identity_anonymous_id=r.anonymous_id,e.identities.$identity_cookie_id=ir()),e.history_login_id=e.history_login_id||{};var i=e.history_login_id,n=i.name;if(r.login_id)if(n&&f(e.identities)&&e.identities.hasOwnProperty(n)){if(e.identities[n]!==r.login_id){e.identities[n]=r.login_id;for(t in e.identities)f(e.identities)&&e.identities.hasOwnProperty(t)&&"$identity_cookie_id"!==t&&t!==n&&delete e.identities[t];e.history_login_id.value=r.login_id}}else{e.identities[Jt.para.login_id_key]=r.login_id;for(t in e.identities)f(e.identities)&&e.identities.hasOwnProperty(t)&&"$identity_cookie_id"!==t&&t!==Jt.para.login_id_key&&delete e.identities[t];e.history_login_id={name:Jt.para.login_id_key,value:r.login_id}}else{if(f(e.identities)&&e.identities.hasOwnProperty("$identity_login_id")||e.identities.hasOwnProperty(n))for(t in e.identities)f(e.identities)&&e.identities.hasOwnProperty(t)&&"$identity_cookie_id"!==t&&"$identity_anonymous_id"!==t&&delete e.identities[t];e.history_login_id={name:"",value:""}}return e}function t(e){Jt.store.set("distinct_id",e),Jt.store.set("identities",{$identity_cookie_id:e}),Jt.store.set("history_login_id",{name:"",value:""})}this.initSessionState();var i=ir(),n=sr.get(this.getCookieName());n=sr.resolveValue(n);var a=P(n);null===n||!k(n)||!f(a)||f(a)&&!a.distinct_id?(Jt.is_first_visitor=!0,t(i)):(Jt.store._state=r(e(a)),Jt.store.save()),pr.setDeviceId(i),pr.storeInitCheck(),pr.checkIsFirstLatest()}},fr={string:function(e){J(e+" must be string")},emptyString:function(e){J(e+"'s is empty")},regexTest:function(e){J(e+" is invalid")},idLength:function(e){J(e+" length is longer than "+Zt.max_id_length)},keyLength:function(e){J(e+" length is longer than "+Zt.max_key_length)},stringLength:function(e){J(e+" length is longer than "+Zt.max_string_length)},voidZero:function(e){J(e+"'s is undefined")},reservedLoginId:function(e){J(e+" is invalid")},reservedBind:function(e){J(e+" is invalid")}},gr={regName:/^((?!^distinct_id$|^original_id$|^time$|^properties$|^id$|^first_id$|^second_id$|^users$|^events$|^event$|^user_id$|^date$|^datetime$|^user_tag.*|^user_group.*)[a-zA-Z_$][a-zA-Z\d_$]*)$/i,loginIDReservedNames:["$identity_anonymous_id","$identity_cookie_id"],bindReservedNames:["$identity_login_id","$identity_anonymous_id","$identity_cookie_id"],string:function(e){return!!v(e)},emptyString:function(e){return!(!v(e)||0===_(e).length)},regexTest:function(e){return!(!v(e)||!this.regName.test(e))},idLength:function(e){return!(!v(e)||e.length>Zt.max_id_length)},keyLength:function(e){return!(!v(e)||e.length>Zt.max_key_length)},stringLength:function(e){return!(!v(e)||e.length>Zt.max_string_length)},voidZero:function(e){return void 0!==e},reservedLoginId:function(e){return!(u(this.loginIDReservedNames,e)>-1)},reservedBind:function(e){return Zt.login_id_key&&this.bindReservedNames.indexOf(Zt.login_id_key)===-1&&this.bindReservedNames.push(Zt.login_id_key),!(u(this.bindReservedNames,e)>-1)}},hr={distinct_id:{rules:["string","emptyString","idLength"],onComplete:function(e,t,r){return!e&&("emptyString"===r&&(t="Id"),a(fr[r])&&fr[r](t),"idLength"===r)||e}},event:{rules:["string","emptyString","keyLength","regexTest"],onComplete:function(e,t,r){return e||("emptyString"===r&&(t="eventName"),a(fr[r])&&fr[r](t)),!0}},propertyKey:{rules:["string","emptyString","keyLength","regexTest"],onComplete:function(e,t,r){return e||("emptyString"===r&&(t="Property key"),a(fr[r])&&fr[r](t)),!0}},propertyValue:{rules:["voidZero"],onComplete:function(e,t,r){return e||(t="Property Value",a(fr[r])&&fr[r](t)),!0}},properties:function(t){return f(t)?e(t,function(e,t){xe({propertyKey:t});var r=function(e,r,i){return e||(r=t+"'s Value",a(fr[i])&&fr[i](r)),!0};xe({propertyValue:e},r)}):gr.voidZero(t)&&J("properties\u53ef\u4ee5\u6ca1\u6709\uff0c\u4f46\u6709\u7684\u8bdd\u5fc5\u987b\u662f\u5bf9\u8c61"),!0},propertiesMust:function(e){return void 0!==e&&f(e)&&!g(e)?this.properties.call(this,e):J("properties\u5fc5\u987b\u662f\u5bf9\u8c61"),!0},item_type:{rules:["string","emptyString","keyLength","regexTest"],onComplete:function(e,t,r){return e||("emptyString"===r&&(t="item_type"),a(fr[r])&&fr[r](t)),!0}},item_id:{rules:["string","emptyString","stringLength"],onComplete:function(e,t,r){return e||("emptyString"===r&&(t="item_id"),a(fr[r])&&fr[r](t)),!0}},loginIdKey:{rules:["string","emptyString","keyLength","regexTest","reservedLoginId"],onComplete:function(e,t,r){return!e&&("emptyString"===r&&(t="login_id_key"),a(fr[r])&&fr[r](t),"keyLength"===r)||e}},bindKey:{rules:["string","emptyString","keyLength","regexTest","reservedBind"],onComplete:function(e,t,r){return!e&&("emptyString"===r&&(t="Key"),a(fr[r])&&fr[r](t),"keyLength"===r)||e}},bindValue:{rules:["string","emptyString","idLength"],onComplete:function(e,t,r){return!e&&("emptyString"===r&&(t="Value"),a(fr[r])&&fr[r](t),"idLength"===r)||e}},check:function(e,t,r){var i=this[e];if(a(i))return i.call(this,t);if(!i)return!1;for(var n=0;n<i.rules.length;n++){var s=i.rules[n],o=gr[s](t),l=a(r)?r(o,t,s):i.onComplete(o,t,s);if(!o)return l}return!0}},mr={};mr.check=xe,mr.sendItem=function(e){var t={lib:{$lib:"js",$lib_method:"code",$lib_version:String(Jt.lib_version)},time:1*new Date};r(t,e),Ke(t),Jt.sendState.getSendCall(t)},mr.send=function(e,t){var r=Jt.kit.buildData(e);Jt.kit.sendData(r,t)},mr.debugPath=function(e){var t=e,r="";r=Jt.para.debug_mode_url.indexOf("?")!==-1?Jt.para.debug_mode_url+"&"+Jt.kit.encodeTrackData(e):Jt.para.debug_mode_url+"?"+Jt.kit.encodeTrackData(e),Te({url:r,type:"GET",cors:!0,header:{"Dry-Run":String(Jt.para.debug_mode_upload)},success:function(e){g(e)===!0?alert("debug\u6570\u636e\u53d1\u9001\u6210\u529f"+t):alert("debug\u5931\u8d25 \u9519\u8bef\u539f\u56e0"+JSON.stringify(e))}})};var vr={otherTags:[],getTargetElement:function(e,t){var r=this,i=e;if("object"!=typeof i)return null;if("string"!=typeof i.tagName)return null;var n=i.tagName.toLowerCase();if("body"===n.toLowerCase()||"html"===n.toLowerCase())return null;if(!i||!i.parentNode||!i.parentNode.children)return null;var a=i.parentNode,s=r.hasElement({event:t&&t.originalEvent||t,element:e},function(e){return"a"===e.tagName.toLowerCase()||B(e,Jt.para.heatmap.track_attr)}),o=r.otherTags;if("a"===n||"button"===n||"input"===n||"textarea"===n)return i;if(u(o,n)>-1)return i;if("button"===a.tagName.toLowerCase()||"a"===a.tagName.toLowerCase())return a;if("area"===n&&"map"===a.tagName.toLowerCase()&&K(a).prev().tagName&&"img"===K(a).prev().tagName.toLowerCase())return K(a).prev();if(s)return s;if("div"===n&&Jt.para.heatmap.collect_tags.div&&r.isDivLevelValid(i)){var l=Jt.para.heatmap&&Jt.para.heatmap.collect_tags&&Jt.para.heatmap.collect_tags.div&&Jt.para.heatmap.collect_tags.div.max_level||1;return l>1||r.isCollectableDiv(i)?i:null}if(r.isStyleTag(n)&&Jt.para.heatmap.collect_tags.div){var c=r.getCollectableParent(i);if(c&&r.isDivLevelValid(c))return c}return null},getDivLevels:function(t,r){var i=vr.getElementPath(t,!0,r),n=i.split(" > "),a=0;return e(n,function(e){"div"===e&&a++}),a},isDivLevelValid:function(e){for(var t=Jt.para.heatmap&&Jt.para.heatmap.collect_tags&&Jt.para.heatmap.collect_tags.div&&Jt.para.heatmap.collect_tags.div.max_level||1,r=e.getElementsByTagName("div"),i=r.length-1;i>=0;i--)if(vr.getDivLevels(r[i],e)>t)return!1;return!0},getElementPath:function(e,t,r){for(var i=[];e.parentNode;){if(e.id&&!t&&/^[A-Za-z][-A-Za-z0-9_:.]*$/.test(e.id)){i.unshift(e.tagName.toLowerCase()+"#"+e.id);break}if(r&&e===r){i.unshift(e.tagName.toLowerCase());break}if(e===document.body){i.unshift("body");break}i.unshift(e.tagName.toLowerCase()),e=e.parentNode}return i.join(" > ")},getClosestLi:function(e){var t=function(e,t){for(;e&&e!==document&&1===e.nodeType;e=e.parentNode)if(e.tagName.toLowerCase()===t)return e;return null};return t(e,"li")},getElementPosition:function(e,t,r){function i(e){var t=e.parentNode;if(!t)return"";var r=K(e).getSameTypeSiblings(),i=r.length;if(1===i)return 0;for(var n=0,a=e;K(a).previousElementSibling().ele;a=K(a).previousElementSibling().ele,n++);return n}var n=Jt.heatmap.getClosestLi(e);if(!n)return null;var a=e.tagName.toLowerCase(),s=n.getElementsByTagName(a),o=s.length,l=[];if(o>1){for(var c=0;c<o;c++){var d=Jt.heatmap.getElementPath(s[c],r);d===t&&l.push(s[c])}if(l.length>1)return u(l,e)}return i(n)},setNotice:function(e){Jt.is_heatmap_render_mode=!0,Jt.para.heatmap||(Jt.errorMsg="\u60a8SDK\u6ca1\u6709\u914d\u7f6e\u5f00\u542f\u70b9\u51fb\u56fe\uff0c\u53ef\u80fd\u6ca1\u6709\u6570\u636e\uff01"),e&&e[0]&&e[1]&&"http:"===e[1].slice(0,5)&&"https:"===location.protocol&&(Jt.errorMsg="\u60a8\u7684\u5f53\u524d\u9875\u9762\u662fhttps\u7684\u5730\u5740\uff0c\u795e\u7b56\u5206\u6790\u73af\u5883\u4e5f\u5fc5\u987b\u662fhttps\uff01"),Jt.para.heatmap_url||(Jt.para.heatmap_url=location.protocol+"//static.sensorsdata.cn/sdk/"+Jt.lib_version+"/heatmap.min.js")},getDomIndex:function(e){if(!e.parentNode)return-1;for(var t=0,r=e.tagName,i=e.parentNode.children,n=0;n<i.length;n++)if(i[n].tagName===r){if(e===i[n])return t;t++}return-1},selector:function(e,t){var r=e.parentNode&&9==e.parentNode.nodeType?-1:this.getDomIndex(e);return e.getAttribute&&e.getAttribute("id")&&/^[A-Za-z][-A-Za-z0-9_:.]*$/.test(e.getAttribute("id"))&&(!Jt.para.heatmap||Jt.para.heatmap&&"not_use_id"!==Jt.para.heatmap.element_selector)&&!t?"#"+e.getAttribute("id"):e.tagName.toLowerCase()+(~r?":nth-of-type("+(r+1)+")":"")},getDomSelector:function(e,t,r){if(!e||!e.parentNode||!e.parentNode.children)return!1;t=t&&t.join?t:[];var i=e.nodeName.toLowerCase();return e&&"body"!==i&&1==e.nodeType?(t.unshift(this.selector(e,r)),e.getAttribute&&e.getAttribute("id")&&/^[A-Za-z][-A-Za-z0-9_:.]*$/.test(e.getAttribute("id"))&&Jt.para.heatmap&&"not_use_id"!==Jt.para.heatmap.element_selector&&!r?t.join(" > "):this.getDomSelector(e.parentNode,t,r)):(t.unshift("body"),t.join(" > "))},na:function(){var e=document.documentElement.scrollLeft||window.pageXOffset;return parseInt(isNaN(e)?0:e,10)},i:function(){var e=0;try{e=o.documentElement&&o.documentElement.scrollTop||m.pageYOffset,e=isNaN(e)?0:e}catch(t){e=0}return parseInt(e,10)},getBrowserWidth:function(){var e=window.innerWidth||document.body.clientWidth;return isNaN(e)?0:parseInt(e,10)},getBrowserHeight:function(){var e=window.innerHeight||document.body.clientHeight;return isNaN(e)?0:parseInt(e,10)},getScrollWidth:function(){var e=parseInt(document.body.scrollWidth,10);return isNaN(e)?0:e},getEleDetail:function(e){var t=this.getDomSelector(e),r=le({target:e});r.$element_selector=t?t:"",r.$element_path=Jt.heatmap.getElementPath(e,Jt.para.heatmap&&"not_use_id"===Jt.para.heatmap.element_selector);var i=Jt.heatmap.getElementPosition(e,r.$element_path,Jt.para.heatmap&&"not_use_id"===Jt.para.heatmap.element_selector);return S(i)&&(r.$element_position=i),r},getPointerEventProp:function(e,t){function r(){var e=document.body.scrollLeft||document.documentElement.scrollLeft||0,t=document.body.scrollTop||document.documentElement.scrollTop||0;return{scrollLeft:e,scrollTop:t}}function i(e){if(document.documentElement.getBoundingClientRect){var t=e.getBoundingClientRect();return{targetEleX:t.left+r().scrollLeft||0,targetEleY:t.top+r().scrollTop||0}}}function n(e){return Number(Number(e).toFixed(3))}function a(e){var a=e.pageX||e.clientX+r().scrollLeft||e.offsetX+i(t).targetEleX||0,s=e.pageY||e.clientY+r().scrollTop||e.offsetY+i(t).targetEleY||0;return{$page_x:n(a),$page_y:n(s)}}return e?a(e):{}},start:function(e,t,i,n,s){var o=f(n)?n:{},l=a(s)?s:a(n)?n:void 0;if(Jt.para.heatmap&&Jt.para.heatmap.collect_element&&!Jt.para.heatmap.collect_element(t))return!1;var c=this.getEleDetail(t);if(Jt.para.heatmap&&Jt.para.heatmap.custom_property){var u=Jt.para.heatmap.custom_property(t);f(u)&&(c=r(c,u))}c=r(c,this.getPointerEventProp(e,t),o),"a"===i&&Jt.para.heatmap&&Jt.para.heatmap.isTrackLink===!0?Jt.trackLink({event:e,target:t},"$WebClick",c):Jt.track("$WebClick",c,l)},hasElement:function(e,t){var r;if(e.event){var i=e.event;r=i.path||i._getPath&&i._getPath()}else e.element&&(r=K(e.element).getParents());if(r&&Ft(r)&&r.length>0)for(var n=0;n<r.length;n++)if("object"==typeof r[n]&&1===r[n].nodeType&&t(r[n]))return r[n]},isStyleTag:function(e,t){var r=["a","div","input","button","textarea"],i=["mark","/mark","strong","b","em","i","u","abbr","ins","del","s","sup"];return!(u(r,e)>-1)&&(!t||Jt.para.heatmap&&Jt.para.heatmap.collect_tags&&Jt.para.heatmap.collect_tags.div?!!(f(Jt.para.heatmap)&&f(Jt.para.heatmap.collect_tags)&&f(Jt.para.heatmap.collect_tags.div)&&Ft(Jt.para.heatmap.collect_tags.div.ignore_tags)&&u(Jt.para.heatmap.collect_tags.div.ignore_tags,e)>-1):u(i,e)>-1)},isCollectableDiv:function(e,t){try{if(0===e.children.length)return!0;for(var r=0;r<e.children.length;r++)if(1===e.children[r].nodeType){var i=e.children[r].tagName.toLowerCase(),n=Jt.para&&Jt.para.heatmap&&Jt.para.heatmap.collect_tags&&Jt.para.heatmap.collect_tags.div&&Jt.para.heatmap.collect_tags.div.max_level;if(!("div"===i&&n>1||this.isStyleTag(i,t)))return!1;if(!this.isCollectableDiv(e.children[r],t))return!1}return!0}catch(a){Jt.log(a)}return!1},getCollectableParent:function(e,t){try{var r=e.parentNode,i=r?r.tagName.toLowerCase():"";if("body"===i)return!1;var n=Jt.para&&Jt.para.heatmap&&Jt.para.heatmap.collect_tags&&Jt.para.heatmap.collect_tags.div&&Jt.para.heatmap.collect_tags.div.max_level;if(i&&"div"===i&&(n>1||this.isCollectableDiv(r,t)))return r;if(r&&this.isStyleTag(i,t))return this.getCollectableParent(r,t)}catch(a){Jt.log(a)}return!1},initScrollmap:function(){if(!f(Jt.para.heatmap)||"default"!==Jt.para.heatmap.scroll_notice_map)return!1;var e=function(){return!(Jt.para.scrollmap&&a(Jt.para.scrollmap.collect_url)&&!Jt.para.scrollmap.collect_url())},t=function(e){var t={};return t.timeout=e.timeout||1e3,t.func=e.func,t.hasInit=!1,t.inter=null,t.main=function(e,t){this.func(e,t),this.inter=null},t.go=function(e){var r={};this.inter||(r.$viewport_position=document.documentElement&&document.documentElement.scrollTop||window.pageYOffset||document.body.scrollTop||0,r.$viewport_position=Math.round(r.$viewport_position)||0,e?t.main(r,!0):this.inter=setTimeout(function(){t.main(r)},this.timeout))},t},r=t({timeout:1e3,func:function(e,t){var r=document.documentElement&&document.documentElement.scrollTop||window.pageYOffset||document.body.scrollTop||0,i=new Date,n=i-this.current_time;(n>Jt.para.heatmap.scroll_delay_time&&r-e.$viewport_position!==0||t)&&(e.$url=ee(),e.$title=document.title,e.$url_path=location.pathname,e.event_duration=Math.min(Jt.para.heatmap.scroll_event_duration,parseInt(n)/1e3),e.event_duration=e.event_duration<0?0:e.event_duration,Jt.track("$WebStay",e)),this.current_time=i}});r.current_time=new Date,Ce(window,"scroll",function(){return!!e()&&void r.go()}),Ce(window,"unload",function(){return!!e()&&void r.go("notime")})},initHeatmap:function(){var e=this;return!(!f(Jt.para.heatmap)||"default"!==Jt.para.heatmap.clickmap)&&(!(a(Jt.para.heatmap.collect_url)&&!Jt.para.heatmap.collect_url())&&("all"===Jt.para.heatmap.collect_elements?Jt.para.heatmap.collect_elements="all":Jt.para.heatmap.collect_elements="interact",void("all"===Jt.para.heatmap.collect_elements?Ce(document,"click",function(t){var r=t||window.event;if(!r)return!1;var i=r.target||r.srcElement;if("object"!=typeof i)return!1;if("string"!=typeof i.tagName)return!1;var n=i.tagName.toLowerCase();if("body"===n||"html"===n)return!1;if(!i||!i.parentNode||!i.parentNode.children)return!1;var a=i.parentNode.tagName.toLowerCase();"a"===a||"button"===a?e.start(r,i.parentNode,a):e.start(r,i,n)}):Ce(document,"click",function(t){var r=t||window.event;if(!r)return!1;var i=r.target||r.srcElement,n=Jt.heatmap.getTargetElement(i,t);n?e.start(r,n,n.tagName.toLowerCase()):b(i)&&"div"===i.tagName.toLowerCase()&&f(Jt.para.heatmap)&&Jt.para.heatmap.get_vtrack_config&&Jt.unlimitedDiv.events.length>0&&Jt.unlimitedDiv.isTargetEle(i)&&e.start(r,i,i.tagName.toLowerCase(),{$lib_method:"vtrack"})}))))}},yr={setOnlineState:function(t){if(t===!0&&f(Jt.para.jsapp)&&"function"==typeof Jt.para.jsapp.getData){Jt.para.jsapp.isOnline=!0;var r=Jt.para.jsapp.getData();Ft(r)&&r.length>0&&e(r,function(e){k(e)&&Jt.sendState.realtimeSend(JSON.parse(e))})}else Jt.para.jsapp.isOnline=!1},autoTrackIsUsed:!1,isReady:function(e){e()},getUtm:function(){return ar.campaignParams()},getStayTime:function(){return(new Date-Jt._t)/1e3},setProfileLocal:function(e){if(!or.isSupport())return Jt.setProfile(e),!1;if(!f(e)||g(e))return!1;var t=or.parse("sensorsdata_2015_jssdk_profile"),r=!1;if(f(t)&&!g(t)){for(var i in e)!(i in t&&t[i]!==e[i])&&i in t||(t[i]=e[i],r=!0);r&&(or.set("sensorsdata_2015_jssdk_profile",JSON.stringify(t)),Jt.setProfile(e))}else or.set("sensorsdata_2015_jssdk_profile",JSON.stringify(e)),Jt.setProfile(e)},setInitReferrer:function(){var e=fe();Jt.setOnceProfile({_init_referrer:e,_init_referrer_host:ar.pageProp.referrer_host})},setSessionReferrer:function(){var e=fe();Jt.store.setSessionPropsOnce({_session_referrer:e,_session_referrer_host:ar.pageProp.referrer_host})},setDefaultAttr:function(){ar.register({_current_url:location.href,_referrer:fe(),_referring_host:ar.pageProp.referrer_host})},trackHeatMap:function(e,t,r){if("object"==typeof e&&e.tagName){var i=e.tagName.toLowerCase(),n=e.parentNode.tagName.toLowerCase(),a=Jt.para.heatmap&&Jt.para.heatmap.track_attr?Jt.para.heatmap.track_attr:["data-sensors-click"];"button"===i||"a"===i||"a"===n||"button"===n||"input"===i||"textarea"===i||B(e,a)||vr.start(null,e,i,t,r)}},trackAllHeatMap:function(e,t,r){if("object"==typeof e&&e.tagName){var i=e.tagName.toLowerCase();vr.start(null,e,i,t,r)}},autoTrackSinglePage:function(t,i){function n(){var t=ar.campaignParams(),r={};return e(t,function(e,t,i){(" "+Jt.source_channel_standard+" ").indexOf(" "+t+" ")!==-1?r["$"+t]=i[t]:r[t]=i[t]}),r}function a(e,t){Jt.track("$pageview",r({$referrer:s,$url:ee(),$url_path:location.pathname,$title:document.title},e,n()),t),s=ee()}var s;s=this.autoTrackIsUsed?ar.pageProp.url:ar.pageProp.referrer,t=f(t)?t:{};var o=!t.not_set_profile;if(t.not_set_profile&&delete t.not_set_profile,a(t,i),this.autoTrackSinglePage=a,Jt.is_first_visitor&&o){var l={};Jt.para.preset_properties.search_keyword_baidu&&_e(document.referrer)&&ce()&&(l.$search_keyword_id=nr.id(),l.$search_keyword_id_type=nr.type(),l.$search_keyword_id_hash=C(l.$search_keyword_id)),Jt.setOnceProfile(r({$first_visit_time:new Date,$first_referrer:fe(),$first_browser_language:navigator.language||"\u53d6\u503c\u5f02\u5e38",$first_browser_charset:"string"==typeof document.charset?document.charset.toUpperCase():"\u53d6\u503c\u5f02\u5e38",$first_traffic_source_type:ve(),$first_search_keyword:he()},n(),l)),Jt.is_first_visitor=!1}},autoTrackWithoutProfile:function(e,t){e=f(e)?e:{},this.autoTrack(r(e,{not_set_profile:!0}),t)},autoTrack:function(t,i){t=f(t)?t:{};var n=ar.campaignParams(),a={};e(n,function(e,t,r){(" "+Jt.source_channel_standard+" ").indexOf(" "+t+" ")!==-1?a["$"+t]=r[t]:a[t]=r[t]});var s=!t.not_set_profile;t.not_set_profile&&delete t.not_set_profile;var o=location.href;if(Jt.para.is_single_page&&$e(function(){var e=fe(o,!0);Jt.track("$pageview",r({$referrer:e,$url:ee(),$url_path:location.pathname,$title:document.title},a,t),i),o=ee()}),Jt.track("$pageview",r({$referrer:fe(null,!0),$url:ee(),$url_path:location.pathname,$title:document.title},a,t),i),Jt.is_first_visitor&&s){var l={};Jt.para.preset_properties.search_keyword_baidu&&_e(document.referrer)&&ce()&&(l.$search_keyword_id=nr.id(),l.$search_keyword_id_type=nr.type(),l.$search_keyword_id_hash=C(l.$search_keyword_id)),Jt.setOnceProfile(r({$first_visit_time:new Date,$first_referrer:fe(null,!0),$first_browser_language:navigator.language||"\u53d6\u503c\u5f02\u5e38",$first_browser_charset:"string"==typeof document.charset?document.charset.toUpperCase():"\u53d6\u503c\u5f02\u5e38",$first_traffic_source_type:ve(),$first_search_keyword:he()},a,l)),Jt.is_first_visitor=!1}this.autoTrackIsUsed=!0},getAnonymousID:function(){return g(Jt.store._state)?"\u8bf7\u5148\u521d\u59cb\u5316SDK":Jt.store._state._first_id||Jt.store._state.first_id||Jt.store._state._distinct_id||Jt.store._state.distinct_id},setPlugin:function(t){return!!f(t)&&void e(t,function(e,t){a(e)&&(f(window.SensorsDataWebJSSDKPlugin)&&window.SensorsDataWebJSSDKPlugin[t]?e(window.SensorsDataWebJSSDKPlugin[t]):Jt.log(t+"\u6ca1\u6709\u83b7\u53d6\u5230,\u8bf7\u67e5\u9605\u6587\u6863\uff0c\u8c03\u6574"+t+"\u7684\u5f15\u5165\u987a\u5e8f\uff01"))})},useModulePlugin:function(){Jt.use.apply(Jt,arguments)},useAppPlugin:function(){this.setPlugin.apply(this,arguments)}},wr={state:0,historyState:[],stateType:{1:"1-init\u672a\u5f00\u59cb",2:"2-init\u5f00\u59cb",3:"3-store\u5b8c\u6210"},getState:function(){return this.historyState.join("\n")},setState:function(e){String(e)in this.stateType&&(this.state=e),this.historyState.push(this.stateType[e])}},Sr={EMAIL:"$identity_email",MOBILE:"$identity_mobile"},br={__proto__:null,addReferrerHost:We,addPropsHook:qe,initPara:Ve,setInitVar:Fe,enableLocalLog:ze,disableLocalLog:Xe,quick:Ze,use:Qe,track:Ye,bind:Ge,unbind:et,trackLink:tt,trackLinks:rt,setItem:it,deleteItem:nt,setProfile:at,setOnceProfile:st,appendProfile:ot,incrementProfile:lt,deleteProfile:ct,unsetProfile:ut,identify:dt,trackSignup:_t,registerPage:ft,clearAllRegister:gt,clearPageRegister:ht,register:mt,registerOnce:vt,registerSession:yt,registerSessionOnce:wt,login:St,logout:bt,getPresetProperties:kt,iOSWebClickPolyfill:Pt,readyState:wr,para_default:Qt,log:J,debug:er,IDENTITY_KEY:Sr},kr={};kr.buildData=function(e){var t={identities:{},distinct_id:Jt.store.getDistinctId(),lib:{$lib:"js",$lib_method:"code",$lib_version:String(Jt.lib_version)},properties:{}};return f(e)&&f(e.identities)&&!g(e.identities)?r(t.identities,e.identities):r(t.identities,_r._state.identities),f(e)&&f(e.properties)&&!g(e.properties)&&(e.properties.$lib_detail&&(t.lib.$lib_detail=e.properties.$lib_detail,delete e.properties.$lib_detail),e.properties.$lib_method&&(t.lib.$lib_method=e.properties.$lib_method,delete e.properties.$lib_method)),r(t,Jt.store.getUnionId(),e),f(e.properties)&&!g(e.properties)&&r(t.properties,e.properties),e.type&&"profile"===e.type.slice(0,7)||(t.properties=r({},ar.properties(),_r.getProps(),_r.getSessionProps(),ar.currentProps,t.properties),Jt.para.preset_properties.latest_referrer&&!v(t.properties.$latest_referrer)&&(t.properties.$latest_referrer="\u53d6\u503c\u5f02\u5e38"),Jt.para.preset_properties.latest_search_keyword&&!v(t.properties.$latest_search_keyword)&&(Jt.para.preset_properties.search_keyword_baidu&&v(t.properties.$search_keyword_id)&&S(t.properties.$search_keyword_id_hash)&&v(t.properties.$search_keyword_id_type)||(t.properties.$latest_search_keyword="\u53d6\u503c\u5f02\u5e38")),Jt.para.preset_properties.latest_traffic_source_type&&!v(t.properties.$latest_traffic_source_type)&&(t.properties.$latest_traffic_source_type="\u53d6\u503c\u5f02\u5e38"),Jt.para.preset_properties.latest_landing_page&&!v(t.properties.$latest_landing_page)&&(t.properties.$latest_landing_page="\u53d6\u503c\u5f02\u5e38"),"not_collect"===Jt.para.preset_properties.latest_wx_ad_click_id?(delete t.properties._latest_wx_ad_click_id,delete t.properties._latest_wx_ad_hash_key,delete t.properties._latest_wx_ad_callbacks):Jt.para.preset_properties.latest_wx_ad_click_id&&!v(t.properties._latest_wx_ad_click_id)&&(t.properties._latest_wx_ad_click_id="\u53d6\u503c\u5f02\u5e38",t.properties._latest_wx_ad_hash_key="\u53d6\u503c\u5f02\u5e38",t.properties._latest_wx_ad_callbacks="\u53d6\u503c\u5f02\u5e38"),v(t.properties._latest_wx_ad_click_id)&&(t.properties.$url=ee())),t.properties.$time&&y(t.properties.$time)?(t.time=1*t.properties.$time,delete t.properties.$time):t.time=1*new Date,Jt.vtrackBase.addCustomProps(t),ne(t),Ke(t),pr.checkIsAddSign(t),pr.checkIsFirstTime(t),Jt.addReferrerHost(t),Jt.addPropsHook(t),t},kr.sendData=function(e,t){var r=ae(e.properties);Jt.para.debug_mode===!0?(Jt.log(e),Jt.saEvent.debugPath(JSON.stringify(e),t)):Jt.sendState.getSendCall(e,r,t)},kr.encodeTrackData=function(e){var t=O(e),r="crc="+N(t);return"data="+encodeURIComponent(t)+"&ext="+encodeURIComponent(r)};var Pr=function(e){this.callback=e.callback,this.img=document.createElement("img"),this.img.width=1,this.img.height=1,Jt.para.img_use_crossorigin&&(this.img.crossOrigin="anonymous"),this.data=e.data,this.server_url=Dt(e.server_url,e.data)};Pr.prototype.start=function(){var e=this;Jt.para.ignore_oom&&(this.img.onload=function(){this.onload=null,this.onerror=null,this.onabort=null,e.isEnd()},this.img.onerror=function(){this.onload=null,this.onerror=null,this.onabort=null,e.isEnd()},this.img.onabort=function(){this.onload=null,this.onerror=null,this.onabort=null,e.isEnd()}),this.img.src=this.server_url},Pr.prototype.lastClear=function(){this.img.src=""};var Dr=function(e){this.callback=e.callback,this.server_url=e.server_url,this.data=Nt(e.data)};Dr.prototype.start=function(){var e=this;Te({url:this.server_url,type:"POST",data:this.data,credentials:!1,timeout:Jt.para.datasend_timeout,cors:!0,success:function(){e.isEnd()},error:function(){e.isEnd()}})};var Nr=function(e){this.callback=e.callback,this.server_url=e.server_url,this.data=Nt(e.data)};Nr.prototype.start=function(){var e=this;"object"==typeof navigator&&"function"==typeof navigator.sendBeacon&&navigator.sendBeacon(this.server_url,this.data),setTimeout(function(){e.isEnd()},40)};var Cr={};Cr.queue=ye(),Cr.getSendCall=function(e,t,r){if(Jt.is_heatmap_render_mode)return!1;if(Jt.readyState.state<3)return Jt.log("\u521d\u59cb\u5316\u6ca1\u6709\u5b8c\u6210"),!1;e._track_id=Number(String($()).slice(2,5)+String($()).slice(2,4)+String((new Date).getTime()).slice(-4)),
	e._flush_time=(new Date).getTime();var i=e;e=JSON.stringify(e);var n={data:i,config:t,callback:r};return Jt.events.tempAdd("send",i),!Jt.para.app_js_bridge&&Jt.para.batch_send&&localStorage.length<200?(Jt.log(i),Jt.batchSend.add(n.data),!1):("item_set"===i.type||"item_delete"===i.type?this.prepareServerUrl(n):Jt.bridge.dataSend(n,this,r),void Jt.log(i))},Cr.prepareServerUrl=function(e){if("object"==typeof e.config&&e.config.server_url)this.sendCall(e,e.config.server_url,e.callback);else if(Ft(Jt.para.server_url)&&Jt.para.server_url.length)for(var t=0;t<Jt.para.server_url.length;t++)this.sendCall(e,Jt.para.server_url[t]);else"string"==typeof Jt.para.server_url&&""!==Jt.para.server_url?this.sendCall(e,Jt.para.server_url,e.callback):Jt.log("\u5f53\u524d server_url \u4e3a\u7a7a\u6216\u4e0d\u6b63\u786e\uff0c\u53ea\u5728\u63a7\u5236\u53f0\u6253\u5370\u65e5\u5fd7\uff0cnetwork \u4e2d\u4e0d\u4f1a\u53d1\u6570\u636e\uff0c\u8bf7\u914d\u7f6e\u6b63\u786e\u7684 server_url\uff01")},Cr.sendCall=function(e,t,r){var i={server_url:t,data:JSON.stringify(e.data),callback:r,config:e.config};f(Jt.para.jsapp)&&!Jt.para.jsapp.isOnline&&"function"==typeof Jt.para.jsapp.setData?(delete i.callback,i=JSON.stringify(i),Jt.para.jsapp.setData(i)):this.realtimeSend(i)},Cr.realtimeSend=function(e){var t=At(e);t.start()},jt.prototype={add:function(e){f(e)&&(this.writeStore(e),"track_signup"!==e.type&&"$pageview"!==e.event||this.sendStrategy())},clearPendingStatus:function(){this.sendingItemKeys.length&&this.removePendingItems(this.sendingItemKeys)},remove:function(t){this.sendingData>0&&--this.sendingData,Ft(t)&&t.length>0&&e(t,function(e){or.remove(e)})},send:function(e){var t,r=this;return v(Jt.para.server_url)&&""!==Jt.para.server_url||Ft(Jt.para.server_url)&&Jt.para.server_url.length?(t=Ft(Jt.para.server_url)?Jt.para.server_url[0]:Jt.para.server_url,void Te({url:t,type:"POST",data:"data_list="+encodeURIComponent(O(JSON.stringify(e.vals))),credentials:!1,timeout:Jt.para.batch_send.datasend_timeout,cors:!0,success:function(){r.remove(e.keys),r.removePendingItems(e.keys)},error:function(){r.sendingData>0&&--r.sendingData,r.removePendingItems(e.keys)}})):void Jt.log("\u5f53\u524d server_url \u4e3a\u7a7a\u6216\u4e0d\u6b63\u786e\uff0c\u53ea\u5728\u63a7\u5236\u53f0\u6253\u5370\u65e5\u5fd7\uff0cnetwork \u4e2d\u4e0d\u4f1a\u53d1\u6570\u636e\uff0c\u8bf7\u914d\u7f6e\u6b63\u786e\u7684 server_url\uff01")},appendPendingItems:function(e){if(Ft(e)!==!1){this.sendingItemKeys=j(this.sendingItemKeys.concat(e));try{var t=this.getPendingItems(),r=j(t.concat(e));localStorage.setItem("sawebjssdk-sendingitems",JSON.stringify(r))}catch(i){}}},removePendingItems:function(e){if(Ft(e)!==!1){this.sendingItemKeys.length&&(this.sendingItemKeys=d(this.sendingItemKeys,function(t){return u(e,t)===-1}));try{var t=this.getPendingItems(),r=d(t,function(t){return u(e,t)===-1});localStorage.setItem("sawebjssdk-sendingitems",JSON.stringify(r))}catch(i){}}},getPendingItems:function(){var e=[];try{var t=localStorage.getItem("sawebjssdk-sendingitems");t&&(e=JSON.parse(t))}catch(r){}return e},sendPrepare:function(e){this.appendPendingItems(e.keys);var t=e.vals,r=t.length;r>0&&this.send({keys:e.keys,vals:t})},sendStrategy:function(){if(document.hasFocus()===!1)return!1;var e=this.readStore();e.keys.length>0&&0===this.sendingData&&(this.sendingData=1,this.sendPrepare(e))},batchInterval:function(){var e=this;setInterval(function(){e.sendStrategy()},Jt.para.batch_send.send_interval)},readStore:function(){for(var e=[],t=[],r=null,i=(new Date).getTime(),n=localStorage.length,a=this.getPendingItems(),s=0;s<n;s++){var o=localStorage.key(s);if(0===o.indexOf("sawebjssdk-")&&/^sawebjssdk\-\d+$/.test(o)){if(a.length&&u(a,o)>-1)continue;r=localStorage.getItem(o),r?(r=P(r),r&&f(r)?(r._flush_time=i,e.push(o),t.push(r)):(localStorage.removeItem(o),Jt.log("localStorage-\u6570\u636eparse\u5f02\u5e38"+r))):(localStorage.removeItem(o),Jt.log("localStorage-\u6570\u636e\u53d6\u503c\u5f02\u5e38"+r))}}return{keys:e,vals:t}},writeStore:function(e){var t=String($()).slice(2,5)+String($()).slice(2,5)+String((new Date).getTime()).slice(3);localStorage.setItem("sawebjssdk-"+t,JSON.stringify(e))}};var $r=new jt,Ar={bridge_info:{touch_app_bridge:!1,verify_success:!1,platform:""},is_verify_success:!1,initPara:function(){var e={is_send:!0,white_list:[],is_mui:!1};"object"==typeof Jt.para.app_js_bridge?Jt.para.app_js_bridge=r({},e,Jt.para.app_js_bridge):Jt.para.use_app_track===!0||Jt.para.app_js_bridge===!0||"only"===Jt.para.use_app_track?(Jt.para.use_app_track_is_send!==!1&&"only"!==Jt.para.use_app_track||(e.is_send=!1),Jt.para.app_js_bridge=r({},e)):"mui"===Jt.para.use_app_track&&(e.is_mui=!0,Jt.para.app_js_bridge=r({},e)),Jt.para.app_js_bridge.is_send===!1&&Jt.log("\u8bbe\u7f6e\u4e86 is_send:false,\u5982\u679c\u6253\u901a\u5931\u8d25\uff0c\u6570\u636e\u5c06\u88ab\u4e22\u5f03\uff01")},initState:function(){function e(e){function t(e){var t={hostname:"",project:""};try{t.hostname=Q(e).hostname,t.project=Q(e).searchParams.get("project")||"default"}catch(r){Jt.log(r)}return t}var r=t(e),i=t(Jt.para.server_url);if(r.hostname===i.hostname&&r.project===i.project)return!0;if(Jt.para.app_js_bridge.white_list.length>0)for(var n=0;n<Jt.para.app_js_bridge.white_list.length;n++){var a=t(Jt.para.app_js_bridge.white_list[n]);if(a.hostname===r.hostname&&a.project===r.project)return!0}return!1}if(f(Jt.para.app_js_bridge)&&!Jt.para.app_js_bridge.is_mui)if(window.webkit&&window.webkit.messageHandlers&&window.webkit.messageHandlers.sensorsdataNativeTracker&&f(window.SensorsData_iOS_JS_Bridge)&&window.SensorsData_iOS_JS_Bridge.sensorsdata_app_server_url)e(window.SensorsData_iOS_JS_Bridge.sensorsdata_app_server_url)&&(Jt.bridge.is_verify_success=!0);else if(f(window.SensorsData_APP_New_H5_Bridge)&&window.SensorsData_APP_New_H5_Bridge.sensorsdata_get_server_url&&window.SensorsData_APP_New_H5_Bridge.sensorsdata_track){var t=window.SensorsData_APP_New_H5_Bridge.sensorsdata_get_server_url();t&&e(t)&&(Jt.bridge.is_verify_success=!0)}this.bridge_info=this.initDefineBridgeInfo()},initDefineBridgeInfo:function(){var e={touch_app_bridge:!0,verify_success:!1,platform:""};return window.webkit&&window.webkit.messageHandlers&&window.webkit.messageHandlers.sensorsdataNativeTracker&&window.webkit.messageHandlers.sensorsdataNativeTracker.postMessage&&f(window.SensorsData_iOS_JS_Bridge)&&window.SensorsData_iOS_JS_Bridge.sensorsdata_app_server_url?(e.platform="ios",Jt.bridge.is_verify_success?e.verify_success="success":e.verify_success="fail"):f(window.SensorsData_APP_New_H5_Bridge)&&window.SensorsData_APP_New_H5_Bridge.sensorsdata_get_server_url&&window.SensorsData_APP_New_H5_Bridge.sensorsdata_track?(e.platform="android",Jt.bridge.is_verify_success?e.verify_success="success":e.verify_success="fail"):"object"==typeof SensorsData_APP_JS_Bridge&&(SensorsData_APP_JS_Bridge.sensorsdata_verify&&SensorsData_APP_JS_Bridge.sensorsdata_visual_verify||SensorsData_APP_JS_Bridge.sensorsdata_track)?(e.platform="android",SensorsData_APP_JS_Bridge.sensorsdata_verify&&SensorsData_APP_JS_Bridge.sensorsdata_visual_verify?SensorsData_APP_JS_Bridge.sensorsdata_visual_verify(JSON.stringify({server_url:Jt.para.server_url}))?e.verify_success="success":e.verify_success="fail":e.verify_success="success"):!/sensors-verify/.test(navigator.userAgent)&&!/sa-sdk-ios/.test(navigator.userAgent)||window.MSStream?e.touch_app_bridge=!1:(e.platform="ios",Jt.bridge.iOS_UA_bridge()?e.verify_success="success":e.verify_success="fail"),e},iOS_UA_bridge:function(){if(/sensors-verify/.test(navigator.userAgent)){var e=navigator.userAgent.match(/sensors-verify\/([^\s]+)/);if(e&&e[0]&&"string"==typeof e[1]&&2===e[1].split("?").length){e=e[1].split("?");var t=null,r=null;try{t=Q(Jt.para.server_url).hostname,r=Q(Jt.para.server_url).searchParams.get("project")||"default"}catch(i){Jt.log(i)}return!(!t||t!==e[0]||!r||r!==e[1])}return!1}return!!/sa-sdk-ios/.test(navigator.userAgent)},dataSend:function(e,t,i){function n(e){var t=JSON.stringify(r({server_url:Jt.para.server_url},e));return t=t.replaceAll(/\r\n/g,""),t=encodeURIComponent(t),"sensorsanalytics://trackEvent?event="+t}var a=e.data;if(f(Jt.para.app_js_bridge)&&!Jt.para.app_js_bridge.is_mui)if(window.webkit&&window.webkit.messageHandlers&&window.webkit.messageHandlers.sensorsdataNativeTracker&&window.webkit.messageHandlers.sensorsdataNativeTracker.postMessage&&f(window.SensorsData_iOS_JS_Bridge)&&window.SensorsData_iOS_JS_Bridge.sensorsdata_app_server_url)Jt.bridge.is_verify_success?(window.webkit.messageHandlers.sensorsdataNativeTracker.postMessage(JSON.stringify({callType:"app_h5_track",data:r({server_url:Jt.para.server_url},a)})),"function"==typeof i&&i()):Jt.para.app_js_bridge.is_send?(Jt.debug.apph5({data:a,step:"4.1",output:"all"}),t.prepareServerUrl(e)):"function"==typeof i&&i();else if(f(window.SensorsData_APP_New_H5_Bridge)&&window.SensorsData_APP_New_H5_Bridge.sensorsdata_get_server_url&&window.SensorsData_APP_New_H5_Bridge.sensorsdata_track)Jt.bridge.is_verify_success?(SensorsData_APP_New_H5_Bridge.sensorsdata_track(JSON.stringify(r({server_url:Jt.para.server_url},a))),"function"==typeof i&&i()):Jt.para.app_js_bridge.is_send?(Jt.debug.apph5({data:a,step:"4.2",output:"all"}),t.prepareServerUrl(e)):"function"==typeof i&&i();else if("object"==typeof SensorsData_APP_JS_Bridge&&(SensorsData_APP_JS_Bridge.sensorsdata_verify||SensorsData_APP_JS_Bridge.sensorsdata_track))SensorsData_APP_JS_Bridge.sensorsdata_verify?SensorsData_APP_JS_Bridge.sensorsdata_verify(JSON.stringify(r({server_url:Jt.para.server_url},a)))?"function"==typeof i&&i():Jt.para.app_js_bridge.is_send?(Jt.debug.apph5({data:a,step:"3.1",output:"all"}),t.prepareServerUrl(e)):"function"==typeof i&&i():(SensorsData_APP_JS_Bridge.sensorsdata_track(JSON.stringify(r({server_url:Jt.para.server_url},a))),"function"==typeof i&&i());else if(!/sensors-verify/.test(navigator.userAgent)&&!/sa-sdk-ios/.test(navigator.userAgent)||window.MSStream)f(Jt.para.app_js_bridge)&&Jt.para.app_js_bridge.is_send===!0?(Jt.debug.apph5({data:a,step:"2",output:"all"}),t.prepareServerUrl(e)):"function"==typeof i&&i();else{var s=null;if(Jt.bridge.iOS_UA_bridge()){s=document.createElement("iframe");var o=n(a);s.setAttribute("src",o),document.documentElement.appendChild(s),s.parentNode.removeChild(s),s=null,"function"==typeof i&&i()}else Jt.para.app_js_bridge.is_send?(Jt.debug.apph5({data:a,step:"3.2",output:"all"}),t.prepareServerUrl(e)):"function"==typeof i&&i()}else f(Jt.para.app_js_bridge)&&Jt.para.app_js_bridge.is_mui?f(window.plus)&&window.plus.SDAnalytics&&window.plus.SDAnalytics.trackH5Event?(window.plus.SDAnalytics.trackH5Event(e),"function"==typeof i&&i()):f(Jt.para.app_js_bridge)&&Jt.para.app_js_bridge.is_send===!0?t.prepareServerUrl(e):"function"==typeof i&&i():(Jt.debug.apph5({data:a,step:"1",output:"code"}),t.prepareServerUrl(e))},app_js_bridge_v1:function(){function e(e){i=e,k(i)&&(i=JSON.parse(i)),n&&(n(i),n=null,i=null)}function t(){"object"==typeof window.SensorsData_APP_JS_Bridge&&window.SensorsData_APP_JS_Bridge.sensorsdata_call_app&&(i=SensorsData_APP_JS_Bridge.sensorsdata_call_app(),k(i)&&(i=JSON.parse(i)))}function r(){if(/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream){var e=document.createElement("iframe");e.setAttribute("src","sensorsanalytics://getAppInfo"),document.documentElement.appendChild(e),e.parentNode.removeChild(e),e=null}}var i=null,n=null;window.sensorsdata_app_js_bridge_call_js=function(t){e(t)},Jt.getAppStatus=function(e){return r(),t(),e?void(null===i?n=e:(e(i),i=null)):i}},supportAppCallJs:function(){window.sensorsdata_app_call_js=function(e,t){if(e in window.sensorsdata_app_call_js.modules)return window.sensorsdata_app_call_js.modules[e](t)},window.sensorsdata_app_call_js.modules={}}},jr=function(e){this.list={},this.type=e.type,this.app_call_js=a(e.app_call_js)?e.app_call_js:function(){},this.init()};jr.prototype.init=function(){var e=this;window.sensorsdata_app_call_js.modules[this.type]||(window.sensorsdata_app_call_js.modules[this.type]=function(t){return e.app_call_js(t)})},jr.prototype.jsCallApp=function(e){var t={callType:this.type,data:e};if(window.webkit&&window.webkit.messageHandlers&&window.webkit.messageHandlers.sensorsdataNativeTracker&&window.webkit.messageHandlers.sensorsdataNativeTracker.postMessage)window.webkit.messageHandlers.sensorsdataNativeTracker.postMessage(JSON.stringify(t));else{if(!f(window.SensorsData_APP_New_H5_Bridge)||!window.SensorsData_APP_New_H5_Bridge.sensorsdata_js_call_app)return Jt.log("\u6570\u636e\u53d1\u5f80App\u5931\u8d25\uff0cApp\u6ca1\u6709\u66b4\u9732bridge"),!1;window.SensorsData_APP_New_H5_Bridge.sensorsdata_js_call_app(JSON.stringify(t))}},jr.prototype.getAppData=function(){return f(window.SensorsData_APP_New_H5_Bridge)?a(window.SensorsData_APP_New_H5_Bridge[this.type])?window.SensorsData_APP_New_H5_Bridge[this.type]():window.SensorsData_APP_New_H5_Bridge[this.type]:f(window.SensorsData_APP_JS_Bridge)&&a(window.SensorsData_APP_JS_Bridge[this.type])?window.SensorsData_APP_JS_Bridge[this.type]():void 0},jr.prototype.hasAppBridge=function(){return window.webkit&&window.webkit.messageHandlers&&window.webkit.messageHandlers.sensorsdataNativeTracker&&window.webkit.messageHandlers.sensorsdataNativeTracker.postMessage?"ios":f(window.SensorsData_APP_New_H5_Bridge)&&window.SensorsData_APP_New_H5_Bridge.sensorsdata_js_call_app?"android":(Jt.log("App\u7aefbridge\u672a\u66b4\u9732"),!1)},jr.prototype.requestToApp=function(e){function t(){var e=(new Date).getTime().toString(16),t=String($()).replace(".","").slice(1,8);return e+"-"+t}var r=this,i=f(e.data)?e.data:{};a(e.callback)||(e.callback=function(){}),f(e.timeout)&&S(e.timeout.time)&&(a(e.timeout.callback)||(e.timeout.callback=function(){}),e.timer=setTimeout(function(){e.timeout.callback(),delete r.list[n]},e.timeout.time));var n=t();this.list[n]=e;var s={callType:this.type,data:i};if(s.data.message_id=n,window.webkit&&window.webkit.messageHandlers&&window.webkit.messageHandlers.sensorsdataNativeTracker&&window.webkit.messageHandlers.sensorsdataNativeTracker.postMessage)window.webkit.messageHandlers.sensorsdataNativeTracker.postMessage(JSON.stringify(s));else{if(!f(window.SensorsData_APP_New_H5_Bridge)||!window.SensorsData_APP_New_H5_Bridge.sensorsdata_js_call_app)return Jt.log("\u6570\u636e\u53d1\u5f80App\u5931\u8d25\uff0cApp\u6ca1\u6709\u66b4\u9732bridge"),!1;window.SensorsData_APP_New_H5_Bridge.sensorsdata_js_call_app(JSON.stringify(s))}},jr.prototype["double"]=function(e){if(e.message_id){var t=this.list[e.message_id];t&&(t.timer&&clearTimeout(t.timer),t.callback(e),delete this.list[e.message_id])}};var Or={};Or.initUrl=function(){var e,t={server_url:{project:"",host:""},page_url:{host:"",pathname:""}};if(!v(Jt.para.server_url))return Jt.log("----vcollect---server_url\u5fc5\u987b\u4e3a\u5b57\u7b26\u4e32"),!1;try{e=Q(Jt.para.server_url),t.server_url.project=e.searchParams.get("project")||"default",t.server_url.host=e.host}catch(r){return Jt.log("----vcollect---server_url\u89e3\u6790\u5f02\u5e38",r),!1}var i;try{i=Q(location.href),t.page_url.host=i.hostname,t.page_url.pathname=i.pathname}catch(r){return Jt.log("----vcollect---\u9875\u9762\u5730\u5740\u89e3\u6790\u5f02\u5e38",r),!1}return t},Or.isDiv=function(e){if(e.element_path){var t=e.element_path.split(">"),r=_(t.pop());if("div"!==r.slice(0,3))return!1}return!0},Or.configIsMatchNew=function(e,t){if(v(e.$element_selector)&&v(t.element_selector)){if("element_selector"===t.element_field&&"equal"===t["function"])return e.$element_selector===t.element_selector;if("element_selector"===t.element_field&&"contain"===t["function"])return e.$element_selector.indexOf(t.element_selector)>-1}if(v(e.$element_path)&&v(t.element_path)){if("element_path"===t.element_field&&"equal"===t["function"])return e.$element_path===t.element_path;if("element_path"===t.element_field&&"contain"===t["function"])return e.$element_path.indexOf(t.element_path)>-1}return!1},Or.configIsMatch=function(e,t){return(!t.limit_element_content||t.element_content===e.$element_content)&&((!t.limit_element_position||t.element_position===String(e.$element_position))&&(t.element_field&&t["function"]?Or.configIsMatchNew(e,t):Or.configIsMatchOldVersion(e,t)))},Or.configIsMatchOldVersion=function(e,t){if(!t.element_path)return!1;if(void 0!==e.$element_position){if(t.element_path!==e.$element_path)return!1}else if(Jt.vtrackBase.isDiv({element_path:t.element_path})){if(e.$element_path.indexOf(t.element_path)<0)return!1}else if(t.element_path!==e.$element_path)return!1;return!0},Or.filterConfig=function(t,r,i){var n=[];if(!i){var a=Or.initUrl();if(!a)return[];i=a.page_url}return"$WebClick"===t.event&&e(r,function(e){f(e)&&("webclick"===e.event_type||"appclick"===e.event_type)&&f(e.event)&&e.event.url_host===i.host&&e.event.url_path===i.pathname&&Or.configIsMatch(t.properties,e.event)&&n.push(e)}),n},Or.getPropElInLi=function(e,t){if(!(e&&b(e)&&v(t)))return null;if("li"!==e.tagName.toLowerCase())return null;var r,i=Jt.heatmap.getDomSelector(e);if(i){r=i+t;var n=q(r);return n?n:null}return Jt.log("----custom---\u83b7\u53d6\u540c\u7ea7\u5c5e\u6027\u5143\u7d20\u5931\u8d25\uff0cselector\u4fe1\u606f\u5f02\u5e38",i,t),null},Or.getProp=function(e,t){if(!f(e))return!1;if(!(v(e.name)&&e.name.length>0))return Jt.log("----vcustom----\u5c5e\u6027\u540d\u4e0d\u5408\u6cd5,\u5c5e\u6027\u629b\u5f03",e.name),!1;var r,i,n={};if("content"===e.method){var a;if(v(e.element_selector)&&e.element_selector.length>0)a=q(e.element_selector);else{if(!t||!v(e.list_selector))return Jt.log("----vcustom----\u5c5e\u6027\u914d\u7f6e\u5f02\u5e38\uff0c\u5c5e\u6027\u629b\u5f03",e.name),!1;var s=q(t.properties.$element_selector);if(!s)return Jt.log("----vcustom----\u70b9\u51fb\u5143\u7d20\u83b7\u53d6\u5f02\u5e38\uff0c\u5c5e\u6027\u629b\u5f03",e.name),!1;var o=Jt.heatmap.getClosestLi(s);a=Or.getPropElInLi(o,e.list_selector)}if(!a||!b(a))return Jt.log("----vcustom----\u5c5e\u6027\u5143\u7d20\u83b7\u53d6\u5931\u8d25\uff0c\u5c5e\u6027\u629b\u5f03",e.name),!1;if("input"===a.tagName.toLowerCase())r=a.value||"";else if("select"===a.tagName.toLowerCase()){var l=a.selectedIndex;S(l)&&b(a[l])&&(r=R(a[l],"select"))}else r=R(a,a.tagName.toLowerCase());if(e.regular){try{i=new RegExp(e.regular).exec(r)}catch(c){return Jt.log("----vcustom----\u6b63\u5219\u5904\u7406\u5931\u8d25\uff0c\u5c5e\u6027\u629b\u5f03",e.name),!1}if(null===i)return Jt.log("----vcustom----\u5c5e\u6027\u89c4\u5219\u5904\u7406\uff0c\u672a\u5339\u914d\u5230\u7ed3\u679c,\u5c5e\u6027\u629b\u5f03",e.name),!1;if(!Ft(i)||!v(i[0]))return Jt.log("----vcustom----\u6b63\u5219\u5904\u7406\u5f02\u5e38\uff0c\u5c5e\u6027\u629b\u5f03",e.name,i),!1;r=i[0]}if("STRING"===e.type)n[e.name]=r;else if("NUMBER"===e.type){if(r.length<1)return Jt.log("----vcustom----\u672a\u83b7\u53d6\u5230\u6570\u5b57\u5185\u5bb9\uff0c\u5c5e\u6027\u629b\u5f03",e.name,r),!1;if(isNaN(Number(r)))return Jt.log("----vcustom----\u6570\u5b57\u7c7b\u578b\u5c5e\u6027\u8f6c\u6362\u5931\u8d25\uff0c\u5c5e\u6027\u629b\u5f03",e.name,r),!1;n[e.name]=Number(r)}return n}return Jt.log("----vcustom----\u5c5e\u6027\u4e0d\u652f\u6301\u6b64\u83b7\u53d6\u65b9\u5f0f",e.name,e.method),!1},Or.getAssignConfigs=function(t,r){var i=Or.initUrl();if(!i||!i.page_url)return[];if(!f(r))return[];var n=[];return r.events=r.events||r.eventList,Ft(r.events)&&r.events.length>0?(e(r.events,function(e){f(e)&&f(e.event)&&e.event.url_host===i.page_url.host&&e.event.url_path===i.page_url.pathname&&t(e)&&n.push(e)}),n):[]},Or.addCustomProps=function(e){if("success"===Jt.bridge.bridge_info.verify_success){var t=Jt.vapph5collect.customProp.geth5Props(JSON.parse(JSON.stringify(e)));f(t)&&!g(t)&&(e.properties=r(e.properties,t))}var i=Jt.vtrackcollect.customProp.getVtrackProps(JSON.parse(JSON.stringify(e)));return f(i)&&!g(i)&&(e.properties=r(e.properties,i)),e},Or.init=function(){Jt.vtrackcollect.init(),"success"===Jt.bridge.bridge_info.verify_success&&Jt.vapph5collect.init()};var Ir={events:[],init:function(e){this.filterWebClickEvents(e)},filterWebClickEvents:function(e){this.events=Jt.vtrackcollect.getAssignConfigs(function(e){return!(!f(e)||e.event.unlimited_div!==!0||"webclick"!==e.event_type)},e)},isTargetEle:function(e){var t=Jt.heatmap.getEleDetail(e);if(!f(t)||!v(t.$element_path))return!1;for(var r=0;r<this.events.length;r++)if(f(this.events[r])&&f(this.events[r].event)&&Jt.vtrackcollect.configIsMatch(t,this.events[r].event))return!0;return!1}},Tr={events:[],configSwitch:!1,collectAble:function(){return this.configSwitch&&f(Jt.para.heatmap)&&Jt.para.heatmap.get_vtrack_config},updateEvents:function(e){this.events=Jt.vtrackcollect.getAssignConfigs(function(e){return!!(f(e)&&Ft(e.properties)&&e.properties.length>0)},e),this.events.length?this.configSwitch=!0:this.configSwitch=!1},getVtrackProps:function(e){var t={};return this.collectAble()?("$WebClick"===e.event&&(t=this.clickCustomPropMaker(e,this.events)),t):{}},clickCustomPropMaker:function(t,i,n){var a=this;n=n||this.filterConfig(t,i,Jt.vtrackcollect.url_info.page_url);var s={};return n.length?(e(n,function(i){Ft(i.properties)&&i.properties.length>0&&e(i.properties,function(e){var i=a.getProp(e,t);f(i)&&r(s,i)})}),s):{}},getProp:Or.getProp,getPropElInLi:Or.getPropElInLi,filterConfig:Or.filterConfig},Lr={unlimitedDiv:Ir,config:{},storageEnable:!0,storage_name:"webjssdkvtrackcollect",para:{session_time:18e5,timeout:5e3,update_interval:18e5},url_info:{},timer:null,update_time:null,customProp:Tr,initUrl:function(){var e=Or.initUrl();if(e){var t;try{t=new X(Jt.para.server_url),t._values.Path="/config/visualized/Web.conf",e.api_url=t.getUrl()}catch(r){return Jt.log("----vtrackcollect---API\u5730\u5740\u89e3\u6790\u5f02\u5e38",r),!1}this.url_info=e}return e},init:function(){if(!f(Jt.para.heatmap)||!Jt.para.heatmap.get_vtrack_config)return!1;if(or.isSupport()||(this.storageEnable=!1),!this.initUrl())return Jt.log("----vtrackcustom----\u521d\u59cb\u5316\u5931\u8d25\uff0curl\u4fe1\u606f\u89e3\u6790\u5931\u8d25"),!1;if(this.storageEnable){var e=or.parse(this.storage_name);if(f(e)&&f(e.data))if(this.serverUrlIsSame(e.serverUrl)){this.config=e.data,this.update_time=e.updateTime,this.updateConfig(e.data);var t=(new Date).getTime(),r=t-this.update_time;if(S(r)&&r>0&&r<this.para.session_time){var i=this.para.update_interval-r;this.setNextFetch(i)}else this.getConfigFromServer()}else this.getConfigFromServer();else this.getConfigFromServer()}else this.getConfigFromServer();this.pageStateListenner()},serverUrlIsSame:function(e){return!!f(e)&&(e.host===this.url_info.server_url.host&&e.project===this.url_info.server_url.project)},getConfigFromServer:function(){var e=this,t=function(t,r){e.update_time=(new Date).getTime();var i={};200===t?r&&f(r)&&"Web"===r.os&&(i=r,e.updateConfig(i)):205===t?e.updateConfig(i):304===t?i=e.config:(Jt.log("----vtrackcustom----\u6570\u636e\u5f02\u5e38",t),e.updateConfig(i)),e.updateStorage(i),e.setNextFetch()},r=function(t){e.update_time=(new Date).getTime(),Jt.log("----vtrackcustom----\u914d\u7f6e\u62c9\u53d6\u5931\u8d25",t),e.setNextFetch()};this.sendRequest(t,r)},setNextFetch:function(e){var t=this;this.timer&&(clearTimeout(this.timer),this.timer=null),e=e||this.para.update_interval,this.timer=setTimeout(function(){t.getConfigFromServer()},e)},pageStateListenner:function(){var e=this;je({visible:function(){var t=(new Date).getTime(),r=t-e.update_time;if(S(r)&&r>0&&r<e.para.update_interval){var i=e.para.update_interval-r;e.setNextFetch(i)}else e.getConfigFromServer()},hidden:function(){e.timer&&(clearTimeout(e.timer),e.timer=null)}})},updateConfig:function(e){return!!f(e)&&(this.config=e,this.customProp.updateEvents(e),void this.unlimitedDiv.init(e))},updateStorage:function(e){if(!this.storageEnable)return!1;if(!f(e))return!1;var t;if(this.url_info.server_url)t=this.url_info.server_url;else{var r=Jt.vtrackcollect.initUrl();if(!r)return!1;t=r.server_url}var i={updateTime:(new Date).getTime(),data:e,serverUrl:t};or.set(this.storage_name,JSON.stringify(i))},sendRequest:function(e,t){var r=this,i={app_id:this.url_info.page_url.host};this.config.version&&(i.v=this.config.version),Le({url:r.url_info.api_url,callbackName:"saJSSDKVtrackCollectConfig",data:i,timeout:r.para.timeout,success:function(t,r){e(t,r)},error:function(e){t(e)}})},getAssignConfigs:Or.getAssignConfigs,configIsMatch:Or.configIsMatch},xr={events:[],getAssignConfigs:Or.getAssignConfigs,filterConfig:Or.filterConfig,getProp:Or.getProp,initUrl:Or.initUrl,updateEvents:function(e){Ft(e)&&(this.events=e)},init:function(){this.initAppGetPropsBridge()},geth5Props:function(t){var i={},n=[],a=this;if(!this.events.length)return{};if("$WebClick"===t.event){var s=this.filterConfig(t,this.events);if(!s.length)return{};e(s,function(s){f(s)&&(Ft(s.properties)&&s.properties.length>0&&e(s.properties,function(e){if(f(e))if(e.h5===!1)Ft(i.sensorsdata_app_visual_properties)||(i.sensorsdata_app_visual_properties=[]),i.sensorsdata_app_visual_properties.push(e);else{var n=a.getProp(e,t);f(n)&&(i=r(i,n))}}),v(s.event_name)&&n.push(s.event_name))}),f(window.SensorsData_App_Visual_Bridge)&&window.SensorsData_App_Visual_Bridge.sensorsdata_visualized_mode&&(window.SensorsData_App_Visual_Bridge.sensorsdata_visualized_mode===!0||window.SensorsData_App_Visual_Bridge.sensorsdata_visualized_mode())&&(i.sensorsdata_web_visual_eventName=n)}return i.sensorsdata_app_visual_properties&&(i.sensorsdata_app_visual_properties=O(JSON.stringify(i.sensorsdata_app_visual_properties))),i},initAppGetPropsBridge:function(){var t=this;return new Jt.JSBridge({type:"getJSVisualProperties",app_call_js:function(i){var n={};try{i=JSON.parse(I(i))}catch(s){Jt.log("getJSVisualProperties data parse error!")}if(f(i)){var o=i.sensorsdata_js_visual_properties,l=t.initUrl();l&&(l=l.page_url,Ft(o)&&o.length>0&&e(o,function(e){if(f(e)&&e.url_host===l.host&&e.url_path===l.pathname&&e.h5){var i=t.getProp(e);f(i)&&(n=r(n,i))}}))}var c=Jt.bridge.bridge_info.platform;if("android"===c){var u={callType:"getJSVisualProperties",data:n};f(i)&&i.message_id&&(u.message_id=i.message_id),f(window.SensorsData_APP_New_H5_Bridge)&&a(SensorsData_APP_New_H5_Bridge.sensorsdata_js_call_app)?SensorsData_APP_New_H5_Bridge.sensorsdata_js_call_app(JSON.stringify(u)):f(window.SensorsData_APP_JS_Bridge)&&a(SensorsData_APP_JS_Bridge.sensorsdata_js_call_app)&&SensorsData_APP_JS_Bridge.sensorsdata_js_call_app(JSON.stringify(u))}return n}})}},Er={events:[],customProp:xr,getAssignConfigs:Or.getAssignConfigs,initUrl:Or.initUrl,init:function(){if(this.initUrl()){var e=this.getConfigFromApp();e&&this.updateConfigs(e),this.customProp.init(),this.initAppUpdateConfigBridge()}},initAppUpdateConfigBridge:function(){var e=this;return new Jt.JSBridge({type:"updateH5VisualConfig",app_call_js:function(t){if(t){try{t=JSON.parse(I(t))}catch(r){return void Jt.log("updateH5VisualConfig result parse error\uff01")}e.updateConfigs(t)}}})},getConfigFromApp:function(){var e=new Jt.JSBridge({type:"sensorsdata_get_app_visual_config"}),t=e.getAppData();if(t)try{t=JSON.parse(I(t))}catch(r){t=null,Jt.log("getAppVisualConfig result parse error\uff01")}return t},updateConfigs:function(e){this.events=this.filterConfigs(e),this.customProp.updateEvents(this.events)},filterConfigs:function(e){return this.getAssignConfigs(function(e){return!(!f(e)||e.h5===!1)},e)}},Hr={searchKeywordMatch:location.search.match(/sa-request-id=([^&#]+)/),isSeachHasKeyword:function(){var e=this.searchKeywordMatch;return!!(e&&e[0]&&e[1])&&("string"==typeof sessionStorage.getItem("sensors-visual-mode")&&sessionStorage.removeItem("sensors-visual-mode"),!0)},hasKeywordHandle:function(){var e=this.searchKeywordMatch,t=location.search.match(/sa-request-type=([^&#]+)/),r=location.search.match(/sa-request-url=([^&#]+)/);vr.setNotice(r),lr.isSupport()&&(r&&r[0]&&r[1]&&sessionStorage.setItem("sensors_heatmap_url",V(r[1])),sessionStorage.setItem("sensors_heatmap_id",e[1]),t&&t[0]&&t[1]?"1"===t[1]||"2"===t[1]||"3"===t[1]?(t=t[1],sessionStorage.setItem("sensors_heatmap_type",t)):t=null:t=null!==sessionStorage.getItem("sensors_heatmap_type")?sessionStorage.getItem("sensors_heatmap_type"):null),this.isReady(e[1],t)},isReady:function(e,t,r){Jt.para.heatmap_url?M({success:function(){setTimeout(function(){"undefined"!=typeof sa_jssdk_heatmap_render&&(sa_jssdk_heatmap_render(Jt,e,t,r),"object"==typeof console&&"function"==typeof console.log&&(Jt.heatmap_version&&Jt.heatmap_version===Jt.lib_version||console.log("heatmap.js\u4e0esensorsdata.js\u7248\u672c\u53f7\u4e0d\u4e00\u81f4\uff0c\u53ef\u80fd\u5b58\u5728\u98ce\u9669!")))},0)},error:function(){},type:"js",url:Jt.para.heatmap_url}):Jt.log("\u6ca1\u6709\u6307\u5b9aheatmap_url\u7684\u8def\u5f84")},isStorageHasKeyword:function(){return lr.isSupport()&&"string"==typeof sessionStorage.getItem("sensors_heatmap_id")},storageHasKeywordHandle:function(){vr.setNotice(),Hr.isReady(sessionStorage.getItem("sensors_heatmap_id"),sessionStorage.getItem("sensors_heatmap_type"),location.href)}},Jr={isStorageHasKeyword:function(){return lr.isSupport()&&"string"==typeof sessionStorage.getItem("sensors-visual-mode")},isSearchHasKeyword:function(){return!!location.search.match(/sa-visual-mode=true/)&&("string"==typeof sessionStorage.getItem("sensors_heatmap_id")&&sessionStorage.removeItem("sensors_heatmap_id"),!0)},loadVtrack:function(){M({success:function(){},error:function(){},type:"js",url:Jt.para.vtrack_url?Jt.para.vtrack_url:location.protocol+"//static.sensorsdata.cn/sdk/"+Jt.lib_version+"/vtrack.min.js"})},messageListener:function(e){function t(e){return Yt.isHttpUrl(e)?Yt.removeScriptProtocol(e):(Jt.log("\u53ef\u89c6\u5316\u6a21\u5f0f\u68c0\u6d4b URL \u5931\u8d25"),!1)}if("sa-fe"!==e.data.source)return!1;if("v-track-mode"===e.data.type){if(e.data.data&&e.data.data.isVtrack)if(lr.isSupport()&&sessionStorage.setItem("sensors-visual-mode","true"),e.data.data.userURL&&location.search.match(/sa-visual-mode=true/)){var r=t(e.data.data.userURL);r&&(window.location.href=r)}else Jr.loadVtrack();window.removeEventListener("message",Jr.messageListener,!1)}},removeMessageHandle:function(){window.removeEventListener&&window.removeEventListener("message",Jr.messageListener,!1)},verifyVtrackMode:function(){window.addEventListener&&window.addEventListener("message",Jr.messageListener,!1),Jr.postMessage()},postMessage:function(){window.parent&&window.parent.postMessage&&window.parent.postMessage({source:"sa-web-sdk",type:"v-is-vtrack",data:{sdkversion:"1.21.6"}},"*")},notifyUser:function(){var e=function(t){return"sa-fe"===t.data.source&&void("v-track-mode"===t.data.type&&(t.data.data&&t.data.data.isVtrack&&alert("\u5f53\u524d\u7248\u672c\u4e0d\u652f\u6301\uff0c\u8bf7\u5347\u7ea7\u90e8\u7f72\u795e\u7b56\u6570\u636e\u6cbb\u7406"),window.removeEventListener("message",e,!1)))};window.addEventListener&&window.addEventListener("message",e,!1),Jr.postMessage()}},Br=["setItem","deleteItem","getAppStatus","track","quick","register","registerPage","registerOnce","trackSignup","setProfile","setOnceProfile","appendProfile","incrementProfile","deleteProfile","unsetProfile","identify","login","logout","trackLink","clearAllRegister","clearPageRegister"],Ur={track:function(e,t,r){},quick:function(e,t,r,i){},register:function(e){},registerPage:function(e){},registerOnce:function(e){},clearAllRegister:function(e){},trackSignup:function(e,t,r,i){},setProfile:function(e,t){},setOnceProfile:function(e,t){},appendProfile:function(e,t){},incrementProfile:function(e,t){},deleteProfile:function(e){},unsetProfile:function(e,t){},identify:function(e,t){},login:function(e,t){},logout:function(e){},trackLink:function(e,t,r){},deleteItem:function(e,t){},setItem:function(e,t,r){},getAppStatus:function(e){},clearPageRegister:function(e){}},Rr=window.sensors_data_pre_config,Mr=!!f(Rr)&&Rr.is_compliance_enabled;Jt.init=function(e){return!(Jt.readyState&&Jt.readyState.state&&Jt.readyState.state>=2)&&(Mr&&Ht(!0),Jt.setInitVar(),Jt.readyState.setState(2),Jt.initPara(e),Jt.bridge.supportAppCallJs(),Jt.detectMode(),void Jt.iOSWebClickPolyfill())},Mr?Ht(!1):(Ht(!0),Et());var Kr=Jt;try{Jt.modules={},Jt.modules.Amp=function(){"use strict";var e={sd:null,init:function(e){if(this.sd)return!1;if(this.sd=e,!this.sd||!this.sd._)return!1;var t=this.sd._.cookie.get("sensors_amp_id"),r=this.sd.store._state.distinct_id;if(t&&t.length>0){var i="amp-"===t.slice(0,4);if(t!==r){if(!i)return!1;this.sd.store._state.first_id?(this.sd.identify(t,!0),this.sd.saEvent.send({original_id:t,distinct_id:r,type:"track_signup",event:"$SignUp",properties:{}},null),this.setAmpId(r)):this.sd.identify(t,!0)}}else this.setAmpId(r);this.addListener()},addListener:function(){var e=this;this.sd.events.on("changeDistinctId",function(t){e.setAmpId(t)}),this.sd.events.isReady()},setAmpId:function(e){this.sd._.cookie.set("sensors_amp_id",e)}};return window.SensorsDataWebJSSDKPlugin&&"[object Object]"===Object.prototype.toString.call(window.SensorsDataWebJSSDKPlugin)?window.SensorsDataWebJSSDKPlugin.Amp=window.SensorsDataWebJSSDKPlugin.Amp||e:window.SensorsDataWebJSSDKPlugin={Amp:e},e}(),Jt.modules.Channel=function(){"use strict";var e,t,r={event_list:[],latest_event_initial_time:null,max_save_time:2592e6,init:function(r){return!t&&(!!(t=r)&&(e=t._,!!e.localStorage.isSupport()&&(t.para.max_string_length=1024,this.eventList.init(),this.addLatestChannelUrl(),void this.addIsChannelCallbackEvent())))},addIsChannelCallbackEvent:function(){t.registerPage({$is_channel_callback_event:function(e){if(e.event&&"$WebClick"!==e.event&&"$pageview"!==e.event&&"$WebStay"!==e.event&&"$SignUp"!==e.event)return!r.eventList.hasEvent(e.event)&&(r.eventList.add(e.event),!0)}})},addLatestChannelUrl:function(){var i=this.getUrlDomain(),n=this.cookie.getChannel();if("url\u89e3\u6790\u5931\u8d25"===i)this.registerAndSave({_sa_channel_landing_url:"",_sa_channel_landing_url_error:"url\u7684domain\u89e3\u6790\u5931\u8d25"
	});else if(e.isReferralTraffic(document.referrer)){var a=e.getQueryParam(location.href,"sat_cf");e.isString(a)&&a.length>0?(this.registerAndSave({_sa_channel_landing_url:location.href}),r.channelLinkHandler()):this.registerAndSave({_sa_channel_landing_url:""})}else n?t.registerPage(n):t.registerPage({_sa_channel_landing_url:"",_sa_channel_landing_url_error:"\u53d6\u503c\u5f02\u5e38"})},registerAndSave:function(e){t.registerPage(e),this.cookie.saveChannel(e)},cookie:{getChannel:function(){var r;try{r=JSON.parse(e.cookie.get("sensorsdata2015jssdkchannel"))}catch(i){t.log(i)}return!(!e.isObject(r)||!r.prop)&&r.prop},saveChannel:function(t){var r={prop:t};e.cookie.set("sensorsdata2015jssdkchannel",JSON.stringify(r))}},channelLinkHandler:function(){this.eventList.reset(),t.track("$ChannelLinkReaching")},getUrlDomain:function(){var t=e.info.pageProp.url_domain;return""===t&&(t="url\u89e3\u6790\u5931\u8d25"),t},eventList:{init:function(){var t=this.get(),i=(new Date).getTime();if(t&&e.isNumber(t.latest_event_initial_time)&&e.isArray(t.eventList)){var n=i-t.latest_event_initial_time;n>0&&n<r.max_save_time?(r.event_list=t.eventList,r.latest_event_initial_time=t.latest_event_initial_time):this.reset()}else this.reset()},get:function(){var r={};try{r=JSON.parse(e.localStorage.get("sawebjssdkchannel"))}catch(i){t.log(i)}return r},add:function(e){r.event_list.push(e),this.save()},save:function(){var t={latest_event_initial_time:r.latest_event_initial_time,eventList:r.event_list};e.localStorage.set("sawebjssdkchannel",JSON.stringify(t))},reset:function(){r.event_list=[],r.latest_event_initial_time=(new Date).getTime(),this.save()},hasEvent:function(t){var i=!1;return e.each(r.event_list,function(e){e===t&&(i=!0)}),i}}};return window.SensorsDataWebJSSDKPlugin&&"[object Object]"===Object.prototype.toString.call(window.SensorsDataWebJSSDKPlugin)?window.SensorsDataWebJSSDKPlugin.SensorsChannel=window.SensorsDataWebJSSDKPlugin.SensorsChannel||r:window.SensorsDataWebJSSDKPlugin={SensorsChannel:r},r}(),Jt.modules.Deeplink=function(){"use strict";function e(){return"undefined"!=typeof t&&document[t]}var t,r=(/micromessenger\/([\d.]+)/i.test(navigator.userAgent||""),function(){var e={};return"undefined"!=typeof document.hidden?(e.hidden="hidden",e.visibilityChange="visibilitychange"):"undefined"!=typeof document.msHidden?(e.hidden="msHidden",e.visibilityChange="msvisibilitychange"):"undefined"!=typeof document.webkitHidden&&(e.hidden="webkitHidden",e.visibilityChange="webkitvisibilitychange"),e});t=r().hidden;var i={android:/Android/i,iOS:/iPhone|iPad|iPod/i},n=function(){for(var e in i)if(navigator.userAgent.match(i[e]))return e;return""},a=n(),s=function(){return i.hasOwnProperty(a)},o=function(e){return null!=e&&"[object Object]"==Object.prototype.toString.call(e)},l=function(e){var t=/\/sd\/(\w+)\/(\w+)$/;return e.match(t)},c=function(e){var t=e._.URL(e.para.server_url);return{origin:t.origin,project:t.searchParams.get("project")||"default"}},u=function(r,i,n){r.log("\u5c1d\u8bd5\u5524\u8d77 android app");var a=i;r.log("\u5524\u8d77APP\u7684\u5730\u5740\uff1a"+a),window.location=a,r.timer=setTimeout(function(){var i=e();return r.log("hide:"+t+":"+document[t]),i?(r.log("The page is hidden, stop navigating to download page"),!1):(r.log("App\u53ef\u80fd\u672a\u5b89\u88c5\uff0c\u8df3\u8f6c\u5230\u4e0b\u8f7d\u5730\u5740"),void(window.location=n))},r.timeout)},d=function(t,r,i){t.log("\u5c1d\u8bd5\u5524\u8d77 iOS app:"+r),window.location.href=r,t.timer=setTimeout(function(){var r=e();return r?(t.log("The page is hidden, stop navigating to download page"),!1):(t.log("App\u53ef\u80fd\u672a\u5b89\u88c5\uff0c\u8df3\u8f6c\u5230\u4e0b\u8f7d\u5730\u5740"),void(window.location.href=i))},t.timeout),t.log("new timer:"+t.timer)},p={key:null,timer:null,sd:null,data:null,timeout:2500,apiURL:"{origin}/sdk/deeplink/param?key={key}&system_type=JS&project={project}",init:function(){if(this.sd)return this.log("deeplink\u5df2\u7ecf\u521d\u59cb\u5316"),!1;if(o(sensorsDataAnalytic201505)&&(this.sd=sensorsDataAnalytic201505),this.log("init()"),null===this.sd)return this.log("\u795e\u7b56JS SDK\u672a\u6210\u529f\u5f15\u5165"),!1;var e={};if(arguments.length>0&&(1===arguments.length&&o(arguments[0])?e=arguments[0]:arguments.length>=2&&o(arguments[1])&&(e=arguments[1])),!s())return this.log("\u4e0d\u652f\u6301\u5f53\u524d\u7cfb\u7edf\uff0c\u76ee\u524d\u53ea\u652f\u6301Android\u548ciOS"),!1;if(o(e)&&this.sd._.isNumber(e.timeout)&&e.timeout>=2500&&(this.timeout=e.timeout),!this.sd.para.server_url)return this.log("\u795e\u7b56JS SDK\u914d\u7f6e\u9879server_url\u672a\u6b63\u786e\u914d\u7f6e"),!1;var t=c(this.sd);this.apiURL=this.apiURL.replace("{origin}",t.origin).replace("{project}",t.project);var r=this.sd._.URL(window.location.href).searchParams.get("deeplink");if(!r)return this.log("\u5f53\u524d\u9875\u9762\u7f3a\u5c11deeplink\u53c2\u6570"),!1;r=window.decodeURIComponent(r);var i=l(r);return i?(this.key=i[2],this.apiURL=this.apiURL.replace("{key}",window.encodeURIComponent(i[2])),this.sd._.ajax({url:this.apiURL,type:"GET",cors:!0,credentials:!1,success:function(e){return e.errorMsg?(p.log("API\u62a5\u9519\uff1a"+e.errorMsg),!1):(p.data=e,p.log("API\u67e5\u8be2\u6210\u529f\uff0c\u6570\u636e\uff1a"+JSON.stringify(e,null,"  ")),void(this.data.app_key&&(this.data.android_info&&this.data.android_info.url_schemes&&(this.data.android_info.url_schemes+="://sensorsdata/sd/"+this.data.app_key+"/"+this.key),this.data.ios_info&&this.data.ios_info.url_schemes&&(this.data.ios_info.url_schemes+="://sensorsdata/sd/"+this.data.app_key+"/"+this.key))))}.bind(this),error:function(){p.log("API\u67e5\u8be2\u51fa\u9519")}}),void this.addListeners()):(this.log("\u5f53\u524d\u9875\u9762\u7684deeplink\u53c2\u6570\u65e0\u6548"),!1)},openDeepLink:function(){if(this.log("openDeeplink()"),!this.data)return this.log("\u6ca1\u6709Deep link\u6570\u636e!"),!1;if("iOS"===a){this.log("\u5f53\u524d\u7cfb\u7edf\u662fiOS");var e=this.sd&&this.sd._&&this.sd._.getIOSVersion()>=9&&this.data.ios_info.ios_wake_url?this.data.ios_info.ios_wake_url:this.data.ios_info.url_schemes;this.log("\u5524\u8d77APP\u7684\u5730\u5740\uff1a"+e),d(this,e,this.data.ios_info.download_url)}else this.log("\u5f53\u524d\u7cfb\u7edf\u662f android"),u(this,this.data.android_info.url_schemes,this.data.android_info.download_url)},log:function(e){this.sd&&this.sd.log(e)},addListeners:function(){var e=r().visibilityChange;e&&document.addEventListener(e,function(){clearTimeout(this.timer),this.log("visibilitychange, clear timeout:"+this.timer)}.bind(this),!1),window.addEventListener("pagehide",function(){this.log("page hide, clear timeout:"+this.timer),clearTimeout(this.timer)}.bind(this),!1)}};return o(window.SensorsDataWebJSSDKPlugin)?(window.SensorsDataWebJSSDKPlugin.Deeplink=window.SensorsDataWebJSSDKPlugin.Deeplink||p,window.SensorsDataWebJSSDKPlugin.deeplink=window.SensorsDataWebJSSDKPlugin.deeplink||p):window.SensorsDataWebJSSDKPlugin={Deeplink:p,deeplink:p},p}(),Jt.modules.Pageleave=function(){"use strict";function e(){this.sd=null,this.start_time=+new Date,this.page_show_status=!0,this.page_hidden_status=!1,this._={},this.timer=null,this.current_page_url=document.referrer,this.url=location.href,this.option={},this.heartbeat_interval_time=5e3,this.heartbeat_interval_timer=null,this.page_id=null,this.storage_name="sawebjssdkpageleave"}var t=500;e.prototype.init=function(e,t){if(e){this.sd=e,this._=this.sd._;var r=this;if(t){this.option=t;var i=t.heartbeat_interval_time;i&&(this._.isNumber(i)||this._.isNumber(1*i))&&1*i>0&&(this.heartbeat_interval_time=1e3*i)}this.page_id=Number(String(this._.getRandom()).slice(2,5)+String(this._.getRandom()).slice(2,4)+String((new Date).getTime()).slice(-4)),r.addEventListener(),r.addHeartBeatInterval(),this.log("PageLeave\u521d\u59cb\u5316\u5b8c\u6bd5")}else this.log("\u795e\u7b56JS SDK\u672a\u6210\u529f\u5f15\u5165")},e.prototype.log=function(e){this.sd&&this.sd.log(e)},e.prototype.refreshPageEndTimer=function(){var e=this;this.timer&&(clearTimeout(this.timer),this.timer=null),this.timer=setTimeout(function(){e.page_hidden_status=!1},t)},e.prototype.pageStartHandler=function(){this.start_time=+new Date,this.page_show_status=!0},e.prototype.pageEndHandlear=function(){if(this.page_hidden_status!==!0){var e=this.getPageLeaveProperties();this.page_show_status===!1&&delete e.event_duration,this.page_show_status=!1,this.page_hidden_status=!0,this.sd.track("$WebPageLeave",e),this.refreshPageEndTimer(),this.delHeartBeatData()}},e.prototype.addEventListener=function(){this.addPageStartListener(),this.addPageSwitchListener(),this.addSinglePageListener(),this.addPageEndListener()},e.prototype.addPageStartListener=function(){var e=this;"onpageshow"in window&&this._.addEvent(window,"pageshow",function(){e.pageStartHandler()})},e.prototype.addSinglePageListener=function(){var e=this;this._.singlePage.prepend(function(t){t!==location.href&&(e.url=t,e.pageEndHandlear(),e.stopHeartBeatInterval(),e.pageStartHandler(),e.startHeartBeatInterval(),e.current_page_url=e.url)})},e.prototype.addPageEndListener=function(){var e=this;this._.each(["pagehide","beforeunload","unload"],function(t){"on"+t in window&&e._.addEvent(window,t,function(){e.pageEndHandlear()})})},e.prototype.addPageSwitchListener=function(){var e=this;this._.listenPageState({visible:function(){e.pageStartHandler(),e.startHeartBeatInterval()},hidden:function(){e.url=location.href,e.pageEndHandlear(),e.stopHeartBeatInterval()}})},e.prototype.addHeartBeatInterval=function(){this._.localStorage.isSupport()&&this.startHeartBeatInterval()},e.prototype.startHeartBeatInterval=function(){var e=this;this.heartbeat_interval_timer&&this.stopHeartBeatInterval(),this.heartbeat_interval_timer=setInterval(function(){e.saveHeartBeatData(),e.reissueHeartBeatData()},this.heartbeat_interval_time),this.saveHeartBeatData("is_first_heartbeat"),this.reissueHeartBeatData()},e.prototype.stopHeartBeatInterval=function(){clearInterval(this.heartbeat_interval_timer),this.heartbeat_interval_timer=null},e.prototype.saveHeartBeatData=function(e){var t=this.getPageLeaveProperties();t.$time=new Date,"is_first_heartbeat"===e&&(t.event_duration=3.14);var r=this.sd.kit.buildData({type:"track",event:"$WebPageLeave",properties:t});r.heartbeat_interval_time=this.heartbeat_interval_time,this._.localStorage.set(this.storage_name+"-"+this.page_id,JSON.stringify(r))},e.prototype.delHeartBeatData=function(e){this._.localStorage.remove(e||this.storage_name+"-"+this.page_id)},e.prototype.reissueHeartBeatData=function(){for(var e=window.localStorage.length,t=e-1;t>=0;t--){var r=window.localStorage.key(t);if(r&&r!==this.storage_name+"-"+this.page_id&&0===r.indexOf(this.storage_name+"-")){var i=this._.localStorage.parse(r);this._.isObject(i)&&1*new Date-i.time>i.heartbeat_interval_time+5e3&&(delete i.heartbeat_interval_time,this.sd.kit.sendData(i),this.delHeartBeatData(r))}}},e.prototype.getPageLeaveProperties=function(){var e=(+new Date-this.start_time)/1e3;(isNaN(e)||e<0)&&(e=0),e=Number(e.toFixed(3));var t=this._.getReferrer(this.current_page_url),r=document.documentElement&&document.documentElement.scrollTop||window.pageYOffset||document.body&&document.body.scrollTop||0;r=Math.round(r)||0;var i={$title:document.title,$url:this._.getURL(this.url),$url_path:location.pathname,$referrer_host:t?this._.getHostname(t):"",$referrer:t,$viewport_position:r};return 0!==e&&(i.event_duration=e),i=this._.extend(i,this.option.custom_props)};var r=new e;return window.SensorsDataWebJSSDKPlugin&&"[object Object]"===Object.prototype.toString.call(window.SensorsDataWebJSSDKPlugin)?window.SensorsDataWebJSSDKPlugin.PageLeave=window.SensorsDataWebJSSDKPlugin.PageLeave||r:window.SensorsDataWebJSSDKPlugin={PageLeave:r},r}(),Jt.modules.Pageload=function(){"use strict";var e={init:function(e){function t(){var r=window.performance||window.webkitPerformance||window.msPerformance||window.mozPerformance,i=0,n={$url_path:location.pathname,$referrer:e._.getReferrer(null,!0)};if(r&&r.timing){var a=r.timing;0===a.fetchStart||0===a.domContentLoadedEventEnd?e.log("performance \u6570\u636e\u83b7\u53d6\u5f02\u5e38"):i=a.domContentLoadedEventEnd-a.fetchStart}else e.log("\u6d4f\u89c8\u5668\u672a\u652f\u6301 performance API.");i>0&&(n.event_duration=Number((i/1e3).toFixed(3))),e.track("$WebPageLoad",n),window.removeEventListener?window.removeEventListener("load",t):window.detachEvent&&window.detachEvent("onload",t)}"complete"==document.readyState?t():window.addEventListener?window.addEventListener("load",t):window.attachEvent&&window.attachEvent("onload",t)}};return window.SensorsDataWebJSSDKPlugin&&"[object Object]"===Object.prototype.toString.call(window.SensorsDataWebJSSDKPlugin)?window.SensorsDataWebJSSDKPlugin.PageLoad=window.SensorsDataWebJSSDKPlugin.PageLoad||e:window.SensorsDataWebJSSDKPlugin={PageLoad:e},e}(),Jt.modules.RegisterPropertyPageHeight=function(){"use strict";function e(e){try{if("$pageview"!==e.event&&(!e.type||"profile"!==e.type.slice(0,7))){var n=window.innerHeight||document.documentElement.clientHeight||document.body.clientHeight||0,a=document.documentElement.scrollHeight||0,s={$page_height:Math.max(n,a)||0};e.properties=t._.extend(e.properties||{},s)}}catch(o){i("\u9875\u9762\u9ad8\u5ea6\u83b7\u53d6\u5f02\u5e38\u3002")}return r.call(t.kit,e)}var t,r,i=window.console&&window.console.log||function(){},n={init:function(n){return t=n,i=t&&t.log||i,n&&n.kit&&n.kit.buildData?(r=t.kit.buildData,t.kit.buildData=e,void i("RegisterPropertyPageHeight \u63d2\u4ef6\u521d\u59cb\u5316\u5b8c\u6210")):void i("RegisterPropertyPageHeight \u63d2\u4ef6\u521d\u59cb\u5316\u5931\u8d25,\u5f53\u524d\u4e3bsdk\u4e0d\u652f\u6301 RegisterPropertyPageHeight \u63d2\u4ef6\uff0c\u8bf7\u5347\u7ea7\u4e3bsdk")}};return window.SensorsDataWebJSSDKPlugin&&"[object Object]"===Object.prototype.toString.call(window.SensorsDataWebJSSDKPlugin)?window.SensorsDataWebJSSDKPlugin.RegisterPropertyPageHeight=window.SensorsDataWebJSSDKPlugin.RegisterPropertyPageHeight||n:window.SensorsDataWebJSSDKPlugin={RegisterPropertyPageHeight:n},n}(),Jt.modules.SiteLinker=function(){"use strict";var e={};return e.getPart=function(e){var t=!1,r=this.option.length;if(r)for(var i=0;i<r;i++)if(e.indexOf(this.option[i].part_url)>-1)return!0;return t},e.getPartHash=function(e){var t=this.option.length,r=!1;if(t)for(var i=0;i<t;i++)if(e.indexOf(this.option[i].part_url)>-1)return this.option[i].after_hash;return!!r},e.getCurrenId=function(){var e=this.store.getDistinctId()||"",t=this.store.getFirstId()||"";this._.urlSafeBase64&&this._.urlSafeBase64.encode?e=e?this._.urlSafeBase64.trim(this._.urlSafeBase64.encode(dr.base64Encode(e))):"":this._.rot13obfs&&(e=e?this._.rot13obfs(e):"");var r=t?"f"+e:"d"+e;return encodeURIComponent(r)},e.rewireteUrl=function(e,t){var r=/([^?#]+)(\?[^#]*)?(#.*)?/,i=r.exec(e),n="";if(i){var a,s=i[1]||"",o=i[2]||"",l=i[3]||"";if(this.getPartHash(e)){a=l.indexOf("_sasdk");var c=l.indexOf("?");n=c>-1?a>-1?s+o+"#"+l.substring(1,a)+"_sasdk="+this.getCurrenId():s+o+"#"+l.substring(1)+"&_sasdk="+this.getCurrenId():s+o+"#"+l.substring(1)+"?_sasdk="+this.getCurrenId()}else{a=o.indexOf("_sasdk");var u=/^\?(\w)+/.test(o);n=u?a>-1?s+"?"+o.substring(1,a)+"_sasdk="+this.getCurrenId()+l:s+"?"+o.substring(1)+"&_sasdk="+this.getCurrenId()+l:s+"?"+o.substring(1)+"_sasdk="+this.getCurrenId()+l}return t&&(t.href=n),n}},e.getUrlId=function(){var e=location.href.match(/_sasdk=([aufd][^\?\#\&\=]+)/);if(this._.isArray(e)&&e[1]){var t=decodeURIComponent(e[1]);return!t||"f"!==t.substring(0,1)&&"d"!==t.substring(0,1)||(this._.urlSafeBase64&&this._.urlSafeBase64.isUrlSafeBase64&&this._.urlSafeBase64.isUrlSafeBase64(t)?t=t.substring(0,1)+dr.base64Decode(this._.urlSafeBase64.decode(t.substring(1))):this._.rot13defs&&(t=t.substring(0,1)+this._.rot13defs(t.substring(1)))),t}return""},e.setRefferId=function(){var e=this.store.getDistinctId(),t=this.getUrlId();if(""===t)return!1;var r="a"===t.substring(0,1)||"d"===t.substring(0,1);return t=t.substring(1),t!==e&&(t&&r&&this.store.getFirstId()&&(this.sd.identify(t,!0),this.sd.saEvent.send({original_id:t,distinct_id:e,type:"track_signup",event:"$SignUp",properties:{}},null)),t&&r&&!this.store.getFirstId()&&this.sd.identify(t,!0),void(!t||r||this.store.getFirstId()||this.sd.login(t)))},e.addListen=function(){var e=this,t=function(t){var r,i,n=t.target,a=n.tagName.toLowerCase(),s=n.parentNode;if("a"===a&&n.href||s&&s.tagName&&"a"===s.tagName.toLowerCase()&&s.href){"a"===a&&n.href?(r=n.href,i=n):(r=s.href,i=s);var o=e._.URL(r),l=o.protocol;"http:"!==l&&"https:"!==l||e.getPart(r)&&e.rewireteUrl(r,i)}};e._.addEvent(document,"mousedown",t),window.PointerEvent&&"maxTouchPoints"in window.navigator&&window.navigator.maxTouchPoints>=0&&e._.addEvent(document,"pointerdown",t)},e.init=function(e,t){function r(t){for(var r=t.length,i=[],n=0;n<r;n++)/[A-Za-z0-9]+\./.test(t[n].part_url)&&"[object Boolean]"==Object.prototype.toString.call(t[n].after_hash)?i.push(t[n]):e.log("linker \u914d\u7f6e\u7684\u7b2c "+(n+1)+" \u9879\u683c\u5f0f\u4e0d\u6b63\u786e\uff0c\u8bf7\u68c0\u67e5\u53c2\u6570\u683c\u5f0f\uff01");return i}return this.sd=e,this._=e._,this.store=e.store,this.para=e.para,this._.isObject(t)&&this._.isArray(t.linker)&&t.linker.length>0?(this.setRefferId(),this.addListen(),this.option=t.linker,void(this.option=r(this.option))):void e.log("\u8bf7\u914d\u7f6e\u6253\u901a\u57df\u540d\u53c2\u6570\uff01")},dr.isObject(window.SensorsDataWebJSSDKPlugin)?window.SensorsDataWebJSSDKPlugin.SiteLinker=window.SensorsDataWebJSSDKPlugin.SiteLinker||e:window.SensorsDataWebJSSDKPlugin={SiteLinker:e},e}(),"string"==typeof window.sensorsDataAnalytic201505?(Jt.para=window[sensorsDataAnalytic201505].para,Jt._q=window[sensorsDataAnalytic201505]._q,window[sensorsDataAnalytic201505]=Jt,window.sensorsDataAnalytic201505=Jt,Jt.init()):"undefined"==typeof window.sensorsDataAnalytic201505?window.sensorsDataAnalytic201505=Jt:Kr=window.sensorsDataAnalytic201505}catch(Wr){if("object"==typeof console&&console.log)try{console.log(Wr)}catch(qr){Jt.log(qr)}}var Vr=Kr;return Vr});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index.js